webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdalService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_expose_loader_AuthenticationContext_node_modules_adal_angular_lib_adal_js__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_expose_loader_AuthenticationContext_node_modules_adal_angular_lib_adal_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_expose_loader_AuthenticationContext_node_modules_adal_angular_lib_adal_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(55);
/// <reference path="../../../node_modules/@types/adal/index.d.ts" />





var createAuthContextFn = AuthenticationContext;
var AdalService = /** @class */ (function () {
    function AdalService() {
        this.azureAdConfig = {
            tenant: '078256a4-c4a0-4e95-b107-2ae7d5db8581',
            clientId: '75db915c-344c-4e36-a5f2-20925770c15b',
            redirectUri: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].AzureADUrl + 'dashboard',
            postLogoutRedirectUri: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].AzureADUrl + 'login',
            navigateToLoginRequestUrl: false,
            cacheLocation: 'localStorage'
        };
        this.context = new createAuthContextFn(this.azureAdConfig);
    }
    AdalService.prototype.login_userhint = function (loginid) {
        this.context.config.extraQueryParameter = 'login_hint=' + loginid;
        this.context.login();
    };
    AdalService.prototype.login = function () {
        this.login_userhint(localStorage.getItem('emailid'));
    };
    AdalService.prototype.logout = function () {
        this.context.logOut();
    };
    AdalService.prototype.handleCallback = function () {
        this.context.handleWindowCallback();
    };
    AdalService.prototype.acquireToken = function (resource, callback) {
        return this.context.acquireToken(resource, callback);
    };
    AdalService.prototype.getCachedToken = function (resource) {
        if (resource) {
            return this.context.getCachedToken(resource);
        }
        return this.context.getCachedToken(this.azureAdConfig.clientId);
    };
    Object.defineProperty(AdalService.prototype, "userInfo", {
        get: function () {
            return this.context.getCachedUser();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdalService.prototype, "getCachedUser", {
        get: function () {
            return this.context.getCachedUser();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdalService.prototype, "isAuthenticated", {
        get: function () {
            return this.userInfo && this.getCachedToken();
        },
        enumerable: true,
        configurable: true
    });
    AdalService.prototype.acquireTokenResilient = function (resource) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"](function (subscriber) {
            return _this.context.acquireToken(resource, function (_message, token) {
                if (token) {
                    subscriber.next(token);
                }
                else {
                    window.location.href = "/login";
                }
            });
        }).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["retry"])(3));
    };
    AdalService = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [])
    ], AdalService);
    return AdalService;
}());



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppLoaderService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material_dialog__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_loader_component__ = __webpack_require__(218);



var AppLoaderService = /** @class */ (function () {
    function AppLoaderService(dialog) {
        this.dialog = dialog;
        this.isLoginDialogOpen = false;
    }
    AppLoaderService.prototype.open = function (title, percentage, _config) {
        if (title === void 0) { title = "Please wait"; }
        if (percentage === void 0) { percentage = ""; }
        if (_config === void 0) { _config = { width: "200px" }; }
        this.dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__app_loader_component__["a" /* AppLoaderComponent */], {
            disableClose: true
        });
        this.dialogRef.componentInstance.title = title;
        this.dialogRef.componentInstance.percentage = percentage;
        this.isLoginDialogOpen = true;
        return this.dialogRef.afterClosed();
    };
    AppLoaderService.prototype.close = function () {
        if (this.dialogRef)
            this.dialogRef.close();
        this.isLoginDialogOpen = false;
    };
    AppLoaderService.prototype.IsLoader = function () {
        return this.isLoginDialogOpen;
    };
    AppLoaderService.prototype.ChangeLoaderTitle = function (input) {
        this.dialogRef.componentInstance.title = input;
    };
    AppLoaderService.prototype.ChangePercentage = function (input) {
        this.dialogRef.componentInstance.percentage = input;
    };
    AppLoaderService = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material_dialog__["b" /* MdDialog */]])
    ], AppLoaderService);
    return AppLoaderService;
}());



/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenseService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common_http__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(55);



var LicenseService = /** @class */ (function () {
    function LicenseService(httpClient) {
        this.httpClient = httpClient;
        this.baseUrl = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* config */].apiUrl;
    }
    LicenseService.prototype.getHeaders = function () {
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_common_http__["c" /* HttpHeaders */]();
        headers.append("Content-Type", "application/json");
        return headers;
    };
    // getBillingShippingDetail(SalesOrderNo):Observable<any>{
    //     const params = new HttpParams().set('$filter', `number eq '${SalesOrderNo}'`);
    //     return this.httpClient.get(this.envService.microsoftBusinessApiUrl+"shippingandbilling",{params:params,headers:this.getHeaders()}).map((response)=>{
    //         console.log("inside license service")
    //         return response;
    //     })
    // }
    //getLicensePortalProducts
    LicenseService.prototype.getLicensePortalProducts = function () {
        return this.httpClient
            .get(this.baseUrl + "ReleaseManagement/v2/GetLicensePortalProducts", {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    //get license product by product code
    LicenseService.prototype.getLicensePortalProductByProductCode = function (productCode) {
        return this.httpClient
            .get(this.baseUrl +
            "ReleaseManagement/v2/GetLicensePortalProductByProductCode?productCode=" +
            productCode, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    //Customer billing shipping
    LicenseService.prototype.getBillingShippingDetail = function (salesOrderNo) {
        //from MAS 90
        return this.httpClient
            .get(this.baseUrl +
            "CustomerBillingShipping/getBillingShippingDetails?salesOrderNo=" +
            salesOrderNo)
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.addBillingShippingDetail = function (billingSHippingDetail) {
        return this.httpClient
            .post(this.baseUrl + "CustomerBillingShipping/addBillingShippingDetails", billingSHippingDetail)
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getAllCustomersDetail = function () {
        return this.httpClient
            .get(this.baseUrl + "CustomerBillingShipping/getAllCustomersDetail", {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    //Service 360
    LicenseService.prototype.getService360LicenseDisplayDetail = function () {
        return this.httpClient
            .get(this.baseUrl +
            "Service360LicenseDetails/v3/GetService360LicenseDetails", { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.generateService360License = function (service360LicensePurchaseDetail) {
        return this.httpClient
            .post(this.baseUrl + "Service360LicenseDetails/v3/GenerateLicense", service360LicensePurchaseDetail, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.updateService360License = function (service360LicenseUpdateDetail) {
        return this.httpClient
            .post(this.baseUrl + "Service360LicenseDetails/v3/UpdateLicense", service360LicenseUpdateDetail, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.activateService360License = function (service360LicenseActivateDetail) {
        return this.httpClient
            .post(this.baseUrl + "Service360LicenseDetails/v3/ActivateLicense", service360LicenseActivateDetail, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.viewService360ActivationHistory = function (licenseId) {
        return this.httpClient
            .get(this.baseUrl +
            "Service360LicenseDetails/v3/ViewActivationHistory?LicenseId=" +
            licenseId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.deactiveService360License = function (service360LicenseDeactivateDetail) {
        return this.httpClient
            .post(this.baseUrl + "Service360LicenseDetails/v3/DeActivateLicense", service360LicenseDeactivateDetail, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    //smartlink 360
    LicenseService.prototype.getSmartLinkDemoData = function () {
        return this.httpClient
            .get(this.baseUrl + "SmartLink360LicenseDetails/v3/GetDemoLicenseInfo", {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getSmartLinkPurchaseLicenseDisplayDetail = function () {
        return this.httpClient
            .get(this.baseUrl + "SmartLink360LicenseDetails/v3/GetPurchaseLicenseInfo", { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.generateSmartLink360License = function (smartLink360PurchaseLicenseDetail) {
        return this.httpClient
            .post(this.baseUrl + "SmartLink360LicenseDetails/v3/GenerateLicense", smartLink360PurchaseLicenseDetail, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.updateSmartLink360License = function (smartLink360UodateLicenseDetail) {
        return this.httpClient
            .post(this.baseUrl + "SmartLink360LicenseDetails/v3/UpdateLicense", smartLink360UodateLicenseDetail, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.viewSmartLink360ActivationHistory = function (LicenseId) {
        return this.httpClient
            .get(this.baseUrl +
            "SmartLink360LicenseDetails/v3/ViewActivationHistory?LicenseId=" +
            LicenseId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.renewSmartLink360License = function (data) {
        return this.httpClient
            .post(this.baseUrl + "SmartLink360LicenseDetails/v3/RenewLicense", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.viewSmartLink360RenewalHistory = function (LicenseId) {
        return this.httpClient
            .get(this.baseUrl +
            "SmartLink360LicenseDetails/v3/getRenewalHistory/" +
            LicenseId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getUserFeedBackInfo = function (UserRegId) {
        return this.httpClient
            .get(this.baseUrl +
            "SmartLink360LicenseDetails/v3/getUserFeedbackInfo?UserRegId=" +
            UserRegId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    //advertisement
    LicenseService.prototype.getAllAdvertisement = function () {
        return this.httpClient
            .get(this.baseUrl +
            "LZ30AdvertisementDetails/v3/GetLZ30AdvertisementDetails", { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.addAdvertisement = function (data) {
        return this.httpClient
            .post(this.baseUrl +
            "LZ30AdvertisementDetails/v3/AddLZ30AdvertisementDetails", data, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.deleteAdvertisement = function (data) {
        return this.httpClient
            .post(this.baseUrl +
            "LZ30AdvertisementDetails/v3/DeleteLZ30AdvertisementDetails", data, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.updateAdvertisement = function (data) {
        return this.httpClient
            .post(this.baseUrl +
            "LZ30AdvertisementDetails/v3/UpdateLZ30AdvertisementDetails", data, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.updateActiveInactiveAdvertisement = function (data) {
        return this.httpClient
            .post(this.baseUrl +
            "LZ30AdvertisementDetails/v3/ActiveDeActiveLZ30AdvertisementDetails", data, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    //glt
    LicenseService.prototype.generateGltLicenseKey = function (data) {
        return this.httpClient
            .post(this.baseUrl + "GLTLicenseDetails/generateLicenseKey", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.generateGltLicense = function (data) {
        return this.httpClient
            .post(this.baseUrl + "GLTLicenseDetails/generateGltLicense", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getGltLicenseDetail = function () {
        return this.httpClient
            .get(this.baseUrl + "GLTLicenseDetails/getGltLicenseDetail", {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.updateGltLicense = function (data) {
        return this.httpClient
            .post(this.baseUrl + "GLTLicenseDetails/updateGltLicense", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    //LZ-30
    LicenseService.prototype.getLz30UserDeviceDisplayDetail = function () {
        return this.httpClient
            .get(this.baseUrl + "LZ30UserDetails/v2/GetLZ30UserDeviceDetails", {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.addLz30Device = function (data) {
        return this.httpClient
            .post(this.baseUrl + "LZ30UserDetails/v2/AddLZ30Device", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.updateLz30Device = function (data) {
        return this.httpClient
            .post(this.baseUrl + "LZ30UserDetails/v2/UpdateLZ30Device", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getLz30PurchaseLicenseDisplayDetail = function () {
        return this.httpClient
            .get(this.baseUrl + "LZ30LicenseDetails/v3/GetLZ30LicensePurchaseDetails", { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getAllLz30DeviceDetail = function () {
        return this.httpClient
            .get(this.baseUrl + "LZ30UserDetails/v2/GetLZ30DeviceDetail", {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.extendLZ30TrialPeriod = function (data) {
        return this.httpClient
            .post(this.baseUrl + "LZ30UserDetails/v3/ExtendTrialPeriod", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.viewLZ30DeviceHistory = function (LZ30DeviceId, LZ30UserDetailId) {
        return this.httpClient
            .get(this.baseUrl +
            "LZ30UserDetails/v3/GetLZ30DeviceHistory?LZ30DeviceId=" +
            LZ30DeviceId +
            "&LZ30UserDetailId=" +
            LZ30UserDetailId)
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.purchaseLz30License = function (data) {
        return this.httpClient
            .post(this.baseUrl + "LZ30LicenseDetails/v3/PurchaseLZ30License", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getLZ30LicenseDetail = function (LZ30UserDeviceId) {
        return this.httpClient
            .get(this.baseUrl +
            "LZ30LicenseDetails/v3/GetLZ30LicenseDetails?LZ30UserDeviceId=" +
            LZ30UserDeviceId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getLz30PurchaseHistory = function (LZ30UserDeviceId) {
        return this.httpClient
            .get(this.baseUrl +
            "LZ30LicenseDetails/v3/GetLZ30PurchaseHistory?LZ30UserDeviceId=" +
            LZ30UserDeviceId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.addMoreLZ30License = function (data) {
        return this.httpClient
            .post(this.baseUrl + "LZ30LicenseDetails/v3/AddMoreLZ30License", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    //SCAL
    LicenseService.prototype.generateScalLicense = function (data) {
        return this.httpClient
            .post(this.baseUrl + "ProductLicenseDetails/v3/GenerateLicense", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getScalPurchaseLicenseDisplayDetails = function () {
        return this.httpClient
            .get(this.baseUrl + "ProductLicenseDetails/v3/GetLicensePurchaseDetails", { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getScalCustomerLicenseDetail = function (LicenseId) {
        return this.httpClient
            .get(this.baseUrl +
            "ProductLicenseDetails/v3/GetLicenseDetailswithoutuser?LicenseId=" +
            LicenseId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.updateScalPurchaseLicense = function (data) {
        return this.httpClient
            .post(this.baseUrl + "ProductLicenseDetails/v3/UpdateLicense", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.activateScalLicense = function (data) {
        return this.httpClient
            .post(this.baseUrl +
            "ProductActivationDetails/v3/ConfirmGenerateActivationKey", data, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.addMoreScalLicense = function (data) {
        return this.httpClient
            .post(this.baseUrl + "ProductPurchaseDetails/v3/AddMoreLicense", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.viewScal360PurchaseHistory = function (LicenseId) {
        return this.httpClient
            .get(this.baseUrl +
            "ProductPurchaseDetails/v3/ViewPurchaseDetails?LicenseId=" +
            LicenseId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getScalCustomerLicenseDetailForActivationAndRenewal = function (LicenseId) {
        return this.httpClient
            .get(this.baseUrl +
            "ProductLicenseDetails/v3/GetLicenseDetailsandRenewalDetails?LicenseId=" +
            LicenseId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.renewScal360License = function (data) {
        return this.httpClient
            .post(this.baseUrl + "ProductRenewalDetails/v3/RenewLicense", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getScal360CustomerLicenseDetail = function (LicenseId) {
        return this.httpClient
            .get(this.baseUrl +
            "ProductLicenseDetails/v3/getLicenseDetails?LicenseId=" +
            LicenseId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.viewScal360ActivationHistory = function (LicenseDetailId) {
        return this.httpClient
            .get(this.baseUrl +
            "ProductActivationDetails/v3/ViewActivationKey?LicenseDetailId=" +
            LicenseDetailId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.deleteScal360ActivationKey = function (data) {
        return this.httpClient
            .post(this.baseUrl + "ProductActivationDetails/v3/DeleteActivationKey", data, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getScalLicenseRenewalHistory = function (LicenseDetailId) {
        return this.httpClient
            .get(this.baseUrl +
            "ProductRenewalDetails/v3/GetRenewalLicense?LicenseDetailId=" +
            LicenseDetailId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.deleteScalCustomerLicense = function (data) {
        return this.httpClient
            .post(this.baseUrl + "ProductLicenseDetails/v3/DeleteLicense", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.deleteParticularCustomerParticularLicense = function (data) {
        return this.httpClient
            .post(this.baseUrl + "ProductLicenseDetails/v2/DeleteParticularLicenseKey", data, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.viewScalDownloadReleaseHistory = function (LicenseKey) {
        return this.httpClient
            .get(this.baseUrl +
            "Operations/v2/ViewSCALDownloadHistory?LicenseKey=" +
            LicenseKey, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    //SMART-CAL360N
    LicenseService.prototype.generatesmartcal360NLicenseKey = function (data) {
        return this.httpClient
            .post(this.baseUrl +
            "SmartCal360NLicenseDetail/v1/GenerateSmartCal360NLicenseKey", data, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getSmartCal360NLicenseDetails = function () {
        return this.httpClient
            .get(this.baseUrl +
            "SmartCal360NLicenseDetail/v1/GetSmartCal360NLicenceSerialDetails", { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.updateSmarCal360NLicense = function (data) {
        return this.httpClient
            .post(this.baseUrl + "SmartCal360NLicenseDetail/v1/UpdateSmartCal360NLicense", data, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    //FAQ
    LicenseService.prototype.addFAQ = function (data) {
        return this.httpClient
            .post(this.baseUrl + "Faq/v3/AddUpdateFAQ", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getFAQWithProductId = function (productId) {
        return this.httpClient
            .get(this.baseUrl + "Faq/v3/getProductFAQ?ProductId=" + productId, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.deleteFAQ = function (FAQId, UpdatedBy) {
        return this.httpClient
            .delete(this.baseUrl +
            "Faq/v3/DeleteFAQ?FAQId=" +
            FAQId +
            "&UpdatedBy=" +
            UpdatedBy, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.importFAQ = function (data) {
        return this.httpClient
            .post(this.baseUrl + "Faq/v3/importFAQ", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    //SyncIT
    LicenseService.prototype.getSyncItLicenseDetails = function () {
        return this.httpClient
            .get(this.baseUrl + "SyncIT/v2/getSyncITLicenseInfo", {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getSyncITLicenseHistory = function (SyncItProductLicenseId) {
        return this.httpClient
            .get(this.baseUrl + "SyncIT/v2/GetSyncITLicenseHistory/" + SyncItProductLicenseId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getSyncITProducts = function () {
        return this.httpClient
            .get(this.baseUrl + "SyncIT/v2/getSyncITProduct", {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.GenerateSyncITLicense = function (data) {
        return this.httpClient
            .post(this.baseUrl + "SyncIT/v2/GenerateSyncITLicense", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.addBillingShippingDetailsSyncIT = function (billingSHippingDetail) {
        return this.httpClient
            .post(this.baseUrl +
            "CustomerBillingShipping/addBillingShippingDetailsSyncIT", billingSHippingDetail)
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.ExtendTrialRenewPeriod = function (data) {
        return this.httpClient
            .post(this.baseUrl + "SyncIT/v2/ExtendTrialRenewPeriod", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.getSyncITLicensePurchaseProduct = function (SyncItproductLicenseId) {
        return this.httpClient
            .get(this.baseUrl + "SyncIT/v2/getSyncITLicensePurchaseProduct?SyncItproductLicenseId=" + SyncItproductLicenseId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.addMoreSyncItLicense = function (data) {
        return this.httpClient
            .post(this.baseUrl + "SyncIT/v2/addMoreSyncItLicense", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService.prototype.approveTrialPeriodExtension = function (data) {
        return this.httpClient
            .post(this.baseUrl + "SyncIT/v2/ApproveTrialPeriodExtension", data, {
            headers: this.getHeaders(),
        })
            .map(function (response) {
            return response;
        });
    };
    LicenseService = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_0__angular_common_http__["d" /* HttpClient */]])
    ], LicenseService);
    return LicenseService;
}());



/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_catch__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common_http__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(55);







var UserService = /** @class */ (function () {
    function UserService(http, httpClient) {
        this.http = http;
        this.httpClient = httpClient;
        this.baseUrl = __WEBPACK_IMPORTED_MODULE_6__config__["a" /* config */].apiUrl;
        this.notify = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["Subject"]();
        this.notifyObservable$ = this.notify.asObservable();
    }
    UserService.prototype.getHeaders = function () {
        var headers = new __WEBPACK_IMPORTED_MODULE_5__angular_common_http__["c" /* HttpHeaders */]();
        headers.append('Content-Type', 'application/json');
        return headers;
    };
    // This API used when we login into release management (Azure AD token not pass in this API)
    UserService.prototype.getUsers = function (EmailId) {
        return this.httpClient.get(this.baseUrl + 'user/getuserdata/' + EmailId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    UserService.prototype.getUsersByData = function (EmailId, UserId) {
        return this.httpClient.get(this.baseUrl + 'user/GetUserByData/' + EmailId + '/' + UserId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    UserService.prototype.getUser = function () {
        return this.httpClient.get(this.baseUrl + 'user/getusers/', { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    UserService.prototype.getUserById = function (UserId) {
        return this.httpClient.get(this.baseUrl + 'user/getusersbyid/' + UserId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    // Add Application Name and Code
    UserService.prototype.addUser = function (UserData) {
        return this.httpClient.post(this.baseUrl + 'user/v2/addUser', UserData, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    UserService.prototype.updateUser = function (UserData) {
        return this.httpClient.post(this.baseUrl + 'user/v2/updateUser', UserData, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    UserService.prototype.getUserRights = function (UserId) {
        return this.httpClient.get(this.baseUrl + 'user/getusersrights/' + UserId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    UserService.prototype.getUserAllRightsById = function (UserId) {
        return this.httpClient.get(this.baseUrl + 'user/v2/getusersrights/' + UserId, { headers: this.getHeaders() }).map(function (response) {
            return response;
        });
    };
    UserService.prototype.getUserRightsById = function (UserId, InstumentTypeMasterId) {
        return this.httpClient.get(this.baseUrl + 'user/getusersrightsbyid/' + UserId + '/' + InstumentTypeMasterId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    UserService.prototype.getUserLicenseRightById = function (userId, productId) {
        return this.httpClient.get(this.baseUrl + 'user/v2/getUserLicenseRightByProductId/' + userId + '/' + productId, { headers: this.getHeaders() }).map(function (response) {
            return response;
        });
    };
    UserService.prototype.getUserRightsDetaisSummaryById = function (UserId) {
        return this.httpClient.get(this.baseUrl + 'user/getuserreightsummary/' + UserId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    UserService.prototype.notifyOther = function (data) {
        if (data) {
            this.notify.next(data);
        }
    };
    UserService = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* Http */], __WEBPACK_IMPORTED_MODULE_5__angular_common_http__["d" /* HttpClient */]])
    ], UserService);
    return UserService;
}());



/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SCALType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SCALOperations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SCALRenewalType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SCALOsDetailType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicensePortalProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProductClientSecret; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PortalAccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OTARoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LicenseRoles; });
var SCALType;
(function (SCALType) {
    SCALType[SCALType["SCAL-D 360"] = 1] = "SCAL-D 360";
    SCALType[SCALType["SCAL-N 360"] = 2] = "SCAL-N 360";
})(SCALType || (SCALType = {}));
var SCALOperations;
(function (SCALOperations) {
    SCALOperations[SCALOperations["add"] = 1] = "add";
    SCALOperations[SCALOperations["edit"] = 2] = "edit";
    SCALOperations[SCALOperations["addMore"] = 3] = "addMore";
})(SCALOperations || (SCALOperations = {}));
var SCALRenewalType;
(function (SCALRenewalType) {
    SCALRenewalType[SCALRenewalType["Renew Based on Expiration Date"] = 1] = "Renew Based on Expiration Date";
    SCALRenewalType[SCALRenewalType["Renew Based on Current Purchase Date"] = 2] = "Renew Based on Current Purchase Date";
})(SCALRenewalType || (SCALRenewalType = {}));
var SCALOsDetailType;
(function (SCALOsDetailType) {
    SCALOsDetailType[SCALOsDetailType["Windows 11"] = 1] = "Windows 11";
    SCALOsDetailType[SCALOsDetailType["Windows 10"] = 2] = "Windows 10";
    SCALOsDetailType[SCALOsDetailType["Windows 8.1"] = 3] = "Windows 8.1";
    SCALOsDetailType[SCALOsDetailType["Windows 8"] = 4] = "Windows 8";
    SCALOsDetailType[SCALOsDetailType["Windows 7"] = 5] = "Windows 7";
    SCALOsDetailType[SCALOsDetailType["Windows Server 2019"] = 6] = "Windows Server 2019";
    SCALOsDetailType[SCALOsDetailType["Windows Server 2016"] = 7] = "Windows Server 2016";
    SCALOsDetailType[SCALOsDetailType["Windows Server 2012 R2"] = 8] = "Windows Server 2012 R2";
    SCALOsDetailType[SCALOsDetailType["Windows Server 2012"] = 9] = "Windows Server 2012";
    SCALOsDetailType[SCALOsDetailType["Windows Server 2008 R2"] = 10] = "Windows Server 2008 R2";
    SCALOsDetailType[SCALOsDetailType["Windows Server 2008"] = 11] = "Windows Server 2008";
})(SCALOsDetailType || (SCALOsDetailType = {}));
var LicensePortalProduct;
(function (LicensePortalProduct) {
    LicensePortalProduct[LicensePortalProduct["LZ30"] = 19] = "LZ30";
    LicensePortalProduct[LicensePortalProduct["SmartLink360"] = 20] = "SmartLink360";
    LicensePortalProduct[LicensePortalProduct["Service360"] = 22] = "Service360";
    LicensePortalProduct[LicensePortalProduct["SCAL"] = 14] = "SCAL";
    LicensePortalProduct[LicensePortalProduct["SmartCal360N"] = 11] = "SmartCal360N";
    LicensePortalProduct[LicensePortalProduct["SYNCIt"] = 1000] = "SYNCIt";
})(LicensePortalProduct || (LicensePortalProduct = {}));
var ProductClientSecret;
(function (ProductClientSecret) {
    ProductClientSecret["LZ30"] = "f0631e1a5c310c3093b01768ccc495ba";
    ProductClientSecret["SmartLink360"] = "bc5897005257f20324acff937ca1426f";
    ProductClientSecret["Service360"] = "ca17d891365396e696362635c79fb348";
    ProductClientSecret["SCAL"] = "54012654468d382b6f75159d7fd6fe75";
    ProductClientSecret["SmartCal360N"] = "b204de74a5fa459cd1bdbd45f1a2c791";
    ProductClientSecret["SyncIT"] = "CXFXxsCT1m5PkgRNOj8RRDlO0szixBrm";
})(ProductClientSecret || (ProductClientSecret = {}));
var PortalAccess;
(function (PortalAccess) {
    PortalAccess[PortalAccess["OTA"] = 1] = "OTA";
    PortalAccess[PortalAccess["LicensingAndAdv"] = 2] = "LicensingAndAdv";
    PortalAccess[PortalAccess["All"] = 3] = "All";
})(PortalAccess || (PortalAccess = {}));
var OTARoles;
(function (OTARoles) {
    OTARoles[OTARoles["Developer"] = 1] = "Developer";
    OTARoles[OTARoles["QA"] = 2] = "QA";
    OTARoles[OTARoles["Product Management"] = 3] = "Product Management";
})(OTARoles || (OTARoles = {}));
var LicenseRoles;
(function (LicenseRoles) {
    LicenseRoles[LicenseRoles["CSR"] = 1] = "CSR";
})(LicenseRoles || (LicenseRoles = {}));


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PagerService; });
var PagerService = /** @class */ (function () {
    function PagerService() {
    }
    PagerService.prototype.getPager = function (totalItems, currentPage, pageSize) {
        if (currentPage === void 0) { currentPage = 1; }
        if (pageSize === void 0) { pageSize = 7; }
        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);
        // ensure current page isn't out of range
        if (currentPage < 1) {
            currentPage = 1;
        }
        else if (currentPage > totalPages) {
            currentPage = totalPages;
        }
        var startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        }
        else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            }
            else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            }
            else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }
        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
        // create an array of pages to ng-repeat in the pager control
        var pages = Array.from(Array((endPage + 1) - startPage).keys()).map(function (i) { return startPage + i; });
        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    };
    return PagerService;
}());



/***/ }),
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductReleaseService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common_http__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(55);






var ProductReleaseService = /** @class */ (function () {
    function ProductReleaseService(httpClient) {
        this.httpClient = httpClient;
        this.baseUrl = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].apiUrl;
        this.notify = new __WEBPACK_IMPORTED_MODULE_1_rxjs__["Subject"]();
        this.notifyObservable$ = this.notify.asObservable();
    }
    ProductReleaseService.prototype.getHeaders = function () {
        var headers = new __WEBPACK_IMPORTED_MODULE_4__angular_common_http__["c" /* HttpHeaders */]();
        headers.append('Content-Type', 'application/json');
        return headers;
    };
    ProductReleaseService.prototype.getChangeLogDetails = function (ProductReleaseId) {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/getProductChangeLogMaster/' + ProductReleaseId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.getProductAllChangeLogDetails = function (ProductId) {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/getAllChangeLogById/' + ProductId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.checkRevisionNo = function (ReleaseFormdata) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/getRevNo', ReleaseFormdata, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.checkDBVersion = function (DBVersion, ProductId, ProductReleaseId) {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/getDBVersion/' + DBVersion + '/' + Number(ProductId) + '/' + Number(ProductReleaseId), { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.getToken = function (body, header) {
        return this.httpClient.post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].TokenGenerationUrl + 'connect/token', body, { headers: header })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.getProductionRelease = function (ProductId) {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/getProductionRelease/' + ProductId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.getReleaseByProductId = function (ProductId) {
        // Replacing with v4 API to get Customer list for Pilot and Custom release
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v4/getReleasesForProduct/' + ProductId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.getReleaseProductsListByProductCode = function (ProductCode, ProductId, Variant) {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/getReleaseProductsListByProductCode/' + ProductCode + '/' + ProductId + '/' + Variant, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.getIsAllowedToAddReleaseByProductId = function (ProductId) {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/IsAddRelease/' + ProductId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.getProductReleaseById = function (ProductReleaseId) {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/getReleaseProductDetailById/' + ProductReleaseId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.getStableRelease = function (ApplicationCode) {
        return this.httpClient.get(this.baseUrl + 'Operations/v2/GetSoftwareUpdates?ApplicationCode=' + ApplicationCode + '&ReleaseStatus=1&DBVersion=&AppVersion=', { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    // Revision File Upload
    ProductReleaseService.prototype.UploadFiles = function (files) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/UploadFile', files, { headers: this.getHeaders(), reportProgress: true, observe: 'events' })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.PackageUploadFiles = function (files) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/UploadPackageFiles', files, { headers: this.getHeaders(), reportProgress: true, observe: 'events' })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.addProductReleaseMenually = function (ReleaseFormdata) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/addProductRelease', ReleaseFormdata, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.deleteProductReleaseSupportFile = function (ProductReleaseSupportFileId) {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/DeleteProductReleaseSupportFile/' + ProductReleaseSupportFileId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.updateProductReleaseDetail = function (ReleaseFormdata) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/updateProductRelease', ReleaseFormdata, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    // Revert Release
    ProductReleaseService.prototype.ActiveRelease = function (ReleaseFormdata) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/ActiveRelease', ReleaseFormdata, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    //Approve Release
    ProductReleaseService.prototype.ApproveRelease = function (ReleaseFormdata) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/ApproveRelease', ReleaseFormdata, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    //Reject Release
    ProductReleaseService.prototype.RejectRelease = function (ReleaseFormdata) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/RejectRelease', ReleaseFormdata, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    // STP Start
    ProductReleaseService.prototype.STPStart = function (ReleaseFormdata) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/STPStart', ReleaseFormdata, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    // ViewHistory Release
    ProductReleaseService.prototype.ViewHistory = function (ProductReleaseId) {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/GetProductRelaseHistory/' + ProductReleaseId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    // Download Azure Container
    ProductReleaseService.prototype.DownloadFile = function (LicenseInfo) {
        return this.httpClient.post(this.baseUrl + 'Operations/v2/DownloadZipFile', LicenseInfo, { responseType: 'blob', reportProgress: true, observe: 'events', headers: this.getHeaders() })
            .map(function (result) {
            return result;
        });
    };
    ProductReleaseService.prototype.VerifySCAL360OTPVerification = function (LicenseInfo) {
        return this.httpClient.post(this.baseUrl + 'Operations/v2/VerifySCAL360OTPVerification?AuthKey=SensitActivationKey', LicenseInfo, { headers: this.getHeaders() })
            .map(function (result) {
            return result;
        });
    };
    ProductReleaseService.prototype.SendEmailToSCAL3609Customer = function (LicenseInfo) {
        return this.httpClient.post(this.baseUrl + 'Operations/V2/SendEmailToSCAL360Customer', LicenseInfo, { headers: this.getHeaders() })
            .map(function (result) {
            return result;
        });
    };
    ProductReleaseService.prototype.DownloadReleaseFile = function (ProductReleaseId) {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/DownloadFile/' + ProductReleaseId, { responseType: 'blob', reportProgress: true, observe: 'events', headers: this.getHeaders() })
            .map(function (result) {
            return result;
        });
    };
    //Release status change through email notification 
    ProductReleaseService.prototype.SendEmail = function (Emaildata) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v2/SendEmail', Emaildata, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.SendEmailToSyncItClientAdmins = function (Emaildata) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v4/emails/syncit-client-admins', Emaildata, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.getSASToken = function (filePath) {
        return this.httpClient.get(this.baseUrl + 'operations/v2/generate-sas-token?blobName=' + filePath, { headers: this.getHeaders() })
            .map(function (result) {
            return result;
        });
    };
    ProductReleaseService.prototype.getIPAddress = function () {
        return this.httpClient.get(this.baseUrl + 'operations/v2/get-ip', { headers: this.getHeaders() })
            .map(function (result) {
            return result;
        });
    };
    ProductReleaseService.prototype.AddSoftwareDownloadDetails = function (requestInfo) {
        return this.httpClient.post(this.baseUrl + 'operations/v2/AddSoftwareDownloadDetails', requestInfo, { headers: this.getHeaders() })
            .map(function (result) {
            return result;
        });
    };
    ProductReleaseService.prototype.ChangePilotCustomReleaseStatus = function (ReleaseFormdata) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v4/ChangePilotCustomReleaseStatus', ReleaseFormdata, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.ActivateRelease = function (ReleaseFormdata) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/v4/ActivateRelease', ReleaseFormdata, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.getCustomers = function (productId) {
        return this.httpClient.get(this.baseUrl + ("ReleaseManagement/v4/GetCustomerList?productId=" + productId), { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductReleaseService.prototype.notifyOther = function (data) {
        if (data) {
            this.notify.next(data);
        }
    };
    ProductReleaseService = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_4__angular_common_http__["d" /* HttpClient */]])
    ], ProductReleaseService);
    return ProductReleaseService;
}());



/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExportToCSVService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var ExportToCSVService = /** @class */ (function () {
    function ExportToCSVService() {
    }
    ExportToCSVService.prototype.exportToCsv = function (data, fileName) {
        if (!data || data.length == 0) {
            return;
        }
        var headers = Object.keys(data[0]);
        var csvRows = data.map(function (row) {
            return headers.map(function (header) { return JSON.stringify(row[header], function (key, value) {
                return (value === null || value === undefined) ? "" : value;
            }); }).join(',');
        });
        csvRows.unshift(headers.join(','));
        var csvData = csvRows.join('\n');
        var blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        var url = window.URL.createObjectURL(blob);
        var dummyTag = document.createElement('a');
        dummyTag.href = url;
        dummyTag.download = fileName + ".csv";
        dummyTag.click();
        dummyTag.remove();
        window.URL.revokeObjectURL(url);
    };
    ExportToCSVService = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
    ], ExportToCSVService);
    return ExportToCSVService;
}());



/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
var config = {
    apiUrl: 'https://licenseandactivation-app.azurewebsites.net/api/',
    AzureADUrl: 'https://softwaremanagementportal.sensitsystems.net/',
    ReleaseVersionNo: 'Production (ver 3.0.27)',
    TokenGenerationUrl: 'https://licenseandactivation-app.azurewebsites.net/'
};
// For Staging
// export const config = {
//     apiUrl: 'https://licenseandactivationapi-stage.sensitsystems.net/api/',
//     AzureADUrl: 'https://softwaremanagementportal-stage.sensitsystems.net/',
//     ReleaseVersionNo: 'stage (ver 2.0.36)',
//     TokenGenerationUrl: 'https://licenseandactivationapi-stage.sensitsystems.net/'
// }
//For Development
// export const config = {
//     apiUrl: 'https://licenseandactivationapi-developer.sensitsystems.net/api/',
//     AzureADUrl: 'https://softwaremanagementportal-developer.sensitsystems.net/',
//     ReleaseVersionNo: 'Development (ver 1.0.31)',
//     TokenGenerationUrl: 'https://licenseandactivationapi-developer.sensitsystems.net/'
// }
// For Local
// export const config = {
//     apiUrl: 'https://localhost:44381/api/',
//     AzureADUrl: 'http://localhost:3003/',
//     ReleaseVersionNo: 'Development (ver 1.0.27)',
//     TokenGenerationUrl: 'https://localhost:44381/' 
// }


/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common_http__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_catch__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(55);






var ProductService = /** @class */ (function () {
    function ProductService(httpClient) {
        this.httpClient = httpClient;
        this.baseUrl = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].apiUrl;
        this.notify = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["Subject"]();
        this.notifyObservable$ = this.notify.asObservable();
    }
    ProductService.prototype.getProduct = function () {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/getProductsList', { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    ProductService.prototype.getReleaseProductsList = function () {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/getReleaseProductsList', { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    // Add Product
    ProductService.prototype.addProduct = function (ApplicationData) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/addProductList', ApplicationData, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    // Update Product
    ProductService.prototype.updateProduct = function (ApplicationData) {
        return this.httpClient.post(this.baseUrl + 'ReleaseManagement/updateProductList', ApplicationData, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    //get first displayed product
    ProductService.prototype.GetFirstDisplayedOTAProduct = function () {
        return this.httpClient.get(this.baseUrl + 'ReleaseManagement/v2/GetFirstDisplayedOTAProduct', { headers: this.getHeaders() }).map(function (response) {
            return response;
        });
    };
    ProductService.prototype.notifyOther = function (data) {
        if (data) {
            this.notify.next(data);
        }
    };
    ProductService.prototype.getHeaders = function () {
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_common_http__["c" /* HttpHeaders */]();
        headers.append('Content-Type', 'application/json');
        return headers;
    };
    ProductService = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_common_http__["d" /* HttpClient */]])
    ], ProductService);
    return ProductService;
}());



/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPCONFIG; });
function makeAppConfig() {
    var date = new Date();
    var year = date.getFullYear();
    return {
        brand: 'SENSIT TECHNOLOGIES',
        year: year,
        layoutBoxed: false,
        navCollapsed: false,
        navBehind: false,
        fixedHeader: true,
        sidebarWidth: 'large',
        theme: 'light',
        colorOption: '25',
        AutoCloseMobileNav: true,
    };
}
var APPCONFIG = makeAppConfig();


/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductReleaseStatus; });
var ProductReleaseStatus;
(function (ProductReleaseStatus) {
    ProductReleaseStatus[ProductReleaseStatus["DevRelease"] = 0] = "DevRelease";
    ProductReleaseStatus[ProductReleaseStatus["STPStart"] = 1] = "STPStart";
    ProductReleaseStatus[ProductReleaseStatus["QARelease"] = 2] = "QARelease";
    ProductReleaseStatus[ProductReleaseStatus["ProductionRelease"] = 3] = "ProductionRelease";
    ProductReleaseStatus[ProductReleaseStatus["PilotRelease"] = 4] = "PilotRelease";
    ProductReleaseStatus[ProductReleaseStatus["CustomRelease"] = 5] = "CustomRelease";
})(ProductReleaseStatus || (ProductReleaseStatus = {}));


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductsWithPushNotification; });
var ProductsWithPushNotification;
(function (ProductsWithPushNotification) {
    ProductsWithPushNotification[ProductsWithPushNotification["G3"] = 12] = "G3";
    ProductsWithPushNotification[ProductsWithPushNotification["G3-GLT"] = 41] = "G3-GLT";
    ProductsWithPushNotification[ProductsWithPushNotification["PMD2"] = 13] = "PMD2";
    ProductsWithPushNotification[ProductsWithPushNotification["PMD2GLT"] = 42] = "PMD2GLT";
    ProductsWithPushNotification[ProductsWithPushNotification["PMD2EMEA"] = 13] = "PMD2EMEA";
    ProductsWithPushNotification[ProductsWithPushNotification["LZ-50"] = 15] = "LZ-50";
})(ProductsWithPushNotification || (ProductsWithPushNotification = {}));


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutRevertReleaseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Rx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ProductReleaseService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_NotificationService__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__interfaces_PushNotificationHistory__ = __webpack_require__(124);








var PageLayoutRevertReleaseComponent = /** @class */ (function () {
    function PageLayoutRevertReleaseComponent(dialogRef, snackBar, appLoaderService, productRelaseService, notificationService, data) {
        this.dialogRef = dialogRef;
        this.snackBar = snackBar;
        this.appLoaderService = appLoaderService;
        this.productRelaseService = productRelaseService;
        this.notificationService = notificationService;
        this.data = data;
        this.IsSTPPerformed = false;
        this.IsPushNotificationChecked = true;
        this.pushNotificationHistoryDTO = { Title: "", Body: "", ProductReleaseId: 0, ProductId: 0, ParentProductId: 0, CreatedBy: 0 };
        this.ChangeLogData = "\nChange Logs:";
        document.body.style.overflow = "hidden";
        this.ProductReleaseId = this.data.ProductReleaseId;
        this.ProductReleaseNo = this.data.ProductReleaseNo;
        this.ProductId = this.data.ProductId;
        this.ParentProductId = this.data.ParentProductId;
        this.IsSTPPerformed = this.data.IsSTPPerformed;
        this.ProductName = this.data.ProductName;
        this.SubProductName = this.data.SubProductName;
        this.ProductCode = this.data.ProductCode;
        if (this.data.Status == 3) {
            this.Title = "Activate Release";
            this.TitleDescription =
                "Are you sure want to Activate #" + this.ProductReleaseNo + " Release ?";
        }
        else if (this.data.Status == 2) {
            this.Title = "Approve Release";
            this.TitleDescription =
                "Are you sure want to Approve build #" + this.ProductReleaseNo + "?";
        }
        else if (this.data.Status == -1) {
            this.Title = "Reject Release";
            this.TitleDescription =
                "Are you sure want to reject build #" +
                    this.ProductReleaseNo +
                    "? Once you reject the build it will be deleted permanently!";
        }
        else if (this.data.Status == 1) {
            this.Title = "STP";
            this.TitleDescription =
                "Are you sure want to Start STP for build #" +
                    this.ProductReleaseNo +
                    "?";
        }
    }
    PageLayoutRevertReleaseComponent.prototype.ActiveRelease = function () {
        var _this = this;
        this.appLoaderService.open();
        var model = {
            ProductReleaseId: this.ProductReleaseId,
            ProductId: Number(this.ProductId),
            PrductReleaseNo: this.ProductReleaseNo,
            UpdatedBy: Number(localStorage.getItem("userid")),
            CommentDesc: this.commentForRelease
        };
        this.productRelaseService.ActiveRelease(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                //if the release is added to the active releases in the database then send push notification if check box is checked
                if (_this.checkIsValidProductForNotification() && _this.IsPushNotificationChecked) {
                    _this.SendPushNotification();
                }
                _this.appLoaderService.close();
                _this.snackBar.open("Active Release Successfully", "", {
                    duration: 2000,
                });
            }
            else {
                _this.appLoaderService.close();
                _this.snackBar.open(data.Error, "", {
                    duration: 2000,
                });
            }
            document.body.style.overflow = "auto";
            _this.dialogRef.close(true);
        }, function (_error) {
            document.body.style.overflow = "auto";
            _this.dialogRef.close(false);
            _this.appLoaderService.close();
        });
    };
    PageLayoutRevertReleaseComponent.prototype.checkIsValidProductForNotification = function () {
        var productCode = this.ProductCode;
        if (productCode in __WEBPACK_IMPORTED_MODULE_7__interfaces_PushNotificationHistory__["a" /* ProductsWithPushNotification */]) {
            return true;
        }
        return false;
    };
    PageLayoutRevertReleaseComponent.prototype.SendPushNotification = function () {
        var _this = this;
        this.productRelaseService.getChangeLogDetails(this.ProductReleaseId).subscribe(function (data) {
            var allChangeLog = "";
            if (!data.IsError && !data.DataObject != null) {
                var counter = 1;
                for (var _i = 0, _a = data.DataObject; _i < _a.length; _i++) {
                    var log = _a[_i];
                    allChangeLog += '\n' + counter + '. ' + log.ChangeLog;
                    counter++;
                }
                if (allChangeLog.length > 150) {
                    _this.ChangeLogData = allChangeLog.substring(0, 150) + "...";
                }
                else {
                    _this.ChangeLogData = allChangeLog;
                }
                _this.ChangeLogData += '\n\n"To view detailed change logs visit products page"';
            }
            else {
                allChangeLog = null;
            }
            var message = {
                Title: _this.ProductName + " updates available",
                Body: _this.SubProductName + " Version " + _this.ProductReleaseNo + " released" + _this.ChangeLogData,
            };
            _this.notificationService.sendNotificationMessageForAndroid(message).subscribe();
            _this.notificationService.sendNotificationMessageForApple(message).subscribe();
            _this.pushNotificationMessage = message;
            _this.pushNotificationHistoryDTO.Body = _this.pushNotificationMessage.Body;
            _this.pushNotificationHistoryDTO.Title = _this.pushNotificationMessage.Title;
            _this.pushNotificationHistoryDTO.ProductId = _this.ProductId;
            _this.pushNotificationHistoryDTO.ParentProductId = _this.ParentProductId;
            _this.pushNotificationHistoryDTO.ProductReleaseId = _this.ProductReleaseId;
            _this.pushNotificationHistoryDTO.CreatedBy = Number(localStorage.getItem("userid"));
            _this.notificationService.addNotificationHistory(_this.pushNotificationHistoryDTO).subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    _this.appLoaderService.close();
                    _this.snackBar.open("Push notification sent successfully!", "", {
                        duration: 2000
                    });
                }
            });
        });
    };
    PageLayoutRevertReleaseComponent.prototype.ApproveRelease = function () {
        var _this = this;
        this.appLoaderService.open();
        var model = {
            ProductReleaseId: this.ProductReleaseId,
            IsApproved: true,
            UpdatedBy: Number(localStorage.getItem("userid")),
            IsSTPPerformed: this.IsSTPPerformed,
            CommentDesc: this.commentForRelease
        };
        this.productRelaseService.ApproveRelease(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.appLoaderService.close();
                _this.snackBar.open("Approve Release Successfully", "", {
                    duration: 2000,
                });
            }
            else {
                _this.appLoaderService.close();
                _this.snackBar.open(data.Error, "", {
                    duration: 2000,
                });
            }
            document.body.style.overflow = "auto";
            _this.dialogRef.close(true);
        }, function (_error) {
            document.body.style.overflow = "auto";
            _this.dialogRef.close(false);
            _this.appLoaderService.close();
        });
    };
    PageLayoutRevertReleaseComponent.prototype.RejectRelease = function () {
        var _this = this;
        this.appLoaderService.open();
        var model = {
            ProductReleaseId: this.ProductReleaseId,
            IsApproved: true,
            UpdatedBy: Number(localStorage.getItem("userid")),
            CommentDesc: this.commentForRelease
        };
        this.productRelaseService.RejectRelease(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.appLoaderService.close();
                _this.snackBar.open("Delete Release Successfully", "", {
                    duration: 2000,
                });
            }
            else {
                _this.appLoaderService.close();
                _this.snackBar.open(data.Error, "", {
                    duration: 2000,
                });
            }
            document.body.style.overflow = "auto";
            _this.dialogRef.close(true);
        }, function (_error) {
            document.body.style.overflow = "auto";
            _this.dialogRef.close(false);
            _this.appLoaderService.close();
        });
    };
    PageLayoutRevertReleaseComponent.prototype.STPStart = function (showLoadder, ISRequestSTP) {
        var _this = this;
        if (showLoadder === void 0) { showLoadder = true; }
        if (ISRequestSTP === void 0) { ISRequestSTP = false; }
        if (showLoadder == true)
            this.appLoaderService.open();
        var model = {
            ProductReleaseId: this.ProductReleaseId,
            IsApproved: true,
            UpdatedBy: Number(localStorage.getItem("userid")),
            CommentDesc: this.commentForRelease
        };
        this.productRelaseService.STPStart(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.appLoaderService.close();
                _this.snackBar.open("STP Started", "", {
                    duration: 2000,
                });
            }
            else {
                _this.appLoaderService.close();
                _this.snackBar.open(data.Error, "", {
                    duration: 2000,
                });
            }
            var result = {
                "result": true,
                "ISRequestSTP": ISRequestSTP
            };
            document.body.style.overflow = "auto";
            _this.dialogRef.close(result);
        }, function (_error) {
            document.body.style.overflow = "auto";
            _this.dialogRef.close(false);
            _this.appLoaderService.close();
        });
    };
    PageLayoutRevertReleaseComponent.prototype.checkValue = function (result) {
        this.IsSTPPerformed = result;
    };
    PageLayoutRevertReleaseComponent.prototype.checkValueForPushNotification = function (result) {
        this.IsPushNotificationChecked = result;
    };
    PageLayoutRevertReleaseComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.data.Status == 3) {
            if (this.IsSTPPerformed == false) {
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a
                    .fire({
                    title: "<strong>Releasing Product without STP</strong>",
                    icon: "info",
                    html: "\n        <p><b>Warning:</b> Releasing this product without testing carries significant risks and could lead to unexpected behavior, performance issues, or even security vulnerabilities. By proceeding, you acknowledge and accept these risks.</p>\n        <b>Please confirm your action:</b>\n        <ul style=\"text-align: left;\">\n        <li style=\"margin-top:10px;\"><b>Accept:</b> Proceed with releasing this product without STP.</li>\n        <li><b>Request STP:</b> Requesting QA Department to perform STP.</li>\n        <li><b>Cancel:</b> Effectively closes this dialog box without applying any alterations.</li>\n        </ul>\n        ",
                    showCloseButton: true,
                    showCancelButton: true,
                    showDenyButton: true,
                    focusConfirm: false,
                    confirmButtonText: "Accept",
                    confirmButtonAriaLabel: "Accept",
                    cancelButtonText: "Cancel",
                    cancelButtonAriaLabel: "Cancel",
                    denyButtonText: "Request STP",
                    denyButtonAriaLabel: "Request STP",
                })
                    .then(function (result) {
                    if (result.isConfirmed) {
                        _this.ActiveRelease();
                    }
                    else if (result.isDismissed) {
                        document.body.style.overflow = "auto";
                        _this.dialogRef.close(false);
                    }
                    else if (result.isDenied) {
                        _this.appLoaderService.open();
                        _this.productRelaseService
                            .getReleaseByProductId(_this.ProductId)
                            .subscribe(function (data) {
                            var IsAllowReleae = true;
                            if (!data.IsError && data.DataObject != null) {
                                var releaseData = data.DataObject;
                                releaseData.forEach(function (element) {
                                    var customers = element.Customers ? element.Customers.map(function (c, index) { return index + 1 + ". " + c.Name; }) : [];
                                    var toolip = customers && customers.length > 0 ? customers.join('\n') : 'No customers';
                                    element.CustomerTooltip = toolip;
                                    if ((element.Status == 0 || element.Status == 1) &&
                                        element.IsDeleted == false) {
                                        IsAllowReleae = false;
                                    }
                                });
                                if (IsAllowReleae == true) {
                                    _this.STPStart(false, true);
                                }
                                else {
                                    _this.appLoaderService.close();
                                    __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a
                                        .fire({
                                        title: "<strong>Unable To Process Request</strong>",
                                        icon: "info",
                                        html: "<P>You can't request STP because there is already one pending release in queue</P>",
                                        showDenyButton: false,
                                        showCancelButton: false,
                                        confirmButtonText: "Ok",
                                    })
                                        .then(function (result) {
                                        /* Read more about isConfirmed, isDenied below */
                                        if (result.isConfirmed) {
                                            _this.onSubmit();
                                        }
                                    });
                                }
                            }
                            else {
                                _this.appLoaderService.close();
                            }
                        }, function (error) {
                            _this.appLoaderService.close();
                        });
                    }
                });
            }
            else {
                this.ActiveRelease();
            }
        }
        else if (this.data.Status == 2) {
            if (this.IsSTPPerformed == false) {
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a
                    .fire({
                    title: "<strong>Skipping the Software Test Plan (STP)</strong>",
                    icon: "info",
                    html: "\n        <p><b>Warning:</b> Releasing this product without testing carries significant risks and could lead to unexpected behavior, performance issues, or even security vulnerabilities. By proceeding, you acknowledge and accept these risks.</p>\n        ",
                    showCloseButton: true,
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText: "Accept",
                    confirmButtonAriaLabel: "Accept",
                    cancelButtonText: "Cancel",
                    cancelButtonAriaLabel: "Cancel",
                })
                    .then(function (result) {
                    if (result.isConfirmed) {
                        _this.ApproveRelease();
                    }
                    else if (result.isDismissed) {
                        document.body.style.overflow = "auto";
                        _this.dialogRef.close(false);
                    }
                });
            }
            else {
                this.ApproveRelease();
            }
        }
        else if (this.data.Status == -1)
            this.RejectRelease();
        else if (this.data.Status == 1)
            this.STPStart();
    };
    PageLayoutRevertReleaseComponent.prototype.onCancel = function () {
        document.body.style.overflow = "auto";
        this.dialogRef.close(false);
    };
    PageLayoutRevertReleaseComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: "my-page-layout-revert-release",
            styles: [],
            template: __webpack_require__(1067),
        }),
        __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_3__services_ProductReleaseService__["a" /* ProductReleaseService */],
            __WEBPACK_IMPORTED_MODULE_6__services_NotificationService__["a" /* NotificationService */], Object])
    ], PageLayoutRevertReleaseComponent);
    return PageLayoutRevertReleaseComponent;
}());



/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutProductReleaseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ProductReleaseService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto_js__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_common_http__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__interfaces_ProductRevFileNotReadFromFile_model__ = __webpack_require__(747);













var PageLayoutProductReleaseComponent = /** @class */ (function () {
    function PageLayoutProductReleaseComponent(router, formBuilder, productReleaseService, snackBar, appLoaderService, adalService, userService, dialogRef, data) {
        var _this = this;
        this.router = router;
        this.formBuilder = formBuilder;
        this.productReleaseService = productReleaseService;
        this.snackBar = snackBar;
        this.appLoaderService = appLoaderService;
        this.adalService = adalService;
        this.userService = userService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.IsFileSize = false;
        this.IsPackageSize = false;
        this.IsAllowedToAdd = false;
        this.EditHash = false;
        // Package File and DBVersion visible
        this.IsProductCodeVisble = false;
        this.ProductCodePanelVisble = [14, 89];
        // Release Status for Edit File Upload
        this.ProductReleaseStatus = 0;
        // Button Disable
        this.CancelButtonDisabled = false;
        this.SaveButtonDisabled = false;
        // for Change Log
        this.dynamicArray = [];
        this.newDynamic = {};
        this.percentDone = 0;
        this.packagepercentDone = 0;
        this.submitted = false;
        // For Error Display
        this.errorMessage = "";
        // For Display Purpose Edit
        this.filename = "";
        this.filehash = null;
        this.ProductReleaseId = 0;
        // For Package Support File
        this.ProductReleaseSupport = [];
        this.packagefiles = [];
        this.packagefilehash = [];
        //#endregion
        //#region "IN STP Start,QA and Prod Release Release Status User Can not chnage the file"   
        this.disableInputClick = function (event) {
            if ((_this.IsDeveloperRights && _this.ProductReleaseStatus != 0) || (!_this.IsDeveloperRights)) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
        };
        // Check Authentication               
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        // On Edit Get Data
        if (this.data.ProductReleaseId != 0) {
            if (this.data.SubProductName != '')
                this.Title = "Edit " + this.data.ProductName + " [" + this.data.SubProductName + "] " + "Release";
            else
                this.Title = "Edit " + this.data.ProductName + " Release";
            this.ProductReleaseId = this.data.ProductReleaseId;
            this.getProductReleaseDetails(this.data.ProductReleaseId);
            this.getChangeLogDetails(this.data.ProductReleaseId);
        }
        else {
            if (this.data.SubProductName != '')
                this.Title = "Add " + this.data.ProductName + " [" + this.data.SubProductName + "] " + "Release";
            else
                this.Title = "Add " + this.data.ProductName + " Release";
        }
        this.getUserRights(Number(localStorage.getItem('userid')), this.data.ParentProductId);
    }
    PageLayoutProductReleaseComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    PageLayoutProductReleaseComponent.prototype.buildForm = function () {
        var _this = this;
        this.validationForm = this.formBuilder.group({
            ProductReleaseNo: ['', __WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required],
            ReleaseDate: this.formBuilder.control(__WEBPACK_IMPORTED_MODULE_5_moment__().format("YYYY-MM-DD"), __WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required),
            DBVersion: [''],
            file: ['', __WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required],
            packagefile: [''],
            ChangeLogs: this.ProductReleaseId == 0 ? this.formBuilder.array([this.createChangeLog(null)]) : this.formBuilder.array([]),
        });
        // For Specific Product Visible DBVersion and Package File Upload
        this.ProductCodePanelVisble.forEach(function (element) {
            if (element == _this.data.ProductCode) {
                _this.IsProductCodeVisble = true;
            }
        });
        if (this.IsProductCodeVisble) { // In SCAL DBVesion and Package File Required
            this.validationForm.get('DBVersion').setValidators(__WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required);
            this.validationForm.get('DBVersion').updateValueAndValidity();
            this.validationForm.get('DBVersion').setValidators(__WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].pattern('^[0-9]*$'));
            this.validationForm.get('DBVersion').updateValueAndValidity();
            this.validationForm.get('packagefile').setValidators(__WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required);
        }
        // G3,PMD 2 and G3GLT case File Revision No read from File
        if (this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].G3 || this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].PMD2 || this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].G3GLT || this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].PMD2GLT || this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].TrakIT4) {
            var ctrl = this.validationForm.get('ProductReleaseNo');
            ctrl.disable();
        }
        this.validationForm.get('DBVersion').updateValueAndValidity();
        this.validationForm.get('packagefile').updateValueAndValidity();
        // In Edit Mode ProductReleaseNo Disable and Product File and Package File Required Field Validator Remove
        if (this.ProductReleaseId != 0) {
            var ProductReleaseNo = this.validationForm.get('ProductReleaseNo');
            if ((this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_12__interfaces_ProductRevFileNotReadFromFile_model__["a" /* ProductRevFileNotReadFromFile */].SCAL360 || this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_12__interfaces_ProductRevFileNotReadFromFile_model__["a" /* ProductRevFileNotReadFromFile */].SmartCal360 || this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_12__interfaces_ProductRevFileNotReadFromFile_model__["a" /* ProductRevFileNotReadFromFile */].LZ50) && (this.data.Status == 0))
                ProductReleaseNo.enable();
            else
                ProductReleaseNo.disable();
            this.validationForm.get("file").clearValidators();
            this.validationForm.get("file").setErrors(null);
            this.validationForm.get('file').updateValueAndValidity();
            this.validationForm.get('packagefile').clearValidators();
            this.validationForm.get('packagefile').updateValueAndValidity();
        }
    };
    PageLayoutProductReleaseComponent.prototype.DBVersionNumericOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    };
    //#region "GetUserRightsByUserIdandProductId"
    PageLayoutProductReleaseComponent.prototype.getUserRights = function (UserId, ProductId) {
        var _this = this;
        this.userService.getUserRightsById(UserId, ProductId).subscribe(function (Data) {
            _this.IsDeveloperRights = Data[0].IsAdd; // If IsDeveloperRights==true then Update Product File and Package Files              
        });
    };
    //#endregion
    //#region "GetProductReleaseDetailsByProductReleaseId"
    PageLayoutProductReleaseComponent.prototype.getProductReleaseDetails = function (ProductReleaseId) {
        var _this = this;
        this.appLoaderService.open();
        this.productReleaseService.getProductReleaseById(ProductReleaseId).subscribe(function (releaseData) {
            if (!releaseData.IsError && releaseData.DataObject != null) {
                _this.validationForm.patchValue({
                    ProductReleaseNo: releaseData.DataObject.ProductReleaseNo,
                    ReleaseDate: __WEBPACK_IMPORTED_MODULE_5_moment__(releaseData.DataObject.ReleaseDate).format("YYYY-MM-DD"),
                    DBVersion: releaseData.DataObject.DBVersion
                });
                _this.LastProductReleaseNo = releaseData.DataObject.ProductReleaseNo;
                _this.EditFileHash = releaseData.DataObject.HashKey;
                _this.filename = releaseData.DataObject.FileName;
                _this.filehash = releaseData.DataObject.HashKey;
                _this.filesize = releaseData.DataObject.FileSize;
                _this.filepath = releaseData.DataObject.FilePath;
                if (releaseData.DataObject.ProductReleaseSupport == "" && _this.IsProductCodeVisble && releaseData.DataObject.Status == 0) {
                    _this.validationForm.get('packagefile').setValidators([__WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required]);
                    _this.validationForm.get('packagefile').updateValueAndValidity();
                }
                _this.ProductReleaseSupportEditData = releaseData.DataObject.ProductReleaseSupport;
                _this.ProductReleaseStatus = releaseData.DataObject.Status;
                _this.appLoaderService.close();
            }
            else {
                _this.errorMessage = releaseData.Error;
                _this.appLoaderService.close();
            }
        }, function (_error) {
            _this.appLoaderService.close();
        });
    };
    //#endregion
    //#region "getChangeLogDetailsbyProductReleaseId"
    PageLayoutProductReleaseComponent.prototype.getChangeLogDetails = function (ProductReleaseId) {
        var _this = this;
        this.productReleaseService.getChangeLogDetails(ProductReleaseId).subscribe(function (data) {
            if (data.DataObject.length > 0) {
                var changelog = _this.validationForm.get('ChangeLogs');
                for (var _i = 0, _a = data.DataObject; _i < _a.length; _i++) {
                    var row = _a[_i];
                    changelog.push(_this.createChangeLog(row));
                }
            }
        });
    };
    //#endregion
    PageLayoutProductReleaseComponent.prototype.checkRevsionNo = function () {
        var _this = this;
        if (this.validationForm.value.ProductReleaseNo != "") {
            var CheckRevModel = {
                ProductReleaseId: Number(this.ProductReleaseId),
                ProductRev: this.validationForm.value.ProductReleaseNo,
                ProductId: Number(this.data.ProductId)
            };
            this.productReleaseService.checkRevisionNo(CheckRevModel).subscribe(function (SoftwareData) {
                if (SoftwareData.DataObject.length > 0) {
                    _this.validationForm.patchValue({
                        ProductReleaseNo: ''
                    });
                    _this.SaveButtonDisabled = false;
                    _this.CancelButtonDisabled = false;
                    _this.appLoaderService.close();
                    _this.errorMessage = "Revision Already Exists..!";
                }
                else {
                    _this.errorMessage = "";
                }
            }, function (_error) { return _this.CancelButtonDisabled = false; });
        }
        else {
            this.errorMessage = "";
        }
    };
    PageLayoutProductReleaseComponent.prototype.checkDBVersion = function () {
        var _this = this;
        if (this.validationForm.value.DBVersion != "") {
            this.productReleaseService.checkDBVersion(this.validationForm.value.DBVersion, Number(this.data.ProductId), Number(this.ProductReleaseId)).subscribe(function (Data) {
                if (!Data.IsError) {
                    _this.errorMessage = "";
                }
                else {
                    _this.validationForm.patchValue({
                        DBVersion: ''
                    });
                    _this.SaveButtonDisabled = false;
                    _this.CancelButtonDisabled = false;
                    _this.appLoaderService.close();
                    _this.errorMessage = Data.Error;
                }
            }, function (_error) { return _this.CancelButtonDisabled = false; });
        }
        else {
            this.errorMessage = "";
        }
    };
    PageLayoutProductReleaseComponent.prototype.createChangeLog = function (data) {
        data = data || { ChangeLog: null, ProductReleaseChangeLogId: 0, ProductReleaseId: 0 };
        return this.formBuilder.group({
            ProductReleaseChangeLogId: [0],
            ChangeLog: [data.ChangeLog, __WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required],
            ProductReleaseId: [0]
        });
    };
    Object.defineProperty(PageLayoutProductReleaseComponent.prototype, "ChangeLogs", {
        get: function () {
            return this.validationForm.get("ChangeLogs");
        },
        enumerable: true,
        configurable: true
    });
    PageLayoutProductReleaseComponent.prototype.addChangeLog = function () {
        var changelog = this.validationForm.get('ChangeLogs');
        changelog.push(this.createChangeLog(null));
        this.IsChangeLog = false;
        if (changelog.length == 0) {
            this.IsChangeLog = true;
        }
    };
    PageLayoutProductReleaseComponent.prototype.deleteChangeLog = function (index) {
        var changelog = this.validationForm.get('ChangeLogs');
        if (changelog.length == 1) {
            this.IsChangeLog = true;
        }
        else {
            this.validationForm.controls['ChangeLogs'].markAsDirty();
            this.ChangeLogs.removeAt(index);
        }
    };
    //#region "Read File Bytes and Convert HexaDecimal to Decimal"
    PageLayoutProductReleaseComponent.prototype.hexadecimalToDecimal = function (hexVal) {
        var len = hexVal.length;
        // Initializing base value to 1, i.e 16^0
        var base = 1;
        var dec_val = 0;
        // Extracting characters as digits from last
        // character
        for (var i = len - 1; i >= 0; i--) {
            // if character lies in '0'-'9', converting
            // it to integral 0-9 by subtracting 48 from
            // ASCII value
            if (hexVal.charAt(i) >= '0'
                && hexVal.charAt(i) <= '9') {
                dec_val += (hexVal.charAt(i).charCodeAt(0) - 48) * base;
                // incrementing base by power
                base = base * 16;
            }
            // if character lies in 'A'-'F' , converting
            // it to integral 10 - 15 by subtracting 55
            // from ASCII value
            else if (hexVal.charAt(i) >= 'A'
                && hexVal.charAt(i) <= 'F') {
                dec_val += (hexVal.charAt(i).charCodeAt(0) - 55) * base;
                // incrementing base by power
                base = base * 16;
            }
        }
        // Code to Resolved G3 Bug [Remove this code when SCAL new relase with G3 Changes]
        var decimal_value;
        if (dec_val.toString().length < 2)
            decimal_value = "0" + dec_val;
        else
            decimal_value = dec_val;
        return decimal_value;
    };
    //#endregion
    PageLayoutProductReleaseComponent.prototype.CheckChangeLog = function (value) {
        if (value != "") {
            this.IsChangeLog = false;
        }
    };
    PageLayoutProductReleaseComponent.prototype.getAllowedToAdd = function (ProductId) {
        var _this = this;
        this.SaveButtonDisabled = true;
        this.CancelButtonDisabled = true;
        if (this.validationForm.get("ProductReleaseNo").value != null || this.validationForm.get("ProductReleaseNo").value != undefined)
            this.ProductReleaseNo = this.validationForm.get("ProductReleaseNo").value;
        else
            this.ProductReleaseNo = this.data.payload.ProductReleaseNo;
        this.productReleaseService.getIsAllowedToAddReleaseByProductId(ProductId).subscribe(function (data) {
            if (_this.ProductReleaseId != 0) {
                _this.IsAllowedToAdd = false;
            }
            else {
                if (!data.IsError && data.DataObject != null) {
                    _this.IsAllowedToAdd = false;
                }
                else {
                    _this.IsAllowedToAdd = true;
                    _this.SaveButtonDisabled = false;
                    _this.CancelButtonDisabled = false;
                    _this.errorMessage = "You can't add new release because there is already one pending release in queue";
                    return;
                }
            }
            if (!_this.IsAllowedToAdd && _this.ProductReleaseNo != "") {
                _this.CheckRevNoandDBVersion();
            }
        }, function (_error) {
            _this.CancelButtonDisabled = false;
        });
    };
    PageLayoutProductReleaseComponent.prototype.CheckRevNoandDBVersion = function () {
        var _this = this;
        var CheckRevModel = {
            ProductReleaseId: Number(this.ProductReleaseId),
            ProductRev: this.ProductReleaseNo,
            ProductId: Number(this.data.ProductId)
        };
        this.productReleaseService.checkRevisionNo(CheckRevModel).subscribe(function (SoftwareData) {
            if (SoftwareData.DataObject.length > 0) {
                if (_this.data.ProductCode != __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].G3 && _this.data.ProductCode != __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].PMD2 && _this.data.ProductCode != __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].G3GLT && _this.data.ProductCode != __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].PMD2GLT && _this.data.ProductCode != __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].TrakIT4) {
                    _this.validationForm.patchValue({
                        ProductReleaseNo: ''
                    });
                }
                _this.SaveButtonDisabled = false;
                _this.CancelButtonDisabled = false;
                _this.errorMessage = "Revision Already Exists..!";
                _this.appLoaderService.close();
            }
            else {
                _this.CheckDBVersionandUpload();
            }
        }, function (_error) { return _this.CancelButtonDisabled = false; });
    };
    PageLayoutProductReleaseComponent.prototype.CheckDBVersionandUpload = function () {
        var _this = this;
        // Check DB Version [If DBVersion is there]
        if (this.IsProductCodeVisble) {
            if (this.validationForm.value.DBVersion != "") {
                this.productReleaseService.checkDBVersion(this.validationForm.value.DBVersion, Number(this.data.ProductId), Number(this.ProductReleaseId)).subscribe(function (Data) {
                    if (Data.IsError) {
                        _this.appLoaderService.close();
                        _this.validationForm.patchValue({
                            DBVersion: ''
                        });
                        _this.SaveButtonDisabled = false;
                        _this.CancelButtonDisabled = false;
                        _this.errorMessage = Data.Error;
                        return;
                    }
                    _this.CalculateProductHashandUpload();
                }, function (_error) { return _this.CancelButtonDisabled = false; });
            }
        }
        else {
            this.errorMessage = "";
            this.CalculateProductHashandUpload();
        }
    };
    // On Submit Click Event
    PageLayoutProductReleaseComponent.prototype.onSubmit = function () {
        this.errorMessage = "";
        this.IsChangeLog = false;
        if (this.validationForm.invalid) {
            return;
        }
        // First Check Any Pending Release in Queue
        this.getAllowedToAdd(this.data.ProductId);
    };
    PageLayoutProductReleaseComponent.prototype.oneditcancel = function () {
        this.dialogRef.close(null);
    };
    PageLayoutProductReleaseComponent.prototype.CalculateProductHashandUpload = function () {
        if (!this.IsFileSize && !this.IsPackageSize) {
            this.appLoaderService.open();
            if (this.eventdata != null && this.eventdata.target.files.length > 0) {
                this.getHash(this.eventdata.target.files[0]);
            }
            else if (this.packagedata != null && this.packagedata.target.files.length > 0) {
                this.getPackageHash(this.packagedata.target.files[0]);
            }
            else {
                this.SaveProductDetail();
            }
        }
    };
    PageLayoutProductReleaseComponent.prototype.detectMimeType = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onloadend = function () {
                if (reader.result instanceof ArrayBuffer) {
                    var arr = new Uint8Array(reader.result).subarray(0, 4);
                    var header = "";
                    for (var i = 0; i < arr.length; i++) {
                        header += arr[i].toString(16);
                    }
                    // Common file signatures (Magic Numbers)
                    var mimeTypes = {
                        "89504e47": "image/png",
                        "47494638": "image/gif",
                        "25504446": "application/pdf",
                        "504b0304": "application/zip",
                        "d0cf11e0": "application/x-msi",
                        "ffd8ffe0": "image/jpeg",
                        "ffd8ffe1": "image/jpeg",
                        "ffd8ffe2": "image/jpeg",
                        "4d5a9000": "application/x-msdownload"
                    };
                    resolve(mimeTypes[header] || "unknown");
                }
                else {
                    reject("Failed to read file.");
                }
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(file.slice(0, 4)); // Read first 4 bytes
        });
    };
    //#region "Get Product File OnChange Event"
    PageLayoutProductReleaseComponent.prototype.onChange = function (event) {
        var _this = this;
        this.errorMessage = "";
        this.uploadresponse = "";
        this.eventdata = event;
        var fileList = this.eventdata.target.files;
        if (fileList.length > 0) {
            var file = fileList[0];
            if (this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_12__interfaces_ProductRevFileNotReadFromFile_model__["a" /* ProductRevFileNotReadFromFile */].SCAL360) {
                this.detectMimeType(file).then(function (mime) {
                    if (mime != 'application/x-msi') {
                        _this.uploadSuccess = false;
                        _this.uploadresponse = "Please Select MSI file.";
                        _this.IsFileSize = true;
                        _this.SaveButtonDisabled = true;
                        return false;
                    }
                });
            }
            this.errorMessage = "";
            var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
            if (Number(sizeInMB) > 1000) {
                this.uploadSuccess = false;
                this.uploadresponse = "Product File Size should not be greater than 1 GB";
                this.IsFileSize = true;
                this.SaveButtonDisabled = true;
                return false;
            }
            this.IsFileSize = false;
            // In G3 and PMD2 Case get ProductReleaseNo and ProductId   
            this.ReadSelectedProductFile(sizeInMB, this.eventdata);
            if (this.IsProductCodeVisble && this.ProductReleaseId == 0 && this.IsPackageSize)
                this.SaveButtonDisabled = true;
            else
                this.SaveButtonDisabled = false;
        }
        else {
            if (this.data.ProductCode == 12 && this.ProductReleaseId == 0) {
                this.validationForm.patchValue({ ProductReleaseNo: '' });
            }
            else if (this.data.ProductCode == 12 && this.ProductReleaseId != 0) {
                this.validationForm.patchValue({ ProductReleaseNo: this.LastProductReleaseNo });
            }
            this.SaveButtonDisabled = false;
        }
    };
    //#endregion
    //#region "Read G3,PMD2,G3GLT"
    PageLayoutProductReleaseComponent.prototype.ReadSelectedProductFile = function (sizeInMB, event) {
        var _this = this;
        // In G3 and PMD2 Case get ProductReleaseNo and ProductId   
        if (this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].G3 || this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].PMD2 || this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].G3GLT || this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].PMD2GLT || this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].TrakIT4) {
            if (Number(sizeInMB) > 5) {
                this.uploadSuccess = false;
                this.uploadresponse = "File Size should not be greater than 5 MB";
                this.IsFileSize = true;
                this.SaveButtonDisabled = true;
                return false;
            }
            var reader_1 = new FileReader();
            reader_1.onload = function () {
                _this.arrayBuffer = reader_1.result;
                var ProductCode = (Array.prototype.map.call(new Uint8Array(_this.arrayBuffer.slice(0x00000000, 0x00000001)), function (x) { return ('00' + _this.hexadecimalToDecimal(x.toString(16).toUpperCase())).slice(-2); }).join(''));
                var ProductSubCode = (Array.prototype.map.call(new Uint8Array(_this.arrayBuffer.slice(0x00000001, 0x00000002)), function (x) { return ('00' + _this.hexadecimalToDecimal(x.toString(16).toUpperCase())).slice(-1); }).join(''));
                var ProductReleaseNo = (Array.prototype.map.call(new Uint8Array(_this.arrayBuffer.slice(0x00000003, 0x00000006)), function (x) { return (_this.hexadecimalToDecimal(x.toString(16).toUpperCase())); }).join('.'));
                if ((_this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].G3 && ProductCode != _this.data.ProductCode) || (_this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].TrakIT4 && ProductCode != _this.data.ProductCode)) { // G3 Case Product Code Shoud be match
                    _this.uploadSuccess = false;
                    _this.uploadresponse = "Selected file is not appropriate for " + _this.data.ProductName + " Firmware";
                    _this.SaveButtonDisabled = true;
                    return;
                }
                else if (_this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].PMD2 || _this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].G3GLT || _this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_11__interfaces_ProductReleaseFileReadEnum_model__["a" /* ProductReleaseFileRead */].PMD2GLT) { // IN PMD2 & G3GLT Code and  Sub Type should be match                             
                    if ((ProductCode != _this.data.ProductCode) || (ProductSubCode != _this.data.SubType)) {
                        _this.uploadSuccess = false;
                        _this.uploadresponse = "Selected file is not a valid for " + _this.data.ProductName + " " + _this.data.SubProductName + " Firmware";
                        _this.SaveButtonDisabled = true;
                        return;
                    }
                }
                _this.validationForm.get("ProductReleaseNo").setValue(ProductReleaseNo);
            };
            reader_1.readAsArrayBuffer(event.target.files[0]);
        }
    };
    //#endregion
    //#region "Get Product File Hash"
    PageLayoutProductReleaseComponent.prototype.getHash = function (filename) {
        var _this = this;
        var hashdata = __WEBPACK_IMPORTED_MODULE_6_crypto_js__["algo"].SHA256.create();
        var file = filename;
        if (file) {
            var reader_2 = new FileReader();
            var size_1 = file.size;
            var chunk_size_1 = Math.pow(2, 22);
            var offset_1 = 0;
            var bytes_1 = 0;
            reader_2.onloadend = function (_e) {
                if (reader_2.readyState == FileReader.DONE) {
                    _this.uploadSuccess = true;
                    _this.uploadresponse = "Computing File Hash...!";
                    //every chunk read updating hash
                    hashdata.update(_this.arrayBufferToWordArray(reader_2.result));
                    var chunk = reader_2.result;
                    bytes_1 += chunk.length;
                    if ((offset_1 < size_1)) {
                        offset_1 += chunk_size_1;
                        var blobchunk = file.slice(offset_1, offset_1 + chunk_size_1);
                        reader_2.readAsArrayBuffer(blobchunk);
                    }
                    else {
                        var hash = hashdata.finalize().toString();
                        _this.CheckAndUploadProductFile(hash);
                    }
                }
            };
            var blob = file.slice(offset_1, offset_1 + chunk_size_1);
            reader_2.readAsArrayBuffer(blob);
        }
    };
    //#endregion
    //#region "Product File Upload"
    PageLayoutProductReleaseComponent.prototype.CheckAndUploadProductFile = function (hash) {
        if (this.ProductReleaseId != 0) {
            if (String(hash) == String(this.EditFileHash)) {
                this.uploadSuccess = false;
                this.appLoaderService.close();
                this.uploadresponse = "Same Product File is not uploaded again...!";
                this.SaveButtonDisabled = true;
                this.CancelButtonDisabled = false;
                return;
            }
            this.filehash = String(hash);
            if (this.packagedata != null && this.packagedata.target.files.length > 0) {
                this.uploadresponse = '';
                this.EditHash = true;
                this.getPackageHash(this.packagedata.target.files[0]);
            }
            else {
                this.uploadfiles(this.eventdata.target.files[0]);
            }
        }
        else {
            this.filehash = String(hash);
            this.uploadfiles(this.eventdata.target.files[0]);
        }
    };
    //#endregion
    //#region "arrayBufferToWordArray [Used in Hash Function"]
    PageLayoutProductReleaseComponent.prototype.arrayBufferToWordArray = function (fileResult) {
        var i8a = new Uint8Array(fileResult);
        return __WEBPACK_IMPORTED_MODULE_6_crypto_js__["lib"].WordArray.create(i8a, i8a.length);
    };
    //#endregion
    //#region "Upload Product File and Package Files"
    PageLayoutProductReleaseComponent.prototype.uploadfiles = function (filelist) {
        var _this = this;
        var file = filelist;
        var formData = new FormData();
        this.filename = file.name.toString();
        var size = 0;
        if (file.size.toString() == null)
            size = Number(0);
        else
            size = Number(file.size.toString());
        this.filesize = Number(size);
        formData.append("ProductName", this.data.ProductName);
        formData.append("SubProductName", this.data.SubProductName);
        formData.append("ProductReleaseNo", this.ProductReleaseNo);
        formData.append("File", file);
        formData.append("fileName", this.filename);
        formData.append("FileHash", this.filehash);
        this.productReleaseService.UploadFiles(formData)
            .subscribe(function (event) {
            if (event.type === __WEBPACK_IMPORTED_MODULE_7__angular_common_http__["e" /* HttpEventType */].UploadProgress) {
                _this.uploadresponse = '';
                _this.percentDone = Math.round((100 * event.loaded) / event.total);
                if (_this.percentDone == 100) {
                    _this.uploadSuccess = true;
                    _this.uploadresponse = "File is uploading on azure...!";
                }
            }
            else if (event instanceof __WEBPACK_IMPORTED_MODULE_7__angular_common_http__["f" /* HttpResponse */]) {
                if (event.body.DataObject != null) {
                    _this.uploadSuccess = true;
                    _this.uploadresponse = "Successfully Upload";
                    _this.filepath = event.body.DataObject;
                    // If Package File Exists then Upload Package File Otherwise Save Funciton Call
                    _this.CheckPackageFileandHash();
                }
                else {
                    _this.uploadSuccess = false;
                    _this.CancelButtonDisabled = false;
                    _this.uploadresponse = event.body.Error;
                    _this.appLoaderService.close();
                }
            }
        }, function (_error) {
            _this.uploadSuccess = false;
            _this.uploadresponse = "Product file upload failure. Please contact administrator..!";
            _this.CancelButtonDisabled = false;
            _this.appLoaderService.close();
        });
    };
    //#endregion
    //#region "If Any Package File is there then First Get Package Hash"     
    PageLayoutProductReleaseComponent.prototype.CheckPackageFileandHash = function () {
        if (this.packagedata != null && this.packagedata.target.files.length > 0) {
            var PackageFileList = this.packagedata.target.files[0];
            this.EditHash = false;
            this.getPackageHash(PackageFileList);
        }
        else {
            this.SaveProductDetail();
        }
    };
    //#endregion
    //Package File Upload
    PageLayoutProductReleaseComponent.prototype.packageFileUpload = function () {
        var _this = this;
        var formData = new FormData();
        var fileList = this.packagedata.target.files;
        var filename = fileList[0].name.toString();
        var size = 0;
        size = Number(fileList[0].size.toString());
        formData.append("ProductName", this.data.ProductName);
        formData.append("ProductReleaseNo", this.ProductReleaseNo);
        formData.append("File", fileList.item(0));
        formData.append("fileName", filename);
        formData.append("PackageFileHash", this.packagefilehash[0]);
        var PackageModel = {
            PackageFileHashKey: this.packagefilehash[0],
            PackageFileName: fileList[0].name.toString(),
            PackageFilePath: this.data.ProductName + "\\" + this.ProductReleaseNo + "\\SupportFile\\" + fileList[0].name.toString(),
            PackageFileSize: Number(size)
        };
        this.ProductReleaseSupport.push(PackageModel);
        this.productReleaseService.PackageUploadFiles(formData)
            .subscribe(function (event) {
            if (event.type === __WEBPACK_IMPORTED_MODULE_7__angular_common_http__["e" /* HttpEventType */].UploadProgress) {
                _this.packageuploadresponse = '';
                _this.packagepercentDone = Math.round((100 * event.loaded) / event.total);
                if (_this.packagepercentDone == 100) {
                    _this.packageuploadSuccess = true;
                    _this.packageuploadresponse = "File is uploading on azure...!";
                }
            }
            else if (event instanceof __WEBPACK_IMPORTED_MODULE_7__angular_common_http__["f" /* HttpResponse */]) {
                if (event.body.DataObject != null) {
                    _this.packagepercentDone = 0;
                    _this.packageuploadSuccess = true;
                    _this.packageuploadresponse = "Successfully Upload";
                    _this.SaveProductDetail();
                }
                else {
                    _this.packageuploadSuccess = false;
                    _this.CancelButtonDisabled = false;
                    _this.packageuploadresponse = event.body.Error;
                    _this.appLoaderService.close();
                }
            }
        }, function (_error) {
            _this.packageuploadSuccess = false;
            _this.packageuploadresponse = "Package file upload failure.Please contact administrator...!";
            _this.CancelButtonDisabled = false;
            _this.appLoaderService.close();
        });
    };
    //#region "Save & Update Package Release"
    PageLayoutProductReleaseComponent.prototype.SaveProductDetail = function () {
        var _this = this;
        if (this.ProductReleaseId == 0 || this.ProductReleaseId == undefined) {
            var model_1 = {
                ProductReleaseId: 0,
                ProductId: Number(this.data.ProductId),
                ProductReleaseNo: this.ProductReleaseNo,
                ReleaseDate: this.validationForm.value.ReleaseDate,
                FilePath: this.filepath,
                CreatedBy: Number(localStorage.getItem('userid')),
                UpdatedBy: Number(localStorage.getItem('userid')),
                FileName: this.filename,
                FileSize: this.filesize,
                HashKey: String(this.filehash),
                ChangeLog: this.validationForm.value.ChangeLogs,
                DBVersion: this.IsProductCodeVisble ? String(this.validationForm.value.DBVersion) : "",
                ProductReleaseSupport: this.ProductReleaseSupport,
            };
            this.productReleaseService.addProductReleaseMenually(model_1).subscribe(function (data) {
                if (data.IsError) { // If Any Error
                    _this.errorMessage = "Product Release is not added. Please contact Administrator..!";
                    _this.appLoaderService.close();
                    _this.CancelButtonDisabled = false;
                    return;
                }
                // Save Release
                _this.validationForm.patchValue({
                    ProductReleaseNo: '',
                    Title: ''
                });
                _this.snackBar.open("Product has been Saved Successfully", "", {
                    duration: 2000,
                });
                _this.appLoaderService.close();
                _this.dialogRef.close(model_1);
            }, function (_error) {
                _this.appLoaderService.close();
                _this.CancelButtonDisabled = false;
            });
        }
        else {
            var model = {
                ProductReleaseId: this.ProductReleaseId,
                ProductId: Number(this.data.ProductId),
                ProductReleaseNo: this.ProductReleaseNo,
                ReleaseDate: this.validationForm.value.ReleaseDate,
                FilePath: this.filepath,
                UpdatedBy: Number(localStorage.getItem('userid')),
                FileName: this.filename,
                FileSize: this.filesize,
                HashKey: String(this.filehash),
                ChangeLog: this.validationForm.value.ChangeLogs,
                DBVersion: this.IsProductCodeVisble ? String(this.validationForm.value.DBVersion) : "",
                ProductReleaseSupport: this.ProductReleaseSupport,
            };
            this.productReleaseService.updateProductReleaseDetail(model).subscribe(function (data) {
                if (data.IsError) { // If Any Error
                    _this.errorMessage = "Product Release is not updated. Please contact Administrator..!";
                    _this.appLoaderService.close();
                    _this.CancelButtonDisabled = false;
                    return;
                }
                // Update Release
                _this.validationForm.patchValue({
                    ProductReleaseNo: '',
                    Title: ''
                });
                _this.dialogRef.close(null);
                _this.appLoaderService.close();
                _this.snackBar.open("Product has been Updated Successfully", "", {
                    duration: 2000,
                });
            }, function (_error) {
                _this.appLoaderService.close();
                _this.CancelButtonDisabled = false;
            });
        }
    };
    //#endregion
    //#region "Replace Package File Event"
    PageLayoutProductReleaseComponent.prototype.UpdatePackageFile = function () {
        document.getElementById("packagefiles").click();
    };
    //#endregion
    //#region "Package File Change Event [Current Use in SCAL 360 Product]"    
    PageLayoutProductReleaseComponent.prototype.onPackageChange = function (event) {
        this.packagedata = event;
        this.packageuploadresponse = "";
        if (this.packagedata.target.files.length > 0) {
            var PackageFileList = this.packagedata.target.files;
            var file = PackageFileList[0];
            if (this.data.ProductCode == __WEBPACK_IMPORTED_MODULE_12__interfaces_ProductRevFileNotReadFromFile_model__["a" /* ProductRevFileNotReadFromFile */].SCAL360) {
                if (file.type != 'application/x-zip-compressed') {
                    this.packageuploadSuccess = false;
                    this.packageuploadresponse = "Please Select ZIP file";
                    this.SaveButtonDisabled = true;
                    return false;
                }
            }
            var sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
            if (Number(sizeInMB) > 1000) {
                this.packageuploadSuccess = false;
                this.packageuploadresponse = "Package File Size should not be greater than 1 GB";
                this.IsPackageSize = true;
                this.SaveButtonDisabled = true;
                return false;
            }
            else {
                this.IsPackageSize = false;
                if (this.IsFileSize) {
                    this.SaveButtonDisabled = true;
                }
                else
                    this.SaveButtonDisabled = false;
            }
        }
        else
            this.SaveButtonDisabled = false;
    };
    //#endregion
    //#region "Get Package File Hash"
    PageLayoutProductReleaseComponent.prototype.getPackageHash = function (filename) {
        var _this = this;
        var hashdata = __WEBPACK_IMPORTED_MODULE_6_crypto_js__["algo"].SHA256.create();
        var file = filename;
        if (file) {
            var reader_3 = new FileReader();
            var size_2 = file.size;
            var chunk_size_2 = Math.pow(2, 22);
            var offset_2 = 0;
            var bytes_2 = 0;
            reader_3.onloadend = function (_e) {
                if (reader_3.readyState == FileReader.DONE) {
                    _this.packageuploadSuccess = true;
                    if (!_this.EditHash) {
                        _this.packageuploadresponse = "Computing File Hash...!";
                    }
                    hashdata.update(_this.arrayBufferToWordArray(reader_3.result));
                    var chunk = reader_3.result;
                    bytes_2 += chunk.length;
                    if ((offset_2 < size_2)) {
                        offset_2 += chunk_size_2;
                        var blobchunk = file.slice(offset_2, offset_2 + chunk_size_2);
                        reader_3.readAsArrayBuffer(blobchunk);
                    }
                    else {
                        var hash = hashdata.finalize().toString();
                        _this.ComparePackageHashandUpload(hash);
                    }
                }
            };
            var blob = file.slice(offset_2, offset_2 + chunk_size_2);
            reader_3.readAsArrayBuffer(blob);
        }
    };
    //#endregion
    //#region "getPackageHashandUploadPackageFile"
    PageLayoutProductReleaseComponent.prototype.ComparePackageHashandUpload = function (hash) {
        if (this.ProductReleaseId != 0 && this.ProductReleaseSupportEditData[0] != undefined) {
            if (hash == this.ProductReleaseSupportEditData[0].PackageFileHashKey) {
                this.packageuploadSuccess = false;
                this.appLoaderService.close();
                this.packageuploadresponse = "Same Package File is not uploaded again...!";
                this.SaveButtonDisabled = true;
                this.CancelButtonDisabled = false;
                return;
            }
            if (this.EditHash) {
                this.packagefilehash.push(hash);
                this.uploadfiles(this.eventdata.target.files[0]);
            }
            else {
                this.packagefilehash.push(hash);
                this.packageFileUpload();
            }
        }
        else {
            this.packagefilehash.push(hash);
            this.packageFileUpload();
        }
    };
    PageLayoutProductReleaseComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-page-layout-add-edit-productrelease',
            styles: ['./addProductrelease.component.css'],
            template: __webpack_require__(1069)
        }),
        __param(8, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_4__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_2__services_ProductReleaseService__["a" /* ProductReleaseService */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_9__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_10__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["e" /* MdDialogRef */], Object])
    ], PageLayoutProductReleaseComponent);
    return PageLayoutProductReleaseComponent;
}());



/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutConfirmDialogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Rx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Rx__);



var PageLayoutConfirmDialogComponent = /** @class */ (function () {
    function PageLayoutConfirmDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.ProductReleaseNo = this.data.ProductReleaseNo;
        if (this.data.Status == "Active")
            this.TitleDescription = "Once Release #" + this.ProductReleaseNo + " is approved then you can active the Release.";
        else if (this.data.Status == "Edit")
            this.TitleDescription = "Once Release #" + this.ProductReleaseNo + " is approved then you can't edit the Release.";
        else if (this.data.Status == "Add")
            this.TitleDescription = "You can't add new release because there is already one pending release in queue";
        else if (this.data.Status == "DBVersionMSG")
            this.TitleDescription = "You can't active this release because DBVersion value always greater than or equal to stable release";
    }
    PageLayoutConfirmDialogComponent.prototype.onCancel = function () {
        this.dialogRef.close(true);
    };
    PageLayoutConfirmDialogComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-page-layout-confirm-dialog',
            styles: [],
            template: __webpack_require__(1072)
        }),
        __param(1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */], Object])
    ], PageLayoutConfirmDialogComponent);
    return PageLayoutConfirmDialogComponent;
}());



/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutRevisionComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ProductReleaseService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__ = __webpack_require__(6);





var PageLayoutRevisionComponent = /** @class */ (function () {
    function PageLayoutRevisionComponent(route, router, adalService, productRelaseService, dialogRef, data) {
        this.route = route;
        this.router = router;
        this.adalService = adalService;
        this.productRelaseService = productRelaseService;
        this.dialogRef = dialogRef;
        this.data = data;
        document.body.style.overflow = "hidden";
        //Check Authentication        
        if (!this.adalService.getCachedToken()) {
            document.body.style.overflow = "auto";
            this.dialogRef.close();
            this.router.navigate(['login']);
        }
        if (this.data.SubProductName != '')
            this.Title = this.data.ProductName + " [" + this.data.SubProductName + "]" + "Change Logs Of Product Release No " + this.data.ProductReleaseNo + "";
        else
            this.Title = this.data.ProductName + " Change Logs Of Product Release No " + this.data.ProductReleaseNo + "";
        this.getReleaseDetailById(this.data.productReleaseId);
    }
    PageLayoutRevisionComponent.prototype.getReleaseDetailById = function (ProductReleaseId) {
        var _this = this;
        this.productRelaseService.getChangeLogDetails(ProductReleaseId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.ChangeLogData = data.DataObject;
            }
            else {
                _this.ChangeLogData = null;
            }
        }, function (error) {
            _this.errorMessage = error;
        });
    };
    PageLayoutRevisionComponent.prototype.onCancel = function () {
        document.body.style.overflow = "auto";
        this.dialogRef.close(true);
    };
    PageLayoutRevisionComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'dialog-result-example-dialog',
            template: __webpack_require__(1077),
            styles: [__webpack_require__(1008)],
        }),
        __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_3__services_ProductReleaseService__["a" /* ProductReleaseService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */], Object])
    ], PageLayoutRevisionComponent);
    return PageLayoutRevisionComponent;
}());



/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutRevisionHistoryComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ProductReleaseService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);






var PageLayoutRevisionHistoryComponent = /** @class */ (function () {
    function PageLayoutRevisionHistoryComponent(route, router, snackBar, adalService, productReleaseService, dialogRef, data) {
        this.route = route;
        this.router = router;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.productReleaseService = productReleaseService;
        this.dialogRef = dialogRef;
        this.data = data;
        document.body.style.overflow = "hidden";
        //Check Authentication
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close();
            document.body.style.overflow = "auto";
            this.router.navigate(["login"]);
        }
        if (this.data.SubProductName != "")
            this.Title =
                "Release History Of " +
                    this.data.ProductName +
                    " [" +
                    this.data.SubProductName +
                    "] " +
                    " Release No " +
                    this.data.ProductReleaseNo;
        else
            this.Title =
                "Release History Of " +
                    this.data.ProductName +
                    " Release No " +
                    this.data.ProductReleaseNo;
        this.getProductReleaseHistory(this.data.ProductReleaseId);
    }
    PageLayoutRevisionHistoryComponent.prototype.UTCToLocalTimeZone = function (date) {
        var stillUtc = __WEBPACK_IMPORTED_MODULE_5_moment__["utc"](date).toDate();
        var theDate = __WEBPACK_IMPORTED_MODULE_5_moment__(stillUtc).local();
        return theDate.toLocaleString();
    };
    PageLayoutRevisionHistoryComponent.prototype.getProductReleaseHistory = function (ProductReleaseId) {
        var _this = this;
        this.productReleaseService.ViewHistory(ProductReleaseId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.historyData = data.DataObject;
                _this.historyData.forEach(function (element) {
                    if (element.Role == 1) {
                        element.Role = "Developer";
                    }
                    else if (element.Role == 2) {
                        element.Role = "QA";
                    }
                    else {
                        element.Role = "Product Management";
                    }
                });
            }
            else {
                _this.snackBar.open(data.Error, "", {
                    duration: 2000,
                });
            }
        }, function (error) {
            _this.errorMessage = error;
        });
    };
    PageLayoutRevisionHistoryComponent.prototype.onCancel = function () {
        this.dialogRef.close(true);
        document.body.style.overflow = "auto";
    };
    PageLayoutRevisionHistoryComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: "dialog-result-example-dialog",
            template: __webpack_require__(1078),
            styles: [__webpack_require__(1009)],
        }),
        __param(6, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_3__services_ProductReleaseService__["a" /* ProductReleaseService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */], Object])
    ], PageLayoutRevisionHistoryComponent);
    return PageLayoutRevisionHistoryComponent;
}());



/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutAllChangeLog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ProductReleaseService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__ = __webpack_require__(7);






var PageLayoutAllChangeLog = /** @class */ (function () {
    function PageLayoutAllChangeLog(router, adalService, appLoaderService, productRelaseService, dialogRef, data) {
        this.router = router;
        this.adalService = adalService;
        this.appLoaderService = appLoaderService;
        this.productRelaseService = productRelaseService;
        this.dialogRef = dialogRef;
        this.data = data;
        document.body.style.overflow = "hidden";
        //Check Authentication        
        if (!this.adalService.getCachedToken()) {
            document.body.style.overflow = "auto";
            this.dialogRef.close();
            this.router.navigate(['login']);
        }
        this.ProductId = this.data.ProductId;
        if (this.data.SubProductName != '')
            this.Title = "All Release Change Logs of " + this.data.ProductName + " [" + this.data.SubProductName + "]";
        else
            this.Title = "All Release Change Logs of " + this.data.ProductName;
        this.getReleaseDetailById(this.data.ProductId);
    }
    PageLayoutAllChangeLog.prototype.getReleaseDetailById = function (ProductId) {
        var _this = this;
        this.appLoaderService.open();
        this.productRelaseService.getProductAllChangeLogDetails(ProductId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.appLoaderService.close();
                _this.changeLogData = data.DataObject;
            }
            else {
                _this.changeLogData = null;
            }
        }, function (_error) {
            _this.appLoaderService.close();
        });
    };
    PageLayoutAllChangeLog.prototype.onCancel = function () {
        document.body.style.overflow = "auto";
        this.dialogRef.close(true);
    };
    PageLayoutAllChangeLog = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'dialog-result-example-dialog',
            template: __webpack_require__(1079),
        }),
        __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_3__services_ProductReleaseService__["a" /* ProductReleaseService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */], Object])
    ], PageLayoutAllChangeLog);
    return PageLayoutAllChangeLog;
}());



/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddNewAdvertisementDialogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);





var AddNewAdvertisementDialogComponent = /** @class */ (function () {
    function AddNewAdvertisementDialogComponent(dialogRef, data, formBuilder, licenseService, appLoaderService, snackBar) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.formBuilder = formBuilder;
        this.licenseService = licenseService;
        this.appLoaderService = appLoaderService;
        this.snackBar = snackBar;
        this.errorMessage = "";
        this.uploadResponse = "";
        this.validImage = false;
        this.submitted = false;
        this.imageBase64 = '';
        this.imageURL = '';
        this.advertisementId = null;
        this.dialogTitle = '';
        this.advertisementList = [];
        this.buildForm();
        this.selectedAdvDetail = this.data.SelectedAdvData;
        this.advertisementList = data.Advlist;
        if (this.selectedAdvDetail) {
            this.dialogTitle = 'Edit Advertisement';
            this.advertisementId = this.selectedAdvDetail.LZ30AdervertisementId;
            this.imageBase64 = this.selectedAdvDetail.ProductImage;
            this.advertisementForm.patchValue({
                ProductTitle: this.selectedAdvDetail.ProductTitle,
                ProductDescription: this.selectedAdvDetail.ProductDescription,
                ProductLink: this.selectedAdvDetail.ProductLink,
                ProductImage: this.imageBase64
            });
            this.imageURL = "data:image/jpg;base64," + this.imageBase64;
        }
        else {
            this.dialogTitle = 'Add advertisement';
        }
    }
    AddNewAdvertisementDialogComponent.prototype.buildForm = function () {
        this.advertisementForm = this.formBuilder.group({
            ProductTitle: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].maxLength(30)]],
            ProductDescription: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].maxLength(200)]],
            ProductLink: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]],
            ProductImage: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]]
        });
    };
    AddNewAdvertisementDialogComponent.prototype.onChange = function (event) {
        var _this = this;
        var imageFileList = event.target.files;
        this.uploadResponse = '';
        if (imageFileList.length > 0) {
            var imageFile = imageFileList[0];
            var extension_1 = imageFile.type.toLowerCase();
            if (!(extension_1 == "image/jpg" || extension_1 == "image/jpeg" || extension_1 == "image/png")) {
                this.imageBase64 = '';
                this.imageURL = '';
                this.uploadResponse = "The product image file can be in JPG/JPEG/PNG format only.";
                this.advertisementForm.controls['ProductImage'].setValue(this.imageBase64);
                this.advertisementForm.markAsDirty();
            }
            else {
                if (imageFile.size >= 1048576) {
                    this.imageBase64 = '';
                    this.imageURL = '';
                    this.uploadResponse = "The product image file cannot be greater than 1MB.";
                    this.advertisementForm.controls['ProductImage'].setValue(this.imageBase64);
                    this.advertisementForm.markAsDirty();
                }
                else {
                    var reader_1 = new FileReader();
                    reader_1.addEventListener("load", function () {
                        if (typeof (reader_1.result) === 'string') {
                            _this.imageBase64 = reader_1.result.split(',')[1];
                            _this.imageURL = "data:" + extension_1 + ";base64," + _this.imageBase64;
                            _this.advertisementForm.controls['ProductImage'].setValue(_this.imageBase64);
                            _this.advertisementForm.markAsDirty();
                        }
                    });
                    reader_1.readAsDataURL(imageFile);
                }
            }
        }
        else {
            this.imageBase64 = '';
            this.advertisementForm.controls['ProductImage'].setValue(this.imageBase64);
            this.advertisementForm.markAsDirty();
            this.imageURL = '';
            this.uploadResponse = "Product image file is required.";
        }
    };
    AddNewAdvertisementDialogComponent.prototype.onSubmit = function () {
        var _this = this;
        this.appLoaderService.open();
        if (this.selectedAdvDetail) {
            var model = {
                LZ30AdvertisementId: this.selectedAdvDetail.LZ30AdvertisementId,
                ProductTitle: this.advertisementForm.value.ProductTitle,
                ProductDescription: this.advertisementForm.value.ProductDescription,
                ProductLink: this.advertisementForm.value.ProductLink,
                ProductImage: this.imageBase64,
                IsActive: false,
                CreatedBy: Number(localStorage.getItem('userid')),
                UpdatedBy: Number(localStorage.getItem('userid'))
            };
            this.licenseService.updateAdvertisement(model).subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    _this.advertisementList = data.DataObject;
                    _this.snackBar.open("Advertisement updated successfully!", "", {
                        duration: 2000
                    });
                }
                else {
                    _this.errorMessage = "Advertisement is not updated. Please contact administrator.";
                }
                _this.appLoaderService.close();
                _this.dialogRef.close(_this.advertisementList);
            });
        }
        else {
            var model = {
                ProductTitle: this.advertisementForm.value.ProductTitle,
                ProductDescription: this.advertisementForm.value.ProductDescription,
                ProductLink: this.advertisementForm.value.ProductLink,
                ProductImage: this.imageBase64,
                IsActive: false,
                CreatedBy: Number(localStorage.getItem('userid')),
                UpdatedBy: Number(localStorage.getItem('userid'))
            };
            this.licenseService.addAdvertisement(model).subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    _this.advertisementList = data.DataObject;
                    _this.snackBar.open("Advertisement added successfully!", "", {
                        duration: 2000
                    });
                }
                else {
                    _this.errorMessage = "Advertisement is not added. Please contact administrator.";
                }
                _this.appLoaderService.close();
                _this.dialogRef.close(_this.advertisementList);
            });
        }
    };
    AddNewAdvertisementDialogComponent.prototype.chooseFile = function () {
        document.getElementById('productImageInput').click();
    };
    AddNewAdvertisementDialogComponent.prototype.onDialogCancel = function () {
        this.dialogRef.close(this.advertisementList);
    };
    AddNewAdvertisementDialogComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            styles: [__webpack_require__(957)],
            template: __webpack_require__(1012)
        }),
        __param(1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */], Object, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["c" /* MdSnackBar */]])
    ], AddNewAdvertisementDialogComponent);
    return AddNewAdvertisementDialogComponent;
}());



/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdvertisementComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__add_new_advertisement_add_new_advertisement_component__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__ = __webpack_require__(7);






var AdvertisementComponent = /** @class */ (function () {
    function AdvertisementComponent(dialog, licenseService, snackBar, appLoader) {
        this.dialog = dialog;
        this.licenseService = licenseService;
        this.snackBar = snackBar;
        this.appLoader = appLoader;
        this.advertisementList = [];
        this.errorMessage = '';
        this.getAllAdvertisement();
    }
    AdvertisementComponent.prototype.addNewAdvertisement = function () {
        var _this = this;
        var addNewAdvertisementDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__add_new_advertisement_add_new_advertisement_component__["a" /* AddNewAdvertisementDialogComponent */], {
            data: {
                SelectedAdvData: null,
                Advlist: this.advertisementList
            },
            disableClose: true,
            height: '70%',
            width: '50%'
        });
        addNewAdvertisementDialog.afterClosed().subscribe(function (result) {
            _this.advertisementList = result;
        });
    };
    AdvertisementComponent.prototype.getAllAdvertisement = function () {
        var _this = this;
        this.appLoader.open();
        this.licenseService.getAllAdvertisement().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.advertisementList = data.DataObject;
                _this.appLoader.close();
            }
            else {
                _this.appLoader.close();
            }
        });
    };
    AdvertisementComponent.prototype.editAdvertisement = function (advData) {
        var _this = this;
        var editAdvertisementDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__add_new_advertisement_add_new_advertisement_component__["a" /* AddNewAdvertisementDialogComponent */], {
            data: {
                SelectedAdvData: advData,
                Advlist: this.advertisementList
            },
            height: '70%',
            width: '50%',
            disableClose: true
        });
        editAdvertisementDialogRef.afterClosed().subscribe(function (result) {
            _this.advertisementList = result;
        });
    };
    AdvertisementComponent.prototype.deleteAdvertisement = function (row) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
            title: 'Delete Advertisement',
            text: 'Are you sure you want to delete advertisement?',
            showCancelButton: true,
            showCloseButton: true,
            showConfirmButton: true,
            confirmButtonColor: '#FFCA28',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(function (result) {
            if (result.isConfirmed) {
                var model = {
                    LZ30AdvertisementId: row.LZ30AdvertisementId,
                    UpdatedBy: Number(localStorage.getItem('userid'))
                };
                _this.appLoader.open();
                _this.licenseService.deleteAdvertisement(model).subscribe(function (response) {
                    if (!response.IsError && response.DataObject != null) {
                        _this.advertisementList = response.DataObject;
                        _this.appLoader.close();
                        _this.snackBar.open("Advertisement deleted successfully.", "", {
                            duration: 2000
                        });
                    }
                    else {
                        _this.appLoader.close();
                        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                            title: "Error",
                            text: response.Error
                        });
                    }
                });
            }
        });
    };
    AdvertisementComponent.prototype.activeAdvertisement = function (row) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
            title: 'Active Advertisement',
            text: 'Are you sure you want to active the advertisement?',
            showCancelButton: true,
            showCloseButton: true,
            showConfirmButton: true,
            confirmButtonColor: '#FFCA28',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(function (result) {
            if (result.isConfirmed) {
                var model = {
                    LZ30AdvertisementId: row.LZ30AdvertisementId,
                    IsActive: true,
                    UpdatedBy: Number(localStorage.getItem('userid')),
                };
                _this.appLoader.open();
                _this.licenseService.updateActiveInactiveAdvertisement(model).subscribe(function (response) {
                    if (!response.IsError && response.DataObject != null) {
                        _this.advertisementList = response.DataObject;
                        _this.appLoader.close();
                        _this.snackBar.open("Advertisement activated successfully.", "", {
                            duration: 2000
                        });
                    }
                    else {
                        _this.appLoader.close();
                        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                            title: "Error",
                            text: response.Error,
                            showConfirmButton: true,
                            confirmButtonColor: ' #FFCA28',
                            returnFocus: true
                        });
                    }
                });
            }
        });
    };
    AdvertisementComponent.prototype.deactiveAdvertisement = function (row) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
            title: 'Deactive Advertisement',
            text: 'Are you sure you want to deactive the advertisement?',
            showCancelButton: true,
            showCloseButton: true,
            showConfirmButton: true,
            confirmButtonColor: '#FFCA28',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(function (result) {
            if (result.isConfirmed) {
                var model = {
                    LZ30AdvertisementId: row.LZ30AdvertisementId,
                    IsActive: false,
                    UpdatedBy: Number(localStorage.getItem('userid')),
                };
                _this.appLoader.open();
                _this.licenseService.updateActiveInactiveAdvertisement(model).subscribe(function (response) {
                    if (!response.IsError && response.DataObject != null) {
                        _this.advertisementList = response.DataObject;
                        _this.appLoader.close();
                        _this.snackBar.open("Advertisement deactivated successfully.", "", {
                            duration: 2000
                        });
                    }
                    else {
                        _this.appLoader.close();
                        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                            title: "Error",
                            text: response.Error
                        });
                    }
                });
            }
        });
    };
    AdvertisementComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'advertisement',
            template: __webpack_require__(1013),
            styles: [__webpack_require__(958)],
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_4__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__["a" /* AppLoaderService */]])
    ], AdvertisementComponent);
    return AdvertisementComponent;
}());



/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppMainComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var AppMainComponent = /** @class */ (function () {
    function AppMainComponent() {
    }
    AppMainComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-app-main',
            template: __webpack_require__(1024),
        })
    ], AppMainComponent);
    return AppMainComponent;
}());



/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddEditFaqComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__(4);







var AddEditFaqComponent = /** @class */ (function () {
    function AddEditFaqComponent(formBuilder, dialogRef, licenseService, appLoader, adalService, router, dialogData) {
        this.formBuilder = formBuilder;
        this.dialogRef = dialogRef;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'Add FAQ';
        this.errorMessage = '';
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
    }
    AddEditFaqComponent.prototype.ngOnInit = function () {
        this.buildForm();
        this.FaqList = this.dialogData.FaqDisplayDetail;
        this.selectedFAQDetail = this.dialogData.SelectedFAQDetail;
        if (this.selectedFAQDetail != null) {
            this.dialogTitle = 'Edit FAQ';
            this.FAQForm.patchValue({
                Question: this.selectedFAQDetail.Question,
                Answer: this.selectedFAQDetail.Answer
            });
        }
    };
    AddEditFaqComponent.prototype.buildForm = function () {
        this.FAQForm = this.formBuilder.group({
            Question: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]],
            Answer: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]]
        });
    };
    AddEditFaqComponent.prototype.onSave = function () {
        var _this = this;
        this.appLoader.open();
        var model;
        if (this.selectedFAQDetail != null) { //Edit
            model = {
                FAQId: this.selectedFAQDetail.FAQId,
                ProductId: 19,
                OrderId: 1,
                CreatedBy: Number(localStorage.getItem('userid')),
                UpdatedBy: Number(localStorage.getItem('userid')),
                Question: this.FAQForm.value.Question,
                Answer: this.FAQForm.value.Answer
            };
        }
        else { //Add
            model = {
                ProductId: 19,
                OrderId: 1,
                CreatedBy: Number(localStorage.getItem('userid')),
                UpdatedBy: Number(localStorage.getItem('userid')),
                Question: this.FAQForm.value.Question,
                Answer: this.FAQForm.value.Answer
            };
        }
        this.licenseService.addFAQ(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.FaqList = data.DataObject;
            }
            _this.appLoader.close();
            _this.dialogRef.close(_this.FaqList);
        });
    };
    AddEditFaqComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.FaqList);
    };
    AddEditFaqComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'add-edit-faq',
            template: __webpack_require__(1029),
            styles: [__webpack_require__(967)]
        }),
        __param(6, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_6__angular_router__["a" /* Router */], Object])
    ], AddEditFaqComponent);
    return AddEditFaqComponent;
}());



/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImportFaqComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__(4);







var ImportFaqComponent = /** @class */ (function () {
    function ImportFaqComponent(dialogRef, licenseService, appLoader, adalService, router, dialogData) {
        this.dialogRef = dialogRef;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'Import FAQ';
        this.uploadResponse = '';
        this.errorMessage = '';
        this.importedFaqData = [];
        this.saveButtonDisabled = true;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.FaqDisplayDetail = dialogData.FaqDisplayDetail;
    }
    ImportFaqComponent.prototype.onChange = function (event) {
        var _this = this;
        this.importedFaqData = [];
        var faqFileList = event.target.files;
        if (faqFileList.length > 0) {
            var faqFile = faqFileList[0];
            var extension = faqFile.type.toLowerCase();
            if (!(extension == "text/csv")) {
                __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
                    title: 'Error',
                    text: "The faq file can be in text/csv format only."
                });
                this.saveButtonDisabled = true;
            }
            else {
                if (faqFile.size >= 1048576) {
                    __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
                        title: 'Error',
                        text: "The file cannot be greater than 1MB."
                    });
                    this.saveButtonDisabled = true;
                }
                else {
                    var reader_1 = new FileReader();
                    reader_1.addEventListener("load", function () {
                        if (typeof (reader_1.result) === 'string') {
                            var csvData = reader_1.result;
                            _this.importedFaqData = _this.csvToJson(csvData.trim());
                        }
                    });
                    reader_1.readAsText(faqFile);
                }
            }
        }
        else {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
                title: 'Error',
                text: "FAQ file is required."
            });
            this.saveButtonDisabled = true;
        }
    };
    ImportFaqComponent.prototype.deleteFAQ = function (index) {
        this.importedFaqData.splice(index, 1);
        if (this.importedFaqData.length <= 0) {
            this.saveButtonDisabled = true;
        }
    };
    ImportFaqComponent.prototype.csvToJson = function (csvString) {
        var jsonObject = [];
        var lines = csvString.split(/\r?\n/);
        var headers = lines[0].split(',');
        if (headers[0].trim() != 'Question' || headers[1].trim() != 'Answer') {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
                title: 'Error',
                text: 'Invalid CSV file.'
            });
            this.saveButtonDisabled = true;
            return [];
        }
        this.saveButtonDisabled = false;
        var _loop_1 = function (i) {
            var data = lines[i].split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/); //splits based on only those commas that have the specified pattern after them.
            var object = {
                Question: "",
                Answer: "",
                OrderId: 1,
                FAQId: 0,
                ProductId: 19,
                UpdatedBy: Number(localStorage.getItem('userid')),
                CreatedBy: Number(localStorage.getItem('userid')),
            };
            for (var j = 0; j < data.length; j++) {
                object[headers[j]] = data[j].replace(/["]+/g, ''); //replaces one or more occurences of \" in th string with an empty character
                this_1.FaqDisplayDetail.forEach(function (element) {
                    if (element.Question == object['Question'] && element.Answer == object['Answer']) {
                        object['FAQId'] = element.FAQId;
                        object['OrderId'] = element.OrderId;
                    }
                });
            }
            if (object['Question'] != "" && object['Answer'] != "") {
                jsonObject.push(object);
            }
        };
        var this_1 = this;
        for (var i = 1; i < lines.length; i++) {
            _loop_1(i);
        }
        return jsonObject;
    };
    ImportFaqComponent.prototype.importFaq = function () {
        document.getElementById('inputFaqFile').click();
    };
    ImportFaqComponent.prototype.onSave = function () {
        var _this = this;
        this.appLoader.open();
        this.licenseService.importFAQ(this.importedFaqData).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.FaqDisplayDetail = data.DataObject;
                _this.dialogRef.close(_this.FaqDisplayDetail);
            }
            _this.appLoader.close();
        });
    };
    ImportFaqComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.FaqDisplayDetail);
    };
    ImportFaqComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'import-faq',
            template: __webpack_require__(1031),
            styles: [__webpack_require__(969)]
        }),
        __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_6__angular_router__["a" /* Router */], Object])
    ], ImportFaqComponent);
    return ImportFaqComponent;
}());



/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenerateGltLicenseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_router__ = __webpack_require__(4);








var GenerateGltLicenseComponent = /** @class */ (function () {
    function GenerateGltLicenseComponent(dialogRef, formBuilder, licenseService, appLoader, adalService, router, dialogData) {
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = "Add/Edit License";
        this.errorMessage = "";
        this.isSaveButtonDisabled = true;
        this.submitted = false;
        this.activatedYearsArray = [0, 0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        this.licenseKey = '';
        this.error = '';
        this.isGenerateKeyButtonClicked = false;
        this.isBillingShippingDetailFetched = false;
        this.gltLicenseDisplayData = [];
        this.shouldFetchSalesOrderNo = true;
        this.isLicensekeyGenerated = false;
        this.prevSalesOrderNo = '';
        this.billingShippingDetail = {
            ODataEtag: '',
            Number: '',
            publicId: '',
            CustomerNo: '',
            publicSalesPersoncode: '',
            BillToName: '',
            BillToAddress1: '',
            BillToAddress2: '',
            BillToCity: '',
            BillToState: '',
            BillToZipcode: '',
            BillToCountryCode: '',
            ShipToCode: '',
            ShipToName: '',
            ShipToAddress1: '',
            ShipToAddress2: '',
            ShipToCity: '',
            ShipToState: '',
            ShipToZipcode: '',
            ShipToCountryCode: '',
            CustomerTelephone: '',
            CustomerEmailAddress: '',
            CustomerFaxno: '',
            ShippingTelephoneno: '',
            ShippingFaxno: '',
            ShippingEmailAddress: '',
            Rep1: '',
            Rep2: '',
            Sales1: '',
            Sales2: ''
        };
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.buildForm();
        this.gltLicenseDisplayData = this.dialogData.gltLicenseData;
        this.SelectedLicenseDetail = this.dialogData.SelectedLicenseDetail;
        if (this.SelectedLicenseDetail) {
            console.log(this.SelectedLicenseDetail);
            this.gltGenerateKeyForm.patchValue({
                'UniqueHardwareId': this.SelectedLicenseDetail.CustomerUniqueKey,
                'TabletSerial': this.SelectedLicenseDetail.TabletSerialNo,
                'NoOfYearsActivated': this.SelectedLicenseDetail.WarrantyYears,
                'SalesOrderNo': this.SelectedLicenseDetail.SalesOrderNo
            });
            this.licenseKey = this.SelectedLicenseDetail.LicenseKey;
            this.isBillingShippingDetailFetched = true;
            this.isLicensekeyGenerated = true;
            this.prevSalesOrderNo = this.SelectedLicenseDetail.SalesOrderNo;
            this.billingShippingDetail.BillToName = this.SelectedLicenseDetail.BillToName;
            this.billingShippingDetail.BillToAddress1 = this.SelectedLicenseDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2 = this.SelectedLicenseDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity = this.SelectedLicenseDetail.BillToCity;
            this.billingShippingDetail.ShipToName = this.SelectedLicenseDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1 = this.SelectedLicenseDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2 = this.SelectedLicenseDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity = this.SelectedLicenseDetail.ShipToCity;
            this.billingShippingDetail.ShipToState = this.SelectedLicenseDetail.ShipToState;
        }
    }
    GenerateGltLicenseComponent.prototype.buildForm = function () {
        this.gltGenerateKeyForm = this.formBuilder.group({
            'UniqueHardwareId': ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            'TabletSerial': ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            'NoOfYearsActivated': [],
            'SalesOrderNo': ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]
        });
    };
    GenerateGltLicenseComponent.prototype.fetchBillingShippingDetails = function () {
        var _this = this;
        this.appLoader.open();
        this.licenseService.getBillingShippingDetail(this.gltGenerateKeyForm.value.SalesOrderNo).subscribe(function (data) {
            console.log(data);
            if (!data.IsError && data.DataObject != null) {
                _this.billingShippingDetail = data.DataObject;
                _this.isBillingShippingDetailFetched = true;
                _this.errorMessage = '';
                _this.appLoader.close();
            }
            else {
                _this.errorMessage = data.Error;
                _this.appLoader.close();
            }
        });
    };
    GenerateGltLicenseComponent.prototype.generateGltLicenseKey = function () {
        var _this = this;
        var model = {
            TabletSerial: this.gltGenerateKeyForm.value.TabletSerial,
            DeviceUniqueId: this.gltGenerateKeyForm.value.UniqueHardwareId
        };
        this.appLoader.open();
        this.licenseService.generateGltLicenseKey(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.errorMessage = '';
                if (_this.SelectedLicenseDetail != null) {
                    _this.SelectedLicenseDetail.TabletSerialNo = _this.gltGenerateKeyForm.value.TabletSerial;
                    _this.SelectedLicenseDetail.CustomerUniqueKey = _this.gltGenerateKeyForm.value.UniqueHardwareId;
                }
                _this.licenseKey = data.DataObject;
                _this.isLicensekeyGenerated = true;
            }
            else {
                _this.errorMessage = 'Cannot generate license key';
            }
            _this.appLoader.close();
        });
    };
    GenerateGltLicenseComponent.prototype.fetchSalesOrderDetailAndGenerateKey = function () {
        var _this = this;
        this.isGenerateKeyButtonClicked = true;
        if (!this.gltGenerateKeyForm.valid) {
            return;
        }
        else {
            //fetch the sales order details
            if (!this.isBillingShippingDetailFetched && this.shouldFetchSalesOrderNo && !this.isLicensekeyGenerated) {
                var model = {
                    TabletSerial: this.gltGenerateKeyForm.value.TabletSerial,
                    DeviceUniqueId: this.gltGenerateKeyForm.value.UniqueHardwareId
                };
                this.appLoader.open();
                this.licenseService.generateGltLicenseKey(model).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.errorMessage = '';
                        if (_this.SelectedLicenseDetail != null) {
                            _this.SelectedLicenseDetail.TabletSerialNo = _this.gltGenerateKeyForm.value.TabletSerial;
                            _this.SelectedLicenseDetail.CustomerUniqueKey = _this.gltGenerateKeyForm.value.UniqueHardwareId;
                        }
                        _this.licenseKey = data.DataObject;
                        _this.isLicensekeyGenerated = true;
                        _this.licenseService.getBillingShippingDetail(_this.gltGenerateKeyForm.value.SalesOrderNo).subscribe(function (data) {
                            console.log(data);
                            if (!data.IsError && data.DataObject != null) {
                                _this.billingShippingDetail = data.DataObject;
                                _this.isBillingShippingDetailFetched = true;
                                _this.errorMessage = '';
                                _this.appLoader.close();
                            }
                            else {
                                _this.errorMessage = data.Error;
                                _this.appLoader.close();
                            }
                        });
                    }
                    else {
                        _this.errorMessage = 'Cannot generate license key';
                        _this.appLoader.close();
                    }
                });
            }
            else if (!this.isBillingShippingDetailFetched && this.shouldFetchSalesOrderNo) {
                this.fetchBillingShippingDetails();
            }
            else if (!this.isLicensekeyGenerated) {
                //call the generate license key api
                this.generateGltLicenseKey();
            }
        }
    };
    GenerateGltLicenseComponent.prototype.checkSalesOrderNo = function () {
        var _this = this;
        if (this.prevSalesOrderNo != null) {
            if (this.prevSalesOrderNo.trim().toUpperCase() == this.gltGenerateKeyForm.value.SalesOrderNo.trim().toUpperCase()) {
                return;
            }
        }
        this.prevSalesOrderNo = this.gltGenerateKeyForm.value.SalesOrderNo;
        if (this.gltLicenseDisplayData) {
            return this.gltLicenseDisplayData.forEach(function (element) {
                if (_this.gltGenerateKeyForm.value.SalesOrderNo != null) {
                    if (_this.gltGenerateKeyForm.value.SalesOrderNo.toUpperCase() == element.SalesOrderNo.toUpperCase()) {
                        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                            title: "This sales order no already exists",
                            text: "Are you sure you want to use this Sales Order No?",
                            showCancelButton: true,
                            showCloseButton: true,
                            showConfirmButton: true,
                            confirmButtonText: "Yes",
                            confirmButtonColor: "#FFCA28",
                            cancelButtonText: "No",
                        }).then(function (result) {
                            if (result.isConfirmed) {
                                _this.shouldFetchSalesOrderNo = true;
                                _this.isBillingShippingDetailFetched = false;
                                _this.fetchBillingShippingDetails();
                            }
                            else {
                                _this.shouldFetchSalesOrderNo = false;
                                _this.isBillingShippingDetailFetched = false;
                                _this.gltGenerateKeyForm.patchValue({
                                    SalesOrderNo: ""
                                });
                            }
                        });
                    }
                    else {
                        _this.shouldFetchSalesOrderNo = true;
                        _this.isBillingShippingDetailFetched = false;
                    }
                }
            });
        }
        else {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
        }
    };
    GenerateGltLicenseComponent.prototype.onSave = function () {
        var _this = this;
        this.submitted = true;
        this.appLoader.open();
        if (!this.isBillingShippingDetailFetched && !this.isLicensekeyGenerated) {
            __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                title: 'Billing Shipping Details not fetched and License Key not generated/updated',
                text: 'Please fetch billing shipping details and generate License Key by clicking on the "Generate Key" button.',
                confirmButtonColor: '#FFCA28',
                focusConfirm: false,
                allowEnterKey: false
            });
            this.appLoader.close();
            return;
        }
        else if (!this.isBillingShippingDetailFetched) {
            __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                title: 'Billing shipping details not fetched',
                text: 'Please fetch billing shipping details by clicking on the "Generate Key" button.',
                confirmButtonColor: '#FFCA28',
                focusConfirm: false,
                allowEnterKey: false
            });
            this.appLoader.close();
            return;
        }
        else if (!this.isLicensekeyGenerated) {
            __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                title: 'License key not generated or updated.',
                text: 'Changes made in the field Unique H/W Id or Tablet Serial Number requires the generation of license key.Please generate license key by clicking on the "Generate Key" button.',
                confirmButtonColor: '#FFCA28',
                focusConfirm: false,
                allowEnterKey: false
            });
            this.appLoader.close();
            return;
        }
        if (this.SelectedLicenseDetail != null) { //Edit License
            if (this.SelectedLicenseDetail.SalesOrderNo.toUpperCase() != this.gltGenerateKeyForm.value.SalesOrderNo.toUpperCase()) { //If SalesOrderNo has been changed then add the new sales order in the database
                this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        var model = {
                            LicenseId: _this.SelectedLicenseDetail.LicenseId,
                            LicenseKey: _this.licenseKey,
                            TabletSerialNo: _this.gltGenerateKeyForm.value.TabletSerial,
                            CustomerUniqueKey: _this.gltGenerateKeyForm.value.UniqueHardwareId,
                            CustomerId: data.DataObject.CustomerId,
                            SalesOrderNo: _this.gltGenerateKeyForm.value.SalesOrderNo,
                            ShippingAddressId: data.DataObject.ShippingAddressId,
                            WarrantyYears: _this.gltGenerateKeyForm.value.NoOfYearsActivated,
                            ApplicationIdentification: "A",
                            PartNo: '931-00000-01',
                            CreatedBy: Number(localStorage.getItem('userid')),
                            UpdatedBy: Number(localStorage.getItem('userid'))
                        };
                        _this.licenseService.updateGltLicense(model).subscribe(function (licenseData) {
                            if (!licenseData.IsError && licenseData.DataObject != null) {
                                _this.gltLicenseDisplayData = licenseData.DataObject;
                                _this.appLoader.close();
                                _this.dialogRef.close(_this.gltLicenseDisplayData);
                            }
                            else {
                                _this.error = licenseData.Error;
                                _this.appLoader.close();
                                _this.dialogRef.close(_this.gltLicenseDisplayData);
                            }
                        });
                    }
                });
            }
            else {
                var model = {
                    LicenseId: this.SelectedLicenseDetail.LicenseId,
                    LicenseKey: this.licenseKey,
                    TabletSerialNo: this.gltGenerateKeyForm.value.TabletSerial,
                    CustomerUniqueKey: this.gltGenerateKeyForm.value.UniqueHardwareId,
                    CustomerId: this.SelectedLicenseDetail.CustomerId,
                    SalesOrderNo: this.gltGenerateKeyForm.value.SalesOrderNo,
                    ShippingAddressId: this.SelectedLicenseDetail.ShippingAddressId,
                    WarrantyYears: this.gltGenerateKeyForm.value.NoOfYearsActivated,
                    ApplicationIdentification: "A",
                    PartNo: '931-00000-01',
                    CreatedBy: Number(localStorage.getItem('userid')),
                    UpdatedBy: Number(localStorage.getItem('userid'))
                };
                this.licenseService.updateGltLicense(model).subscribe(function (licenseData) {
                    if (!licenseData.IsError && licenseData.DataObject != null) {
                        _this.gltLicenseDisplayData = licenseData.DataObject;
                        _this.appLoader.close();
                        _this.dialogRef.close(_this.gltLicenseDisplayData);
                    }
                    else {
                        _this.error = licenseData.Error;
                        _this.appLoader.close();
                        _this.dialogRef.close(_this.gltLicenseDisplayData);
                    }
                });
            }
        }
        else { //Add License
            this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    var model = {
                        LicenseKey: _this.licenseKey,
                        TabletSerialNo: _this.gltGenerateKeyForm.value.TabletSerial,
                        CustomerUniqueKey: _this.gltGenerateKeyForm.value.UniqueHardwareId,
                        CustomerId: data.DataObject.CustomerId,
                        SalesOrderNo: _this.gltGenerateKeyForm.value.SalesOrderNo,
                        ShippingAddressId: data.DataObject.ShippingAddressId,
                        WarrantyYears: _this.gltGenerateKeyForm.value.NoOfYearsActivated,
                        ApplicationIdentification: "A",
                        PartNo: '931-00000-01',
                        CreatedBy: Number(localStorage.getItem('userid')),
                        UpdatedBy: Number(localStorage.getItem('userid'))
                    };
                    _this.licenseService.generateGltLicense(model).subscribe(function (licenseData) {
                        if (!licenseData.IsError && licenseData.DataObject != null) {
                            _this.gltLicenseDisplayData = licenseData.DataObject;
                            _this.appLoader.close();
                            _this.dialogRef.close(_this.gltLicenseDisplayData);
                        }
                        else {
                            _this.error = licenseData.Error;
                            _this.appLoader.close();
                            _this.dialogRef.close(_this.gltLicenseDisplayData);
                        }
                    });
                }
            });
        }
    };
    GenerateGltLicenseComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.gltLicenseDisplayData);
    };
    GenerateGltLicenseComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'generate-glt-license',
            template: __webpack_require__(1032),
            styles: [__webpack_require__(970)]
        }),
        __param(6, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_7__angular_router__["a" /* Router */], Object])
    ], GenerateGltLicenseComponent);
    return GenerateGltLicenseComponent;
}());



/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicensePortalComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var LicensePortalComponent = /** @class */ (function () {
    function LicensePortalComponent() {
        this.isVisible = true;
    }
    LicensePortalComponent.prototype.toggleSideNav = function () {
        this.isVisible = !this.isVisible;
    };
    LicensePortalComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'license-portal',
            styles: [__webpack_require__(955)],
            template: __webpack_require__(1034)
        })
    ], LicensePortalComponent);
    return LicensePortalComponent;
}());



/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddLz30DeviceLicenseRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__ = __webpack_require__(6);








var AddLz30DeviceLicenseRequest = /** @class */ (function () {
    function AddLz30DeviceLicenseRequest(formBuilder, dialogRef, licenseService, appLoader, adalService, router, dialogData) {
        this.formBuilder = formBuilder;
        this.dialogRef = dialogRef;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'Generate LZ30 Device License';
        this.errorMessage = '';
        this.shouldFetchSalesOrderNo = true;
        this.error = '';
        this.rowClicked = -1;
        this.DeviceList = [];
        this.prevSalesOrderNo = '';
        this.billingShippingDetail = {
            ODataEtag: '',
            Number: '',
            publicId: '',
            CustomerNo: '',
            publicSalesPersoncode: '',
            BillToName: '',
            BillToAddress1: '',
            BillToAddress2: '',
            BillToCity: '',
            BillToState: '',
            BillToZipcode: '',
            BillToCountryCode: '',
            ShipToCode: '',
            ShipToName: '',
            ShipToAddress1: '',
            ShipToAddress2: '',
            ShipToCity: '',
            ShipToState: '',
            ShipToZipcode: '',
            ShipToCountryCode: '',
            CustomerTelephone: '',
            CustomerEmailAddress: '',
            CustomerFaxno: '',
            ShippingTelephoneno: '',
            ShippingFaxno: '',
            ShippingEmailAddress: '',
            Rep1: '',
            Rep2: '',
            Sales1: '',
            Sales2: ''
        };
        this.isBillingShippingDetailFetched = false;
        this.isAddButtonClicked = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.buildForm();
        this.userDeviceDisplayData = dialogData.userDeviceDisplayData;
        this.lz30PurchaseLicenseDisplayData = dialogData.purchaseLicenseDisplayData;
        this.SelectedCustomerDetail = dialogData.SelectedCustomerDetail;
        if (this.SelectedCustomerDetail != null) {
            this.dialogTitle = 'Add More LZ30 License';
            this.isBillingShippingDetailFetched = true;
            this.SelectedCustomerDetail.SalesOrderNo = '';
            this.billingShippingDetail.BillToName = this.SelectedCustomerDetail.BillToName;
            this.billingShippingDetail.BillToAddress1 = this.SelectedCustomerDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2 = this.SelectedCustomerDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity = this.SelectedCustomerDetail.BillToCity;
            this.billingShippingDetail.ShipToName = this.SelectedCustomerDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1 = this.SelectedCustomerDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2 = this.SelectedCustomerDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity = this.SelectedCustomerDetail.ShipToCity;
            this.billingShippingDetail.ShipToState = this.SelectedCustomerDetail.ShipToState;
        }
    }
    AddLz30DeviceLicenseRequest.prototype.buildForm = function () {
        this.lz30LicenseForm = this.formBuilder.group({
            PurchaseDate: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            NoOfMonths: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            SalesOrderNo: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            Devices: this.formBuilder.array([this.createDevice(null)])
        });
    };
    AddLz30DeviceLicenseRequest.prototype.createDevice = function (data) {
        data = data || { SerialNo: null, StartDate: '' };
        return this.formBuilder.group({
            SerialNo: [data.SerialNo],
            StartDate: [data.StartDate]
        });
    };
    Object.defineProperty(AddLz30DeviceLicenseRequest.prototype, "devices", {
        get: function () {
            return this.lz30LicenseForm.get('Devices');
        },
        enumerable: true,
        configurable: true
    });
    AddLz30DeviceLicenseRequest.prototype.addDevice = function (index) {
        var currentDevice = this.devices.controls[index].get('SerialNo').value;
        var currentDeviceStartDate = this.devices.controls[index].get('StartDate').value;
        // const SerialNoError=this.devices.controls[index].get('SerialNo').errors
        // const DateError=this.devices.controls[index].get('StartDate').errors
        // if((SerialNoError && SerialNoError.required ) || (DateError && DateError.required )){
        //     return;   
        // }
        this.errorMessage = '';
        if (currentDevice == null || currentDeviceStartDate == '') {
            // this.isAddButtonClicked=true;
            this.errorMessage = 'Serial No or Start date cannot be empty.';
            return;
        }
        var filteredDeviceList = this.DeviceList.filter(function (device) {
            return device.MACAddress == currentDevice.MACAddress;
        });
        if (filteredDeviceList.length > 0) {
            this.errorMessage = 'This device already exists.';
            return;
        }
        this.DeviceList.push({
            LZ30DeviceId: currentDevice.LZ30DeviceId,
            MACAddress: currentDevice.MACAddress,
            DeviceStartDate: currentDeviceStartDate
        });
        this.rowClicked = index;
        this.devices.push(this.createDevice(null));
    };
    AddLz30DeviceLicenseRequest.prototype.removeDevice = function (index) {
        this.devices.removeAt(index);
        this.DeviceList.splice(index, 1);
        this.rowClicked--;
    };
    AddLz30DeviceLicenseRequest.prototype.onSave = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.isBillingShippingDetailFetched) {
                _this.error = "Please fetch the customer billing and shipping details!";
                return;
            }
            if (_this.DeviceList == null || _this.DeviceList.length <= 0) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    title: 'Serial Number Empty',
                    text: 'Please add atleast one Serial Number.',
                    showConfirmButton: true,
                    confirmButtonColor: '#FFCA28'
                });
                return;
            }
            if (_this.SelectedCustomerDetail != null) {
                _this.appLoader.open();
                if (_this.lz30LicenseForm.value.SalesOrderNo.toUpperCase() != _this.SelectedCustomerDetail.SalesOrderNo.toUpperCase()) {
                    _this.licenseService.addBillingShippingDetail(_this.billingShippingDetail).subscribe(function (data) {
                        var model = {
                            LZ30UserDeviceId: _this.SelectedCustomerDetail.LZ30UserDeviceId,
                            PurchaseDate: _this.lz30LicenseForm.value.PurchaseDate,
                            SalesOrderNo: _this.lz30LicenseForm.value.SalesOrderNo,
                            NoOfMonths: _this.lz30LicenseForm.value.NoOfMonths,
                            CustomerId: data.DataObject.CustomerId,
                            ShippingAddressId: data.DataObject.ShippingAddressId,
                            NoOfDevicePurchased: _this.DeviceList.length,
                            LZ30LicenseInfo: _this.DeviceList,
                            CreatedBy: Number(localStorage.getItem('userid')),
                            UpdatedBy: Number(localStorage.getItem('userid'))
                        };
                        _this.licenseService.addMoreLZ30License(model).subscribe(function (data) {
                            if (!data.IsError && data.DataObject != null) {
                                _this.dialogRef.close(data.DataObject);
                            }
                            _this.appLoader.close();
                        });
                    });
                }
                else {
                    var model = {
                        LZ30UserDeviceId: _this.SelectedCustomerDetail.LZ30UserDeviceId,
                        CustomerId: _this.SelectedCustomerDetail.CustomerId,
                        ShippingAddressId: _this.SelectedCustomerDetail.ShippingAddressId,
                        PurchaseDate: _this.lz30LicenseForm.value.PurchaseDate,
                        SalesOrderNo: _this.lz30LicenseForm.value.SalesOrderNo,
                        NoOfMonths: _this.lz30LicenseForm.value.NoOfMonths,
                        NoOfDevicePurchased: _this.DeviceList.length,
                        LZ30LicenseInfo: _this.DeviceList,
                        CreatedBy: Number(localStorage.getItem('userid')),
                        UpdatedBy: Number(localStorage.getItem('userid'))
                    };
                    _this.licenseService.addMoreLZ30License(model).subscribe(function (data) {
                        if (!data.IsError && data.DataObject != null) {
                            _this.dialogRef.close(data.DataObject);
                        }
                        _this.appLoader.close();
                    });
                }
            }
            else {
                _this.appLoader.open();
                _this.licenseService.addBillingShippingDetail(_this.billingShippingDetail).subscribe(function (data) {
                    var model = {
                        PurchaseDate: _this.lz30LicenseForm.value.PurchaseDate,
                        SalesOrderNo: _this.lz30LicenseForm.value.SalesOrderNo,
                        NoOfMonths: _this.lz30LicenseForm.value.NoOfMonths,
                        CustomerId: data.DataObject.CustomerId,
                        ShippingAddressId: data.DataObject.ShippingAddressId,
                        NoOfDevicePurchased: _this.DeviceList.length,
                        LZ30LicenseInfo: _this.DeviceList,
                        CreatedBy: Number(localStorage.getItem('userid')),
                        UpdatedBy: Number(localStorage.getItem('userid'))
                    };
                    _this.licenseService.purchaseLz30License(model).subscribe(function (data) {
                        if (!data.IsError && data.DataObject != null) {
                            _this.dialogRef.close(data.DataObject);
                        }
                        _this.appLoader.close();
                    });
                });
            }
        }, 300);
    };
    AddLz30DeviceLicenseRequest.prototype.blurSalesOrderEvent = function () {
        var _this = this;
        if (this.prevSalesOrderNo.trim().toUpperCase() == this.lz30LicenseForm.value.SalesOrderNo.trim().toUpperCase()) {
            return;
        }
        this.prevSalesOrderNo = this.lz30LicenseForm.value.SalesOrderNo;
        setTimeout(function () {
            _this.shouldFetchSalesOrderNo = true;
            _this.isBillingShippingDetailFetched = false;
        }, 150);
    };
    AddLz30DeviceLicenseRequest.prototype.checkSalesOrderNo = function () {
        var _this = this;
        if (this.lz30PurchaseLicenseDisplayData) {
            console.log(this.lz30PurchaseLicenseDisplayData);
            var exist = this.lz30PurchaseLicenseDisplayData.some(function (element) {
                if (element.SalesOrderNo != null) {
                    return _this.lz30LicenseForm.value.SalesOrderNo.trim().toUpperCase() == element.SalesOrderNo.trim().toUpperCase();
                }
                else {
                    return false;
                }
            });
            if (exist) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    title: "This sales order no already exists",
                    text: "Are you sure you want to use this Sales Order No?",
                    showCancelButton: true,
                    showCloseButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#FFCA28",
                    cancelButtonText: "No",
                }).then(function (result) {
                    if (result.isConfirmed) {
                        _this.shouldFetchSalesOrderNo = true;
                        _this.isBillingShippingDetailFetched = false;
                        _this.getBillingShippingDetail();
                    }
                    else {
                        _this.shouldFetchSalesOrderNo = false;
                        _this.lz30LicenseForm.patchValue({
                            SalesOrderNo: ""
                        });
                    }
                });
            }
            else {
                this.shouldFetchSalesOrderNo = true;
                this.isBillingShippingDetailFetched = false;
                this.getBillingShippingDetail();
            }
        }
        else {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
            this.getBillingShippingDetail();
        }
    };
    AddLz30DeviceLicenseRequest.prototype.getBillingShippingDetail = function () {
        var _this = this;
        var salesOrderNo = this.lz30LicenseForm.value.SalesOrderNo;
        if (salesOrderNo != '') {
            if (this.shouldFetchSalesOrderNo) {
                this.appLoader.open();
                this.licenseService.getBillingShippingDetail(salesOrderNo).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.billingShippingDetail = data.DataObject;
                        _this.isBillingShippingDetailFetched = true;
                        _this.error = '';
                    }
                    else {
                        _this.isBillingShippingDetailFetched = false;
                        _this.error = data.Error;
                    }
                    _this.appLoader.close();
                });
            }
            else {
                this.error = "Please select other sales order number.";
            }
        }
        else {
            this.error = "Sales Order No is required";
            this.isBillingShippingDetailFetched = false;
        }
    };
    AddLz30DeviceLicenseRequest.prototype.onCancel = function () {
        this.dialogRef.close(this.lz30PurchaseLicenseDisplayData);
    };
    AddLz30DeviceLicenseRequest = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1035),
            selector: 'add-lz30-device-license-request',
            styles: [__webpack_require__(972)]
        }),
        __param(6, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_4__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_6__angular_router__["a" /* Router */], Object])
    ], AddLz30DeviceLicenseRequest);
    return AddLz30DeviceLicenseRequest;
}());



/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddEditLZ30DeviceComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__ = __webpack_require__(6);







var AddEditLZ30DeviceComponent = /** @class */ (function () {
    function AddEditLZ30DeviceComponent(dialogRef, formBuilder, licenseService, appLoader, adalService, router, dialogData) {
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.errorMessage = '';
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.buildForm();
        this.userDeviceDisplayDetail = dialogData.userDeviceDisplayData;
        this.SelectedCustomerDetail = dialogData.SelectedCustomerDetail;
        if (this.SelectedCustomerDetail) {
            this.dialogTitle = "Edit Device Info";
            this.lz30AddDeviceForm.patchValue({
                MACAddress: this.SelectedCustomerDetail.MACAddress,
                DeviceSerialNo: this.SelectedCustomerDetail.DeviceSerialNo
            });
        }
        else {
            this.dialogTitle = "Add Device";
        }
    }
    AddEditLZ30DeviceComponent.prototype.buildForm = function () {
        this.lz30AddDeviceForm = this.formBuilder.group({
            MACAddress: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].pattern]],
            DeviceSerialNo: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]
        });
    };
    AddEditLZ30DeviceComponent.prototype.onSave = function () {
        var _this = this;
        this.appLoader.open();
        if (this.SelectedCustomerDetail) {
            var model = {
                MACAddress: this.lz30AddDeviceForm.value.MACAddress,
                DeviceSerialNo: this.lz30AddDeviceForm.value.DeviceSerialNo,
                UpdatedBy: Number(localStorage.getItem('userid')),
                LZ30DeviceId: this.SelectedCustomerDetail.LZ30DeviceId
            };
            this.licenseService.updateLz30Device(model).subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    _this.userDeviceDisplayDetail = data.DataObject;
                    _this.dialogRef.close(_this.userDeviceDisplayDetail);
                }
                else {
                    _this.errorMessage = data.Error;
                }
                _this.appLoader.close();
            });
        }
        else {
            var model = {
                MACAddress: this.lz30AddDeviceForm.value.MACAddress,
                DeviceSerialNo: this.lz30AddDeviceForm.value.DeviceSerialNo,
                CreatedBy: Number(localStorage.getItem('userid'))
            };
            this.licenseService.addLz30Device(model).subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    _this.userDeviceDisplayDetail = data.DataObject;
                    _this.dialogRef.close(_this.userDeviceDisplayDetail);
                }
                else {
                    _this.errorMessage = data.Error;
                }
                _this.appLoader.close();
            });
        }
    };
    AddEditLZ30DeviceComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.userDeviceDisplayDetail);
    };
    AddEditLZ30DeviceComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'add-lz30-device',
            template: __webpack_require__(1036),
            styles: [__webpack_require__(973)]
        }),
        __param(6, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_5__angular_router__["a" /* Router */], Object])
    ], AddEditLZ30DeviceComponent);
    return AddEditLZ30DeviceComponent;
}());



/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExtendLZ30TrialPeriod; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_app_loader_app_loader_service__ = __webpack_require__(7);







var ExtendLZ30TrialPeriod = /** @class */ (function () {
    function ExtendLZ30TrialPeriod(licenseService, dialogRef, adalService, router, formBuilder, snackBar, appLoader, dialogData) {
        this.licenseService = licenseService;
        this.dialogRef = dialogRef;
        this.adalService = adalService;
        this.router = router;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        this.appLoader = appLoader;
        this.dialogData = dialogData;
        this.dialogTitle = 'Extend Trial Period';
        this.errorMessage = '';
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.userDeviceDisplayDetail = dialogData.userDeviceDisplayData;
        this.SelectedDeviceDetail = dialogData.SelectedDeviceDetail;
        this.buildForm();
    }
    ExtendLZ30TrialPeriod.prototype.buildForm = function () {
        this.LZ30ExtendTrialPeriodForm = this.formBuilder.group({
            TrialMonth: ['', __WEBPACK_IMPORTED_MODULE_5__angular_forms__["e" /* Validators */].required],
            Date: ['', __WEBPACK_IMPORTED_MODULE_5__angular_forms__["e" /* Validators */].required]
        });
    };
    ExtendLZ30TrialPeriod.prototype.onSave = function () {
        var _this = this;
        var model = {
            UpdatedBy: Number(localStorage.getItem('userid')),
            LZ30DeviceId: this.SelectedDeviceDetail.LZ30DeviceId,
            TrialMonth: this.LZ30ExtendTrialPeriodForm.value.TrialMonth,
            LZ30StartDate: this.LZ30ExtendTrialPeriodForm.value.Date
        };
        this.appLoader.open();
        this.licenseService.extendLZ30TrialPeriod(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.userDeviceDisplayDetail = data.DataObject;
                _this.appLoader.close();
                _this.dialogRef.close(_this.userDeviceDisplayDetail);
                _this.snackBar.open("Trial period extended", "", {
                    duration: 1000
                });
            }
        });
    };
    ExtendLZ30TrialPeriod.prototype.onCancel = function () {
        this.dialogRef.close(this.userDeviceDisplayDetail);
    };
    ExtendLZ30TrialPeriod = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1037),
            styles: [__webpack_require__(974)],
            selector: 'extend-LZ30-trial-period'
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_3__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_5__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_6__services_app_loader_app_loader_service__["a" /* AppLoaderService */], Object])
    ], ExtendLZ30TrialPeriod);
    return ExtendLZ30TrialPeriod;
}());



/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewLZ30DeviceHistory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_app_loader_app_loader_service__ = __webpack_require__(7);







var ViewLZ30DeviceHistory = /** @class */ (function () {
    function ViewLZ30DeviceHistory(licenseService, dialogRef, adalService, router, formBuilder, snackBar, appLoader, dialogData) {
        this.licenseService = licenseService;
        this.dialogRef = dialogRef;
        this.adalService = adalService;
        this.router = router;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        this.appLoader = appLoader;
        this.dialogData = dialogData;
        this.errorMessage = '';
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.userDeviceDisplayDetail = dialogData.userDeviceDisplayData;
        this.SelectedDeviceDetail = dialogData.SelectedDeviceDetail;
        this.dialogTitle = 'View Device History [' + this.SelectedDeviceDetail.DeviceSerialNo + ']';
        this.getLZ30DeviceHistory();
    }
    ViewLZ30DeviceHistory.prototype.getLZ30DeviceHistory = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.viewLZ30DeviceHistory(this.SelectedDeviceDetail.LZ30DeviceId, this.SelectedDeviceDetail.LZ30UserDetailId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.LZ30DeviceHistory = data.DataObject;
            }
            else {
                _this.errorMessage = data.Error;
            }
            _this.isLoading = false;
        });
    };
    ViewLZ30DeviceHistory.prototype.onCancel = function () {
        this.dialogRef.close(null);
    };
    ViewLZ30DeviceHistory = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1039),
            styles: [__webpack_require__(976)],
            selector: 'view-lz30-device-history'
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_3__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_5__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_6__services_app_loader_app_loader_service__["a" /* AppLoaderService */], Object])
    ], ViewLZ30DeviceHistory);
    return ViewLZ30DeviceHistory;
}());



/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewLZ30PurchaseLicenseHistory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);






var ViewLZ30PurchaseLicenseHistory = /** @class */ (function () {
    function ViewLZ30PurchaseLicenseHistory(licenseService, appLoader, dialogRef, adalService, router, dialogData) {
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.dialogRef = dialogRef;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'View LZ30 Purchase License History';
        this.errorMessage = "";
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        else {
            this.SelectedCustomerDetail = dialogData.SelectedCustomerDetail,
                this.Lz30PurchaselicenceDisplayList = dialogData.purchaseLicenseDisplayData;
            this.getLZ30PurchaseLicenseHistory();
        }
    }
    ViewLZ30PurchaseLicenseHistory.prototype.getLZ30PurchaseLicenseHistory = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.getLz30PurchaseHistory(this.SelectedCustomerDetail.LZ30UserDeviceId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.LZ30PurchaseLicenseHistory = data.DataObject;
            }
            else {
                _this.errorMessage = data.Error;
            }
            _this.isLoading = false;
        });
    };
    ViewLZ30PurchaseLicenseHistory.prototype.onCancel = function () {
        this.dialogRef.close(this.Lz30PurchaselicenceDisplayList);
    };
    ViewLZ30PurchaseLicenseHistory = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            styles: [__webpack_require__(977)],
            template: __webpack_require__(1040),
            selector: 'view-lz30-purchase-history'
        }),
        __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_2__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */], Object])
    ], ViewLZ30PurchaseLicenseHistory);
    return ViewLZ30PurchaseLicenseHistory;
}());



/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivateScal360LicenseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);









var ActivateScal360LicenseComponent = /** @class */ (function () {
    function ActivateScal360LicenseComponent(dialogRef, formBuilder, licenseService, appLoader, snackBar, adalService, router, dialogData) {
        var _this = this;
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'Activate SCAL 360 License';
        this.errorMessage = '';
        this.isRadioButtonDisabled = false;
        this.selectedRow = null;
        this.billingShippingDetail = {
            ODataEtag: '',
            Number: '',
            publicId: '',
            CustomerNo: '',
            publicSalesPersoncode: '',
            BillToName: '',
            BillToAddress1: '',
            BillToAddress2: '',
            BillToCity: '',
            BillToState: '',
            BillToZipcode: '',
            BillToCountryCode: '',
            ShipToCode: '',
            ShipToName: '',
            ShipToAddress1: '',
            ShipToAddress2: '',
            ShipToCity: '',
            ShipToState: '',
            ShipToZipcode: '',
            ShipToCountryCode: '',
            CustomerTelephone: '',
            CustomerEmailAddress: '',
            CustomerFaxno: '',
            ShippingTelephoneno: '',
            ShippingFaxno: '',
            ShippingEmailAddress: '',
            Rep1: '',
            Rep2: '',
            Sales1: '',
            Sales2: ''
        };
        this.customerId = 0;
        this.shippingAddressId = 0;
        this.shouldFetchSalesOrderNo = false;
        this.error = "";
        this.SCALTypeList = [];
        this.OSDetailList = [];
        this.SelectedLicenseKey = '';
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.scal360LicenseDisplayList = this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail = this.dialogData.SelectedLicenseDetail;
        this.buildForm();
        Object.keys(__WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__["h" /* SCALOsDetailType */]).filter(function (type) { return isNaN(Number(type)); }).forEach(function (key, index) {
            _this.OSDetailList.push(key);
        });
        this.getScalCustomerLicenseDetail();
        this.billingShippingDetail.BillToName = this.SelectedCustomerLicenseDetail.BillToName;
        this.billingShippingDetail.BillToAddress1 = this.SelectedCustomerLicenseDetail.BillToAddress1;
        this.billingShippingDetail.BillToAddress2 = this.SelectedCustomerLicenseDetail.BillToAddress2;
        this.billingShippingDetail.BillToCity = this.SelectedCustomerLicenseDetail.BillToCity;
        this.billingShippingDetail.ShipToName = this.SelectedCustomerLicenseDetail.ShipToName;
        this.billingShippingDetail.ShipToAddress1 = this.SelectedCustomerLicenseDetail.ShipToAddress1;
        this.billingShippingDetail.ShipToAddress2 = this.SelectedCustomerLicenseDetail.ShipToAddress2;
        this.billingShippingDetail.ShipToCity = this.SelectedCustomerLicenseDetail.ShipToCity;
        this.billingShippingDetail.ShipToState = this.SelectedCustomerLicenseDetail.ShipToState;
    }
    ActivateScal360LicenseComponent.prototype.buildForm = function () {
        this.activateScal360LicenseForm = this.formBuilder.group({
            UniqueHardwareId: ['', [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* Validators */].required]],
            RequesterName: ['', [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* Validators */].required]],
            RequesterEmail: ['', [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* Validators */].required]],
            OSDetails: ['', [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* Validators */].required]],
            RequesterPhone: ['', __WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* Validators */].required]
        });
    };
    ActivateScal360LicenseComponent.prototype.selectRow = function (selectedLicense, index) {
        this.selectedRow = (this.selectedRow == index) ? null : index;
        this.SelectedLicenseKey = selectedLicense.LicenseKey;
    };
    ActivateScal360LicenseComponent.prototype.getScalCustomerLicenseDetail = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.getScalCustomerLicenseDetailForActivationAndRenewal(this.SelectedCustomerLicenseDetail.LicenseId).subscribe(function (data) {
            if (!data.Error && data.DataObject != null) {
                _this.LicenseActivationDetails = data.DataObject;
            }
            _this.isLoading = false;
        });
    };
    ActivateScal360LicenseComponent.prototype.onSave = function () {
        var _this = this;
        if (this.selectedRow == null) {
            __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.fire({
                title: "Please select atleast one license key",
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: '#FFCA28',
                confirmButtonText: 'OK',
            });
            return;
        }
        this.appLoader.open();
        var model = {
            LicenseKey: this.SelectedLicenseKey,
            SCALType: this.SelectedCustomerLicenseDetail.SCALType,
            HardwareId: this.activateScal360LicenseForm.value.UniqueHardwareId,
            OSDetails: this.activateScal360LicenseForm.value.OSDetails,
            RequesterName: this.activateScal360LicenseForm.value.RequesterName,
            RequesterEmail: this.activateScal360LicenseForm.value.RequesterEmail,
            RequesterPhone: this.activateScal360LicenseForm.value.RequesterPhone,
            CreatedBy: Number(localStorage.getItem('userid')),
            UpdatedBy: Number(localStorage.getItem('userid'))
        };
        this.licenseService.activateScalLicense(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.scal360LicenseDisplayList = data.DataObject;
                _this.dialogRef.close(_this.scal360LicenseDisplayList);
                _this.appLoader.close();
                _this.snackBar.open("License activated successfully!", "", {
                    duration: 2000
                });
            }
            else {
                _this.appLoader.close();
                _this.dialogRef.close(_this.scal360LicenseDisplayList);
            }
        });
    };
    ActivateScal360LicenseComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.scal360LicenseDisplayList);
    };
    ActivateScal360LicenseComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'activate-scal360-license',
            template: __webpack_require__(1041),
            styles: [__webpack_require__(978)]
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_3__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_6__angular_router__["a" /* Router */], Object])
    ], ActivateScal360LicenseComponent);
    return ActivateScal360LicenseComponent;
}());



/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenerateSCAL30LicenseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__interfaces_LicenseModel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__ = __webpack_require__(6);









var GenerateSCAL30LicenseComponent = /** @class */ (function () {
    function GenerateSCAL30LicenseComponent(dialogRef, formBuilder, licenseService, appLoader, snackBar, adalService, router, dialogData) {
        var _this = this;
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = '';
        this.errorMessage = '';
        this.isRadioButtonDisabled = false;
        this.billingShippingDetail = {
            ODataEtag: '',
            Number: '',
            publicId: '',
            CustomerNo: '',
            publicSalesPersoncode: '',
            BillToName: '',
            BillToAddress1: '',
            BillToAddress2: '',
            BillToCity: '',
            BillToState: '',
            BillToZipcode: '',
            BillToCountryCode: '',
            ShipToCode: '',
            ShipToName: '',
            ShipToAddress1: '',
            ShipToAddress2: '',
            ShipToCity: '',
            ShipToState: '',
            ShipToZipcode: '',
            ShipToCountryCode: '',
            CustomerTelephone: '',
            CustomerEmailAddress: '',
            CustomerFaxno: '',
            ShippingTelephoneno: '',
            ShippingFaxno: '',
            ShippingEmailAddress: '',
            Rep1: '',
            Rep2: '',
            Sales1: '',
            Sales2: ''
        };
        this.isBillingShippingDetailFetched = false;
        this.customerId = 0;
        this.shippingAddressId = 0;
        this.shouldFetchSalesOrderNo = false;
        this.error = "";
        this.isLoading = false;
        this.SCALTypeList = [];
        this.prevSalesOrderNo = '';
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.buildForm();
        this.scal360LicenseDisplayList = this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail = this.dialogData.SelectedLicenseDetail;
        this.SCALOperation = this.dialogData.scalOperation;
        Object.keys(__WEBPACK_IMPORTED_MODULE_6__interfaces_LicenseModel__["g" /* SCALType */]).filter(function (type) { return isNaN(Number(type)); }).forEach(function (key, index) {
            _this.SCALTypeList.push({
                name: key,
                value: __WEBPACK_IMPORTED_MODULE_6__interfaces_LicenseModel__["g" /* SCALType */][key]
            });
        });
        if (this.SCALOperation == 2) {
            this.dialogTitle = "Edit License Request";
            this.isRadioButtonDisabled = true;
            this.scal360LicenseForm.patchValue({
                NoOfLicensePurchased: this.SelectedCustomerLicenseDetail.NoOfLicensePurchased,
                NoOfUserLicensePurchased: this.SelectedCustomerLicenseDetail.NoOfUserLicensePurchased,
                ScalType: __WEBPACK_IMPORTED_MODULE_6__interfaces_LicenseModel__["g" /* SCALType */][this.SelectedCustomerLicenseDetail.SCALType],
                LicenseType: this.SelectedCustomerLicenseDetail.LicenseType,
                SupportValidityYear: this.SelectedCustomerLicenseDetail.SupportValidityYears,
                PurchaseDate: this.SelectedCustomerLicenseDetail.PurchaseInvoiceDate.split('T')[0],
                SalesOrderNo: this.SelectedCustomerLicenseDetail.SalesOrderNo,
            });
            this.isBillingShippingDetailFetched = true;
            this.prevSalesOrderNo = this.SelectedCustomerLicenseDetail.SalesOrderNo;
            this.billingShippingDetail.BillToName = this.SelectedCustomerLicenseDetail.BillToName;
            this.billingShippingDetail.BillToAddress1 = this.SelectedCustomerLicenseDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2 = this.SelectedCustomerLicenseDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity = this.SelectedCustomerLicenseDetail.BillToCity;
            this.billingShippingDetail.ShipToName = this.SelectedCustomerLicenseDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1 = this.SelectedCustomerLicenseDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2 = this.SelectedCustomerLicenseDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity = this.SelectedCustomerLicenseDetail.ShipToCity;
            this.billingShippingDetail.ShipToState = this.SelectedCustomerLicenseDetail.ShipToState;
        }
        else if (this.SCALOperation == 3) {
            this.dialogTitle = "Add More License Request";
            this.isRadioButtonDisabled = true;
            this.scal360LicenseForm.patchValue({
                ScalType: __WEBPACK_IMPORTED_MODULE_6__interfaces_LicenseModel__["g" /* SCALType */][this.SelectedCustomerLicenseDetail.SCALType],
                LicenseType: this.SelectedCustomerLicenseDetail.LicenseType
            });
            this.isBillingShippingDetailFetched = true;
            this.prevSalesOrderNo = this.SelectedCustomerLicenseDetail.SalesOrderNo;
            this.billingShippingDetail.BillToName = this.SelectedCustomerLicenseDetail.BillToName;
            this.billingShippingDetail.BillToAddress1 = this.SelectedCustomerLicenseDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2 = this.SelectedCustomerLicenseDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity = this.SelectedCustomerLicenseDetail.BillToCity;
            this.billingShippingDetail.ShipToName = this.SelectedCustomerLicenseDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1 = this.SelectedCustomerLicenseDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2 = this.SelectedCustomerLicenseDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity = this.SelectedCustomerLicenseDetail.ShipToCity;
            this.billingShippingDetail.ShipToState = this.SelectedCustomerLicenseDetail.ShipToState;
        }
        else {
            this.scal360LicenseForm.get('NoOfLicensePurchased').setValidators([__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].max(100), __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].min(1)]);
            this.dialogTitle = 'Generate New License Request';
        }
    }
    GenerateSCAL30LicenseComponent.prototype.buildForm = function () {
        this.scal360LicenseForm = this.formBuilder.group({
            NoOfLicensePurchased: [1, [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].max(100)]],
            NoOfUserLicensePurchased: [0, [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].max(100)]],
            SalesOrderNo: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]],
            ScalType: [1, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            LicenseType: ['NEW', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            PurchaseDate: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            SupportValidityYear: [24, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]
        });
    };
    GenerateSCAL30LicenseComponent.prototype.blurSalesOrderEvent = function () {
        var _this = this;
        if (this.prevSalesOrderNo.trim().toUpperCase() == this.scal360LicenseForm.value.SalesOrderNo.trim().toUpperCase()) {
            return;
        }
        this.prevSalesOrderNo = this.scal360LicenseForm.value.SalesOrderNo;
        setTimeout(function () {
            _this.shouldFetchSalesOrderNo = true;
            _this.isBillingShippingDetailFetched = false;
        }, 150);
    };
    GenerateSCAL30LicenseComponent.prototype.checkSalesOrderNo = function () {
        var _this = this;
        if (this.dialogData.Scal360LicenseData) {
            var exist = this.dialogData.Scal360LicenseData.some(function (element) {
                if (element.SalesOrderNo != null) {
                    return _this.scal360LicenseForm.value.SalesOrderNo.trim().toUpperCase() == element.SalesOrderNo.trim().toUpperCase();
                }
                else {
                    return false;
                }
            });
            if (exist) {
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                    title: "This sales order no already exists",
                    text: "Are you sure you want to use this Sales Order No?",
                    showCancelButton: true,
                    showCloseButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#FFCA28",
                    cancelButtonText: "No",
                }).then(function (result) {
                    if (result.isConfirmed) {
                        _this.shouldFetchSalesOrderNo = true;
                        _this.isBillingShippingDetailFetched = false;
                        _this.getBillingShippingDetail();
                    }
                    else {
                        _this.shouldFetchSalesOrderNo = false;
                        _this.scal360LicenseForm.patchValue({
                            SalesOrderNo: ""
                        });
                    }
                });
            }
            else {
                this.shouldFetchSalesOrderNo = true;
                this.isBillingShippingDetailFetched = false;
                this.getBillingShippingDetail();
            }
        }
        else {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
            this.getBillingShippingDetail();
        }
    };
    GenerateSCAL30LicenseComponent.prototype.getBillingShippingDetail = function () {
        var _this = this;
        var salesOrderNo = this.scal360LicenseForm.value.SalesOrderNo;
        if (salesOrderNo != '') {
            if (this.shouldFetchSalesOrderNo) {
                this.appLoader.open();
                this.licenseService.getBillingShippingDetail(salesOrderNo).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.billingShippingDetail = data.DataObject;
                        _this.isBillingShippingDetailFetched = true;
                        _this.error = '';
                    }
                    else {
                        _this.isBillingShippingDetailFetched = false;
                        _this.error = data.Error;
                    }
                    _this.appLoader.close();
                });
            }
            else {
                this.error = "Please select other sales order number.";
            }
        }
        else {
            this.error = "Sales Order No is required";
            this.isBillingShippingDetailFetched = false;
        }
    };
    GenerateSCAL30LicenseComponent.prototype.onSave = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.isBillingShippingDetailFetched) {
                _this.error = "Please fetch the customer billing and shipping details!";
                return;
            }
            else {
                if (_this.SCALOperation == 2) { //edit license request
                    _this.appLoader.open();
                    if (_this.SelectedCustomerLicenseDetail.SalesOrderNo.toUpperCase() === _this.scal360LicenseForm.value.SalesOrderNo.toUpperCase()) {
                        var model = {
                            CustomerId: _this.SelectedCustomerLicenseDetail.CustomerId,
                            ShippingAddressId: _this.SelectedCustomerLicenseDetail.ShippingAddressId,
                            SCALType: __WEBPACK_IMPORTED_MODULE_6__interfaces_LicenseModel__["g" /* SCALType */][_this.scal360LicenseForm.value.ScalType],
                            LicenseType: _this.scal360LicenseForm.value.LicenseType,
                            SupportValidityYear: _this.scal360LicenseForm.value.SupportValidityYear,
                            PurchaseInvoiceDate: _this.scal360LicenseForm.value.PurchaseDate,
                            SalesOrderNo: _this.scal360LicenseForm.value.SalesOrderNo,
                            NoOfLicensePurchased: _this.scal360LicenseForm.value.NoOfLicensePurchased,
                            NoOfUserLicensePurchased: _this.scal360LicenseForm.value.NoOfUserLicensePurchased,
                            PurchaseId: _this.SelectedCustomerLicenseDetail.PurchaseId,
                            LicenseId: _this.SelectedCustomerLicenseDetail.LicenseId,
                            UpdatedBy: Number(localStorage.getItem('userid'))
                        };
                        _this.licenseService.updateScalPurchaseLicense(model).subscribe(function (data) {
                            if (!data.IsError && data.DataObject != null) {
                                _this.scal360LicenseDisplayList = data.DataObject;
                                _this.dialogRef.close(_this.scal360LicenseDisplayList);
                                _this.appLoader.close();
                                _this.snackBar.open("License Updated successfully!", "", {
                                    duration: 2000
                                });
                            }
                            else {
                                _this.appLoader.close();
                                _this.dialogRef.close(_this.scal360LicenseDisplayList);
                            }
                        });
                    }
                    else {
                        _this.licenseService.addBillingShippingDetail(_this.billingShippingDetail).subscribe(function (data) {
                            if (!data.IsError && data.DataObject != null) {
                                _this.customerId = data.DataObject.CustomerId;
                                _this.shippingAddressId = data.DataObject.ShippingAddressId;
                                var model = {
                                    CustomerId: data.DataObject.CustomerId,
                                    ShippingAddressId: data.DataObject.ShippingAddressId,
                                    SCALType: __WEBPACK_IMPORTED_MODULE_6__interfaces_LicenseModel__["g" /* SCALType */][_this.scal360LicenseForm.value.ScalType],
                                    LicenseType: _this.scal360LicenseForm.value.LicenseType,
                                    SupportValidityYear: _this.scal360LicenseForm.value.SupportValidityYear,
                                    PurchaseInvoiceDate: _this.scal360LicenseForm.value.PurchaseDate,
                                    SalesOrderNo: _this.scal360LicenseForm.value.SalesOrderNo,
                                    NoOfLicensePurchased: _this.scal360LicenseForm.value.NoOfLicensePurchased,
                                    NoOfUserLicensePurchased: _this.scal360LicenseForm.value.NoOfUserLicensePurchased,
                                    PurchaseId: _this.SelectedCustomerLicenseDetail.PurchaseId,
                                    LicenseId: _this.SelectedCustomerLicenseDetail.LicenseId,
                                    UpdatedBy: Number(localStorage.getItem('userid'))
                                };
                                _this.licenseService.updateScalPurchaseLicense(model).subscribe(function (data) {
                                    if (!data.IsError && data.DataObject != null) {
                                        _this.scal360LicenseDisplayList = data.DataObject;
                                        _this.dialogRef.close(_this.scal360LicenseDisplayList);
                                        _this.appLoader.close();
                                        _this.snackBar.open("License Updated successfully!", "", {
                                            duration: 2000
                                        });
                                    }
                                    else {
                                        _this.appLoader.close();
                                        _this.dialogRef.close(_this.scal360LicenseDisplayList);
                                    }
                                });
                            }
                        });
                    }
                }
                else if (_this.SCALOperation == 3) { //add more license request
                    _this.appLoader.open();
                    if (_this.SelectedCustomerLicenseDetail.SalesOrderNo.toUpperCase() === _this.scal360LicenseForm.value.SalesOrderNo.toUpperCase()) {
                        var model = {
                            CustomerId: _this.SelectedCustomerLicenseDetail.CustomerId,
                            ShippingAddressId: _this.SelectedCustomerLicenseDetail.ShippingAddressId,
                            SCALType: __WEBPACK_IMPORTED_MODULE_6__interfaces_LicenseModel__["g" /* SCALType */][_this.scal360LicenseForm.value.ScalType],
                            LicenseType: _this.scal360LicenseForm.value.LicenseType,
                            SupportValidityYear: _this.scal360LicenseForm.value.SupportValidityYear,
                            PurchaseInvoiceDate: _this.scal360LicenseForm.value.PurchaseDate,
                            SalesOrderNo: _this.scal360LicenseForm.value.SalesOrderNo,
                            NoOfLicensePurchased: _this.scal360LicenseForm.value.NoOfLicensePurchased,
                            NoOfUserLicensePurchased: _this.scal360LicenseForm.value.NoOfUserLicensePurchased,
                            PurchaseId: _this.SelectedCustomerLicenseDetail.PurchaseId,
                            LicenseId: _this.SelectedCustomerLicenseDetail.LicenseId,
                            UpdatedBy: Number(localStorage.getItem('userid'))
                        };
                        _this.licenseService.addMoreScalLicense(model).subscribe(function (data) {
                            if (!data.IsError && data.DataObject != null) {
                                _this.scal360LicenseDisplayList = data.DataObject;
                                _this.dialogRef.close(_this.scal360LicenseDisplayList);
                                _this.appLoader.close();
                                _this.snackBar.open("License added successfully!", "", {
                                    duration: 2000
                                });
                            }
                            else {
                                _this.appLoader.close();
                                _this.dialogRef.close(_this.scal360LicenseDisplayList);
                            }
                        });
                    }
                    else {
                        _this.licenseService.addBillingShippingDetail(_this.billingShippingDetail).subscribe(function (data) {
                            if (!data.IsError && data.DataObject != null) {
                                _this.customerId = data.DataObject.CustomerId;
                                _this.shippingAddressId = data.DataObject.ShippingAddressId;
                                var model = {
                                    CustomerId: data.DataObject.CustomerId,
                                    ShippingAddressId: data.DataObject.ShippingAddressId,
                                    SCALType: __WEBPACK_IMPORTED_MODULE_6__interfaces_LicenseModel__["g" /* SCALType */][_this.scal360LicenseForm.value.ScalType],
                                    LicenseType: _this.scal360LicenseForm.value.LicenseType,
                                    SupportValidityYear: _this.scal360LicenseForm.value.SupportValidityYear,
                                    PurchaseInvoiceDate: _this.scal360LicenseForm.value.PurchaseDate,
                                    SalesOrderNo: _this.scal360LicenseForm.value.SalesOrderNo,
                                    NoOfLicensePurchased: _this.scal360LicenseForm.value.NoOfLicensePurchased,
                                    NoOfUserLicensePurchased: _this.scal360LicenseForm.value.NoOfUserLicensePurchased,
                                    PurchaseId: _this.SelectedCustomerLicenseDetail.PurchaseId,
                                    LicenseId: _this.SelectedCustomerLicenseDetail.LicenseId,
                                    UpdatedBy: Number(localStorage.getItem('userid'))
                                };
                                _this.licenseService.addMoreScalLicense(model).subscribe(function (data) {
                                    if (!data.IsError && data.DataObject != null) {
                                        _this.scal360LicenseDisplayList = data.DataObject;
                                        _this.dialogRef.close(_this.scal360LicenseDisplayList);
                                        _this.appLoader.close();
                                        _this.snackBar.open("License Updated successfully!", "", {
                                            duration: 2000
                                        });
                                    }
                                    else {
                                        _this.appLoader.close();
                                        _this.dialogRef.close(_this.scal360LicenseDisplayList);
                                    }
                                });
                            }
                        });
                    }
                }
                else { //add new license request
                    _this.appLoader.open();
                    _this.licenseService.addBillingShippingDetail(_this.billingShippingDetail).subscribe(function (data) {
                        if (!data.IsError && data.DataObject != null) {
                            _this.customerId = data.DataObject.CustomerId;
                            _this.shippingAddressId = data.DataObject.ShippingAddressId;
                            var model = {
                                CustomerId: data.DataObject.CustomerId,
                                ShippingAddressId: data.DataObject.ShippingAddressId,
                                SCALType: __WEBPACK_IMPORTED_MODULE_6__interfaces_LicenseModel__["g" /* SCALType */][_this.scal360LicenseForm.value.ScalType],
                                LicenseType: _this.scal360LicenseForm.value.LicenseType,
                                SupportValidityYear: _this.scal360LicenseForm.value.SupportValidityYear,
                                PurchaseInvoiceDate: _this.scal360LicenseForm.value.PurchaseDate,
                                SalesOrderNo: _this.scal360LicenseForm.value.SalesOrderNo,
                                NoOfLicensePurchased: _this.scal360LicenseForm.value.NoOfLicensePurchased,
                                NoOfUserLicensePurchased: _this.scal360LicenseForm.value.NoOfUserLicensePurchased,
                                CreatedBy: Number(localStorage.getItem('userid')),
                                UpdatedBy: Number(localStorage.getItem('userid'))
                            };
                            _this.licenseService.generateScalLicense(model).subscribe(function (data) {
                                if (!data.IsError && data.DataObject != null) {
                                    _this.scal360LicenseDisplayList = data.DataObject;
                                    _this.appLoader.close();
                                    _this.dialogRef.close(_this.scal360LicenseDisplayList);
                                    _this.snackBar.open("License generated successfully!", "", {
                                        duration: 2000
                                    });
                                }
                                else {
                                    _this.appLoader.close();
                                    _this.dialogRef.close(_this.scal360LicenseDisplayList);
                                }
                            });
                        }
                    });
                }
            }
        }, 300);
    };
    GenerateSCAL30LicenseComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.scal360LicenseDisplayList);
    };
    GenerateSCAL30LicenseComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'generate-scal360-license',
            styles: [__webpack_require__(979)],
            template: __webpack_require__(1042)
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_7__angular_router__["a" /* Router */], Object])
    ], GenerateSCAL30LicenseComponent);
    return GenerateSCAL30LicenseComponent;
}());



/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenewScal360LicenseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__interfaces_LicenseModel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__ = __webpack_require__(6);









var RenewScal360LicenseComponent = /** @class */ (function () {
    function RenewScal360LicenseComponent(dialogRef, formBuilder, licenseService, appLoader, snackBar, adalService, router, dialogData) {
        var _this = this;
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.renewalType = __WEBPACK_IMPORTED_MODULE_2__interfaces_LicenseModel__["f" /* SCALRenewalType */];
        this.scalTypeEnum = __WEBPACK_IMPORTED_MODULE_2__interfaces_LicenseModel__["g" /* SCALType */];
        this.dialogTitle = 'Renew SCAL 360 License';
        this.errorMessage = '';
        this.isRadioButtonDisabled = false;
        this.billingShippingDetail = {
            ODataEtag: '',
            Number: '',
            publicId: '',
            CustomerNo: '',
            publicSalesPersoncode: '',
            BillToName: '',
            BillToAddress1: '',
            BillToAddress2: '',
            BillToCity: '',
            BillToState: '',
            BillToZipcode: '',
            BillToCountryCode: '',
            ShipToCode: '',
            ShipToName: '',
            ShipToAddress1: '',
            ShipToAddress2: '',
            ShipToCity: '',
            ShipToState: '',
            ShipToZipcode: '',
            ShipToCountryCode: '',
            CustomerTelephone: '',
            CustomerEmailAddress: '',
            CustomerFaxno: '',
            ShippingTelephoneno: '',
            ShippingFaxno: '',
            ShippingEmailAddress: '',
            Rep1: '',
            Rep2: '',
            Sales1: '',
            Sales2: ''
        };
        this.customerId = 0;
        this.shippingAddressId = 0;
        this.shouldFetchSalesOrderNo = false;
        this.error = "";
        this.SCALRenewalTypeList = [];
        this.SelectedLicenseKey = '';
        this.isBillingShippingDetailFetched = false;
        this.selectedLicenseDetailIdList = [];
        this.selectedNoOfUserRenewalList = [];
        this.isLoading = false;
        this.currentTime = Date.now();
        this.prevSalesOrderNo = '';
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.scal360LicenseDisplayList = this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail = this.dialogData.SelectedLicenseDetail;
        this.buildForm();
        this.getScalCustomerLicenseDetail();
        Object.keys(__WEBPACK_IMPORTED_MODULE_2__interfaces_LicenseModel__["f" /* SCALRenewalType */]).filter(function (type) { return isNaN(Number(type)); }).forEach(function (key, index) {
            _this.SCALRenewalTypeList.push({
                name: key,
                value: __WEBPACK_IMPORTED_MODULE_2__interfaces_LicenseModel__["f" /* SCALRenewalType */][key]
            });
        });
        this.billingShippingDetail.BillToName = this.SelectedCustomerLicenseDetail.BillToName;
        this.billingShippingDetail.BillToAddress1 = this.SelectedCustomerLicenseDetail.BillToAddress1;
        this.billingShippingDetail.BillToAddress2 = this.SelectedCustomerLicenseDetail.BillToAddress2;
        this.billingShippingDetail.BillToCity = this.SelectedCustomerLicenseDetail.BillToCity;
        this.billingShippingDetail.ShipToName = this.SelectedCustomerLicenseDetail.ShipToName;
        this.billingShippingDetail.ShipToAddress1 = this.SelectedCustomerLicenseDetail.ShipToAddress1;
        this.billingShippingDetail.ShipToAddress2 = this.SelectedCustomerLicenseDetail.ShipToAddress2;
        this.billingShippingDetail.ShipToCity = this.SelectedCustomerLicenseDetail.ShipToCity;
        this.billingShippingDetail.ShipToState = this.SelectedCustomerLicenseDetail.ShipToState;
    }
    RenewScal360LicenseComponent.prototype.buildForm = function () {
        this.renewScal360LicenseForm = this.formBuilder.group({
            RenewalType: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]],
            PurchaseDate: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            SupportValidityYear: [24, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            SalesOrderNo: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]],
        });
    };
    RenewScal360LicenseComponent.prototype.selectRow = function (selectedLicense, index) {
        this.selectedRow[index] = (this.selectedRow[index] == index) ? null : index;
        this.SelectedLicenseKey = selectedLicense.LicenseKey;
    };
    RenewScal360LicenseComponent.prototype.getScalCustomerLicenseDetail = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.getScalCustomerLicenseDetailForActivationAndRenewal(this.SelectedCustomerLicenseDetail.LicenseId).subscribe(function (data) {
            if (!data.Error && data.DataObject != null) {
                _this.LicenseRenewalDetails = data.DataObject;
                _this.selectedRow = new Array(_this.LicenseRenewalDetails.length).fill(null);
            }
            _this.isLoading = false;
        });
    };
    RenewScal360LicenseComponent.prototype.blurSalesOrderEvent = function () {
        var _this = this;
        if (this.prevSalesOrderNo.trim().toUpperCase() == this.renewScal360LicenseForm.value.SalesOrderNo.trim().toUpperCase()) {
            return;
        }
        this.prevSalesOrderNo = this.renewScal360LicenseForm.value.SalesOrderNo;
        setTimeout(function () {
            _this.shouldFetchSalesOrderNo = true;
            _this.isBillingShippingDetailFetched = false;
        }, 150);
    };
    RenewScal360LicenseComponent.prototype.checkSalesOrderNo = function () {
        var _this = this;
        if (this.dialogData.Scal360LicenseData) {
            var exists = this.dialogData.Scal360LicenseData.some(function (element) {
                if (element != null) {
                    return _this.renewScal360LicenseForm.value.SalesOrderNo.toUpperCase().trim() == element.SalesOrderNo.toUpperCase().trim();
                }
                else {
                    return false;
                }
            });
            if (exists) {
                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    title: "This sales order no already exists",
                    text: "Are you sure you want to use this Sales Order No?",
                    showCancelButton: true,
                    showCloseButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#FFCA28",
                    cancelButtonText: "No",
                }).then(function (result) {
                    if (result.isConfirmed) {
                        _this.shouldFetchSalesOrderNo = true;
                        _this.isBillingShippingDetailFetched = false;
                        _this.getBillingShippingDetail();
                    }
                    else {
                        _this.shouldFetchSalesOrderNo = false;
                        _this.isBillingShippingDetailFetched = false;
                        _this.renewScal360LicenseForm.patchValue({
                            SalesOrderNo: ""
                        });
                    }
                });
            }
            else {
                this.shouldFetchSalesOrderNo = true;
                this.isBillingShippingDetailFetched = false;
                this.getBillingShippingDetail();
            }
        }
        else {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
            this.getBillingShippingDetail();
        }
    };
    RenewScal360LicenseComponent.prototype.getBillingShippingDetail = function () {
        var _this = this;
        var salesOrderNo = this.renewScal360LicenseForm.value.SalesOrderNo;
        if (salesOrderNo != '') {
            if (this.shouldFetchSalesOrderNo) {
                this.appLoader.open();
                this.licenseService.getBillingShippingDetail(salesOrderNo).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.billingShippingDetail = data.DataObject;
                        _this.isBillingShippingDetailFetched = true;
                        _this.error = '';
                    }
                    else {
                        _this.isBillingShippingDetailFetched = false;
                        _this.error = data.Error;
                    }
                    _this.appLoader.close();
                });
            }
            else {
                this.error = "Please select other sales order number.";
            }
        }
        else {
            this.error = "Sales Order No is required";
            this.isBillingShippingDetailFetched = false;
        }
    };
    RenewScal360LicenseComponent.prototype.onSave = function () {
        var _this = this;
        setTimeout(function () {
            for (var i = 0; i < _this.selectedRow.length; i++) {
                if (_this.selectedRow[i] != null) {
                    if (_this.LicenseRenewalDetails[i].RenewalUser > _this.LicenseRenewalDetails[i].NoOfUser) {
                        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                            title: 'Warning',
                            text: 'Renewal User cannot be greater than Number of Users.',
                            showConfirmButton: true,
                            confirmButtonColor: '#FFCA28'
                        });
                        _this.selectedLicenseDetailIdList = [];
                        _this.selectedNoOfUserRenewalList = [];
                        return;
                    }
                    _this.selectedLicenseDetailIdList.push(_this.LicenseRenewalDetails[i].LicenseDetailId);
                    _this.selectedNoOfUserRenewalList.push(_this.LicenseRenewalDetails[i].RenewalUser);
                }
            }
            if (_this.selectedLicenseDetailIdList.length == 0 || _this.selectedNoOfUserRenewalList.length == 0) {
                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    title: 'Warning',
                    text: 'Please select atleast one license.',
                    showConfirmButton: true,
                    confirmButtonColor: '#FFCA28'
                });
                return;
            }
            else if (!_this.isBillingShippingDetailFetched) {
                _this.error = "Please fetch the customer billing and shipping details!";
                _this.selectedLicenseDetailIdList = [];
                _this.selectedNoOfUserRenewalList = [];
                return;
            }
            _this.appLoader.open();
            _this.licenseService.addBillingShippingDetail(_this.billingShippingDetail).subscribe(function (respData) {
                if (!respData.IsError && respData.DataObject != null) {
                    _this.customerId = respData.DataObject.CustomerId;
                    _this.shippingAddressId = respData.DataObject.ShippingAddressId;
                    var model = {
                        LicenseDetailId: _this.selectedLicenseDetailIdList,
                        NoOfUserRenewal: _this.selectedNoOfUserRenewalList,
                        LicenseId: _this.SelectedCustomerLicenseDetail.LicenseId,
                        RenewType: _this.renewScal360LicenseForm.value.RenewalType,
                        SupportValidityMonths: _this.renewScal360LicenseForm.value.SupportValidityYear,
                        SCALType: _this.SelectedCustomerLicenseDetail.SCALType,
                        PurchaseInvoiceDate: _this.renewScal360LicenseForm.value.PurchaseDate,
                        SalesOrderNo: _this.renewScal360LicenseForm.value.SalesOrderNo,
                        CustomerId: _this.customerId,
                        ShippingAddressId: _this.shippingAddressId,
                        TotalNoOfUserLicenses: _this.SelectedCustomerLicenseDetail.TotalNoOfUserLicenses,
                        CreatedBy: Number(localStorage.getItem('userid')),
                        UpdatedBy: Number(localStorage.getItem('userid'))
                    };
                    _this.licenseService.renewScal360License(model).subscribe(function (data) {
                        if (!data.IsError && data.DataObject != null) {
                            _this.scal360LicenseDisplayList = data.DataObject;
                            _this.dialogRef.close(_this.scal360LicenseDisplayList);
                            _this.appLoader.close();
                            _this.snackBar.open("License renewed successfully!", "", {
                                duration: 2000
                            });
                        }
                    });
                }
            });
        }, 300);
    };
    RenewScal360LicenseComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.scal360LicenseDisplayList);
    };
    RenewScal360LicenseComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'renew-scal360-license',
            template: __webpack_require__(1043),
            styles: [__webpack_require__(980)]
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_4__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_7__angular_router__["a" /* Router */], Object])
    ], RenewScal360LicenseComponent);
    return RenewScal360LicenseComponent;
}());



/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewScal360ActivationHistoryComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interfaces_LicenseModel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__ = __webpack_require__(6);








var ViewScal360ActivationHistoryComponent = /** @class */ (function () {
    function ViewScal360ActivationHistoryComponent(licenseService, dialogRef, appLoader, adalService, router, dialogData) {
        this.licenseService = licenseService;
        this.dialogRef = dialogRef;
        this.appLoader = appLoader;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'View SCAL 360 Activation History';
        this.errorMessage = '';
        this.SCALTypeEnum = __WEBPACK_IMPORTED_MODULE_3__interfaces_LicenseModel__["g" /* SCALType */];
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.scal360LicenseDisplayList = this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail = this.dialogData.SelectedLicenseDetail;
        this.getScal360ActivationHistory();
    }
    ViewScal360ActivationHistoryComponent.prototype.getScal360ActivationHistory = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.viewScal360ActivationHistory(this.SelectedCustomerLicenseDetail.LicenseDetailId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.Scal360ActivationHistory = data.DataObject;
            }
            else {
                _this.errorMessage = data.Error;
            }
            _this.isLoading = false;
        });
    };
    ViewScal360ActivationHistoryComponent.prototype.deleteActivation = function (row) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
            title: "Delete Activated User",
            text: "Are you sure you want to delete this activated user?",
            showCancelButton: true,
            showCloseButton: true,
            showConfirmButton: true,
            confirmButtonColor: '#FFCA28',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(function (result) {
            if (result.isConfirmed) {
                _this.appLoader.open();
                var model = {
                    LicenseDetailId: row.LicenseDetailId,
                    ActivationId: row.ActivationId,
                    UpdatedBy: Number(localStorage.getItem('userid'))
                };
                _this.licenseService.deleteScal360ActivationKey(model).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.scal360LicenseDisplayList = data.DataObject;
                        _this.SelectedCustomerLicenseDetail.NoOfLicenseActivated--;
                        _this.dialogRef.close(_this.scal360LicenseDisplayList);
                    }
                    _this.appLoader.close();
                });
            }
        });
    };
    ViewScal360ActivationHistoryComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.scal360LicenseDisplayList);
    };
    ViewScal360ActivationHistoryComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1045),
            styles: [__webpack_require__(982)],
            selector: 'view-scal360-activation-history'
        }),
        __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_6__angular_router__["a" /* Router */], Object])
    ], ViewScal360ActivationHistoryComponent);
    return ViewScal360ActivationHistoryComponent;
}());



/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewScal360DownloadReleaseHistoryComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interfaces_LicenseModel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);






var ViewScal360DownloadReleaseHistoryComponent = /** @class */ (function () {
    function ViewScal360DownloadReleaseHistoryComponent(licenseService, dialogRef, adalService, router, dialogData) {
        this.licenseService = licenseService;
        this.dialogRef = dialogRef;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'View SCAL 360 Download Release History';
        this.errorMessage = '';
        this.SCALTypeEnum = __WEBPACK_IMPORTED_MODULE_3__interfaces_LicenseModel__["g" /* SCALType */];
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.scal360LicenseDisplayList = this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail = this.dialogData.SelectedLicenseDetail;
        this.getScal360DownloadReleaseHistory();
    }
    ViewScal360DownloadReleaseHistoryComponent.prototype.getScal360DownloadReleaseHistory = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.viewScalDownloadReleaseHistory(this.SelectedCustomerLicenseDetail.LicenseKey).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.Scal360DownloadReleaseHistory = data.DataObject;
            }
            else {
                _this.errorMessage = data.Error;
            }
            _this.isLoading = false;
        });
    };
    ViewScal360DownloadReleaseHistoryComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.scal360LicenseDisplayList);
    };
    ViewScal360DownloadReleaseHistoryComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1046),
            styles: [__webpack_require__(983)],
            selector: 'view-scal360-download-release-history'
        }),
        __param(4, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */], Object])
    ], ViewScal360DownloadReleaseHistoryComponent);
    return ViewScal360DownloadReleaseHistoryComponent;
}());



/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewScal360LicenseInformationComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__ = __webpack_require__(6);








var ViewScal360LicenseInformationComponent = /** @class */ (function () {
    function ViewScal360LicenseInformationComponent(dialogRef, formBuilder, licenseService, appLoader, snackBar, adalService, router, dialogData) {
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'SCAL 360 License Information';
        this.errorMessage = '';
        this.isRadioButtonDisabled = false;
        this.selectedRow = null;
        this.SCALTypeEnum = __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__["g" /* SCALType */];
        this.billingShippingDetail = {
            ODataEtag: '',
            Number: '',
            publicId: '',
            CustomerNo: '',
            publicSalesPersoncode: '',
            BillToName: '',
            BillToAddress1: '',
            BillToAddress2: '',
            BillToCity: '',
            BillToState: '',
            BillToZipcode: '',
            BillToCountryCode: '',
            ShipToCode: '',
            ShipToName: '',
            ShipToAddress1: '',
            ShipToAddress2: '',
            ShipToCity: '',
            ShipToState: '',
            ShipToZipcode: '',
            ShipToCountryCode: '',
            CustomerTelephone: '',
            CustomerEmailAddress: '',
            CustomerFaxno: '',
            ShippingTelephoneno: '',
            ShippingFaxno: '',
            ShippingEmailAddress: '',
            Rep1: '',
            Rep2: '',
            Sales1: '',
            Sales2: ''
        };
        this.customerId = 0;
        this.shippingAddressId = 0;
        this.shouldFetchSalesOrderNo = false;
        this.error = "";
        this.SCALTypeList = [];
        this.SelectedLicenseKey = '';
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.scal360LicenseDisplayList = this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail = this.dialogData.SelectedLicenseDetail;
        this.getScalCustomerLicenseDetail();
        this.billingShippingDetail.BillToName = this.SelectedCustomerLicenseDetail.BillToName;
        this.billingShippingDetail.BillToAddress1 = this.SelectedCustomerLicenseDetail.BillToAddress1;
        this.billingShippingDetail.BillToAddress2 = this.SelectedCustomerLicenseDetail.BillToAddress2;
        this.billingShippingDetail.BillToCity = this.SelectedCustomerLicenseDetail.BillToCity;
        this.billingShippingDetail.ShipToName = this.SelectedCustomerLicenseDetail.ShipToName;
        this.billingShippingDetail.ShipToAddress1 = this.SelectedCustomerLicenseDetail.ShipToAddress1;
        this.billingShippingDetail.ShipToAddress2 = this.SelectedCustomerLicenseDetail.ShipToAddress2;
        this.billingShippingDetail.ShipToCity = this.SelectedCustomerLicenseDetail.ShipToCity;
        this.billingShippingDetail.ShipToState = this.SelectedCustomerLicenseDetail.ShipToState;
    }
    ViewScal360LicenseInformationComponent.prototype.getScalCustomerLicenseDetail = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.getScal360CustomerLicenseDetail(this.SelectedCustomerLicenseDetail.LicenseId).subscribe(function (data) {
            if (!data.Error && data.DataObject != null) {
                _this.LicenseDetails = data.DataObject;
            }
            _this.isLoading = false;
        });
    };
    ViewScal360LicenseInformationComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.scal360LicenseDisplayList);
    };
    ViewScal360LicenseInformationComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1047),
            styles: [__webpack_require__(984)],
            selector: 'view-scal360-license-information'
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_2__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_6__angular_router__["a" /* Router */], Object])
    ], ViewScal360LicenseInformationComponent);
    return ViewScal360LicenseInformationComponent;
}());



/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewScal360PurchaseHistoryComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interfaces_LicenseModel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);






var ViewScal360PurchaseHistoryComponent = /** @class */ (function () {
    function ViewScal360PurchaseHistoryComponent(licenseService, dialogRef, dialogData, adalService, router) {
        this.licenseService = licenseService;
        this.dialogRef = dialogRef;
        this.dialogData = dialogData;
        this.adalService = adalService;
        this.router = router;
        this.dialogTitle = 'View SCAL 360 Purchase History';
        this.errorMessage = '';
        this.SCALTypeEnum = __WEBPACK_IMPORTED_MODULE_3__interfaces_LicenseModel__["g" /* SCALType */];
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.scal360LicenseDisplayList = this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail = this.dialogData.SelectedLicenseDetail;
        this.getScal360PurchaseHistory();
    }
    ViewScal360PurchaseHistoryComponent.prototype.getScal360PurchaseHistory = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.viewScal360PurchaseHistory(this.SelectedCustomerLicenseDetail.LicenseId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.Scal360PurchaseHistory = data.DataObject;
            }
            else {
                _this.errorMessage = data.Error;
            }
            _this.isLoading = false;
        });
    };
    ViewScal360PurchaseHistoryComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.scal360LicenseDisplayList);
    };
    ViewScal360PurchaseHistoryComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1048),
            styles: [__webpack_require__(985)],
            selector: 'view-scal360-purchase-history'
        }),
        __param(2, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */], Object, __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */]])
    ], ViewScal360PurchaseHistoryComponent);
    return ViewScal360PurchaseHistoryComponent;
}());



/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewScal360RenewalHistoryComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__interfaces_LicenseModel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);






var ViewScal360RenewalHistoryComponent = /** @class */ (function () {
    function ViewScal360RenewalHistoryComponent(licenseService, dialogRef, adalService, router, dialogData) {
        this.licenseService = licenseService;
        this.dialogRef = dialogRef;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'View SCAL 360 Renewal History';
        this.errorMessage = '';
        this.SCALTypeEnum = __WEBPACK_IMPORTED_MODULE_3__interfaces_LicenseModel__["g" /* SCALType */];
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        else {
            this.scal360LicenseDisplayList = this.dialogData.Scal360LicenseData;
            this.SelectedCustomerLicenseDetail = this.dialogData.SelectedLicenseDetail;
            this.getScal360LicenseRenewalHistory();
        }
    }
    ViewScal360RenewalHistoryComponent.prototype.getScal360LicenseRenewalHistory = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.getScalLicenseRenewalHistory(this.SelectedCustomerLicenseDetail.LicenseDetailId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.Scal360LicenseRenewalHistory = data.DataObject;
            }
            else {
                _this.errorMessage = data.Error;
            }
            _this.isLoading = false;
        });
    };
    ViewScal360RenewalHistoryComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.scal360LicenseDisplayList);
    };
    ViewScal360RenewalHistoryComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1049),
            styles: [__webpack_require__(986)],
            selector: 'view-scal360-renewal-history'
        }),
        __param(4, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */], Object])
    ], ViewScal360RenewalHistoryComponent);
    return ViewScal360RenewalHistoryComponent;
}());



/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenerateService360LicenseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__ = __webpack_require__(6);








var GenerateService360LicenseComponent = /** @class */ (function () {
    function GenerateService360LicenseComponent(dialogRef, formBuilder, licenseService, appLoader, snackBar, adalService, router, dialogData) {
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = '';
        this.errorMessage = '';
        this.billingShippingDetail = {
            ODataEtag: '',
            Number: '',
            publicId: '',
            CustomerNo: '',
            publicSalesPersoncode: '',
            BillToName: '',
            BillToAddress1: '',
            BillToAddress2: '',
            BillToCity: '',
            BillToState: '',
            BillToZipcode: '',
            BillToCountryCode: '',
            ShipToCode: '',
            ShipToName: '',
            ShipToAddress1: '',
            ShipToAddress2: '',
            ShipToCity: '',
            ShipToState: '',
            ShipToZipcode: '',
            ShipToCountryCode: '',
            CustomerTelephone: '',
            CustomerEmailAddress: '',
            CustomerFaxno: '',
            ShippingTelephoneno: '',
            ShippingFaxno: '',
            ShippingEmailAddress: '',
            Rep1: '',
            Rep2: '',
            Sales1: '',
            Sales2: ''
        };
        this.isBillingShippingDetailFetched = false;
        this.customerId = 0;
        this.shippingAddressId = 0;
        this.shouldFetchSalesOrderNo = false;
        this.error = "";
        this.prevSalesOrderNo = '';
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.buildForm();
        this.Service360LicenseDisplayList = this.dialogData.Service360LicenseData;
        this.SelectedLicenseDetail = this.dialogData.SelectedLicenseDetail;
        if (this.SelectedLicenseDetail) {
            this.dialogTitle = "Edit License Request";
            this.service360LicenseForm.patchValue({
                NoOfInstallation: this.SelectedLicenseDetail.NoOfInstallation,
                SalesOrderNo: this.SelectedLicenseDetail.SalesOrderNo,
            });
            this.isBillingShippingDetailFetched = true;
            this.prevSalesOrderNo = this.SelectedLicenseDetail.SalesOrderNo;
            this.billingShippingDetail.BillToName = this.SelectedLicenseDetail.BillToName;
            this.billingShippingDetail.BillToAddress1 = this.SelectedLicenseDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2 = this.SelectedLicenseDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity = this.SelectedLicenseDetail.BillToCity;
            this.billingShippingDetail.ShipToName = this.SelectedLicenseDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1 = this.SelectedLicenseDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2 = this.SelectedLicenseDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity = this.SelectedLicenseDetail.ShipToCity;
            this.billingShippingDetail.ShipToState = this.SelectedLicenseDetail.ShipToState;
        }
        else {
            this.dialogTitle = 'Generate New License Request';
        }
    }
    GenerateService360LicenseComponent.prototype.buildForm = function () {
        this.service360LicenseForm = this.formBuilder.group({
            NoOfInstallation: [, [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].max(100)]],
            SalesOrderNo: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]]
        });
    };
    GenerateService360LicenseComponent.prototype.blurSalesOrderEvent = function () {
        var _this = this;
        if (this.prevSalesOrderNo.trim().toUpperCase() == this.service360LicenseForm.value.SalesOrderNo.trim().toUpperCase()) {
            return;
        }
        this.prevSalesOrderNo = this.service360LicenseForm.value.SalesOrderNo;
        setTimeout(function () {
            _this.shouldFetchSalesOrderNo = true;
            _this.isBillingShippingDetailFetched = false;
        }, 150);
    };
    GenerateService360LicenseComponent.prototype.checkSalesOrderNo = function () {
        var _this = this;
        if (this.dialogData.Service360LicenseData) {
            var exist = this.dialogData.Service360LicenseData.some(function (element) {
                if (element.SalesOrderNo != null) {
                    return _this.service360LicenseForm.value.SalesOrderNo.trim().toUpperCase() == element.SalesOrderNo.trim().toUpperCase();
                }
                else {
                    return false;
                }
            });
            if (exist) {
                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                    title: "This sales order no already exists",
                    text: "Are you sure you want to use this Sales Order No?",
                    showCancelButton: true,
                    showCloseButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#FFCA28",
                    cancelButtonText: "No",
                }).then(function (result) {
                    if (result.isConfirmed) {
                        _this.shouldFetchSalesOrderNo = true;
                        _this.isBillingShippingDetailFetched = false;
                        _this.getBillingShippingDetail();
                    }
                    else {
                        _this.shouldFetchSalesOrderNo = false;
                        _this.isBillingShippingDetailFetched = false;
                        _this.service360LicenseForm.patchValue({
                            SalesOrderNo: ""
                        });
                    }
                });
            }
            else {
                this.shouldFetchSalesOrderNo = true;
                this.isBillingShippingDetailFetched = false;
                this.getBillingShippingDetail();
            }
        }
        else {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
            this.getBillingShippingDetail();
        }
    };
    GenerateService360LicenseComponent.prototype.getBillingShippingDetail = function () {
        var _this = this;
        var salesOrderNo = this.service360LicenseForm.value.SalesOrderNo;
        console.log(salesOrderNo);
        if (salesOrderNo != '') {
            if (this.shouldFetchSalesOrderNo) {
                this.appLoader.open();
                this.licenseService.getBillingShippingDetail(salesOrderNo).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.billingShippingDetail = data.DataObject;
                        _this.isBillingShippingDetailFetched = true;
                        _this.error = '';
                    }
                    else {
                        _this.isBillingShippingDetailFetched = false;
                        _this.error = data.Error;
                    }
                    _this.appLoader.close();
                });
            }
            else {
                this.error = "Please select other sales order number.";
            }
        }
        else {
            this.error = "Sales Order No is required";
            this.isBillingShippingDetailFetched = false;
        }
    };
    GenerateService360LicenseComponent.prototype.onSave = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.isBillingShippingDetailFetched) {
                _this.error = "Please fetch the customer billing and shipping details!";
                return;
            }
            if (_this.SelectedLicenseDetail != null) {
                _this.appLoader.open();
                if (_this.SelectedLicenseDetail.SalesOrderNo != _this.service360LicenseForm.value.SalesOrderNo) {
                    _this.licenseService.addBillingShippingDetail(_this.billingShippingDetail).subscribe(function (response) {
                        if (!response.IsError && response.DataObject != null) {
                            var model = {
                                LicenseId: _this.SelectedLicenseDetail.LicenseId,
                                CustomerId: response.DataObject.CustomerId,
                                ShippingAddressId: response.DataObject.ShippingAddressId,
                                NoOfInstallation: _this.service360LicenseForm.value.NoOfInstallation,
                                SalesOrderNo: _this.service360LicenseForm.value.SalesOrderNo,
                                UpdatedBy: Number(localStorage.getItem('userid'))
                            };
                            _this.licenseService.updateService360License(model).subscribe(function (data) {
                                if (!data.IsError && data.DataObject != null) {
                                    _this.Service360LicenseDisplayList = data.DataObject;
                                    _this.dialogRef.close(_this.Service360LicenseDisplayList);
                                    _this.appLoader.close();
                                    _this.snackBar.open("License Updated successfully!", "", {
                                        duration: 2000
                                    });
                                }
                                else {
                                    _this.appLoader.close();
                                    _this.dialogRef.close(_this.Service360LicenseDisplayList);
                                }
                            });
                        }
                    });
                }
                else {
                    var model = {
                        LicenseId: _this.SelectedLicenseDetail.LicenseId,
                        CustomerId: _this.SelectedLicenseDetail.CustomerId,
                        ShippingAddressId: _this.SelectedLicenseDetail.ShippingAddressId,
                        NoOfInstallation: _this.service360LicenseForm.value.NoOfInstallation,
                        SalesOrderNo: _this.service360LicenseForm.value.SalesOrderNo,
                        UpdatedBy: Number(localStorage.getItem('userid'))
                    };
                    _this.licenseService.updateService360License(model).subscribe(function (data) {
                        if (!data.IsError && data.DataObject != null) {
                            _this.Service360LicenseDisplayList = data.DataObject;
                            _this.dialogRef.close(_this.Service360LicenseDisplayList);
                            _this.appLoader.close();
                            _this.snackBar.open("License Updated successfully!", "", {
                                duration: 2000
                            });
                        }
                        else {
                            _this.appLoader.close();
                            _this.dialogRef.close(_this.Service360LicenseDisplayList);
                        }
                    });
                }
            }
            else {
                _this.appLoader.open();
                _this.licenseService.addBillingShippingDetail(_this.billingShippingDetail).subscribe(function (data) {
                    var model = {
                        CustomerId: data.DataObject.CustomerId,
                        ShippingAddressId: data.DataObject.ShippingAddressId,
                        NoOfInstallation: _this.service360LicenseForm.value.NoOfInstallation,
                        SalesOrderNo: _this.service360LicenseForm.value.SalesOrderNo,
                        CreatedBy: Number(localStorage.getItem('userid')),
                        UpdatedBy: Number(localStorage.getItem('userid'))
                    };
                    if (!data.IsError && data.DataObject != null) {
                        _this.customerId = data.DataObject.CustomerId;
                        _this.shippingAddressId = data.DataObject.ShippingAddressId;
                        _this.licenseService.generateService360License(model).subscribe(function (data) {
                            if (!data.IsError && data.DataObject != null) {
                                _this.Service360LicenseDisplayList = data.DataObject;
                                _this.appLoader.close();
                                _this.dialogRef.close(_this.Service360LicenseDisplayList);
                                _this.snackBar.open("License generated successfully!", "", {
                                    duration: 2000
                                });
                            }
                            else {
                                _this.appLoader.close();
                                _this.dialogRef.close(_this.Service360LicenseDisplayList);
                            }
                        });
                    }
                });
            }
        }, 300);
    };
    GenerateService360LicenseComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.Service360LicenseDisplayList);
    };
    GenerateService360LicenseComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1050),
            styles: [__webpack_require__(987)],
            selector: 'generate-service360-license'
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_6__angular_router__["a" /* Router */], Object])
    ], GenerateService360LicenseComponent);
    return GenerateService360LicenseComponent;
}());



/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Service360FilterPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var Service360FilterPipe = /** @class */ (function () {
    function Service360FilterPipe() {
    }
    Service360FilterPipe.prototype.transform = function (info, filterBillToName, filterShipToName, filterLicenseKey) {
        if (info.length === 0 || (filterBillToName == '' && filterShipToName == '' && filterLicenseKey == '')) {
            return info;
        }
        else {
            return info.filter(function (item) {
                if (filterBillToName != '' && filterShipToName != '' && filterLicenseKey != '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && item.ShipToName.toLowerCase() === filterShipToName.toLowerCase() && item.LicenseKey.toLowerCase() === filterLicenseKey.toLowerCase());
                }
                else if (filterBillToName == '' && filterShipToName != '' && filterLicenseKey != '') {
                    return (item.ShipToName.toLowerCase() === filterShipToName.toLowerCase() && item.LicenseKey.toLowerCase() === filterLicenseKey.toLowerCase());
                }
                else if (filterBillToName != '' && filterShipToName == '' && filterLicenseKey != '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && item.LicenseKey.toLowerCase() === filterLicenseKey.toLowerCase());
                }
                else if (filterBillToName != '' && filterShipToName != '' && filterLicenseKey == '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && item.ShipToName.toLowerCase() === filterShipToName.toLowerCase());
                }
                else if (filterBillToName == '' && filterShipToName == '' && filterLicenseKey != '') {
                    return (item.LicenseKey.toLowerCase() === filterLicenseKey.toLowerCase());
                }
                else if (filterBillToName != '' && filterShipToName == '' && filterLicenseKey == '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase());
                }
                else if (filterBillToName == '' && filterShipToName != '' && filterLicenseKey == '') {
                    return (item.ShipToName.toLowerCase() === filterShipToName.toLowerCase());
                }
            });
        }
    };
    Service360FilterPipe = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
            name: 'Service360FilterPipe',
        })
    ], Service360FilterPipe);
    return Service360FilterPipe;
}());



/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Service360ViewActivationDetailComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);






var Service360ViewActivationDetailComponent = /** @class */ (function () {
    function Service360ViewActivationDetailComponent(licenseService, appLoader, dialogRef, adalService, router, dialogData) {
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.dialogRef = dialogRef;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'View License Activation Details';
        this.errorMessage = '';
        this.error = '';
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.SelectedLicenseDetail = this.dialogData.SelectedLicenseDetail;
        this.getActivationDetails();
    }
    Service360ViewActivationDetailComponent.prototype.getActivationDetails = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.viewService360ActivationHistory(this.SelectedLicenseDetail.LicenseId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.ActivationDetail = data.DataObject;
                _this.error = '';
            }
            else {
                _this.error = data.Error;
            }
            _this.isLoading = false;
        });
    };
    Service360ViewActivationDetailComponent.prototype.onCancel = function () {
        this.dialogRef.close();
    };
    Service360ViewActivationDetailComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'service360-view-activation-details',
            styles: [__webpack_require__(988)],
            template: __webpack_require__(1051)
        }),
        __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_3__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */], Object])
    ], Service360ViewActivationDetailComponent);
    return Service360ViewActivationDetailComponent;
}());



/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssignSmartCal360NCustomerComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pipes_smartcal360AssignCustomerPipe__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_PagerService__ = __webpack_require__(36);









var AssignSmartCal360NCustomerComponent = /** @class */ (function () {
    function AssignSmartCal360NCustomerComponent(licenseService, dialogRef, appLoader, adalService, router, filterPipe, pagerService, dialogData) {
        this.licenseService = licenseService;
        this.dialogRef = dialogRef;
        this.appLoader = appLoader;
        this.adalService = adalService;
        this.router = router;
        this.filterPipe = filterPipe;
        this.pagerService = pagerService;
        this.dialogData = dialogData;
        this.dialogTitle = 'Assign Customer';
        this.filteredCustomerDetailsList = [];
        this.errorMessage = '';
        this.isLoading = false;
        this.BillToList = [];
        this.searchCustomerName = '';
        this.pager = {};
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.SelectedLicenseIdList = dialogData.SelectedLicensesId;
        this.SmartCal360NLicenseData = dialogData.SmartCal360NLicenseData;
        this.getAllCustomersDetails();
    }
    AssignSmartCal360NCustomerComponent.prototype.getAllCustomersDetails = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.getAllCustomersDetail().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.originalCustomerDetailList = data.DataObject;
                _this.customerDetailList = _this.originalCustomerDetailList.slice();
                _this.buildSearchArray();
                _this.setPage(1);
            }
            else {
                _this.errorMessage = data.Error;
            }
            _this.isLoading = false;
        });
    };
    AssignSmartCal360NCustomerComponent.prototype.buildSearchArray = function () {
        var BillToArray = this.customerDetailList.map(function (item) { return item.BillToName; });
        this.BillToList = Array.from(new Set(BillToArray)).sort();
    };
    AssignSmartCal360NCustomerComponent.prototype.search = function () {
        this.setPage(1);
    };
    AssignSmartCal360NCustomerComponent.prototype.clear = function () {
        this.searchCustomerName = '';
        this.setPage(1);
    };
    AssignSmartCal360NCustomerComponent.prototype.setPage = function (page) {
        this.customerDetailList = this.originalCustomerDetailList.slice();
        this.applySort();
        this.filteredCustomerDetailsList = this.filterPipe.transform(this.customerDetailList, this.searchCustomerName);
        this.pager = this.pagerService.getPager(this.filteredCustomerDetailsList.length, page, 5);
        this.pagedItems = this.filteredCustomerDetailsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
        this.errorMessage = (this.pagedItems.length == 0) ? "No records found." : "";
    };
    AssignSmartCal360NCustomerComponent.prototype.assignCustomer = function (row) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
            title: 'Assign Customer',
            text: 'Are you sure you want to assign selected license to this customer?',
            showCloseButton: true,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonColor: '#FFCA28',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(function (result) {
            if (result.isConfirmed) {
                _this.appLoader.open();
                _this.licenseService.addBillingShippingDetail(row).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        var model = {
                            SmartCal360NLicenseIdList: _this.SelectedLicenseIdList,
                            CustomerId: data.DataObject.CustomerId,
                            UpdatedBy: Number(localStorage.getItem('userid'))
                        };
                        _this.licenseService.updateSmarCal360NLicense(model).subscribe(function (data) {
                            if (!data.IsError && data.DataObject != null) {
                                _this.SmartCal360NLicenseData = data.DataObject;
                            }
                            _this.appLoader.close();
                            _this.dialogRef.close(_this.SmartCal360NLicenseData);
                        });
                    }
                });
            }
        });
    };
    AssignSmartCal360NCustomerComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.SmartCal360NLicenseData);
    };
    AssignSmartCal360NCustomerComponent.prototype.onSortChange = function (event) {
        this.currentSortColumn = event.column;
        this.currentSortOrder = event.order;
        this.setPage(this.pager.currentPage);
    };
    AssignSmartCal360NCustomerComponent.prototype.applySort = function () {
        var _this = this;
        if (!this.currentSortColumn || !this.currentSortOrder)
            return;
        this.customerDetailList = this.customerDetailList.sort(function (a, b) {
            if (_this.currentSortOrder === 'asc') {
                a[_this.currentSortColumn] = a[_this.currentSortColumn] || '';
                return a[_this.currentSortColumn].localeCompare(b[_this.currentSortColumn]);
            }
            else if (_this.currentSortOrder === 'desc') {
                b[_this.currentSortColumn] = b[_this.currentSortColumn] || '';
                return b[_this.currentSortColumn].localeCompare(a[_this.currentSortColumn]);
            }
            else {
                return 0;
            }
        });
    };
    AssignSmartCal360NCustomerComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1053),
            styles: [__webpack_require__(990)],
            selector: 'assign-smartcal360n-customer'
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_5__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_7__pipes_smartcal360AssignCustomerPipe__["a" /* SmartCal360AssignCustomerFilterPipe */],
            __WEBPACK_IMPORTED_MODULE_8__services_PagerService__["a" /* PagerService */], Object])
    ], AssignSmartCal360NCustomerComponent);
    return AssignSmartCal360NCustomerComponent;
}());



/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenerateSmartLink360LicenseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__ = __webpack_require__(6);








var GenerateSmartLink360LicenseComponent = /** @class */ (function () {
    function GenerateSmartLink360LicenseComponent(dialogRef, formBuilder, licenseService, appLoader, snackBar, adalService, router, dialogData) {
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'Generate New License Request';
        this.errorMessage = '';
        this.shouldFetchSalesOrderNo = true;
        this.error = '';
        this.billingShippingDetail = {
            ODataEtag: '',
            Number: '',
            publicId: '',
            CustomerNo: '',
            publicSalesPersoncode: '',
            BillToName: '',
            BillToAddress1: '',
            BillToAddress2: '',
            BillToCity: '',
            BillToState: '',
            BillToZipcode: '',
            BillToCountryCode: '',
            ShipToCode: '',
            ShipToName: '',
            ShipToAddress1: '',
            ShipToAddress2: '',
            ShipToCity: '',
            ShipToState: '',
            ShipToZipcode: '',
            ShipToCountryCode: '',
            CustomerTelephone: '',
            CustomerEmailAddress: '',
            CustomerFaxno: '',
            ShippingTelephoneno: '',
            ShippingFaxno: '',
            ShippingEmailAddress: '',
            Rep1: '',
            Rep2: '',
            Sales1: '',
            Sales2: ''
        };
        this.isBillingShippingDetailFetched = false;
        this.prevSalesOrderNo = '';
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.smartLink360PurchaseLicenseData = this.dialogData.Smartlink360PurchaseLicenseData;
        this.SelectedLicenseDetail = this.dialogData.SelectedLicenseDetail;
        this.buildForm();
        if (this.SelectedLicenseDetail) {
            this.dialogTitle = "Edit License Request";
            this.smartLink360LicenseForm.patchValue({
                PurchaseInvoiceDate: this.SelectedLicenseDetail.PurchaseDate.toString().split('T')[0],
                SupportValidityYear: this.SelectedLicenseDetail.NoOfMonths,
                SalesOrderNo: this.SelectedLicenseDetail.SalesOrderNo,
            });
            this.isBillingShippingDetailFetched = true;
            this.prevSalesOrderNo = this.SelectedLicenseDetail.SalesOrderNo;
            this.billingShippingDetail.BillToName = this.SelectedLicenseDetail.BillToName;
            this.billingShippingDetail.BillToAddress1 = this.SelectedLicenseDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2 = this.SelectedLicenseDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity = this.SelectedLicenseDetail.BillToCity;
            this.billingShippingDetail.ShipToName = this.SelectedLicenseDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1 = this.SelectedLicenseDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2 = this.SelectedLicenseDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity = this.SelectedLicenseDetail.ShipToCity;
            this.billingShippingDetail.ShipToState = this.SelectedLicenseDetail.ShipToState;
        }
        else {
            this.dialogTitle = 'Generate New License Request';
        }
    }
    GenerateSmartLink360LicenseComponent.prototype.buildForm = function () {
        this.smartLink360LicenseForm = this.formBuilder.group({
            PurchaseInvoiceDate: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]],
            SupportValidityYear: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]],
            SalesOrderNo: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]]
        });
    };
    GenerateSmartLink360LicenseComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.smartLink360PurchaseLicenseData);
    };
    GenerateSmartLink360LicenseComponent.prototype.blurSalesOrderEvent = function () {
        var _this = this;
        if (this.prevSalesOrderNo.trim().toUpperCase() == this.smartLink360LicenseForm.value.SalesOrderNo.trim().toUpperCase()) {
            return;
        }
        this.prevSalesOrderNo = this.smartLink360LicenseForm.value.SalesOrderNo;
        setTimeout(function () {
            _this.shouldFetchSalesOrderNo = true;
            _this.isBillingShippingDetailFetched = false;
        }, 150);
    };
    GenerateSmartLink360LicenseComponent.prototype.checkSalesOrderNo = function () {
        var _this = this;
        if (this.smartLink360PurchaseLicenseData) {
            var exist = this.smartLink360PurchaseLicenseData.some(function (element) {
                if (element.SalesOrderNo != null) {
                    return _this.smartLink360LicenseForm.value.SalesOrderNo.trim().toUpperCase() == element.SalesOrderNo.trim().toUpperCase();
                }
                else {
                    return false;
                }
            });
            if (exist) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    title: "This sales order no already exists",
                    text: "Are you sure you want to use this Sales Order No?",
                    showCancelButton: true,
                    showCloseButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#FFCA28",
                    cancelButtonText: "No",
                }).then(function (result) {
                    if (result.isConfirmed) {
                        _this.shouldFetchSalesOrderNo = true;
                        _this.isBillingShippingDetailFetched = false;
                        _this.getBillingShippingDetail();
                    }
                    else {
                        _this.shouldFetchSalesOrderNo = false;
                        _this.smartLink360LicenseForm.patchValue({
                            SalesOrderNo: ""
                        });
                    }
                });
            }
            else {
                this.shouldFetchSalesOrderNo = true;
                this.isBillingShippingDetailFetched = false;
                this.getBillingShippingDetail();
            }
        }
        else {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
            this.getBillingShippingDetail();
        }
    };
    GenerateSmartLink360LicenseComponent.prototype.getBillingShippingDetail = function () {
        var _this = this;
        var salesOrderNo = this.smartLink360LicenseForm.value.SalesOrderNo;
        if (salesOrderNo != '') {
            if (this.shouldFetchSalesOrderNo) {
                this.appLoader.open();
                this.licenseService.getBillingShippingDetail(salesOrderNo).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.billingShippingDetail = data.DataObject;
                        _this.isBillingShippingDetailFetched = true;
                        _this.error = '';
                    }
                    else {
                        _this.isBillingShippingDetailFetched = false;
                        _this.error = data.Error;
                    }
                    _this.appLoader.close();
                });
            }
            else {
                this.error = "Please select other sales order number.";
            }
        }
        else {
            this.error = "Sales Order No is required";
            this.isBillingShippingDetailFetched = false;
        }
    };
    GenerateSmartLink360LicenseComponent.prototype.onSave = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.isBillingShippingDetailFetched) {
                _this.error = "Please fetch the customer billing and shipping details!";
                return;
            }
            if (_this.SelectedLicenseDetail != null) {
                if (_this.SelectedLicenseDetail.SalesOrderNo != _this.smartLink360LicenseForm.value.SalesOrderNo) {
                    _this.appLoader.open();
                    _this.licenseService.addBillingShippingDetail(_this.billingShippingDetail).subscribe(function (data) {
                        if (data.DataObject != null && !data.IsError) {
                            var model = {
                                LicenseId: _this.SelectedLicenseDetail.LicenseId,
                                CustomerId: data.DataObject.CustomerId,
                                ShippingAddressId: data.DataObject.ShippingAddressId,
                                PurchaseInvoiceDate: _this.smartLink360LicenseForm.value.PurchaseInvoiceDate,
                                SupportValidityYear: _this.smartLink360LicenseForm.value.SupportValidityYear,
                                SalesOrderNo: _this.smartLink360LicenseForm.value.SalesOrderNo
                            };
                            _this.licenseService.updateSmartLink360License(model).subscribe(function (data) {
                                if (!data.IsError && data.DataObject != null) {
                                    _this.smartLink360PurchaseLicenseData = data.DataObject;
                                    _this.dialogRef.close(_this.smartLink360PurchaseLicenseData);
                                    _this.appLoader.close();
                                    _this.snackBar.open("License Updated successfully!", "", {
                                        duration: 2000
                                    });
                                }
                                else {
                                    _this.appLoader.close();
                                    _this.dialogRef.close(_this.smartLink360PurchaseLicenseData);
                                }
                            });
                        }
                    });
                }
                else {
                    var model = {
                        LicenseId: _this.SelectedLicenseDetail.LicenseId,
                        CustomerId: _this.SelectedLicenseDetail.CustomerId,
                        ShippingAddressId: _this.SelectedLicenseDetail.ShippingAddressId,
                        PurchaseInvoiceDate: _this.smartLink360LicenseForm.value.PurchaseInvoiceDate,
                        SupportValidityYear: _this.smartLink360LicenseForm.value.SupportValidityYear,
                        SalesOrderNo: _this.smartLink360LicenseForm.value.SalesOrderNo
                    };
                    _this.appLoader.open();
                    _this.licenseService.updateSmartLink360License(model).subscribe(function (data) {
                        if (!data.IsError && data.DataObject != null) {
                            _this.smartLink360PurchaseLicenseData = data.DataObject;
                            _this.dialogRef.close(_this.smartLink360PurchaseLicenseData);
                            _this.appLoader.close();
                            _this.snackBar.open("License Updated successfully!", "", {
                                duration: 2000
                            });
                        }
                        else {
                            _this.appLoader.close();
                            _this.dialogRef.close(_this.smartLink360PurchaseLicenseData);
                        }
                    });
                }
            }
            else {
                _this.appLoader.open();
                _this.licenseService.addBillingShippingDetail(_this.billingShippingDetail).subscribe(function (data) {
                    var model = {
                        CustomerId: data.DataObject.CustomerId,
                        ShippingAddressId: data.DataObject.ShippingAddressId,
                        PurchaseInvoiceDate: _this.smartLink360LicenseForm.value.PurchaseInvoiceDate,
                        SupportValidityYear: _this.smartLink360LicenseForm.value.SupportValidityYear,
                        SalesOrderNo: _this.smartLink360LicenseForm.value.SalesOrderNo,
                    };
                    if (!data.IsError && data.DataObject != null) {
                        _this.licenseService.generateSmartLink360License(model).subscribe(function (data) {
                            if (!data.IsError && data.DataObject != null) {
                                _this.smartLink360PurchaseLicenseData = data.DataObject;
                                _this.appLoader.close();
                                _this.dialogRef.close(_this.smartLink360PurchaseLicenseData);
                                _this.snackBar.open("License generated successfully!", "", {
                                    duration: 2000
                                });
                            }
                            else {
                                _this.appLoader.close();
                                _this.dialogRef.close(_this.smartLink360PurchaseLicenseData);
                                _this.snackBar.open(data.Error, "", {
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        }, 300);
    };
    GenerateSmartLink360LicenseComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1055),
            styles: [__webpack_require__(992)],
            selector: 'generate-smartlink360-license'
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_4__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_6__angular_router__["a" /* Router */], Object])
    ], GenerateSmartLink360LicenseComponent);
    return GenerateSmartLink360LicenseComponent;
}());



/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Smartlink360RenewLicenseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__ = __webpack_require__(6);









var Smartlink360RenewLicenseComponent = /** @class */ (function () {
    function Smartlink360RenewLicenseComponent(dialogRef, formBuilder, licenseService, appLoader, snackBar, adalService, router, dialogData) {
        var _this = this;
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.renewalType = __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__["f" /* SCALRenewalType */];
        this.dialogTitle = 'Renew Smart Link 360 License';
        this.errorMessage = '';
        this.isRadioButtonDisabled = false;
        this.billingShippingDetail = {
            ODataEtag: '',
            Number: '',
            publicId: '',
            CustomerNo: '',
            publicSalesPersoncode: '',
            BillToName: '',
            BillToAddress1: '',
            BillToAddress2: '',
            BillToCity: '',
            BillToState: '',
            BillToZipcode: '',
            BillToCountryCode: '',
            ShipToCode: '',
            ShipToName: '',
            ShipToAddress1: '',
            ShipToAddress2: '',
            ShipToCity: '',
            ShipToState: '',
            ShipToZipcode: '',
            ShipToCountryCode: '',
            CustomerTelephone: '',
            CustomerEmailAddress: '',
            CustomerFaxno: '',
            ShippingTelephoneno: '',
            ShippingFaxno: '',
            ShippingEmailAddress: '',
            Rep1: '',
            Rep2: '',
            Sales1: '',
            Sales2: ''
        };
        this.customerId = 0;
        this.shippingAddressId = 0;
        this.shouldFetchSalesOrderNo = false;
        this.error = "";
        this.SCALRenewalTypeList = [];
        this.SelectedLicenseKey = '';
        this.isBillingShippingDetailFetched = false;
        this.selectedLicenseDetailIdList = [];
        this.selectedNoOfUserRenewalList = [];
        this.isLoading = false;
        this.currentTime = Date.now();
        this.prevSalesOrderNo = '';
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.Smartlink360PurchaseLicenseData = this.dialogData.Smartlink360PurchaseLicenseData;
        this.SelectedCustomerLicenseDetail = this.dialogData.SelectedLicenseDetail;
        this.buildForm();
        Object.keys(__WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__["f" /* SCALRenewalType */]).filter(function (type) { return isNaN(Number(type)); }).forEach(function (key, index) {
            _this.SCALRenewalTypeList.push({
                name: key,
                value: __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__["f" /* SCALRenewalType */][key]
            });
        });
        this.billingShippingDetail.BillToName = this.SelectedCustomerLicenseDetail.BillToName;
        this.billingShippingDetail.BillToAddress1 = this.SelectedCustomerLicenseDetail.BillToAddress1;
        this.billingShippingDetail.BillToAddress2 = this.SelectedCustomerLicenseDetail.BillToAddress2;
        this.billingShippingDetail.BillToCity = this.SelectedCustomerLicenseDetail.BillToCity;
        this.billingShippingDetail.ShipToName = this.SelectedCustomerLicenseDetail.ShipToName;
        this.billingShippingDetail.ShipToAddress1 = this.SelectedCustomerLicenseDetail.ShipToAddress1;
        this.billingShippingDetail.ShipToAddress2 = this.SelectedCustomerLicenseDetail.ShipToAddress2;
        this.billingShippingDetail.ShipToCity = this.SelectedCustomerLicenseDetail.ShipToCity;
        this.billingShippingDetail.ShipToState = this.SelectedCustomerLicenseDetail.ShipToState;
    }
    Smartlink360RenewLicenseComponent.prototype.buildForm = function () {
        this.renewSmartlink360LicenseForm = this.formBuilder.group({
            RenewalType: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]],
            PurchaseDate: ['', __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            SupportValidityYear: [24, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            SalesOrderNo: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]],
        });
    };
    Smartlink360RenewLicenseComponent.prototype.blurSalesOrderEvent = function () {
        var _this = this;
        if (this.prevSalesOrderNo.trim().toUpperCase() == this.renewSmartlink360LicenseForm.value.SalesOrderNo.trim().toUpperCase()) {
            return;
        }
        this.prevSalesOrderNo = this.renewSmartlink360LicenseForm.value.SalesOrderNo;
        setTimeout(function () {
            _this.shouldFetchSalesOrderNo = true;
            _this.isBillingShippingDetailFetched = false;
        }, 150);
    };
    Smartlink360RenewLicenseComponent.prototype.checkSalesOrderNo = function () {
        var _this = this;
        if (this.dialogData.Smartlink360PurchaseLicenseData) {
            var exists = this.dialogData.Smartlink360PurchaseLicenseData.some(function (element) {
                if (element != null) {
                    return _this.renewSmartlink360LicenseForm.value.SalesOrderNo.toUpperCase().trim() == element.SalesOrderNo.toUpperCase().trim();
                }
                else {
                    return false;
                }
            });
            if (exists) {
                __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
                    title: "This sales order no already exists",
                    text: "Are you sure you want to use this Sales Order No?",
                    showCancelButton: true,
                    showCloseButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#FFCA28",
                    cancelButtonText: "No",
                }).then(function (result) {
                    if (result.isConfirmed) {
                        _this.shouldFetchSalesOrderNo = true;
                        _this.isBillingShippingDetailFetched = false;
                        _this.getBillingShippingDetail();
                    }
                    else {
                        _this.shouldFetchSalesOrderNo = false;
                        _this.isBillingShippingDetailFetched = false;
                        _this.renewSmartlink360LicenseForm.patchValue({
                            SalesOrderNo: ""
                        });
                    }
                });
            }
            else {
                this.shouldFetchSalesOrderNo = true;
                this.isBillingShippingDetailFetched = false;
                this.getBillingShippingDetail();
            }
        }
        else {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
            this.getBillingShippingDetail();
        }
    };
    Smartlink360RenewLicenseComponent.prototype.getBillingShippingDetail = function () {
        var _this = this;
        var salesOrderNo = this.renewSmartlink360LicenseForm.value.SalesOrderNo;
        if (salesOrderNo != '') {
            if (this.shouldFetchSalesOrderNo) {
                this.appLoader.open();
                this.licenseService.getBillingShippingDetail(salesOrderNo).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.billingShippingDetail = data.DataObject;
                        _this.isBillingShippingDetailFetched = true;
                        _this.error = '';
                    }
                    else {
                        _this.isBillingShippingDetailFetched = false;
                        _this.error = data.Error;
                    }
                    _this.appLoader.close();
                });
            }
            else {
                this.error = "Please select other sales order number.";
            }
        }
        else {
            this.error = "Sales Order No is required";
            this.isBillingShippingDetailFetched = false;
        }
    };
    Smartlink360RenewLicenseComponent.prototype.onSave = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.isBillingShippingDetailFetched) {
                _this.error = "Please fetch the customer billing and shipping details!";
                return;
            }
            _this.appLoader.open();
            _this.licenseService.addBillingShippingDetail(_this.billingShippingDetail).subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    var model = {
                        LicenseId: _this.SelectedCustomerLicenseDetail.LicenseId,
                        CustomerId: data.DataObject.CustomerId,
                        ShippingAddressId: data.DataObject.ShippingAddressId,
                        RenewType: _this.renewSmartlink360LicenseForm.value.RenewalType,
                        PurchaseInvoiceDate: _this.renewSmartlink360LicenseForm.value.PurchaseDate,
                        SalesOrderNo: _this.renewSmartlink360LicenseForm.value.SalesOrderNo,
                        SupportValidityMonths: _this.renewSmartlink360LicenseForm.value.SupportValidityYear,
                        CreatedBy: Number(localStorage.getItem('userid')),
                        UpdatedBy: Number(localStorage.getItem('userid'))
                    };
                    _this.licenseService.renewSmartLink360License(model).subscribe(function (data) {
                        if (!data.IsError && data.DataObject != null) {
                            _this.Smartlink360PurchaseLicenseData = data.DataObject;
                            _this.dialogRef.close(_this.Smartlink360PurchaseLicenseData);
                            _this.appLoader.close();
                            _this.snackBar.open("License renewed successfully!", "", {
                                duration: 2000
                            });
                        }
                    });
                }
            });
        }, 300);
    };
    Smartlink360RenewLicenseComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.Smartlink360PurchaseLicenseData);
    };
    Smartlink360RenewLicenseComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'smartlink360-renew-license',
            template: __webpack_require__(1056),
            styles: [__webpack_require__(993)]
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_7__angular_router__["a" /* Router */], Object])
    ], Smartlink360RenewLicenseComponent);
    return Smartlink360RenewLicenseComponent;
}());



/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SmartLink360ViewActivationDetailComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);






var SmartLink360ViewActivationDetailComponent = /** @class */ (function () {
    function SmartLink360ViewActivationDetailComponent(appLoader, licenseService, dialogRef, adalService, router, dialogData) {
        this.appLoader = appLoader;
        this.licenseService = licenseService;
        this.dialogRef = dialogRef;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'View Activation Details';
        this.error = '';
        this.errorMessage = '';
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.SelectedLicenseDetail = this.dialogData.SelectedLicenseData;
        this.Smartlink360PurchaseLicenseData = this.dialogData.Smartlink360PurchaseLicenseData;
        this.getActivationDetails();
    }
    SmartLink360ViewActivationDetailComponent.prototype.getActivationDetails = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.viewSmartLink360ActivationHistory(this.SelectedLicenseDetail.LicenseId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.ActivationDetail = data.DataObject;
                _this.error = '';
            }
            else {
                _this.error = data.Error;
            }
            _this.isLoading = false;
        });
    };
    SmartLink360ViewActivationDetailComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.Smartlink360PurchaseLicenseData);
    };
    SmartLink360ViewActivationDetailComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'smartlink360-view-activation-details',
            template: __webpack_require__(1057),
            styles: [__webpack_require__(994)]
        }),
        __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_2__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */], Object])
    ], SmartLink360ViewActivationDetailComponent);
    return SmartLink360ViewActivationDetailComponent;
}());



/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SmartLink360ViewFeedbackComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);






var SmartLink360ViewFeedbackComponent = /** @class */ (function () {
    function SmartLink360ViewFeedbackComponent(appLoader, licenseService, dialogRef, adalService, router, dialogData) {
        this.appLoader = appLoader;
        this.licenseService = licenseService;
        this.dialogRef = dialogRef;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'View Feedback';
        this.errorMessage = '';
        this.error = '';
        this.selectedRow = null;
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.SelectedDemoLicenseInfo = dialogData.SelectedLicenseDetail;
        this.getFeedbackDetails();
    }
    SmartLink360ViewFeedbackComponent.prototype.selectRow = function (index) {
        this.selectedRow = this.selectedRow == index ? null : index;
    };
    SmartLink360ViewFeedbackComponent.prototype.getFeedbackDetails = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.getUserFeedBackInfo(this.SelectedDemoLicenseInfo.UserRegId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.feedbackDetails = data.DataObject;
            }
            else {
                _this.error = data.Error;
            }
            _this.isLoading = false;
        });
    };
    SmartLink360ViewFeedbackComponent.prototype.onCancel = function () {
        this.dialogRef.close();
    };
    SmartLink360ViewFeedbackComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'smartlink360-view-feedback',
            template: __webpack_require__(1058),
            styles: [__webpack_require__(995)]
        }),
        __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_2__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */], Object])
    ], SmartLink360ViewFeedbackComponent);
    return SmartLink360ViewFeedbackComponent;
}());



/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SmartLink360ViewRenewalHistoryComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);






var SmartLink360ViewRenewalHistoryComponent = /** @class */ (function () {
    function SmartLink360ViewRenewalHistoryComponent(licenseService, appLoader, dialogRef, adalService, router, dialogData) {
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.dialogRef = dialogRef;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = 'View Renewal History';
        this.error = '';
        this.errorMessage = '';
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        else {
            this.SelectedLicenseDetail = this.dialogData.SelectedLicenseDetail;
            this.Smartlink360PurchaseLicenseData = this.dialogData.Smartlink360PurchaseLicenseData;
            this.getRenewalDetails();
        }
    }
    SmartLink360ViewRenewalHistoryComponent.prototype.getRenewalDetails = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService.viewSmartLink360RenewalHistory(this.SelectedLicenseDetail.LicenseId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.renewalHistoryDetail = data.DataObject;
                _this.errorMessage = '';
            }
            else {
                _this.errorMessage = data.Error;
            }
            _this.isLoading = false;
        });
    };
    SmartLink360ViewRenewalHistoryComponent.prototype.onCancel = function () {
        this.dialogRef.close(this.Smartlink360PurchaseLicenseData);
    };
    SmartLink360ViewRenewalHistoryComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'smartlink360-view-renewal-history',
            template: __webpack_require__(1059),
            styles: [__webpack_require__(996)]
        }),
        __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_3__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_2__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */], Object])
    ], SmartLink360ViewRenewalHistoryComponent);
    return SmartLink360ViewRenewalHistoryComponent;
}());



/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_TRIAL_INSTRUMENTS; });
var MAX_TRIAL_INSTRUMENTS = 35;


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivateReleaseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Rx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__interfaces_PushNotificationHistory__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ProductReleaseService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_app_loader_app_loader_service__ = __webpack_require__(7);









var ActivateReleaseComponent = /** @class */ (function () {
    function ActivateReleaseComponent(fb, dialogRef, elementRef, appLoaderService, snackBar, productRelaseService, data) {
        this.fb = fb;
        this.dialogRef = dialogRef;
        this.elementRef = elementRef;
        this.appLoaderService = appLoaderService;
        this.snackBar = snackBar;
        this.productRelaseService = productRelaseService;
        this.data = data;
        this.Title = "Activate Release";
        this.IsPushNotificationChecked = true;
        this.ProductReleaseStatus = __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */];
        this.isPilotReleaseExists = false;
        this.isCustomReleaseExists = false;
        this.customersLoaded = false;
        this.customers = [];
        this.releaseTypes = [
            { label: 'Pilot', value: __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].PilotRelease },
            { label: 'Custom', value: __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].CustomRelease },
            { label: 'Prod', value: __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].ProductionRelease }
        ];
    }
    ActivateReleaseComponent.prototype.ngAfterViewInit = function () {
        var container = this.elementRef.nativeElement.closest('md-dialog-container');
        if (container) {
            container.style.overflow = 'visible';
        }
    };
    ActivateReleaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        document.body.style.overflow = "hidden";
        this.TitleDescription = "Are you sure you want to activate Release v" + this.data.ProductReleaseNo + " ?";
        console.log(this.data);
        // Iterate the list of releases and check if any of them is a Pilot or Custom release.
        var releaseList = this.data.releaseList || [];
        this.isPilotReleaseExists = releaseList.some(function (release) {
            return _this.getReleaseStatus(release) === __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].PilotRelease;
        });
        this.isCustomReleaseExists = releaseList.some(function (release) {
            return _this.getReleaseStatus(release) === __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].CustomRelease;
        });
        this.releaseForm = this.fb.group({
            releaseType: [null, __WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required],
            comment: [null],
            customers: [null],
            isNotifySyncItClientAdmin: [null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required]]
        });
        this.setupValidation();
    };
    ActivateReleaseComponent.prototype.getReleaseStatus = function (release) {
        return release.Status !== undefined ? release.Status : release.ReleaseType;
    };
    ActivateReleaseComponent.prototype.isReleaseTypeDisabled = function (releaseType) {
        return (releaseType === __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].PilotRelease && this.isPilotReleaseExists) ||
            (releaseType === __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].CustomRelease && this.isCustomReleaseExists);
    };
    ActivateReleaseComponent.prototype.setupValidation = function () {
        var _this = this;
        this.releaseForm.get('releaseType').valueChanges.subscribe(function (value) {
            var comment = _this.releaseForm.get('comment');
            var releaseType = _this.releaseForm.get('releaseType');
            var customers = _this.releaseForm.get('customers');
            if (value === __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].ProductionRelease) {
                releaseType.clearValidators();
                comment.clearValidators();
                customers.clearValidators();
            }
            else {
                releaseType.setValidators([__WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required]);
                comment.setValidators([__WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].pattern('.*\\S.*')]);
                customers.setValidators([__WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required]);
            }
            comment.updateValueAndValidity();
            customers.updateValueAndValidity();
            if ((value === __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].PilotRelease || value === __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].CustomRelease) && !_this.customersLoaded) {
                _this.loadCustomers();
            }
        });
    };
    ActivateReleaseComponent.prototype.isProdReleaseWarningDisplay = function () {
        return this.releaseForm.get('releaseType').value == __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].ProductionRelease;
    };
    ActivateReleaseComponent.prototype.loadCustomers = function () {
        var _this = this;
        this.appLoaderService.open();
        this.productRelaseService.getCustomers(this.data.ProductId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.customers = data.DataObject.Customers;
                _this.customersLoaded = true;
            }
            _this.appLoaderService.close();
        }, function (error) {
            console.error(error);
            _this.appLoaderService.close();
        });
    };
    ActivateReleaseComponent.prototype.checkIsValidProductForNotification = function () {
        var productCode = this.data.ProductCode;
        if (productCode in __WEBPACK_IMPORTED_MODULE_6__interfaces_PushNotificationHistory__["a" /* ProductsWithPushNotification */]) {
            return true;
        }
        return false;
    };
    ActivateReleaseComponent.prototype.activateRelease = function () {
        var _this = this;
        console.log(this.releaseForm.value);
        var selectedReleaseType = this.releaseForm.value.releaseType;
        var releaseTypeName = selectedReleaseType === __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].ProductionRelease ? "Prod" : (this.releaseForm.value.releaseType === __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].PilotRelease ? "Pilot" : "Custom");
        console.log("Selected Release Type: ", selectedReleaseType);
        this.appLoaderService.open();
        var model = {
            ProductId: Number(this.data.ProductId),
            ProductReleaseId: this.data.ProductReleaseId,
            ReleaseStatus: this.releaseForm.value.releaseType,
            UpdatedBy: Number(localStorage.getItem("userid")),
            Comment: this.releaseForm.value.comment,
            CustomerIds: this.releaseForm.value.customers,
        };
        this.productRelaseService.ActivateRelease(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                var releaseStatusChangeMessage = "Release status changed to " + releaseTypeName + " Successfully";
                _this.dialogRef.close({
                    SelectedReleaseType: _this.releaseForm.value.releaseType,
                    customers: _this.releaseForm.value.customers,
                    isNotifySyncItClientAdmin: _this.releaseForm.value.isNotifySyncItClientAdmin
                });
                _this.snackBar.open(releaseStatusChangeMessage, "", {
                    duration: 2000,
                });
            }
            else {
                _this.dialogRef.close(false);
                _this.snackBar.open(data.Error, "", {
                    duration: 2000,
                });
            }
            document.body.style.overflow = "auto";
        }, function (error) {
            document.body.style.overflow = "auto";
            _this.dialogRef.close(false);
        });
    };
    ActivateReleaseComponent.prototype.STPStart = function (showLoadder, ISRequestSTP) {
        var _this = this;
        if (showLoadder === void 0) { showLoadder = true; }
        if (ISRequestSTP === void 0) { ISRequestSTP = false; }
        if (showLoadder)
            this.appLoaderService.open();
        var model = {
            ProductReleaseId: this.data.ProductReleaseId,
            IsApproved: true,
            UpdatedBy: Number(localStorage.getItem("userid")),
        };
        this.productRelaseService.STPStart(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.snackBar.open("STP Started", "", {
                    duration: 2000,
                });
            }
            else {
                _this.snackBar.open(data.Error, "", {
                    duration: 2000,
                });
            }
            var result = {
                SelectedReleaseType: __WEBPACK_IMPORTED_MODULE_5__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].STPStart,
            };
            document.body.style.overflow = "auto";
            _this.dialogRef.close(result);
        }, function (_error) {
            document.body.style.overflow = "auto";
            _this.dialogRef.close(false);
            _this.appLoaderService.close();
        });
    };
    ActivateReleaseComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.data.IsSTPPerformed) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a
                .fire({
                title: "<strong>Releasing Product without STP</strong>",
                icon: "info",
                html: "\n                <p><b>Warning:</b> Releasing this product without testing carries significant risks and could lead to unexpected behavior, performance issues, or even security vulnerabilities. By proceeding, you acknowledge and accept these risks.</p>\n                <b>Please confirm your action:</b>\n                <ul style=\"text-align: left;\">\n                <li style=\"margin-top:10px;\"><b>Accept:</b> Proceed with releasing this product without STP.</li>\n                <li><b>Request STP:</b> Requesting QA Department to perform STP.</li>\n                <li><b>Cancel:</b> Effectively closes this dialog box without applying any alterations.</li>\n                </ul>\n                ",
                showCloseButton: true,
                showCancelButton: true,
                showDenyButton: true,
                focusConfirm: false,
                confirmButtonText: "Accept",
                confirmButtonAriaLabel: "Accept",
                cancelButtonText: "Cancel",
                cancelButtonAriaLabel: "Cancel",
                denyButtonText: "Request STP",
                denyButtonAriaLabel: "Request STP",
            })
                .then(function (result) {
                if (result.isConfirmed) {
                    _this.activateRelease();
                }
                else if (result.isDenied) {
                    _this.appLoaderService.open();
                    _this.productRelaseService
                        .getReleaseByProductId(_this.data.ProductId)
                        .subscribe(function (data) {
                        var IsAllowRelease = true;
                        if (!data.IsError && data.DataObject != null) {
                            var releaseData = data.DataObject;
                            releaseData.forEach(function (element) {
                                if ((element.Status == 0 || element.Status == 1) &&
                                    element.IsDeleted == false) {
                                    IsAllowRelease = false;
                                }
                            });
                            if (IsAllowRelease == true) {
                                _this.STPStart(false, true);
                            }
                            else {
                                _this.appLoaderService.close();
                                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a
                                    .fire({
                                    title: "<strong>Unable To Process Request</strong>",
                                    icon: "info",
                                    html: "<P>You can't request STP because there is already one pending release in queue</P>",
                                    showDenyButton: false,
                                    showCancelButton: false,
                                    confirmButtonText: "Ok",
                                })
                                    .then(function (result) {
                                    /* Read more about isConfirmed, isDenied below */
                                    if (result.isConfirmed) {
                                        _this.onSubmit();
                                    }
                                });
                            }
                        }
                        else {
                            _this.appLoaderService.close();
                        }
                    }, function (error) {
                        _this.appLoaderService.close();
                    });
                }
            });
        }
        else {
            this.activateRelease();
        }
    };
    ActivateReleaseComponent.prototype.onCancel = function () {
        document.body.style.overflow = "auto";
        this.dialogRef.close(false);
    };
    ActivateReleaseComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'activate-release',
            template: __webpack_require__(1068),
            styles: [__webpack_require__(1004)],
        }),
        __param(6, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_8__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_7__services_ProductReleaseService__["a" /* ProductReleaseService */], Object])
    ], ActivateReleaseComponent);
    return ActivateReleaseComponent;
}());



/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChangeReleaseTypeComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ProductReleaseService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);






var ChangeReleaseTypeComponent = /** @class */ (function () {
    function ChangeReleaseTypeComponent(dialogRef, appLoaderService, snackBar, productRelaseService, data) {
        this.dialogRef = dialogRef;
        this.appLoaderService = appLoaderService;
        this.snackBar = snackBar;
        this.productRelaseService = productRelaseService;
        this.data = data;
        this.ProductReleaseStatus = __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */];
        this.isQAEnabled = false;
        this.isNotifySyncItClientAdmin = null;
    }
    ChangeReleaseTypeComponent.prototype.ngOnInit = function () {
        var _this = this;
        document.body.style.overflow = "hidden";
        this.releaseType = this.data.Status == __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].PilotRelease ? "Pilot" : "Custom";
        console.log(this.data);
        this.currentReleaseBadge = this.releaseType + " Release";
        // check if prod release exists and is newer than the current release, if yes then disable the Prod option    
        var releaseList = this.data.releaseList || [];
        this.isQAEnabled = releaseList.some(function (release) {
            return release.IsDeleted == false &&
                release.Status === __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].ProductionRelease;
        });
        this.latestProdRelease = releaseList.find(function (release) {
            return release.IsDeleted == false && release.Status === __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].ProductionRelease;
        });
        console.log(this.latestProdRelease);
        this.isHigherProdReleaseExists = releaseList.some(function (release) {
            return release.Status === __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].ProductionRelease &&
                release.IsDeleted == false &&
                _this.compareVersions(release.ProductReleaseNo, _this.data.ProductReleaseNo) > 0;
        });
    };
    ChangeReleaseTypeComponent.prototype.compareVersions = function (version1, version2) {
        var versionRegex = /^\d+(\.\d+)*$/;
        // Ignore invalid version strings
        if (!versionRegex.test(version1) || !versionRegex.test(version2)) {
            return 0;
        }
        var v1 = version1.split('.').map(Number);
        var v2 = version2.split('.').map(Number);
        var maxLength = Math.max(v1.length, v2.length);
        for (var i = 0; i < maxLength; i++) {
            var num1 = v1[i] || 0;
            var num2 = v2[i] || 0;
            if (num1 > num2)
                return 1;
            if (num1 < num2)
                return -1;
        }
        return 0;
    };
    ChangeReleaseTypeComponent.prototype.isConfirmButtonDisabled = function () {
        var disabled = (this.selectedReleaseType == null) || (this.isNotifySyncItClientAdmin == null && !this.isRadioGroupDisabled());
        return disabled;
    };
    ChangeReleaseTypeComponent.prototype.isRadioGroupDisabled = function () {
        return this.selectedReleaseType === __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].QARelease && !this.isHigherProdReleaseExists;
    };
    ChangeReleaseTypeComponent.prototype.getWarningMessage = function () {
        var message;
        if (this.selectedReleaseType == __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].ProductionRelease) {
            var isCustomRelease = this.data.Status == __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].CustomRelease;
            var oppositeRelease = isCustomRelease ? "pilot" : "custom";
            var oppositeStatus_1 = isCustomRelease
                ? __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].PilotRelease
                : __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].CustomRelease;
            var oppositeReleaseObj = this.data.releaseList.find(function (release) {
                return !release.IsDeleted &&
                    release.Status == oppositeStatus_1;
            });
            if (oppositeReleaseObj) {
                message = "Release v" + this.data.ProductReleaseNo + " will become available for all customers <b>except</b> those enrolled in " + oppositeRelease + " release v" + oppositeReleaseObj.ProductReleaseNo + ".";
            }
            else {
                message = "Release v" + this.data.ProductReleaseNo + " will become available for all customers.";
            }
        }
        else {
            if (this.isHigherProdReleaseExists)
                message = "Enrolled customers will get the latest prod release v" + this.latestProdRelease.ProductReleaseNo + ".";
            else
                message = "Enrolled customers will stay on v" + this.data.ProductReleaseNo + " until a new Prod release is available.";
        }
        return message;
    };
    ChangeReleaseTypeComponent.prototype.getCheckboxNote = function () {
        var message;
        if (this.isHigherProdReleaseExists)
            message = "<strong>Note:</strong> Only the admins of customers enrolled in this release will receive notification email for latest prod release v" + this.latestProdRelease.ProductReleaseNo + ".";
        else
            message = "<strong>Note:</strong> Only the admins of customers enrolled in this release will receive notification email for latest prod release.";
        return message;
    };
    ChangeReleaseTypeComponent.prototype.onReleaseTypeChanged = function (type) {
        this.selectedReleaseType = type;
        if (type === __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].QARelease &&
            !this.isHigherProdReleaseExists) {
            this.isNotifySyncItClientAdmin = null;
        }
    };
    ChangeReleaseTypeComponent.prototype.STPStart = function (showLoadder, ISRequestSTP) {
        var _this = this;
        if (showLoadder === void 0) { showLoadder = true; }
        if (ISRequestSTP === void 0) { ISRequestSTP = false; }
        if (showLoadder)
            this.appLoaderService.open();
        var model = {
            ProductReleaseId: this.data.ProductReleaseId,
            IsApproved: true,
            UpdatedBy: Number(localStorage.getItem("userid")),
        };
        this.productRelaseService.STPStart(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.snackBar.open("STP Started", "", {
                    duration: 2000,
                });
            }
            else {
                _this.snackBar.open(data.Error, "", {
                    duration: 2000,
                });
            }
            var result = {
                SelectedReleaseType: __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].STPStart,
            };
            document.body.style.overflow = "auto";
            _this.dialogRef.close(result);
        }, function (_error) {
            document.body.style.overflow = "auto";
            _this.dialogRef.close(false);
            _this.appLoaderService.close();
        });
    };
    ChangeReleaseTypeComponent.prototype.onConfirm = function () {
        var _this = this;
        if (this.selectedReleaseType == __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].ProductionRelease && !this.data.IsSTPPerformed) {
            __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                title: "<strong>Releasing Product without STP</strong>",
                icon: "info",
                html: "\n          <p><b>Warning:</b> Releasing this product without testing carries significant risks and could lead to unexpected behavior, performance issues, or even security vulnerabilities. By proceeding, you acknowledge and accept these risks.</p>\n          <b>Please confirm your action:</b>\n          <ul style=\"text-align: left;\">\n          <li style=\"margin-top:10px;\"><b>Accept:</b> Proceed with releasing this product without STP.</li>\n          <li><b>Request STP:</b> Requesting QA Department to perform STP.</li>\n          <li><b>Cancel:</b> Effectively closes this dialog box without applying any alterations.</li>\n          </ul>",
                showCloseButton: true,
                showCancelButton: true,
                showDenyButton: true,
                focusConfirm: false,
                confirmButtonText: "Accept",
                confirmButtonAriaLabel: "Accept",
                cancelButtonText: "Cancel",
                cancelButtonAriaLabel: "Cancel",
                denyButtonText: "Request STP",
                denyButtonAriaLabel: "Request STP",
            })
                .then(function (result) {
                if (result.isConfirmed) {
                    _this.changeReleaseType();
                }
                else if (result.isDenied) {
                    _this.appLoaderService.open();
                    _this.productRelaseService
                        .getReleaseByProductId(_this.data.ProductId)
                        .subscribe(function (data) {
                        var IsAllowRelease = true;
                        if (!data.IsError && data.DataObject != null) {
                            var releaseData = data.DataObject;
                            releaseData.forEach(function (element) {
                                if ((element.Status == 0 || element.Status == 1) &&
                                    element.IsDeleted == false) {
                                    IsAllowRelease = false;
                                }
                            });
                            if (IsAllowRelease == true) {
                                _this.STPStart(false, true);
                            }
                            else {
                                _this.appLoaderService.close();
                                __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                                    title: "<strong>Unable To Process Request</strong>",
                                    icon: "info",
                                    html: "<P>You can't request STP because there is already one pending release in queue</P>",
                                    showDenyButton: false,
                                    showCancelButton: false,
                                    confirmButtonText: "Ok",
                                })
                                    .then(function (result) {
                                    /* Read more about isConfirmed, isDenied below */
                                    if (result.isConfirmed) {
                                        _this.onConfirm();
                                    }
                                });
                            }
                        }
                        else {
                            _this.appLoaderService.close();
                        }
                    }, function (error) {
                        _this.appLoaderService.close();
                    });
                }
            });
        }
        else {
            this.changeReleaseType();
        }
    };
    ChangeReleaseTypeComponent.prototype.changeReleaseType = function () {
        var _this = this;
        console.log("Selected Release Type: " + this.selectedReleaseType + ", isNotifySyncItClientAdmin: " + this.isNotifySyncItClientAdmin);
        var releaseTypeName = this.selectedReleaseType === __WEBPACK_IMPORTED_MODULE_2__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].ProductionRelease ? "Prod" : "QA";
        this.appLoaderService.open();
        var model = {
            ProductId: Number(this.data.ProductId),
            ProductReleaseId: this.data.ProductReleaseId,
            ReleaseStatus: this.selectedReleaseType,
            UpdatedBy: Number(localStorage.getItem("userid")),
        };
        this.productRelaseService.ChangePilotCustomReleaseStatus(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                var releaseStatusChangeMessage = "Release status changed to " + releaseTypeName + " Successfully";
                _this.dialogRef.close({
                    SelectedReleaseType: _this.selectedReleaseType,
                    isNotifySyncItClientAdmin: _this.isNotifySyncItClientAdmin,
                    customers: data.DataObject.customerIds
                });
                _this.snackBar.open(releaseStatusChangeMessage, "", {
                    duration: 2000,
                });
            }
            else {
                _this.dialogRef.close(false);
                _this.snackBar.open(data.Error, "", {
                    duration: 2000,
                });
            }
            document.body.style.overflow = "auto";
        }, function (error) {
            document.body.style.overflow = "auto";
            _this.dialogRef.close(false);
        });
    };
    ChangeReleaseTypeComponent.prototype.onCancel = function () {
        document.body.style.overflow = "auto";
        this.dialogRef.close();
    };
    ChangeReleaseTypeComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: "change-release-type",
            template: __webpack_require__(1071),
            styles: [__webpack_require__(1005)]
        }),
        __param(4, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_3__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_4__services_ProductReleaseService__["a" /* ProductReleaseService */], Object])
    ], ChangeReleaseTypeComponent);
    return ChangeReleaseTypeComponent;
}());



/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common_http__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(55);




var NotificationService = /** @class */ (function () {
    function NotificationService(httpClient) {
        this.httpClient = httpClient;
        this.baseUrl = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].apiUrl;
    }
    NotificationService.prototype.getHeaders = function () {
        var headers = new __WEBPACK_IMPORTED_MODULE_0__angular_common_http__["c" /* HttpHeaders */]();
        headers.append('Content-Type', 'application/json');
        return headers;
    };
    NotificationService.prototype.sendNotificationMessageForAndroid = function (message) {
        var pushNotificationUrlForAndroid = this.baseUrl + 'Notification/sendPushNotificationForAndroid';
        return this.httpClient.post(pushNotificationUrlForAndroid, message, { headers: this.getHeaders() }).map(function (response) {
            return response;
        });
    };
    NotificationService.prototype.sendNotificationMessageForApple = function (message) {
        var pushNotificationUrlForApple = this.baseUrl + 'Notification/sendPushNotificationForApple';
        return this.httpClient.post(pushNotificationUrlForApple, message, { headers: this.getHeaders() }).map(function (response) {
            return response;
        });
    };
    NotificationService.prototype.addNotificationHistory = function (notificationHistoryDTO) {
        return this.httpClient.post(this.baseUrl + 'Notification/addNotificationHistory', notificationHistoryDTO, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    NotificationService.prototype.getNotificationHistoryByProductId = function (productId) {
        return this.httpClient.get(this.baseUrl + 'Notification/getNotificationHistoryByProductId/' + productId, { headers: this.getHeaders() })
            .map(function (response) {
            return response;
        });
    };
    NotificationService = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_0__angular_common_http__["d" /* HttpClient */]])
    ], NotificationService);
    return NotificationService;
}());



/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdalAccessGuard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_adal_service__ = __webpack_require__(6);


var AdalAccessGuard = /** @class */ (function () {
    function AdalAccessGuard(adalService) {
        this.adalService = adalService;
    }
    AdalAccessGuard.prototype.canActivate = function (_route, _state) {
        return this.adalService.userInfo.profile;
    };
    AdalAccessGuard.prototype.canActivateChild = function (childRoute, state) {
        return this.canActivate(childRoute, state);
    };
    AdalAccessGuard = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__shared_adal_service__["a" /* AdalService */]])
    ], AdalAccessGuard);
    return AdalAccessGuard;
}());



/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenseAuthGuard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(4);


var LicenseAuthGuard = /** @class */ (function () {
    function LicenseAuthGuard(router) {
        this.router = router;
    }
    LicenseAuthGuard.prototype.canActivate = function () {
        if (localStorage.getItem("portalAccess") === "2" || localStorage.getItem("portalAccess") === "3") {
            return true;
        }
        this.router.navigate(['/access-denied']);
        return false;
    };
    LicenseAuthGuard.prototype.canActivateChild = function () {
        return this.canActivate();
    };
    LicenseAuthGuard = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* Router */]])
    ], LicenseAuthGuard);
    return LicenseAuthGuard;
}());



/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserManagementComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var UserManagementComponent = /** @class */ (function () {
    function UserManagementComponent() {
    }
    UserManagementComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'user-management',
            template: __webpack_require__(1082),
            styles: [__webpack_require__(1010)]
        })
    ], UserManagementComponent);
    return UserManagementComponent;
}());



/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutUserRightsSummaryComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);






var PageLayoutUserRightsSummaryComponent = /** @class */ (function () {
    function PageLayoutUserRightsSummaryComponent(route, router, adalService, userService, dialogRef, data) {
        this.route = route;
        this.router = router;
        this.adalService = adalService;
        this.userService = userService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.summaryText = [];
        //Check Authentication
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close();
            this.router.navigate(["login"]);
        }
        if (this.data.UserName != "")
            this.Title = this.data.UserName + " - User rights change history";
        else
            this.Title = "";
        this.getUserRightsSummary(this.data.userId);
    }
    PageLayoutUserRightsSummaryComponent.prototype.getUserRightsSummary = function (userId) {
        var _this = this;
        this.userService.getUserRightsDetaisSummaryById(userId).subscribe(function (data) {
            _this.userrightssummary = data.DataObject;
        }, function (error) {
            _this.errorMessage = error;
        });
    };
    PageLayoutUserRightsSummaryComponent.prototype.UTCToLocalTimeZone = function (date) {
        //let theDate = new Date(Date.parse(date));
        var stillUtc = __WEBPACK_IMPORTED_MODULE_5_moment__["utc"](date).toDate();
        var theDate = __WEBPACK_IMPORTED_MODULE_5_moment__(stillUtc).local();
        return theDate.toLocaleString();
    };
    PageLayoutUserRightsSummaryComponent.prototype.onCancel = function () {
        this.dialogRef.close(true);
    };
    PageLayoutUserRightsSummaryComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: "dialog-result-example-dialog",
            template: __webpack_require__(1083),
            styles: [__webpack_require__(1011)],
        }),
        __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_3__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */], Object])
    ], PageLayoutUserRightsSummaryComponent);
    return PageLayoutUserRightsSummaryComponent;
}());



/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppLoaderComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material_dialog__ = __webpack_require__(120);


var AppLoaderComponent = /** @class */ (function () {
    function AppLoaderComponent(dialogRef) {
        this.dialogRef = dialogRef;
    }
    AppLoaderComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'app-app-loader',
            template: __webpack_require__(1085)
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material_dialog__["a" /* MdDialogRef */]])
    ], AppLoaderComponent);
    return AppLoaderComponent;
}());



/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	return new Promise(function(resolve, reject) { reject(new Error("Cannot find module '" + req + "'.")); });
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = 273;

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AdvertismentRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdvertisementRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__advertisement_component__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__add_new_advertisement_add_new_advertisement_component__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_license_auth_guard__ = __webpack_require__(215);




var AdvertismentRoutes = [{
        path: 'advertisement',
        children: [
            { path: 'add-advertisement', component: __WEBPACK_IMPORTED_MODULE_2__add_new_advertisement_add_new_advertisement_component__["a" /* AddNewAdvertisementDialogComponent */] }
        ],
        canActivate: [__WEBPACK_IMPORTED_MODULE_3__shared_license_auth_guard__["a" /* LicenseAuthGuard */]],
        canActivateChild: [__WEBPACK_IMPORTED_MODULE_3__shared_license_auth_guard__["a" /* LicenseAuthGuard */]],
        component: __WEBPACK_IMPORTED_MODULE_0__advertisement_component__["a" /* AdvertisementComponent */],
    }];
var AdvertisementRoutingModule = __WEBPACK_IMPORTED_MODULE_1__angular_router__["g" /* RouterModule */].forChild(AdvertismentRoutes);


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DashboardComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_adal_service__ = __webpack_require__(6);



var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(router, adal) {
        this.router = router;
        this.adal = adal;
        // Check Authentication
        if (!this.adal.getCachedToken()) {
            // this.router.navigate(["login"]);
        }
    }
    DashboardComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-dashboard',
            template: __webpack_require__(1015)
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_2__shared_adal_service__["a" /* AdalService */]])
    ], DashboardComponent);
    return DashboardComponent;
}());



/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AzureDownloadService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_app_loader_app_loader_service__ = __webpack_require__(7);


var AzureDownloadService = /** @class */ (function () {
    function AzureDownloadService(appLoaderService) {
        this.appLoaderService = appLoaderService;
        this.chunkSize = 1024 * 1024; // 1MB chunks
    }
    AzureDownloadService.prototype.getFileSize = function (url) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('HEAD', url, true);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(parseInt(xhr.getResponseHeader('Content-Length') || '0', 10));
                    }
                    else {
                        reject('Error fetching file size');
                    }
                }
            };
            xhr.onerror = function () { return reject('Error fetching file size'); };
            xhr.send();
        });
    };
    AzureDownloadService.prototype.downloadFile = function (url, progressCallback) {
        var self = this;
        this.getFileSize(url).then(function (fileSize) {
            var chunks = [];
            var downloadedSize = 0;
            var numChunks = Math.ceil(fileSize / self.chunkSize);
            var chunkPromises = [];
            for (var i = 0; i < numChunks; i++) {
                (function (index) {
                    var start = index * self.chunkSize;
                    var end = Math.min(start + self.chunkSize - 1, fileSize - 1);
                    var promise = new Promise(function (resolve, reject) {
                        var xhr = new XMLHttpRequest();
                        xhr.open('GET', url, true);
                        xhr.setRequestHeader('Range', "bytes=" + start + "-" + end);
                        xhr.responseType = 'arraybuffer';
                        xhr.onload = function () {
                            if (xhr.status === 206 || xhr.status === 200) {
                                downloadedSize += xhr.response.byteLength;
                                progressCallback((downloadedSize / fileSize) * 100);
                                resolve(xhr.response);
                            }
                            else {
                                reject("Error downloading chunk " + index);
                            }
                        };
                        xhr.onerror = function () {
                            reject("Network error in chunk " + index);
                        };
                        xhr.send();
                    });
                    chunkPromises.push(promise);
                })(i);
            }
            Promise.all(chunkPromises).then(function (data) {
                var combined = new Blob(data, { type: 'application/zip' });
                var link = document.createElement('a');
                link.href = URL.createObjectURL(combined);
                link.download = 'SCAL360.zip';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch(function (error) {
                console.error('Download failed:', error);
            });
        }).catch(function (error) {
            console.error('Failed to fetch file size:', error);
        });
    };
    AzureDownloadService = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_app_loader_app_loader_service__["a" /* AppLoaderService */]])
    ], AzureDownloadService);
    return AzureDownloadService;
}());



/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageDownloadSCAL360Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ProductReleaseService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_common_http__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__changelog_changelog_component__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AzureDownloadService_service__ = __webpack_require__(335);








var PageDownloadSCAL360Component = /** @class */ (function () {
    function PageDownloadSCAL360Component(formBuilder, dialog, productReleaseService, http, appLoaderService, fileService, cdr) {
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.productReleaseService = productReleaseService;
        this.http = http;
        this.appLoaderService = appLoaderService;
        this.fileService = fileService;
        this.cdr = cdr;
        this.disabled = true;
        this.IsMailSend = false;
        this.submitted = false;
    }
    PageDownloadSCAL360Component.prototype.ngOnInit = function () {
        this.buildForm();
        this.getIPAddress();
    };
    PageDownloadSCAL360Component.prototype.buildForm = function () {
        this.validationForm = this.formBuilder.group({
            contactno: [{ value: '', disabled: false }],
            licenseKey: [{ value: '', disabled: false }, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            email: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].email, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
        });
        this.OTPForm = this.formBuilder.group({
            OTP: [{ value: '', disabled: false }, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]
        });
    };
    PageDownloadSCAL360Component.prototype.validateInfo = function () {
        var _this = this;
        this.errorMessage = '';
        if (this.validationForm.invalid) {
            return;
        }
        // First Send Email
        var LicenseInfo = {
            EmailId: this.validationForm.value.email,
            LicenseKey: this.validationForm.value.licenseKey,
            PhoneNo: this.validationForm.value.contactno,
            IPAddress: this.IPAddress
        };
        this.appLoaderService.open("Loading");
        this.productReleaseService.SendEmailToSCAL3609Customer(LicenseInfo).subscribe(function (result) {
            if (result.DataObject != null) {
                _this.IsMailSend = true;
                _this.submitted = true;
                _this.isDisabled(true, 'licenseKey');
                _this.isDisabled(true, 'contactno');
                _this.isDisabled(true, 'email');
                _this.cdr.detectChanges();
                _this.appLoaderService.close();
            }
            else {
                _this.appLoaderService.close();
                _this.errorMessage = result.Error;
                _this.validationForm.patchValue({
                    licenseKey: ''
                });
                _this.cdr.detectChanges();
            }
        }, function (_error) {
            _this.appLoaderService.close();
        });
    };
    PageDownloadSCAL360Component.prototype.OTPVerfication = function () {
        var _this = this;
        this.errorMessage = "";
        this.appLoaderService.open("Verify OTP");
        var LicenseInfo = {
            EmailId: this.validationForm.value.email,
            LicenseKey: this.validationForm.value.licenseKey,
            PhoneNo: this.validationForm.value.contactno,
            IPAddress: this.IPAddress,
            OTP: this.OTPForm.value.OTP,
            SoftwareVersionNo: this.StableRelease
        };
        this.productReleaseService.VerifySCAL360OTPVerification(LicenseInfo).subscribe(function (result) {
            if (result.DataObject != null) {
                _this.startDownload(result.DataObject[0].FilePath, LicenseInfo);
            }
            else {
                _this.OTPForm.patchValue({
                    OTP: ''
                });
                _this.errorMessage = result.Error;
                _this.appLoaderService.close();
            }
        }, function (_error) {
            _this.appLoaderService.close();
        });
    };
    PageDownloadSCAL360Component.prototype.getIPAddress = function () {
        var _this = this;
        this.appLoaderService.open();
        this.productReleaseService.getIPAddress().subscribe(function (result) {
            _this.IPAddress = result.ip;
            _this.getStableRelease();
        }, function (_error) {
            _this.appLoaderService.close();
        });
    };
    PageDownloadSCAL360Component.prototype.getStableRelease = function () {
        var _this = this;
        this.productReleaseService.getStableRelease(14).subscribe(function (result) {
            if (result.DataObject != null) {
                _this.StableRelease = result.DataObject.SoftwareVersionNo;
                _this.ChangeLog = result.DataObject.ChangeLog;
                _this.cdr.detectChanges(); // Force re-rendering                
            }
            _this.appLoaderService.close();
        }, function (_error) {
            _this.appLoaderService.close();
        });
    };
    PageDownloadSCAL360Component.prototype.isDisabled = function (value, controlname) {
        this.IsDisabled = value;
        if (value) {
            this.validationForm.controls[controlname].disable();
        }
        else {
            this.validationForm.controls[controlname].enable();
        }
    };
    PageDownloadSCAL360Component.prototype.viewChangeLog = function () {
        var _this = this;
        setTimeout(function () {
            var confirmdialog = _this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__changelog_changelog_component__["a" /* PageLayoutViewChangeLogComponent */], { height: "50%", data: { "ChangeLog": _this.ChangeLog }, disableClose: true });
            confirmdialog.afterClosed().subscribe(function (result) {
                console.log(result);
            });
        }, 0);
    };
    PageDownloadSCAL360Component.prototype.startDownload = function (filePath, LicenseInfo) {
        var _this = this;
        this.productReleaseService.getSASToken(filePath).subscribe(function (response) {
            _this.fileService.downloadFile(response.url, function (percentage) {
                _this.appLoaderService.ChangeLoaderTitle("Downloading File");
                _this.appLoaderService.ChangePercentage(percentage.toFixed(0) + '%');
                console.log("Percentage:" + percentage.toFixed(0) + "@" + percentage);
                if (percentage >= 100) {
                    console.log("Closing loader...");
                    _this.IsMailSend = false;
                    _this.validationForm.patchValue({
                        licenseKey: '',
                        contactno: '',
                        email: ''
                    });
                    _this.OTPForm.patchValue({
                        OTP: ''
                    });
                    _this.successMessage = "Successfully Downloaded SCAL-360 File";
                    // Call DownloadDetails after successful download
                    _this.addSoftwareDownloadDetails(LicenseInfo);
                }
            });
        }, function (_error) {
            _this.appLoaderService.close();
        });
    };
    PageDownloadSCAL360Component.prototype.addSoftwareDownloadDetails = function (LicenseInfo) {
        var _this = this;
        this.productReleaseService.AddSoftwareDownloadDetails(LicenseInfo).subscribe(function (result) {
            _this.appLoaderService.close();
        });
    };
    PageDownloadSCAL360Component = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-page-download',
            template: __webpack_require__(1016)
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_6__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_2__services_ProductReleaseService__["a" /* ProductReleaseService */],
            __WEBPACK_IMPORTED_MODULE_3__angular_common_http__["d" /* HttpClient */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_7__AzureDownloadService_service__["a" /* AzureDownloadService */],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]])
    ], PageDownloadSCAL360Component);
    return PageDownloadSCAL360Component;
}());



/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HomePageComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__interfaces_LicenseModel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ProductService__ = __webpack_require__(84);








var HomePageComponent = /** @class */ (function () {
    function HomePageComponent(router, adal, userService, appLoader, licenseService, productService) {
        this.router = router;
        this.adal = adal;
        this.userService = userService;
        this.appLoader = appLoader;
        this.licenseService = licenseService;
        this.productService = productService;
        this.userId = 0;
        // Check Authentication
        if (!this.adal.getCachedToken()) {
            this.router.navigate(["login"]);
        }
    }
    HomePageComponent.prototype.ngOnInit = function () {
        this.userId = Number(localStorage.getItem('userid'));
        this.portalAccess = Number(localStorage.getItem('portalAccess'));
        this.IsAdmin = localStorage.getItem('IsAdmin');
        // this.getUserRights(this.userId)
    };
    HomePageComponent.prototype.navigateToOTA = function () {
        var _this = this;
        this.appLoader.open();
        this.productService.GetFirstDisplayedOTAProduct().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.router.navigate(['/app/pglayout/product-release-tab/' + data.DataObject.ProductName + '/' + data.DataObject.ProductId + '/' + data.DataObject.Code + '/' + data.DataObject.Variant + '/' + 0]);
            }
            _this.appLoader.close();
        });
    };
    HomePageComponent.prototype.navigateToLicensePortal = function () {
        var _this = this;
        var productId;
        var productName;
        this.appLoader.open();
        this.licenseService.getLicensePortalProductByProductCode(__WEBPACK_IMPORTED_MODULE_6__interfaces_LicenseModel__["a" /* LicensePortalProduct */].SmartCal360N).subscribe(function (data) {
            if (data.DataObject != null && !data.IsError) {
                productId = data.DataObject.ProductId;
                productName = data.DataObject.ProductName;
                _this.router.navigate(['/license-portal/' + productName + '/' + productId]);
            }
            _this.appLoader.close();
        });
    };
    HomePageComponent.prototype.navigateToAdvertisement = function () {
        this.router.navigate(['/advertisement']);
    };
    HomePageComponent.prototype.navigateToUserManagement = function () {
        this.router.navigate(['/user-management/user']);
        // if (!this.IsAdmin) {
        //     Swal.fire({
        //         title: 'Access Denied',
        //         text: 'You don\'t have the rights to view this portal',
        //         confirmButtonColor: '#FFCA28',
        //         focusConfirm: false,
        //         allowEnterKey: false
        //     })
        // }
        // else {
        //     this.router.navigate(['/user-management/user'])
        // }
    };
    HomePageComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'home-page',
            template: __webpack_require__(1017),
            styles: [__webpack_require__(959)]
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_2__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_3__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_5__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_7__services_ProductService__["a" /* ProductService */]])
    ], HomePageComponent);
    return HomePageComponent;
}());



/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutViewChangeLogComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);


var PageLayoutViewChangeLogComponent = /** @class */ (function () {
    function PageLayoutViewChangeLogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.changeLogData = this.data.ChangeLog;
    }
    PageLayoutViewChangeLogComponent.prototype.onCancel = function () {
        this.dialogRef.close(false);
    };
    PageLayoutViewChangeLogComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'dialog-result-example-dialog',
            template: __webpack_require__(1018),
            styles: [__webpack_require__(960)],
        }),
        __param(1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */], Object])
    ], PageLayoutViewChangeLogComponent);
    return PageLayoutViewChangeLogComponent;
}());



/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLoginComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Rx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_app_loader_app_loader_service__ = __webpack_require__(7);







var PageLoginComponent = /** @class */ (function () {
    function PageLoginComponent(formBuilder, userService, adalService, loader) {
        this.formBuilder = formBuilder;
        this.userService = userService;
        this.adalService = adalService;
        this.loader = loader;
    }
    PageLoginComponent.prototype.ngOnInit = function () {
        this.buildForm();
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
    };
    // Get User Details from Api
    PageLoginComponent.prototype.buildForm = function () {
        this.validationForm = this.formBuilder.group({
            userName: ['', [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].email, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
        });
    };
    PageLoginComponent.prototype.onResetForm = function () {
        this.validationForm.reset();
    };
    PageLoginComponent.prototype.logIn = function () {
        var _this = this;
        this.loader.open();
        this.errorMessage = "";
        // First Check EmailId is valid or Not
        this.userService.getUsers(this.validationForm.value.userName).subscribe(function (data) {
            _this.loader.close();
            if (data.IsError && data.DataObject == null) {
                _this.errorMessage = data.Error;
            }
            else {
                window.localStorage.setItem('emailid', _this.validationForm.value.userName);
                window.localStorage.setItem('userid', data.DataObject.UserId);
                window.localStorage.setItem('Name', data.DataObject.Name);
                window.localStorage.setItem('role', data.DataObject.Role);
                window.localStorage.setItem('portalAccess', data.DataObject.PortalAccess);
                window.localStorage.setItem('IsAdmin', data.DataObject.IsAdmin);
                _this.adalService.login();
            }
        }, function (error) {
            _this.loader.close();
        });
    };
    PageLoginComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-page-login',
            template: __webpack_require__(1019),
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_5__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_6__services_app_loader_app_loader_service__["a" /* AppLoaderService */]])
    ], PageLoginComponent);
    return PageLoginComponent;
}());



/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PilotCustomSupportedProductCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PilotCustomSupportedSubTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PilotCustomSupportedVariants; });
var PilotCustomSupportedProductCodes;
(function (PilotCustomSupportedProductCodes) {
    PilotCustomSupportedProductCodes[PilotCustomSupportedProductCodes["SmartCal"] = 11] = "SmartCal";
    PilotCustomSupportedProductCodes[PilotCustomSupportedProductCodes["G3"] = 12] = "G3";
    PilotCustomSupportedProductCodes[PilotCustomSupportedProductCodes["PMD2"] = 13] = "PMD2";
    PilotCustomSupportedProductCodes[PilotCustomSupportedProductCodes["T4"] = 37] = "T4";
})(PilotCustomSupportedProductCodes || (PilotCustomSupportedProductCodes = {}));
var PilotCustomSupportedSubTypes;
(function (PilotCustomSupportedSubTypes) {
    PilotCustomSupportedSubTypes[PilotCustomSupportedSubTypes["App"] = 0] = "App";
    PilotCustomSupportedSubTypes[PilotCustomSupportedSubTypes["Main"] = 0] = "Main";
})(PilotCustomSupportedSubTypes || (PilotCustomSupportedSubTypes = {}));
var PilotCustomSupportedVariants;
(function (PilotCustomSupportedVariants) {
    PilotCustomSupportedVariants[PilotCustomSupportedVariants["USA"] = 0] = "USA";
})(PilotCustomSupportedVariants || (PilotCustomSupportedVariants = {}));


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccessDeniedComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var AccessDeniedComponent = /** @class */ (function () {
    function AccessDeniedComponent() {
    }
    AccessDeniedComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'app-access-denied',
            template: __webpack_require__(1020),
            styles: [__webpack_require__(961)]
        })
    ], AccessDeniedComponent);
    return AccessDeniedComponent;
}());



/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__);


var LayoutService = /** @class */ (function () {
    function LayoutService() {
        this.preloaderStateSource = new __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__["Subject"]();
        this.preloaderState$ = this.preloaderStateSource.asObservable();
        this.searchOverlaySource = new __WEBPACK_IMPORTED_MODULE_1_rxjs_Subject__["Subject"]();
        this.searchOverlayState$ = this.searchOverlaySource.asObservable();
    }
    LayoutService.prototype.updatePreloaderState = function (state) {
        // console.log('preloader state: ' + state)
        this.preloaderStateSource.next(state);
    };
    LayoutService.prototype.updateSearchOverlayState = function (state) {
        // console.log('overlay state: ' + state)
        this.searchOverlaySource.next(state);
    };
    LayoutService = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
    ], LayoutService);
    return LayoutService;
}());



/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FaqComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__add_edit_faq_add_edit_faq_component__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ExportToCSVService__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__import_faq_import_faq_component__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_PagerService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__interfaces_LicenseModel__ = __webpack_require__(33);












var FaqComponent = /** @class */ (function () {
    function FaqComponent(dialog, licenseService, appLoader, exportService, adalService, router, pagerService) {
        this.dialog = dialog;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.exportService = exportService;
        this.adalService = adalService;
        this.router = router;
        this.pagerService = pagerService;
        this.dialogTitle = "FAQ";
        this.errorMessage = "";
        this.uploadResponse = '';
        this.pager = {};
        this.pagedItems = [];
        if (!this.adalService.getCachedToken()) {
            this.router.navigate(["login"]);
        }
        else {
            this.getFaq();
        }
    }
    FaqComponent.prototype.addFaq = function () {
        var _this = this;
        var addFaqDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__add_edit_faq_add_edit_faq_component__["a" /* AddEditFaqComponent */], {
            width: '40%',
            data: {
                FaqDisplayDetail: this.faqDisplayDetail,
                SelectedFAQDetail: null
            },
            disableClose: true
        });
        addFaqDialogRef.afterClosed().subscribe(function (result) {
            _this.faqDisplayDetail = result;
            _this.setPage(1);
        });
    };
    FaqComponent.prototype.editFaq = function (row) {
        var _this = this;
        var editFaqDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__add_edit_faq_add_edit_faq_component__["a" /* AddEditFaqComponent */], {
            width: '40%',
            data: {
                FaqDisplayDetail: this.faqDisplayDetail,
                SelectedFAQDetail: row
            },
            disableClose: true
        });
        editFaqDialogRef.afterClosed().subscribe(function (result) {
            _this.faqDisplayDetail = result;
            _this.setPage(_this.pager.currentPage);
        });
    };
    FaqComponent.prototype.deleteFaq = function (row) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire({
            title: 'Delete FAQ',
            text: 'Are you sure you want to delete the FAQ?',
            showCancelButton: true,
            showConfirmButton: true,
            showCloseButton: true,
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            confirmButtonColor: '#FFCA28'
        }).then(function (result) {
            if (result.isConfirmed) {
                _this.appLoader.open();
                _this.licenseService.deleteFAQ(row.FAQId, Number(localStorage.getItem('userid'))).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.faqDisplayDetail = data.DataObject;
                        _this.setPage(_this.pager.currentPage);
                    }
                    _this.appLoader.close();
                });
            }
        });
    };
    FaqComponent.prototype.importFaq = function () {
        var _this = this;
        var importFaqDialogComponent = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__import_faq_import_faq_component__["a" /* ImportFaqComponent */], {
            width: '50%',
            height: '70%',
            data: {
                FaqDisplayDetail: this.faqDisplayDetail,
            },
            disableClose: true
        });
        importFaqDialogComponent.afterClosed().subscribe(function (result) {
            _this.faqDisplayDetail = result;
            _this.setPage(1);
        });
    };
    FaqComponent.prototype.setPage = function (page) {
        this.pager = this.pagerService.getPager(this.faqDisplayDetail.length, page);
        this.pagedItems = this.faqDisplayDetail.slice(this.pager.startIndex, this.pager.endIndex + 1);
    };
    FaqComponent.prototype.getFaq = function () {
        var _this = this;
        this.appLoader.open();
        this.licenseService.getFAQWithProductId(__WEBPACK_IMPORTED_MODULE_11__interfaces_LicenseModel__["a" /* LicensePortalProduct */].LZ30).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.faqDisplayDetail = data.DataObject;
                _this.setPage(1);
            }
            _this.appLoader.close();
        });
    };
    FaqComponent.prototype.downloadCsv = function () {
        var jsonData = [];
        this.faqDisplayDetail.forEach(function (element) {
            jsonData.push({
                Question: element.Question,
                Answer: element.Answer,
            });
        });
        this.exportService.exportToCsv(jsonData, 'FAQ');
    };
    FaqComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'faq',
            template: __webpack_require__(1030),
            styles: [__webpack_require__(968)]
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_5__services_ExportToCSVService__["a" /* ExportToCSVService */],
            __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_9__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_10__services_PagerService__["a" /* PagerService */]])
    ], FaqComponent);
    return FaqComponent;
}());



/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenseFilterPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var LicenseFilterPipe = /** @class */ (function () {
    function LicenseFilterPipe() {
    }
    LicenseFilterPipe.prototype.transform = function (info, nameFilter, emailFilter, mobileNOFilter, licenseKeyFilter) {
        if (info.length === 0 || (nameFilter == '' && emailFilter == '' && mobileNOFilter == '' && licenseKeyFilter == '')) {
            return info;
        }
        else {
            return info.filter(function (license) {
                if (nameFilter != '' && emailFilter != '' && mobileNOFilter != '' && licenseKeyFilter != '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.MobileNo === mobileNOFilter && license.LicenseKey.toLowerCase() === licenseKeyFilter.toLowerCase());
                }
                else if (nameFilter != '' && emailFilter == '' && mobileNOFilter != '' && licenseKeyFilter != '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.MobileNo === mobileNOFilter && license.LicenseKey.toLowerCase() === licenseKeyFilter.toLowerCase());
                }
                else if (nameFilter != '' && emailFilter != '' && mobileNOFilter == '' && licenseKeyFilter != '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.LicenseKey.toLowerCase() === licenseKeyFilter.toLowerCase());
                }
                else if (nameFilter != '' && emailFilter != '' && mobileNOFilter != '' && licenseKeyFilter == '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.MobileNo === mobileNOFilter);
                }
                else if (nameFilter == '' && emailFilter != '' && mobileNOFilter != '' && licenseKeyFilter != '') {
                    return (license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.MobileNo === mobileNOFilter && license.LicenseKey.toLowerCase() === licenseKeyFilter.toLowerCase());
                }
                else if (nameFilter == '' && emailFilter == '' && mobileNOFilter != '' && licenseKeyFilter != '') {
                    return (license.MobileNo === mobileNOFilter && license.LicenseKey.toLowerCase() === licenseKeyFilter.toLowerCase());
                }
                else if (nameFilter == '' && emailFilter != '' && mobileNOFilter == '' && licenseKeyFilter != '') {
                    return (license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.LicenseKey.toLowerCase() === licenseKeyFilter.toLowerCase());
                }
                else if (nameFilter == '' && emailFilter != '' && mobileNOFilter != '' && licenseKeyFilter == '') {
                    return (license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.MobileNo === mobileNOFilter);
                }
                else if (nameFilter != '' && emailFilter != '' && mobileNOFilter != '' && licenseKeyFilter != '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.MobileNo === mobileNOFilter && license.LicenseKey.toLowerCase() === licenseKeyFilter.toLowerCase());
                }
                else if (nameFilter != '' && emailFilter == '' && mobileNOFilter == '' && licenseKeyFilter == '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase());
                }
                else if (nameFilter != '' && emailFilter == '' && mobileNOFilter == '' && licenseKeyFilter != '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.LicenseKey.toLowerCase() === licenseKeyFilter.toLowerCase());
                }
                else if (nameFilter != '' && emailFilter == '' && mobileNOFilter != '' && licenseKeyFilter == '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.MobileNo === mobileNOFilter);
                }
                else if (nameFilter == '' && emailFilter != '' && mobileNOFilter == '' && licenseKeyFilter == '') {
                    return (license.EmailId.toLowerCase() === emailFilter.toLowerCase());
                }
                else if (nameFilter != '' && emailFilter != '' && mobileNOFilter == '' && licenseKeyFilter == '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase() === emailFilter.toLowerCase());
                }
                else if (nameFilter == '' && emailFilter == '' && mobileNOFilter != '' && licenseKeyFilter == '') {
                    return (license.MobileNo === mobileNOFilter);
                }
                else if (nameFilter == '' && emailFilter == '' && mobileNOFilter == '' && licenseKeyFilter != '') {
                    return (license.LicenseKey.toLowerCase() === licenseKeyFilter.toLowerCase());
                }
            });
        }
    };
    LicenseFilterPipe = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
            name: 'smartlinkDemoLicenseFilter'
        })
    ], LicenseFilterPipe);
    return LicenseFilterPipe;
}());



/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenseModuleGltComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generate_glt_license_generate_glt_license_component__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_ExportToCSVService__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_PagerService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_UserService__ = __webpack_require__(25);











var LicenseModuleGltComponent = /** @class */ (function () {
    function LicenseModuleGltComponent(dialog, licenseService, appLoader, adalService, router, route, exportService, pagerService, userService) {
        var _this = this;
        this.dialog = dialog;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.adalService = adalService;
        this.router = router;
        this.route = route;
        this.exportService = exportService;
        this.pagerService = pagerService;
        this.userService = userService;
        this.error = "";
        this.originalGltLicenseDisplayDetail = [];
        this.gltLicenseDisplayDetail = [];
        this.pager = {};
        this.pagedItems = [];
        this.currentSortColumn = '';
        this.currentSortOrder = '';
        if (!this.adalService.getCachedToken()) {
            setTimeout(function () {
                _this.router.navigate(["login"]);
            }, 100);
        }
        appLoader.close();
        route.params.subscribe(function (params) {
            _this.ProductId = params['productId'];
        });
        this.getUserRights();
        this.getLicenseDetail();
    }
    LicenseModuleGltComponent.prototype.setPage = function (page) {
        this.gltLicenseDisplayDetail = this.originalGltLicenseDisplayDetail.slice();
        this.applySort();
        this.pager = this.pagerService.getPager(this.gltLicenseDisplayDetail.length, page);
        this.pagedItems = this.gltLicenseDisplayDetail.slice(this.pager.startIndex, this.pager.endIndex + 1);
    };
    LicenseModuleGltComponent.prototype.openGenerateKeyDialog = function () {
        var _this = this;
        var gltGenerateKeyDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__generate_glt_license_generate_glt_license_component__["a" /* GenerateGltLicenseComponent */], {
            width: '40%',
            disableClose: true,
            data: {
                gltLicenseData: this.originalGltLicenseDisplayDetail,
                SelectedLicenseDetail: null
            }
        });
        gltGenerateKeyDialogRef.afterClosed().subscribe(function (result) {
            _this.originalGltLicenseDisplayDetail = result;
            _this.gltLicenseDisplayDetail = _this.originalGltLicenseDisplayDetail.slice();
            _this.setPage(1);
        });
    };
    LicenseModuleGltComponent.prototype.getUserRights = function () {
        var _this = this;
        var UserId = Number(localStorage.getItem('userid'));
        this.userService.getUserLicenseRightById(UserId, this.ProductId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.IsAddEdit = data.DataObject.IsAddEdit;
                _this.IsDelete = data.DataObject.IsDelete;
            }
        });
    };
    LicenseModuleGltComponent.prototype.getLicenseDetail = function () {
        var _this = this;
        this.appLoader.open();
        this.licenseService.getGltLicenseDetail().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.originalGltLicenseDisplayDetail = data.DataObject;
                _this.gltLicenseDisplayDetail = _this.originalGltLicenseDisplayDetail.slice();
                _this.setPage(1);
                _this.appLoader.close();
            }
            else {
                _this.error = data.Error;
                _this.appLoader.close();
            }
        });
    };
    LicenseModuleGltComponent.prototype.onEdit = function (row) {
        var _this = this;
        var gltGenerateKeyEditDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__generate_glt_license_generate_glt_license_component__["a" /* GenerateGltLicenseComponent */], {
            width: "40%",
            disableClose: true,
            data: {
                gltLicenseData: this.originalGltLicenseDisplayDetail,
                SelectedLicenseDetail: row
            }
        });
        gltGenerateKeyEditDialogRef.afterClosed().subscribe(function (result) {
            _this.originalGltLicenseDisplayDetail = result;
            _this.gltLicenseDisplayDetail = _this.originalGltLicenseDisplayDetail.slice();
            _this.setPage(_this.pager.currentPage);
        });
    };
    LicenseModuleGltComponent.prototype.exportToCSV = function () {
        var jsonData = [];
        if (this.gltLicenseDisplayDetail) {
            this.gltLicenseDisplayDetail.forEach(function (element) {
                jsonData.push({
                    Customer: element.CustomerName,
                    TabletSerialNo: element.TabletSerialNo,
                    'Unique H/W Id': element.CustomerUniqueKey,
                    LicenseKey: element.LicenseKey,
                    SUAExpirationDate: element.SUAExpirationDate
                });
            });
            this.exportService.exportToCsv(jsonData, 'GLT');
        }
        else {
            __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.fire({
                title: 'No data',
                text: 'There is no data available to export to CSV file.',
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: '#FFCA28'
            });
        }
    };
    LicenseModuleGltComponent.prototype.onSortChange = function (event) {
        this.currentSortColumn = event.column;
        this.currentSortOrder = event.order;
        this.setPage(this.pager.currentPage);
    };
    LicenseModuleGltComponent.prototype.applySort = function () {
        var _this = this;
        if (!this.currentSortColumn || !this.currentSortOrder)
            return;
        this.gltLicenseDisplayDetail = this.gltLicenseDisplayDetail.sort(function (a, b) {
            if (_this.currentSortOrder === 'asc') {
                return a[_this.currentSortColumn].localeCompare(b[_this.currentSortColumn]);
            }
            else if (_this.currentSortOrder === 'desc') {
                return b[_this.currentSortColumn].localeCompare(a[_this.currentSortColumn]);
            }
            else {
                return 0;
            }
        });
    };
    LicenseModuleGltComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'license-glt',
            template: __webpack_require__(1033),
            styles: [__webpack_require__(971)],
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_5__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_5__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_8__services_ExportToCSVService__["a" /* ExportToCSVService */],
            __WEBPACK_IMPORTED_MODULE_9__services_PagerService__["a" /* PagerService */],
            __WEBPACK_IMPORTED_MODULE_10__services_UserService__["a" /* UserService */]])
    ], LicenseModuleGltComponent);
    return LicenseModuleGltComponent;
}());



/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenseModuleLz30Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__add_lz30_device_add_lz30_device_component__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__add_lz30_device_license_request_add_lz30_device_license_request_component__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_lz30_purchase_history_view_lz30_purchase_history_component__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_ExportToCSVService__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_PagerService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__extend_LZ30_trial_period_extend_LZ30_trial_period_component__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__view_lz30_device_history_view_lz30_device_history_component__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pipes_lz30DeviceInfoFilterPipe__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pipes_lz30PurchaseLicenseFilterPipe__ = __webpack_require__(348);

















var LicenseModuleLz30Component = /** @class */ (function () {
    function LicenseModuleLz30Component(licenseService, dialog, appLoader, adalService, router, exportService, pagerService, route, userService, demoFilterPipe, purchaseFilterPipe) {
        var _this = this;
        this.licenseService = licenseService;
        this.dialog = dialog;
        this.appLoader = appLoader;
        this.adalService = adalService;
        this.router = router;
        this.exportService = exportService;
        this.pagerService = pagerService;
        this.route = route;
        this.userService = userService;
        this.demoFilterPipe = demoFilterPipe;
        this.purchaseFilterPipe = purchaseFilterPipe;
        this.title = "LZ-30";
        this.originalUserDeviceDisplayDetail = [];
        this.userDeviceDisplayDetail = [];
        this.searchName = '';
        this.searchEmailId = '';
        this.searchMobileNo = '';
        this.searchSerialNoInDeviceTab = '';
        this.searchSerialNoInPurchaseTab = '';
        this.searchBillToName = '';
        this.searchShipToName = '';
        this.filterName = '';
        this.filterEmailId = '';
        this.filterMobileNo = '';
        this.filterSerialNoInDeviceTab = '';
        this.filterSerialNoInPurchaseTab = '';
        this.filterBillTo = '';
        this.filterShipTo = '';
        this.lz30PurchaseLicenseDetailList = [];
        this.originalLz30PurchaseLicenseDetailList = [];
        this.filteredLz30PurchaseLicenseDetailList = [];
        this.UserDeviceDetail = [];
        this.expandedRow = null;
        this.error = '';
        this.serialNoList = [];
        this.BillToList = [];
        this.ShipToList = [];
        this.isLoading = false;
        this.demoPager = {};
        this.purchasePager = {};
        this.errorMessageDemoPage = "";
        this.errorMessagePurchasePage = "";
        this.purchaseCurrentSortOrder = '';
        this.purchaseCurrentSortColumn = '';
        this.deviceCurrentSortOrder = '';
        this.deviceCurrentSortColumn = '';
        // this.appLoader.open()
        if (!this.adalService.getCachedToken()) {
            setTimeout(function () {
                _this.router.navigate(["login"]);
            }, 100);
        }
        appLoader.close();
        this.route.params.subscribe(function (params) {
            _this.ProductId = params['productId'];
        });
        this.getUserRights();
        this.getUserDeviceDisplayDetail();
        this.getLz30PurchaseLicenseDetail();
    }
    LicenseModuleLz30Component.prototype.getUserRights = function () {
        var _this = this;
        var UserId = Number(localStorage.getItem('userid'));
        this.userService.getUserLicenseRightById(UserId, this.ProductId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.IsAddEdit = data.DataObject.IsAddEdit;
                _this.IsDelete = data.DataObject.IsDelete;
            }
        });
    };
    LicenseModuleLz30Component.prototype.getUserDeviceDisplayDetail = function () {
        var _this = this;
        this.licenseService.getLz30UserDeviceDisplayDetail().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.originalUserDeviceDisplayDetail = data.DataObject;
                _this.userDeviceDisplayDetail = _this.originalUserDeviceDisplayDetail.slice();
                _this.setPageForDemo(1);
                // this.createSerialNoList();
            }
        });
    };
    LicenseModuleLz30Component.prototype.getLz30PurchaseLicenseDetail = function () {
        var _this = this;
        this.licenseService.getLz30PurchaseLicenseDisplayDetail().subscribe(function (data) {
            if (!data.IsError && data.DataObject) {
                _this.originalLz30PurchaseLicenseDetailList = data.DataObject;
                _this.lz30PurchaseLicenseDetailList = _this.originalLz30PurchaseLicenseDetailList.slice();
                _this.buildSearchArray();
                _this.setPageForPurchase(1);
            }
            else {
                _this.error = data.Error;
            }
            _this.appLoader.close();
        });
    };
    // createSerialNoList(){
    //     this.userDeviceDisplayDetail.forEach((device)=>{
    //         this.serialNoList.push(device.DeviceSerialNo)
    //     })
    // }
    LicenseModuleLz30Component.prototype.expandRow = function (index, row) {
        var _this = this;
        this.isLoading = true;
        this.expandedRow = this.expandedRow === index ? null : index;
        if (this.expandedRow != null) {
            this.UserDeviceDetail = [];
            this.licenseService.getLZ30LicenseDetail(row.LZ30UserDeviceId).subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    _this.UserDeviceDetail = data.DataObject;
                }
                else {
                }
                _this.isLoading = false;
            });
        }
    };
    LicenseModuleLz30Component.prototype.buildSearchArray = function () {
        var BillToArray = this.lz30PurchaseLicenseDetailList.map(function (item) { return item.BillToName; });
        var ShipToArray = this.lz30PurchaseLicenseDetailList.map(function (item) { return item.ShipToName; });
        this.BillToList = Array.from(new Set(BillToArray)).sort();
        this.ShipToList = Array.from(new Set(ShipToArray)).sort();
    };
    LicenseModuleLz30Component.prototype.addDevice = function () {
        var _this = this;
        var addLz30DialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_4__add_lz30_device_add_lz30_device_component__["a" /* AddEditLZ30DeviceComponent */], {
            width: "40%",
            height: "40%",
            disableClose: true,
            data: {
                userDeviceDisplayData: this.originalUserDeviceDisplayDetail,
                SelectedDeviceDetail: null
            }
        });
        addLz30DialogRef.afterClosed().subscribe(function (result) {
            _this.originalUserDeviceDisplayDetail = result;
            _this.userDeviceDisplayDetail = _this.originalUserDeviceDisplayDetail.slice();
            _this.setPageForDemo(1);
        });
    };
    LicenseModuleLz30Component.prototype.extendLZ30TrialPeriod = function (row) {
        var _this = this;
        var extendLZ30TrialPeriodDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_13__extend_LZ30_trial_period_extend_LZ30_trial_period_component__["a" /* ExtendLZ30TrialPeriod */], {
            width: '40%',
            height: '40%',
            disableClose: true,
            data: {
                userDeviceDisplayData: this.originalUserDeviceDisplayDetail,
                SelectedDeviceDetail: row
            }
        });
        extendLZ30TrialPeriodDialogRef.afterClosed().subscribe(function (result) {
            _this.originalUserDeviceDisplayDetail = result;
            _this.userDeviceDisplayDetail = _this.originalUserDeviceDisplayDetail.slice();
            _this.setPageForDemo(_this.demoPager.currentPage);
        });
    };
    LicenseModuleLz30Component.prototype.viewDeviceHistory = function (row) {
        var videDeviceHistoryDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_14__view_lz30_device_history_view_lz30_device_history_component__["a" /* ViewLZ30DeviceHistory */], {
            width: '60%',
            height: '80%',
            disableClose: true,
            data: {
                userDeviceDisplayData: this.originalUserDeviceDisplayDetail,
                SelectedDeviceDetail: row
            }
        });
    };
    LicenseModuleLz30Component.prototype.addNewDeviceLicenseRequest = function () {
        var _this = this;
        var addNewDeviceLicenseRequestDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__add_lz30_device_license_request_add_lz30_device_license_request_component__["a" /* AddLz30DeviceLicenseRequest */], {
            width: '60%',
            height: '80%',
            disableClose: true,
            data: {
                userDeviceDisplayData: this.originalUserDeviceDisplayDetail,
                purchaseLicenseDisplayData: this.originalLz30PurchaseLicenseDetailList,
                SelectedCustomerDetail: null
            }
        });
        addNewDeviceLicenseRequestDialogRef.afterClosed().subscribe(function (result) {
            _this.originalLz30PurchaseLicenseDetailList = result;
            _this.lz30PurchaseLicenseDetailList = _this.originalLz30PurchaseLicenseDetailList.slice();
            _this.expandedRow = null;
            _this.setPageForPurchase(1);
        });
    };
    LicenseModuleLz30Component.prototype.addMoreLicenseRequest = function (row) {
        var _this = this;
        var addMoreDeviceLicenseRequestDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__add_lz30_device_license_request_add_lz30_device_license_request_component__["a" /* AddLz30DeviceLicenseRequest */], {
            width: '60%',
            height: '80%',
            disableClose: true,
            data: {
                userDeviceDisplayData: this.originalUserDeviceDisplayDetail,
                purchaseLicenseDisplayData: this.originalLz30PurchaseLicenseDetailList,
                SelectedCustomerDetail: row
            }
        });
        addMoreDeviceLicenseRequestDialogRef.afterClosed().subscribe(function (result) {
            _this.originalLz30PurchaseLicenseDetailList = result;
            _this.lz30PurchaseLicenseDetailList = _this.originalLz30PurchaseLicenseDetailList.slice();
            _this.expandedRow = null;
            _this.setPageForPurchase(_this.purchasePager.currentPage);
        });
    };
    LicenseModuleLz30Component.prototype.viewLz30PurchaseLicenseHistory = function (row) {
        var _this = this;
        var viewLz30PurchaseLicenseHistory = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__view_lz30_purchase_history_view_lz30_purchase_history_component__["a" /* ViewLZ30PurchaseLicenseHistory */], {
            width: '60%',
            height: '80%',
            disableClose: true,
            data: {
                SelectedCustomerDetail: row,
                userDeviceDisplayData: this.originalUserDeviceDisplayDetail,
                purchaseLicenseDisplayData: this.originalLz30PurchaseLicenseDetailList,
            }
        });
        viewLz30PurchaseLicenseHistory.afterClosed().subscribe(function (result) {
            _this.originalLz30PurchaseLicenseDetailList = result;
            _this.lz30PurchaseLicenseDetailList = _this.originalLz30PurchaseLicenseDetailList.slice();
        });
    };
    LicenseModuleLz30Component.prototype.setPageForDemo = function (page) {
        this.userDeviceDisplayDetail = this.originalUserDeviceDisplayDetail.slice();
        this.deviceApplySort();
        this.filteredUserDeviceDisplayDetail = this.demoFilterPipe.transform(this.userDeviceDisplayDetail, this.filterName, this.filterEmailId, this.filterMobileNo, this.filterSerialNoInDeviceTab);
        this.demoPager = this.pagerService.getPager(this.filteredUserDeviceDisplayDetail.length, page);
        this.demoPageItems = this.filteredUserDeviceDisplayDetail.slice(this.demoPager.startIndex, this.demoPager.endIndex + 1);
        this.errorMessageDemoPage = (this.demoPageItems.length == 0) ? "No records found." : "";
    };
    LicenseModuleLz30Component.prototype.setPageForPurchase = function (page) {
        this.lz30PurchaseLicenseDetailList = this.originalLz30PurchaseLicenseDetailList.slice();
        this.purchaseApplySort();
        this.filteredLz30PurchaseLicenseDetailList = this.purchaseFilterPipe.transform(this.lz30PurchaseLicenseDetailList, this.filterBillTo, this.filterShipTo, this.filterSerialNoInPurchaseTab);
        this.purchasePager = this.pagerService.getPager(this.filteredLz30PurchaseLicenseDetailList.length, page);
        this.purchasePageItems = this.filteredLz30PurchaseLicenseDetailList.slice(this.purchasePager.startIndex, this.purchasePager.endIndex + 1);
        this.errorMessagePurchasePage = (this.purchasePageItems.length == 0) ? "No records found." : "";
    };
    LicenseModuleLz30Component.prototype.onEdit = function (row) {
        var _this = this;
        var editLz30Dialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_4__add_lz30_device_add_lz30_device_component__["a" /* AddEditLZ30DeviceComponent */], {
            width: "40%",
            height: "40%",
            data: {
                userDeviceDisplayData: this.originalUserDeviceDisplayDetail,
                SelectedCustomerDetail: row
            }
        });
        editLz30Dialog.afterClosed().subscribe(function (result) {
            _this.originalUserDeviceDisplayDetail = result;
            _this.userDeviceDisplayDetail = _this.originalUserDeviceDisplayDetail.slice();
            console.log(_this.demoPager.currentPage);
            _this.setPageForDemo(_this.demoPager.currentPage);
        });
    };
    LicenseModuleLz30Component.prototype.exportDeviceInfo = function () {
        var jsonData = [];
        if (this.userDeviceDisplayDetail) {
            this.userDeviceDisplayDetail.forEach(function (element) {
                jsonData.push({
                    Name: element.Name,
                    EmailId: element.EmailId,
                    MobileNo: element.Mobile,
                    MACAddress: element.MACAddress,
                    SerialNo: element.DeviceSerialNo,
                    StartDate: element.StartDate,
                    EndDate: element.EndDate,
                    LicenseType: element.LicenseType,
                    FeedBackDate: element.FeedbackDate
                });
            });
            this.exportService.exportToCsv(jsonData, 'LZ30DemoLicenseInfo');
        }
        else {
            __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.fire({
                title: 'No data',
                text: 'There is no data available to export to CSV file.',
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: '#FFCA28'
            });
        }
    };
    LicenseModuleLz30Component.prototype.exportDevicePurchaseInfo = function () {
        var jsonData = [];
        if (this.lz30PurchaseLicenseDetailList) {
            this.lz30PurchaseLicenseDetailList.forEach(function (element) {
                jsonData.push({
                    BillToName: element.BillToName,
                    BillToAddress1: element.BillToAddress1,
                    BillToAddress2: element.BillToAddress2,
                    BillToCity: element.BillToCity,
                    BillToState: element.BillToState,
                    BillToZipcode: element.BillToZipcode,
                    BillToCountryCode: element.BillToCountryCode,
                    ShipToName: element.ShipToName,
                    ShipToAddress1: element.ShipToAddress1,
                    ShipToAddress2: element.ShipToAddress2,
                    ShipToCity: element.ShipToCity,
                    ShipToState: element.ShipToState,
                    ShipToZipcode: element.ShipToZipcode,
                    ShipToCountryCode: element.ShipToCountryCode,
                    TotalDevicePurchased: element.TotalNoOfDevicePurchased
                });
            });
            this.exportService.exportToCsv(jsonData, 'LZ30PurchaseLicenseInfo');
        }
        else {
            __WEBPACK_IMPORTED_MODULE_10_sweetalert2___default.a.fire({
                title: 'No data',
                text: 'There is no data available to export to CSV file.',
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: '#FFCA28'
            });
        }
    };
    LicenseModuleLz30Component.prototype.searchDeviceInfo = function () {
        this.filterName = this.searchName;
        this.filterEmailId = this.searchEmailId;
        this.filterMobileNo = this.searchMobileNo;
        this.filterSerialNoInDeviceTab = this.searchSerialNoInDeviceTab;
        this.setPageForDemo(1);
    };
    LicenseModuleLz30Component.prototype.searchPurchaseInfo = function () {
        this.filterSerialNoInPurchaseTab = this.searchSerialNoInPurchaseTab;
        this.filterBillTo = this.searchBillToName;
        this.filterShipTo = this.searchShipToName;
        this.expandedRow = null;
        this.setPageForPurchase(1);
    };
    LicenseModuleLz30Component.prototype.clearDeviceInfo = function () {
        this.searchName = this.filterName = '';
        this.searchEmailId = this.filterEmailId = '';
        this.searchMobileNo = this.filterMobileNo = '';
        this.filterSerialNoInDeviceTab = this.searchSerialNoInDeviceTab = '';
        this.setPageForDemo(1);
    };
    LicenseModuleLz30Component.prototype.clearPurchaseInfo = function () {
        this.filterSerialNoInPurchaseTab = this.searchSerialNoInPurchaseTab = '';
        this.filterBillTo = this.searchBillToName = '';
        this.filterShipTo = this.searchShipToName = '';
        this.expandedRow = null;
        this.setPageForPurchase(1);
    };
    LicenseModuleLz30Component.prototype.onPurchaseSortChange = function (event) {
        this.purchaseCurrentSortColumn = event.column;
        this.purchaseCurrentSortOrder = event.order;
        this.setPageForPurchase(this.purchasePager.currentPage);
    };
    LicenseModuleLz30Component.prototype.purchaseApplySort = function () {
        var _this = this;
        if (!this.purchaseCurrentSortColumn || !this.purchaseCurrentSortOrder)
            return;
        this.lz30PurchaseLicenseDetailList = this.lz30PurchaseLicenseDetailList.sort(function (a, b) {
            if (_this.purchaseCurrentSortOrder === 'asc') {
                a[_this.purchaseCurrentSortColumn] = a[_this.purchaseCurrentSortColumn] || '';
                return a[_this.purchaseCurrentSortColumn].localeCompare(b[_this.purchaseCurrentSortColumn]);
            }
            else if (_this.purchaseCurrentSortOrder === 'desc') {
                b[_this.purchaseCurrentSortColumn] = b[_this.purchaseCurrentSortColumn] || '';
                return b[_this.purchaseCurrentSortColumn].localeCompare(a[_this.purchaseCurrentSortColumn]);
            }
            else {
                return 0;
            }
        });
    };
    LicenseModuleLz30Component.prototype.onDeviceSortChange = function (event) {
        this.deviceCurrentSortColumn = event.column;
        this.deviceCurrentSortOrder = event.order;
        this.setPageForDemo(this.demoPager.currentPage);
    };
    LicenseModuleLz30Component.prototype.deviceApplySort = function () {
        var _this = this;
        if (!this.deviceCurrentSortColumn || !this.deviceCurrentSortOrder)
            return;
        this.userDeviceDisplayDetail = this.userDeviceDisplayDetail.sort(function (a, b) {
            if (_this.deviceCurrentSortOrder === 'asc') {
                a[_this.deviceCurrentSortColumn] = a[_this.deviceCurrentSortColumn] || '';
                return a[_this.deviceCurrentSortColumn].localeCompare(b[_this.deviceCurrentSortColumn]);
            }
            else if (_this.deviceCurrentSortOrder === 'desc') {
                b[_this.deviceCurrentSortColumn] = b[_this.deviceCurrentSortColumn] || '';
                return b[_this.deviceCurrentSortColumn].localeCompare(a[_this.deviceCurrentSortColumn]);
            }
            else {
                return 0;
            }
        });
    };
    LicenseModuleLz30Component = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'license-lz30',
            template: __webpack_require__(1038),
            styles: [__webpack_require__(975)],
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_2__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_7__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_9__services_ExportToCSVService__["a" /* ExportToCSVService */],
            __WEBPACK_IMPORTED_MODULE_11__services_PagerService__["a" /* PagerService */],
            __WEBPACK_IMPORTED_MODULE_7__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_12__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_15__pipes_lz30DeviceInfoFilterPipe__["a" /* Lz30DeviceInfoFilterPipe */],
            __WEBPACK_IMPORTED_MODULE_16__pipes_lz30PurchaseLicenseFilterPipe__["a" /* LZ30PurchaseLicenseFilterPipe */]])
    ], LicenseModuleLz30Component);
    return LicenseModuleLz30Component;
}());



/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Lz30DeviceInfoFilterPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var Lz30DeviceInfoFilterPipe = /** @class */ (function () {
    function Lz30DeviceInfoFilterPipe() {
    }
    Lz30DeviceInfoFilterPipe.prototype.transform = function (info, nameFilter, emailFilter, mobileNOFilter, serialNoFilter) {
        if (info.length === 0 || (nameFilter == '' && emailFilter == '' && mobileNOFilter == '' && serialNoFilter == '')) {
            return info;
        }
        else {
            return info.filter(function (license) {
                if (nameFilter != '' && emailFilter != '' && mobileNOFilter != '' && serialNoFilter != '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.Mobile === mobileNOFilter && license.DeviceSerialNo === serialNoFilter);
                }
                else if (nameFilter != '' && emailFilter == '' && mobileNOFilter != '' && serialNoFilter != '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.Mobile === mobileNOFilter && license.DeviceSerialNo === serialNoFilter);
                }
                else if (nameFilter != '' && emailFilter != '' && mobileNOFilter == '' && serialNoFilter != '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.DeviceSerialNo === serialNoFilter);
                }
                else if (nameFilter != '' && emailFilter != '' && mobileNOFilter != '' && serialNoFilter == '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.Mobile === mobileNOFilter);
                }
                else if (nameFilter == '' && emailFilter != '' && mobileNOFilter != '' && serialNoFilter != '') {
                    return (license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.Mobile === mobileNOFilter && license.DeviceSerialNo === serialNoFilter);
                }
                else if (nameFilter == '' && emailFilter == '' && mobileNOFilter != '' && serialNoFilter != '') {
                    return (license.Mobile === mobileNOFilter && license.DeviceSerialNo === serialNoFilter);
                }
                else if (nameFilter == '' && emailFilter != '' && mobileNOFilter == '' && serialNoFilter != '') {
                    return (license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.DeviceSerialNo === serialNoFilter);
                }
                else if (nameFilter == '' && emailFilter != '' && mobileNOFilter != '' && serialNoFilter == '') {
                    return (license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.Mobile === mobileNOFilter);
                }
                else if (nameFilter != '' && emailFilter != '' && mobileNOFilter != '' && serialNoFilter != '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase() === emailFilter.toLowerCase() && license.Mobile === mobileNOFilter && license.DeviceSerialNo === serialNoFilter);
                }
                else if (nameFilter != '' && emailFilter == '' && mobileNOFilter == '' && serialNoFilter == '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase());
                }
                else if (nameFilter != '' && emailFilter == '' && mobileNOFilter == '' && serialNoFilter != '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.DeviceSerialNo === serialNoFilter);
                }
                else if (nameFilter != '' && emailFilter == '' && mobileNOFilter != '' && serialNoFilter == '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.Mobile === mobileNOFilter);
                }
                else if (nameFilter == '' && emailFilter != '' && mobileNOFilter == '' && serialNoFilter == '') {
                    return (license.EmailId.toLowerCase() === emailFilter.toLowerCase());
                }
                else if (nameFilter != '' && emailFilter != '' && mobileNOFilter == '' && serialNoFilter == '') {
                    return (license.Name.trim().toLowerCase() === nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase() === emailFilter.toLowerCase());
                }
                else if (nameFilter == '' && emailFilter == '' && mobileNOFilter != '' && serialNoFilter == '') {
                    return (license.Mobile === mobileNOFilter);
                }
                else if (nameFilter == '' && emailFilter == '' && mobileNOFilter == '' && serialNoFilter != '') {
                    return (license.DeviceSerialNo === serialNoFilter);
                }
            });
        }
    };
    Lz30DeviceInfoFilterPipe = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
            name: 'Lz30DeviceInfoFilterPipe'
        })
    ], Lz30DeviceInfoFilterPipe);
    return Lz30DeviceInfoFilterPipe;
}());



/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LZ30PurchaseLicenseFilterPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var LZ30PurchaseLicenseFilterPipe = /** @class */ (function () {
    function LZ30PurchaseLicenseFilterPipe() {
    }
    LZ30PurchaseLicenseFilterPipe.prototype.transform = function (info, filterBillToName, filterShipToName, filterSerialNo) {
        if (info.length === 0 || (filterBillToName == '' && filterShipToName == '' && filterSerialNo == '')) {
            return info;
        }
        else {
            return info.filter(function (item) {
                var serialNoList = item.DeviceSerialNos.split(',');
                if (filterBillToName != '' && filterShipToName != '' && filterSerialNo != '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && item.ShipToName.toLowerCase() === filterShipToName.toLowerCase() && serialNoList.some(function (serialNo) { return serialNo === filterSerialNo; }));
                }
                else if (filterBillToName == '' && filterShipToName != '' && filterSerialNo != '') {
                    return (item.ShipToName.toLowerCase() === filterShipToName.toLowerCase() && serialNoList.some(function (serialNo) { return serialNo === filterSerialNo; }));
                }
                else if (filterBillToName != '' && filterShipToName == '' && filterSerialNo != '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && serialNoList.some(function (serialNo) { return serialNo === filterSerialNo; }));
                }
                else if (filterBillToName != '' && filterShipToName != '' && filterSerialNo == '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && item.ShipToName.toLowerCase() === filterShipToName.toLowerCase());
                }
                else if (filterBillToName == '' && filterShipToName == '' && filterSerialNo != '') {
                    return (serialNoList.some(function (serialNo) { return serialNo === filterSerialNo; }));
                }
                else if (filterBillToName != '' && filterShipToName == '' && filterSerialNo == '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase());
                }
                else if (filterBillToName == '' && filterShipToName != '' && filterSerialNo == '') {
                    return (item.ShipToName.toLowerCase() === filterShipToName.toLowerCase());
                }
            });
        }
    };
    LZ30PurchaseLicenseFilterPipe = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
            name: 'lz30PurchaseLicenseFilterPipe'
        })
    ], LZ30PurchaseLicenseFilterPipe);
    return LZ30PurchaseLicenseFilterPipe;
}());



/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scal360FilterPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var Scal360FilterPipe = /** @class */ (function () {
    function Scal360FilterPipe() {
    }
    Scal360FilterPipe.prototype.transform = function (info, filterScalType, filterBillToName, filterShipToName, filterLicenseKey) {
        if (info.length === 0 || (filterBillToName == '' && filterShipToName == '' && filterLicenseKey == '' && filterScalType == '')) {
            return info;
        }
        else {
            return info.filter(function (item) {
                var LicenseKeyList = item.LicenseKey.split(',');
                if (filterBillToName != '' && filterShipToName != '' && filterLicenseKey != '' && filterScalType == '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && item.ShipToName.toLowerCase() === filterShipToName.toLowerCase() && LicenseKeyList.some(function (licenseKey) { return licenseKey.toLowerCase() === filterLicenseKey.toLowerCase(); }));
                }
                else if (filterBillToName == '' && filterShipToName != '' && filterLicenseKey != '' && filterScalType == '') {
                    return (item.ShipToName.toLowerCase() === filterShipToName.toLowerCase() && LicenseKeyList.some(function (licenseKey) { return licenseKey.toLowerCase() === filterLicenseKey.toLowerCase(); }));
                }
                else if (filterBillToName != '' && filterShipToName == '' && filterLicenseKey != '' && filterScalType == '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && LicenseKeyList.some(function (licenseKey) { return licenseKey.toLowerCase() === filterLicenseKey.toLowerCase(); }));
                }
                else if (filterBillToName != '' && filterShipToName != '' && filterLicenseKey == '' && filterScalType == '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && item.ShipToName.toLowerCase() === filterShipToName.toLowerCase());
                }
                else if (filterBillToName == '' && filterShipToName == '' && filterLicenseKey != '' && filterScalType == '') {
                    return (LicenseKeyList.some(function (licenseKey) { return licenseKey.toLowerCase() === filterLicenseKey.toLowerCase(); }));
                }
                else if (filterBillToName != '' && filterShipToName == '' && filterLicenseKey == '' && filterScalType == '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase());
                }
                else if (filterBillToName == '' && filterShipToName != '' && filterLicenseKey == '' && filterScalType == '') {
                    return (item.ShipToName.toLowerCase() === filterShipToName.toLowerCase());
                }
                else if (filterBillToName != '' && filterShipToName != '' && filterLicenseKey != '' && filterScalType != '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && item.ShipToName.toLowerCase() === filterShipToName.toLowerCase() && LicenseKeyList.some(function (licenseKey) { return licenseKey.toLowerCase() === filterLicenseKey.toLowerCase(); }) && item.SCALType.toLowerCase() === filterScalType.toLowerCase());
                }
                else if (filterBillToName == '' && filterShipToName != '' && filterLicenseKey != '' && filterScalType != '') {
                    return (item.ShipToName.toLowerCase() === filterShipToName.toLowerCase() && LicenseKeyList.some(function (licenseKey) { return licenseKey.toLowerCase() === filterLicenseKey.toLowerCase(); }) && item.SCALType.toLowerCase() === filterScalType.toLowerCase());
                }
                else if (filterBillToName != '' && filterShipToName == '' && filterLicenseKey != '' && filterScalType != '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && LicenseKeyList.some(function (licenseKey) { return licenseKey.toLowerCase() === filterLicenseKey.toLowerCase(); }) && item.SCALType.toLowerCase() === filterScalType.toLowerCase());
                }
                else if (filterBillToName != '' && filterShipToName != '' && filterLicenseKey == '' && filterScalType != '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && item.ShipToName.toLowerCase() === filterShipToName.toLowerCase() && item.SCALType.toLowerCase() === filterScalType.toLowerCase());
                }
                else if (filterBillToName == '' && filterShipToName == '' && filterLicenseKey != '' && filterScalType != '') {
                    return (LicenseKeyList.some(function (licenseKey) { return licenseKey.toLowerCase() === filterLicenseKey.toLowerCase(); }) && item.SCALType.toLowerCase() === filterScalType.toLowerCase());
                }
                else if (filterBillToName != '' && filterShipToName == '' && filterLicenseKey == '' && filterScalType != '') {
                    return (item.BillToName.toLowerCase() === filterBillToName.toLowerCase() && item.SCALType.toLowerCase() === filterScalType.toLowerCase());
                }
                else if (filterBillToName == '' && filterShipToName != '' && filterLicenseKey == '' && filterScalType != '') {
                    return (item.ShipToName.toLowerCase() === filterShipToName.toLowerCase() && item.SCALType.toLowerCase() === filterScalType.toLowerCase());
                }
                else if (filterBillToName == '' && filterShipToName == '' && filterLicenseKey == '' && filterScalType != '') {
                    return (item.SCALType.toLowerCase() === filterScalType.toLowerCase());
                }
            });
        }
    };
    Scal360FilterPipe = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
            name: 'Scal360FilterPipe',
        })
    ], Scal360FilterPipe);
    return Scal360FilterPipe;
}());



/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenseModuleScal360Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__generate_scal360_license_generate_scal360_license_component__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__activate_scal360_license_activate_scal360_license_component__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_scal360_purchase_history_view_scal360_purchase_history_component__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__renew_scal360_license_renew_scal360_license_component__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__view_scal360_license_information_view_scal360_license_information_component__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_scal360_activation_history_view_scal360_activation_history_component__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__view_scal360_renewal_history_view_scal360_renewal_history_component__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__view_scal360_download_release_history_view_scal360_download_release_history_component__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_ExportToCSVService__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_PagerService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pipes_scal360FilterPipe__ = __webpack_require__(349);




















var LicenseModuleScal360Component = /** @class */ (function () {
    function LicenseModuleScal360Component(dialog, licenseService, appLoader, snackBar, adalService, router, exportService, route, pagerService, userService, filterPipe) {
        var _this = this;
        this.dialog = dialog;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.router = router;
        this.exportService = exportService;
        this.route = route;
        this.pagerService = pagerService;
        this.userService = userService;
        this.filterPipe = filterPipe;
        this.SCALTypeEnum = __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__["g" /* SCALType */];
        this.filterBillToName = '';
        this.filterShipToName = '';
        this.filterLicenseKey = '';
        this.filterSCALType = '';
        this.searchBillToName = '';
        this.searchShipToName = '';
        this.searchLicenseKey = '';
        this.searchSCALType = '';
        this.BillToList = [];
        this.ShipToList = [];
        this.scal360LicenseList = [];
        this.originalScal360LicenseList = [];
        this.filteredScal360LicenseList = [];
        this.errorMessage = '';
        this.SCALTypeList = [];
        this.expandedRow = null;
        this.isLoading = false;
        this.customerLicenseDetails = [];
        this.pager = {};
        this.pagedItems = [];
        if (!this.adalService.getCachedToken()) {
            setTimeout(function () {
                _this.router.navigate(["login"]);
            }, 100);
        }
        appLoader.close();
        route.params.subscribe(function (params) {
            _this.ProductId = params['productId'];
        });
        this.getUserRights();
        this.getScalPurchaseLicenseDisplayDetails();
        Object.keys(__WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__["g" /* SCALType */]).filter(function (type) { return isNaN(Number(type)); }).forEach(function (key, index) {
            _this.SCALTypeList.push({
                name: key,
                value: __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__["g" /* SCALType */][key]
            });
        });
    }
    LicenseModuleScal360Component.prototype.getUserRights = function () {
        var _this = this;
        var UserId = Number(localStorage.getItem('userid'));
        this.userService.getUserLicenseRightById(UserId, this.ProductId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.IsAddEdit = data.DataObject.IsAddEdit;
                _this.IsDelete = data.DataObject.IsDelete;
            }
        });
    };
    LicenseModuleScal360Component.prototype.expandRow = function (index, row) {
        var _this = this;
        this.isLoading = true;
        this.expandedRow = this.expandedRow === index ? null : index;
        if (this.expandedRow != null) {
            this.customerLicenseDetails = [];
            this.licenseService.getScalCustomerLicenseDetailForActivationAndRenewal(row.LicenseId).subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    _this.customerLicenseDetails = data.DataObject;
                }
                else {
                }
                _this.isLoading = false;
            });
        }
    };
    LicenseModuleScal360Component.prototype.openGenerateNewLicenseRequestDialog = function () {
        var _this = this;
        var generateNewLicenseRequestDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__generate_scal360_license_generate_scal360_license_component__["a" /* GenerateSCAL30LicenseComponent */], {
            width: '60%',
            height: '70%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: null,
                scalOperation: __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__["i" /* SCALOperations */]['add']
            },
            disableClose: true
        });
        generateNewLicenseRequestDialogRef.afterClosed().subscribe(function (result) {
            _this.originalScal360LicenseList = result;
            _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
            _this.expandedRow = null;
            _this.setPage(1);
        });
    };
    LicenseModuleScal360Component.prototype.editLicenseRequestDialog = function (row) {
        var _this = this;
        var editLicenseRequestDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__generate_scal360_license_generate_scal360_license_component__["a" /* GenerateSCAL30LicenseComponent */], {
            width: '60%',
            height: '80%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row,
                scalOperation: __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__["i" /* SCALOperations */]['edit']
            },
            disableClose: true
        });
        editLicenseRequestDialogRef.afterClosed().subscribe(function (result) {
            _this.originalScal360LicenseList = result;
            _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
            _this.expandedRow = null;
            _this.setPage(_this.pager.currentPage);
        });
    };
    LicenseModuleScal360Component.prototype.addMoreLicenseRequestDialog = function (row) {
        var _this = this;
        var addMoreLicenseRequestDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__generate_scal360_license_generate_scal360_license_component__["a" /* GenerateSCAL30LicenseComponent */], {
            width: '60%',
            height: '80%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row,
                scalOperation: __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__["i" /* SCALOperations */]['addMore']
            },
            disableClose: true
        });
        addMoreLicenseRequestDialogRef.afterClosed().subscribe(function (result) {
            _this.originalScal360LicenseList = result;
            _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
            _this.expandedRow = null;
            _this.setPage(_this.pager.currentPage);
        });
    };
    LicenseModuleScal360Component.prototype.renewScalLicense = function (row) {
        var _this = this;
        var renewScalLicenseDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_9__renew_scal360_license_renew_scal360_license_component__["a" /* RenewScal360LicenseComponent */], {
            width: '60%',
            height: '80%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row,
            },
            disableClose: true
        });
        renewScalLicenseDialogRef.afterClosed().subscribe(function (result) {
            _this.originalScal360LicenseList = result;
            _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
            _this.expandedRow = null;
            _this.setPage(_this.pager.currentPage);
        });
    };
    LicenseModuleScal360Component.prototype.viewScal360LicenseInformation = function (row) {
        var _this = this;
        var viewScalLicenseInformationDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_10__view_scal360_license_information_view_scal360_license_information_component__["a" /* ViewScal360LicenseInformationComponent */], {
            width: '60%',
            height: '80%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row,
            },
            disableClose: true
        });
        viewScalLicenseInformationDialogRef.afterClosed().subscribe(function (result) {
            _this.originalScal360LicenseList = result;
            _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
        });
    };
    LicenseModuleScal360Component.prototype.viewScal360PurchaseHistory = function (row) {
        var _this = this;
        var viewScal360PurchaseHistoryDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__view_scal360_purchase_history_view_scal360_purchase_history_component__["a" /* ViewScal360PurchaseHistoryComponent */], {
            width: '60%',
            height: '80%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row,
            },
            disableClose: true
        });
        viewScal360PurchaseHistoryDialogRef.afterClosed().subscribe(function (result) {
            _this.originalScal360LicenseList = result;
            _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
        });
    };
    LicenseModuleScal360Component.prototype.activateScalLicense = function (row) {
        var _this = this;
        var activateLicenseDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__activate_scal360_license_activate_scal360_license_component__["a" /* ActivateScal360LicenseComponent */], {
            width: '60%',
            height: '80%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row
            },
            disableClose: true
        });
        activateLicenseDialogRef.afterClosed().subscribe(function (result) {
            _this.originalScal360LicenseList = result;
            _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
            _this.setPage(_this.pager.currentPage);
            _this.expandedRow = null;
        });
    };
    LicenseModuleScal360Component.prototype.viewScalActivationHistory = function (row) {
        var _this = this;
        var activationHistoryDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_11__view_scal360_activation_history_view_scal360_activation_history_component__["a" /* ViewScal360ActivationHistoryComponent */], {
            width: '40%',
            height: '70%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row
            },
            disableClose: true
        });
        activationHistoryDialogRef.afterClosed().subscribe(function (result) {
            _this.originalScal360LicenseList = result;
            _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
            _this.setPage(_this.pager.currentPage);
            console.log(_this.scal360LicenseList);
        });
    };
    LicenseModuleScal360Component.prototype.viewScalRenewalHistory = function (row) {
        var _this = this;
        var renewalHistoryDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_12__view_scal360_renewal_history_view_scal360_renewal_history_component__["a" /* ViewScal360RenewalHistoryComponent */], {
            width: '40%',
            height: '70%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row
            },
            disableClose: true
        });
        renewalHistoryDialogRef.afterClosed().subscribe(function (result) {
            _this.originalScal360LicenseList = result;
            _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
        });
    };
    LicenseModuleScal360Component.prototype.viewScalDownloadReleaseHistory = function (row) {
        var _this = this;
        var scalDownloadReleaseHistoryDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_13__view_scal360_download_release_history_view_scal360_download_release_history_component__["a" /* ViewScal360DownloadReleaseHistoryComponent */], {
            width: '40%',
            height: '70%',
            data: {
                Scal360LicenseData: this.originalScal360LicenseList,
                SelectedLicenseDetail: row
            },
            disableClose: true
        });
        scalDownloadReleaseHistoryDialogRef.afterClosed().subscribe(function (result) {
            _this.originalScal360LicenseList = result;
            _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
        });
    };
    LicenseModuleScal360Component.prototype.deleteCustomerLicense = function (row) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
            title: 'Delete License',
            text: 'Are you sure you want to delete the license?',
            showCancelButton: true,
            showCloseButton: true,
            showConfirmButton: true,
            confirmButtonColor: '#FFCA28',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(function (result) {
            if (result.isConfirmed) {
                var model = {
                    LicenseId: row.LicenseId,
                    UpdatedBy: Number(localStorage.getItem('userid'))
                };
                _this.appLoader.open();
                _this.licenseService.deleteScalCustomerLicense(model).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.originalScal360LicenseList = data.DataObject;
                        _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
                        _this.setPage(_this.pager.currentPage);
                        _this.appLoader.close();
                    }
                    _this.appLoader.close();
                });
            }
        });
    };
    LicenseModuleScal360Component.prototype.deleteParticularLicenseKey = function (row, mainlicense, mainlicensedetails) {
        var _this = this;
        if (mainlicensedetails.length == 1) {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                title: "Delete License",
                text: "Are you sure you want to delete this license? This action will permanently remove all license information associated with the customer.",
                showCancelButton: true,
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: "#FFCA28",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then(function (result) {
                if (result.isConfirmed) {
                    var model = {
                        LicenseId: mainlicense.LicenseId,
                        UpdatedBy: Number(localStorage.getItem("userid")),
                    };
                    _this.appLoader.open();
                    _this.licenseService
                        .deleteScalCustomerLicense(model)
                        .subscribe(function (data) {
                        if (!data.IsError && data.DataObject != null) {
                            _this.originalScal360LicenseList = data.DataObject;
                            _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
                            _this.expandedRow = null;
                            _this.setPage(_this.pager.currentPage);
                            _this.appLoader.close();
                        }
                    });
                }
            });
        }
        else {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                title: "Delete License",
                text: "Are you sure you want to delete the license?",
                showCancelButton: true,
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: "#FFCA28",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then(function (result) {
                if (result.isConfirmed) {
                    var model = {
                        LicenseId: row.LicenseId,
                        LicenseDetailId: row.LicenseDetailId,
                        UpdatedBy: Number(localStorage.getItem("userid")),
                    };
                    _this.appLoader.open();
                    _this.licenseService
                        .deleteParticularCustomerParticularLicense(model)
                        .subscribe(function (data) {
                        if (!data.IsError && data.DataObject != null) {
                            _this.originalScal360LicenseList = data.DataObject;
                            _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
                            _this.expandedRow = null;
                            _this.setPage(_this.pager.currentPage);
                            _this.appLoader.close();
                        }
                        else {
                            _this.appLoader.close();
                            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                                title: "Error",
                                text: data.Error,
                                showConfirmButton: true,
                                confirmButtonColor: "#FFCA28",
                            });
                            return;
                        }
                    });
                }
            });
        }
    };
    LicenseModuleScal360Component.prototype.setPage = function (page) {
        this.scal360LicenseList = this.originalScal360LicenseList.slice();
        this.applySort();
        this.filteredScal360LicenseList = this.filterPipe.transform(this.scal360LicenseList, this.filterSCALType, this.filterBillToName, this.filterShipToName, this.filterLicenseKey);
        this.pager = this.pagerService.getPager(this.filteredScal360LicenseList.length, page);
        this.pagedItems = this.filteredScal360LicenseList.slice(this.pager.startIndex, this.pager.endIndex + 1);
        this.errorMessage = (this.pagedItems.length == 0) ? "No records found." : "";
    };
    LicenseModuleScal360Component.prototype.exportToCSV = function () {
        var jsonData = [];
        if (this.scal360LicenseList) {
            this.scal360LicenseList.forEach(function (element) {
                jsonData.push({
                    BillToName: element.BillToName,
                    BillToAddress1: element.BillToAddress1,
                    BillToAddress2: element.BillToAddress2,
                    BillToCity: element.BillToCity,
                    BillToState: element.BillToState,
                    BillToZipcode: element.BillToZipcode,
                    BillToCountryCode: element.BillToCountryCode,
                    ShipToName: element.ShipToName,
                    ShipToAddress1: element.ShipToAddress1,
                    ShipToAddress2: element.ShipToAddress2,
                    ShipToCity: element.ShipToCity,
                    ShipToState: element.ShipToState,
                    ShipToZipcode: element.ShipToZipcode,
                    ShipToCountryCode: element.ShipToCountryCode,
                    LicenseType: element.LicenseType,
                    ScalType: element.SCALType,
                    LicensePurchased: element.NoOfLicensePurchased,
                    LicenseActivated: element.TotalNoOfLicenseActivated
                });
            });
            this.exportService.exportToCsv(jsonData, 'SCAL360');
        }
        else {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                title: 'No data',
                text: 'There is no data available to export to CSV file.',
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: '#FFCA28'
            });
        }
    };
    LicenseModuleScal360Component.prototype.clearSearch = function () {
        this.searchBillToName = this.filterBillToName = '';
        this.searchShipToName = this.filterShipToName = '';
        this.searchLicenseKey = this.filterLicenseKey = '';
        this.searchSCALType = this.filterSCALType = '';
        this.expandedRow = null;
        this.setPage(1);
        // this.getBillingShippingDetail('SO-0002995');
    };
    LicenseModuleScal360Component.prototype.search = function () {
        this.filterBillToName = this.searchBillToName;
        this.filterShipToName = this.searchShipToName;
        this.filterLicenseKey = this.searchLicenseKey;
        this.filterSCALType = this.searchSCALType ? __WEBPACK_IMPORTED_MODULE_5__interfaces_LicenseModel__["g" /* SCALType */][this.searchSCALType] : '';
        this.expandedRow = null;
        this.setPage(1);
        // console.log(this.filterBillToName,this.filterShipToName,this.filterLicenseKey,this.filterSCALType)
    };
    LicenseModuleScal360Component.prototype.getScalPurchaseLicenseDisplayDetails = function () {
        var _this = this;
        this.appLoader.open();
        this.licenseService.getScalPurchaseLicenseDisplayDetails().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.originalScal360LicenseList = data.DataObject;
                _this.scal360LicenseList = _this.originalScal360LicenseList.slice();
                _this.setPage(1);
                _this.buildSearchArray();
            }
            else {
            }
            _this.appLoader.close();
        });
    };
    LicenseModuleScal360Component.prototype.buildSearchArray = function () {
        var BillToArray = this.scal360LicenseList.map(function (item) { return item.BillToName; });
        var ShipToArray = this.scal360LicenseList.map(function (item) { return item.ShipToName; });
        this.BillToList = Array.from(new Set(BillToArray)).sort();
        this.ShipToList = Array.from(new Set(ShipToArray)).sort();
    };
    LicenseModuleScal360Component.prototype.onSortChange = function (event) {
        this.currentSortColumn = event.column;
        this.currentSortOrder = event.order;
        this.setPage(this.pager.currentPage);
    };
    LicenseModuleScal360Component.prototype.applySort = function () {
        var _this = this;
        if (!this.currentSortColumn || !this.currentSortOrder)
            return;
        this.scal360LicenseList = this.scal360LicenseList.sort(function (a, b) {
            if (_this.currentSortOrder === 'asc') {
                a[_this.currentSortColumn] = a[_this.currentSortColumn] || '';
                return a[_this.currentSortColumn].localeCompare(b[_this.currentSortColumn]);
            }
            else if (_this.currentSortOrder === 'desc') {
                b[_this.currentSortColumn] = b[_this.currentSortColumn] || '';
                return b[_this.currentSortColumn].localeCompare(a[_this.currentSortColumn]);
            }
            else {
                return 0;
            }
        });
    };
    LicenseModuleScal360Component = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'license-scal360',
            template: __webpack_require__(1044),
            styles: [__webpack_require__(981)],
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_2__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_3__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_15__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_14__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_16__services_ExportToCSVService__["a" /* ExportToCSVService */],
            __WEBPACK_IMPORTED_MODULE_14__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_17__services_PagerService__["a" /* PagerService */],
            __WEBPACK_IMPORTED_MODULE_18__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_19__pipes_scal360FilterPipe__["a" /* Scal360FilterPipe */]])
    ], LicenseModuleScal360Component);
    return LicenseModuleScal360Component;
}());



/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenseModuleService360Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generate_service360_license_generate_service360_license_component__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service360_view_activation_details_service360_view_activation_details_component__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_ExportToCSVService__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_PagerService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pipes_service360FilterPipe__ = __webpack_require__(202);













var LicenseModuleService360Component = /** @class */ (function () {
    function LicenseModuleService360Component(dialog, licenseService, appLoader, snackBar, adalService, router, exportService, pagerService, route, userService, filterPipe) {
        var _this = this;
        this.dialog = dialog;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.router = router;
        this.exportService = exportService;
        this.pagerService = pagerService;
        this.route = route;
        this.userService = userService;
        this.filterPipe = filterPipe;
        this.filterBillToName = '';
        this.filterShipToName = '';
        this.filterLicenseKey = '';
        this.searchBillToName = '';
        this.searchShipToName = '';
        this.searchLicenseKey = '';
        this.BillToList = [];
        this.ShipToList = [];
        this.service360LicenseList = [];
        this.originalService360LicenseList = [];
        this.filteredService360LicenseList = [];
        this.errorMessage = '';
        this.pager = {};
        if (!this.adalService.getCachedToken()) {
            setTimeout(function () {
                _this.router.navigate(["login"]);
            }, 100);
        }
        appLoader.close();
        route.params.subscribe(function (params) {
            _this.ProductId = params['productId'];
        });
        this.getUserRights();
        this.getService360LicenseDisplayDetail();
    }
    LicenseModuleService360Component.prototype.getUserRights = function () {
        var _this = this;
        var UserId = Number(localStorage.getItem('userid'));
        this.userService.getUserLicenseRightById(UserId, this.ProductId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.IsAddEdit = data.DataObject.IsAddEdit;
                _this.IsDelete = data.DataObject.IsDelete;
            }
        });
    };
    LicenseModuleService360Component.prototype.setPage = function (page) {
        this.service360LicenseList = this.originalService360LicenseList.slice();
        this.applySort();
        this.filteredService360LicenseList = this.filterPipe.transform(this.service360LicenseList, this.filterBillToName, this.filterShipToName, this.filterLicenseKey);
        this.pager = this.pagerService.getPager(this.filteredService360LicenseList.length, page);
        this.pagedItems = this.filteredService360LicenseList.slice(this.pager.startIndex, this.pager.endIndex + 1);
        this.errorMessage = (this.pagedItems.length == 0) ? "No records found." : "";
    };
    LicenseModuleService360Component.prototype.openGenerateNewLicenseRequestDialog = function () {
        var _this = this;
        var generateNewLicenseRequestDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__generate_service360_license_generate_service360_license_component__["a" /* GenerateService360LicenseComponent */], {
            data: {
                Service360LicenseData: this.originalService360LicenseList,
                SelectedLicenseDetail: null
            },
            disableClose: true
        });
        generateNewLicenseRequestDialogRef.afterClosed().subscribe(function (result) {
            _this.originalService360LicenseList = result;
            _this.service360LicenseList = _this.originalService360LicenseList.slice();
            _this.setPage(1);
        });
    };
    LicenseModuleService360Component.prototype.exportToCSV = function () {
        var jsonData = [];
        if (this.service360LicenseList) {
            this.service360LicenseList.forEach(function (element) {
                jsonData.push({
                    BillToName: element.BillToName,
                    BillToAddress1: element.BillToAddress1,
                    BillToAddress2: element.BillToAddress2,
                    BillToCity: element.BillToCity,
                    BillToState: element.BillToState,
                    BillToZipcode: element.BillToZipcode,
                    BillToCountryCode: element.BillToCountryCode,
                    ShipToName: element.ShipToName,
                    ShipToAddress1: element.ShipToAddress1,
                    ShipToAddress2: element.ShipToAddress2,
                    ShipToCity: element.ShipToCity,
                    ShipToState: element.ShipToState,
                    ShipToZipcode: element.ShipToZipcode,
                    ShipToCountryCode: element.ShipToCountryCode,
                    LicenseKey: element.LicenseKey,
                    SalesOrderNo: element.SalesOrderNo,
                    ExpiryDate: element.ExpiryDate,
                    NoOfInstallations: element.NoOfInstallation,
                    TotalActivation: element.NoOfActivations
                });
            });
            this.exportService.exportToCsv(jsonData, 'Service360');
        }
        else {
            __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
                title: 'No data',
                text: 'There is no data available to export to CSV file.',
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: '#FFCA28'
            });
        }
    };
    LicenseModuleService360Component.prototype.clearSearch = function () {
        this.filterBillToName = this.searchBillToName = '';
        this.filterShipToName = this.searchShipToName = '';
        this.filterLicenseKey = this.searchLicenseKey = '';
        this.setPage(1);
        // this.getBillingShippingDetail('SO-0002995');
    };
    LicenseModuleService360Component.prototype.search = function () {
        this.filterBillToName = this.searchBillToName;
        this.filterShipToName = this.searchShipToName;
        this.filterLicenseKey = this.searchLicenseKey;
        this.setPage(1);
    };
    LicenseModuleService360Component.prototype.getService360LicenseDisplayDetail = function () {
        var _this = this;
        this.appLoader.open();
        this.licenseService.getService360LicenseDisplayDetail().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.originalService360LicenseList = data.DataObject;
                _this.service360LicenseList = _this.originalService360LicenseList.slice();
                _this.setPage(1);
                _this.buildSearchArray();
            }
            else {
            }
            _this.appLoader.close();
        });
    };
    LicenseModuleService360Component.prototype.onEdit = function (row) {
        var _this = this;
        var editService360LicenseRequest = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__generate_service360_license_generate_service360_license_component__["a" /* GenerateService360LicenseComponent */], {
            data: {
                Service360LicenseData: this.originalService360LicenseList,
                SelectedLicenseDetail: row
            },
            disableClose: true
        });
        editService360LicenseRequest.afterClosed().subscribe(function (result) {
            _this.originalService360LicenseList = result;
            _this.service360LicenseList = _this.originalService360LicenseList.slice();
            _this.setPage(_this.pager.currentPage);
        });
    };
    LicenseModuleService360Component.prototype.buildSearchArray = function () {
        var BillToArray = this.service360LicenseList.map(function (item) { return item.BillToName; });
        var ShipToArray = this.service360LicenseList.map(function (item) { return item.ShipToName; });
        this.BillToList = Array.from(new Set(BillToArray)).sort();
        this.ShipToList = Array.from(new Set(ShipToArray)).sort();
    };
    LicenseModuleService360Component.prototype.viewActivationHistory = function (row) {
        var service360ViewActivationDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__service360_view_activation_details_service360_view_activation_details_component__["a" /* Service360ViewActivationDetailComponent */], {
            width: '40%',
            height: '60%',
            data: {
                SelectedLicenseDetail: row
            }
        });
    };
    LicenseModuleService360Component.prototype.deactivateLicense = function (row) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
            title: "Deactivate License",
            text: "Are you sure you want to deactivate the license?",
            confirmButtonText: "Yes",
            confirmButtonColor: "#FFCA28",
            cancelButtonText: "No",
            showCloseButton: true,
            showConfirmButton: true,
            showCancelButton: true
        }).then(function (result) {
            if (result.isConfirmed) {
                _this.appLoader.open();
                var model = {
                    LicenseId: row.LicenseId,
                    UpdatedBy: Number(localStorage.getItem('userid'))
                };
                _this.licenseService.deactiveService360License(model).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.originalService360LicenseList = data.DataObject;
                        _this.service360LicenseList = _this.originalService360LicenseList.slice();
                        _this.setPage(_this.pager.currentPage);
                        _this.appLoader.close();
                        _this.snackBar.open("License Deactivated successfully.", "", {
                            duration: 2000,
                        });
                    }
                    else {
                        _this.appLoader.close();
                    }
                });
            }
        });
    };
    LicenseModuleService360Component.prototype.activateLicense = function (row) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_5_sweetalert2___default.a.fire({
            title: "Activate License",
            text: "Are you sure you want to activate the license?",
            confirmButtonText: "Yes",
            confirmButtonColor: "#FFCA28",
            cancelButtonText: "No",
            showCloseButton: true,
            showConfirmButton: true,
            showCancelButton: true
        }).then(function (result) {
            if (result.isConfirmed) {
                _this.appLoader.open();
                var model = {
                    LicenseId: row.LicenseId,
                    UpdatedBy: Number(localStorage.getItem('userid'))
                };
                _this.licenseService.activateService360License(model).subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.originalService360LicenseList = data.DataObject;
                        _this.service360LicenseList = _this.originalService360LicenseList.slice();
                        _this.setPage(_this.pager.currentPage);
                        _this.appLoader.close();
                        _this.snackBar.open("License activated successfully.", "", {
                            duration: 2000,
                        });
                    }
                    else {
                        _this.appLoader.close();
                    }
                });
            }
        });
    };
    LicenseModuleService360Component.prototype.onSortChange = function (event) {
        this.currentSortColumn = event.column;
        this.currentSortOrder = event.order;
        this.setPage(this.pager.currentPage);
    };
    LicenseModuleService360Component.prototype.applySort = function () {
        var _this = this;
        if (!this.currentSortColumn || !this.currentSortOrder)
            return;
        this.service360LicenseList = this.service360LicenseList.sort(function (a, b) {
            if (_this.currentSortOrder === 'asc') {
                a[_this.currentSortColumn] = a[_this.currentSortColumn] || '';
                return a[_this.currentSortColumn].localeCompare(b[_this.currentSortColumn]);
            }
            else if (_this.currentSortOrder === 'desc') {
                b[_this.currentSortColumn] = b[_this.currentSortColumn] || '';
                return b[_this.currentSortColumn].localeCompare(a[_this.currentSortColumn]);
            }
            else {
                return 0;
            }
        });
    };
    LicenseModuleService360Component = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'license-service360',
            template: __webpack_require__(1052),
            styles: [__webpack_require__(989)],
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_3__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_7__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_9__services_ExportToCSVService__["a" /* ExportToCSVService */],
            __WEBPACK_IMPORTED_MODULE_10__services_PagerService__["a" /* PagerService */],
            __WEBPACK_IMPORTED_MODULE_7__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_11__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_12__pipes_service360FilterPipe__["a" /* Service360FilterPipe */]])
    ], LicenseModuleService360Component);
    return LicenseModuleService360Component;
}());



/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SmartCal360AssignCustomerFilterPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var SmartCal360AssignCustomerFilterPipe = /** @class */ (function () {
    function SmartCal360AssignCustomerFilterPipe() {
    }
    SmartCal360AssignCustomerFilterPipe.prototype.transform = function (smartCalAssignCustomerList, filterCustomerName) {
        if (smartCalAssignCustomerList.length === 0 || filterCustomerName === '') {
            return smartCalAssignCustomerList;
        }
        else {
            return smartCalAssignCustomerList.filter(function (a) {
                return a.BillToName.toLowerCase() === filterCustomerName.toLowerCase();
            });
        }
    };
    SmartCal360AssignCustomerFilterPipe = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
            name: 'SmartCal360AssignCustomerFilterPipe'
        })
    ], SmartCal360AssignCustomerFilterPipe);
    return SmartCal360AssignCustomerFilterPipe;
}());



/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SmartCal360FilterPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var SmartCal360FilterPipe = /** @class */ (function () {
    function SmartCal360FilterPipe() {
    }
    SmartCal360FilterPipe.prototype.transform = function (smartCalLicenseList, filterSerialNumber) {
        if (smartCalLicenseList.length === 0 || filterSerialNumber === null) {
            return smartCalLicenseList;
        }
        else {
            return smartCalLicenseList.filter(function (a) {
                return a.ProductSerialNo === filterSerialNumber;
            });
        }
    };
    SmartCal360FilterPipe = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
            name: 'SmartCal360FilterPipe'
        })
    ], SmartCal360FilterPipe);
    return SmartCal360FilterPipe;
}());



/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenseModuleSmartcal360Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assign_smartcal360n_customer_assign_smartcal360n_customer_component__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_ExportToCSVService__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_PagerService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pipes_smartcal360FilterPipe__ = __webpack_require__(353);













var LicenseModuleSmartcal360Component = /** @class */ (function () {
    function LicenseModuleSmartcal360Component(dialog, licenseService, appLoader, snackBar, formBuilder, adalService, router, exportService, pagerService, route, userService, filterPipe) {
        var _this = this;
        this.dialog = dialog;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.formBuilder = formBuilder;
        this.adalService = adalService;
        this.router = router;
        this.exportService = exportService;
        this.pagerService = pagerService;
        this.route = route;
        this.userService = userService;
        this.filterPipe = filterPipe;
        this.originalSmartCal360NLicenseList = [];
        this.smartCal360NLicenseList = [];
        this.filteredSmartCal360NLicenseList = [];
        this.errorMessage = '';
        this.submitted = false;
        this.error = '';
        this.selectedLicenseKeyIdList = [];
        this.pager = {};
        this.pagedItems = [];
        this.currentSortColumn = '';
        this.currentSortOrder = '';
        this.filterSerialNumber = null;
        this.serialNoValidationMessage = "Serial number should be greater than zero.";
        if (!this.adalService.getCachedToken()) {
            setTimeout(function () {
                _this.router.navigate(["login"]);
            }, 100);
        }
        appLoader.close();
        route.params.subscribe(function (params) {
            _this.ProductId = params['productId'];
        });
        this.getUserRights();
        this.getSmartCal360NLicenseDisplayDetail();
        this.buildForm();
    }
    LicenseModuleSmartcal360Component.prototype.getUserRights = function () {
        var _this = this;
        var UserId = Number(localStorage.getItem('userid'));
        this.userService.getUserLicenseRightById(UserId, this.ProductId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.IsAddEdit = data.DataObject.IsAddEdit;
                _this.IsDelete = data.DataObject.IsDelete;
            }
        });
    };
    LicenseModuleSmartcal360Component.prototype.selectRow = function (index, selectedRowDetail) {
        this.selectedRow[index] = this.selectedRow[index] == index ? null : index;
    };
    LicenseModuleSmartcal360Component.prototype.buildForm = function () {
        this.smartCal360NLicenseForm = this.formBuilder.group({
            SerialNoFrom: [null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required]],
            SerialNoTo: [null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required]],
            SearchSerialNumber: [null, [__WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].min(1)]]
        });
    };
    LicenseModuleSmartcal360Component.prototype.setPage = function (page) {
        this.smartCal360NLicenseList = this.originalSmartCal360NLicenseList.slice();
        this.applySort();
        this.filteredSmartCal360NLicenseList = this.filterPipe.transform(this.smartCal360NLicenseList, this.filterSerialNumber);
        this.pager = this.pagerService.getPager(this.filteredSmartCal360NLicenseList.length, page);
        this.pagedItems = this.filteredSmartCal360NLicenseList.slice(this.pager.startIndex, this.pager.endIndex + 1);
        this.selectedRow = new Array(this.pagedItems.length).fill(null);
        this.errorMessage = (this.pagedItems.length == 0) ? "No records found." : "";
    };
    LicenseModuleSmartcal360Component.prototype.exportToCSV = function () {
        var jsonData = [];
        if (this.smartCal360NLicenseList) {
            this.smartCal360NLicenseList.forEach(function (element) {
                jsonData.push({
                    ProductSerialNo: element.ProductSerialNo,
                    ProductActivationKey: element.ProductActivationKey,
                    CustomerName: element.CustomerName,
                    CreationDate: element.CreatedDate
                });
            });
            this.exportService.exportToCsv(jsonData, 'SmartCal360N');
        }
        else {
            __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.fire({
                title: 'No data',
                text: 'There is no data available to export to CSV file.',
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: '#FFCA28'
            });
        }
    };
    LicenseModuleSmartcal360Component.prototype.generateSmartCal360NLicenseKey = function () {
        var _this = this;
        this.errorMessage = '';
        this.submitted = true;
        if (this.smartCal360NLicenseForm.controls.SerialNoFrom.errors || this.smartCal360NLicenseForm.controls.SerialNoTo.errors) {
            return;
        }
        if (this.smartCal360NLicenseForm.value.SerialNoFrom < 0 || this.smartCal360NLicenseForm.value.SerialNoTo < 0) {
            this.errorMessage = 'Serial Number cannot be negative';
            return;
        }
        else if (this.smartCal360NLicenseForm.value.SerialNoFrom > this.smartCal360NLicenseForm.value.SerialNoTo) {
            this.errorMessage = 'Serial Number From value cannot be greater than Serial Number To Value';
            return;
        }
        this.appLoader.open();
        var model = {
            ProductSerialNoFrom: this.smartCal360NLicenseForm.value.SerialNoFrom,
            ProductSerialNoTo: this.smartCal360NLicenseForm.value.SerialNoTo,
            CreatedBy: Number(localStorage.getItem('userid'))
        };
        this.licenseService.generatesmartcal360NLicenseKey(model).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.originalSmartCal360NLicenseList = data.DataObject;
                _this.smartCal360NLicenseList = _this.originalSmartCal360NLicenseList.slice();
                _this.setPage(1);
                _this.clear();
            }
            else {
                _this.errorMessage = data.Error;
            }
            _this.appLoader.close();
        });
    };
    LicenseModuleSmartcal360Component.prototype.openAssignCustomerDialog = function () {
        var _this = this;
        for (var i = 0; i < this.selectedRow.length; i++) {
            if (this.selectedRow[i] != null) {
                this.selectedLicenseKeyIdList.push(this.pagedItems[i].SmartCAL360NLicenceKeyId);
            }
        }
        if (this.selectedLicenseKeyIdList.length > 0) {
            var assignSmartCal360NCustomerDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__assign_smartcal360n_customer_assign_smartcal360n_customer_component__["a" /* AssignSmartCal360NCustomerComponent */], {
                width: '80%',
                height: '81%',
                data: {
                    SmartCal360NLicenseData: this.originalSmartCal360NLicenseList,
                    SelectedLicensesId: this.selectedLicenseKeyIdList
                },
                disableClose: true
            });
            assignSmartCal360NCustomerDialogRef.afterClosed().subscribe(function (result) {
                _this.originalSmartCal360NLicenseList = result;
                _this.smartCal360NLicenseList = _this.originalSmartCal360NLicenseList.slice();
                _this.setPage(_this.pager.currentPage);
                _this.selectedRow.fill(null);
                _this.selectedLicenseKeyIdList = [];
            });
        }
        else {
            __WEBPACK_IMPORTED_MODULE_8_sweetalert2___default.a.fire({
                title: 'No Serial Number Selected',
                text: 'Please select at least one Serial Number',
                showConfirmButton: true,
                confirmButtonColor: '#FFCA28'
            });
        }
    };
    LicenseModuleSmartcal360Component.prototype.getSmartCal360NLicenseDisplayDetail = function () {
        var _this = this;
        this.appLoader.open();
        this.licenseService.getSmartCal360NLicenseDetails().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.originalSmartCal360NLicenseList = data.DataObject;
                _this.smartCal360NLicenseList = _this.originalSmartCal360NLicenseList.slice();
                _this.setPage(_this.pager.currentPage);
            }
            else {
            }
            _this.appLoader.close();
        });
    };
    LicenseModuleSmartcal360Component.prototype.clear = function () {
        this.smartCal360NLicenseForm.patchValue({
            SerialNoFrom: null,
            SerialNoTo: null
        });
        this.error = '';
        this.errorMessage = '';
        this.submitted = false;
    };
    LicenseModuleSmartcal360Component.prototype.onSortChange = function (event) {
        this.currentSortColumn = event.column;
        this.currentSortOrder = event.order;
        this.setPage(this.pager.currentPage);
    };
    LicenseModuleSmartcal360Component.prototype.search = function () {
        this.filterSerialNumber = this.smartCal360NLicenseForm.value.SearchSerialNumber;
        this.setPage(1);
    };
    LicenseModuleSmartcal360Component.prototype.clearSearch = function () {
        this.smartCal360NLicenseForm.get('SearchSerialNumber').setValue(null);
        this.filterSerialNumber = null;
        this.setPage(1);
    };
    LicenseModuleSmartcal360Component.prototype.applySort = function () {
        var _this = this;
        if (!this.currentSortColumn || !this.currentSortOrder)
            return;
        this.smartCal360NLicenseList = this.smartCal360NLicenseList.sort(function (a, b) {
            if (_this.currentSortOrder === 'asc') {
                if (typeof a[_this.currentSortColumn] === 'number') {
                    return a[_this.currentSortColumn] - b[_this.currentSortColumn];
                }
                else {
                    a[_this.currentSortColumn] = a[_this.currentSortColumn] || '';
                    return a[_this.currentSortColumn].localeCompare(b[_this.currentSortColumn]);
                }
            }
            else if (_this.currentSortOrder === 'desc') {
                if (typeof a[_this.currentSortColumn] === 'number') {
                    return b[_this.currentSortColumn] - a[_this.currentSortColumn];
                }
                else {
                    b[_this.currentSortColumn] = b[_this.currentSortColumn] || '';
                    return b[_this.currentSortColumn].localeCompare(a[_this.currentSortColumn]);
                }
            }
            else {
                return 0;
            }
        });
    };
    LicenseModuleSmartcal360Component = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'license-smartcal360',
            template: __webpack_require__(1054),
            styles: [__webpack_require__(991)],
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_2__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_3__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_4__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_6__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_9__services_ExportToCSVService__["a" /* ExportToCSVService */],
            __WEBPACK_IMPORTED_MODULE_10__services_PagerService__["a" /* PagerService */],
            __WEBPACK_IMPORTED_MODULE_6__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_11__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_12__pipes_smartcal360FilterPipe__["a" /* SmartCal360FilterPipe */]])
    ], LicenseModuleSmartcal360Component);
    return LicenseModuleSmartcal360Component;
}());



/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenseModuleSmartlink360Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generate_smartlink360_license_generate_smartlink360_license_component__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__smartlink360_view_activation_details_smartlink360_view_activation_details_component__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__smartlink360_renew_license_smartlink360_renew_license_component__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__smartlink360_view_renewal_history_smartlink360_view_renewal_history_component__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__smartlink360_view_feedback_smartlink360_view_feedback_component__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_ExportToCSVService__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_PagerService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__filter_pipe__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__service360_pipes_service360FilterPipe__ = __webpack_require__(202);

















var LicenseModuleSmartlink360Component = /** @class */ (function () {
    function LicenseModuleSmartlink360Component(licenseService, dialog, appLoader, adalService, router, exportService, pagerService, route, userService, demoFilterPipe, purchaseFilterPipe) {
        var _this = this;
        this.licenseService = licenseService;
        this.dialog = dialog;
        this.appLoader = appLoader;
        this.adalService = adalService;
        this.router = router;
        this.exportService = exportService;
        this.pagerService = pagerService;
        this.route = route;
        this.userService = userService;
        this.demoFilterPipe = demoFilterPipe;
        this.purchaseFilterPipe = purchaseFilterPipe;
        this.originalDemoLicenseData = [];
        this.demoLicenseData = [];
        this.filteredDemoLicenseData = [];
        this.searchName = '';
        this.searchEmailId = '';
        this.searchMobileNo = '';
        this.searchShipTo = '';
        this.searchBillTo = '';
        this.searchDemoLicenseKey = '';
        this.searchPurchaseLicenseKey = '';
        this.filterName = '';
        this.filterEmailId = '';
        this.filterMobileNo = '';
        this.filterDemoLicenseKey = '';
        this.filterBillTo = '';
        this.filterShipTo = '';
        this.filterPurchaseLicenseKey = '';
        this.originalSmartlinkPurchaseLicenseDetailList = [];
        this.smartlinkPurchaseLicenseDetailList = [];
        this.filteredPurchaseLicenseDetailList = [];
        this.error = '';
        this.BillToList = [];
        this.ShipToList = [];
        this.demoPager = {};
        this.demoPageItems = [];
        this.purchasePager = {};
        this.purchasePageItems = [];
        this.errorMessageDemoPage = "";
        this.errorMessagePurchasePage = "";
        this.purchaseCurrentSortOrder = '';
        this.purchaseCurrentSortColumn = '';
        this.demoCurrentSortOrder = '';
        this.demoCurrentSortColumn = '';
        if (!this.adalService.getCachedToken()) {
            setTimeout(function () {
                _this.router.navigate(["login"]);
            }, 100);
        }
        this.appLoader.open();
        route.params.subscribe(function (params) {
            _this.ProductId = params['productId'];
        });
        this.getUserRights();
        this.getDemoLicenseData();
        this.getPurchaseLicenseData();
        // this.getCustomerDetails();
        // this.demoLicenseData=[{UserRegId:1,Name:'Freyal',EmailId:'freyal123@gmail.com', MobileNo:'345294197', Organization:'Sensit',ExpiryDate:'2021-12-01 14:30:15',LicenseType:'Demo',Status:'InActive',HardwareId:3147,LicenseKey:'2B7E-85E7'},
        //     {Name:'Freyal',EmailId:'freyal123@gmail.com', MobileNo:'345294197', Organization:'Sensit',ExpiryDate:'2021-12-01 14:30:15',LicenseType:'Demo',Status:'Active',HardwareId:3147,LicenseKey:'2B7E-85E7'}
        // ];
    }
    LicenseModuleSmartlink360Component.prototype.getUserRights = function () {
        var _this = this;
        var UserId = Number(localStorage.getItem('userid'));
        this.userService.getUserLicenseRightById(UserId, this.ProductId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.IsAddEdit = data.DataObject.IsAddEdit;
                _this.IsDelete = data.DataObject.IsDelete;
            }
        });
    };
    LicenseModuleSmartlink360Component.prototype.getDemoLicenseData = function () {
        var _this = this;
        this.licenseService.getSmartLinkDemoData().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.originalDemoLicenseData = data.DataObject;
                _this.demoLicenseData = _this.originalDemoLicenseData.slice();
                _this.setPageForDemo(1);
            }
            else {
                _this.error = data.Error;
            }
            _this.appLoader.close();
        });
    };
    LicenseModuleSmartlink360Component.prototype.exportDemoLicenseInfoToCSV = function () {
        var jsonData = [];
        if (this.demoLicenseData) {
            this.demoLicenseData.forEach(function (element) {
                jsonData.push({
                    Name: element.Name,
                    EmailId: element.EmailId,
                    MobileNo: element.MobileNo,
                    Organisation: element.Organization,
                    ExpiryDate: element.ExpiryDate,
                    LicenseType: element.LicenseType,
                    HardwareId: element.HardwareId,
                    LicenseKey: element.LicenseKey,
                    Status: element.Status
                });
            });
            this.exportService.exportToCsv(jsonData, 'SmartLink360DemoLicense');
        }
        else {
            __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.fire({
                title: 'No data',
                text: 'There is no data available to export to CSV file.',
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: '#FFCA28'
            });
        }
    };
    LicenseModuleSmartlink360Component.prototype.exportPurchaseLicenseData = function () {
        var jsonData = [];
        if (this.smartlinkPurchaseLicenseDetailList) {
            this.smartlinkPurchaseLicenseDetailList.forEach(function (element) {
                jsonData.push({
                    BillToName: element.BillToName,
                    BillToAddress1: element.BillToAddress1,
                    BillToAddress2: element.BillToAddress2,
                    BillToCity: element.BillToCity,
                    BillToState: element.BillToState,
                    BillToZipcode: element.BillToZipcode,
                    BillToCountryCode: element.BillToCountryCode,
                    ShipToName: element.ShipToName,
                    ShipToAddress1: element.ShipToAddress1,
                    ShipToAddress2: element.ShipToAddress2,
                    ShipToCity: element.ShipToCity,
                    ShipToState: element.ShipToState,
                    ShipToZipcode: element.ShipToZipcode,
                    ShipToCountryCode: element.ShipToCountryCode,
                    LicenseKey: element.LicenseKey,
                    SalesOrderNo: element.SalesOrderNo,
                    PurchaseDate: element.PurchaseDate,
                    NoOfMonths: element.NoOfMonths,
                    ExpiryDate: element.ExpiryDate
                });
            });
            this.exportService.exportToCsv(jsonData, 'SmartLink360PurchaseLicense');
        }
        else {
            __WEBPACK_IMPORTED_MODULE_12_sweetalert2___default.a.fire({
                title: 'No data',
                text: 'There is no data available to export to CSV file.',
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: '#FFCA28'
            });
        }
    };
    LicenseModuleSmartlink360Component.prototype.setPageForDemo = function (page) {
        this.demoLicenseData = this.originalDemoLicenseData.slice();
        this.demoApplySort();
        this.filteredDemoLicenseData = this.demoFilterPipe.transform(this.demoLicenseData, this.filterName, this.filterEmailId, this.filterMobileNo, this.filterDemoLicenseKey);
        this.demoPager = this.pagerService.getPager(this.filteredDemoLicenseData.length, page);
        this.demoPageItems = this.filteredDemoLicenseData.slice(this.demoPager.startIndex, this.demoPager.endIndex + 1);
        this.errorMessageDemoPage = (this.demoPageItems.length == 0) ? "No records found." : "";
    };
    LicenseModuleSmartlink360Component.prototype.setPageForPurchase = function (page) {
        this.smartlinkPurchaseLicenseDetailList = this.originalSmartlinkPurchaseLicenseDetailList.slice();
        this.purchaseApplySort();
        this.filteredPurchaseLicenseDetailList = this.purchaseFilterPipe.transform(this.smartlinkPurchaseLicenseDetailList, this.filterBillTo, this.filterShipTo, this.filterPurchaseLicenseKey);
        this.purchasePager = this.pagerService.getPager(this.filteredPurchaseLicenseDetailList.length, page);
        this.purchasePageItems = this.filteredPurchaseLicenseDetailList.slice(this.purchasePager.startIndex, this.purchasePager.endIndex + 1);
        this.errorMessagePurchasePage = (this.purchasePageItems.length == 0) ? "No records found." : "";
    };
    LicenseModuleSmartlink360Component.prototype.buildSearchArray = function () {
        var BillToArray = this.smartlinkPurchaseLicenseDetailList.map(function (item) { return item.BillToName; });
        var ShipToArray = this.smartlinkPurchaseLicenseDetailList.map(function (item) { return item.ShipToName; });
        this.BillToList = Array.from(new Set(BillToArray)).sort();
        this.ShipToList = Array.from(new Set(ShipToArray)).sort();
    };
    LicenseModuleSmartlink360Component.prototype.getPurchaseLicenseData = function () {
        var _this = this;
        this.licenseService.getSmartLinkPurchaseLicenseDisplayDetail().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.originalSmartlinkPurchaseLicenseDetailList = data.DataObject;
                _this.smartlinkPurchaseLicenseDetailList = _this.originalSmartlinkPurchaseLicenseDetailList.slice();
                _this.buildSearchArray();
                _this.setPageForPurchase(1);
            }
            else {
                _this.error = data.Error;
            }
            _this.appLoader.close();
        });
    };
    LicenseModuleSmartlink360Component.prototype.viewFeedback = function (row) {
        var smartlinkFeedbackDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_8__smartlink360_view_feedback_smartlink360_view_feedback_component__["a" /* SmartLink360ViewFeedbackComponent */], {
            disableClose: true,
            width: '60%',
            height: '70%',
            data: {
                SelectedLicenseDetail: row,
            }
        });
    };
    // getCustomerDetails(){
    //     this.licenseService.getCustomerDetails().subscribe((data)=>{
    //         if(!data.IsError && data.DataObject!=null){
    //             console.log(data.DataObject);
    //         }
    //     })
    // }
    LicenseModuleSmartlink360Component.prototype.generateNewLicenseRequest = function () {
        var _this = this;
        var smartLinkGenerateNewLicenseRequestDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_3__generate_smartlink360_license_generate_smartlink360_license_component__["a" /* GenerateSmartLink360LicenseComponent */], {
            disableClose: true,
            data: {
                SelectedLicenseDetail: null,
                Smartlink360PurchaseLicenseData: this.originalSmartlinkPurchaseLicenseDetailList
            }
        });
        smartLinkGenerateNewLicenseRequestDialogRef.afterClosed().subscribe(function (result) {
            _this.originalSmartlinkPurchaseLicenseDetailList = result;
            _this.smartlinkPurchaseLicenseDetailList = _this.originalSmartlinkPurchaseLicenseDetailList.slice();
            _this.setPageForPurchase(1);
        });
    };
    LicenseModuleSmartlink360Component.prototype.viewActivationDetail = function (row) {
        var smartLinkViewActivationDetailialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_5__smartlink360_view_activation_details_smartlink360_view_activation_details_component__["a" /* SmartLink360ViewActivationDetailComponent */], {
            width: '40%',
            height: '60%',
            disableClose: true,
            data: {
                SelectedLicenseData: row,
                Smartlink360PurchaseLicenseData: this.originalSmartlinkPurchaseLicenseDetailList
            }
        });
    };
    LicenseModuleSmartlink360Component.prototype.onEdit = function (row) {
        var _this = this;
        var editSmartLink360LicenseDataDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_3__generate_smartlink360_license_generate_smartlink360_license_component__["a" /* GenerateSmartLink360LicenseComponent */], {
            disableClose: true,
            data: {
                SelectedLicenseDetail: row,
                Smartlink360PurchaseLicenseData: this.originalSmartlinkPurchaseLicenseDetailList
            }
        });
        editSmartLink360LicenseDataDialogRef.afterClosed().subscribe(function (result) {
            _this.originalSmartlinkPurchaseLicenseDetailList = result;
            _this.smartlinkPurchaseLicenseDetailList = _this.originalSmartlinkPurchaseLicenseDetailList.slice();
            _this.setPageForPurchase(_this.purchasePager.currentPage);
        });
    };
    LicenseModuleSmartlink360Component.prototype.renewLicense = function (row) {
        var _this = this;
        var renewScalLicenseDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__smartlink360_renew_license_smartlink360_renew_license_component__["a" /* Smartlink360RenewLicenseComponent */], {
            width: '60%',
            height: '80%',
            data: {
                Smartlink360PurchaseLicenseData: this.originalSmartlinkPurchaseLicenseDetailList,
                SelectedLicenseDetail: row,
            }
        });
        renewScalLicenseDialogRef.afterClosed().subscribe(function (result) {
            _this.originalSmartlinkPurchaseLicenseDetailList = result;
            _this.smartlinkPurchaseLicenseDetailList = _this.originalSmartlinkPurchaseLicenseDetailList.slice();
            _this.setPageForPurchase(_this.purchasePager.currentPage);
        });
    };
    LicenseModuleSmartlink360Component.prototype.viewRenewalHistory = function (row) {
        var renewalHistoryDialogBox = this.dialog.open(__WEBPACK_IMPORTED_MODULE_7__smartlink360_view_renewal_history_smartlink360_view_renewal_history_component__["a" /* SmartLink360ViewRenewalHistoryComponent */], {
            width: '40%',
            height: '60%',
            data: {
                Smartlink360PurchaseLicenseData: this.purchasePageItems,
                SelectedLicenseDetail: row,
            }
        });
    };
    LicenseModuleSmartlink360Component.prototype.searchDemoLicenseInfo = function () {
        this.filterName = this.searchName;
        this.filterEmailId = this.searchEmailId;
        this.filterMobileNo = this.searchMobileNo;
        this.filterDemoLicenseKey = this.searchDemoLicenseKey;
        this.setPageForDemo(1);
    };
    LicenseModuleSmartlink360Component.prototype.clearDemoLicenseInfo = function () {
        this.searchName = this.filterName = '';
        this.searchEmailId = this.filterEmailId = '';
        this.searchMobileNo = this.filterMobileNo = '';
        this.searchDemoLicenseKey = this.filterDemoLicenseKey = '';
        this.setPageForDemo(1);
    };
    LicenseModuleSmartlink360Component.prototype.searchPurchaseLicenseInfo = function () {
        this.filterBillTo = this.searchBillTo;
        this.filterShipTo = this.searchShipTo;
        this.filterPurchaseLicenseKey = this.searchPurchaseLicenseKey;
        this.setPageForPurchase(1);
    };
    LicenseModuleSmartlink360Component.prototype.clearPurchaseLicenseInfo = function () {
        this.filterBillTo = this.searchBillTo = '';
        this.filterShipTo = this.searchShipTo = '';
        this.filterPurchaseLicenseKey = this.searchPurchaseLicenseKey = '';
        this.setPageForPurchase(1);
    };
    LicenseModuleSmartlink360Component.prototype.onPurchaseSortChange = function (event) {
        this.purchaseCurrentSortColumn = event.column;
        this.purchaseCurrentSortOrder = event.order;
        this.setPageForPurchase(this.purchasePager.currentPage);
    };
    LicenseModuleSmartlink360Component.prototype.purchaseApplySort = function () {
        var _this = this;
        if (!this.purchaseCurrentSortColumn || !this.purchaseCurrentSortOrder)
            return;
        this.smartlinkPurchaseLicenseDetailList = this.smartlinkPurchaseLicenseDetailList.sort(function (a, b) {
            if (_this.purchaseCurrentSortOrder === 'asc') {
                a[_this.purchaseCurrentSortColumn] = a[_this.purchaseCurrentSortColumn] || '';
                return a[_this.purchaseCurrentSortColumn].localeCompare(b[_this.purchaseCurrentSortColumn]);
            }
            else if (_this.purchaseCurrentSortOrder === 'desc') {
                b[_this.purchaseCurrentSortColumn] = b[_this.purchaseCurrentSortColumn] || '';
                return b[_this.purchaseCurrentSortColumn].localeCompare(a[_this.purchaseCurrentSortColumn]);
            }
            else {
                return 0;
            }
        });
    };
    LicenseModuleSmartlink360Component.prototype.onDemoSortChange = function (event) {
        this.demoCurrentSortColumn = event.column;
        this.demoCurrentSortOrder = event.order;
        this.setPageForDemo(this.demoPager.currentPage);
    };
    LicenseModuleSmartlink360Component.prototype.demoApplySort = function () {
        var _this = this;
        if (!this.demoCurrentSortColumn || !this.demoCurrentSortOrder)
            return;
        this.demoLicenseData = this.demoLicenseData.sort(function (a, b) {
            if (_this.demoCurrentSortOrder === 'asc') {
                a[_this.demoCurrentSortColumn] = a[_this.demoCurrentSortColumn] || '';
                return a[_this.demoCurrentSortColumn].localeCompare(b[_this.demoCurrentSortColumn]);
            }
            else if (_this.demoCurrentSortOrder === 'desc') {
                b[_this.demoCurrentSortColumn] = b[_this.demoCurrentSortColumn] || '';
                return b[_this.demoCurrentSortColumn].localeCompare(a[_this.demoCurrentSortColumn]);
            }
            else {
                return 0;
            }
        });
    };
    LicenseModuleSmartlink360Component = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'license-smartlink360',
            template: __webpack_require__(1060),
            styles: [__webpack_require__(997)],
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_10__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_9__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_11__services_ExportToCSVService__["a" /* ExportToCSVService */],
            __WEBPACK_IMPORTED_MODULE_13__services_PagerService__["a" /* PagerService */],
            __WEBPACK_IMPORTED_MODULE_9__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_14__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_15__filter_pipe__["a" /* LicenseFilterPipe */],
            __WEBPACK_IMPORTED_MODULE_16__service360_pipes_service360FilterPipe__["a" /* Service360FilterPipe */]])
    ], LicenseModuleSmartlink360Component);
    return LicenseModuleSmartlink360Component;
}());



/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyncITFilterPipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var SyncITFilterPipe = /** @class */ (function () {
    function SyncITFilterPipe() {
    }
    SyncITFilterPipe.prototype.transform = function (items, billToName, shipToName, clientAdminEmail) {
        if (!items || items.length === 0) {
            return [];
        }
        return items.filter(function (item) {
            var matchBillTo = true;
            var matchShipTo = true;
            var matchClientAdmin = true;
            if (billToName && billToName.trim() !== '') {
                matchBillTo = item.BillToName && item.BillToName.toLowerCase().indexOf(billToName.toLowerCase()) !== -1;
            }
            if (shipToName && shipToName.trim() !== '') {
                matchShipTo = item.ShipToName && item.ShipToName.toLowerCase().indexOf(shipToName.toLowerCase()) !== -1;
            }
            if (clientAdminEmail && clientAdminEmail.trim() !== '') {
                matchClientAdmin = item.ClientAdminEmail && item.ClientAdminEmail.toLowerCase().indexOf(clientAdminEmail.toLowerCase()) !== -1;
            }
            return matchBillTo && matchShipTo && matchClientAdmin;
        });
    };
    SyncITFilterPipe = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
            name: 'SyncITFilterPipe'
        })
    ], SyncITFilterPipe);
    return SyncITFilterPipe;
}());



/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddMoreSyncItLicenseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(210);









var AddMoreSyncItLicenseComponent = /** @class */ (function () {
    function AddMoreSyncItLicenseComponent(dialogRef, formBuilder, licenseService, appLoader, snackBar, adalService, router, dialogData) {
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.billingShippingDetail = {
            ODataEtag: "",
            Number: "",
            publicId: "",
            CustomerNo: "",
            publicSalesPersoncode: "",
            BillToName: "",
            BillToAddress1: "",
            BillToAddress2: "",
            BillToCity: "",
            BillToState: "",
            BillToZipcode: "",
            BillToCountryCode: "",
            ShipToCode: "",
            ShipToName: "",
            ShipToAddress1: "",
            ShipToAddress2: "",
            ShipToCity: "",
            ShipToState: "",
            ShipToZipcode: "",
            ShipToCountryCode: "",
            CustomerTelephone: "",
            CustomerEmailAddress: "",
            CustomerFaxno: "",
            ShippingTelephoneno: "",
            ShippingFaxno: "",
            ShippingEmailAddress: "",
            Rep1: "",
            Rep2: "",
            Sales1: "",
            Sales2: "",
        };
        this.isBillingShippingDetailFetched = false;
        this.submitted = false;
        this.customerId = 0;
        this.shippingAddressId = 0;
        this.shouldFetchSalesOrderNo = false;
        this.errorMessage = "";
        this.MAX_TRIAL_INSTRUMENTS = __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* MAX_TRIAL_INSTRUMENTS */];
        this.error = "";
        this.isLoading = false;
        this.prevSalesOrderNo = "";
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.buildForm();
        this.dialogTitle = "Add More SyncIT License";
        this.SyncITProductLicenseId = this.dialogData.SyncITProductLicenseId;
        this.licenseType = this.dialogData.LicenseType;
        this.fetchSyncITLicenseDetails(this.SyncITProductLicenseId);
    }
    AddMoreSyncItLicenseComponent.prototype.buildForm = function () {
        this.syncITLicenseForm = this.formBuilder.group({
            SalesOrderNo: ["", [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]],
            Products: this.formBuilder.array([]),
        });
    };
    AddMoreSyncItLicenseComponent.prototype.blurSalesOrderEvent = function () {
        var _this = this;
        if (this.prevSalesOrderNo.trim().toUpperCase() ==
            this.syncITLicenseForm.value.SalesOrderNo.trim().toUpperCase()) {
            return;
        }
        this.prevSalesOrderNo = this.syncITLicenseForm.value.SalesOrderNo;
        setTimeout(function () {
            _this.shouldFetchSalesOrderNo = true;
            _this.isBillingShippingDetailFetched = false;
        }, 150);
    };
    AddMoreSyncItLicenseComponent.prototype.fetchSyncITLicenseDetails = function (licenseId) {
        var _this = this;
        if (!licenseId)
            return;
        this.appLoader.open();
        this.licenseService.getSyncITLicensePurchaseProduct(licenseId).subscribe(function (res) {
            _this.appLoader.close();
            var productFormGroups = res.DataObject.map(function (product) {
                return _this.formBuilder.group({
                    ProductId: [product.SyncItProductId],
                    ProductName: [product.SyncItProductName],
                    NoOfProductLicense: [product.NoOfProductLicense],
                    NoOfLicense: [0, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].min(0)],
                });
            });
            var productsFormArray = _this.syncITLicenseForm.get("Products");
            productFormGroups.forEach(function (fg) { return productsFormArray.push(fg); });
            productsFormArray.updateValueAndValidity();
            // Ensure FormArray exists
        }, function (err) {
            _this.appLoader.close();
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                icon: "error",
                title: "Error",
                text: "Something went wrong while fetching license data.",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFCA28",
            });
        });
    };
    Object.defineProperty(AddMoreSyncItLicenseComponent.prototype, "productsFormArray", {
        get: function () {
            return this.syncITLicenseForm.get("Products");
        },
        enumerable: true,
        configurable: true
    });
    AddMoreSyncItLicenseComponent.prototype.checkSalesOrderNo = function () {
        var _this = this;
        if (this.dialogData.SyncItLicenseList) {
            var exist = this.dialogData.SyncItLicenseList.some(function (element) {
                if (element.SalesOrderNo != null) {
                    return (_this.syncITLicenseForm.value.SalesOrderNo.trim().toUpperCase() ==
                        element.SalesOrderNo.trim().toUpperCase());
                }
                else {
                    return false;
                }
            });
            if (exist) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    title: "This sales order no already exists",
                    text: "Are you sure you want to use this Sales Order No?",
                    showCancelButton: true,
                    showCloseButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#FFCA28",
                    cancelButtonText: "No",
                }).then(function (result) {
                    if (result.isConfirmed) {
                        _this.shouldFetchSalesOrderNo = true;
                        _this.isBillingShippingDetailFetched = false;
                        _this.getBillingShippingDetail();
                    }
                    else {
                        _this.shouldFetchSalesOrderNo = false;
                        _this.syncITLicenseForm.patchValue({
                            SalesOrderNo: "",
                        });
                    }
                });
            }
            else {
                this.shouldFetchSalesOrderNo = true;
                this.isBillingShippingDetailFetched = false;
                this.getBillingShippingDetail();
            }
        }
        else {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
            this.getBillingShippingDetail();
        }
    };
    AddMoreSyncItLicenseComponent.prototype.getBillingShippingDetail = function () {
        var _this = this;
        var salesOrderNo = this.syncITLicenseForm.value.SalesOrderNo;
        if (salesOrderNo != "") {
            if (this.shouldFetchSalesOrderNo) {
                this.appLoader.open();
                this.licenseService
                    .getBillingShippingDetail(salesOrderNo)
                    .subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.billingShippingDetail = data.DataObject;
                        _this.isBillingShippingDetailFetched = true;
                        _this.error = "";
                    }
                    else {
                        _this.isBillingShippingDetailFetched = false;
                        _this.error = data.Error;
                    }
                    _this.appLoader.close();
                });
            }
            else {
                this.error = "Please select other sales order number.";
            }
        }
        else {
            this.error = "Sales Order No is required";
            this.isBillingShippingDetailFetched = false;
        }
    };
    AddMoreSyncItLicenseComponent.prototype.onSave = function () {
        var _this = this;
        var formValue = this.syncITLicenseForm.getRawValue();
        var totalLicenses = formValue.Products.reduce(function (sum, p) { return sum + (Number(p.NoOfLicense) || 0); }, 0);
        if (totalLicenses === 0) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                icon: "warning",
                title: "No License Selected",
                text: "Please purchase at least one instrument license before saving.",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFCA28",
            });
            return; // Stop saving
        }
        if (this.licenseType == "Trial") {
            var totalLicenses_1 = formValue.Products.reduce(function (sum, p) {
                return sum +
                    (Number(p.NoOfLicense) || 0) +
                    (Number(p.NoOfProductLicense) || 0);
            }, 0);
            if (totalLicenses_1 > this.MAX_TRIAL_INSTRUMENTS) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    icon: "warning",
                    title: "Limit Exceeded",
                    text: "Trial license allows maximum " + this.MAX_TRIAL_INSTRUMENTS + " instruments.",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFCA28",
                });
                return; // stop save
            }
        }
        if (this.syncITLicenseForm.valid) {
            this.appLoader.open();
            var formValue_1 = this.syncITLicenseForm.getRawValue();
            this.licenseService
                .addBillingShippingDetailsSyncIT(this.billingShippingDetail)
                .subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    var payload = {
                        CustomerId: data.DataObject.CustomerId,
                        ShippingAddressId: data.DataObject.ShippingAddressId,
                        NoOfMonths: formValue_1.NoOfMonths,
                        SalesOrderNo: formValue_1.SalesOrderNo,
                        PurchaseDate: formValue_1.PurchaseDate,
                        SyncItProductLicenseId: _this.SyncITProductLicenseId,
                        deviceDetails: formValue_1.Products.filter(function (p) { return p.NoOfLicense > 0; }).map(function (p) { return ({
                            SyncItProductId: p.ProductId,
                            NoOfProductLicense: p.NoOfLicense,
                        }); }),
                    };
                    _this.licenseService.addMoreSyncItLicense(payload).subscribe({
                        next: function (res) {
                            if (!res.IsError) {
                                _this.appLoader.close();
                                _this.dialogRef.close(res.DataObject);
                                _this.snackBar.open("License saved successfully", "", {
                                    duration: 3000,
                                });
                                _this.errorMessage = "";
                                _this.appLoader.close();
                            }
                            else {
                                _this.appLoader.close();
                                _this.errorMessage = res.Error;
                                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                                    icon: "warning",
                                    title: "Trial License Exists",
                                    text: res.Error,
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#FFCA28",
                                });
                            }
                        },
                        error: function (err) {
                            _this.appLoader.close();
                            _this.errorMessage = "Something went wrong.";
                        },
                    });
                }
            });
        }
    };
    AddMoreSyncItLicenseComponent.prototype.onCancel = function () {
        this.dialogRef.close(false);
    };
    Object.defineProperty(AddMoreSyncItLicenseComponent.prototype, "isSaveDisabled", {
        get: function () {
            if (!this.syncITLicenseForm)
                return true;
            // If form invalid → Disable Save
            if (!this.syncITLicenseForm.valid)
                return true;
            // const hasSelectedProduct = this.productsFormArray.controls.some(
            //   (c) => Number(c.value.NoOfLicense) > 0
            // );
            if (!this.isBillingShippingDetailFetched)
                return true;
        },
        enumerable: true,
        configurable: true
    });
    AddMoreSyncItLicenseComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: "addmore-syncit-license",
            styles: [__webpack_require__(998)],
            template: __webpack_require__(1061),
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_5__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_7__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */], Object])
    ], AddMoreSyncItLicenseComponent);
    return AddMoreSyncItLicenseComponent;
}());



/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExtendSyncItTrialPeriodComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_app_loader_app_loader_service__ = __webpack_require__(7);







var ExtendSyncItTrialPeriodComponent = /** @class */ (function () {
    function ExtendSyncItTrialPeriodComponent(licenseService, dialogRef, adalService, router, formBuilder, snackBar, appLoader, dialogData) {
        this.licenseService = licenseService;
        this.dialogRef = dialogRef;
        this.adalService = adalService;
        this.router = router;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        this.appLoader = appLoader;
        this.dialogData = dialogData;
        this.dialogTitle = "Extend Trial Period";
        this.errorMessage = "";
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.SyncITProductLicenseId = dialogData.payload.SyncITProductLicenseId;
        this.buildForm();
        this.SyncItExtendTrialPeriodForm.get("NoOfMonths").setValidators(__WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* Validators */].required);
    }
    ExtendSyncItTrialPeriodComponent.prototype.buildForm = function () {
        this.SyncItExtendTrialPeriodForm = this.formBuilder.group({
            NoOfMonths: [
                "",
                [__WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* Validators */].min(1), __WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* Validators */].max(120)],
            ],
        });
    };
    ExtendSyncItTrialPeriodComponent.prototype.onSave = function () {
        var noOfMonths = this.SyncItExtendTrialPeriodForm.value.NoOfMonths;
        if (!noOfMonths || noOfMonths < 1) {
            this.snackBar.open("Trial months must be at least 1.", "Close", {
                duration: 4000,
            });
            return;
        }
        var model = {
            UpdatedBy: Number(localStorage.getItem("userid")),
            SyncITProductLicenseId: this.SyncITProductLicenseId,
            NoOfMonths: this.SyncItExtendTrialPeriodForm.value.NoOfMonths,
        };
        this.dialogRef.close(model);
    };
    ExtendSyncItTrialPeriodComponent.prototype.onCancel = function () {
        this.dialogRef.close(false);
    };
    ExtendSyncItTrialPeriodComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1062),
            styles: [__webpack_require__(999)],
            selector: "extend-SyncIt-trial-period",
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_4__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_3__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_6__services_app_loader_app_loader_service__["a" /* AppLoaderService */], Object])
    ], ExtendSyncItTrialPeriodComponent);
    return ExtendSyncItTrialPeriodComponent;
}());



/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GenerateSyncITLicenseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(210);









var GenerateSyncITLicenseComponent = /** @class */ (function () {
    function GenerateSyncITLicenseComponent(dialogRef, formBuilder, licenseService, appLoader, snackBar, adalService, router, dialogData) {
        var _this = this;
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = "";
        this.errorMessage = "";
        this.billingShippingDetail = {
            ODataEtag: "",
            Number: "",
            publicId: "",
            CustomerNo: "",
            publicSalesPersoncode: "",
            BillToName: "",
            BillToAddress1: "",
            BillToAddress2: "",
            BillToCity: "",
            BillToState: "",
            BillToZipcode: "",
            BillToCountryCode: "",
            ShipToCode: "",
            ShipToName: "",
            ShipToAddress1: "",
            ShipToAddress2: "",
            ShipToCity: "",
            ShipToState: "",
            ShipToZipcode: "",
            ShipToCountryCode: "",
            CustomerTelephone: "",
            CustomerEmailAddress: "",
            CustomerFaxno: "",
            ShippingTelephoneno: "",
            ShippingFaxno: "",
            ShippingEmailAddress: "",
            Rep1: "",
            Rep2: "",
            Sales1: "",
            Sales2: "",
        };
        this.isBillingShippingDetailFetched = false;
        this.submitted = false;
        this.customerId = 0;
        this.shippingAddressId = 0;
        this.shouldFetchSalesOrderNo = false;
        this.MAX_TRIAL_INSTRUMENTS = __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* MAX_TRIAL_INSTRUMENTS */];
        this.error = "";
        this.isLoading = false;
        this.prevSalesOrderNo = "";
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.buildForm();
        this.syncItproductList = this.dialogData.syncITproducts;
        this.SyncItLicenseList = this.dialogData.SyncITLicenseData;
        this.dialogTitle = this.dialogData.dialogTitle;
        var productFormGroups = this.syncItproductList.map(function (product) {
            return _this.formBuilder.group({
                ProductId: [product.ProductEnum],
                ProductName: [product.SyncITProductName],
                NoOfLicense: [0, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].min(0)],
            });
        });
        var licenseTypeControl = this.syncITLicenseForm.get("LicenseType");
        var productsArray = this.syncITLicenseForm.get("Products");
        // 1️⃣ Populate initial NoOfLicense based on LicenseType
        setTimeout(function () {
            if (licenseTypeControl.value === "1") {
                productsArray.controls.forEach(function (c) { return c.get("NoOfLicense").setValue(5); });
            }
            else {
                productsArray.controls.forEach(function (c) { return c.get("NoOfLicense").setValue(0); });
            }
        }, 0);
        // Listen to LicenseType changes
        this.syncITLicenseForm.get("LicenseType").valueChanges.subscribe(function (val) {
            var control = _this.syncITLicenseForm.get("NoOfMonths");
            var productsArray = _this.syncITLicenseForm.get("Products");
            if (val === "1") {
                // Trial
                control.setValue(1);
                control.disable();
                // Set NoOfLicense = 5 for each product
                productsArray.controls.forEach(function (c) { return c.get("NoOfLicense").setValue(5); });
            }
            else {
                // Purchase
                control.enable();
                // Reset NoOfLicense = 0 for each product
                productsArray.controls.forEach(function (c) { return c.get("NoOfLicense").setValue(0); });
            }
        });
        var productsFormArray = this.syncITLicenseForm.get("Products");
        productFormGroups.forEach(function (fg) { return productsFormArray.push(fg); });
    }
    GenerateSyncITLicenseComponent.prototype.buildForm = function () {
        this.syncITLicenseForm = this.formBuilder.group({
            SalesOrderNo: ["", [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required]],
            PurchaseDate: ["", __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            clientName: ["", __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            NoOfMonths: [
                { value: 1, disabled: true },
                [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].min(1), __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].max(120)],
            ],
            LicenseType: ["1", __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required],
            clientAdminEmail: ["", [__WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_1__angular_forms__["e" /* Validators */].email]],
            Products: this.formBuilder.array([]),
        });
    };
    GenerateSyncITLicenseComponent.prototype.blurSalesOrderEvent = function () {
        var _this = this;
        if (this.prevSalesOrderNo.trim().toUpperCase() ==
            this.syncITLicenseForm.value.SalesOrderNo.trim().toUpperCase()) {
            return;
        }
        this.prevSalesOrderNo = this.syncITLicenseForm.value.SalesOrderNo;
        setTimeout(function () {
            _this.shouldFetchSalesOrderNo = true;
            _this.isBillingShippingDetailFetched = false;
        }, 150);
    };
    Object.defineProperty(GenerateSyncITLicenseComponent.prototype, "productsFormArray", {
        get: function () {
            return this.syncITLicenseForm.get("Products");
        },
        enumerable: true,
        configurable: true
    });
    GenerateSyncITLicenseComponent.prototype.checkSalesOrderNo = function () {
        var _this = this;
        if (this.dialogData.SyncItLicenseList) {
            var exist = this.dialogData.SyncItLicenseList.some(function (element) {
                if (element.SalesOrderNo != null) {
                    return (_this.syncITLicenseForm.value.SalesOrderNo.trim().toUpperCase() ==
                        element.SalesOrderNo.trim().toUpperCase());
                }
                else {
                    return false;
                }
            });
            if (exist) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    title: "This sales order no already exists",
                    text: "Are you sure you want to use this Sales Order No?",
                    showCancelButton: true,
                    showCloseButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#FFCA28",
                    cancelButtonText: "No",
                }).then(function (result) {
                    if (result.isConfirmed) {
                        _this.shouldFetchSalesOrderNo = true;
                        _this.isBillingShippingDetailFetched = false;
                        _this.getBillingShippingDetail();
                    }
                    else {
                        _this.shouldFetchSalesOrderNo = false;
                        _this.syncITLicenseForm.patchValue({
                            SalesOrderNo: "",
                        });
                    }
                });
            }
            else {
                this.shouldFetchSalesOrderNo = true;
                this.isBillingShippingDetailFetched = false;
                this.getBillingShippingDetail();
            }
        }
        else {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
            this.getBillingShippingDetail();
        }
    };
    GenerateSyncITLicenseComponent.prototype.getBillingShippingDetail = function () {
        var _this = this;
        var salesOrderNo = this.syncITLicenseForm.value.SalesOrderNo;
        if (salesOrderNo != "") {
            if (this.shouldFetchSalesOrderNo) {
                this.appLoader.open();
                this.licenseService
                    .getBillingShippingDetail(salesOrderNo)
                    .subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.syncITLicenseForm.patchValue({
                            clientName: data.DataObject.BillToName,
                        });
                        _this.billingShippingDetail = data.DataObject;
                        _this.isBillingShippingDetailFetched = true;
                        _this.error = "";
                    }
                    else {
                        _this.isBillingShippingDetailFetched = false;
                        _this.error = data.Error;
                    }
                    _this.appLoader.close();
                });
            }
            else {
                this.error = "Please select other sales order number.";
            }
        }
        else {
            this.error = "Sales Order No is required";
            this.isBillingShippingDetailFetched = false;
        }
    };
    GenerateSyncITLicenseComponent.prototype.onSave = function () {
        var _this = this;
        var licenseTypeControl = this.syncITLicenseForm.get("LicenseType");
        var formValue = this.syncITLicenseForm.getRawValue();
        var totalLicenses = formValue.Products.reduce(function (sum, p) { return sum + (Number(p.NoOfLicense) || 0); }, 0);
        if (totalLicenses === 0) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                icon: "warning",
                title: "No License Selected",
                text: "Please purchase at least one instrument license before saving.",
                confirmButtonText: "Ok",
                confirmButtonColor: "#FFCA28",
            });
            return; // Stop saving
        }
        if (licenseTypeControl && licenseTypeControl.value === "1") {
            var totalLicenses_1 = formValue.Products.reduce(function (sum, p) { return sum + (Number(p.NoOfLicense) || 0); }, 0);
            if (totalLicenses_1 > this.MAX_TRIAL_INSTRUMENTS) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                    icon: "warning",
                    title: "Limit Exceeded",
                    text: "Trial license allows maximum " + this.MAX_TRIAL_INSTRUMENTS + " instruments.",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#FFCA28",
                });
                return; // stop save
            }
        }
        if (this.syncITLicenseForm.valid) {
            this.appLoader.open();
            var formValue_1 = this.syncITLicenseForm.getRawValue();
            this.licenseService
                .addBillingShippingDetailsSyncIT(this.billingShippingDetail)
                .subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    var payload = {
                        CustomerId: data.DataObject.CustomerId,
                        ShippingAddressId: data.DataObject.ShippingAddressId,
                        NoOfMonths: formValue_1.NoOfMonths,
                        LicenseType: formValue_1.LicenseType,
                        SalesOrderNo: formValue_1.SalesOrderNo,
                        PurchaseDate: formValue_1.PurchaseDate,
                        clientAdminEmail: formValue_1.clientAdminEmail,
                        clientName: formValue_1.clientName,
                        deviceDetails: formValue_1.Products.filter(function (p) { return p.NoOfLicense > 0; }).map(function (p) { return ({
                            SyncItProductId: p.ProductId,
                            NoOfProductLicense: p.NoOfLicense,
                        }); }),
                    };
                    _this.licenseService.GenerateSyncITLicense(payload).subscribe({
                        next: function (res) {
                            if (!res.IsError) {
                                _this.dialogRef.close(res.DataObject);
                                _this.snackBar.open("License saved successfully", "", {
                                    duration: 3000,
                                });
                                _this.errorMessage = "";
                                _this.appLoader.close();
                            }
                            else {
                                _this.appLoader.close();
                                _this.errorMessage = res.Error;
                                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
                                    icon: "warning",
                                    title: "Error",
                                    text: res.Error,
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#FFCA28",
                                });
                            }
                        },
                        error: function (err) {
                            _this.appLoader.close();
                            _this.errorMessage = "Something went wrong.";
                        },
                    });
                }
            });
        }
    };
    GenerateSyncITLicenseComponent.prototype.onCancel = function () {
        this.dialogRef.close(false);
    };
    Object.defineProperty(GenerateSyncITLicenseComponent.prototype, "isSaveDisabled", {
        get: function () {
            if (!this.syncITLicenseForm)
                return true;
            // If form invalid → Disable Save
            if (!this.syncITLicenseForm.valid)
                return true;
            if (!this.isBillingShippingDetailFetched)
                return true;
            var licenseTypeControl = this.syncITLicenseForm.get("LicenseType");
            // if (licenseTypeControl && licenseTypeControl.value === "1") {
            //   const totalLicenses = this.productsFormArray.controls.reduce(
            //     (sum, ctrl) => {
            //       const val = ctrl.get("NoOfLicense");
            //       return sum + (val ? Number(val.value) : 0);
            //     },
            //     0
            //   );
            //   if (totalLicenses > 20) {
            //     return true; // Disable Save
            //   }
            // }
            this.errorMessage = "";
            return false;
        },
        enumerable: true,
        configurable: true
    });
    GenerateSyncITLicenseComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: "generate-syncit-license",
            styles: [__webpack_require__(1000)],
            template: __webpack_require__(1063),
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_1__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_5__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_7__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */], Object])
    ], GenerateSyncITLicenseComponent);
    return GenerateSyncITLicenseComponent;
}());



/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenewSyncItComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_sweetalert2__);








var RenewSyncItComponent = /** @class */ (function () {
    function RenewSyncItComponent(licenseService, dialogRef, adalService, router, formBuilder, snackBar, appLoader, dialogData) {
        this.licenseService = licenseService;
        this.dialogRef = dialogRef;
        this.adalService = adalService;
        this.router = router;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        this.appLoader = appLoader;
        this.dialogData = dialogData;
        this.dialogTitle = "Extend Trial Period";
        this.billingShippingDetail = {
            ODataEtag: "",
            Number: "",
            publicId: "",
            CustomerNo: "",
            publicSalesPersoncode: "",
            BillToName: "",
            BillToAddress1: "",
            BillToAddress2: "",
            BillToCity: "",
            BillToState: "",
            BillToZipcode: "",
            BillToCountryCode: "",
            ShipToCode: "",
            ShipToName: "",
            ShipToAddress1: "",
            ShipToAddress2: "",
            ShipToCity: "",
            ShipToState: "",
            ShipToZipcode: "",
            ShipToCountryCode: "",
            CustomerTelephone: "",
            CustomerEmailAddress: "",
            CustomerFaxno: "",
            ShippingTelephoneno: "",
            ShippingFaxno: "",
            ShippingEmailAddress: "",
            Rep1: "",
            Rep2: "",
            Sales1: "",
            Sales2: "",
        };
        this.error = "";
        this.isLoading = false;
        this.prevSalesOrderNo = "";
        this.customerId = 0;
        this.shippingAddressId = 0;
        this.shouldFetchSalesOrderNo = false;
        this.isBillingShippingDetailFetched = false;
        this.errorMessage = "";
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.SyncITProductLicenseId = dialogData.payload.SyncITProductLicenseId;
        this.buildForm();
    }
    RenewSyncItComponent.prototype.buildForm = function () {
        this.SyncItExtendRenewForm = this.formBuilder.group({
            NoOfMonths: ["", __WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* Validators */].required],
            SalesOrderNo: ["", __WEBPACK_IMPORTED_MODULE_3__angular_forms__["e" /* Validators */].required],
        });
    };
    RenewSyncItComponent.prototype.onSave = function () {
        var _this = this;
        if (this.SyncItExtendRenewForm.valid) {
            this.appLoader.open();
            var formValue = this.SyncItExtendRenewForm.getRawValue();
            this.licenseService
                .addBillingShippingDetailsSyncIT(this.billingShippingDetail)
                .subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    var model = {
                        CustomerId: data.DataObject.CustomerId,
                        ShippingAddressId: data.DataObject.ShippingAddressId,
                        UpdatedBy: Number(localStorage.getItem("userid")),
                        SyncITProductLicenseId: _this.SyncITProductLicenseId,
                        NoOfMonths: _this.SyncItExtendRenewForm.value.NoOfMonths,
                        SalesOrderNo: _this.SyncItExtendRenewForm.value.SalesOrderNo,
                    };
                    _this.dialogRef.close(model);
                }
            });
        }
    };
    RenewSyncItComponent.prototype.getBillingShippingDetail = function () {
        var _this = this;
        var salesOrderNo = this.SyncItExtendRenewForm.value.SalesOrderNo;
        if (salesOrderNo != "") {
            if (this.shouldFetchSalesOrderNo) {
                this.appLoader.open();
                this.licenseService
                    .getBillingShippingDetail(salesOrderNo)
                    .subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.billingShippingDetail = data.DataObject;
                        _this.isBillingShippingDetailFetched = true;
                        _this.error = "";
                    }
                    else {
                        _this.isBillingShippingDetailFetched = false;
                        _this.error = data.Error;
                    }
                    _this.appLoader.close();
                });
            }
            else {
                this.error = "Please select other sales order number.";
            }
        }
        else {
            this.error = "Sales Order No is required";
            this.isBillingShippingDetailFetched = false;
        }
    };
    RenewSyncItComponent.prototype.checkSalesOrderNo = function () {
        var _this = this;
        if (this.dialogData.SyncItLicenseList) {
            var exist = this.dialogData.SyncItLicenseList.some(function (element) {
                if (element.SalesOrderNo != null) {
                    return (_this.SyncItExtendRenewForm.value.SalesOrderNo.trim().toUpperCase() ==
                        element.SalesOrderNo.trim().toUpperCase());
                }
                else {
                    return false;
                }
            });
            if (exist) {
                __WEBPACK_IMPORTED_MODULE_7_sweetalert2___default.a.fire({
                    title: "This sales order no already exists",
                    text: "Are you sure you want to use this Sales Order No?",
                    showCancelButton: true,
                    showCloseButton: true,
                    showConfirmButton: true,
                    confirmButtonText: "Yes",
                    confirmButtonColor: "#FFCA28",
                    cancelButtonText: "No",
                }).then(function (result) {
                    if (result.isConfirmed) {
                        _this.shouldFetchSalesOrderNo = true;
                        _this.isBillingShippingDetailFetched = false;
                        _this.getBillingShippingDetail();
                    }
                    else {
                        _this.shouldFetchSalesOrderNo = false;
                        _this.SyncItExtendRenewForm.patchValue({
                            SalesOrderNo: "",
                        });
                    }
                });
            }
            else {
                this.shouldFetchSalesOrderNo = true;
                this.isBillingShippingDetailFetched = false;
                this.getBillingShippingDetail();
            }
        }
        else {
            this.shouldFetchSalesOrderNo = true;
            this.isBillingShippingDetailFetched = false;
            this.getBillingShippingDetail();
        }
    };
    RenewSyncItComponent.prototype.blurSalesOrderEvent = function () {
        var _this = this;
        if (this.prevSalesOrderNo.trim().toUpperCase() ==
            this.SyncItExtendRenewForm.value.SalesOrderNo.trim().toUpperCase()) {
            return;
        }
        this.prevSalesOrderNo = this.SyncItExtendRenewForm.value.SalesOrderNo;
        setTimeout(function () {
            _this.shouldFetchSalesOrderNo = true;
            _this.isBillingShippingDetailFetched = false;
        }, 150);
    };
    RenewSyncItComponent.prototype.onCancel = function () {
        this.dialogRef.close(false);
    };
    RenewSyncItComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1064),
            styles: [__webpack_require__(1001)],
            selector: "renew-syncit-license",
        }),
        __param(7, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_4__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_3__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_6__services_app_loader_app_loader_service__["a" /* AppLoaderService */], Object])
    ], RenewSyncItComponent);
    return RenewSyncItComponent;
}());



/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ViewSyncItHistoryComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);






var ViewSyncItHistoryComponent = /** @class */ (function () {
    function ViewSyncItHistoryComponent(licenseService, dialogRef, appLoader, adalService, router, dialogData) {
        this.licenseService = licenseService;
        this.dialogRef = dialogRef;
        this.appLoader = appLoader;
        this.adalService = adalService;
        this.router = router;
        this.dialogData = dialogData;
        this.dialogTitle = "View License History";
        this.errorMessage = "";
        this.isLoading = false;
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.SyncITProductLicenseId = this.dialogData.SyncITProductLicenseId;
        this.getHistory();
    }
    ViewSyncItHistoryComponent.prototype.getHistory = function () {
        var _this = this;
        this.isLoading = true;
        this.licenseService
            .getSyncITLicenseHistory(this.SyncITProductLicenseId)
            .subscribe({
            next: function (data) {
                if (!data.IsError) {
                    _this.SyncItLicenseHistory = data.DataObject; // <-- use DataObject
                }
                else {
                    _this.errorMessage = data.Error || "Failed to fetch history";
                }
                _this.isLoading = false;
            },
            error: function (err) {
                _this.errorMessage = "Error fetching license history";
                _this.isLoading = false;
            },
        });
    };
    ViewSyncItHistoryComponent.prototype.copyToClipboard = function (text) {
        if (!navigator.clipboard) {
            // fallback for older browsers
            var textarea = document.createElement("textarea");
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            alert("Copied to clipboard!");
            return;
        }
        navigator.clipboard.writeText(text).then(function () {
        }, function (err) {
            console.error("Could not copy text: ", err);
        });
    };
    ViewSyncItHistoryComponent.prototype.onCancel = function () {
        this.dialogRef.close();
    };
    ViewSyncItHistoryComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            template: __webpack_require__(1065),
            styles: [__webpack_require__(1002)],
            selector: "view-history-popup",
        }),
        __param(5, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_1__angular_material__["d" /* MD_DIALOG_DATA */])),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_4__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["e" /* MdDialogRef */],
            __WEBPACK_IMPORTED_MODULE_3__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */], Object])
    ], ViewSyncItHistoryComponent);
    return ViewSyncItHistoryComponent;
}());



/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenseModuleSyncITComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ExportToCSVService__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_PagerService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pipes_SyncITFilterPipe__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__popup_generate_syncit_license_generate_syncit_license_component__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__popup_extend_trial_period_extend_trial_period_component__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__popup_addmore_syncit_license_addmore_syncit_license_component__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__popup_renew_syncit_license_renew_syncit_license_component__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__popup_view_history_popup_view_history_popup_component__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(210);

















var LicenseModuleSyncITComponent = /** @class */ (function () {
    function LicenseModuleSyncITComponent(dialog, licenseService, appLoader, snackBar, adalService, router, exportService, route, pagerService, userService, filterPipe) {
        var _this = this;
        this.dialog = dialog;
        this.licenseService = licenseService;
        this.appLoader = appLoader;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.router = router;
        this.exportService = exportService;
        this.route = route;
        this.pagerService = pagerService;
        this.userService = userService;
        this.filterPipe = filterPipe;
        this.MAX_TRIAL_INSTRUMENTS = __WEBPACK_IMPORTED_MODULE_16__constants__["a" /* MAX_TRIAL_INSTRUMENTS */];
        this.filterBillToName = "";
        this.filterShipToName = "";
        this.searchBillToName = "";
        this.searchShipToName = "";
        this.syncITproducts = [];
        this.BillToList = [];
        this.ShipToList = [];
        this.SyncITLicenseList = [];
        this.originalSyncITLicenseList = [];
        this.filteredScal360LicenseList = [];
        this.filterClientAdminEmail = "";
        this.searchClientAdminEmail = "";
        this.errorMessage = "";
        this.SCALTypeList = [];
        this.expandedRow = null;
        this.isLoading = false;
        this.customerLicenseDetails = [];
        this.pager = {};
        this.pagedItems = [];
        this.currentSortColumn = "";
        this.currentSortOrder = "";
        if (!this.adalService.getCachedToken()) {
            setTimeout(function () {
                _this.router.navigate(["login"]);
            }, 100);
        }
        appLoader.close();
        route.params.subscribe(function (params) {
            _this.ProductId = params["productId"];
        });
        this.getUserRights();
        this.getSyncITProducts();
        this.appLoader.open();
        this.getSyncITLicenseDetails();
    }
    LicenseModuleSyncITComponent.prototype.getUserRights = function () {
        var _this = this;
        var UserId = Number(localStorage.getItem("userid"));
        this.userService
            .getUserLicenseRightById(UserId, this.ProductId)
            .subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.IsAddEdit = data.DataObject.IsAddEdit;
                _this.IsDelete = data.DataObject.IsDelete;
            }
        });
    };
    LicenseModuleSyncITComponent.prototype.setPage = function (page) {
        this.SyncITLicenseList = this.originalSyncITLicenseList.slice();
        this.applySort();
        this.filteredScal360LicenseList = this.filterPipe.transform(this.SyncITLicenseList, this.filterBillToName, this.filterShipToName, this.filterClientAdminEmail);
        this.pager = this.pagerService.getPager(this.filteredScal360LicenseList.length, page);
        this.pagedItems = this.filteredScal360LicenseList.slice(this.pager.startIndex, this.pager.endIndex + 1);
        this.errorMessage = this.pagedItems.length == 0 ? "No records found." : "";
    };
    LicenseModuleSyncITComponent.prototype.exportToCSV = function () {
        var jsonData = [];
        if (this.SyncITLicenseList) {
            this.SyncITLicenseList.forEach(function (element) {
                jsonData.push({
                    BillToName: element.BillToName,
                    BillToAddress1: element.BillToAddress1,
                    BillToAddress2: element.BillToAddress2,
                    BillToCity: element.BillToCity,
                    BillToState: element.BillToState,
                    BillToCountry: element.BillToCountry,
                    ShipToName: element.ShipToName,
                    ShipToAddress1: element.ShipToAddress1,
                    ShipToAddress2: element.ShipToAddress2,
                    ShipToCity: element.ShipToCity,
                    ShipToState: element.ShipToState,
                    ShipToCountryCode: element.ShipToCountryCode,
                    ClientAdminEmail: element.ClientAdminEmail,
                    ExpiryDate: element.ExpiryDate,
                    LicenseType: element.LicenseType,
                    ProductWiseInstrumentCount: element.ProductWiseInstrumentCount
                        ? element.ProductWiseInstrumentCount.replace(/<br\s*\/?>/gi, ", ").replace(/\r?\n/g, ", ")
                        : "",
                    UpdatedDate: element.UpdatedDate,
                });
            });
            this.exportService.exportToCsv(jsonData, "SyncIT");
        }
        else {
            __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                title: "No data",
                text: "There is no data available to export to CSV file.",
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonColor: "#FFCA28",
            });
        }
    };
    LicenseModuleSyncITComponent.prototype.clearSearch = function () {
        this.searchBillToName = this.filterBillToName = "";
        this.searchShipToName = this.filterShipToName = "";
        this.searchClientAdminEmail = this.filterClientAdminEmail = "";
        this.expandedRow = null;
        this.setPage(1);
    };
    LicenseModuleSyncITComponent.prototype.search = function () {
        this.filterBillToName = this.searchBillToName;
        this.filterShipToName = this.searchShipToName;
        this.filterClientAdminEmail = this.searchClientAdminEmail;
        this.expandedRow = null;
        this.setPage(1);
    };
    LicenseModuleSyncITComponent.prototype.getSyncITLicenseDetails = function () {
        var _this = this;
        this.licenseService.getSyncItLicenseDetails().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.originalSyncITLicenseList = data.DataObject;
                _this.SyncITLicenseList = _this.originalSyncITLicenseList.slice();
                _this.setPage(1);
                _this.buildSearchArray();
            }
            else {
            }
            _this.appLoader.close();
        });
    };
    LicenseModuleSyncITComponent.prototype.buildSearchArray = function () {
        var BillToArray = this.SyncITLicenseList.map(function (item) { return item.BillToName; });
        var ShipToArray = this.SyncITLicenseList.map(function (item) { return item.ShipToName; });
        this.BillToList = Array.from(new Set(BillToArray)).sort();
        this.ShipToList = Array.from(new Set(ShipToArray)).sort();
    };
    LicenseModuleSyncITComponent.prototype.onSortChange = function (event) {
        this.currentSortColumn = event.column;
        this.currentSortOrder = event.order;
        if (this.pager && this.pager.currentPage) {
            this.setPage(this.pager.currentPage);
        }
        else {
            this.setPage(1);
        }
    };
    LicenseModuleSyncITComponent.prototype.applySort = function () {
        if (!this.currentSortColumn || !this.currentSortOrder) {
            return;
        }
        this.SyncITLicenseList.sort(function (a, b) {
            var valA = a[this.currentSortColumn];
            var valB = b[this.currentSortColumn];
            valA = valA === null || valA === undefined ? "" : valA;
            valB = valB === null || valB === undefined ? "" : valB;
            // DATE columns
            if (this.currentSortColumn.toLowerCase().indexOf("date") !== -1) {
                var dateA = new Date(valA).getTime() || 0;
                var dateB = new Date(valB).getTime() || 0;
                return this.currentSortOrder === "asc"
                    ? dateA - dateB
                    : dateB - dateA;
            }
            // NUMBER columns
            if (!isNaN(valA) && !isNaN(valB)) {
                return this.currentSortOrder === "asc"
                    ? Number(valA) - Number(valB)
                    : Number(valB) - Number(valA);
            }
            // HTML column
            if (this.currentSortColumn === "ProductWiseInstrumentCount") {
                valA = valA.toString().replace(/<[^>]*>/g, "");
                valB = valB.toString().replace(/<[^>]*>/g, "");
            }
            // STRING compare
            valA = valA.toString();
            valB = valB.toString();
            return this.currentSortOrder === "asc"
                ? valA.localeCompare(valB)
                : valB.localeCompare(valA);
        }.bind(this));
    };
    LicenseModuleSyncITComponent.prototype.openGenerateNewLicenseRequestDialog = function () {
        var _this = this;
        var generateNewLicenseRequestDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_11__popup_generate_syncit_license_generate_syncit_license_component__["a" /* GenerateSyncITLicenseComponent */], {
            width: "60%",
            height: "94%",
            data: {
                syncITproducts: this.syncITproducts,
                SyncITLicenseData: this.SyncITLicenseList,
                dialogTitle: "Generate New License",
            },
            disableClose: true,
        });
        generateNewLicenseRequestDialogRef.afterClosed().subscribe(function (result) {
            if (result) {
                _this.getSyncITLicenseDetails();
            }
        });
    };
    LicenseModuleSyncITComponent.prototype.openExtendTrial = function (row) {
        var _this = this;
        if (row.LicenseType.toLowerCase() == "trial") {
            var ExtendSyncItTrialPeriodRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_12__popup_extend_trial_period_extend_trial_period_component__["a" /* ExtendSyncItTrialPeriodComponent */], {
                width: "50%",
                height: "30%",
                data: {
                    payload: row,
                },
                disableClose: true,
            });
            ExtendSyncItTrialPeriodRef.afterClosed().subscribe(function (result) {
                if (result) {
                    _this.appLoader.open();
                    _this.licenseService.ExtendTrialRenewPeriod(result).subscribe({
                        next: function (data) {
                            if (data.IsError == true) {
                                _this.appLoader.close();
                                _this.snackBar.open(data.Error, "Close", {
                                    duration: 3000,
                                });
                                return;
                            }
                            _this.getSyncITLicenseDetails();
                            _this.snackBar.open("Trial Period Extend Successfully", "Close", {
                                duration: 3000,
                            });
                        },
                        error: function (err) {
                            _this.snackBar.open(err.error.message, "Close", {
                                duration: 3000,
                            });
                        },
                    });
                }
            });
        }
        else {
            var RenewSyncItComponentRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_14__popup_renew_syncit_license_renew_syncit_license_component__["a" /* RenewSyncItComponent */], {
                width: "50%",
                height: "30%",
                data: {
                    payload: row,
                },
                disableClose: true,
            });
            RenewSyncItComponentRef.afterClosed().subscribe(function (result) {
                if (result) {
                    _this.licenseService.ExtendTrialRenewPeriod(result).subscribe({
                        next: function (data) {
                            if (data.IsError == true) {
                                _this.appLoader.close();
                                _this.snackBar.open(data.Error, "Close", {
                                    duration: 3000,
                                });
                                return;
                            }
                            _this.getSyncITLicenseDetails();
                            _this.snackBar.open("License Renew Successfully", "Close", {
                                duration: 3000,
                            });
                        },
                        error: function (err) {
                            _this.snackBar.open(err.error.message, "Close", {
                                duration: 3000,
                            });
                        },
                    });
                }
            });
        }
    };
    LicenseModuleSyncITComponent.prototype.openSyncItLicenseHistory = function (row) {
        var activationHistoryDialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_15__popup_view_history_popup_view_history_popup_component__["a" /* ViewSyncItHistoryComponent */], {
            width: "60%",
            height: "70%",
            data: {
                SyncITProductLicenseId: row.SyncITProductLicenseId,
            },
            disableClose: true,
        });
        activationHistoryDialogRef.afterClosed().subscribe(function (result) { });
    };
    LicenseModuleSyncITComponent.prototype.addMoreLicense = function (row) {
        var _this = this;
        var AddMoreLicenseComponentRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_13__popup_addmore_syncit_license_addmore_syncit_license_component__["a" /* AddMoreSyncItLicenseComponent */], {
            width: "70%",
            height: "94%",
            data: {
                SyncITProductLicenseId: row.SyncITProductLicenseId,
                LicenseType: row.LicenseType,
            },
            disableClose: true,
        });
        AddMoreLicenseComponentRef.afterClosed().subscribe(function (result) {
            if (result) {
                _this.getSyncITLicenseDetails();
            }
        });
    };
    LicenseModuleSyncITComponent.prototype.getSyncITProducts = function () {
        var _this = this;
        this.licenseService.getSyncITProducts().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.syncITproducts = data.DataObject;
            }
        });
    };
    LicenseModuleSyncITComponent.prototype.approveTrailPeriodExtension = function (row) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
            title: "Approve Trial Period Extension",
            text: "Are you sure you want to approve trial period extension?",
            showCancelButton: true,
            showCloseButton: true,
            showConfirmButton: true,
            confirmButtonColor: "#FFCA28",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
        }).then(function (result) {
            if (result.isConfirmed) {
                _this.appLoader.open();
                var model = {
                    SyncITProductLicenseId: row.SyncITProductLicenseId,
                    UpdatedBy: Number(localStorage.getItem("userid")),
                };
                _this.licenseService
                    .approveTrialPeriodExtension(model)
                    .subscribe(function (data) {
                    if (!data.IsError && data.DataObject != null) {
                        _this.licenseService
                            .getSyncItLicenseDetails()
                            .subscribe(function (data) {
                            if (!data.IsError && data.DataObject != null) {
                                _this.originalSyncITLicenseList = data.DataObject;
                                _this.SyncITLicenseList = _this.originalSyncITLicenseList.slice();
                                _this.setPage(1);
                                _this.buildSearchArray();
                            }
                            else {
                            }
                            _this.appLoader.close();
                        });
                    }
                    else {
                        _this.appLoader.close();
                        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default.a.fire({
                            title: "Error",
                            text: data.Error,
                            showConfirmButton: true,
                            confirmButtonColor: "#FFCA28",
                        });
                        return;
                    }
                });
            }
        });
    };
    LicenseModuleSyncITComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: "license-syncit",
            template: __webpack_require__(1066),
            styles: [__webpack_require__(1003)],
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_2__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_3__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_5__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_7__services_ExportToCSVService__["a" /* ExportToCSVService */],
            __WEBPACK_IMPORTED_MODULE_5__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_8__services_PagerService__["a" /* PagerService */],
            __WEBPACK_IMPORTED_MODULE_9__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_10__pipes_SyncITFilterPipe__["a" /* SyncITFilterPipe */]])
    ], LicenseModuleSyncITComponent);
    return LicenseModuleSyncITComponent;
}());



/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutProductaddComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_ProductService__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_Rx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_app_loader_app_loader_service__ = __webpack_require__(7);








var PageLayoutProductaddComponent = /** @class */ (function () {
    function PageLayoutProductaddComponent(dialog, router, formBuilder, snackBar, adalService, appLoaderService, productService) {
        this.dialog = dialog;
        this.router = router;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        this.adalService = adalService;
        this.appLoaderService = appLoaderService;
        this.productService = productService;
        this.submitted = false;
        //Check Authentication        
        if (!this.adalService.getCachedToken()) {
            this.router.navigate(['login']);
        }
        this.getProducts();
    }
    PageLayoutProductaddComponent.prototype.ngOnInit = function () {
        this.buildForm();
    };
    PageLayoutProductaddComponent.prototype.buildForm = function () {
        this.ProductId = 0;
        this.validationForm = this.formBuilder.group({
            ProductName: ['', __WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required],
            Code: ['', __WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required],
            SubType: ['', __WEBPACK_IMPORTED_MODULE_4__angular_forms__["e" /* Validators */].required]
        });
    };
    PageLayoutProductaddComponent.prototype.getProducts = function () {
        var _this = this;
        this.productService.getProduct().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.ProductData = data.DataObject;
            }
        }, function (error) {
            _this.errorMessage = error;
        });
    };
    PageLayoutProductaddComponent.prototype.onSubmit = function () {
        this.submitted = true;
        if (this.validationForm.invalid) {
            return;
        }
        this.SaveProductDetail();
    };
    PageLayoutProductaddComponent.prototype.oneditcancel = function () {
        this.errorMessage = "";
        this.ProductId = 0;
        this.submitted = false;
        this.validationForm.patchValue({
            ProductName: '',
            Code: '',
            SubType: ''
        });
    };
    PageLayoutProductaddComponent.prototype.EditProductDetail = function (row) {
        this.ProductId = row.ProductId;
        this.validationForm.patchValue({
            ProductName: row.ProductName,
            Code: row.Code,
            SubType: row.SubType
        });
    };
    PageLayoutProductaddComponent.prototype.SaveProductDetail = function () {
        var _this = this;
        this.errorMessage = "";
        if (this.ProductId == 0) {
            this.appLoaderService.open();
            var model = {
                ProductId: 0,
                ProductName: this.validationForm.value.ProductName,
                Code: this.validationForm.value.Code,
                SubType: this.validationForm.value.SubType,
                CreatedBy: Number(localStorage.getItem('userid')),
                UpdatedBy: Number(localStorage.getItem('userid'))
            };
            this.productService.addProduct(model).subscribe(function (response) {
                if (response.IsError || response.DataObject == null) {
                    _this.errorMessage = "Product Code is already Exists..!";
                    _this.appLoaderService.close();
                }
                else {
                    _this.submitted = false;
                    _this.validationForm.patchValue({
                        ProductName: '',
                        Code: '',
                        SubType: ''
                    });
                    _this.snackBar.open("Product Created Successfully", "", {
                        duration: 2000,
                    });
                    _this.appLoaderService.close();
                    _this.productService.notifyOther({ option: 'onSave', value: 'Product Created Successfully' });
                    _this.getProducts();
                }
            }, function (_error) { _this.appLoaderService.close(); });
        }
        else {
            this.appLoaderService.open();
            var model = {
                ProductId: this.ProductId,
                ProductName: this.validationForm.value.ProductName,
                Code: this.validationForm.value.Code,
                SubType: this.validationForm.value.SubType,
                CreatedBy: Number(localStorage.getItem('userid')),
                UpdatedBy: Number(localStorage.getItem('userid'))
            };
            this.productService.updateProduct(model).subscribe(function (response) {
                if (response.IsError || response.DataObject == null) {
                    _this.errorMessage = "Product Code is already Exists..!";
                    _this.appLoaderService.close();
                }
                else {
                    _this.submitted = false;
                    _this.validationForm.patchValue({
                        ProductName: '',
                        Code: '',
                        SubType: ''
                    });
                    _this.snackBar.open("Product Update Successfully", "", {
                        duration: 2000,
                    });
                    _this.appLoaderService.close();
                    _this.productService.notifyOther({ option: 'onSave', value: 'Product Updated Successfully' });
                    _this.getProducts();
                }
            }, function (_error) { _this.appLoaderService.close(); });
        }
    };
    PageLayoutProductaddComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-page-layout-add-Product',
            styles: [],
            template: __webpack_require__(1070)
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_3__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_4__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_3__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_6__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_7__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_1__services_ProductService__["a" /* ProductService */]])
    ], PageLayoutProductaddComponent);
    return PageLayoutProductaddComponent;
}());



/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PageLayoutsRoutes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutsRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__page_layouts_component__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_release_list_product_release_component__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__revision_changelog_revision_component__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__revision_history_revisionhistory_component__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__add_edit_productrelease_addproductrelease_component__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__add_product_addproduct_component__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Revert_Release_revertrelease_component__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__confirm_dialog_confirmdialog_component__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_product_changelog_viewallchangelog_component__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__product_release_tab_list_product_release_tab_component__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__push_notification_push_notification_history_component__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_ota_auth_guard__ = __webpack_require__(372);













var PageLayoutsRoutes = [
    {
        path: 'pglayout',
        component: __WEBPACK_IMPORTED_MODULE_1__page_layouts_component__["a" /* PageLayoutsComponent */],
        children: [
            { path: 'product-release/:name/:id/:code', component: __WEBPACK_IMPORTED_MODULE_2__product_release_list_product_release_component__["a" /* PageLayoutProductReleaseListComponent */] },
            { path: 'product-release-tab/:name/:id/:code/:variant/:selectedindex', component: __WEBPACK_IMPORTED_MODULE_10__product_release_tab_list_product_release_tab_component__["a" /* PageLayoutProductReleaseTabComponent */], pathMatch: 'full' },
            { path: 'revision-changelog/:name/:id', component: __WEBPACK_IMPORTED_MODULE_3__revision_changelog_revision_component__["a" /* PageLayoutRevisionComponent */] },
            { path: 'revision-allchangelog/:name/:id', component: __WEBPACK_IMPORTED_MODULE_9__view_product_changelog_viewallchangelog_component__["a" /* PageLayoutAllChangeLog */] },
            { path: 'revision-history/:name/:id', component: __WEBPACK_IMPORTED_MODULE_4__revision_history_revisionhistory_component__["a" /* PageLayoutRevisionHistoryComponent */] },
            { path: 'add-edit-productrelease/:name/:id', component: __WEBPACK_IMPORTED_MODULE_5__add_edit_productrelease_addproductrelease_component__["a" /* PageLayoutProductReleaseComponent */] },
            { path: 'add-product', component: __WEBPACK_IMPORTED_MODULE_6__add_product_addproduct_component__["a" /* PageLayoutProductaddComponent */] },
            { path: 'revert-release/:name/:id', component: __WEBPACK_IMPORTED_MODULE_7__Revert_Release_revertrelease_component__["a" /* PageLayoutRevertReleaseComponent */] },
            { path: 'confirm-dialog/:title', component: __WEBPACK_IMPORTED_MODULE_8__confirm_dialog_confirmdialog_component__["a" /* PageLayoutConfirmDialogComponent */] },
            { path: 'push-notification-history/:Title/:id', component: __WEBPACK_IMPORTED_MODULE_11__push_notification_push_notification_history_component__["a" /* PageLayoutPushNotificationHistoryComponent */] },
        ],
        canActivate: [__WEBPACK_IMPORTED_MODULE_12__shared_ota_auth_guard__["a" /* OTAAuthGuard */]],
        canActivateChild: [__WEBPACK_IMPORTED_MODULE_12__shared_ota_auth_guard__["a" /* OTAAuthGuard */]]
    }
];
var PageLayoutsRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(PageLayoutsRoutes);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutsComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var PageLayoutsComponent = /** @class */ (function () {
    function PageLayoutsComponent() {
    }
    PageLayoutsComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-page-layouts',
            styles: [],
            template: "<router-outlet></router-outlet>"
        })
    ], PageLayoutsComponent);
    return PageLayoutsComponent;
}());



/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutProductReleaseListComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__revision_changelog_revision_component__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__add_edit_productrelease_addproductrelease_component__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ProductReleaseService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_PagerService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Revert_Release_revertrelease_component__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__revision_history_revisionhistory_component__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__confirm_dialog_confirmdialog_component__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__view_product_changelog_viewallchangelog_component__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__interfaces_ProductReleaseStatusEnum_model__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__angular_common_http__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__interfaces_PushNotificationHistory__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__change_release_type_change_release_type_component__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__activate_release_activateRelease_component__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__interfaces_PilotCustomReleaseProducts__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_operators__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_observable_of__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs_observable_forkJoin__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_rxjs_observable_forkJoin__);
























var PageLayoutProductReleaseListComponent = /** @class */ (function () {
    function PageLayoutProductReleaseListComponent(dialog, route, router, productReleaseService, userservice, pagerService, appLoaderService, adalService) {
        var _this_1 = this;
        this.dialog = dialog;
        this.route = route;
        this.router = router;
        this.productReleaseService = productReleaseService;
        this.userservice = userservice;
        this.pagerService = pagerService;
        this.appLoaderService = appLoaderService;
        this.adalService = adalService;
        this.IsAdd = false;
        this.IsEdit = false;
        this.IsProductionRights = false;
        this.Title = "";
        this.IsApprove = false;
        this.IsReject = false;
        this.IsAllowedToAdd = false;
        this.pager = {};
        this.pagedItems = [];
        this.ProductCodePanelVisble = [14, 89];
        this.IsShowDeleted = false;
        this.IsPushNotificationButtonVisible = false;
        this.isValidProductForPushNotification = false;
        this.ProductReleaseStatus = __WEBPACK_IMPORTED_MODULE_14__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */];
        if (!this.adalService.getCachedToken()) {
            this.router.navigate(["login"]);
        }
        this.sub = this.route.params.subscribe(function (params) {
            _this_1.Title = params["name"];
            _this_1.ProductId = params["id"];
            _this_1.ProductCode = params["code"];
            _this_1.IsShowDeleted = false;
            _this_1.getProductReleaseList(_this_1.ProductId);
            _this_1.getUserRights(Number(localStorage.getItem("userid")), _this_1.ProductId);
            _this_1.isValidProductForPushNotification = _this_1.checkIsValidProductForNotification();
        });
    }
    PageLayoutProductReleaseListComponent.prototype.getNotificationHistory = function () {
        this.router.navigate(["/app/pglayout/push-notification-history/", this.Title, this.ProductId]);
    };
    PageLayoutProductReleaseListComponent.prototype.checkIsValidProductForNotification = function () {
        var productCode = this.ProductCode;
        if (productCode in __WEBPACK_IMPORTED_MODULE_17__interfaces_PushNotificationHistory__["a" /* ProductsWithPushNotification */]) {
            return true;
        }
        return false;
    };
    PageLayoutProductReleaseListComponent.prototype.showRejected = function (value) {
        var _this_1 = this;
        if (value == true) {
            this.pagedItems = [];
            this.releaseData.forEach(function (element) {
                _this_1.pagedItems.push(element);
            });
        }
        else {
            this.pagedItems = [];
            this.releaseData.forEach(function (element) {
                if (element.IsDeleted == false) {
                    _this_1.pagedItems.push(element);
                }
            });
        }
    };
    PageLayoutProductReleaseListComponent.prototype.setPage = function (page) {
        this.pager = this.pagerService.getPager(this.releaseData.length, page);
        this.pagedItems = this.releaseData.slice(this.pager.startIndex, this.pager.endIndex + 1);
    };
    //#region ViewChangeLog
    PageLayoutProductReleaseListComponent.prototype.openDialogWithAResult = function (row) {
        this.ProductReleaseId = row.ProductReleaseId;
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__revision_changelog_revision_component__["a" /* PageLayoutRevisionComponent */], {
            height: "50%",
            width: "60%",
            data: {
                productReleaseId: this.ProductReleaseId,
                ProductName: this.Title,
                ProductReleaseNo: row.ProductReleaseNo,
                SubProductName: "",
            },
        });
        dialogRef.afterClosed().subscribe(function (_result) {
            //this.getProductReleaseList(this.ProductId);
        });
    };
    //#endregion
    //#region viewAllChangeLog
    PageLayoutProductReleaseListComponent.prototype.OpenViewAllChangeLog = function () {
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_12__view_product_changelog_viewallchangelog_component__["a" /* PageLayoutAllChangeLog */], {
            height: "50%",
            width: "60%",
            data: {
                ProductId: this.ProductId,
                ProductName: this.Title,
                SubProductName: "",
            },
        });
        dialogRef.afterClosed().subscribe(function (_result) {
            //this.getProductReleaseList(this.ProductId);
        });
    };
    //#endregion
    //#region Add Release
    PageLayoutProductReleaseListComponent.prototype.openProductReleaseAddDialog = function (row) {
        var _this_1 = this;
        if (this.IsAllowedToAdd) {
            var confirmdialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_11__confirm_dialog_confirmdialog_component__["a" /* PageLayoutConfirmDialogComponent */], {
                data: { Status: "Add" },
                disableClose: true,
            });
            confirmdialog.afterClosed().subscribe(function (_result) {
                _this_1.getProductReleaseList(_this_1.ProductId);
            });
        }
        else {
            var releaseDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_3__add_edit_productrelease_addproductrelease_component__["a" /* PageLayoutProductReleaseComponent */], {
                height: "90%",
                width: "60%",
                data: {
                    ProductId: this.ProductId,
                    ParentProductId: this.ProductId,
                    ProductName: this.Title,
                    SubProductName: "",
                    ProductCode: this.ProductCode,
                    ProductReleaseId: 0,
                    payload: row,
                },
                disableClose: true,
            });
            releaseDialog.afterClosed().subscribe(function (result) {
                _this_1.getProductReleaseList(_this_1.ProductId);
                if (result != null) {
                    _this_1.SendEmail(result, __WEBPACK_IMPORTED_MODULE_14__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].DevRelease);
                }
            });
        }
    };
    //#endregion
    //#region EditDialog
    PageLayoutProductReleaseListComponent.prototype.openProductReleaseEditDialog = function (row) {
        var _this_1 = this;
        var releaseDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_3__add_edit_productrelease_addproductrelease_component__["a" /* PageLayoutProductReleaseComponent */], {
            height: "90%",
            width: "60%",
            data: {
                ProductId: this.ProductId,
                ParentProductId: this.ProductId,
                ProductReleaseId: row.ProductReleaseId,
                ProductName: this.Title,
                SubProductName: "",
                ProductCode: this.ProductCode,
                Status: row.Status,
                payload: row,
            },
            disableClose: true,
        });
        releaseDialog.afterClosed().subscribe(function (_result) {
            _this_1.getProductReleaseList(_this_1.ProductId);
        });
    };
    //#endregion
    //#region GridData and IsAllowedtoDataAdd if any release in pending queue [ViewRelease]
    PageLayoutProductReleaseListComponent.prototype.getProductReleaseList = function (ProductId) {
        var _this_1 = this;
        // For Specific Product Visible DBVersion and Package File Upload
        this.IsProductCodeVisble = false;
        this.ProductCodePanelVisble.forEach(function (element) {
            if (element == _this_1.ProductCode) {
                _this_1.IsProductCodeVisble = true;
            }
        });
        this.productReleaseService.getReleaseByProductId(ProductId).subscribe(function (data) {
            _this_1.pagedItems = [];
            if (!data.IsError && data.DataObject != null) {
                _this_1.releaseData = data.DataObject;
                _this_1.releaseData.forEach(function (element) {
                    var customers = element.Customers ? element.Customers.map(function (c, index) { return index + 1 + ". " + c.Name; }) : [];
                    var toolip = customers && customers.length > 0 ? customers.join('\n') : 'No customers';
                    element.CustomerTooltip = toolip;
                    if (_this_1.IsShowDeleted) {
                        _this_1.pagedItems.push(element);
                    }
                    else {
                        if (element.IsDeleted == false) {
                            _this_1.pagedItems.push(element);
                        }
                    }
                });
                //this.setPage(this.pager.currentPage);
            }
            else {
                _this_1.releaseData = null;
            }
        }, function (error) {
            _this_1.errorMessage = error;
        });
        this.productReleaseService
            .getIsAllowedToAddReleaseByProductId(ProductId)
            .subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this_1.IsAllowedToAdd = false;
            }
            else {
                _this_1.IsAllowedToAdd = true;
            }
        }, function (error) {
            _this_1.errorMessage = error;
        });
    };
    PageLayoutProductReleaseListComponent.prototype.getProductReleaseList_Observable = function (ProductId) {
        var _this_1 = this;
        // 1. Run the synchronous UI checks first
        this.IsProductCodeVisble = false;
        this.ProductCodePanelVisble.forEach(function (element) {
            if (element == _this_1.ProductCode) {
                _this_1.IsProductCodeVisble = true;
            }
        });
        var _this = this;
        // 2. Define the first API call stream with its side-effects
        var getRelease$ = this.productReleaseService.getReleaseByProductId(ProductId).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_rxjs_operators__["take"])(1), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_rxjs_operators__["tap"])(function (data) {
            _this.pagedItems = [];
            if (!data.IsError && data.DataObject != null) {
                _this.releaseData = data.DataObject;
                _this.releaseData.forEach(function (element) {
                    var customers = element.Customers ? element.Customers.map(function (c, index) { return index + 1 + ". " + c.Name; }) : [];
                    var toolip = customers && customers.length > 0 ? customers.join('\n') : 'No customers';
                    element.CustomerTooltip = toolip;
                    if (_this.IsShowDeleted) {
                        _this.pagedItems.push(element);
                    }
                    else {
                        if (element.IsDeleted == false) {
                            _this.pagedItems.push(element);
                        }
                    }
                });
            }
            else {
                _this.releaseData = null;
            }
        }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_rxjs_operators__["catchError"])(function (error) {
            _this.errorMessage = error;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_rxjs_observable_of__["of"])(null); // Keep forkJoin alive even if one fails
        }));
        // 3. Define the second API call stream with its side-effects
        var getIsAllowed$ = this.productReleaseService.getIsAllowedToAddReleaseByProductId(ProductId).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_rxjs_operators__["take"])(1), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_rxjs_operators__["tap"])(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.IsAllowedToAdd = false;
            }
            else {
                _this.IsAllowedToAdd = true;
            }
        }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_rxjs_operators__["catchError"])(function (error) {
            _this.errorMessage = error;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_rxjs_observable_of__["of"])(null); // Keep forkJoin alive even if one fails
        }));
        // 4. Return combined observable that completes only when both requests finish
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_rxjs_observable_forkJoin__["forkJoin"])([getRelease$, getIsAllowed$]);
    };
    //#endregion
    //#region  getUserRights to visible button true false
    PageLayoutProductReleaseListComponent.prototype.getUserRights = function (UserId, ProductId) {
        var _this_1 = this;
        this.userservice.getUserRightsById(UserId, ProductId).subscribe(function (Data) {
            if (Data != "") {
                _this_1.IsAdd = Data[0].IsAdd;
                _this_1.IsEdit = Data[0].IsEdit;
                _this_1.IsProductionRights = Data[0].IsActiveInactive; // IsDelete means Active/Inactive Release
                _this_1.IsApprove = Data[0].IsApproveReject;
                _this_1.IsPushNotificationButtonVisible = true;
            }
        }, function (error) {
            _this_1.errorMessage = error;
        });
    };
    //#endregion
    //#region  Click: Active Release
    PageLayoutProductReleaseListComponent.prototype.ActiveRelease = function (row) {
        var _this_1 = this;
        // In SCAL360 Case DBVersion Based Active Release
        if (this.IsProductCodeVisble) {
            this.productReleaseService
                .getProductionRelease(this.ProductId)
                .subscribe(function (Data) {
                if (Data.DataObject != null &&
                    row.DBVersion != "" &&
                    Number(Data.DataObject.DBVersion) > Number(row.DBVersion)) {
                    var confirmdialog = _this_1.dialog.open(__WEBPACK_IMPORTED_MODULE_11__confirm_dialog_confirmdialog_component__["a" /* PageLayoutConfirmDialogComponent */], {
                        data: {
                            ProductReleaseNo: row.ProductReleaseNo,
                            Status: "DBVersionMSG",
                        },
                        disableClose: true,
                    });
                    confirmdialog.afterClosed().subscribe(function (_result) {
                        _this_1.getProductReleaseList(_this_1.ProductId);
                    });
                }
                else {
                    _this_1.OpenConfirmDialog(row);
                }
            });
        }
        else {
            this.OpenConfirmDialog(row);
        }
    };
    // #region  Code Complexity Resolved [Create a Function OpenConfirmDialog]
    PageLayoutProductReleaseListComponent.prototype.OpenConfirmDialog = function (row) {
        var _this_1 = this;
        var isPilotCustomReleaseSupported = this.ProductCode in __WEBPACK_IMPORTED_MODULE_20__interfaces_PilotCustomReleaseProducts__["a" /* PilotCustomSupportedProductCodes */];
        var activateReleaseDialog;
        var data = {
            ProductReleaseId: row.ProductReleaseId,
            ProductId: this.ProductId,
            ParentProductId: this.ProductId,
            ProductReleaseNo: row.ProductReleaseNo,
            ProductName: this.Title,
            SubProductName: "",
            ProductCode: this.ProductCode,
            Status: 3,
            IsSTPPerformed: row.IsSTPPerformed,
            releaseList: this.pagedItems
        };
        if (isPilotCustomReleaseSupported) {
            activateReleaseDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_19__activate_release_activateRelease_component__["a" /* ActivateReleaseComponent */], {
                width: "35%",
                data: data,
                disableClose: true,
            });
        }
        else {
            activateReleaseDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_9__Revert_Release_revertrelease_component__["a" /* PageLayoutRevertReleaseComponent */], {
                data: data,
                disableClose: true,
            });
        }
        activateReleaseDialog.afterClosed().subscribe(function (result) {
            _this_1.getProductReleaseList_Observable(_this_1.ProductId).subscribe(function () {
                _this_1.appLoaderService.close();
                if (isPilotCustomReleaseSupported) {
                    if (result) {
                        _this_1.SendEmail(row, result.SelectedReleaseType);
                        _this_1.SendEmailToSyncItClientAdmins(row, result);
                    }
                }
                else {
                    if (typeof result === "object") {
                        _this_1.SendEmail(row, __WEBPACK_IMPORTED_MODULE_14__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].STPStart);
                    }
                    else if (result == true) {
                        _this_1.SendEmail(row, __WEBPACK_IMPORTED_MODULE_14__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].ProductionRelease);
                    }
                }
            });
        });
    };
    //#endregion
    //#endregion
    //#region  Click: Approve Release
    PageLayoutProductReleaseListComponent.prototype.ApproveRelease = function (row) {
        var _this_1 = this;
        var approveDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_9__Revert_Release_revertrelease_component__["a" /* PageLayoutRevertReleaseComponent */], {
            data: {
                ProductReleaseId: row.ProductReleaseId,
                ProductId: this.ProductId,
                ProductReleaseNo: row.ProductReleaseNo,
                Status: 2,
                IsSTPPerformed: row.IsSTPPerformed,
            },
            disableClose: true,
        });
        approveDialog.afterClosed().subscribe(function (result) {
            _this_1.getProductReleaseList(_this_1.ProductId);
            if (result) {
                _this_1.SendEmail(row, __WEBPACK_IMPORTED_MODULE_14__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].QARelease);
            }
        });
    };
    //#endregion
    // #region  Click: Reject Release
    PageLayoutProductReleaseListComponent.prototype.RejectRelease = function (row) {
        var _this_1 = this;
        var rejestdialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_9__Revert_Release_revertrelease_component__["a" /* PageLayoutRevertReleaseComponent */], {
            data: {
                ProductReleaseId: row.ProductReleaseId,
                ProductId: this.ProductId,
                ProductReleaseNo: row.ProductReleaseNo,
                Status: -1,
                IsSTPPerformed: row.IsSTPPerformed,
            },
            disableClose: true,
        });
        rejestdialog.afterClosed().subscribe(function (result) {
            _this_1.getProductReleaseList(_this_1.ProductId);
            if (result) {
                _this_1.SendEmail(row, -1);
            }
        });
    };
    //#endregion
    //#region ViewReleaseHistory
    PageLayoutProductReleaseListComponent.prototype.ViewHistory = function (row) {
        var historyDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_10__revision_history_revisionhistory_component__["a" /* PageLayoutRevisionHistoryComponent */], {
            height: "50%",
            width: "60%",
            data: {
                ProductReleaseId: row.ProductReleaseId,
                ProductReleaseNo: row.ProductReleaseNo,
                ProductName: this.Title,
                SubProductName: "",
            },
        });
        historyDialog.afterClosed().subscribe(function (_result) {
            //this.getProductReleaseList(this.ProductId);
        });
    };
    //#endregion
    //Region Click: STPStart
    PageLayoutProductReleaseListComponent.prototype.STPStart = function (row) {
        var _this_1 = this;
        var STPStart = this.dialog.open(__WEBPACK_IMPORTED_MODULE_9__Revert_Release_revertrelease_component__["a" /* PageLayoutRevertReleaseComponent */], {
            data: {
                ProductReleaseId: row.ProductReleaseId,
                ProductId: this.ProductId,
                ProductReleaseNo: row.ProductReleaseNo,
                Status: 1,
                IsSTPPerformed: row.IsSTPPerformed,
            },
            disableClose: true,
        });
        STPStart.afterClosed().subscribe(function (result) {
            _this_1.getProductReleaseList(_this_1.ProductId);
            if (result) {
                _this_1.SendEmail(row, __WEBPACK_IMPORTED_MODULE_14__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].STPStart);
            }
        });
    };
    //#endregion
    PageLayoutProductReleaseListComponent.prototype.ChangeReleaseType = function (row) {
        var _this_1 = this;
        var changeReleaseTypeDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_18__change_release_type_change_release_type_component__["a" /* ChangeReleaseTypeComponent */], {
            width: "40%",
            data: {
                ProductReleaseId: row.ProductReleaseId,
                ProductId: this.ProductId,
                ProductReleaseNo: row.ProductReleaseNo,
                Status: row.Status,
                IsSTPPerformed: row.IsSTPPerformed,
                releaseList: this.pagedItems
            },
            disableClose: true,
        });
        changeReleaseTypeDialog.afterClosed().subscribe(function (result) {
            _this_1.getProductReleaseList_Observable(_this_1.ProductId).subscribe(function () {
                _this_1.appLoaderService.close();
                if (result) {
                    _this_1.SendEmail(row, result.SelectedReleaseType);
                    _this_1.SendEmailToSyncItClientAdmins(row, result);
                }
            });
        });
    };
    //#region DownloadFile
    PageLayoutProductReleaseListComponent.prototype.DownloadFile = function (row) {
        var _this_1 = this;
        this.appLoaderService.open();
        this.productReleaseService
            .DownloadReleaseFile(row.ProductReleaseId)
            .subscribe(function (result) {
            switch (result.type) {
                case __WEBPACK_IMPORTED_MODULE_15__angular_common_http__["e" /* HttpEventType */].DownloadProgress:
                    var percentage = Math.round((result.loaded / result.total) * 100);
                    _this_1.appLoaderService.ChangeLoaderTitle("Downloading File");
                    _this_1.appLoaderService.ChangePercentage(percentage + "%");
                    break;
                case __WEBPACK_IMPORTED_MODULE_15__angular_common_http__["e" /* HttpEventType */].Response:
                    var downloadedFile = new Blob([result.body], {
                        type: result.body.type,
                    });
                    var a = document.createElement("a");
                    a.setAttribute("style", "display:none;");
                    document.body.appendChild(a);
                    a.download = row.FileName;
                    a.href = URL.createObjectURL(downloadedFile);
                    a.target = "_blank";
                    a.click();
                    document.body.removeChild(a);
                    _this_1.appLoaderService.close();
                    break;
            }
        }, function (_error) {
            _this_1.appLoaderService.close();
        });
    };
    //#endregion
    //#region  SendEmail Function
    PageLayoutProductReleaseListComponent.prototype.SendEmail = function (ProductReleaseInfo, ReleaseStatus) {
        var _this_1 = this;
        var model = {
            ProductName: this.Title,
            SubProductName: "",
            ProductCode: this.ProductCode,
            SubType: 0,
            ProductReleaseNo: ProductReleaseInfo.ProductReleaseNo,
            ReleaseDate: new Date(),
            UpdatedBy: localStorage.getItem("Name"),
            ProductId: this.ProductId,
            ReleaseStatus: ReleaseStatus,
        };
        this.productReleaseService.SendEmail(model).subscribe(function (Data) {
            if (Data.IsError) {
                __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default.a.fire("Error", Data.Error, "error");
            }
        }, function (error) {
            _this_1.errorMessage = error;
        });
    };
    PageLayoutProductReleaseListComponent.prototype.SendEmailToSyncItClientAdmins = function (ProductReleaseInfo, statusChangeInfo) {
        var _this_1 = this;
        if (statusChangeInfo.isNotifySyncItClientAdmin) {
            var model = {
                ProductId: this.ProductId,
                ProductName: this.Title,
                ProductCode: this.ProductCode,
                SubType: 0,
                ProductReleaseNo: ProductReleaseInfo.ProductReleaseNo,
                ReleaseDate: new Date(),
                ReleaseStatus: statusChangeInfo.SelectedReleaseType,
                CustomerIds: statusChangeInfo.customers
            };
            this.productReleaseService.SendEmailToSyncItClientAdmins(model).subscribe(function (Data) {
                if (Data.IsError) {
                    __WEBPACK_IMPORTED_MODULE_16_sweetalert2___default.a.fire("Error", Data.Error, "error");
                }
            }, function (error) {
                _this_1.errorMessage = error;
            });
        }
    };
    PageLayoutProductReleaseListComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: "my-page-layout-with-product-release",
            styles: [__webpack_require__(1007)],
            template: __webpack_require__(1074),
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_5__services_ProductReleaseService__["a" /* ProductReleaseService */],
            __WEBPACK_IMPORTED_MODULE_6__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_8__services_PagerService__["a" /* PagerService */],
            __WEBPACK_IMPORTED_MODULE_13__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__["a" /* AdalService */]])
    ], PageLayoutProductReleaseListComponent);
    return PageLayoutProductReleaseListComponent;
}());



/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutProductReleaseTabComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ProductReleaseService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interfaces_PushNotificationHistory__ = __webpack_require__(124);






var PageLayoutProductReleaseTabComponent = /** @class */ (function () {
    function PageLayoutProductReleaseTabComponent(dialog, route, router, snackBar, productReleaseService, adalService) {
        var _this = this;
        this.dialog = dialog;
        this.route = route;
        this.router = router;
        this.snackBar = snackBar;
        this.productReleaseService = productReleaseService;
        this.adalService = adalService;
        this.isValidProductForPushNotification = false;
        if (!this.adalService.getCachedToken()) {
            this.router.navigate(['login']);
        }
        this.sub = this.route.params.subscribe(function (params) {
            _this.Title = params['name'];
            _this.ProductCode = params['code'];
            _this.ParentProductId = params['id'];
            _this.value = params['selectedindex'];
            _this.variant = params['variant'];
            _this.getReleaseProductsListByProductCode(_this.ProductCode, _this.ParentProductId, _this.variant);
            _this.isValidProductForPushNotification = _this.checkIsValidProductForNotification();
        });
    }
    PageLayoutProductReleaseTabComponent.prototype.checkIsValidProductForNotification = function () {
        var productCode = this.ProductCode;
        if (productCode in __WEBPACK_IMPORTED_MODULE_5__interfaces_PushNotificationHistory__["a" /* ProductsWithPushNotification */]) {
            return true;
        }
        return false;
    };
    PageLayoutProductReleaseTabComponent.prototype.getNotificationHistory = function () {
        this.router.navigate(["/app/pglayout/push-notification-history/", this.Title, this.ParentProductId]);
    };
    PageLayoutProductReleaseTabComponent.prototype.getReleaseProductsListByProductCode = function (ProductCode, ProductId, Variant) {
        var _this = this;
        this.productReleaseService.getReleaseProductsListByProductCode(ProductCode, ProductId, Variant).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.Tab = data.DataObject;
                window.setTimeout(function () {
                    _this.SelectedTabIndex = _this.value;
                });
            }
            else {
                _this.Tab = null;
            }
        }, function (error) {
            _this.errorMessage = error;
        });
    };
    PageLayoutProductReleaseTabComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-page-layout-with-product-release-tab',
            template: __webpack_require__(1075)
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_1__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_3__services_ProductReleaseService__["a" /* ProductReleaseService */],
            __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__["a" /* AdalService */]])
    ], PageLayoutProductReleaseTabComponent);
    return PageLayoutProductReleaseTabComponent;
}());



/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutPushNotificationHistoryComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_NotificationService__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ProductService__ = __webpack_require__(84);








var PageLayoutPushNotificationHistoryComponent = /** @class */ (function () {
    function PageLayoutPushNotificationHistoryComponent(router, route, adalService, notificationService, appLoaderService, productService, snackBar) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.adalService = adalService;
        this.notificationService = notificationService;
        this.appLoaderService = appLoaderService;
        this.productService = productService;
        this.snackBar = snackBar;
        this.errorMessage = "";
        this.pager = {};
        this.productCode = 12;
        this.productVariant = 0;
        this.pushNotificationHistoryList = [];
        this.productData = [];
        this.items = [];
        this.IsProductSubTypeVisible = true;
        //Check Authentication
        if (!this.adalService.getCachedToken()) {
            this.router.navigate(["login"]);
        }
        this.appLoaderService.open();
        this.route.params.subscribe(function (params) {
            _this.productId = params["id"];
            _this.productName = params["Title"];
        });
        this.getPushNotificationHistoryByProductId(this.productId);
    }
    PageLayoutPushNotificationHistoryComponent.prototype.getPushNotificationHistoryByProductId = function (productId) {
        var _this = this;
        this.notificationService.getNotificationHistoryByProductId(productId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null && data.DataObject.length > 0) {
                if (data.DataObject[0].ProductSubType == null) {
                    _this.IsProductSubTypeVisible = false;
                }
                else {
                    _this.IsProductSubTypeVisible = true;
                }
                _this.pushNotificationHistoryList = data.DataObject;
                _this.appLoaderService.close();
            }
            else if (!data.IsError && data.DataObject != null && data.DataObject.length == 0) {
                _this.errorMessage = "No Records Found";
                _this.pushNotificationHistoryList = [];
                _this.appLoaderService.close();
            }
            else {
                _this.errorMessage = data.IsError;
                _this.pushNotificationHistoryList = [];
                _this.appLoaderService.close();
            }
        });
    };
    PageLayoutPushNotificationHistoryComponent.prototype.UTCToLocalTimeZone = function (date) {
        var stillUtc = __WEBPACK_IMPORTED_MODULE_6_moment___default.a.utc(date).toDate();
        var theDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(stillUtc).local();
        return theDate.toLocaleString();
    };
    PageLayoutPushNotificationHistoryComponent.prototype.selectChange = function () {
        this.appLoaderService.open();
        this.getPushNotificationHistoryByProductId(this.selected.ProductId);
    };
    PageLayoutPushNotificationHistoryComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-app-push-notification',
            template: __webpack_require__(1076)
        }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_1__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_3__services_NotificationService__["a" /* NotificationService */],
            __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_7__services_ProductService__["a" /* ProductService */],
            __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdSnackBar */]])
    ], PageLayoutPushNotificationHistoryComponent);
    return PageLayoutPushNotificationHistoryComponent;
}());



/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthGuard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(4);


var AuthGuard = /** @class */ (function () {
    function AuthGuard(router) {
        this.router = router;
    }
    AuthGuard.prototype.canActivate = function () {
        if (localStorage.getItem("IsAdmin") === "true") {
            return true;
        }
        this.router.navigate(['/access-denied']);
        return false;
    };
    AuthGuard.prototype.canActivateChild = function () {
        return this.canActivate();
    };
    AuthGuard = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* Router */]])
    ], AuthGuard);
    return AuthGuard;
}());



/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TIMEOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthInterceptor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_service__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(55);









var DEFAULT_TIMEOUT = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('defaultTimeout');
var AuthInterceptor = /** @class */ (function () {
    function AuthInterceptor(adalService, defaultTimeout, inj, authService, appLoaderService) {
        this.adalService = adalService;
        this.defaultTimeout = defaultTimeout;
        this.inj = inj;
        this.authService = authService;
        this.appLoaderService = appLoaderService;
    }
    AuthInterceptor.prototype.intercept = function (req, next) {
        var _this = this;
        var timeoutValue = req.headers.get('timeout') || this.defaultTimeout;
        var timeoutValueNumeric = Number(timeoutValue);
        if (req.url.includes(__WEBPACK_IMPORTED_MODULE_8__config__["a" /* config */].TokenGenerationUrl + "connect/token") || req.url.includes('user/getuserdata')) {
            return next.handle(req).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["timeout"])(timeoutValueNumeric), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["catchError"])(function (err) {
                _this.handleAzureADError(err);
                return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
            }));
        }
        else if (req.url.includes('DownloadZipFile') || req.url.includes('VerifySCAL360OTPVerification') || req.url.includes("GetSoftwareUpdates") || req.url.includes('SendEmailToSCAL360Customer') || req.url.includes('get-ip') || req.url.includes('generate-sas-token') || req.url.includes('AddSoftwareDownloadDetails')) {
            return this.authService.access_token().pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["switchMap"])(function (token) {
                var JWT = "Bearer " + token.access_token;
                req = req.clone({
                    setHeaders: {
                        Authorization: JWT,
                    },
                });
                return next.handle(req)
                    .pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["catchError"])(function (err) {
                    _this.handleIdentityServerToken(err);
                    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
                }));
            }));
        }
        else if (req.url.includes('LZ30AdvertisementDetails') || req.url.includes('LZ30UserDetails') || req.url.includes('LZ30LicenseDetails') || req.url.includes('Faq')) {
            return this.authService.access_token_license(__WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["a" /* LicensePortalProduct */].LZ30, __WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["b" /* ProductClientSecret */].LZ30).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["switchMap"])(function (token) {
                var JWT = "Bearer " + token.access_token;
                req = req.clone({
                    setHeaders: {
                        Authorization: JWT
                    }
                });
                return next.handle(req)
                    .pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["catchError"])(function (err) {
                    _this.handleIdentityServerToken(err);
                    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
                }));
            }));
        }
        else if (req.url.includes('SmartLink360LicenseDetails')) {
            return this.authService.access_token_license(__WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["a" /* LicensePortalProduct */].SmartLink360, __WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["b" /* ProductClientSecret */].SmartLink360).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["switchMap"])(function (token) {
                var JWT = "Bearer " + token.access_token;
                req = req.clone({
                    setHeaders: {
                        Authorization: JWT
                    }
                });
                return next.handle(req).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["catchError"])(function (err) {
                    _this.handleIdentityServerToken(err);
                    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
                }));
            }));
        }
        else if (req.url.includes('Service360LicenseDetails')) {
            return this.authService.access_token_license(__WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["a" /* LicensePortalProduct */].Service360, __WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["b" /* ProductClientSecret */].Service360).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["switchMap"])(function (token) {
                var JWT = "Bearer " + token.access_token;
                req = req.clone({
                    setHeaders: {
                        Authorization: JWT
                    }
                });
                return next.handle(req).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["catchError"])(function (err) {
                    _this.handleIdentityServerToken(err);
                    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
                }));
            }));
        }
        else if (req.url.includes('ProductLicenseDetails') || req.url.includes('ProductPurchaseDetails') || req.url.includes('ProductActivationDetails') || req.url.includes('ProductRenewalDetails') || req.url.includes('Operations')) {
            return this.authService.access_token_license(__WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["a" /* LicensePortalProduct */].SCAL, __WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["b" /* ProductClientSecret */].SCAL).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["switchMap"])(function (token) {
                var JWT = "Bearer " + token.access_token;
                req = req.clone({
                    setHeaders: {
                        Authorization: JWT
                    }
                });
                return next.handle(req).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["catchError"])(function (err) {
                    _this.handleIdentityServerToken(err);
                    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
                }));
            }));
        }
        else if (req.url.includes('SmartCal360NLicenseDetail')) {
            return this.authService.access_token_license(__WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["a" /* LicensePortalProduct */].SmartCal360N, __WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["b" /* ProductClientSecret */].SmartCal360N).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["switchMap"])(function (token) {
                var JWT = "Bearer " + token.access_token;
                req = req.clone({
                    setHeaders: {
                        Authorization: JWT
                    }
                });
                return next.handle(req).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["catchError"])(function (err) {
                    _this.handleIdentityServerToken(err);
                    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
                }));
            }));
        }
        else if (req.url.includes('SyncIT')) {
            return this.authService.access_token_license(__WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["a" /* LicensePortalProduct */].SYNCIt, __WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["b" /* ProductClientSecret */].SyncIT).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["switchMap"])(function (token) {
                var JWT = "Bearer " + token.access_token;
                req = req.clone({
                    setHeaders: {
                        Authorization: JWT
                    }
                });
                return next.handle(req).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["catchError"])(function (err) {
                    _this.handleIdentityServerToken(err);
                    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
                }));
            }));
        }
        else {
            return this.adalService.acquireTokenResilient("75db915c-344c-4e36-a5f2-20925770c15b")
                .pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["mergeMap"])(function (token) {
                if (token) {
                    req = req.clone({
                        setHeaders: {
                            Authorization: 'Bearer ' + token,
                        },
                    });
                }
                return next.handle(req)
                    .pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["catchError"])(function (err) {
                    _this.handleAzureADError(err);
                    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
                }));
            }));
        }
    };
    AuthInterceptor.prototype.handleIdentityServerToken = function (err) {
        if (err.status == 404) {
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Warning", "The Client was unable to connect the API " + err.url, 'warning');
            this.appLoaderService.close();
        }
        else if (err.status == 500) {
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Warning", "The server encountered an unexpected condition that prevented it from fulfilling the request.", "warning");
            this.appLoaderService.close();
        }
        else if (err.status == 401) {
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Warning", "UnAuthorized Token..!", "warning");
            this.appLoaderService.close();
        }
        else {
            this.appLoaderService.close();
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Warning", "Something went wrong! Please contact administrator..!", "warning");
        }
    };
    AuthInterceptor.prototype.handleAzureADError = function (err) {
        if (err.status == 404) {
            this.appLoaderService.close();
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Warning", "The Client was unable to connect the API " + err.url, 'warning');
        }
        else if (err.status == 500) {
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Warning", "The server encountered an unexpected condition that prevented it from fulfilling the request.", "warning");
        }
        else if (err.status == 401) {
            this.appLoaderService.close();
            window.close();
            window.location.href = "/login";
        }
        else {
            this.appLoaderService.close();
            __WEBPACK_IMPORTED_MODULE_6_sweetalert2___default.a.fire("Warning", "Something went wrong! Please contact administrator..!", "warning");
        }
    };
    AuthInterceptor = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __param(1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(DEFAULT_TIMEOUT)),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__adal_service__["a" /* AdalService */], Number, __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], __WEBPACK_IMPORTED_MODULE_4__auth_service__["a" /* AuthService */], __WEBPACK_IMPORTED_MODULE_5__services_app_loader_app_loader_service__["a" /* AppLoaderService */]])
    ], AuthInterceptor);
    return AuthInterceptor;
}());



/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_http__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(55);






var AuthService = /** @class */ (function () {
    function AuthService(http, appLoaderService) {
        this.http = http;
        this.appLoaderService = appLoaderService;
        this.tokenCache = null;
        this.tokenExpiryTime = 0;
        this.licenseTokenCache = new Map();
    }
    AuthService.prototype.access_token = function () {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["c" /* Headers */]({
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
            "No-Auth": "True",
        });
        var options = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["d" /* RequestOptions */]({ headers: headers });
        var data = "grant_type=client_credentials&scope=LicenseandActivationAPIAccess&" +
            "client_secret=54012654468d382b6f75159d7fd6fe75&client_id=14";
        return this.http
            .post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].TokenGenerationUrl + "connect/token", data, options)
            .map(function (res) { return res.json(); })
            .catch(function (err) {
            if (err.status == 404) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("Warning", "The Client was unable to connect the API " + err.url, "warning");
                _this.appLoaderService.close();
            }
            else if (err.status == 500) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("Warning", "The server encountered an unexpected condition that prevented it from fulfilling the request.", "warning");
                _this.appLoaderService.close();
            }
            else if (err.status == 401) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("Warning", "UnAuthorized Token..!", "warning");
                _this.appLoaderService.close();
            }
            else {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("Warning", "Something went wrong! Please contact administrator..!", "warning");
                _this.appLoaderService.close();
            }
            return __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"].throw(err);
        });
    };
    AuthService.prototype.access_token_licenseFreyalCode = function (client_id, client_secret) {
        var _this = this;
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["c" /* Headers */]({
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
            "No-Auth": "True",
        });
        var options = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["d" /* RequestOptions */]({ headers: headers });
        var body = "grant_type=client_credentials&scope=LicenseandActivationAPIAccess&client_secret=" +
            client_secret +
            "&client_id=" +
            client_id;
        return this.http
            .post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].TokenGenerationUrl + "connect/token", body, options)
            .map(function (response) { return response.json(); })
            .catch(function (error) {
            if (error.status == 404) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("Warning", "The Client was unable to connect the API " + error.url, "warning");
                _this.appLoaderService.close();
            }
            else if (error.status == 500) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("Warning", "The server encountered an unexpected condition that prevented it from fulfilling the request.", "warning");
                _this.appLoaderService.close();
            }
            else if (error.status == 401) {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("Warning", "UnAuthorized Token..!", "warning");
                _this.appLoaderService.close();
            }
            else {
                __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("Warning", "Something went wrong! Please contact administrator..!", "warning");
                _this.appLoaderService.close();
            }
            return __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"].throw(error);
        });
    };
    AuthService.prototype.access_token_license = function (client_id, client_secret) {
        var _this = this;
        var cached = this.licenseTokenCache.get(client_id);
        // ✅ Return cached token if valid
        if (cached && Date.now() < cached.expiry) {
            return __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"].of(cached.token);
        }
        var headers = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["c" /* Headers */]({
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
            "No-Auth": "True",
        });
        var options = new __WEBPACK_IMPORTED_MODULE_1__angular_http__["d" /* RequestOptions */]({ headers: headers });
        var body = "grant_type=client_credentials&scope=LicenseandActivationAPIAccess&" +
            "client_secret=" +
            client_secret +
            "&client_id=" +
            client_id;
        return this.http
            .post(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].TokenGenerationUrl + "connect/token", body, options)
            .map(function (response) {
            var token = response.json();
            // ✅ Cache per product
            _this.licenseTokenCache.set(client_id, {
                token: token,
                expiry: Date.now() + token.expires_in * 1000 - 60000,
            });
            return token;
        })
            .catch(function (err) { return _this.handleError(err); });
    };
    AuthService.prototype.handleError = function (error) {
        if (error.status == 404) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("Warning", "The Client was unable to connect the API " + error.url, "warning");
        }
        else if (error.status == 500) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("Warning", "The server encountered an unexpected condition that prevented it from fulfilling the request.", "warning");
        }
        else if (error.status == 401) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("Warning", "UnAuthorized Token..!", "warning");
        }
        else {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire("Warning", "Something went wrong! Please contact administrator..!", "warning");
        }
        this.appLoaderService.close();
        return __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"].throw(error);
    };
    AuthService = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_http__["e" /* Http */], __WEBPACK_IMPORTED_MODULE_4__services_app_loader_app_loader_service__["a" /* AppLoaderService */]])
    ], AuthService);
    return AuthService;
}());



/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OTAAuthGuard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(4);


var OTAAuthGuard = /** @class */ (function () {
    function OTAAuthGuard(router) {
        this.router = router;
    }
    OTAAuthGuard.prototype.canActivate = function () {
        if (localStorage.getItem("portalAccess") === "1" || localStorage.getItem("portalAccess") === "3") {
            return true;
        }
        this.router.navigate(['/access-denied']);
        return false;
    };
    OTAAuthGuard.prototype.canActivateChild = function () {
        return this.canActivate();
    };
    OTAAuthGuard = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* Router */]])
    ], OTAAuthGuard);
    return OTAAuthGuard;
}());



/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export httpInterceptorProviders */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SharedModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adal_access_guard__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common_http__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_interceptor__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__searchable_multi_select_searchable_multi_select_component__ = __webpack_require__(765);







var httpInterceptorProviders = [
    { provide: __WEBPACK_IMPORTED_MODULE_4__angular_common_http__["b" /* HTTP_INTERCEPTORS */], useClass: __WEBPACK_IMPORTED_MODULE_5__auth_interceptor__["a" /* AuthInterceptor */], multi: true },
];
var SharedModule = /** @class */ (function () {
    function SharedModule() {
    }
    SharedModule = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_1__angular_common__["a" /* CommonModule */],
                __WEBPACK_IMPORTED_MODULE_4__angular_common_http__["a" /* HttpClientModule */]
            ],
            declarations: [__WEBPACK_IMPORTED_MODULE_6__searchable_multi_select_searchable_multi_select_component__["a" /* SearchableMultiSelectComponent */]],
            exports: [__WEBPACK_IMPORTED_MODULE_6__searchable_multi_select_searchable_multi_select_component__["a" /* SearchableMultiSelectComponent */]],
            providers: [__WEBPACK_IMPORTED_MODULE_3__adal_service__["a" /* AdalService */], __WEBPACK_IMPORTED_MODULE_2__adal_access_guard__["a" /* AdalAccessGuard */], httpInterceptorProviders]
        })
    ], SharedModule);
    return SharedModule;
}());



/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutaddUserComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ProductService__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_Rx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__interfaces_LicenseModel__ = __webpack_require__(33);













var PageLayoutaddUserComponent = /** @class */ (function () {
    function PageLayoutaddUserComponent(dialog, router, route, formBuilder, snackBar, appLoaderService, productService, adalService, userService, licenseService) {
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
        this.appLoaderService = appLoaderService;
        this.productService = productService;
        this.adalService = adalService;
        this.userService = userService;
        this.licenseService = licenseService;
        this.productAdd = false;
        this.productDelete = false;
        this.productApprove = false;
        this.submitted = false;
        this.chkAllProduct = false;
        this.flagInstrument = false;
        this.Oldselected = 1;
        this.loggeduserrole = Number(localStorage.getItem("role"));
        this.LicenseRole = 0;
        this.licenseRightsArray = [];
        this.items = [
            {
                label: "Developer",
                value: 1,
            },
            {
                label: "QA",
                value: 2,
            },
            {
                label: "Product Management",
                value: 3,
            },
        ];
        this.userRightsArray = [];
        this.newDynamicInstrument = {};
        // Check Authentication
        if (!this.adalService.getCachedToken()) {
            this.router.navigate(["login"]);
        }
        this.getInstrument();
        this.getLicenseProducts();
    }
    PageLayoutaddUserComponent.prototype.radioChange = function (event) {
        var _this = this;
        var role = "";
        if (event.value == 1) {
            role = "Developer";
        }
        else if (event.value == 2) {
            role = "QA";
        }
        else {
            role = "Product Management";
        }
        this.selected = event.value;
        __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a
            .fire({
            title: "<strong>User Role Change</strong>",
            icon: "info",
            html: "\n        <p>You are about to grant " +
                this.validationForm.value.Name.trim() +
                " " +
                role +
                " access.</p>\n        <p><b>Are you sure want to continue?</b></p>\n        ",
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: "Continue",
            confirmButtonAriaLabel: "Continue",
            cancelButtonText: "Cancel",
            cancelButtonAriaLabel: "Cancel",
        })
            .then(function (result) {
            if (result.isConfirmed) {
                _this.Oldselected = _this.selected;
                // Reset all rights
                // this.productData.forEach((element) => {
                //
                //   element.isDirtyAddchecked = false;
                //   element.isDirtyActiveInactiveChecked = false;
                //   element.isDirtyApprovechecked = false;
                //   element.Addchecked = false;
                //   element.Approvechecked = false;
                //   element.ActiveInactiveChecked = false;
                // });
            }
            else if (result.isDismissed) {
                _this.selected = _this.Oldselected;
            }
        });
        //this.filter['property'] = this.selected;
        //console.log(this.filter);
    };
    PageLayoutaddUserComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sub = this.route.params.subscribe(function (params) {
            _this.UserId = params["id"];
            if (_this.UserId == 0) {
                _this.UserId = 0;
                _this.chkAllProduct = false;
            }
            if (_this.UserId != 0) {
                _this.getUserDetail(_this.UserId);
                _this.getUserAllRights(_this.UserId);
                // this.userRights(this.UserId);
            }
            _this.buildForm();
        });
        if (this.UserId != 0) {
            // this.userRights(this.UserId);
            this.getUserAllRights(this.UserId);
        }
    };
    PageLayoutaddUserComponent.prototype.buildForm = function () {
        this.validationForm = this.formBuilder.group({
            Name: [
                "",
                [__WEBPACK_IMPORTED_MODULE_5__angular_forms__["e" /* Validators */].required, __WEBPACK_IMPORTED_MODULE_5__angular_forms__["e" /* Validators */].pattern("\\S[a-zA-Z ]{2,50}$")],
            ],
            EmailId: [
                "",
                [
                    __WEBPACK_IMPORTED_MODULE_5__angular_forms__["e" /* Validators */].required,
                    __WEBPACK_IMPORTED_MODULE_5__angular_forms__["e" /* Validators */].email,
                    __WEBPACK_IMPORTED_MODULE_5__angular_forms__["e" /* Validators */].pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"),
                ],
            ],
            IsAdmin: false,
            Role: 1,
            OTARights: false,
            LicensingRights: false,
        });
    };
    PageLayoutaddUserComponent.prototype.OTARightsChange = function (event) {
        if (event.checked) {
            this.OTARights = true;
            this.selected = 1; //by default developer role would be selected
        }
        else {
            this.OTARights = false;
            this.selected = 0;
        }
    };
    PageLayoutaddUserComponent.prototype.LicenseRightsChange = function (event) {
        if (event.checked) {
            this.LicensingRights = true;
            this.LicenseRole = 1;
        }
        else {
            this.LicensingRights = false;
            this.LicenseRole = 0;
        }
    };
    PageLayoutaddUserComponent.prototype.ExpandProductRightsColumn = function () {
        this.isProductRightsColumnExpanded = (this.isProductRightsColumnExpanded == null) ? true : null;
    };
    PageLayoutaddUserComponent.prototype.ExpandLicenseRightsColumn = function () {
        this.isLicenseRightsColumnExpanded = (this.isLicenseRightsColumnExpanded == null) ? true : null;
    };
    PageLayoutaddUserComponent.prototype.CheckAllProductOptions = function () {
        if (this.chkAllProduct) {
            this.productData.forEach(function (val) {
                val.checked = true;
                val.Addchecked = true;
                val.ActiveInactiveChecked = true;
                val.Approvechecked = true;
            });
            this.productAdd = true;
            this.productDelete = true;
            this.productApprove = true;
        }
        if (this.productData.every(function (val) { return val.checked; })) {
            this.chkAllProduct = false;
            this.productData.forEach(function (val) {
                val.checked = false;
                val.Addchecked = false;
                val.ActiveInactiveChecked = false;
                val.Approvechecked = false;
            });
            this.productAdd = false;
            this.productDelete = false;
            this.productApprove = false;
        }
        else {
            this.chkAllProduct = true;
            this.productData.forEach(function (val) {
                val.checked = true;
                val.Addchecked = true;
                val.ActiveInactiveChecked = true;
                val.Approvechecked = true;
            });
            this.productAdd = true;
            this.productDelete = true;
            this.productApprove = true;
        }
    };
    PageLayoutaddUserComponent.prototype.changeproductvalue = function (i) {
        if (this.productData[i].checked) {
            this.productData[i].Addchecked = true;
            this.productData[i].ActiveInactiveChecked = true;
            this.productData[i].Approvechecked = true;
        }
        else {
            this.productData[i].Addchecked = false;
            this.productData[i].ActiveInactiveChecked = false;
            this.productData[i].Approvechecked = false;
        }
    };
    PageLayoutaddUserComponent.prototype.getInstrument = function () {
        var _this = this;
        this.productService.getReleaseProductsList().subscribe(function (data) {
            _this.productData = data.DataObject;
            for (var _i = 0, _a = _this.productData; _i < _a.length; _i++) {
                var row = _a[_i];
                row.checked = false;
                row.Addchecked = false;
                row.ActiveInactiveChecked = false;
                row.Approvechecked = false;
                row.isDirtyAddchecked = false;
                row.isDirtyActiveInactiveChecked = false;
                row.isDirtyApprovechecked = false;
            }
        });
    };
    PageLayoutaddUserComponent.prototype.getLicenseProducts = function () {
        var _this = this;
        this.licenseService.getLicensePortalProducts().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.licenseProducts = data.DataObject;
                for (var _i = 0, _a = _this.licenseProducts; _i < _a.length; _i++) {
                    var row = _a[_i];
                    row.IsAddEdit = false;
                    row.IsDelete = false;
                }
            }
            else {
            }
        });
    };
    PageLayoutaddUserComponent.prototype.checkornot = function () {
        return false;
    };
    PageLayoutaddUserComponent.prototype.checkDevValue = function (type, value, product) {
        var _this = this;
        if (this.loggeduserrole != type) {
            var message = "";
            var buttontxt = "";
            if (value == true) {
                // Grant
                message =
                    "Are you aware of the potential risks associated with granting access to the another department, and do you accept full responsibility for any issues that may arise?";
                buttontxt = "Accept";
            }
            else {
                // Revoke
                message =
                    "Revoking access for other departments can potentially disrupt workflow and impact the user's ability to perform their duties. It is recommended to consult with the respective department administrator for their input and approval on this change.";
                buttontxt = "Continue";
            }
            __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a
                .fire({
                title: "<strong style='color: red;'>Bypassing Established Workflows</strong>",
                icon: "info",
                html: "\n        <p>" +
                    message +
                    "</p>\n        <b>Please confirm your action:</b>\n        <ul>\n        <li style=\"margin-top:10px;\"><b>" +
                    buttontxt +
                    ":</b> Proceed with the authorization change despite the recommendation.</li>\n        <li><b>Cancel:</b> Restore the original settings and consult with the department administrator.</li>\n        </ul>\n        ",
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText: buttontxt,
                confirmButtonAriaLabel: buttontxt,
                cancelButtonText: "Cancel",
                cancelButtonAriaLabel: "Cancel",
            })
                .then(function (result) {
                if (!result.isConfirmed) {
                    _this.productData.forEach(function (element) {
                        if (element.ProductId == product.ProductId) {
                            if (type == 1) {
                                element.Addchecked = value == true ? false : true;
                            }
                            else if (type == 2) {
                                element.Approvechecked = value == true ? false : true;
                            }
                            else if (type == 3) {
                                element.ActiveInactiveChecked = value == true ? false : true;
                            }
                        }
                    });
                }
                else {
                    _this.productData.forEach(function (element) {
                        if (element.ProductId == product.ProductId) {
                            if (type == 1) {
                                element.isDirtyAddchecked = true;
                            }
                            else if (type == 2) {
                                element.isDirtyActiveInactiveChecked = true;
                            }
                            else if (type == 3) {
                                element.isDirtyApprovechecked = true;
                            }
                        }
                    });
                }
            });
        }
        else {
            this.productData.forEach(function (element) {
                if (element.ProductId == product.ProductId) {
                    if (element.ProductId == product.ProductId) {
                        if (type == 1) {
                            element.isDirtyAddchecked = true;
                        }
                        else if (type == 2) {
                            element.isDirtyActiveInactiveChecked = true;
                        }
                        else if (type == 3) {
                            element.isDirtyApprovechecked = true;
                        }
                    }
                }
            });
        }
    };
    PageLayoutaddUserComponent.prototype.getUserDetail = function (UserId) {
        var _this = this;
        this.userService.getUserById(UserId).subscribe(function (Data) {
            console.log(Data);
            _this.IsAdmin = Data.IsAdmin;
            _this.selected = Data.Role;
            _this.Oldselected = Data.Role;
            _this.LicenseRole = Data.LicenseRole;
            var OTARightsSelected = (Data.PortalAccess == __WEBPACK_IMPORTED_MODULE_11__interfaces_LicenseModel__["c" /* PortalAccess */]['OTA'] || Data.PortalAccess == __WEBPACK_IMPORTED_MODULE_11__interfaces_LicenseModel__["c" /* PortalAccess */]['All']) ? true : false;
            var LicensingRightSelected = (Data.PortalAccess == __WEBPACK_IMPORTED_MODULE_11__interfaces_LicenseModel__["c" /* PortalAccess */]['LicensingAndAdv'] || Data.PortalAccess == __WEBPACK_IMPORTED_MODULE_11__interfaces_LicenseModel__["c" /* PortalAccess */]['All']) ? true : false;
            _this.validationForm.patchValue({
                Name: Data.Name,
                EmailId: Data.EmailId,
                IsAdmin: Data.IsAdmin,
                Role: Data.Role,
                OTARights: OTARightsSelected,
                LicensingRights: LicensingRightSelected
            });
        });
    };
    PageLayoutaddUserComponent.prototype.userRights = function (UserId) {
        var _this = this;
        this.userService.getUserRights(UserId).subscribe(function (Data) {
            if (!Data.IsError && Data.DataObject != "") {
                for (var _i = 0, _a = Data.DataObject; _i < _a.length; _i++) {
                    var row = _a[_i];
                    for (var _b = 0, _c = _this.productData; _b < _c.length; _b++) {
                        var col = _c[_b];
                        if (col.ProductId == row.ProductId) {
                            _this.CheckRights(row, col);
                        }
                    }
                }
                if (!_this.flagInstrument)
                    _this.chkAllProduct = true;
                else
                    _this.chkAllProduct = false;
            }
            else {
                _this.errorMessage = Data.Error;
            }
        });
    };
    PageLayoutaddUserComponent.prototype.getUserAllRights = function (UserId) {
        var _this = this;
        this.userService.getUserAllRightsById(UserId).subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                for (var _i = 0, _a = data.DataObject; _i < _a.length; _i++) {
                    var row = _a[_i];
                    if (row.LicenseProductId) {
                        for (var _b = 0, _c = _this.licenseProducts; _b < _c.length; _b++) {
                            var product = _c[_b];
                            if (product.ProductId == row.LicenseProductId) {
                                _this.checkLicenseRights(row, product);
                            }
                        }
                    }
                    if (row.ProductId) {
                        for (var _d = 0, _e = _this.productData; _d < _e.length; _d++) {
                            var product = _e[_d];
                            if (product.ProductId == row.ProductId) {
                                _this.CheckRights(row, product);
                            }
                        }
                    }
                }
            }
        });
    };
    PageLayoutaddUserComponent.prototype.checkLicenseRights = function (row, product) {
        if (row.LicenseAddEditRight) {
            product.IsAddEdit = true;
        }
        if (row.LicenseDeleteRight) {
            product.IsDelete = true;
        }
    };
    PageLayoutaddUserComponent.prototype.CheckRights = function (row, col) {
        if (row.IsAdd)
            col.Addchecked = true;
        else
            this.flagInstrument = true;
        if (row.IsEdit)
            col.Editchecked = true;
        else
            this.flagInstrument = true;
        if (row.IsActiveInactive)
            col.ActiveInactiveChecked = true;
        else
            this.flagInstrument = true;
        if (row.IsApproveReject)
            col.Approvechecked = true;
        else
            this.flagInstrument = true;
        if (row.IsAdd && row.IsEdit && row.IsActiveInactive && row.IsApproveReject)
            col.checked = true;
    };
    PageLayoutaddUserComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.validationForm.value.OTARights && this.validationForm.value.LicensingRights) {
            this.portalAccess = __WEBPACK_IMPORTED_MODULE_11__interfaces_LicenseModel__["c" /* PortalAccess */]['All'];
        }
        else if (this.validationForm.value.OTARights) {
            this.portalAccess = __WEBPACK_IMPORTED_MODULE_11__interfaces_LicenseModel__["c" /* PortalAccess */]['OTA'];
        }
        else if (this.validationForm.value.LicensingRights) {
            this.portalAccess = __WEBPACK_IMPORTED_MODULE_11__interfaces_LicenseModel__["c" /* PortalAccess */]['LicensingAndAdv'];
        }
        else {
            __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a.fire({
                title: "Please select atleast one user right",
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonText: "OK",
            });
            return;
        }
        this.appLoaderService.open();
        this.submitted = true;
        // stop the process here if form is invalid
        // if (this.validationForm.invalid) {
        //     return;
        // }
        // Check Email Id Already Exists or Not
        this.userService
            .getUsersByData(this.validationForm.value.EmailId, this.UserId)
            .subscribe(function (data) {
            if (data.IsError) {
                _this.appLoaderService.close();
                __WEBPACK_IMPORTED_MODULE_9_sweetalert2___default.a
                    .fire({
                    title: "<strong> Warning</strong>",
                    icon: "warning",
                    html: "\n            <p>" +
                        data.Error +
                        " </p>",
                    showCloseButton: false,
                    focusConfirm: false,
                })
                    .then(function (result) {
                    _this.validationForm.patchValue({
                        EmailId: ''
                    });
                });
            }
            else {
                _this.errorMessage = "";
                _this.SaveUserDetail();
            }
        });
    };
    PageLayoutaddUserComponent.prototype.oneditcancel = function () {
        this.UserId = 0;
        this.router.navigate(["user-management/user"]);
    };
    PageLayoutaddUserComponent.prototype.EditUserDetail = function (row) {
        this.UserId = row.UserId;
        this.validationForm.patchValue({
            Name: row.Name,
            EmailId: row.EmailId,
        });
    };
    PageLayoutaddUserComponent.prototype.checkCheckBoxvalue = function (event) {
        this.IsAdmin = event.checked;
    };
    PageLayoutaddUserComponent.prototype.SaveUserDetail = function () {
        var _this = this;
        this.productData.forEach(function (obj) {
            _this.newDynamicInstrument = {
                ProductId: obj.ProductId,
                IsAdd: obj.Addchecked,
                IsActiveInactive: obj.ActiveInactiveChecked,
                IsApproveReject: obj.Approvechecked,
            };
            _this.userRightsArray.push(_this.newDynamicInstrument);
        });
        //licensing rights array
        this.licenseProducts.forEach(function (product) {
            _this.licenseRightsArray.push({
                ProductId: product.ProductId,
                IsAddEdit: product.IsAddEdit,
                IsDelete: product.IsDelete
            });
        });
        if (this.UserId == 0) {
            var model = {
                UserId: 0,
                Name: this.validationForm.value.Name.trim(),
                EmailId: this.validationForm.value.EmailId.trim(),
                UserRights: this.userRightsArray,
                LicensingRights: this.licenseRightsArray,
                IsAdmin: this.IsAdmin,
                Role: this.selected,
                LicenseRole: this.LicenseRole,
                PortalAccess: this.portalAccess,
                CreatedBy: Number(localStorage.getItem("userid")),
                UpdatedBy: Number(localStorage.getItem("userid")),
            };
            this.userService.addUser(model).subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    _this.validationForm.patchValue({
                        Name: "",
                        EmailId: "",
                        IsAdmin: false,
                        Role: 1,
                    });
                    _this.selected = 1;
                    _this.userRightsArray = [];
                    _this.licenseRightsArray = [];
                    _this.LicenseRole = 0;
                    _this.portalAccess = 0;
                    _this.newDynamicInstrument = {};
                    _this.appLoaderService.close();
                    _this.snackBar.open("User Rights Created Successfully", "", {
                        duration: 2000,
                    });
                    _this.userService.notifyOther({
                        option: "onSave",
                        value: "User Rights Successfully",
                    });
                    _this.router.navigate(["/user-management/user"]);
                }
                else {
                    _this.appLoaderService.close();
                }
            }, function (_error) {
                _this.appLoaderService.close();
            });
        }
        else {
            var model = {
                UserId: Number(this.UserId),
                Name: this.validationForm.value.Name.trim(),
                EmailId: this.validationForm.value.EmailId.trim(),
                UserRights: this.userRightsArray,
                LicensingRights: this.licenseRightsArray,
                IsAdmin: this.IsAdmin,
                Role: this.selected,
                LicenseRole: this.LicenseRole,
                PortalAccess: this.portalAccess,
                CreatedBy: Number(localStorage.getItem("userid")),
                UpdatedBy: Number(localStorage.getItem("userid")),
            };
            console.log(model);
            this.userService.updateUser(model).subscribe(function (data) {
                if (!data.IsError && data.DataObject != null) {
                    _this.validationForm.patchValue({
                        Name: "",
                        EmailId: "",
                        IsAdmin: false,
                        Role: 1,
                    });
                    _this.selected = 1;
                    _this.userRightsArray = [];
                    _this.licenseRightsArray = [];
                    _this.LicenseRole = 0;
                    _this.portalAccess = 0;
                    _this.newDynamicInstrument = {};
                    _this.appLoaderService.close();
                    _this.snackBar.open("User Rights Updated Successfully", "", {
                        duration: 2000,
                    });
                    _this.userService.notifyOther({
                        option: "onSave",
                        value: "User Rights Successfully",
                    });
                    _this.router.navigate(["/user-management/user"]);
                }
                else {
                    _this.appLoaderService.close();
                }
            }, function (_error) {
                _this.appLoaderService.close();
            });
        }
    };
    PageLayoutaddUserComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: "my-page-layout-add-user",
            styles: [],
            template: __webpack_require__(1081),
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_4__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_3__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_3__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_5__angular_forms__["f" /* FormBuilder */],
            __WEBPACK_IMPORTED_MODULE_4__angular_material__["c" /* MdSnackBar */],
            __WEBPACK_IMPORTED_MODULE_8__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_2__services_ProductService__["a" /* ProductService */],
            __WEBPACK_IMPORTED_MODULE_7__shared_adal_service__["a" /* AdalService */],
            __WEBPACK_IMPORTED_MODULE_1__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_10__services_LicenseService__["a" /* LicenseService */]])
    ], PageLayoutaddUserComponent);
    return PageLayoutaddUserComponent;
}());



/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutUserComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_PagerService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_rights_summary_userrightssummary_component__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__ = __webpack_require__(33);








var PageLayoutUserComponent = /** @class */ (function () {
    function PageLayoutUserComponent(dialog, router, pagerService, userService, adalService) {
        this.dialog = dialog;
        this.router = router;
        this.pagerService = pagerService;
        this.userService = userService;
        this.adalService = adalService;
        this.pager = {};
        //Check Authentication
        if (!this.adalService.getCachedToken()) {
            this.router.navigate(["login"]);
        }
        this.getUserDetail();
    }
    PageLayoutUserComponent.prototype.getUserDetail = function () {
        var _this = this;
        this.userService.getUser().subscribe(function (data) {
            _this.userData = data;
            _this.userData.forEach(function (element) {
                element.Role = _this.setRoleText(element.Role, element.LicenseRole);
            });
            _this.pagedItems = _this.userData;
            //this.setPage(1);
        }, function (error) {
            _this.errorMessage = error;
        });
    };
    PageLayoutUserComponent.prototype.setRoleText = function (OTARole, licenseRole) {
        if (OTARole == 0 && licenseRole != 0) {
            return __WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["d" /* LicenseRoles */][licenseRole];
        }
        else if (OTARole != 0 && licenseRole == 0) {
            return __WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["e" /* OTARoles */][OTARole];
        }
        else if (OTARole != 0 && licenseRole != 0) {
            return __WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["e" /* OTARoles */][OTARole] + ' , ' + __WEBPACK_IMPORTED_MODULE_7__interfaces_LicenseModel__["d" /* LicenseRoles */][licenseRole];
        }
    };
    PageLayoutUserComponent.prototype.openDialogWithAResult = function (row) {
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_6__user_rights_summary_userrightssummary_component__["a" /* PageLayoutUserRightsSummaryComponent */], { height: "50%", width: "60%", data: { userId: row.UserId, UserName: row.Name, Role: row.Role } });
        dialogRef.afterClosed().subscribe(function (_result) {
            // Do Nothing
        });
    };
    PageLayoutUserComponent.prototype.setPage = function (page) {
        this.pager = this.pagerService.getPager(this.userData.length, page);
        this.pagedItems = this.userData.slice(this.pager.startIndex, this.pager.endIndex + 1);
    };
    PageLayoutUserComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: "my-page-layout-application",
            styles: [],
            template: __webpack_require__(1084),
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_3__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_5__services_PagerService__["a" /* PagerService */],
            __WEBPACK_IMPORTED_MODULE_2__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_4__shared_adal_service__["a" /* AdalService */]])
    ], PageLayoutUserComponent);
    return PageLayoutUserComponent;
}());



/***/ }),
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common_http__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_http__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angular2_moment__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angular2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angular2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hammerjs__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_routing_module__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_component__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__layout_main_component__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__layout_slim_scroll_directive__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__layout_preloader_directive__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__layout_header_header_component__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__layout_sidenav_sidenav_component__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__layout_sidenav_toggle_offcanvas_nav_directive__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__layout_sidenav_auto_close_mobile_nav_directive__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__layout_sidenav_sidenav_menu_sidenav_menu_component__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__layout_footer_footer_component__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__dashboard_dashboard_component__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__extra_pages_login_login_component__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__extra_pages_DownloadSCAL360_DownloadSCAL360_component__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__extra_pages_changelog_changelog_component__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_ng2_filter_pipe__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_ng2_filter_pipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_ng2_filter_pipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__layout_main_module__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__shared_shared_module__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__angularclass_hmr__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__angularclass_hmr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__angularclass_hmr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__angular_platform_browser_animations__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__shared_adal_access_guard__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__shared_auth_interceptor__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__shared_auth_service__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__services_app_loader_app_loader_component__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__services_NotificationService__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__license_portal_license_portal_module__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__license_portal_license_portal_component__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__layout_license_sidenav_license_sidenav_component__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__services_ExportToCSVService__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__extra_pages_HomePage_home_page_component__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__user_management_user_management_component__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__user_management_user_management_module__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__advertisement_advertisement_component__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__advertisement_advertisement_routing_module__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__advertisement_advertisement_module__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__shared_auth_admin_guard__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__layout_access_denied_access_denied_component__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__shared_license_auth_guard__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__shared_ota_auth_guard__ = __webpack_require__(372);










// Main



// Header

// Sidenav




// Footer

// Pages





// Sub modules


// hmr


// Code By Megha






















var AppModule = /** @class */ (function () {
    function AppModule(appRef) {
        this.appRef = appRef;
    }
    AppModule.prototype.hmrOnInit = function (store) {
        console.log('HMR store', store);
    };
    AppModule.prototype.hmrOnDestroy = function (store) {
        var cmpLocation = this.appRef.components.map(function (cmp) { return cmp.location.nativeElement; });
        // recreate elements
        store.disposeOldHosts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__angularclass_hmr__["createNewHosts"])(cmpLocation);
        // remove styles
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__angularclass_hmr__["removeNgStyles"])();
    };
    AppModule.prototype.hmrAfterDestroy = function (store) {
        // display new elements
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    };
    AppModule = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_2__angular_common_http__["a" /* HttpClientModule */],
                __WEBPACK_IMPORTED_MODULE_27__angular_platform_browser_animations__["a" /* BrowserAnimationsModule */],
                __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["a" /* BrowserModule */],
                __WEBPACK_IMPORTED_MODULE_3__angular_http__["a" /* HttpModule */],
                __WEBPACK_IMPORTED_MODULE_3__angular_http__["b" /* JsonpModule */],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_6_angular2_moment__["MomentModule"],
                __WEBPACK_IMPORTED_MODULE_8__app_routing_module__["a" /* AppRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_44__advertisement_advertisement_routing_module__["a" /* AdvertisementRoutingModule */],
                // Sub modules
                __WEBPACK_IMPORTED_MODULE_24__layout_main_module__["a" /* MainModule */],
                __WEBPACK_IMPORTED_MODULE_25__shared_shared_module__["a" /* SharedModule */],
                __WEBPACK_IMPORTED_MODULE_23_ng2_filter_pipe__["Ng2FilterPipeModule"],
                //license
                __WEBPACK_IMPORTED_MODULE_35__license_portal_license_portal_module__["a" /* LicensePortalModule */],
                //user management
                __WEBPACK_IMPORTED_MODULE_42__user_management_user_management_module__["a" /* UserManagementModule */],
                //Advertisement
                __WEBPACK_IMPORTED_MODULE_45__advertisement_advertisement_module__["a" /* AdvertisementModule */]
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_9__app_component__["a" /* AppComponent */],
                // Main
                __WEBPACK_IMPORTED_MODULE_10__layout_main_component__["a" /* AppMainComponent */],
                __WEBPACK_IMPORTED_MODULE_11__layout_slim_scroll_directive__["a" /* SlimScrollDirective */],
                __WEBPACK_IMPORTED_MODULE_12__layout_preloader_directive__["a" /* PreloaderDirective */],
                // Header
                __WEBPACK_IMPORTED_MODULE_13__layout_header_header_component__["a" /* AppHeaderComponent */],
                __WEBPACK_IMPORTED_MODULE_10__layout_main_component__["a" /* AppMainComponent */],
                // Sidenav
                __WEBPACK_IMPORTED_MODULE_14__layout_sidenav_sidenav_component__["a" /* AppSidenavComponent */],
                __WEBPACK_IMPORTED_MODULE_37__layout_license_sidenav_license_sidenav_component__["a" /* LicenseSideNavComponent */],
                __WEBPACK_IMPORTED_MODULE_15__layout_sidenav_toggle_offcanvas_nav_directive__["a" /* ToggleOffcanvasNavDirective */],
                __WEBPACK_IMPORTED_MODULE_16__layout_sidenav_auto_close_mobile_nav_directive__["a" /* AutoCloseMobileNavDirective */],
                __WEBPACK_IMPORTED_MODULE_17__layout_sidenav_sidenav_menu_sidenav_menu_component__["a" /* AppSidenavMenuComponent */],
                // Footer
                __WEBPACK_IMPORTED_MODULE_18__layout_footer_footer_component__["a" /* AppFooterComponent */],
                // Dashboards
                __WEBPACK_IMPORTED_MODULE_19__dashboard_dashboard_component__["a" /* DashboardComponent */],
                // Pages
                __WEBPACK_IMPORTED_MODULE_21__extra_pages_DownloadSCAL360_DownloadSCAL360_component__["a" /* PageDownloadSCAL360Component */],
                __WEBPACK_IMPORTED_MODULE_20__extra_pages_login_login_component__["a" /* PageLoginComponent */],
                __WEBPACK_IMPORTED_MODULE_22__extra_pages_changelog_changelog_component__["a" /* PageLayoutViewChangeLogComponent */],
                //license
                __WEBPACK_IMPORTED_MODULE_36__license_portal_license_portal_component__["a" /* LicensePortalComponent */],
                //UserManagement
                __WEBPACK_IMPORTED_MODULE_41__user_management_user_management_component__["a" /* UserManagementComponent */],
                //home-page
                __WEBPACK_IMPORTED_MODULE_40__extra_pages_HomePage_home_page_component__["a" /* HomePageComponent */],
                //advertisement
                __WEBPACK_IMPORTED_MODULE_43__advertisement_advertisement_component__["a" /* AdvertisementComponent */],
                __WEBPACK_IMPORTED_MODULE_47__layout_access_denied_access_denied_component__["a" /* AccessDeniedComponent */]
            ],
            bootstrap: [__WEBPACK_IMPORTED_MODULE_9__app_component__["a" /* AppComponent */]],
            providers: [__WEBPACK_IMPORTED_MODULE_30__shared_adal_service__["a" /* AdalService */], __WEBPACK_IMPORTED_MODULE_28__shared_adal_access_guard__["a" /* AdalAccessGuard */], __WEBPACK_IMPORTED_MODULE_46__shared_auth_admin_guard__["a" /* AuthGuard */], __WEBPACK_IMPORTED_MODULE_48__shared_license_auth_guard__["a" /* LicenseAuthGuard */], __WEBPACK_IMPORTED_MODULE_49__shared_ota_auth_guard__["a" /* OTAAuthGuard */], { provide: __WEBPACK_IMPORTED_MODULE_2__angular_common_http__["b" /* HTTP_INTERCEPTORS */], useClass: __WEBPACK_IMPORTED_MODULE_29__shared_auth_interceptor__["a" /* AuthInterceptor */], multi: true },
                { provide: __WEBPACK_IMPORTED_MODULE_29__shared_auth_interceptor__["b" /* DEFAULT_TIMEOUT */], useValue: 300000 }, __WEBPACK_IMPORTED_MODULE_32__services_app_loader_app_loader_service__["a" /* AppLoaderService */], __WEBPACK_IMPORTED_MODULE_31__shared_auth_service__["a" /* AuthService */], __WEBPACK_IMPORTED_MODULE_34__services_NotificationService__["a" /* NotificationService */], __WEBPACK_IMPORTED_MODULE_38__services_LicenseService__["a" /* LicenseService */], __WEBPACK_IMPORTED_MODULE_39__services_ExportToCSVService__["a" /* ExportToCSVService */]],
            entryComponents: [__WEBPACK_IMPORTED_MODULE_33__services_app_loader_app_loader_component__["a" /* AppLoaderComponent */], __WEBPACK_IMPORTED_MODULE_22__extra_pages_changelog_changelog_component__["a" /* PageLayoutViewChangeLogComponent */]]
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationRef"]])
    ], AppModule);
    return AppModule;
}());



/***/ }),
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdvertisementModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__add_new_advertisement_add_new_advertisement_component__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__advertisement_routing_module__ = __webpack_require__(333);






var AdvertisementModule = /** @class */ (function () {
    function AdvertisementModule() {
    }
    AdvertisementModule = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_2__angular_common__["a" /* CommonModule */],
                __WEBPACK_IMPORTED_MODULE_3__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_4__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_5__advertisement_routing_module__["a" /* AdvertisementRoutingModule */]
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_1__add_new_advertisement_add_new_advertisement_component__["a" /* AddNewAdvertisementDialogComponent */]
            ]
        })
    ], AdvertisementModule);
    return AdvertisementModule;
}());



/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_main_component__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__extra_pages_login_login_component__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extra_pages_DownloadSCAL360_DownloadSCAL360_component__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_adal_access_guard__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__license_portal_license_portal_component__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extra_pages_HomePage_home_page_component__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_management_user_management_component__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__advertisement_advertisement_component__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__layout_access_denied_access_denied_component__ = __webpack_require__(341);


// Pages


// Page Layouts






var AppRoutes = [
    // { path: 'dashboard', redirectTo: 'home-page', pathMatch: 'full',canActivate: [AdalAccessGuard]},
    { path: 'buildinstrument', redirectTo: '/app/buildinstrument', pathMatch: 'full' },
    { path: 'access-denied', component: __WEBPACK_IMPORTED_MODULE_9__layout_access_denied_access_denied_component__["a" /* AccessDeniedComponent */] },
    { path: 'app', component: __WEBPACK_IMPORTED_MODULE_1__layout_main_component__["a" /* AppMainComponent */], canActivateChild: [__WEBPACK_IMPORTED_MODULE_4__shared_adal_access_guard__["a" /* AdalAccessGuard */]] },
    { path: 'login', component: __WEBPACK_IMPORTED_MODULE_2__extra_pages_login_login_component__["a" /* PageLoginComponent */] },
    { path: 'home-page', component: __WEBPACK_IMPORTED_MODULE_6__extra_pages_HomePage_home_page_component__["a" /* HomePageComponent */] },
    { path: 'DownloadSCAL360', component: __WEBPACK_IMPORTED_MODULE_3__extra_pages_DownloadSCAL360_DownloadSCAL360_component__["a" /* PageDownloadSCAL360Component */] },
    { path: 'license-portal', component: __WEBPACK_IMPORTED_MODULE_5__license_portal_license_portal_component__["a" /* LicensePortalComponent */] },
    { path: 'user-management', component: __WEBPACK_IMPORTED_MODULE_7__user_management_user_management_component__["a" /* UserManagementComponent */] },
    { path: 'advertisement', component: __WEBPACK_IMPORTED_MODULE_8__advertisement_advertisement_component__["a" /* AdvertisementComponent */] },
    { path: '**', redirectTo: 'home-page', pathMatch: 'full' },
];
var AppRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forRoot(AppRoutes, { useHash: true });


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_layout_service__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_font_awesome_scss__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_font_awesome_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_styles_font_awesome_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles_material2_theme_scss__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles_material2_theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_styles_material2_theme_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_bootstrap_scss__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_bootstrap_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_styles_bootstrap_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles_layout_scss__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_styles_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styles_theme_scss__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styles_theme_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_styles_theme_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_ui_scss__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_ui_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_styles_ui_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles_app_scss__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_styles_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_adal_service__ = __webpack_require__(6);




// 3rd



// custom





var AppComponent = /** @class */ (function () {
    function AppComponent(router, adalSvc) {
        this.router = router;
        this.adalSvc = adalSvc;
    }
    AppComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */];
        this.adalSvc.handleCallback();
        // Scroll to top on route change
        this.router.events.subscribe(function (evt) {
            if (!(evt instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* NavigationEnd */])) {
                return;
            }
            document.body.scrollTop = 0;
        });
    };
    AppComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-app',
            template: __webpack_require__(1014),
            providers: [__WEBPACK_IMPORTED_MODULE_3__layout_layout_service__["a" /* LayoutService */]],
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_11__shared_adal_service__["a" /* AdalService */]])
    ], AppComponent);
    return AppComponent;
}());



/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductReleaseFileRead; });
var ProductReleaseFileRead;
(function (ProductReleaseFileRead) {
    ProductReleaseFileRead[ProductReleaseFileRead["G3"] = 12] = "G3";
    ProductReleaseFileRead[ProductReleaseFileRead["PMD2"] = 13] = "PMD2";
    ProductReleaseFileRead[ProductReleaseFileRead["G3GLT"] = 41] = "G3GLT";
    ProductReleaseFileRead[ProductReleaseFileRead["PMD2GLT"] = 42] = "PMD2GLT";
    ProductReleaseFileRead[ProductReleaseFileRead["TrakIT4"] = 37] = "TrakIT4";
})(ProductReleaseFileRead || (ProductReleaseFileRead = {}));


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductRevFileNotReadFromFile; });
var ProductRevFileNotReadFromFile;
(function (ProductRevFileNotReadFromFile) {
    ProductRevFileNotReadFromFile[ProductRevFileNotReadFromFile["SCAL360"] = 14] = "SCAL360";
    ProductRevFileNotReadFromFile[ProductRevFileNotReadFromFile["SmartCal360"] = 11] = "SmartCal360";
    ProductRevFileNotReadFromFile[ProductRevFileNotReadFromFile["LZ50"] = 15] = "LZ50";
})(ProductRevFileNotReadFromFile || (ProductRevFileNotReadFromFile = {}));


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppFooterComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(55);


var AppFooterComponent = /** @class */ (function () {
    function AppFooterComponent() {
    }
    AppFooterComponent.prototype.ngOnInit = function () {
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* config */].ReleaseVersionNo;
    };
    AppFooterComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-app-footer',
            styles: [],
            template: __webpack_require__(1021)
        }),
        __metadata("design:paramtypes", [])
    ], AppFooterComponent);
    return AppFooterComponent;
}());



/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppHeaderComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);





var AppHeaderComponent = /** @class */ (function () {
    function AppHeaderComponent(adalService, userservice, router) {
        this.adalService = adalService;
        this.userservice = userservice;
        this.router = router;
        this.isSideNavOpen = false;
        this.inLicensePortal = false;
        this.menuToggle = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.username = localStorage.getItem('Name');
    }
    AppHeaderComponent.prototype.OnChanges = function () {
        console.log(this.isSideNavOpen);
    };
    AppHeaderComponent.prototype.onMenuClick = function () {
        this.menuToggle.emit();
    };
    AppHeaderComponent.prototype.ngOnInit = function () {
        this.getUserRights(Number(localStorage.getItem('userid')));
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* APPCONFIG */];
    };
    AppHeaderComponent.prototype.logOut = function () {
        localStorage.clear();
        this.adalService.logout();
    };
    AppHeaderComponent.prototype.getStyle = function (selected) {
        this.selectedTitle = selected;
    };
    AppHeaderComponent.prototype.removeStyle = function () {
        this.selectedTitle = '';
    };
    AppHeaderComponent.prototype.redirectuser = function () {
        this.router.navigate(["/user-management/user"]);
    };
    AppHeaderComponent.prototype.getUserRights = function (UserId) {
        var _this = this;
        this.userservice.getUserById(UserId).subscribe(function (Data) {
            _this.IsAdmin = Data.IsAdmin;
        }, function (error) {
            _this.errorMessage = error;
        });
    };
    AppHeaderComponent.prototype.redirectToHomePage = function () {
        this.router.navigate(['/home-page']);
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], AppHeaderComponent.prototype, "isSideNavOpen", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], AppHeaderComponent.prototype, "inLicensePortal", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
        __metadata("design:type", Object)
    ], AppHeaderComponent.prototype, "menuToggle", void 0);
    AppHeaderComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-app-header',
            styles: [__webpack_require__(962)],
            template: __webpack_require__(1022)
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__shared_adal_service__["a" /* AdalService */], __WEBPACK_IMPORTED_MODULE_3__services_UserService__["a" /* UserService */], __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */]])
    ], AppHeaderComponent);
    return AppHeaderComponent;
}());



/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicenseSideNavComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_router__ = __webpack_require__(4);



var LicenseSideNavComponent = /** @class */ (function () {
    function LicenseSideNavComponent(licenseService, router, route) {
        this.licenseService = licenseService;
        this.router = router;
        this.route = route;
        this.licenseProductFilter = { ProductName: '' };
    }
    LicenseSideNavComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.licenseService.getLicensePortalProducts().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.licenseProductList = data.DataObject;
            }
        });
    };
    LicenseSideNavComponent.prototype.checkSelected = function (product) {
        var _this = this;
        if (this.route.firstChild != null) {
            this.route.firstChild.paramMap.subscribe(function (params) {
                _this.selectedProductId = params.get('productId');
            });
            return product.ProductId == this.selectedProductId;
        }
    };
    LicenseSideNavComponent.prototype.getStyle = function (productName) {
        this.selectedTitle = productName;
    };
    LicenseSideNavComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            styles: [__webpack_require__(963)],
            template: __webpack_require__(1023),
            selector: 'license-nav-bar'
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__services_LicenseService__["a" /* LicenseService */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_2__angular_router__["b" /* ActivatedRoute */]])
    ], LicenseSideNavComponent);
    return LicenseSideNavComponent;
}());



/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_component__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_component__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__page_layouts_page_layouts_routing_module__ = __webpack_require__(364);




var routes = [
    {
        path: 'app',
        component: __WEBPACK_IMPORTED_MODULE_1__main_component__["a" /* AppMainComponent */],
        children: [
            { path: 'dashboard', component: __WEBPACK_IMPORTED_MODULE_2__dashboard_dashboard_component__["a" /* DashboardComponent */] }
        ].concat(__WEBPACK_IMPORTED_MODULE_3__page_layouts_page_layouts_routing_module__["b" /* PageLayoutsRoutes */])
    },
];
var MainRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(routes);


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_routing_module__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ProductService__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ProductReleaseService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_PagerService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__page_layouts_page_layouts_module__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__extra_pages_DownloadSCAL360_AzureDownloadService_service__ = __webpack_require__(335);








var MainModule = /** @class */ (function () {
    function MainModule() {
    }
    MainModule = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_1__main_routing_module__["a" /* MainRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_6__page_layouts_page_layouts_module__["a" /* PageLayoutsModule */]
            ],
            declarations: [],
            providers: [__WEBPACK_IMPORTED_MODULE_2__services_UserService__["a" /* UserService */],
                __WEBPACK_IMPORTED_MODULE_3__services_ProductService__["a" /* ProductService */],
                __WEBPACK_IMPORTED_MODULE_4__services_ProductReleaseService__["a" /* ProductReleaseService */],
                __WEBPACK_IMPORTED_MODULE_5__services_PagerService__["a" /* PagerService */],
                __WEBPACK_IMPORTED_MODULE_7__extra_pages_DownloadSCAL360_AzureDownloadService_service__["a" /* AzureDownloadService */]
            ]
        })
    ], MainModule);
    return MainModule;
}());



/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreloaderDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_service__ = __webpack_require__(342);



var PreloaderDirective = /** @class */ (function () {
    function PreloaderDirective(el, router, layoutService) {
        var _this = this;
        this.el = el;
        this.router = router;
        this.layoutService = layoutService;
        router.events.subscribe(function (event) {
            _this.navigationInterceptor(event);
        });
        this.subscription = layoutService.preloaderState$.subscribe(function (state) {
            _this.updatePreloader(state);
        });
    }
    PreloaderDirective.prototype.ngAfterViewInit = function () {
        this.$el = $(this.el.nativeElement);
    };
    PreloaderDirective.prototype.active = function () {
        if (this.$el) {
            this.$el.removeClass('hide').addClass('active');
        }
    };
    PreloaderDirective.prototype.hide = function () {
        if (this.$el) {
            this.$el.addClass('hide').removeClass('active');
        }
    };
    // Shows and hides the loading spinner during RouterEvent changes
    PreloaderDirective.prototype.navigationInterceptor = function (event) {
        if (event instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["d" /* NavigationStart */]) {
            this.active();
        }
        if (event instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* NavigationEnd */]) {
            this.hide();
        }
        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["e" /* NavigationCancel */]) {
            this.hide();
        }
        if (event instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["f" /* NavigationError */]) {
            this.hide();
        }
    };
    // 
    PreloaderDirective.prototype.updatePreloader = function (state) {
        // console.log('change state')
        if (state == 'active') {
            this.active();
        }
        if (state == 'hide') {
            this.hide();
        }
    };
    PreloaderDirective.prototype.ngOnDestroy = function () {
        // prevent memory leak when component destroyed
        this.subscription.unsubscribe();
    };
    PreloaderDirective = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
            selector: '[myPreloader]',
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* Router */], __WEBPACK_IMPORTED_MODULE_2__layout_service__["a" /* LayoutService */]])
    ], PreloaderDirective);
    return PreloaderDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(100)))

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchableDropdownComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var SearchableDropdownComponent = /** @class */ (function () {
    function SearchableDropdownComponent() {
        this.options = [];
        this.placeholder = 'Select';
        this.selectedChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.dropdownOpen = false;
        this.searchText = '';
    }
    SearchableDropdownComponent.prototype.toggleDropdown = function () {
        this.dropdownOpen = !this.dropdownOpen;
    };
    SearchableDropdownComponent.prototype.selectOption = function (option) {
        this.selected = option;
        this.selectedChange.emit(this.selected);
        this.dropdownOpen = false;
        this.searchText = '';
    };
    Object.defineProperty(SearchableDropdownComponent.prototype, "filteredOptions", {
        get: function () {
            if (!this.searchText)
                return this.options;
            var text = this.searchText.toLowerCase();
            return this.options.filter(function (o) { return o.toLowerCase().includes(text); });
        },
        enumerable: true,
        configurable: true
    });
    // Close dropdown on click outside
    SearchableDropdownComponent.prototype.clickOutside = function (event) {
        var target = event.target;
        if (!target.closest('.dropdown-container')) {
            this.dropdownOpen = false;
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Array)
    ], SearchableDropdownComponent.prototype, "options", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", String)
    ], SearchableDropdownComponent.prototype, "placeholder", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], SearchableDropdownComponent.prototype, "selected", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
        __metadata("design:type", Object)
    ], SearchableDropdownComponent.prototype, "selectedChange", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('document:click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], SearchableDropdownComponent.prototype, "clickOutside", null);
    SearchableDropdownComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'searchable-dropdown',
            template: __webpack_require__(1025),
            styles: [__webpack_require__(964)]
        })
    ], SearchableDropdownComponent);
    return SearchableDropdownComponent;
}());



/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoCloseMobileNavDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(93);



// Mobile only: automatically close sidebar on route change.
var AutoCloseMobileNavDirective = /** @class */ (function () {
    function AutoCloseMobileNavDirective(el, router) {
        this.el = el;
        this.router = router;
    }
    AutoCloseMobileNavDirective.prototype.ngOnInit = function () {
        var $body = $('#body');
        if (__WEBPACK_IMPORTED_MODULE_2__config__["a" /* APPCONFIG */].AutoCloseMobileNav) {
            this.router.events.subscribe(function (event) {
                if (event instanceof __WEBPACK_IMPORTED_MODULE_1__angular_router__["c" /* NavigationEnd */]) {
                    setTimeout(function () {
                        $body.removeClass('sidebar-mobile-open');
                    }, 0);
                }
            });
        }
    };
    AutoCloseMobileNavDirective = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({ selector: '[myAutoCloseMobileNav]' }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* Router */]])
    ], AutoCloseMobileNavDirective);
    return AutoCloseMobileNavDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(100)))

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppSidenavMenuComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Rx__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ProductService__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__ = __webpack_require__(6);






var AppSidenavMenuComponent = /** @class */ (function () {
    function AppSidenavMenuComponent(route, router, productService, userservice, adalService) {
        this.route = route;
        this.router = router;
        this.productService = productService;
        this.userservice = userservice;
        this.adalService = adalService;
        this.ProductFilter = { ProductName: '' };
        // Check Authentication
        if (!this.adalService.getCachedToken()) {
            this.router.navigate(['login']);
        }
    }
    AppSidenavMenuComponent.prototype.ngOnInit = function () {
        this.getUserRights(Number(localStorage.getItem('userid')));
        this.getProductReleaseList();
    };
    AppSidenavMenuComponent.prototype.getProductReleaseList = function () {
        var _this = this;
        this.productService.getReleaseProductsList().subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.productList = data.DataObject;
            }
        }, function (error) {
            _this.errorMessage = error;
        });
    };
    AppSidenavMenuComponent.prototype.getStyle = function (selected) {
        this.selectedTitle = selected;
    };
    AppSidenavMenuComponent.prototype.removeStyle = function () {
        this.selectedTitle = '';
    };
    AppSidenavMenuComponent.prototype.getUserRights = function (UserId) {
        var _this = this;
        this.userservice.getUserById(UserId).subscribe(function (Data) {
            _this.IsAdmin = Data.IsAdmin;
        }, function (error) {
            _this.errorMessage = error;
        });
    };
    AppSidenavMenuComponent.prototype.checkSelected = function (product) {
        var _this = this;
        if (this.route.firstChild != null) {
            if (this.route.firstChild.firstChild != null) {
                this.route.firstChild.firstChild.paramMap.subscribe(function (params) {
                    _this.selectedProductId = params.get('id');
                });
                return product.ProductId == this.selectedProductId;
            }
        }
    };
    AppSidenavMenuComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-app-sidenav-menu',
            styles: [__webpack_require__(965)],
            template: __webpack_require__(1026)
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_router__["b" /* ActivatedRoute */],
            __WEBPACK_IMPORTED_MODULE_1__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_3__services_ProductService__["a" /* ProductService */],
            __WEBPACK_IMPORTED_MODULE_4__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_5__shared_adal_service__["a" /* AdalService */]])
    ], AppSidenavMenuComponent);
    return AppSidenavMenuComponent;
}());



/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppSidenavComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);





var AppSidenavComponent = /** @class */ (function () {
    function AppSidenavComponent(userservice, adalService, router) {
        this.userservice = userservice;
        this.adalService = adalService;
        this.router = router;
        if (!this.adalService.getCachedToken()) {
            this.router.navigate(['login']);
        }
    }
    AppSidenavComponent.prototype.ngOnInit = function () {
        this.getUserRights(Number(localStorage.getItem('userid')));
        this.AppConfig = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* APPCONFIG */];
    };
    AppSidenavComponent.prototype.toggleCollapsedNav = function () {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
    };
    AppSidenavComponent.prototype.getUserRights = function (UserId) {
        var _this = this;
        this.userservice.getUserById(UserId).subscribe(function (Data) {
            _this.IsAdmin = Data.IsAdmin;
        }, function (error) {
            _this.errorMessage = error;
        });
    };
    AppSidenavComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'my-app-sidenav',
            styles: [],
            template: __webpack_require__(1027)
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_2__services_UserService__["a" /* UserService */], __WEBPACK_IMPORTED_MODULE_3__shared_adal_service__["a" /* AdalService */], __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */]])
    ], AppSidenavComponent);
    return AppSidenavComponent;
}());



/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleOffcanvasNavDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

// off-canvas sidebar for mobile, and this is the trigger
var ToggleOffcanvasNavDirective = /** @class */ (function () {
    function ToggleOffcanvasNavDirective(el) {
        this.el = el;
    }
    ToggleOffcanvasNavDirective.prototype.ngAfterViewInit = function () {
        var $navToggler = $(this.el.nativeElement);
        var $body = $('#body');
        $navToggler.on('click', function (e) {
            // _sidebar.scss, _page-container.scss
            $body.toggleClass('sidebar-mobile-open');
            e.preventDefault();
        });
    };
    ToggleOffcanvasNavDirective = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({ selector: '[myToggleOffcanvasNav]' }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]])
    ], ToggleOffcanvasNavDirective);
    return ToggleOffcanvasNavDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(100)))

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlimScrollDirective; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

__webpack_require__(945);
var SlimScrollDirective = /** @class */ (function () {
    function SlimScrollDirective(el) {
        this.el = el;
    }
    SlimScrollDirective.prototype.ngAfterViewInit = function () {
        var $el = $(this.el.nativeElement);
        $el.slimScroll({
            height: this.scrollHeight || '100%'
        });
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", String)
    ], SlimScrollDirective.prototype, "scrollHeight", void 0);
    SlimScrollDirective = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({ selector: '[mySlimScroll]' }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"]])
    ], SlimScrollDirective);
    return SlimScrollDirective;
}());


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(100)))

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SortDropdownComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);

var SortDropdownComponent = /** @class */ (function () {
    function SortDropdownComponent() {
        this.columnName = '';
        this.sortChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.isOpen = false;
    }
    SortDropdownComponent.prototype.toggleDropdown = function () {
        this.isOpen = !this.isOpen;
    };
    SortDropdownComponent.prototype.selectOrder = function (order) {
        this.sortChange.emit({ column: this.columnName, order: order });
        this.isOpen = false; // close dropdown after selection
    };
    SortDropdownComponent.prototype.clickOutside = function (event) {
        var target = event.target;
        if (!target.closest('.sort-dropdown')) {
            this.isOpen = false;
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", String)
    ], SortDropdownComponent.prototype, "columnName", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
        __metadata("design:type", Object)
    ], SortDropdownComponent.prototype, "sortChange", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('document:click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], SortDropdownComponent.prototype, "clickOutside", null);
    SortDropdownComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'sort-dropdown',
            template: __webpack_require__(1028),
            styles: [__webpack_require__(966)]
        })
    ], SortDropdownComponent);
    return SortDropdownComponent;
}());



/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LicensePortalRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicensePortalRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service360_service360_component__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__license_portal_component__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__glt_glt_component__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scal360_scal360_component__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lz30_lz30_component__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__smartlink360_smartlink360_component__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__smartcal360_smartcal360_component__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__service360_generate_service360_license_generate_service360_license_component__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__glt_generate_glt_license_generate_glt_license_component__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__smartlink360_generate_smartlink360_license_generate_smartlink360_license_component__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__service360_service360_view_activation_details_service360_view_activation_details_component__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__smartlink360_smartlink360_view_activation_details_smartlink360_view_activation_details_component__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__faq_faq_component__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__faq_add_edit_faq_add_edit_faq_component__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lz30_add_lz30_device_add_lz30_device_component__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lz30_add_lz30_device_license_request_add_lz30_device_license_request_component__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lz30_view_lz30_purchase_history_view_lz30_purchase_history_component__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__scal360_generate_scal360_license_generate_scal360_license_component__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__scal360_activate_scal360_license_activate_scal360_license_component__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scal360_renew_scal360_license_renew_scal360_license_component__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__scal360_view_scal360_license_information_view_scal360_license_information_component__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__scal360_view_scal360_purchase_history_view_scal360_purchase_history_component__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__scal360_view_scal360_renewal_history_view_scal360_renewal_history_component__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__scal360_view_scal360_activation_history_view_scal360_activation_history_component__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scal360_view_scal360_download_release_history_view_scal360_download_release_history_component__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__smartcal360_assign_smartcal360n_customer_assign_smartcal360n_customer_component__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__smartlink360_smartlink360_renew_license_smartlink360_renew_license_component__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__faq_import_faq_import_faq_component__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__smartlink360_smartlink360_view_renewal_history_smartlink360_view_renewal_history_component__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__smartlink360_smartlink360_view_feedback_smartlink360_view_feedback_component__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lz30_extend_LZ30_trial_period_extend_LZ30_trial_period_component__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__lz30_view_lz30_device_history_view_lz30_device_history_component__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__shared_license_auth_guard__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__syncit_syncit_component__ = __webpack_require__(362);



































var LicensePortalRoutes = [
    {
        path: 'license-portal',
        children: [
            { path: 'GLT/:productId', component: __WEBPACK_IMPORTED_MODULE_3__glt_glt_component__["a" /* LicenseModuleGltComponent */] },
            { path: 'GLT/generate-key', component: __WEBPACK_IMPORTED_MODULE_9__glt_generate_glt_license_generate_glt_license_component__["a" /* GenerateGltLicenseComponent */] },
            { path: 'LZ-30/:productId', component: __WEBPACK_IMPORTED_MODULE_5__lz30_lz30_component__["a" /* LicenseModuleLz30Component */] },
            { path: 'LZ-30/add-edit-device', component: __WEBPACK_IMPORTED_MODULE_15__lz30_add_lz30_device_add_lz30_device_component__["a" /* AddEditLZ30DeviceComponent */] },
            { path: 'LZ-30/add-device-license-resquest', component: __WEBPACK_IMPORTED_MODULE_16__lz30_add_lz30_device_license_request_add_lz30_device_license_request_component__["a" /* AddLz30DeviceLicenseRequest */] },
            { path: 'LZ-30/extend-trial-period', component: __WEBPACK_IMPORTED_MODULE_31__lz30_extend_LZ30_trial_period_extend_LZ30_trial_period_component__["a" /* ExtendLZ30TrialPeriod */] },
            { path: 'LZ-30/view-device-history', component: __WEBPACK_IMPORTED_MODULE_32__lz30_view_lz30_device_history_view_lz30_device_history_component__["a" /* ViewLZ30DeviceHistory */] },
            { path: 'LZ-30/view-purchase-license-history', component: __WEBPACK_IMPORTED_MODULE_17__lz30_view_lz30_purchase_history_view_lz30_purchase_history_component__["a" /* ViewLZ30PurchaseLicenseHistory */] },
            { path: 'LZ-30/FAQ/import-faq', component: __WEBPACK_IMPORTED_MODULE_28__faq_import_faq_import_faq_component__["a" /* ImportFaqComponent */] },
            { path: 'LZ-30/FAQ', component: __WEBPACK_IMPORTED_MODULE_13__faq_faq_component__["a" /* FaqComponent */] },
            { path: 'LZ-30/FAQ/add-edit-faq', component: __WEBPACK_IMPORTED_MODULE_14__faq_add_edit_faq_add_edit_faq_component__["a" /* AddEditFaqComponent */] },
            { path: 'Service 360/:productId', component: __WEBPACK_IMPORTED_MODULE_1__service360_service360_component__["a" /* LicenseModuleService360Component */] },
            { path: 'Service 360/generate-new-license-request', component: __WEBPACK_IMPORTED_MODULE_8__service360_generate_service360_license_generate_service360_license_component__["a" /* GenerateService360LicenseComponent */] },
            { path: 'Service 360/view-activation-detail', component: __WEBPACK_IMPORTED_MODULE_11__service360_service360_view_activation_details_service360_view_activation_details_component__["a" /* Service360ViewActivationDetailComponent */] },
            { path: 'Smart-Link 360/:productId', component: __WEBPACK_IMPORTED_MODULE_6__smartlink360_smartlink360_component__["a" /* LicenseModuleSmartlink360Component */] },
            { path: 'Smart-Link 360/generate-new-license-request', component: __WEBPACK_IMPORTED_MODULE_10__smartlink360_generate_smartlink360_license_generate_smartlink360_license_component__["a" /* GenerateSmartLink360LicenseComponent */] },
            { path: 'Smart-Link 360/view-activation-detail', component: __WEBPACK_IMPORTED_MODULE_12__smartlink360_smartlink360_view_activation_details_smartlink360_view_activation_details_component__["a" /* SmartLink360ViewActivationDetailComponent */] },
            { path: 'Smart-Link 360/renew-license', component: __WEBPACK_IMPORTED_MODULE_27__smartlink360_smartlink360_renew_license_smartlink360_renew_license_component__["a" /* Smartlink360RenewLicenseComponent */] },
            { path: 'Smart-Link 360/view-renewal-history', component: __WEBPACK_IMPORTED_MODULE_29__smartlink360_smartlink360_view_renewal_history_smartlink360_view_renewal_history_component__["a" /* SmartLink360ViewRenewalHistoryComponent */] },
            { path: 'Smart-Link 360/view-feedback', component: __WEBPACK_IMPORTED_MODULE_30__smartlink360_smartlink360_view_feedback_smartlink360_view_feedback_component__["a" /* SmartLink360ViewFeedbackComponent */] },
            { path: 'SCAL 360/:productId', component: __WEBPACK_IMPORTED_MODULE_4__scal360_scal360_component__["a" /* LicenseModuleScal360Component */] },
            { path: 'SCAL 360/generate-scal360-license', component: __WEBPACK_IMPORTED_MODULE_18__scal360_generate_scal360_license_generate_scal360_license_component__["a" /* GenerateSCAL30LicenseComponent */] },
            { path: 'SCAL 360/activate-scal360-license', component: __WEBPACK_IMPORTED_MODULE_19__scal360_activate_scal360_license_activate_scal360_license_component__["a" /* ActivateScal360LicenseComponent */] },
            { path: 'SCAL 360/renew-scal360-license', component: __WEBPACK_IMPORTED_MODULE_20__scal360_renew_scal360_license_renew_scal360_license_component__["a" /* RenewScal360LicenseComponent */] },
            { path: 'SCAL 360/view-scal360-license-information', component: __WEBPACK_IMPORTED_MODULE_21__scal360_view_scal360_license_information_view_scal360_license_information_component__["a" /* ViewScal360LicenseInformationComponent */] },
            { path: 'SCAL 360/view-scal360-purchase-history', component: __WEBPACK_IMPORTED_MODULE_22__scal360_view_scal360_purchase_history_view_scal360_purchase_history_component__["a" /* ViewScal360PurchaseHistoryComponent */] },
            { path: 'SCAL 360/view-scal360-activation-history', component: __WEBPACK_IMPORTED_MODULE_23__scal360_view_scal360_renewal_history_view_scal360_renewal_history_component__["a" /* ViewScal360RenewalHistoryComponent */] },
            { path: 'SCAL 360/view-scal360-cctivation-history', component: __WEBPACK_IMPORTED_MODULE_24__scal360_view_scal360_activation_history_view_scal360_activation_history_component__["a" /* ViewScal360ActivationHistoryComponent */] },
            { path: 'SCAL 360/view-scal360-download-release-history', component: __WEBPACK_IMPORTED_MODULE_25__scal360_view_scal360_download_release_history_view_scal360_download_release_history_component__["a" /* ViewScal360DownloadReleaseHistoryComponent */] },
            { path: 'Smart-Cal 360 N/:productId', component: __WEBPACK_IMPORTED_MODULE_7__smartcal360_smartcal360_component__["a" /* LicenseModuleSmartcal360Component */] },
            { path: 'Smart-Cal 360 N/assign-smartcal360n-customer', component: __WEBPACK_IMPORTED_MODULE_26__smartcal360_assign_smartcal360n_customer_assign_smartcal360n_customer_component__["a" /* AssignSmartCal360NCustomerComponent */] },
            { path: 'Sync IT/:productId', component: __WEBPACK_IMPORTED_MODULE_34__syncit_syncit_component__["a" /* LicenseModuleSyncITComponent */] }
        ],
        canActivate: [__WEBPACK_IMPORTED_MODULE_33__shared_license_auth_guard__["a" /* LicenseAuthGuard */]],
        canActivateChild: [__WEBPACK_IMPORTED_MODULE_33__shared_license_auth_guard__["a" /* LicenseAuthGuard */]],
        component: __WEBPACK_IMPORTED_MODULE_2__license_portal_component__["a" /* LicensePortalComponent */]
    }
];
var LicensePortalRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(LicensePortalRoutes);


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LicensePortalModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__service360_service360_component__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__license_portal_routing_module__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__glt_glt_component__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lz30_lz30_component__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scal360_scal360_component__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__smartcal360_smartcal360_component__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__smartlink360_smartlink360_component__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_common__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__service360_generate_service360_license_generate_service360_license_component__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__glt_generate_glt_license_generate_glt_license_component__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__filter_pipe__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__smartlink360_generate_smartlink360_license_generate_smartlink360_license_component__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__service360_pipes_service360FilterPipe__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__service360_service360_view_activation_details_service360_view_activation_details_component__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__smartlink360_smartlink360_view_activation_details_smartlink360_view_activation_details_component__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__faq_faq_component__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__faq_add_edit_faq_add_edit_faq_component__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lz30_pipes_lz30DeviceInfoFilterPipe__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lz30_add_lz30_device_add_lz30_device_component__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lz30_add_lz30_device_license_request_add_lz30_device_license_request_component__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lz30_pipes_lz30PurchaseLicenseFilterPipe__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lz30_view_lz30_purchase_history_view_lz30_purchase_history_component__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__scal360_generate_scal360_license_generate_scal360_license_component__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__scal360_activate_scal360_license_activate_scal360_license_component__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__scal360_renew_scal360_license_renew_scal360_license_component__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__scal360_view_scal360_license_information_view_scal360_license_information_component__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__scal360_pipes_scal360FilterPipe__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__scal360_view_scal360_purchase_history_view_scal360_purchase_history_component__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__scal360_view_scal360_renewal_history_view_scal360_renewal_history_component__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__scal360_view_scal360_activation_history_view_scal360_activation_history_component__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__scal360_view_scal360_download_release_history_view_scal360_download_release_history_component__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__smartcal360_assign_smartcal360n_customer_assign_smartcal360n_customer_component__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__smartlink360_smartlink360_renew_license_smartlink360_renew_license_component__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__faq_import_faq_import_faq_component__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__smartlink360_smartlink360_view_renewal_history_smartlink360_view_renewal_history_component__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__smartlink360_smartlink360_view_feedback_smartlink360_view_feedback_component__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__services_LicenseService__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__lz30_extend_LZ30_trial_period_extend_LZ30_trial_period_component__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__lz30_view_lz30_device_history_view_lz30_device_history_component__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__layout_searchable_dropdown_searchable_dropdown_component__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__layout_sort_dropdown_sort_dropdown_component__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__smartcal360_pipes_smartcal360FilterPipe__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__smartcal360_pipes_smartcal360AssignCustomerPipe__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__syncit_syncit_component__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__syncit_pipes_SyncITFilterPipe__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__syncit_popup_generate_syncit_license_generate_syncit_license_component__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__syncit_popup_extend_trial_period_extend_trial_period_component__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__syncit_popup_addmore_syncit_license_addmore_syncit_license_component__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__syncit_popup_renew_syncit_license_renew_syncit_license_component__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__syncit_popup_view_history_popup_view_history_popup_component__ = __webpack_require__(361);





















































var LicensePortalModule = /** @class */ (function () {
    function LicensePortalModule() {
    }
    LicensePortalModule = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_2__license_portal_routing_module__["a" /* LicensePortalRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_8__angular_common__["a" /* CommonModule */],
                __WEBPACK_IMPORTED_MODULE_9__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_10__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_10__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_9__angular_material__["f" /* MdSidenavModule */],
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_13__filter_pipe__["a" /* LicenseFilterPipe */],
                __WEBPACK_IMPORTED_MODULE_15__service360_pipes_service360FilterPipe__["a" /* Service360FilterPipe */],
                __WEBPACK_IMPORTED_MODULE_20__lz30_pipes_lz30DeviceInfoFilterPipe__["a" /* Lz30DeviceInfoFilterPipe */],
                __WEBPACK_IMPORTED_MODULE_23__lz30_pipes_lz30PurchaseLicenseFilterPipe__["a" /* LZ30PurchaseLicenseFilterPipe */],
                __WEBPACK_IMPORTED_MODULE_29__scal360_pipes_scal360FilterPipe__["a" /* Scal360FilterPipe */],
                __WEBPACK_IMPORTED_MODULE_1__service360_service360_component__["a" /* LicenseModuleService360Component */],
                __WEBPACK_IMPORTED_MODULE_3__glt_glt_component__["a" /* LicenseModuleGltComponent */],
                __WEBPACK_IMPORTED_MODULE_4__lz30_lz30_component__["a" /* LicenseModuleLz30Component */],
                __WEBPACK_IMPORTED_MODULE_5__scal360_scal360_component__["a" /* LicenseModuleScal360Component */],
                __WEBPACK_IMPORTED_MODULE_6__smartcal360_smartcal360_component__["a" /* LicenseModuleSmartcal360Component */],
                __WEBPACK_IMPORTED_MODULE_7__smartlink360_smartlink360_component__["a" /* LicenseModuleSmartlink360Component */],
                __WEBPACK_IMPORTED_MODULE_11__service360_generate_service360_license_generate_service360_license_component__["a" /* GenerateService360LicenseComponent */],
                __WEBPACK_IMPORTED_MODULE_12__glt_generate_glt_license_generate_glt_license_component__["a" /* GenerateGltLicenseComponent */],
                __WEBPACK_IMPORTED_MODULE_14__smartlink360_generate_smartlink360_license_generate_smartlink360_license_component__["a" /* GenerateSmartLink360LicenseComponent */],
                __WEBPACK_IMPORTED_MODULE_16__service360_service360_view_activation_details_service360_view_activation_details_component__["a" /* Service360ViewActivationDetailComponent */],
                __WEBPACK_IMPORTED_MODULE_17__smartlink360_smartlink360_view_activation_details_smartlink360_view_activation_details_component__["a" /* SmartLink360ViewActivationDetailComponent */],
                __WEBPACK_IMPORTED_MODULE_18__faq_faq_component__["a" /* FaqComponent */],
                __WEBPACK_IMPORTED_MODULE_19__faq_add_edit_faq_add_edit_faq_component__["a" /* AddEditFaqComponent */],
                __WEBPACK_IMPORTED_MODULE_21__lz30_add_lz30_device_add_lz30_device_component__["a" /* AddEditLZ30DeviceComponent */],
                __WEBPACK_IMPORTED_MODULE_41__lz30_view_lz30_device_history_view_lz30_device_history_component__["a" /* ViewLZ30DeviceHistory */],
                __WEBPACK_IMPORTED_MODULE_40__lz30_extend_LZ30_trial_period_extend_LZ30_trial_period_component__["a" /* ExtendLZ30TrialPeriod */],
                __WEBPACK_IMPORTED_MODULE_22__lz30_add_lz30_device_license_request_add_lz30_device_license_request_component__["a" /* AddLz30DeviceLicenseRequest */],
                __WEBPACK_IMPORTED_MODULE_24__lz30_view_lz30_purchase_history_view_lz30_purchase_history_component__["a" /* ViewLZ30PurchaseLicenseHistory */],
                __WEBPACK_IMPORTED_MODULE_25__scal360_generate_scal360_license_generate_scal360_license_component__["a" /* GenerateSCAL30LicenseComponent */],
                __WEBPACK_IMPORTED_MODULE_26__scal360_activate_scal360_license_activate_scal360_license_component__["a" /* ActivateScal360LicenseComponent */],
                __WEBPACK_IMPORTED_MODULE_27__scal360_renew_scal360_license_renew_scal360_license_component__["a" /* RenewScal360LicenseComponent */],
                __WEBPACK_IMPORTED_MODULE_28__scal360_view_scal360_license_information_view_scal360_license_information_component__["a" /* ViewScal360LicenseInformationComponent */],
                __WEBPACK_IMPORTED_MODULE_30__scal360_view_scal360_purchase_history_view_scal360_purchase_history_component__["a" /* ViewScal360PurchaseHistoryComponent */],
                __WEBPACK_IMPORTED_MODULE_31__scal360_view_scal360_renewal_history_view_scal360_renewal_history_component__["a" /* ViewScal360RenewalHistoryComponent */],
                __WEBPACK_IMPORTED_MODULE_32__scal360_view_scal360_activation_history_view_scal360_activation_history_component__["a" /* ViewScal360ActivationHistoryComponent */],
                __WEBPACK_IMPORTED_MODULE_33__scal360_view_scal360_download_release_history_view_scal360_download_release_history_component__["a" /* ViewScal360DownloadReleaseHistoryComponent */],
                __WEBPACK_IMPORTED_MODULE_34__smartcal360_assign_smartcal360n_customer_assign_smartcal360n_customer_component__["a" /* AssignSmartCal360NCustomerComponent */],
                __WEBPACK_IMPORTED_MODULE_35__smartlink360_smartlink360_renew_license_smartlink360_renew_license_component__["a" /* Smartlink360RenewLicenseComponent */],
                __WEBPACK_IMPORTED_MODULE_36__faq_import_faq_import_faq_component__["a" /* ImportFaqComponent */],
                __WEBPACK_IMPORTED_MODULE_37__smartlink360_smartlink360_view_renewal_history_smartlink360_view_renewal_history_component__["a" /* SmartLink360ViewRenewalHistoryComponent */],
                __WEBPACK_IMPORTED_MODULE_38__smartlink360_smartlink360_view_feedback_smartlink360_view_feedback_component__["a" /* SmartLink360ViewFeedbackComponent */],
                __WEBPACK_IMPORTED_MODULE_42__layout_searchable_dropdown_searchable_dropdown_component__["a" /* SearchableDropdownComponent */],
                __WEBPACK_IMPORTED_MODULE_43__layout_sort_dropdown_sort_dropdown_component__["a" /* SortDropdownComponent */],
                __WEBPACK_IMPORTED_MODULE_46__syncit_syncit_component__["a" /* LicenseModuleSyncITComponent */],
                __WEBPACK_IMPORTED_MODULE_48__syncit_popup_generate_syncit_license_generate_syncit_license_component__["a" /* GenerateSyncITLicenseComponent */],
                __WEBPACK_IMPORTED_MODULE_49__syncit_popup_extend_trial_period_extend_trial_period_component__["a" /* ExtendSyncItTrialPeriodComponent */],
                __WEBPACK_IMPORTED_MODULE_50__syncit_popup_addmore_syncit_license_addmore_syncit_license_component__["a" /* AddMoreSyncItLicenseComponent */],
                __WEBPACK_IMPORTED_MODULE_51__syncit_popup_renew_syncit_license_renew_syncit_license_component__["a" /* RenewSyncItComponent */],
                __WEBPACK_IMPORTED_MODULE_52__syncit_popup_view_history_popup_view_history_popup_component__["a" /* ViewSyncItHistoryComponent */],
                __WEBPACK_IMPORTED_MODULE_47__syncit_pipes_SyncITFilterPipe__["a" /* SyncITFilterPipe */],
            ],
            providers: [
                __WEBPACK_IMPORTED_MODULE_39__services_LicenseService__["a" /* LicenseService */],
                __WEBPACK_IMPORTED_MODULE_29__scal360_pipes_scal360FilterPipe__["a" /* Scal360FilterPipe */],
                __WEBPACK_IMPORTED_MODULE_15__service360_pipes_service360FilterPipe__["a" /* Service360FilterPipe */],
                __WEBPACK_IMPORTED_MODULE_20__lz30_pipes_lz30DeviceInfoFilterPipe__["a" /* Lz30DeviceInfoFilterPipe */],
                __WEBPACK_IMPORTED_MODULE_23__lz30_pipes_lz30PurchaseLicenseFilterPipe__["a" /* LZ30PurchaseLicenseFilterPipe */],
                __WEBPACK_IMPORTED_MODULE_13__filter_pipe__["a" /* LicenseFilterPipe */],
                __WEBPACK_IMPORTED_MODULE_44__smartcal360_pipes_smartcal360FilterPipe__["a" /* SmartCal360FilterPipe */],
                __WEBPACK_IMPORTED_MODULE_45__smartcal360_pipes_smartcal360AssignCustomerPipe__["a" /* SmartCal360AssignCustomerFilterPipe */],
                __WEBPACK_IMPORTED_MODULE_47__syncit_pipes_SyncITFilterPipe__["a" /* SyncITFilterPipe */],
            ],
            entryComponents: [
                __WEBPACK_IMPORTED_MODULE_48__syncit_popup_generate_syncit_license_generate_syncit_license_component__["a" /* GenerateSyncITLicenseComponent */],
                __WEBPACK_IMPORTED_MODULE_49__syncit_popup_extend_trial_period_extend_trial_period_component__["a" /* ExtendSyncItTrialPeriodComponent */],
                __WEBPACK_IMPORTED_MODULE_50__syncit_popup_addmore_syncit_license_addmore_syncit_license_component__["a" /* AddMoreSyncItLicenseComponent */],
                __WEBPACK_IMPORTED_MODULE_51__syncit_popup_renew_syncit_license_renew_syncit_license_component__["a" /* RenewSyncItComponent */],
                __WEBPACK_IMPORTED_MODULE_52__syncit_popup_view_history_popup_view_history_popup_component__["a" /* ViewSyncItHistoryComponent */],
            ],
        })
    ], LicensePortalModule);
    return LicensePortalModule;
}());



/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutsModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_layouts_routing_module__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page_layouts_component__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ngx_bootstrap_accordion__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__product_release_list_product_release_component__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__revision_changelog_revision_component__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_product_changelog_viewallchangelog_component__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__revision_history_revisionhistory_component__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__add_edit_productrelease_addproductrelease_component__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Revert_Release_revertrelease_component__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__add_product_addproduct_component__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__confirm_dialog_confirmdialog_component__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_app_loader_app_loader_component__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__product_release_tab_list_product_release_tab_component__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__product_list_tab_child_list_product_release_tab_list_component__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__push_notification_push_notification_history_component__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__activate_release_activateRelease_component__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__change_release_type_change_release_type_component__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shared_shared_module__ = __webpack_require__(373);






















var PageLayoutsModule = /** @class */ (function () {
    function PageLayoutsModule() {
    }
    PageLayoutsModule = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_1__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_4__page_layouts_routing_module__["a" /* PageLayoutsRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_2__angular_common__["a" /* CommonModule */],
                __WEBPACK_IMPORTED_MODULE_3__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_3__angular_forms__["b" /* ReactiveFormsModule */],
                __WEBPACK_IMPORTED_MODULE_21__shared_shared_module__["a" /* SharedModule */],
                //      Ng2FilterPipeModule,    
                [__WEBPACK_IMPORTED_MODULE_6_ngx_bootstrap_accordion__["a" /* AccordionModule */].forRoot()],
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_5__page_layouts_component__["a" /* PageLayoutsComponent */],
                __WEBPACK_IMPORTED_MODULE_7__product_release_list_product_release_component__["a" /* PageLayoutProductReleaseListComponent */],
                __WEBPACK_IMPORTED_MODULE_8__revision_changelog_revision_component__["a" /* PageLayoutRevisionComponent */],
                __WEBPACK_IMPORTED_MODULE_11__add_edit_productrelease_addproductrelease_component__["a" /* PageLayoutProductReleaseComponent */],
                __WEBPACK_IMPORTED_MODULE_17__product_list_tab_child_list_product_release_tab_list_component__["a" /* PageLayoutProductReleaseTabListComponent */],
                __WEBPACK_IMPORTED_MODULE_16__product_release_tab_list_product_release_tab_component__["a" /* PageLayoutProductReleaseTabComponent */],
                __WEBPACK_IMPORTED_MODULE_13__add_product_addproduct_component__["a" /* PageLayoutProductaddComponent */],
                __WEBPACK_IMPORTED_MODULE_18__push_notification_push_notification_history_component__["a" /* PageLayoutPushNotificationHistoryComponent */],
                __WEBPACK_IMPORTED_MODULE_12__Revert_Release_revertrelease_component__["a" /* PageLayoutRevertReleaseComponent */],
                __WEBPACK_IMPORTED_MODULE_19__activate_release_activateRelease_component__["a" /* ActivateReleaseComponent */],
                __WEBPACK_IMPORTED_MODULE_20__change_release_type_change_release_type_component__["a" /* ChangeReleaseTypeComponent */],
                __WEBPACK_IMPORTED_MODULE_10__revision_history_revisionhistory_component__["a" /* PageLayoutRevisionHistoryComponent */],
                __WEBPACK_IMPORTED_MODULE_14__confirm_dialog_confirmdialog_component__["a" /* PageLayoutConfirmDialogComponent */],
                __WEBPACK_IMPORTED_MODULE_15__services_app_loader_app_loader_component__["a" /* AppLoaderComponent */],
                __WEBPACK_IMPORTED_MODULE_9__view_product_changelog_viewallchangelog_component__["a" /* PageLayoutAllChangeLog */]
            ],
            entryComponents: [
                __WEBPACK_IMPORTED_MODULE_19__activate_release_activateRelease_component__["a" /* ActivateReleaseComponent */],
                __WEBPACK_IMPORTED_MODULE_20__change_release_type_change_release_type_component__["a" /* ChangeReleaseTypeComponent */]
            ]
        })
    ], PageLayoutsModule);
    return PageLayoutsModule;
}());



/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageLayoutProductReleaseTabListComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__revision_changelog_revision_component__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__add_edit_productrelease_addproductrelease_component__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operators__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ProductReleaseService__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_UserService__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_PagerService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Revert_Release_revertrelease_component__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__revision_history_revisionhistory_component__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__confirm_dialog_confirmdialog_component__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__view_product_changelog_viewallchangelog_component__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_app_loader_app_loader_service__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__interfaces_ProductReleaseStatusEnum_model__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__angular_common_http__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__activate_release_activateRelease_component__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__change_release_type_change_release_type_component__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__interfaces_PilotCustomReleaseProducts__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_observable_of__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_observable_forkJoin__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_rxjs_observable_forkJoin__);























var PageLayoutProductReleaseTabListComponent = /** @class */ (function () {
    function PageLayoutProductReleaseTabListComponent(dialog, router, productReleaseService, userservice, pagerService, appLoaderService, adalService) {
        this.dialog = dialog;
        this.router = router;
        this.productReleaseService = productReleaseService;
        this.userservice = userservice;
        this.pagerService = pagerService;
        this.appLoaderService = appLoaderService;
        this.adalService = adalService;
        this.IsAdd = false;
        this.IsEdit = false;
        this.IsProductionRights = false;
        this.Title = "";
        this.IsApprove = false;
        this.IsReject = false;
        this.IsAllowedToAdd = false;
        this.pager = {};
        this.IsShowDeleted = false;
        this.ProductCodePanelVisble = [14, 89];
        this.IsValid = false;
        this.ProductReleaseStatus = __WEBPACK_IMPORTED_MODULE_15__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */];
        if (!this.adalService.getCachedToken()) {
            this.router.navigate(["login"]);
        }
    }
    PageLayoutProductReleaseTabListComponent.prototype.ngOnInit = function () {
        this.Title = this.SubProductName;
        this.ProductId = this.Id;
        this.ProductCode = this.Code;
        if (this.ProductCode == 13 && this.SubType == 2) {
            this.IsValid = true;
        }
        this.IsShowDeleted = false;
        this.getProductReleaseList(this.ProductId);
        this.getUserRights(Number(localStorage.getItem("userid")), this.ParentProductId);
    };
    PageLayoutProductReleaseTabListComponent.prototype.showRejected = function (value) {
        var _this_1 = this;
        if (value == true) {
            this.pagedItems = [];
            this.releaseData.forEach(function (element) {
                _this_1.pagedItems.push(element);
            });
        }
        else {
            this.pagedItems = [];
            this.releaseData.forEach(function (element) {
                if (element.IsDeleted == false) {
                    _this_1.pagedItems.push(element);
                }
            });
        }
    };
    PageLayoutProductReleaseTabListComponent.prototype.setPage = function (page) {
        this.pager = this.pagerService.getPager(this.releaseData.length, page);
        this.pagedItems = this.releaseData.slice(this.pager.startIndex, this.pager.endIndex + 1);
    };
    //#region ViewChangeLog
    PageLayoutProductReleaseTabListComponent.prototype.openDialogWithAResult = function (row) {
        this.ProductReleaseId = row.ProductReleaseId;
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_2__revision_changelog_revision_component__["a" /* PageLayoutRevisionComponent */], {
            height: "50%",
            width: "60%",
            data: {
                productReleaseId: this.ProductReleaseId,
                ProductName: this.ProductName,
                ProductReleaseNo: row.ProductReleaseNo,
                SubProductName: this.SubProductName,
            },
        });
        dialogRef.afterClosed().subscribe(function (_result) {
            //this.getProductReleaseList(this.ProductId);
        });
    };
    //#endregion
    //#region viewAllChangeLog
    PageLayoutProductReleaseTabListComponent.prototype.OpenViewAllChangeLog = function () {
        var dialogRef = this.dialog.open(__WEBPACK_IMPORTED_MODULE_13__view_product_changelog_viewallchangelog_component__["a" /* PageLayoutAllChangeLog */], {
            height: "50%",
            width: "60%",
            data: {
                ProductId: this.ProductId,
                ProductName: this.ProductName,
                SubProductName: this.SubProductName,
            },
        });
        dialogRef.afterClosed().subscribe(function (_result) {
            //this.getProductReleaseList(this.ProductId);
        });
    };
    //#endregion
    //#region Add Release
    PageLayoutProductReleaseTabListComponent.prototype.openProductReleaseAddDialog = function (row) {
        var _this_1 = this;
        if (this.IsAllowedToAdd) {
            var confirmdialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_12__confirm_dialog_confirmdialog_component__["a" /* PageLayoutConfirmDialogComponent */], {
                data: { Status: "Add" },
                disableClose: true,
            });
            confirmdialog.afterClosed().subscribe(function (_result) {
                _this_1.getProductReleaseList(_this_1.ProductId);
            });
        }
        else {
            var releaseDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_3__add_edit_productrelease_addproductrelease_component__["a" /* PageLayoutProductReleaseComponent */], {
                height: "90%",
                width: "60%",
                data: {
                    ProductId: this.ProductId,
                    ParentProductId: this.ParentProductId,
                    SubProductName: this.SubProductName,
                    SubType: this.SubType,
                    ProductName: this.ProductName,
                    ProductCode: this.ProductCode,
                    ProductReleaseId: 0,
                    payload: row,
                },
                disableClose: true,
            });
            releaseDialog.afterClosed().subscribe(function (result) {
                _this_1.getProductReleaseList(_this_1.ProductId);
                if (result != null) {
                    _this_1.SendEmail(result, __WEBPACK_IMPORTED_MODULE_15__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].DevRelease);
                }
            });
        }
    };
    //#endregion
    //#region EditDialog
    PageLayoutProductReleaseTabListComponent.prototype.openProductReleaseEditDialog = function (row) {
        var _this_1 = this;
        var releaseDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_3__add_edit_productrelease_addproductrelease_component__["a" /* PageLayoutProductReleaseComponent */], {
            height: "90%",
            width: "60%",
            data: {
                ProductId: this.ProductId,
                ParentProductId: this.ParentProductId,
                SubProductName: this.SubProductName,
                SubType: this.SubType,
                ProductName: this.ProductName,
                ProductCode: this.ProductCode,
                ProductReleaseId: row.ProductReleaseId,
                Status: row.Status,
                payload: row,
            },
            disableClose: true,
        });
        releaseDialog.afterClosed().subscribe(function (_result) {
            _this_1.getProductReleaseList(_this_1.ProductId);
        });
    };
    //#endregion
    //#region GridData and IsAllowedtoDataAdd if any release in pending queue [ViewRelease]
    PageLayoutProductReleaseTabListComponent.prototype.getProductReleaseList = function (ProductId) {
        var _this_1 = this;
        // For Specific Product Visible DBVersion and Package File Upload
        this.IsProductCodeVisble = false;
        this.ProductCodePanelVisble.forEach(function (element) {
            if (element == _this_1.ProductCode) {
                _this_1.IsProductCodeVisble = true;
            }
        });
        this.productReleaseService.getReleaseByProductId(ProductId).subscribe(function (data) {
            _this_1.pagedItems = [];
            if (!data.IsError && data.DataObject != null) {
                _this_1.releaseData = data.DataObject;
                _this_1.releaseData.forEach(function (element) {
                    var customers = element.Customers ? element.Customers.map(function (c, index) { return index + 1 + ". " + c.Name; }) : [];
                    var toolip = customers && customers.length > 0 ? customers.join('\n') : 'No customers';
                    element.CustomerTooltip = toolip;
                    if (_this_1.IsShowDeleted) {
                        _this_1.pagedItems.push(element);
                    }
                    else {
                        if (element.IsDeleted == false) {
                            _this_1.pagedItems.push(element);
                        }
                    }
                });
                //this.setPage(this.pager.currentPage);
            }
            else {
                _this_1.releaseData = null;
            }
        }, function (error) {
            _this_1.errorMessage = error;
        });
        this.productReleaseService
            .getIsAllowedToAddReleaseByProductId(ProductId)
            .subscribe(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this_1.IsAllowedToAdd = false;
            }
            else {
                _this_1.IsAllowedToAdd = true;
            }
        }, function (error) {
            _this_1.errorMessage = error;
        });
    };
    PageLayoutProductReleaseTabListComponent.prototype.getProductReleaseList_Observable = function (ProductId) {
        var _this_1 = this;
        // 1. Run the synchronous UI checks first
        this.IsProductCodeVisble = false;
        this.ProductCodePanelVisble.forEach(function (element) {
            if (element == _this_1.ProductCode) {
                _this_1.IsProductCodeVisble = true;
            }
        });
        var _this = this;
        // 2. Define the first API call stream with its side-effects
        var getRelease$ = this.productReleaseService.getReleaseByProductId(ProductId).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["take"])(1), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["tap"])(function (data) {
            _this.pagedItems = [];
            if (!data.IsError && data.DataObject != null) {
                _this.releaseData = data.DataObject;
                _this.releaseData.forEach(function (element) {
                    var customers = element.Customers ? element.Customers.map(function (c, index) { return index + 1 + ". " + c.Name; }) : [];
                    var toolip = customers && customers.length > 0 ? customers.join('\n') : 'No customers';
                    element.CustomerTooltip = toolip;
                    if (_this.IsShowDeleted) {
                        _this.pagedItems.push(element);
                    }
                    else {
                        if (element.IsDeleted == false) {
                            _this.pagedItems.push(element);
                        }
                    }
                });
            }
            else {
                _this.releaseData = null;
            }
        }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["catchError"])(function (error) {
            _this.errorMessage = error;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_rxjs_observable_of__["of"])(null); // Keep forkJoin alive even if one fails
        }));
        // 3. Define the second API call stream with its side-effects
        var getIsAllowed$ = this.productReleaseService.getIsAllowedToAddReleaseByProductId(ProductId).pipe(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["take"])(1), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["tap"])(function (data) {
            if (!data.IsError && data.DataObject != null) {
                _this.IsAllowedToAdd = false;
            }
            else {
                _this.IsAllowedToAdd = true;
            }
        }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__["catchError"])(function (error) {
            _this.errorMessage = error;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_rxjs_observable_of__["of"])(null); // Keep forkJoin alive even if one fails
        }));
        // 4. Return combined observable that completes only when both requests finish
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_rxjs_observable_forkJoin__["forkJoin"])([getRelease$, getIsAllowed$]);
    };
    //#endregion
    //#region  getUserRights to visible button true false
    PageLayoutProductReleaseTabListComponent.prototype.getUserRights = function (UserId, ProductId) {
        var _this_1 = this;
        this.userservice.getUserRightsById(UserId, ProductId).subscribe(function (Data) {
            if (Data != "") {
                _this_1.IsAdd = Data[0].IsAdd;
                _this_1.IsEdit = Data[0].IsEdit;
                _this_1.IsProductionRights = Data[0].IsActiveInactive; // IsDelete means Active/Inactive Release
                _this_1.IsApprove = Data[0].IsApproveReject;
            }
        }, function (error) {
            _this_1.errorMessage = error;
        });
    };
    //#endregion
    //#region  Click: Active Release
    PageLayoutProductReleaseTabListComponent.prototype.ActiveRelease = function (row) {
        var _this_1 = this;
        // In SCAL360 Case DBVersion Based Active Release
        if (this.IsProductCodeVisble) {
            this.productReleaseService
                .getProductionRelease(this.ProductId)
                .subscribe(function (Data) {
                if (Data.DataObject != null &&
                    row.DBVersion != "" &&
                    Number(Data.DataObject.DBVersion) > Number(row.DBVersion)) {
                    var confirmdialog = _this_1.dialog.open(__WEBPACK_IMPORTED_MODULE_12__confirm_dialog_confirmdialog_component__["a" /* PageLayoutConfirmDialogComponent */], {
                        data: {
                            ProductReleaseNo: row.ProductReleaseNo,
                            Status: "DBVersionMSG",
                        },
                        disableClose: true,
                    });
                    confirmdialog.afterClosed().subscribe(function (_result) {
                        _this_1.getProductReleaseList(_this_1.ProductId);
                    });
                }
                else {
                    _this_1.OpenConfirmDialog(row);
                }
            });
        }
        else {
            // In Other Product No Condition Checked
            this.OpenConfirmDialog(row);
        }
    };
    // #region  Code Complexity Resolved [Create a Function OpenConfirmDialog]
    PageLayoutProductReleaseTabListComponent.prototype.OpenConfirmDialog = function (row) {
        var _this_1 = this;
        var isPilotCustomReleaseSupported = this.ProductCode in __WEBPACK_IMPORTED_MODULE_20__interfaces_PilotCustomReleaseProducts__["a" /* PilotCustomSupportedProductCodes */] &&
            this.SubType in __WEBPACK_IMPORTED_MODULE_20__interfaces_PilotCustomReleaseProducts__["b" /* PilotCustomSupportedSubTypes */] &&
            this.Variant in __WEBPACK_IMPORTED_MODULE_20__interfaces_PilotCustomReleaseProducts__["c" /* PilotCustomSupportedVariants */];
        var activateReleaseDialog;
        var data = {
            ProductReleaseId: row.ProductReleaseId,
            ProductId: this.ProductId,
            ParentProductId: this.ParentProductId,
            ProductReleaseNo: row.ProductReleaseNo,
            ProductName: this.ProductName,
            SubProductName: this.SubProductName,
            ProductCode: this.ProductCode,
            Status: 3,
            IsSTPPerformed: row.IsSTPPerformed,
            releaseList: this.pagedItems
        };
        if (isPilotCustomReleaseSupported) {
            activateReleaseDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_18__activate_release_activateRelease_component__["a" /* ActivateReleaseComponent */], {
                width: "35%",
                data: data,
                disableClose: true,
            });
        }
        else {
            activateReleaseDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_10__Revert_Release_revertrelease_component__["a" /* PageLayoutRevertReleaseComponent */], {
                data: data,
                disableClose: true,
            }); // Release Management Active Status : 3
        }
        activateReleaseDialog.afterClosed().subscribe(function (result) {
            _this_1.getProductReleaseList_Observable(_this_1.ProductId).subscribe(function () {
                _this_1.appLoaderService.close();
                if (isPilotCustomReleaseSupported) {
                    if (result) {
                        _this_1.SendEmail(row, result.SelectedReleaseType);
                        _this_1.SendEmailToSyncItClientAdmins(row, result);
                    }
                }
                else {
                    if (typeof result === "object") {
                        _this_1.SendEmail(row, __WEBPACK_IMPORTED_MODULE_15__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].STPStart);
                    }
                    else if (result == true) {
                        _this_1.SendEmail(row, __WEBPACK_IMPORTED_MODULE_15__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].ProductionRelease);
                    }
                }
            });
        });
    };
    //#endregion
    //#endregion
    //#region  Click: Approve Release
    PageLayoutProductReleaseTabListComponent.prototype.ApproveRelease = function (row) {
        var _this_1 = this;
        var approveDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_10__Revert_Release_revertrelease_component__["a" /* PageLayoutRevertReleaseComponent */], {
            data: {
                ProductReleaseId: row.ProductReleaseId,
                ProductId: this.ProductId,
                ProductReleaseNo: row.ProductReleaseNo,
                Status: 2,
                IsSTPPerformed: row.IsSTPPerformed,
            },
            disableClose: true,
        }); // Release Management Approve Status : 2
        approveDialog.afterClosed().subscribe(function (result) {
            _this_1.getProductReleaseList(_this_1.ProductId);
            if (result) {
                _this_1.SendEmail(row, __WEBPACK_IMPORTED_MODULE_15__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].QARelease);
            }
        });
    };
    //#endregion
    // #region  Click: Reject Release
    PageLayoutProductReleaseTabListComponent.prototype.RejectRelease = function (row) {
        var _this_1 = this;
        var rejestdialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_10__Revert_Release_revertrelease_component__["a" /* PageLayoutRevertReleaseComponent */], {
            data: {
                ProductReleaseId: row.ProductReleaseId,
                ProductId: this.ProductId,
                ProductReleaseNo: row.ProductReleaseNo,
                Status: -1,
                IsSTPPerformed: row.IsSTPPerformed,
            },
            disableClose: true,
        }); // Release Management Delete Status : 2
        rejestdialog.afterClosed().subscribe(function (result) {
            _this_1.getProductReleaseList(_this_1.ProductId);
            if (result) {
                _this_1.SendEmail(row, -1);
            }
        });
    };
    //#endregion
    //#region ViewReleaseHistory
    PageLayoutProductReleaseTabListComponent.prototype.ViewHistory = function (row) {
        var historyDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_11__revision_history_revisionhistory_component__["a" /* PageLayoutRevisionHistoryComponent */], {
            height: "50%",
            width: "60%",
            data: {
                ProductReleaseId: row.ProductReleaseId,
                ProductReleaseNo: row.ProductReleaseNo,
                ProductName: this.ProductName,
                SubProductName: this.SubProductName,
            },
        });
        historyDialog.afterClosed().subscribe(function (_result) {
            //this.getProductReleaseList(this.ProductId);
        });
    };
    //#endregion
    //Region Click: STPStart
    PageLayoutProductReleaseTabListComponent.prototype.STPStart = function (row) {
        var _this_1 = this;
        var STPStart = this.dialog.open(__WEBPACK_IMPORTED_MODULE_10__Revert_Release_revertrelease_component__["a" /* PageLayoutRevertReleaseComponent */], {
            data: {
                ProductReleaseId: row.ProductReleaseId,
                ProductId: this.ProductId,
                ProductReleaseNo: row.ProductReleaseNo,
                Status: 1,
                IsSTPPerformed: row.IsSTPPerformed,
            },
            disableClose: true,
        }); // Release Management STPStart Status : 1
        STPStart.afterClosed().subscribe(function (result) {
            _this_1.getProductReleaseList(_this_1.ProductId);
            if (result) {
                _this_1.SendEmail(row, __WEBPACK_IMPORTED_MODULE_15__interfaces_ProductReleaseStatusEnum_model__["a" /* ProductReleaseStatus */].STPStart);
            }
        });
    };
    //#endregion
    PageLayoutProductReleaseTabListComponent.prototype.ChangeReleaseType = function (row) {
        var _this_1 = this;
        var changeReleaseTypeDialog = this.dialog.open(__WEBPACK_IMPORTED_MODULE_19__change_release_type_change_release_type_component__["a" /* ChangeReleaseTypeComponent */], {
            width: "40%",
            data: {
                ProductReleaseId: row.ProductReleaseId,
                ProductId: this.ProductId,
                ProductReleaseNo: row.ProductReleaseNo,
                Status: row.Status,
                IsSTPPerformed: row.IsSTPPerformed,
                releaseList: this.pagedItems
            },
            disableClose: true,
        });
        changeReleaseTypeDialog.afterClosed().subscribe(function (result) {
            _this_1.getProductReleaseList_Observable(_this_1.ProductId).subscribe(function () {
                _this_1.appLoaderService.close();
                if (result) {
                    _this_1.SendEmail(row, result.SelectedReleaseType);
                    _this_1.SendEmailToSyncItClientAdmins(row, result);
                }
            });
        });
    };
    //#region DownloadFile
    PageLayoutProductReleaseTabListComponent.prototype.DownloadFile = function (row) {
        var _this_1 = this;
        this.appLoaderService.open();
        this.productReleaseService
            .DownloadReleaseFile(row.ProductReleaseId)
            .subscribe(function (result) {
            switch (result.type) {
                case __WEBPACK_IMPORTED_MODULE_16__angular_common_http__["e" /* HttpEventType */].DownloadProgress:
                    var percentage = Math.round((result.loaded / result.total) * 100);
                    _this_1.appLoaderService.ChangeLoaderTitle("Downloading File");
                    _this_1.appLoaderService.ChangePercentage(percentage + "%");
                    break;
                case __WEBPACK_IMPORTED_MODULE_16__angular_common_http__["e" /* HttpEventType */].Response:
                    var downloadedFile = new Blob([result.body], {
                        type: result.body.type,
                    });
                    var a = document.createElement("a");
                    a.setAttribute("style", "display:none;");
                    document.body.appendChild(a);
                    a.download = row.FileName;
                    a.href = URL.createObjectURL(downloadedFile);
                    a.target = "_blank";
                    a.click();
                    document.body.removeChild(a);
                    _this_1.appLoaderService.close();
                    break;
            }
        }, function (_error) {
            _this_1.appLoaderService.close();
        });
    };
    //#endregion
    //#region  SendEmail Function
    PageLayoutProductReleaseTabListComponent.prototype.SendEmail = function (ProductReleaseInfo, ReleaseStatus) {
        var _this_1 = this;
        var model = {
            ProductName: this.ProductName,
            SubProductName: this.SubProductName,
            ProductCode: this.ProductCode,
            Variant: this.Variant,
            SubType: this.SubType,
            TabOrder: this.TabOrder,
            ProductReleaseNo: ProductReleaseInfo.ProductReleaseNo,
            ReleaseDate: new Date(),
            UpdatedBy: localStorage.getItem("Name"),
            ProductId: this.ParentProductId,
            ReleaseStatus: ReleaseStatus,
        };
        this.productReleaseService.SendEmail(model).subscribe(function (Data) {
            if (Data.IsError) {
                __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.fire("Error", Data.Error, "error");
            }
        }, function (error) {
            _this_1.errorMessage = error;
        });
    };
    PageLayoutProductReleaseTabListComponent.prototype.SendEmailToSyncItClientAdmins = function (ProductReleaseInfo, statusChangeInfo) {
        var _this_1 = this;
        if (statusChangeInfo.isNotifySyncItClientAdmin) {
            var model = {
                ProductId: this.ProductId,
                ProductName: this.ProductName,
                SubProductName: this.SubProductName,
                ProductCode: this.ProductCode,
                SubType: this.SubType,
                Variant: this.Variant,
                ProductReleaseNo: ProductReleaseInfo.ProductReleaseNo,
                ReleaseDate: new Date(),
                ReleaseStatus: statusChangeInfo.SelectedReleaseType,
                CustomerIds: statusChangeInfo.customers
            };
            this.productReleaseService.SendEmailToSyncItClientAdmins(model).subscribe(function (Data) {
                if (Data.IsError) {
                    __WEBPACK_IMPORTED_MODULE_17_sweetalert2___default.a.fire("Error", Data.Error, "error");
                }
            }, function (error) {
                _this_1.errorMessage = error;
            });
        }
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], PageLayoutProductReleaseTabListComponent.prototype, "SubProductName", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], PageLayoutProductReleaseTabListComponent.prototype, "ProductName", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], PageLayoutProductReleaseTabListComponent.prototype, "Code", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], PageLayoutProductReleaseTabListComponent.prototype, "SubType", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], PageLayoutProductReleaseTabListComponent.prototype, "Id", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], PageLayoutProductReleaseTabListComponent.prototype, "ParentProductId", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], PageLayoutProductReleaseTabListComponent.prototype, "TabOrder", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], PageLayoutProductReleaseTabListComponent.prototype, "Variant", void 0);
    PageLayoutProductReleaseTabListComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: "my-page-layout-with-product-release-tab-list",
            styles: [__webpack_require__(1006)],
            template: __webpack_require__(1073),
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_1__angular_material__["b" /* MdDialog */],
            __WEBPACK_IMPORTED_MODULE_4__angular_router__["a" /* Router */],
            __WEBPACK_IMPORTED_MODULE_6__services_ProductReleaseService__["a" /* ProductReleaseService */],
            __WEBPACK_IMPORTED_MODULE_7__services_UserService__["a" /* UserService */],
            __WEBPACK_IMPORTED_MODULE_9__services_PagerService__["a" /* PagerService */],
            __WEBPACK_IMPORTED_MODULE_14__services_app_loader_app_loader_service__["a" /* AppLoaderService */],
            __WEBPACK_IMPORTED_MODULE_8__shared_adal_service__["a" /* AdalService */]])
    ], PageLayoutProductReleaseTabListComponent);
    return PageLayoutProductReleaseTabListComponent;
}());



/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SEARCHABLE_MULTI_SELECT_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchableMultiSelectComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_takeUntil__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_takeUntil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_takeUntil__);




var SEARCHABLE_MULTI_SELECT_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__angular_forms__["c" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SearchableMultiSelectComponent; }),
    multi: true,
};
var SearchableMultiSelectComponent = /** @class */ (function () {
    function SearchableMultiSelectComponent(elementRef, cdr) {
        this.elementRef = elementRef;
        this.cdr = cdr;
        // ─── Inputs ────────────────────────────────────────────────────────────────
        /** Full list of items to display. */
        this.items = [];
        /** Placeholder shown inside the trigger when no items are pending. */
        this.placeholder = 'Search and select…';
        /** Property name on each item used as the stored value (emitted to the form). */
        this.idField = 'id';
        /** Property name on each item used as the display label. */
        this.textField = 'name';
        /** When true the control is read-only and the panel cannot be opened. */
        this.disabled = false;
        // ─── Outputs ───────────────────────────────────────────────────────────────
        /** Emits the array of confirmed IDs whenever the confirmed selection changes. */
        this.selectionChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        // ─── Internal state ────────────────────────────────────────────────────────
        this.isOpen = false;
        this.searchQuery = '';
        /**
         * Items currently visible in the dropdown list.
         * Derived from availableItems by applyFilter(); never includes confirmed items.
         */
        this.filteredItems = [];
        /**
         * CONFIRMED selection — items that have been committed via "Select Customers".
         * These items are removed from the dropdown and displayed in the Selected
         * Items list below the component.
         * This is the only state written to the Reactive Form.
         */
        this.selectedIds = new Set();
        /**
         * TEMPORARY/PENDING selection — checkboxes ticked inside the open panel
         * but not yet confirmed.
         * Initialised as an empty set on each panel open (pending ≠ confirmed).
         * Promoted into selectedIds when the user clicks "Select Customers".
         * Discarded (reset to empty) on Escape / outside-click / Tab.
         */
        this.pendingIds = new Set();
        // ─── ControlValueAccessor callbacks ────────────────────────────────────────
        this.onChange = function () { };
        this.onTouched = function () { };
        // ─── Lifecycle ─────────────────────────────────────────────────────────────
        this.destroy$ = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subject__["Subject"]();
    }
    SearchableMultiSelectComponent.prototype.ngOnInit = function () {
        this.rebuildAvailable();
    };
    SearchableMultiSelectComponent.prototype.ngOnChanges = function (changes) {
        if (changes['items']) {
            this.rebuildAvailable();
        }
    };
    SearchableMultiSelectComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    // ─── ControlValueAccessor ──────────────────────────────────────────────────
    /** Called by Angular when the form control value is set programmatically. */
    SearchableMultiSelectComponent.prototype.writeValue = function (ids) {
        this.selectedIds = new Set(Array.isArray(ids) ? ids : []);
        this.pendingIds = new Set();
        this.rebuildAvailable();
        this.cdr.markForCheck();
    };
    SearchableMultiSelectComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    SearchableMultiSelectComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    SearchableMultiSelectComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this.cdr.markForCheck();
    };
    // ─── Panel open / close ────────────────────────────────────────────────────
    SearchableMultiSelectComponent.prototype.togglePanel = function () {
        if (this.disabled) {
            return;
        }
        this.isOpen ? this.closePanel() : this.openPanel();
    };
    SearchableMultiSelectComponent.prototype.openPanel = function () {
        this.isOpen = true;
        this.searchQuery = '';
        // Pending starts empty each time — user must re-select within this session.
        this.pendingIds = new Set();
        this.rebuildAvailable();
        this.cdr.markForCheck();
    };
    SearchableMultiSelectComponent.prototype.closePanel = function () {
        this.isOpen = false;
        // Discard any pending (un-confirmed) ticks.
        this.pendingIds = new Set();
        this.onTouched();
        this.cdr.markForCheck();
    };
    /**
     * Promote pendingIds into selectedIds, update the form, rebuild the
     * available list, and close the panel.
     * This is the ONLY path that writes a new value to the Reactive Form.
     */
    SearchableMultiSelectComponent.prototype.confirmSelection = function () {
        var _this = this;
        // Merge pending into confirmed.
        this.pendingIds.forEach(function (id) { return _this.selectedIds.add(id); });
        this.selectedIds = new Set(this.selectedIds); // new ref for OnPush
        this.pendingIds = new Set();
        this.emitChange();
        this.rebuildAvailable();
        this.isOpen = false;
        this.onTouched();
        this.cdr.markForCheck();
    };
    /**
     * Remove a single customer from the confirmed list.
     * Makes them immediately available again in the dropdown.
     */
    SearchableMultiSelectComponent.prototype.removeConfirmed = function (id) {
        this.selectedIds.delete(id);
        this.selectedIds = new Set(this.selectedIds); // new ref for OnPush
        // Also remove from pending in case they were re-ticked while panel was open.
        this.pendingIds.delete(id);
        this.pendingIds = new Set(this.pendingIds);
        this.emitChange();
        this.rebuildAvailable();
        this.cdr.markForCheck();
    };
    // ─── Outside-click / keyboard ──────────────────────────────────────────────
    SearchableMultiSelectComponent.prototype.onDocumentClick = function (event) {
        if (this.isOpen && !this.elementRef.nativeElement.contains(event.target)) {
            this.closePanel();
        }
    };
    SearchableMultiSelectComponent.prototype.onKeydown = function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            this.closePanel();
        }
        if (event.key === 'Tab' && this.isOpen) {
            this.closePanel();
        }
    };
    // ─── Search ────────────────────────────────────────────────────────────────
    SearchableMultiSelectComponent.prototype.onSearchChange = function (query) {
        this.searchQuery = query;
        this.applyFilter();
    };
    // ─── Selection ─────────────────────────────────────────────────────────────
    /** True if the item is TEMPORARILY checked (pending, not confirmed). */
    SearchableMultiSelectComponent.prototype.isSelected = function (item) {
        return this.pendingIds.has(item[this.idField]);
    };
    /** Toggles an item in pendingIds only. Does NOT touch the form. */
    SearchableMultiSelectComponent.prototype.toggleItem = function (item) {
        var id = item[this.idField];
        if (this.pendingIds.has(id)) {
            this.pendingIds.delete(id);
        }
        else {
            this.pendingIds.add(id);
        }
        this.pendingIds = new Set(this.pendingIds);
        this.cdr.markForCheck();
    };
    Object.defineProperty(SearchableMultiSelectComponent.prototype, "confirmedItems", {
        // ─── Computed helpers ──────────────────────────────────────────────────────
        /**
         * Customers that have been confirmed — displayed in the Selected Items list.
         * Ordered by original items[] position for stable rendering.
         */
        get: function () {
            var _this = this;
            return this.items.filter(function (item) { return _this.selectedIds.has(item[_this.idField]); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchableMultiSelectComponent.prototype, "pendingCount", {
        /** Count of pending (in-panel) ticks — shown next to the Confirm button. */
        get: function () {
            return this.pendingIds.size;
        },
        enumerable: true,
        configurable: true
    });
    /** Used by *ngFor to avoid re-rendering unchanged rows. */
    SearchableMultiSelectComponent.prototype.trackById = function (_index, item) {
        return item[this.idField];
    };
    // ─── Private helpers ───────────────────────────────────────────────────────
    /**
     * Rebuild filteredItems from items[], excluding already-confirmed entries.
     * Called after any change to selectedIds or items[].
     */
    SearchableMultiSelectComponent.prototype.rebuildAvailable = function () {
        var _this = this;
        var available = this.items.filter(function (item) { return !_this.selectedIds.has(item[_this.idField]); });
        var q = (this.searchQuery || '').trim().toLowerCase();
        if (!q) {
            this.filteredItems = available;
        }
        else {
            this.filteredItems = available.filter(function (item) {
                return String(item[_this.textField] || '').toLowerCase().includes(q);
            });
        }
        this.cdr.markForCheck();
    };
    /** Filters available (non-confirmed) items by the current search query. */
    SearchableMultiSelectComponent.prototype.applyFilter = function () {
        this.rebuildAvailable();
    };
    SearchableMultiSelectComponent.prototype.emitChange = function () {
        var ids = Array.from(this.selectedIds);
        this.onChange(ids);
        this.selectionChange.emit(ids);
    };
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Array)
    ], SearchableMultiSelectComponent.prototype, "items", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], SearchableMultiSelectComponent.prototype, "placeholder", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], SearchableMultiSelectComponent.prototype, "idField", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], SearchableMultiSelectComponent.prototype, "textField", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
        __metadata("design:type", Object)
    ], SearchableMultiSelectComponent.prototype, "disabled", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"])(),
        __metadata("design:type", Object)
    ], SearchableMultiSelectComponent.prototype, "selectionChange", void 0);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('document:click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], SearchableMultiSelectComponent.prototype, "onDocumentClick", null);
    __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"])('keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], SearchableMultiSelectComponent.prototype, "onKeydown", null);
    SearchableMultiSelectComponent = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"])({
            selector: 'searchable-multi-select',
            template: __webpack_require__(1080),
            styles: [__webpack_require__(956)],
            changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
            providers: [SEARCHABLE_MULTI_SELECT_VALUE_ACCESSOR],
        }),
        __metadata("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"],
            __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]])
    ], SearchableMultiSelectComponent);
    return SearchableMultiSelectComponent;
}());



/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UserManagementRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserManagementRoutingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_router__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__add_edit_user_adduser_component__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_user_component__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_management_component__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_rights_summary_userrightssummary_component__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_auth_admin_guard__ = __webpack_require__(369);






var UserManagementRoutes = [{
        path: 'user-management',
        children: [
            { path: 'user', component: __WEBPACK_IMPORTED_MODULE_2__user_user_component__["a" /* PageLayoutUserComponent */] },
            { path: 'add-user/:id', component: __WEBPACK_IMPORTED_MODULE_1__add_edit_user_adduser_component__["a" /* PageLayoutaddUserComponent */] },
            { path: 'user-rights-summary', component: __WEBPACK_IMPORTED_MODULE_4__user_rights_summary_userrightssummary_component__["a" /* PageLayoutUserRightsSummaryComponent */] }
        ],
        canActivateChild: [__WEBPACK_IMPORTED_MODULE_5__shared_auth_admin_guard__["a" /* AuthGuard */]],
        canActivate: [__WEBPACK_IMPORTED_MODULE_5__shared_auth_admin_guard__["a" /* AuthGuard */]],
        component: __WEBPACK_IMPORTED_MODULE_3__user_management_component__["a" /* UserManagementComponent */]
    }];
var UserManagementRoutingModule = __WEBPACK_IMPORTED_MODULE_0__angular_router__["g" /* RouterModule */].forChild(UserManagementRoutes);


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserManagementModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_user_component__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__add_edit_user_adduser_component__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_rights_summary_userrightssummary_component__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_material__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_common__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_forms__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_management_routing_module__ = __webpack_require__(766);








var UserManagementModule = /** @class */ (function () {
    function UserManagementModule() {
    }
    UserManagementModule = __decorate([
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_4__angular_material__["a" /* MaterialModule */],
                __WEBPACK_IMPORTED_MODULE_7__user_management_routing_module__["a" /* UserManagementRoutingModule */],
                __WEBPACK_IMPORTED_MODULE_5__angular_common__["a" /* CommonModule */],
                __WEBPACK_IMPORTED_MODULE_6__angular_forms__["a" /* FormsModule */],
                __WEBPACK_IMPORTED_MODULE_6__angular_forms__["b" /* ReactiveFormsModule */],
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_1__user_user_component__["a" /* PageLayoutUserComponent */],
                __WEBPACK_IMPORTED_MODULE_2__add_edit_user_adduser_component__["a" /* PageLayoutaddUserComponent */],
                __WEBPACK_IMPORTED_MODULE_3__user_rights_summary_userrightssummary_component__["a" /* PageLayoutUserRightsSummaryComponent */]
            ],
        })
    ], UserManagementModule);
    return UserManagementModule;
}());



/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["main"] = main;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser_dynamic__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_app_module__ = __webpack_require__(680);



// depending on the env mode, enable prod mode or add debugging modules
if (true) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["enableProdMode"])();
}
function main() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser_dynamic__["a" /* platformBrowserDynamic */])().bootstrapModule(__WEBPACK_IMPORTED_MODULE_2__app_app_module__["a" /* AppModule */]);
}
if (document.readyState === 'complete') {
    main();
}
else {
    document.addEventListener('DOMContentLoaded', main);
}


/***/ }),
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */,
/* 945 */,
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 423,
	"./af.js": 423,
	"./ar": 430,
	"./ar-dz": 424,
	"./ar-dz.js": 424,
	"./ar-kw": 425,
	"./ar-kw.js": 425,
	"./ar-ly": 426,
	"./ar-ly.js": 426,
	"./ar-ma": 427,
	"./ar-ma.js": 427,
	"./ar-sa": 428,
	"./ar-sa.js": 428,
	"./ar-tn": 429,
	"./ar-tn.js": 429,
	"./ar.js": 430,
	"./az": 431,
	"./az.js": 431,
	"./be": 432,
	"./be.js": 432,
	"./bg": 433,
	"./bg.js": 433,
	"./bm": 434,
	"./bm.js": 434,
	"./bn": 436,
	"./bn-bd": 435,
	"./bn-bd.js": 435,
	"./bn.js": 436,
	"./bo": 437,
	"./bo.js": 437,
	"./br": 438,
	"./br.js": 438,
	"./bs": 439,
	"./bs.js": 439,
	"./ca": 440,
	"./ca.js": 440,
	"./cs": 441,
	"./cs.js": 441,
	"./cv": 442,
	"./cv.js": 442,
	"./cy": 443,
	"./cy.js": 443,
	"./da": 444,
	"./da.js": 444,
	"./de": 447,
	"./de-at": 445,
	"./de-at.js": 445,
	"./de-ch": 446,
	"./de-ch.js": 446,
	"./de.js": 447,
	"./dv": 448,
	"./dv.js": 448,
	"./el": 449,
	"./el.js": 449,
	"./en-au": 450,
	"./en-au.js": 450,
	"./en-ca": 451,
	"./en-ca.js": 451,
	"./en-gb": 452,
	"./en-gb.js": 452,
	"./en-ie": 453,
	"./en-ie.js": 453,
	"./en-il": 454,
	"./en-il.js": 454,
	"./en-in": 455,
	"./en-in.js": 455,
	"./en-nz": 456,
	"./en-nz.js": 456,
	"./en-sg": 457,
	"./en-sg.js": 457,
	"./eo": 458,
	"./eo.js": 458,
	"./es": 462,
	"./es-do": 459,
	"./es-do.js": 459,
	"./es-mx": 460,
	"./es-mx.js": 460,
	"./es-us": 461,
	"./es-us.js": 461,
	"./es.js": 462,
	"./et": 463,
	"./et.js": 463,
	"./eu": 464,
	"./eu.js": 464,
	"./fa": 465,
	"./fa.js": 465,
	"./fi": 466,
	"./fi.js": 466,
	"./fil": 467,
	"./fil.js": 467,
	"./fo": 468,
	"./fo.js": 468,
	"./fr": 471,
	"./fr-ca": 469,
	"./fr-ca.js": 469,
	"./fr-ch": 470,
	"./fr-ch.js": 470,
	"./fr.js": 471,
	"./fy": 472,
	"./fy.js": 472,
	"./ga": 473,
	"./ga.js": 473,
	"./gd": 474,
	"./gd.js": 474,
	"./gl": 475,
	"./gl.js": 475,
	"./gom-deva": 476,
	"./gom-deva.js": 476,
	"./gom-latn": 477,
	"./gom-latn.js": 477,
	"./gu": 478,
	"./gu.js": 478,
	"./he": 479,
	"./he.js": 479,
	"./hi": 480,
	"./hi.js": 480,
	"./hr": 481,
	"./hr.js": 481,
	"./hu": 482,
	"./hu.js": 482,
	"./hy-am": 483,
	"./hy-am.js": 483,
	"./id": 484,
	"./id.js": 484,
	"./is": 485,
	"./is.js": 485,
	"./it": 487,
	"./it-ch": 486,
	"./it-ch.js": 486,
	"./it.js": 487,
	"./ja": 488,
	"./ja.js": 488,
	"./jv": 489,
	"./jv.js": 489,
	"./ka": 490,
	"./ka.js": 490,
	"./kk": 491,
	"./kk.js": 491,
	"./km": 492,
	"./km.js": 492,
	"./kn": 493,
	"./kn.js": 493,
	"./ko": 494,
	"./ko.js": 494,
	"./ku": 495,
	"./ku.js": 495,
	"./ky": 496,
	"./ky.js": 496,
	"./lb": 497,
	"./lb.js": 497,
	"./lo": 498,
	"./lo.js": 498,
	"./lt": 499,
	"./lt.js": 499,
	"./lv": 500,
	"./lv.js": 500,
	"./me": 501,
	"./me.js": 501,
	"./mi": 502,
	"./mi.js": 502,
	"./mk": 503,
	"./mk.js": 503,
	"./ml": 504,
	"./ml.js": 504,
	"./mn": 505,
	"./mn.js": 505,
	"./mr": 506,
	"./mr.js": 506,
	"./ms": 508,
	"./ms-my": 507,
	"./ms-my.js": 507,
	"./ms.js": 508,
	"./mt": 509,
	"./mt.js": 509,
	"./my": 510,
	"./my.js": 510,
	"./nb": 511,
	"./nb.js": 511,
	"./ne": 512,
	"./ne.js": 512,
	"./nl": 514,
	"./nl-be": 513,
	"./nl-be.js": 513,
	"./nl.js": 514,
	"./nn": 515,
	"./nn.js": 515,
	"./oc-lnc": 516,
	"./oc-lnc.js": 516,
	"./pa-in": 517,
	"./pa-in.js": 517,
	"./pl": 518,
	"./pl.js": 518,
	"./pt": 520,
	"./pt-br": 519,
	"./pt-br.js": 519,
	"./pt.js": 520,
	"./ro": 521,
	"./ro.js": 521,
	"./ru": 522,
	"./ru.js": 522,
	"./sd": 523,
	"./sd.js": 523,
	"./se": 524,
	"./se.js": 524,
	"./si": 525,
	"./si.js": 525,
	"./sk": 526,
	"./sk.js": 526,
	"./sl": 527,
	"./sl.js": 527,
	"./sq": 528,
	"./sq.js": 528,
	"./sr": 530,
	"./sr-cyrl": 529,
	"./sr-cyrl.js": 529,
	"./sr.js": 530,
	"./ss": 531,
	"./ss.js": 531,
	"./sv": 532,
	"./sv.js": 532,
	"./sw": 533,
	"./sw.js": 533,
	"./ta": 534,
	"./ta.js": 534,
	"./te": 535,
	"./te.js": 535,
	"./tet": 536,
	"./tet.js": 536,
	"./tg": 537,
	"./tg.js": 537,
	"./th": 538,
	"./th.js": 538,
	"./tk": 539,
	"./tk.js": 539,
	"./tl-ph": 540,
	"./tl-ph.js": 540,
	"./tlh": 541,
	"./tlh.js": 541,
	"./tr": 542,
	"./tr.js": 542,
	"./tzl": 543,
	"./tzl.js": 543,
	"./tzm": 545,
	"./tzm-latn": 544,
	"./tzm-latn.js": 544,
	"./tzm.js": 545,
	"./ug-cn": 546,
	"./ug-cn.js": 546,
	"./uk": 547,
	"./uk.js": 547,
	"./ur": 548,
	"./ur.js": 548,
	"./uz": 550,
	"./uz-latn": 549,
	"./uz-latn.js": 549,
	"./uz.js": 550,
	"./vi": 551,
	"./vi.js": 551,
	"./x-pseudo": 552,
	"./x-pseudo.js": 552,
	"./yo": 553,
	"./yo.js": 553,
	"./zh-cn": 554,
	"./zh-cn.js": 554,
	"./zh-hk": 555,
	"./zh-hk.js": 555,
	"./zh-mo": 556,
	"./zh-mo.js": 556,
	"./zh-tw": 557,
	"./zh-tw.js": 557
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 946;

/***/ }),
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */
/***/ (function(module, exports) {

module.exports = ".disabled {\n  visibility: hidden;\n  transition: transform .25s ease; }\n\n.wraper {\n  margin-left: 250px; }\n"

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports = ":host {\n  display: block;\n  font-family: Roboto, 'Helvetica Neue', sans-serif;\n  width: 100%; }\n\n.sms-host {\n  position: relative;\n  width: 100%; }\n  .sms-host--disabled {\n    pointer-events: none;\n    opacity: 0.5; }\n\n.sms-trigger {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 100%;\n  height: 48px;\n  padding: 0 14px;\n  box-sizing: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n  background: #fff;\n  cursor: pointer;\n  outline: none;\n  transition: border-color 150ms ease; }\n  .sms-trigger:hover {\n    border-color: rgba(0, 0, 0, 0.38); }\n  .sms-host--open .sms-trigger {\n    border-color: var(--primary-color, #3f51b5);\n    border-width: 2px;\n    padding: 0 13px; }\n\n.sms-trigger__value {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.54);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0; }\n\n.sms-trigger__arrow {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  margin-left: 8px;\n  color: rgba(0, 0, 0, 0.54);\n  transition: transform 225ms cubic-bezier(0.4, 0, 0.2, 1); }\n  .sms-host--open .sms-trigger__arrow {\n    transform: rotate(180deg);\n    color: var(--primary-color, #3f51b5); }\n\n.sms-panel {\n  max-height: 36vh;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: #fff;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n  animation: sms-panel-enter 180ms cubic-bezier(0.25, 0.8, 0.25, 1); }\n\n@keyframes sms-panel-enter {\n  from {\n    opacity: 0;\n    transform: translateY(-6px) scaleY(0.97); }\n  to {\n    opacity: 1;\n    transform: translateY(0) scaleY(1); } }\n\n.sms-panel__search {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 10px 14px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  gap: 8px; }\n\n.sms-panel__search-icon {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  color: rgba(0, 0, 0, 0.54);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.sms-panel__search-input {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  border: none;\n  outline: none;\n  font-family: inherit;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.87);\n  background: transparent;\n  padding: 0; }\n  .sms-panel__search-input:-ms-input-placeholder {\n    color: rgba(0, 0, 0, 0.54); }\n  .sms-panel__search-input::placeholder {\n    color: rgba(0, 0, 0, 0.54); }\n\n.sms-panel__search-clear {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: rgba(0, 0, 0, 0.54);\n  font-size: 14px;\n  line-height: 1;\n  outline: none; }\n  .sms-panel__search-clear:hover {\n    color: rgba(0, 0, 0, 0.87); }\n\n.sms-panel__list {\n  list-style: none;\n  margin: 0;\n  padding: 4px 0;\n  max-height: 220px;\n  overflow-y: auto; }\n  .sms-panel__list::-webkit-scrollbar {\n    width: 4px; }\n  .sms-panel__list::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.12);\n    border-radius: 2px; }\n\n.sms-panel__empty {\n  padding: 12px 16px;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.54); }\n\n.sms-panel__option {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 0 16px;\n  height: 42px;\n  cursor: pointer;\n  outline: none;\n  -webkit-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  transition: background-color 80ms ease; }\n  .sms-panel__option:hover, .sms-panel__option:focus {\n    background-color: rgba(0, 0, 0, 0.04); }\n  .sms-panel__option--selected {\n    background-color: rgba(63, 81, 181, 0.08); }\n\n.sms-panel__option-label {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.87);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-right: 12px; }\n\n.sms-checkbox {\n  -ms-flex: 0 0 18px;\n      flex: 0 0 18px; }\n\n.sms-checkbox__box {\n  position: relative;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(0, 0, 0, 0.3);\n  border-radius: 2px;\n  box-sizing: border-box;\n  transition: border-color     90ms ease,\r background-color 90ms ease; }\n  .sms-checkbox--checked .sms-checkbox__box {\n    background-color: #44a049;\n    border-color: #44a049; }\n\n.sms-checkbox__checkmark {\n  display: block;\n  width: 10px;\n  height: 7px;\n  opacity: 0;\n  transform: rotate(-45deg) scale(0.6);\n  transition: opacity   90ms ease,\r transform 90ms ease; }\n  .sms-checkbox__checkmark::before, .sms-checkbox__checkmark::after {\n    content: '';\n    position: absolute;\n    background-color: #fff;\n    border-radius: 1px; }\n  .sms-checkbox__checkmark::before {\n    width: 2px;\n    height: 6px;\n    left: 0;\n    top: 2px; }\n  .sms-checkbox__checkmark::after {\n    width: 9px;\n    height: 2px;\n    left: 0;\n    top: 6px; }\n  .sms-checkbox--checked .sms-checkbox__checkmark {\n    opacity: 1;\n    transform: rotate(-45deg) scale(1); }\n\n.sms-panel__footer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 8px 12px;\n  border-top: 1px solid rgba(0, 0, 0, 0.12);\n  min-height: 48px; }\n\n.sms-panel__count {\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.54); }\n\n.sms-panel__confirm {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 36px;\n  padding: 0 20px;\n  border: none;\n  border-radius: 4px;\n  background-color: var(--primary-color, #3f51b5);\n  color: #fff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  outline: none;\n  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  transition: background-color 80ms ease,\r box-shadow       80ms ease; }\n  .sms-panel__confirm:hover:not([disabled]) {\n    background-color: var(--primary-color-dark, #303f9f); }\n  .sms-panel__confirm[disabled] {\n    background-color: rgba(0, 0, 0, 0.12);\n    color: rgba(0, 0, 0, 0.38);\n    box-shadow: none;\n    cursor: default; }\n\n.sms-confirmed {\n  margin-top: 16px;\n  font-family: Roboto, 'Helvetica Neue', sans-serif; }\n\n.sms-confirmed__heading {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.54);\n  /* matches md-input placeholder colour */\n  margin-bottom: 10px;\n  line-height: 1; }\n\n.sms-confirmed__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 171px;\n  overflow-y: auto;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 4px; }\n  .sms-confirmed__list::-webkit-scrollbar {\n    width: 4px; }\n  .sms-confirmed__list::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.12);\n    border-radius: 2px; }\n\n.sms-confirmed__row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 0 14px;\n  height: 42px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12); }\n  .sms-confirmed__row:last-child {\n    border-bottom: none; }\n\n.sms-confirmed__name {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  font-size: 14px;\n  color: var(--primary-color, #3f51b5);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-right: 8px; }\n\n.sms-confirmed__remove {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: #eb3939;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  outline: none;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  transition: background-color 80ms ease; }\n  .sms-confirmed__remove:hover {\n    background-color: rgba(63, 81, 181, 0.1); }\n"

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports = ".image-preview{\r\n    height: 170px; \r\n    width: \"100%\"; \r\n    border: 2px solid #ccc; \r\n    display: -ms-flexbox; \r\n    display: flex; \r\n    -ms-flex-align: center; \r\n        align-items: center; \r\n    -ms-flex-pack: center; \r\n        justify-content: center;\r\n    background-color: #f0f0f0;\r\n}"

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports = ".container {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-direction: column;\r\n        flex-direction: column;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n    -ms-flex-pack: center;\r\n        justify-content: center;\r\n    width: 100%;\r\n    height: 93vh;\r\n    overflow: hidden;\r\n}\r\n.card-container {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-direction: row;\r\n        flex-direction: row;\r\n    -ms-flex-pack: center;\r\n        justify-content: center;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n    width: 100%;\r\n    height:40%;\r\n}\r\n.card-template {\r\n    cursor:pointer;\r\n    background-color:rgba(0, 0, 0, 0.85)!important;\r\n    color: white !important;\r\n    border: 1px solid #ddd;\r\n    border-radius: 20px;\r\n    padding: 10px;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-pack: center;\r\n        justify-content: center;\r\n    text-align: center;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n    margin: 0 10px;\r\n    height: 100%;\r\n    width: 350px;\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n.card-template:hover {\r\n    transform: scale(1.05);\r\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\r\n}\r\nfooter {\r\n    background-color: #333;\r\n    color: white;\r\n    text-align: center;\r\n    padding: 1em 0;\r\n    position: relative;\r\n    bottom: 0;\r\n    width: 100%;\r\n}\r\n::ng-deep .swal2-styled.swal2-confirm {\r\n    border: 0;\r\n    border-radius: .25em;\r\n    color: #000;\r\n    font-size: 1em;\r\n}"

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports = ".mdl-data-table__cell--non-numeric_title{\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    text-align: left;\r\n}\r\n.close-btn-wrapper{\r\n    position:relative;  \r\n}\r\n.close{\r\n    position: relative;\r\n    cursor: pointer;\r\n    top: -19px;\r\n    right: -27px;\r\n    transition: all 200ms;\r\n    font-size: 26px;\r\n    font-weight: bold;\r\n    text-decoration: none;\r\n    color:#333;\r\n}"

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports = ".access-container {\r\n  text-align: center;\r\n  margin-top: 6rem;\r\n  font-family: 'Segoe UI', sans-serif;\r\n}\r\n"

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = ".SideNavOpen{\r\n    margin-left: 250px !important;\r\n}"

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports = ".selectedItem {\r\n    background: #FFFFFF50;\r\n}\r\n.selectedItemColor {\r\n    color: white !important;\r\n    /* More Text with .... */\r\n    white-space: nowrap;\r\n    width: 190px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n.callout-info {\r\n    border-color: #FFCA28 !important;\r\n}"

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports = ".dropdown-container {\r\n  position: relative;\r\n  width: 100%;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.dropdown-trigger {\r\n  padding: 5px 10px;\r\n  width: 100%;\r\n  border: 1px solid #ccc;\r\n  border-radius: 1px;\r\n  cursor: pointer;\r\n  -webkit-user-select: none;\r\n      -ms-user-select: none;\r\n          user-select: none;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-pack: justify;\r\n      justify-content: space-between;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  background: #fff;\r\n}\r\n\r\n.dropdown-panel {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  width: 100%;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  border: 1px solid #ccc;\r\n  background: white;\r\n  padding: 5px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.2);\r\n  z-index: 100;\r\n  margin-top: 2px;\r\n}\r\n\r\n.option {\r\n  padding: 2px;\r\n  cursor: pointer;\r\n}\r\n\r\n.option:hover {\r\n  background-color: #eee;\r\n}\r\n\r\n.search-box {\r\n  width: 100%;\r\n  padding: 7px 10px;\r\n  box-sizing: border-box;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.selected{\r\n  background-color: #e0e0e0;\r\n  font-weight: 500;\r\n}\r\n"

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports = ".selectedItem {\r\n    background: royalblue;\r\n}\r\n.selectedItemColor {\r\n    color: white !important;\r\n    /* More Text with .... */\r\n    white-space: nowrap;\r\n    width: 190px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}"

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports = ".sort-dropdown {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.sort-toggle {\r\n  background: none;\r\n  border: none;\r\n  padding: 4px 8px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  gap: 4px;\r\n  margin-left: 10em;\r\n}\r\n\r\n.dropdown-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  min-width: 120px;\r\n  background: #fff;\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.15);\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-direction: column;\r\n      flex-direction: column;\r\n  margin-top: 2px;\r\n  z-index: 100;\r\n}\r\n\r\n.dropdown-menu button {\r\n  background: none;\r\n  border: none;\r\n  padding: 6px 10px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.dropdown-menu button:hover {\r\n  background: #f0f0f0;\r\n}\r\n"

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports = ".pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {\r\n    z-index: 3;\r\n    color: #000;\r\n    cursor: default;\r\n    background-color: #ffca28;\r\n    border-color: #ffca28;\r\n}"

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports = ".file-preview{\r\n    height: 250px; \r\n    width: \"100%\"; \r\n    border: 2px solid #ccc; \r\n    display: -ms-flexbox; \r\n    display: flex; \r\n    -ms-flex-align: center; \r\n        align-items: center; \r\n    -ms-flex-pack: center; \r\n        justify-content: center;\r\n    background-color: #f0f0f0;\r\n}\r\n.duplicate-row{\r\n    color: red;\r\n}"

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports = "::ng-deep .swal2-styled.swal2-confirm {\r\n    border: 0;\r\n    border-radius: .25em;\r\n    color: #000;\r\n    font-size: 1em;\r\n}"

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports = ".pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {\r\n    z-index: 3;\r\n    color: #000;\r\n    cursor: default;\r\n    background-color: #ffca28;\r\n    border-color: #ffca28;\r\n}"

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports = "::ng-deep .mat-ink-bar {\r\n    background-color: #ffca28 !important; /* Color of the underline */\r\n}\r\n::ng-deep .mat-tab-label.mat-tab-label-active {\r\n    background: none;\r\n}\r\n::ng-deep .mat-tab-label:focus {\r\n    background:none;\r\n}\r\n.pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {\r\n    z-index: 3;\r\n    color: #000;\r\n    cursor: default;\r\n    background-color: #ffca28;\r\n    border-color: #ffca28;\r\n}"

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports = ".selected-row{\r\n    background-color: #FFCA28  !important;\r\n}"

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports = "::ng-deep .mat-radio-disabled, .mat-radio-disabled .mat-radio-label {\r\n    cursor: not-allowed !important;\r\n}\r\n::ng-deep .mat-radio-disabled.mat-radio-checked .mat-radio-outer-circle {\r\n    border-color: rgba(0, 0, 0, 0.38) !important;\r\n}\r\n::ng-deep .mat-radio-disabled.mat-radio-checked .mat-radio-inner-circle {\r\n    background-color: rgba(0, 0, 0, 0.38) !important;\r\n}\r\n:host ::ng-deep .mat-radio-button .mat-radio-inner-circle {\r\n    background-color: #ffca28 !important;\r\n}\r\n:host ::ng-deep .mat-radio-checked .mat-radio-outer-circle {\r\n    border-color: #ffca28 !important;\r\n}\r\n:host ::ng-deep .mat-radio-checked .mat-ripple-element {\r\n    background-color: #ffca28 !important;\r\n    opacity: 0.01;\r\n}\r\n"

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports = "::ng-deep .mat-radio-disabled, .mat-radio-disabled .mat-radio-label {\r\n    cursor: not-allowed !important;\r\n}\r\n::ng-deep .mat-radio-disabled.mat-radio-checked .mat-radio-outer-circle {\r\n    border-color: rgba(0, 0, 0, 0.38) !important;\r\n}\r\n::ng-deep .mat-radio-disabled.mat-radio-checked .mat-radio-inner-circle {\r\n    background-color: rgba(0, 0, 0, 0.38) !important;\r\n}\r\n::ng-deep .mat-radio-button .mat-radio-inner-circle {\r\n    background-color: #ffca28 !important;\r\n}\r\n::ng-deep .mat-radio-checked .mat-radio-outer-circle {\r\n    border-color: #ffca28 !important;\r\n}\r\n::ng-deep .mat-radio-checked .mat-ripple-element {\r\n    background-color: #ffca28 !important;\r\n    opacity: 0.01;\r\n}\r\n.selected-row{\r\n    background-color: #FFCA28  !important;\r\n}"

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports = ".pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {\r\n    z-index: 3;\r\n    color: #000;\r\n    cursor: default;\r\n    background-color: #ffca28;\r\n    border-color: #ffca28;\r\n}"

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports = ".pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {\r\n    z-index: 3;\r\n    color: #000;\r\n    cursor: default;\r\n    background-color: #ffca28;\r\n    border-color: #ffca28;\r\n}"

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports = ".pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {\r\n    z-index: 3;\r\n    color: #000;\r\n    cursor: default;\r\n    background-color: #ffca28;\r\n    border-color: #ffca28;\r\n}"

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports = ".selected-row{\r\n    background-color: #FFCA28  !important;\r\n}\r\n.pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {\r\n    z-index: 3;\r\n    color: #000;\r\n    cursor: default;\r\n    background-color: #ffca28;\r\n    border-color: #ffca28;\r\n}"

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports = "::ng-deep .mat-radio-button .mat-radio-inner-circle {\r\n    background-color: #ffca28 !important;\r\n}\r\n::ng-deep .mat-radio-checked .mat-radio-outer-circle {\r\n    border-color: #ffca28 !important;\r\n}\r\n::ng-deep .mat-radio-checked .mat-ripple-element {\r\n    background-color: #ffca28 !important;\r\n    opacity: 0.01;\r\n}"

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports = "::ng-deep .mat-ink-bar {\r\n    background-color: #ffca28 !important; /* Color of the underline */\r\n}\r\n::ng-deep .mat-tab-label.mat-tab-label-active {\r\n    background: none;\r\n}\r\n::ng-deep .mat-tab-label:focus {\r\n    background:none;\r\n}\r\n.pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {\r\n    z-index: 3;\r\n    color: #000;\r\n    cursor: default;\r\n    background-color: #ffca28;\r\n    border-color: #ffca28;\r\n}"

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports = "::ng-deep .mat-ink-bar {\r\n    background-color: #ffca28 !important; /* Color of the underline */\r\n}\r\n::ng-deep .mat-tab-label.mat-tab-label-active {\r\n    background: none;\r\n}\r\n::ng-deep .mat-tab-label:focus {\r\n    background:none;\r\n}\r\n.pagination>.active>a, .pagination>.active>a:focus, .pagination>.active>a:hover, .pagination>.active>span, .pagination>.active>span:focus, .pagination>.active>span:hover {\r\n    z-index: 3;\r\n    color: #000;\r\n    cursor: default;\r\n    background-color: #ffca28;\r\n    border-color: #ffca28;\r\n}"

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports = "/* activateRelease.component.css\r\n   ─────────────────────────────\r\n   Scoped layout styles for the Activate Release dialog.\r\n   Only spacing / alignment — no colour overrides that fight Material theming.\r\n*/\r\n\r\n/* ── Dialog root ──────────────────────────────────────────────────────────── */\r\n\r\n:host {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-direction: column;\r\n        flex-direction: column;\r\n    /* height: 100%; */\r\n    width: 100%;\r\n}\r\n\r\n.activate-release__form {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-direction: column;\r\n        flex-direction: column;\r\n    -ms-flex: 1;\r\n        flex: 1;\r\n    min-height: 0;\r\n}\r\n\r\n.activate-release {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-direction: column;\r\n      flex-direction: column;\r\n  width:100%;\r\n  /* height: 100%; */\r\n  min-width: 400px;\r\n   /*  prevents the dialog collapsing on short radio labels */\r\n  /* max-width: 480px; */\r\n}\r\n\r\n/* md-dialog-content resets its own padding in beta.2; restore a comfortable\r\n   value and remove the default bottom padding so the footer sits flush. */\r\n.activate-release__content {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-direction: column;\r\n      flex-direction: column;\r\n  max-height: 90vh;\r\n  /* flex: 1; */\r\n  /* padding: 8px 24px 0 !important; */\r\n  /* max-height: 520px;\r\n    overflow-y: auto; */\r\n}\r\n\r\n/* ── Section grouping ─────────────────────────────────────────────────────── */\r\n\r\n.activate-release__section {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.activate-release__section:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/* ── Field label (replaces bare <label><strong>) ─────────────────────────── */\r\n\r\n.activate-release__field-label {\r\n  display: block;\r\n  font-size: 14px;\r\n  color: rgba(0, 0, 0, 0.54);   /* matches md-input placeholder colour */\r\n  margin-bottom: 8px;\r\n  line-height: 1;\r\n}\r\n\r\n/* ── Full-width helpers ───────────────────────────────────────────────────── */\r\n\r\n.activate-release__full-width {\r\n  width: 100%;\r\n  /* Ensure md-input-container doesn't add its own extra-bottom margin that\r\n     would push the error message outside the section block. */\r\n  display: block;\r\n}\r\n\r\n/* ── Radio group ──────────────────────────────────────────────────────────── */\r\n\r\n.activate-release__radio-group {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\r\n  gap: 0 16px;          /* horizontal gap between buttons; no extra top gap */\r\n}\r\n\r\n.activate-release__radio-button {\r\n  margin-right: 0;      /* gap handles spacing; cancel beta.2 default margin */\r\n}\r\n\r\n/* ── Description paragraph ───────────────────────────────────────────────── */\r\n\r\n.activate-release__description {\r\n  font-size: 16px;\r\n  color: rgba(0, 0, 0, 0.54);\r\n  margin: 16px 0 4px;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* ── Dialog actions ───────────────────────────────────────────────────────── */\r\n\r\n/* md-dialog-actions adds its own padding; keep buttons right-aligned with a\r\n   small top separator to visually close off the content area. */\r\n.activate-release__actions {\r\n  padding-top: 15px !important;\r\n  gap: 8px;\r\n}\r\n\r\n.activate-release__actions button:first-child {\r\n    margin-right: 12px;\r\n}\r\n.btn-cancel {\r\n  background-color: #797f79;\r\n  color: white;\r\n}\r\n\r\n.warning-box {\r\n  margin-top: 20px;\r\n  padding: 12px;\r\n  border: 1px solid #f0ad00;\r\n  background: #fff8e1;\r\n  color: #8a6d3b;\r\n  border-radius: 4px;\r\n}\r\n\r\n\r\n::ng-deep .mat-dialog-container cdk-focus-trap{\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-direction: column;\r\n        flex-direction: column;\r\n    -ms-flex: 1;\r\n        flex: 1;\r\n    height: 100%;\r\n}\r\n\r\n::ng-deep .mat-dialog-container .cdk-focus-trap-content {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-direction: column;\r\n        flex-direction: column; \r\n    -ms-flex: 1; \r\n        flex: 1;\r\n    height: 100%;\r\n}\r\n\r\n/* Force the flex container to center items vertically instead of baseline */\r\n:host ::ng-deep .mat-radio-label {\r\n  display: -ms-inline-flexbox !important;\r\n  display: inline-flex !important;\r\n  -ms-flex-align: center !important;\r\n      align-items: center !important;\r\n}\r\n\r\n/* Ensure the text inside doesn't wrap or inherit weird line-heights */\r\n:host ::ng-deep .mat-radio-label-content {\r\n  display: inline-block !important;\r\n  vertical-align: middle !important;\r\n  padding-top: 5px !important;\r\n}\r\n\r\n:host ::ng-deep .mat-radio-disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n:host ::ng-deep .mat-radio-disabled .mat-radio-label-content {\r\n    color: rgba(0, 0, 0, 0.38);\r\n}\r\n\r\n:host ::ng-deep .mat-radio-disabled .mat-radio-outer-circle,\r\n:host ::ng-deep .mat-radio-disabled .mat-radio-inner-circle {\r\n    border-color: rgba(0, 0, 0, 0.38);\r\n}\r\n\r\n.required {\r\n  color: #f44336;   /* Material Design red */\r\n  margin-left: 2px;\r\n  font-weight: 500;\r\n}\r\n\r\n:host ::ng-deep .mat-radio-button.mat-radio-checked .mat-radio-outer-circle {\r\n    border-color: #000000 !important;\r\n}\r\n\r\n:host ::ng-deep .mat-radio-button.mat-radio-checked .mat-radio-inner-circle {\r\n    background-color: #000000 !important;\r\n} \r\n\r\n:host ::ng-deep .mat-radio-button.mat-radio-checked .mat-radio-ripple .mat-ripple-element {\r\n  background-color: rgba(39, 39, 39, 0.2) !important; \r\n}\r\n\r\n.pop-ta {\r\n  width: 100%;\r\n  height: 50px;\r\n  border: 1px solid #1a7abf;\r\n  /* border: 1px solid rgba(0, 0, 0, 0.12); */\r\n  border-radius: 4px;\r\n  padding: 3px 5px;\r\n  font-size: 14px;\r\n  resize: none;\r\n  outline: none;\r\n  overflow: hidden;     /* Prevent scrollbar */\r\n  box-sizing: border-box;\r\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.pop-ta:focus {\r\n  border: 2px solid #2c83bb;\r\n  /* box-shadow: 0 0 0 3px rgba(49, 152, 226, 0.2); */\r\n}\r\n\r\n.activate-release__checkbox-container{\r\n  margin-top: 8px;\r\n}\r\n\r\n.activate-release__notification-options {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  gap: 16px;\r\n}\r\n"

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = ".dialog-content {\r\n  min-width: 500px;\r\n}\r\n\r\n.current-release {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-align: center;\r\n      align-items: center;\r\n  /* background: #ede7f6; */\r\n  padding: 10px 14px;\r\n  border-radius: 4px;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.current-release.pilot-release {\r\n  background: #ede7f6;\r\n\r\n  .release-badge {\r\n    background: #6f42c1;\r\n    color: #fff;\r\n  }\r\n\r\n  .release-text {\r\n    color: #512da8;\r\n  }\r\n}\r\n\r\n.current-release.custom-release {\r\n  background: #fff3e6;\r\n\r\n  .release-badge {\r\n    background: #fd7e14;\r\n    color: #fff;\r\n  }\r\n\r\n  .release-text {\r\n    color: #c75a00;\r\n  }\r\n}\r\n\r\n.release-badge {\r\n  /* background: #673ab7;\r\n  color: white; */\r\n  padding: 4px 10px;\r\n  border-radius: 4px;\r\n  font-weight: 600;\r\n  margin-right: 12px;\r\n}\r\n\r\n.release-text {\r\n  color: #512da8;\r\n  font-size: 16px;\r\n}\r\n\r\n.section-title {\r\n  font-weight: 600;\r\n  color: rgba(0, 0, 0, 0.54);\r\n  font-size: 14px;\r\n  display: block;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.radio-option {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.option-description {\r\n  margin-left: 30px;\r\n  margin-top: 4px;\r\n  color: #666;\r\n  font-size: 14px;\r\n}\r\n\r\n.checkbox-description {\r\n  /* margin-left: 30px; */\r\n  color: #666;\r\n  font-size: 14px;\r\n  padding: 12px;\r\n  border: 1px solid #f0ad00;\r\n  background: #fff8e1;\r\n  color: #8a6d3b;\r\n  border-radius: 4px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.warning-box {\r\n  margin-top: 10px;\r\n  padding: 12px;\r\n  border: 1px solid #f0ad00;\r\n  background: #fff8e1;\r\n  color: #8a6d3b;\r\n  border-radius: 4px;\r\n}\r\n\r\n.warning-box i {\r\n  margin-right: 6px;\r\n}\r\n\r\n.mt-20 {\r\n  margin-top: 20px;\r\n}\r\n\r\n/* md-dialog-actions button {\r\n    min-width: 90px;\r\n} */\r\n\r\nmd-dialog-actions button:first-child {\r\n    margin-right: 12px;\r\n}\r\n\r\n/* Force the flex container to center items vertically instead of baseline */\r\n::ng-deep .mat-radio-label {\r\n  display: -ms-inline-flexbox !important;\r\n  display: inline-flex !important;\r\n  -ms-flex-align: center !important;\r\n      align-items: center !important;\r\n}\r\n\r\n/* Ensure the text inside doesn't wrap or inherit weird line-heights */\r\n::ng-deep .mat-radio-label-content {\r\n  display: inline-block !important;\r\n  vertical-align: middle !important;\r\n  padding-top: 5px !important;\r\n}\r\n\r\n.btn-cancel {\r\n  background-color: #797f79;\r\n  color: white;\r\n}\r\n\r\n.action-buttons {\r\n  padding-top: 25px !important;\r\n  gap: 8px;\r\n}\r\n\r\n.action-buttons button:first-child {\r\n  margin-right: 12px;\r\n}\r\n\r\n:host ::ng-deep .mat-radio-button.mat-radio-checked .mat-radio-outer-circle {\r\n    border-color: #000000 !important;\r\n}\r\n\r\n:host ::ng-deep .mat-radio-button.mat-radio-checked .mat-radio-inner-circle {\r\n    background-color: #000000 !important;\r\n} \r\n\r\n:host ::ng-deep .mat-radio-button.mat-radio-checked .mat-radio-ripple .mat-ripple-element {\r\n  background-color: rgba(39, 39, 39, 0.2) !important; \r\n}\r\n\r\n\r\n:host ::ng-deep .mat-radio-disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n:host ::ng-deep .mat-radio-disabled .mat-radio-label-content {\r\n    color: rgba(0, 0, 0, 0.38);\r\n}\r\n\r\n:host ::ng-deep .mat-radio-disabled .mat-radio-outer-circle,\r\n:host ::ng-deep .mat-radio-disabled .mat-radio-inner-circle {\r\n    border-color: rgba(0, 0, 0, 0.38);\r\n}\r\n\r\n.option-description-disabled {\r\n  color: rgba(0, 0, 0, 0.38);\r\n}\r\n\r\n.required {\r\n  color: #f44336;   /* Material Design red */\r\n  margin-left: 2px;\r\n  font-weight: 500;\r\n}\r\n\r\n.checkbox-container{\r\n  display: block;\r\n  margin-top: 20px;\r\n}\r\n\r\n.notification-options {\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  gap: 16px;\r\n}"

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports = ".STPStart {\r\n    background-color: lightgoldenrodyellow !important;\r\n    font-weight: bold;\r\n}\r\n\r\n::ng-deep .mat-tooltip {\r\n    white-space: pre-line;\r\n}"

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports = ".mat-button-focus-overlay {\r\n    background-color: red !important;\r\n    border-radius: none !important;\r\n    pointer-events: none !important;\r\n    opacity: none !important;\r\n}\r\n\r\n.title {\r\n    font-family: \"Roboto\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\r\n    font-size: 24px;\r\n    font-weight: 400;\r\n    line-height: 32px;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    margin-top: 24px;\r\n    margin-bottom: 16px;\r\n    font-size: 30px;\r\n    overflow-wrap: break-word;\r\n    word-wrap: break-word;\r\n    -ms-hyphens: auto;\r\n        hyphens: auto;\r\n}\r\n.changelogbtn{\r\n    float: right !important;\r\n    /* margin-top:24px; */\r\n}\r\n.pushNotificationHistoryButton{\r\n    margin: 1%;\r\n    margin-top: 24px;\r\n}\r\n.STPStart {\r\n    background-color: lightgoldenrodyellow !important;\r\n    font-weight: bold;\r\n}\r\n\r\n::ng-deep .mat-tooltip {\r\n    white-space: pre-line;\r\n}"

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports = ".mdl-data-table__cell--non-numeric_title\r\n{\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    text-align: left;\r\n}\r\n.close-btn-wrapper{\r\n    position:relative;  \r\n}\r\n.close{\r\n  position: relative;\r\n  cursor: pointer;\r\n  top: -19px;\r\n  right: -27px;\r\n  transition: all 200ms;\r\n  font-size: 26px;\r\n  font-weight: bold;\r\n  text-decoration: none;\r\n  color:#333;\r\n}\r\n.wraptext{\r\n  white-space: pre;\r\n}"

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports = ".mdl-data-table__cell--non-numeric_title{\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    text-align: left;\r\n}\r\n.close-btn-wrapper{\r\n    position:relative;  \r\n}\r\n.close{\r\n  position: relative;\r\n  cursor: pointer;\r\n  top: -19px;\r\n  right: -27px;\r\n  transition: all 200ms;\r\n  font-size: 26px;\r\n  font-weight: bold;\r\n  text-decoration: none;\r\n  color:#333;\r\n}\r\n.wraptext{\r\n  white-space: pre;\r\n}"

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = ".mdl-data-table__cell--non-numeric_title\r\n{\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    text-align: left;\r\n}\r\n.close-btn-wrapper{\r\n    position:relative;  \r\n}\r\n.close{\r\n  position: relative;\r\n  cursor: pointer;\r\n  top: -19px;\r\n  right: -27px;\r\n  transition: all 200ms;\r\n  font-size: 26px;\r\n  font-weight: bold;\r\n  text-decoration: none;\r\n  color:#333;\r\n}\r\n.wraptext{\r\n  white-space: pre;\r\n}"

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <section>\r\n        <div class=\"col-12\">\r\n            <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        </div>\r\n        <div class=\"col-12\">&nbsp; </div>\r\n        <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n            <div class=\"alert alert-danger\">\r\n                {{errorMessage}}\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">\r\n            <form [formGroup]=\"advertisementForm\">\r\n                <div class=\"form-group row\">\r\n                    <label class=\"col-md-4 control-label\">Product Title</label>\r\n                    <div class=\"col-md-8\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"ProductTitle\" type=\"text\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; advertisementForm.controls.ProductTitle.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"advertisementForm.controls.ProductTitle.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Product title is required.</span>\r\n                    </div>                 \r\n                </div>  \r\n                <div class=\"form-group row\">\r\n                    <label class=\"col-md-4 control-label\">Product Description</label>\r\n                    <div class=\"col-md-8\">\r\n                        <textarea class=\"form-control\" \r\n                            formControlName=\"ProductDescription\"></textarea>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; advertisementForm.controls.ProductDescription.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"advertisementForm.controls.ProductDescription.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Product description is required.</span>\r\n                    </div>                 \r\n                </div> \r\n                <div class=\"form-group row\">\r\n                    <label class=\"col-md-4 control-label\">Product Link</label>\r\n                    <div class=\"col-md-8\">\r\n                        <input class=\"form-control\" (keydown.space)=\"$event.preventDefault()\" \r\n                            formControlName=\"ProductLink\" type=\"text\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; advertisementForm.controls.ProductLink.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"advertisementForm.controls.ProductLink.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Product Link is required.</span>\r\n                    </div>                 \r\n                </div>   \r\n                <div class=\"form-group row\">\r\n                    <label class=\"col-md-4 control-label\">Product Image</label>\r\n                    <div class=\"col-md-8\">\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ;\" (click)=\"chooseFile()\">\r\n                            Choose File\r\n                        </button>\r\n                        <input hidden id=\"productImageInput\" class=\"form-control\" (change)=\"onChange($event)\" \r\n                                formControlName=\"ProductImage\" type=\"file\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; advertisementForm.controls.ProductImage.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"advertisementForm.controls.ProductImage.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">Product Image is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"uploadResponse!=''\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">{{uploadResponse}}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div id=\"PreviewImg\" class=\"col-md-8\">\r\n                        <div *ngIf=\"imageURL==''\" class=\"image-preview\">\r\n                            Image Preview\r\n                        </div>\r\n                        <div *ngIf=\"imageURL!=''\">\r\n                            <img [src]=\"imageURL\" style=\"object-fit: contain; height: 170px; width: 170px;\"/>\r\n                        </div>\r\n                    </div>\r\n                    \r\n                </div>\r\n                \r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-12\"> <!--1. Form valid or not validationForm.valid used 2. Form has any changes for that validationForm.pristine used 3.some situation save button disabled and Enabled that's why we use SaveButtonDisbaled) -->\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ;\"\r\n                            [disabled]=\"!advertisementForm.valid || advertisementForm.pristine\"\r\n                            (click)=\"onSubmit()\">Save</button>                        \r\n                        <span class=\"space\"></span>\r\n                        <button md-raised-button [disabled]=\"CancelButtonDisabled\"\r\n                            (click)=\"onDialogCancel()\">Cancel</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </section>\r\n</article>\r\n\r\n\r\n"

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports = "<my-app-header></my-app-header>\r\n<section>\r\n  <div style=\"display: flex; align-items: center; justify-content: center; margin-top: 60px ;\">\r\n    <h2>Advertisement</h2>\r\n  </div>\r\n    <section class=\"container-fluid\">\r\n          <section>\r\n            <hr />\r\n            <div style=\"display: flex; flex-direction: row;\">\r\n                <button md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"addNewAdvertisement()\">\r\n                    Add new advertisement\r\n                </button>\r\n            </div>\r\n            <div class=\"row\">&nbsp;</div>\r\n            <div class=\"row\" *ngIf=\"errorMessage!==''\" class=\"alert alert-danger\">\r\n              <div class=\"col-12\">{{errorMessage}}</div>\r\n            </div>\r\n            <div class=\"row\">&nbsp;</div>\r\n            <div class=\"row\" *ngIf=\"advertisementList?.length > 0\">\r\n              <div class=\"col-12\">\r\n                <div class=\"table-responsive\">\r\n                  <table class=\"mdl-data-table table-striped col-12\">\r\n                    <tbody>\r\n                      <th class=\"mdl-data-table__cell--non-numeric\">Product Title</th>\r\n                      <th class=\"mdl-data-table__cell--non-numeric\"\r\n                        style=\"align-items: center;  justify-content: center;\" >Product Description</th>\r\n                      <th class=\"mdl-data-table__cell--non-numeric\">\r\n                        ProductLink\r\n                      </th>\r\n                      <th style=\"text-wrap: wrap;\" class=\"mdl-data-table__cell--non-numeric\">\r\n                        Action\r\n                      </th>\r\n                      <tr *ngFor=\"let row of advertisementList; let i = index\">\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                          <span>{{row.ProductTitle}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\" style=\"text-wrap:wrap;\">\r\n                          <span>{{row.ProductDescription}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                          <span>{{\r\n                            row.ProductLink\r\n                            }}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                            <span>\r\n                                <button md-icon-button mdTooltip=\"Edit Advertisement\" (click)=\"editAdvertisement(row)\">\r\n                                    <em class=\"fa fa-edit\"></em>\r\n                                </button>\r\n                            </span>\r\n                            <span>\r\n                                <button md-icon-button mdTooltip=\"Delete Advertisement\" (click)=\"deleteAdvertisement(row)\">\r\n                                    <em class=\"fa fa-trash\" ></em>\r\n                                </button>\r\n                            </span>\r\n                            <span>\r\n                                <button *ngIf=\"row.IsActive\" md-icon-button mdTooltip=\"Active Advertisement\" (click)=\"deactiveAdvertisement(row)\">\r\n                                    <em class=\"fa fa-toggle-on\" ></em>\r\n                                </button>\r\n                                <button *ngIf=\"!row.IsActive\" md-icon-button mdTooltip=\"Active Advertisement\" (click)=\"activeAdvertisement(row)\">\r\n                                    <em class=\"fa fa-toggle-off\" ></em>\r\n                                </button>\r\n                            </span>\r\n                          \r\n                        </td>\r\n                      </tr>\r\n                    </tbody>\r\n                  </table>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </section>\r\n          <div class=\"row\">&nbsp;</div>\r\n          <my-app-footer></my-app-footer>\r\n    </section>  \r\n  </section>"

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports = "\r\n\r\n<div myPreloader class=\"preloaderbar hide\"><span class=\"bar\"></span></div>\r\n<div class=\"full-height\"\r\n     [ngClass]=\"{'fixed-header'  : AppConfig.fixedHeader,\r\n                 'nav-collapsed' : AppConfig.navCollapsed,\r\n                 'nav-behind'    : AppConfig.navBehind,\r\n                 'layout-boxed'  : AppConfig.layoutBoxed,\r\n                 'theme-gray'    : AppConfig.theme == 'gray',\r\n                 'theme-dark'    : AppConfig.theme == 'dark',\r\n                 'sidebar-sm'    : AppConfig.sidebarWidth == 'small',\r\n                 'sidebar-lg'    : AppConfig.sidebarWidth == 'large'}\">\r\n    <router-outlet></router-outlet>\r\n</div>"

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid no-breadcrumbs page-dashboard\">\r\n</div>"

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-auth\">\r\n    <div class=\"main-body\">\r\n        <div class=\"card bg-color-white\">\r\n            <div class=\"card-content\">\r\n                <h3>SCAL-360 Release</h3>\r\n                <p class=\"text-medium no-margin\" *ngIf=\"StableRelease\"><strong>Current Stable Release : {{StableRelease}} </strong><a *ngIf=\"StableRelease\"\r\n                        (click)=\"viewChangeLog();\"><span style=\"color:#2196F3 !important;cursor: pointer;\">View Change\r\n                            Log</span></a></p><br />\r\n                <p class=\"text-medium\"><strong>To Download, Please follow following steps.</strong></p>\r\n                <p>Step 1: Fill Form & Submit Detail.</p>\r\n                <p>Step 2: You will receive OTP on your Email Id.</p>\r\n                <p>Step 3: Enter OTP & Submit OTP, Download will start automatically.</p>\r\n                <div class=\"callout callout-danger\" *ngIf=\"errorMessage\">\r\n                    <p> {{errorMessage}}</p>\r\n                </div>\r\n                <div class=\"callout callout-success\" *ngIf=\"successMessage\">\r\n                    {{successMessage}}\r\n                </div>\r\n                <form class=\"md-form-auth\" [formGroup]=\"validationForm\">\r\n                    <div class=\"form-group\">\r\n                        <md-input-container class=\"full-width md-icon-left\">\r\n                            <md-icon class=\"material-icons\">vpn_key</md-icon>\r\n                            <input required mdInput type=\"text\" name=\"name\" disabled=\"!IsMailSend\"\r\n                                placeholder=\"License Key\" formControlName=\"licenseKey\">\r\n                        </md-input-container>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                        <md-input-container class=\"full-width md-icon-left\">\r\n                            <md-icon class=\"material-icons\">email</md-icon>\r\n                            <input required mdInput type=\"email\" name=\"email\" placeholder=\"Email\"\r\n                                formControlName=\"email\">\r\n                        </md-input-container>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                        <md-input-container class=\"full-width md-icon-left no-margin-bottom\">\r\n                            <md-icon class=\"material-icons\">call</md-icon>\r\n                            <input mdInput type=\"text\" name=\"phoneno\" placeholder=\"Contact No\"\r\n                                formControlName=\"contactno\">\r\n                        </md-input-container>\r\n                    </div>\r\n                    <div class=\"divider divider-md\"></div>\r\n\r\n                    <button (click)=\"validateInfo()\" md-raised-button type=\"button\" color=\"primary\" class=\"float-right\"\r\n                        [disabled]=\"!validationForm.valid || submitted\">Submit</button>\r\n\r\n                </form>\r\n                <form [formGroup]=\"OTPForm\">\r\n                    <div *ngIf=\"IsMailSend\">\r\n                        <div class=\"form-group\">\r\n                            <md-input-container class=\"full-width md-icon-left no-margin-bottom\">\r\n                                <md-icon class=\"material-icons\"></md-icon>\r\n                                <input required mdInput type=\"text\" name=\"OTP\" placeholder=\"OTP\" maxlength=\"6\"\r\n                                    formControlName=\"OTP\">\r\n                            </md-input-container>\r\n                        </div>\r\n                        <div class=\"divider divider-md\"></div>\r\n                        <button md-raised-button type=\"button\" color=\"primary\" class=\"float-right\"\r\n                            (click)=\"OTPVerfication()\" [disabled]=\"!OTPForm.valid\">Submit OTP</button>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports = "<my-app-header></my-app-header>\r\n<div class=\"app-page-container\">\r\n    <div class=\"container\">\r\n        <div class=\"card-container\">\r\n            <div *ngIf=\"portalAccess==1 || portalAccess==3\" class=\"card-template\" style=\"background-color: black; color: white;\" id=\"ota-updates\" (click)=\"navigateToOTA()\">\r\n                <div>\r\n                    <p style=\"font-family: Calibri, 'Trebuchet MS', sans-serif; font-size:2.5em\">OTA Admin Portal</p>\r\n                    <div>\r\n                        <img style=\"height: 100px; width: 100px;\" src=\"../../../assets/images-demo/image-icons/OtaUpdate.png\"/>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div *ngIf=\"portalAccess==2 || portalAccess==3\" class=\"card-template\" style=\"background-color: #FFCA28 ; color: black;\" id=\"license-portal\" (click)=\"navigateToLicensePortal()\">\r\n                <div>\r\n                    <p style=\"font-family: Calibri, 'Trebuchet MS', sans-serif; font-size:2.5em\">License Portal</p>\r\n                    <div>\r\n                        <img style=\"height: 100px; width: 100px;\" src=\"../../../assets/images-demo/image-icons/licensing.png\"/>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div *ngIf=\"portalAccess==2 || portalAccess==3\" class=\"card-template\" style=\"background-color: black; color: white;\" id=\"advertisement\" (click)=\"navigateToAdvertisement()\">\r\n                <div>\r\n                    <p style=\"font-family: Calibri, 'Trebuchet MS', sans-serif; font-size:2.5em\">Advertisement</p>\r\n                    <div>\r\n                        <img style=\"height: 100px; width: 100px;\" src=\"../../../assets/images-demo/image-icons/ads.png\"/>\r\n                    </div>\r\n                </div>\r\n                \r\n            </div>\r\n            <div *ngIf=\"IsAdmin=== 'true'\" class=\"card-template bg-color-warning\" style=\" color: black;\" id=\"user-management\" (click)=\"navigateToUserManagement()\">\r\n                <div>\r\n                    <p style=\"font-family: Calibri, 'Trebuchet MS', sans-serif; font-size:2.5em\">User Management</p>\r\n                    <div>\r\n                        <img style=\"height: 100px; width: 100px;\" src=\"../../../assets/images-demo/image-icons/team.png\"/>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <my-app-footer></my-app-footer>\r\n</div>\r\n\r\n\r\n"

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <div>\r\n        <section>\r\n            <div class=\"col-12\">\r\n                <button type=\"button\" class=\"close\" (click)=\"onCancel()\">&times;</button>\r\n                <h1 md-dialog-title=\"\" class=\"mat-dialog-title\">Change Log</h1>\r\n                <div class=\"row\" *ngIf=\"changeLogData?.length == 0\" class=\"alert alert-danger\">\r\n                    No Records Found\r\n                </div>\r\n            </div>\r\n            <div class=\"col-12\"  *ngIf=\"changeLogData?.length > 0\">\r\n                <ul *ngFor=\"let row of changeLogData;let i = index\">\r\n                    <li class=\"mdl-data-table__cell--non-numeric\">\r\n                        <span>{{row}}</span>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n            <div class=\"col-12\">&nbsp;</div>\r\n        </section>\r\n    </div>\r\n</article>"

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports = "<div class=\"page-auth\">    \r\n    <div class=\"main-body\">\r\n        <div class=\"card bg-color-white\">\r\n            <div class=\"card-content\">\r\n                <div class=\"logo\" style=\"font-size: 26px;\">\r\n                    <div  style=\"text-align: center;\">\r\n                       <span>Software Management Portal</span> \r\n                    </div> \r\n                </div>\r\n                <form [formGroup]=\"validationForm\" novalidate>\r\n                    <div class=\"callout callout-danger\" *ngIf=\"errorMessage\">\r\n                        <p>{{errorMessage}}</p>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                        <md-input-container class=\"full-width md-icon-left\">\r\n                            <input required mdInput type=\"email\" name=\"userName\" placeholder=\"Email\"\r\n                                formControlName=\"userName\">\r\n                        </md-input-container>\r\n                        <div *ngIf=\"submitted && f.userName.errors\" class=\"invalid-feedback\">\r\n                            <div *ngIf=\"f.userName.errors.required\">Email is required</div>\r\n                            <div *ngIf=\"f.userName.errors.email\">Email must be a valid email address</div>\r\n                        </div>\r\n                    </div>\r\n                    <button md-raised-button type=\"submit\" color=\"primary\" (click)=\"logIn()\" class=\"float-right\"\r\n                        [disabled]=\"!validationForm.valid\">Login</button>\r\n                </form>\r\n                <div class=\"additional-info\">\r\n                    <span>Copyright © <a class=\"brand\" target=\"_blank\"\r\n                            [href]=\"AppConfig.productLink\">{{AppConfig.brand}}</a> {{AppConfig.year}}</span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports = "<div class=\"access-container\">\r\n  <h1>403 - Access Denied</h1>\r\n  <p>You are not authorized to view this page.</p>\r\n</div>"

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports = "<section class=\"sidebar-footer\">\r\n    <section class=\"app-footer\">\r\n        <div class=\"container-fluid\">\r\n          <span class=\"float-left\">\r\n            <span></span>\r\n          </span>\r\n          <span class=\"float-right\">\r\n            <span>{{this.AppConfig}}</span>\r\n          </span>\r\n        </div>\r\n      </section>\r\n  </section>\r\n"

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports = "<section class=\"app-header\">\r\n  <div\r\n    class=\"app-header-inner\"\r\n    style=\"display: flex; flex-direction: row; justify-content: space-between;\"\r\n    [ngClass]=\"{\r\n      'bg-color-light':\r\n        ['11', '12', '13', '14', '15', '16', '21'].indexOf(\r\n          AppConfig.colorOption\r\n        ) >= 0,\r\n      'bg-color-dark': AppConfig.colorOption === '31',\r\n      'bg-color-primary': ['22', '32'].indexOf(AppConfig.colorOption) >= 0,\r\n      'bg-color-success': ['23', '33'].indexOf(AppConfig.colorOption) >= 0,\r\n      'bg-color-info': ['24', '34'].indexOf(AppConfig.colorOption) >= 0,\r\n      'bg-color-warning': ['25', '35'].indexOf(AppConfig.colorOption) >= 0,\r\n      'bg-color-danger': ['26', '36'].indexOf(AppConfig.colorOption) >= 0\r\n    }\"\r\n   >\r\n   <div style=\"display: flex;align-items: center; justify-content: center; align-items: center;\" [ngClass]=\"{'SideNavOpen':isSideNavOpen}\">\r\n      <div *ngIf=\"inLicensePortal\" style=\"padding: 0%;\" >\r\n        <button\r\n          md-button\r\n          class=\"md-button header-icon toggle-sidebar-btn\"\r\n          (click)=\"onMenuClick()\"\r\n        >\r\n          <em class=\"material-icons\">menu</em>\r\n        </button>\r\n      </div>\r\n      <div *ngIf=\"!inLicensePortal\" style=\"background-color: black; height: 40px; border-radius: 4px; padding: 4px; margin: 7px;\">\r\n        <img src=\"../../../assets/images/SensitLogoYellowWhite.png\" style=\"height: 90%;\"/>\r\n      </div>\r\n      <!-- <h5 style=\"font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif\">{{ AppConfig.brand }}</h5> -->\r\n    </div>\r\n    <div class=\"top-nav-right\">\r\n      <ul class=\"list-unstyled float-right\">\r\n        <li *ngIf=\"IsAdmin\">\r\n          <button\r\n          id=\"userManagement\"\r\n            md-raised-button\r\n            type=\"submit\"\r\n            color=\"primary\"\r\n            mdTooltip=\"View & Manage All Users\"\r\n            style=\"margin: 11px 21px 0 0;\"\r\n            (click)=\"redirectuser()\"\r\n            hidden\r\n          >\r\n            <em class=\"fa fa-user\">&nbsp;&nbsp;</em> User Management\r\n          </button>\r\n        </li>\r\n        <li>\r\n          <label md-label style=\"padding-top: 20px; text-align: center;\">\r\n           {{username}}\r\n          </label>\r\n        </li>\r\n        <li>\r\n          <button md-button class=\"md-button header-btn\" (click)=\"redirectToHomePage()\">\r\n            <em class=\"material-icons\">home</em>\r\n          </button>\r\n        </li>\r\n        <li>\r\n          <button md-button class=\"md-button header-btn\" (click)=\"logOut()\">\r\n            <em class=\"material-icons\">exit_to_app</em>\r\n          </button>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n</section>\r\n"

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"app-sidebar\">\r\n    <ul class=\"nav\" myAccordionNav myAppendSubmenuIcon mySlimScroll myHighlightActiveItems>\r\n        <section>\r\n            <!-- <div class=\"col-xl-12\">&nbsp;</div> -->\r\n            <div class=\"col-xl-12 col-lg-12\">\r\n                <div style=\"display:flex; justify-content: center;\">\r\n                    <h4 style=\"color: white;\">License Portal</h4>\r\n                </div>\r\n                <div>\r\n                    <input type=\"text\" class=\"form-control col-12\" [(ngModel)]=\"licenseProductFilter.ProductName\"\r\n                        placeholder=\"Search for license module\">\r\n                </div>\r\n                <div *ngFor=\"let Product of licenseProductList | filterBy: licenseProductFilter\">\r\n                    <a [class.selectedItem]=\"checkSelected(Product)\" (click)=\"getStyle(Product)\" title=\"{{Product}}\"\r\n                        [routerLink]=\"['/license-portal',Product.ProductName,Product.ProductId]\">\r\n                        <div class=\"callout callout-info\">\r\n                            <h4 class=\"selectedItemColor\" style=\"margin-bottom: 0px\">\r\n                                {{Product.ProductName}}</h4>\r\n                        </div>\r\n                    </a>\r\n                </div>                  \r\n            </div>\r\n        </section>\r\n    </ul>\r\n</nav>\r\n"

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports = "\r\n<my-app-sidenav></my-app-sidenav>\r\n<section id=\"page-container\" class=\"app-page-container\">\r\n    <my-app-header></my-app-header>\r\n    <div class=\"app-content-wrapper\">\r\n        <div class=\"app-content\">\r\n            <div class=\"full-height\">\r\n                <router-outlet></router-outlet>\r\n            </div>\r\n        </div>\r\n        <my-app-footer></my-app-footer>\r\n    </div>\r\n</section>\r\n"

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dropdown-container\">\r\n  <div class=\"dropdown-trigger\" (click)=\"toggleDropdown()\" style=\"height: 37px;\">\r\n    {{ selected ? selected : placeholder }}\r\n  </div>\r\n\r\n  <div class=\"dropdown-panel\" *ngIf=\"dropdownOpen\">\r\n    <input type=\"text\" class=\"search-box\" placeholder=\"Search\" [(ngModel)]=\"searchText\" (click)=\"$event.stopPropagation()\" />\r\n\r\n    <div class=\"option\" *ngFor=\"let opt of filteredOptions\" (click)=\"selectOption(opt)\" [ngClass]=\"{'selected': opt === selected}\">\r\n      {{ opt }}\r\n    </div>\r\n  </div>\r\n</div>"

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"app-sidebar\">\r\n    <ul class=\"nav\" myAccordionNav myAppendSubmenuIcon mySlimScroll myHighlightActiveItems>\r\n        <section>\r\n            <div style=\"display:flex; justify-content: center;\">\r\n                    <h4 style=\"color: white;\">OTA Admin Portal</h4>\r\n            </div>\r\n            <div class=\"col-xl-12 col-lg-12\">\r\n                <div>\r\n                    <input type=\"text\" class=\"form-control col-12\" [(ngModel)]=\"ProductFilter.ProductName\"\r\n                            placeholder=\"Search Product Release\">\r\n                </div>\r\n                <div *ngFor=\"let Product of productList | filterBy: ProductFilter\">\r\n                    <a [class.selectedItem]=\"checkSelected(Product)\" (click)=\"getStyle(Product)\" title=\"{{Product.ProductName}}\"\r\n                        *ngIf=\"Product.SubCount > 0\"\r\n                        [routerLink]=\"['/app/pglayout/product-release-tab', Product.ProductName, Product.ProductId, Product.Code,Product.Variant,0]\">\r\n                        <div class=\"callout callout-info\">\r\n                            <h4 class=\"selectedItemColor\" style=\"margin-bottom: 0px\">\r\n                                {{Product.ProductName}}</h4>\r\n                        </div>\r\n                    </a>\r\n                        <!-- For Tab View -->\r\n                    <a [class.selectedItem]=\"checkSelected(Product)\"  (click)=\"getStyle(Product)\" title=\"{{Product.ProductName}}\"\r\n                        *ngIf=\"Product.SubCount == 0\"\r\n                        [routerLink]=\"['/app/pglayout/product-release', Product.ProductName, Product.ProductId, Product.Code]\">\r\n                        <div class=\"callout callout-info\">\r\n                            <h4 class=\"selectedItemColor\" style=\"margin-bottom: 0px\">\r\n                                {{Product.ProductName}}</h4>\r\n                        </div>\r\n                     </a>\r\n                </div>                  \r\n            </div>\r\n        </section>\r\n    </ul>\r\n</nav>\r\n<!-- <section class=\"sidebar-footer\" *ngIf=\"this.IsAdmin\">\r\n    <ul class=\"nav\">\r\n        <li [class.selectedItem]=\"'UserManagement'== selectedTitle\">\r\n            <a  (click)=\"getStyle('UserManagement')\"\r\n                aria-label=\"menu\" style=\"color:white !important;\"  [routerLink]=\"['/app/pglayout/user']\">\r\n                <span>\r\n                    <em class=\"fa fa-user\">&nbsp;&nbsp;</em>\r\n                    <span class=\"nav-text\"><span>User Management</span></span>\r\n                </span>\r\n            </a>\r\n        </li>\r\n    </ul>\r\n</section> -->\r\n\r\n"

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"app-sidebar\" myAutoCloseMobileNav\r\n     [ngClass]=\"{'bg-color-light': ['31','32','33','34','35','36'].indexOf(AppConfig.colorOption) >= 0,\r\n                 'bg-color-dark': ['31','32','33','34','35','36'].indexOf(AppConfig.colorOption) < 0 }\">\r\n\r\n    <section class=\"sidebar-header\"\r\n             [ngClass]=\"{'bg-color-dark': ['11','31'].indexOf(AppConfig.colorOption) >= 0,\r\n                         'bg-color-light': AppConfig.colorOption === '21',\r\n                         'bg-color-primary': ['12','22','32'].indexOf(AppConfig.colorOption) >= 0,\r\n                         'bg-color-success': ['13','23','33'].indexOf(AppConfig.colorOption) >= 0,\r\n                         'bg-color-info': ['14','24','34'].indexOf(AppConfig.colorOption) >= 0,\r\n                         'bg-color-warning': ['15','25','35'].indexOf(AppConfig.colorOption) >= 0,\r\n                         'bg-color-danger': ['16','26','36'].indexOf(AppConfig.colorOption) >= 0}\">\r\n     \r\n        <a  class=\"brand\">{{AppConfig.brand}}</a>        \r\n    </section>\r\n    <section class=\"sidebar-content\">\r\n        <my-app-sidenav-menu></my-app-sidenav-menu>\r\n    </section> \r\n</nav>\r\n"

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sort-dropdown\">\r\n  <button class=\"sort-toggle\" (click)=\"toggleDropdown()\">\r\n    <em class=\"fa fa-chevron-down\"></em>\r\n  </button>\r\n\r\n  <div class=\"dropdown-menu\" *ngIf=\"isOpen\">\r\n    <button (click)=\"selectOrder('asc')\"><em class=\"fa fa-sort-up\"></em> Ascending</button>\r\n    <button (click)=\"selectOrder('desc')\"><em class=\"fa fa-sort-down\"></em> Descending</button>\r\n    <button (click)=\"selectOrder('reset')\"><em class=\"fa fa-undo\"></em> Reset</button>\r\n  </div>\r\n</div>"

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div class=\"col-12\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">\r\n        <form [formGroup]=\"FAQForm\">\r\n            <div class=\"form-group row\">\r\n                <div class=\"col-md-4\">\r\n                    <label  class=\"control-label\">Question</label><span style=\"color: red;\">*</span>\r\n                </div>\r\n                <input type=\"text\" class=\"col-md-8 form-control\" formControlName=\"Question\"/>\r\n            </div>\r\n            <div *ngIf=\"isGenerateKeyButtonClicked &amp;&amp; FAQForm.controls.Question.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"FAQForm.controls.Question.errors.required\" style=\"padding: 0%;\" class=\"col-md-8\">\r\n                        <span style=\"color:red;\">Question is required.</span>\r\n                    </div>                 \r\n            </div>\r\n            <div class=\"row form-group\">\r\n                <div class=\"col-md-4\">\r\n                    <label class=\"control-label\">Answer</label><span style=\"color: red;\">*</span>\r\n                </div>\r\n                <textarea class=\"col-md-8 form-control\" formControlName=\"Answer\"></textarea>\r\n            \r\n            </div>\r\n            <div *ngIf=\"isGenerateKeyButtonClicked &amp;&amp; FAQForm.controls.Answer.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"FAQForm.controls.Answer.errors.required\" style=\"padding: 0%;\" class=\"col-md-8\">\r\n                        <span style=\"color:red;\">Answer is required.</span>\r\n                    </div>                 \r\n            </div>\r\n            <div class=\"row form-group\">\r\n                <div class=\"col-md-3\">\r\n                    <button [disabled]=\"!FAQForm.valid || FAQForm.pristine\" md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"onSave()\">Save</button>\r\n                </div>\r\n                <div class=\"col-md-3\">\r\n                    <button md-raised-button (click)=\"onCancel()\">Cancel</button>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>"

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div class=\"container-fluid\">\r\n        <div class=\"col-12\">&nbsp; </div>\r\n        <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n            <div class=\"alert alert-danger\">\r\n                {{errorMessage}}\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">\r\n            <div class=\"row\">\r\n                <!-- <div class=\"col-md-8\">\r\n                </div> -->\r\n                <button md-raised-button style=\"background-color:  #FFCA28 ; margin: 1px;\" (click)=\"addFaq()\">\r\n                    Add FAQ\r\n                </button>\r\n                <button md-raised-button style=\"background-color:  #FFCA28 ; margin: 1px;\" (click)=\"downloadCsv()\">\r\n                    Download Sample File\r\n                </button>\r\n                <button md-raised-button style=\"background-color:  #FFCA28 ; margin: 1px\" (click)=\"importFaq()\">\r\n                    Import FAQ\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <div class=\"row\">&nbsp;</div>\r\n        <div class=\"row\" *ngIf=\"pagedItems?.length > 0\">\r\n            <div class=\"col-12\">\r\n              <div class=\"table-responsive\">\r\n                <table class=\"mdl-data-table table-striped col-12\">\r\n                  <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Question</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Answer</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                    <tr *ngFor=\"let row of pagedItems;let i=index;\">\r\n                      <td style=\"text-wrap: wrap;\" class=\"mdl-data-table__cell--non-numeric\">\r\n                        <span>\r\n                          {{row.Question}}\r\n                        </span>\r\n                      </td>\r\n                      <td style=\"text-wrap: wrap;\" class=\"mdl-data-table__cell--non-numeric\">\r\n                        <span>{{row.Answer}}</span>\r\n                      </td>\r\n                      <td class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                        <button md-icon-button mdTooltip=\"Edit FAQ\" (click)=\"editFaq(row)\"><em class=\"fa fa-edit\"></em></button>\r\n                        <button md-icon-button mdTooltip=\"Delete FAQ\" (click)=\"deleteFaq(row)\"><em class=\"fa fa-trash\"></em></button>\r\n                      </td>\r\n                    </tr>\r\n                  </tbody>\r\n                </table>\r\n                <ul *ngIf=\"pager.pages && pager.pages.length\" class=\"pagination\"\r\n              style=\"float: right !important;\">\r\n                  <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                      <a (click)=\"setPage(1)\">First</a>\r\n                  </li>\r\n                  <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                      <a (click)=\"setPage(pager.currentPage - 1)\">Previous</a>\r\n                  </li>\r\n                  <li *ngFor=\"let page of pager.pages\" [ngClass]=\"{active:pager.currentPage === page}\"\r\n                      style=\"cursor:pointer;\">\r\n                      <a (click)=\"setPage(page)\">{{page}}</a>\r\n                  </li>\r\n                  <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                      style=\"cursor:pointer;\">\r\n                      <a (click)=\"setPage(pager.currentPage + 1)\">Next</a>\r\n                  </li>\r\n                  <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                      style=\"cursor:pointer;\">\r\n                      <a (click)=\"setPage(pager.totalPages)\">Last</a>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n            </div>\r\n          </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div style=\"display: flex; flex-direction: row; justify-content: space-between; align-items: center;\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        <div>\r\n            <button style=\"background: none; border: none;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div  *ngIf=\"errorMessage!=''\" class=\"col-12\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">\r\n        <button md-raised-button style=\"background-color:  #FFCA28 ; margin-bottom: 1%\" (click)=\"importFaq()\">\r\n            Select File\r\n        </button>\r\n        <span>{{uploadResponse}}</span>\r\n        <input hidden id=\"inputFaqFile\" class=\"form-control\" (change)=\"onChange($event)\" type=\"file\"/>\r\n    </div>\r\n    <div class=\"col-12\">\r\n        &nbsp;\r\n    </div>\r\n    <div class=\"col-12\">\r\n        <span style=\"font-style: italic; color: grey;\">Note : File size should not be greater than 1 MB & only CSV file is allowed.</span>\r\n    </div>\r\n    <div *ngIf=\"importedFaqData?.length>0\" class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n                <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Question</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Answer</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                    <tr *ngFor=\"let row of importedFaqData; let i=index\"> \r\n                        <td style=\"text-wrap: wrap;\" class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span [ngClass]=\"{'duplicate-row': row.FAQId!=0}\">{{row.Question}}</span>\r\n                        </td>\r\n                        <td style=\"text-wrap: wrap;\" class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span [ngClass]=\"{'duplicate-row': row.FAQId!=0}\">{{row.Answer}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                            <button md-icon-button mdTooltip=\"Delete FAQ\" (click)=\"deleteFAQ(i)\"><em class=\"fa fa-trash\"></em></button>\r\n                        </td>  \r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">\r\n        &nbsp;\r\n    </div>\r\n    <div *ngIf=\"importedFaqData?.length==0\" class=\"col-12\">\r\n        <span class=\"file-preview\">\r\n            File Preview\r\n        </span>\r\n    </div>\r\n    <div class=\"col-12\">\r\n        &nbsp;\r\n    </div>\r\n    <div class=\"col-12\">\r\n            <button md-raised-button style=\"background-color:  #FFCA28 ;\"\r\n                [disabled]=\"saveButtonDisabled\"\r\n                (click)=\"onSave()\">Save</button>                        \r\n            <span class=\"space\"></span>\r\n            <button md-raised-button [disabled]=\"CancelButtonDisabled\"\r\n                (click)=\"onCancel()\">Cancel</button>\r\n    </div>\r\n</div>"

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div class=\"col-12\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">\r\n        <form [formGroup]=\"gltGenerateKeyForm\">\r\n            <div class=\"form-group row\">\r\n                <div class=\"col-md-4\">\r\n                    <label  class=\"control-label\">Unique H/W ID</label><span style=\"color: red;\">*</span>\r\n                </div>\r\n                <input type=\"text\" class=\"col-md-8 form-control\" formControlName=\"UniqueHardwareId\" (change)=\"isLicensekeyGenerated=false\"/>\r\n            </div>\r\n            <div *ngIf=\"isGenerateKeyButtonClicked &amp;&amp; gltGenerateKeyForm.controls.UniqueHardwareId.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"gltGenerateKeyForm.controls.UniqueHardwareId.errors.required\" style=\"padding: 0%;\" class=\"col-md-8\">\r\n                        <span style=\"color:red;\">Unique Hardware Id is required.</span>\r\n                    </div>                 \r\n            </div>\r\n            <div class=\"row form-group\">\r\n                <div class=\"col-md-4\">\r\n                    <label class=\"control-label\">Tablet Serial</label><span style=\"color: red;\">*</span>\r\n                </div>\r\n                <input type=\"text\" class=\"col-md-8 form-control\" formControlName=\"TabletSerial\" (change)=\"isLicensekeyGenerated=false\"/>\r\n            \r\n            </div>\r\n            <div *ngIf=\"isGenerateKeyButtonClicked &amp;&amp; gltGenerateKeyForm.controls.TabletSerial.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"gltGenerateKeyForm.controls.TabletSerial.errors.required\" style=\"padding: 0%;\" class=\"col-md-8\">\r\n                        <span style=\"color:red;\">Table Serial is required.</span>\r\n                    </div>                 \r\n            </div>\r\n            <div class=\"row form-group\">\r\n                <label class=\"col-md-4 control-label\">SUA(# Years)</label>\r\n                <select class=\"col-md-8 form-control\" formControlName=\"NoOfYearsActivated\">\r\n                    <option *ngFor=\"let year of activatedYearsArray\" [ngValue]=\"year\">{{year}}\r\n                    </option>\r\n                </select>\r\n            </div>\r\n            <div class=\"row form-group\">\r\n                <div class=\"col-md-4\">\r\n                    <label class=\"control-label\">Sales Order No</label><span style=\"color: red;\">*</span>\r\n                </div>\r\n                <input type=\"text\" class=\"col-md-8 form-control\" (blur)=\"checkSalesOrderNo()\" formControlName=\"SalesOrderNo\" (change)=\"isBillingShippingDetailFetched=false\"/>\r\n            </div>\r\n            <div *ngIf=\"isGenerateKeyButtonClicked &amp;&amp; gltGenerateKeyForm.controls.SalesOrderNo.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"gltGenerateKeyForm.controls.SalesOrderNo.errors.required\" style=\"padding: 0%;\" class=\"col-md-8\">\r\n                        <span style=\"color:red;\">Sales Order No is required.</span>\r\n                    </div>                 \r\n            </div>\r\n            <div class=\"row form-group\">\r\n                <div class=\"col-md-4\">\r\n                    <button md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"fetchSalesOrderDetailAndGenerateKey()\">Generate Key</button>\r\n                </div>\r\n                <div class=\"col-md-8 form-control\">\r\n                    {{licenseKey}}\r\n                </div>\r\n            </div>\r\n            <div class=\"row form-group\">\r\n                <div class=\"col-md-12\">\r\n                    <span style=\"font-style:italic; color: gray;\">\r\n                        Note: Please click Generate Key button to fetch billing and shipping details and to generate a license key. If you have changed Sales Order Number, Unique H/W Id, or Tablet Serial Number, please click the Generate key button again.\r\n                    </span>\r\n                </div>\r\n            </div>\r\n            <div *ngIf=\"isBillingShippingDetailFetched\" class=\"form-group row\">\r\n                <div class=\"col-md-6\">\r\n                    <span>Billing Address</span>\r\n                    <hr color=\"#FFCA28\"/>\r\n                    <div>\r\n                        <span style=\"font-weight: bold;\">{{this.billingShippingDetail.BillToName}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.BillToAddress1}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.BillToAddress2}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.BillToCity}}</span>\r\n                        <span>{{billingShippingDetail.BillToState}}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <span>Shipping Address</span>\r\n                    <hr color=\"#FFCA28\"/>\r\n                    <div>\r\n                        <span style=\"font-weight: bold;\">{{billingShippingDetail.ShipToName}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.ShipToAddress1}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.ShipToAddress2}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.ShipToCity}}</span>\r\n                        <span>{{billingShippingDetail.ShipToState}}</span>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"row form-group\">\r\n                <div class=\"col-md-2\">\r\n                    <button [disabled]=\"!gltGenerateKeyForm.valid || gltGenerateKeyForm.pristine\" md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"onSave()\">Save</button>\r\n                </div>\r\n                <div  class=\"col-md-2\">\r\n                    <button md-raised-button (click)=\"onCancel()\">Cancel</button>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>"

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports = "<section>\r\n    <div class=\"container-fluid\">\r\n        <h3 class=\"title\">GLT License</h3>\r\n    </div>\r\n    <div class=\"container-fluid\">\r\n        <hr/>\r\n        <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n            <div style=\"margin: 1%;\">\r\n                <button *ngIf=\"IsAddEdit\" md-raised-button style=\"background-color: #FFCA28 ; margin-bottom: 1%;\" (click)=\"openGenerateKeyDialog()\">Generate Key</button>\r\n            </div>\r\n            <div style=\"margin: 1%;\">\r\n                <button md-raised-button style=\"background-color: #FFCA28 ;\" class=\"iconsize\" mdTooltip=\"Export to CSV\" (click)=\"exportToCSV()\">\r\n                    <em class=\"fa fa-download\"></em>\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <div *ngIf=\"pagedItems?.length>0\" class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n                <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Customer\r\n                      <button *ngIf=\"currentSortColumn==='CustomerName' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                      </button>\r\n                      <button *ngIf=\"currentSortColumn==='CustomerName' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                      </button>\r\n                      <sort-dropdown\r\n                          columnName=\"CustomerName\"\r\n                          (sortChange)=\"onSortChange($event)\">\r\n                      </sort-dropdown>\r\n                    </th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Tablet Serial No</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Unique H/W Id\r\n                      <button *ngIf=\"currentSortColumn==='CustomerUniqueKey' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                      </button>\r\n                      <button *ngIf=\"currentSortColumn==='CustomerUniqueKey' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                      </button>\r\n                      <sort-dropdown\r\n                          columnName=\"CustomerUniqueKey\"\r\n                          (sortChange)=\"onSortChange($event)\">\r\n                      </sort-dropdown>\r\n                    </th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">License key\r\n                      <button *ngIf=\"currentSortColumn==='LicenseKey' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                      </button>\r\n                      <button *ngIf=\"currentSortColumn==='LicenseKey' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                      </button>\r\n                        <sort-dropdown\r\n                            columnName=\"LicenseKey\"\r\n                            (sortChange)=\"onSortChange($event)\">\r\n                        </sort-dropdown>\r\n                    </th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">SUA Expiration Date</th>\r\n                    <th *ngIf=\"IsAddEdit\" class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                    <tr *ngFor=\"let row of pagedItems\">\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">{{row.CustomerName}}</td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">{{row.TabletSerialNo}}</td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">{{row.CustomerUniqueKey}}</td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">{{row.LicenseKey}}</td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">{{row.SUAExpirationDate | date :'dd MMM yyyy'}}</td>\r\n                        <td *ngIf=\"IsAddEdit\" class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                            <button  md-icon-button mdTooltip=\"Edit License\" (click)=\"onEdit(row)\">\r\n                                <em class=\"fa fa-edit\"></em>\r\n                            </button>\r\n                        </td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n            <ul *ngIf=\"pager.pages && pager.pages.length\" class=\"pagination\"\r\n                style=\"float: right !important;\">\r\n                <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                    <a (click)=\"setPage(1)\">First</a>\r\n                </li>\r\n                <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                    <a (click)=\"setPage(pager.currentPage - 1)\">Previous</a>\r\n                </li>\r\n                <li *ngFor=\"let page of pager.pages\" [ngClass]=\"{active:pager.currentPage === page}\"\r\n                    style=\"cursor:pointer;\">\r\n                    <a (click)=\"setPage(page)\">{{page}}</a>\r\n                </li>\r\n                <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                    style=\"cursor:pointer;\">\r\n                    <a (click)=\"setPage(pager.currentPage + 1)\">Next</a>\r\n                </li>\r\n                <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                    style=\"cursor:pointer;\">\r\n                    <a (click)=\"setPage(pager.totalPages)\">Last</a>\r\n                </li>\r\n            </ul>\r\n        </div>\r\n    </div>\r\n</section>"

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports = "\r\n<license-nav-bar [ngClass]=\"{disabled:isVisible===false}\"></license-nav-bar>\r\n<section id=\"page-container\" class=\"app-page-container\">\r\n    <my-app-header [inLicensePortal]=\"true\" [isSideNavOpen]=\"isVisible\" (menuToggle)=\"toggleSideNav()\"></my-app-header>\r\n    <div [ngClass]=\"{wraper:isVisible}\" style=\"margin-top: 70px;\">\r\n        <div class=\"app-content\">\r\n            <div class=\"full-height\">\r\n                <router-outlet></router-outlet>\r\n            </div>\r\n        </div>\r\n        <my-app-footer></my-app-footer>\r\n    </div>\r\n</section>\r\n"

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <section>\r\n        <div class=\"col-12\">\r\n            <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        </div>\r\n        <div class=\"col-12\">&nbsp; </div>\r\n        <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n            <div class=\"alert alert-danger\">\r\n                {{errorMessage}}\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">\r\n            <form [formGroup]=\"lz30LicenseForm\">\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Purchase Date</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"PurchaseDate\" type=\"date\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; lz30LicenseForm.controls.PurchaseDate.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"lz30LicenseForm.controls.PurchaseDate.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Purchase Date field is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Support Service Agreement Validity(in Months)</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"NoOfMonths\" type=\"number\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; lz30LicenseForm.controls.NoOfMonths.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"lz30LicenseForm.controls.NoOfMonths.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">Support Service Agreement Validity is required.</span>\r\n                    </div>                 \r\n                </div> \r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Sales Order No</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"SalesOrderNo\" (blur)=\"blurSalesOrderEvent()\" type=\"text\"/>\r\n                        </div>\r\n                    <div class=\"col-md-4\">\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ; height: 30px; text-align: center;\" (click)=\"checkSalesOrderNo()\">Fetch Customer</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\" *ngIf=\"error!=''\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">{{error}}</span>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; lz30LicenseForm.controls.SalesOrderNo.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"lz30LicenseForm.controls.SalesOrderNo.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> SalesOrderNo is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div *ngIf=\"isBillingShippingDetailFetched\" class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <span>Billing Address</span>\r\n                        <hr color=\"#FFCA28\"/>\r\n                        <div>\r\n                            <span style=\"font-weight: bold;\">{{this.billingShippingDetail.BillToName}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToAddress1}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToAddress2}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToCity}}</span>\r\n                            <span>{{billingShippingDetail.BillToState}}</span>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <span>Shipping Address</span>\r\n                        <hr color=\"#FFCA28\"/>\r\n                        <div>\r\n                            <span style=\"font-weight: bold;\">{{billingShippingDetail.ShipToName}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToAddress1}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToAddress2}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToCity}}</span>\r\n                            <span>{{billingShippingDetail.ShipToState}}</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group table-responsive\">\r\n                    <table class=\"mdl-data-table table-striped col-12\" formArrayName=\"Devices\">\r\n                        <tbody>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Serial No</th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Start Date</th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                            <tr [formGroupName]=\"i\" *ngFor=\"let device of devices.controls;  let i=index\">\r\n                                <td  class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <select *ngIf=\"i===rowClicked+1\" class=\"form-control\" formControlName=\"SerialNo\">\r\n                                        <option value=\"\" disabled selected>\r\n                                            Select SerialNo\r\n                                        </option>\r\n                                        <option *ngFor=\"let selectedDevice of userDeviceDisplayData\"  [ngValue]=\"selectedDevice\">\r\n                                            {{selectedDevice.DeviceSerialNo}}\r\n                                        <option>\r\n                                    </select>\r\n                                    <!-- <span *ngIf=\"isAddButtonClicked && device.get('SerialNo')?.value==null && !(i > rowClicked)\" style=\"color:red;font-weight: bold;\">Serial No cannot be empty.</span> -->\r\n                                    <span *ngIf=\"!(i > rowClicked)\">{{device.value.SerialNo.DeviceSerialNo}}</span>\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <input *ngIf=\"i===rowClicked+1\" class=\"form-control\" type=\"date\" formControlName=\"StartDate\"/>\r\n                                    <!-- <span *ngIf=\" isAddButtonClicked && device.get('StartDate')?.value=='' && !(i > rowClicked)\" style=\"color:red;font-weight: bold;\">Start Date cannot be empty.</span> -->\r\n                                    <span *ngIf=\"!(i > rowClicked)\">{{device.value.StartDate}}</span>\r\n                                </td>\r\n                                <td>\r\n                                    <button  *ngIf=\"i===rowClicked+1\" md-icon-button (click)=\"addDevice(i)\"><em class=\"fa fa-plus-circle\"></em></button>\r\n                                    <button  *ngIf=\"!(i > rowClicked)\" md-icon-button (click)=\"removeDevice(i)\"><em class=\"fa fa-trash\"></em></button>\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-12\"> <!--1. Form valid or not validationForm.valid used 2. Form has any changes for that validationForm.pristine used 3.some situation save button disabled and Enabled that's why we use SaveButtonDisbaled) -->\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ;\"\r\n                            [disabled]=\"!lz30LicenseForm.valid || lz30LicenseForm.pristine\"\r\n                            (click)=\"onSave()\">Save</button>                        \r\n                        <span class=\"space\"></span>\r\n                        <button md-raised-button [disabled]=\"CancelButtonDisabled\"\r\n                            (click)=\"onCancel()\">Cancel</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </section>\r\n</article>\r\n\r\n\r\n"

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div class=\"col-12\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">\r\n        <form [formGroup]=\"lz30AddDeviceForm\">\r\n            <div class=\"form-group row\">\r\n                <div class=\"col-md-4\">\r\n                    <label  class=\"control-label\">MAC Address</label><span style=\"color: red;\">*</span>\r\n                </div>\r\n                <input type=\"text\" class=\"col-md-8 form-control\" formControlName=\"MACAddress\" pattern=\"^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$\"/>\r\n            </div>\r\n            <div *ngIf=\"isGenerateKeyButtonClicked &amp;&amp; lz30AddDeviceForm.controls.MACAddress.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"lz30AddDeviceForm.controls.MACAddress.errors.required\" style=\"padding: 0%;\" class=\"col-md-8\">\r\n                        <span style=\"color:red;\">Unique Hardware Id is required.</span>\r\n                    </div>                 \r\n            </div>\r\n            <div class=\"row form-group\">\r\n                <div class=\"col-md-4\">\r\n                    <label class=\"control-label\">Device Serial No</label><span style=\"color: red;\">*</span>\r\n                </div>\r\n                <input type=\"number\" class=\"col-md-8 form-control\" formControlName=\"DeviceSerialNo\"/>\r\n            \r\n            </div>\r\n            <div *ngIf=\"isGenerateKeyButtonClicked &amp;&amp; lz30AddDeviceForm.controls.DeviceSerialNo.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"lz30AddDeviceForm.controls.DeviceSerialNo.errors.required\" style=\"padding: 0%;\" class=\"col-md-8\">\r\n                        <span style=\"color:red;\">Device Serial No is required.</span>\r\n                    </div>                 \r\n            </div>\r\n            <div class=\"row form-group\">\r\n                <div class=\"col-md-2\">\r\n                    <button [disabled]=\"!lz30AddDeviceForm.valid || lz30AddDeviceForm.pristine\" md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"onSave()\">Save</button>\r\n                </div>\r\n                <div  class=\"col-md-2\">\r\n                    <button md-raised-button (click)=\"onCancel()\">Cancel</button>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>"

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div class=\"col-12\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">\r\n        <form [formGroup]=\"LZ30ExtendTrialPeriodForm\">\r\n            <div class=\"form-group row\">\r\n                <div class=\"col-md-4\">\r\n                    <label class=\"control-label\">Trial Month</label><span style=\"color: red;\">*</span>\r\n                </div>\r\n                <select class=\"col-md-8 form-control\" formControlName=\"TrialMonth\">\r\n                    <option [ngValue]=\"1\">\r\n                        1 Month\r\n                    </option>\r\n                    <option [ngValue]=\"2\">\r\n                        2 Month\r\n                    </option>\r\n                    <option [ngValue]=\"3\">\r\n                        3 Month\r\n                    </option>\r\n                </select>\r\n            </div>\r\n            <div *ngIf=\"isGenerateKeyButtonClicked &amp;&amp; LZ30ExtendTrialPeriodForm.controls.TrialMonth.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"LZ30ExtendTrialPeriodForm.controls.TrialMonth.errors.required\" style=\"padding: 0%;\" class=\"col-md-8\">\r\n                        <span style=\"color:red;\">Trial Month is required.</span>\r\n                    </div>                 \r\n            </div>\r\n            <div class=\"row form-group\">\r\n                <div class=\"col-md-4\">\r\n                    <label class=\"control-label\">Date</label><span style=\"color: red;\">*</span>\r\n                </div>\r\n                <input type=\"date\" class=\"col-md-8 form-control\" formControlName=\"Date\"/>\r\n            \r\n            </div>\r\n            <div *ngIf=\"isGenerateKeyButtonClicked &amp;&amp; LZ30ExtendTrialPeriodForm.controls.Date.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"LZ30ExtendTrialPeriodForm.controls.Date.errors.required\" style=\"padding: 0%;\" class=\"col-md-8\">\r\n                        <span style=\"color:red;\">Date is required.</span>\r\n                    </div>                 \r\n            </div>\r\n            <div class=\"row form-group\">\r\n                <div class=\"col-md-2\">\r\n                    <button [disabled]=\"!LZ30ExtendTrialPeriodForm.valid || LZ30ExtendTrialPeriodForm.pristine\" md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"onSave()\">Save</button>\r\n                </div>\r\n                <div  class=\"col-md-2\">\r\n                    <button md-raised-button (click)=\"onCancel()\">Cancel</button>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>"

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid\">\r\n    <div>\r\n        <h3 class=\"title\">{{title}}</h3>\r\n    </div>\r\n    <md-tab-group>\r\n        <md-tab label=\"Device Info\">\r\n            <div class=\"md-tab-content\" style=\"border:1px solid #ddd;\">\r\n                <div class=\"container-fluid\">\r\n                    <div class=\"row\"> \r\n                        <div class=\"col-md-2\" style=\"margin-bottom: 1%;\">\r\n                          <h6>Name</h6>\r\n                          <input class=\"form-control\" type=\"text\" placeholder=\"Search Name\" [(ngModel)]=\"searchName\"/>\r\n                        </div>\r\n                        <div class=\"col-md-2\" style=\"margin-bottom: 1%;\">\r\n                          <h6>Email Id</h6>\r\n                          <input class=\"form-control\" type=\"text\" placeholder=\"Search Email Id\" [(ngModel)]=\"searchEmailId\"/>\r\n                        </div>\r\n                        <div class=\"col-md-2\" style=\"margin-bottom: 1%;\">\r\n                          <h6>Mobile</h6>\r\n                          <input class=\"form-control\" type=\"text\" placeholder=\"Search Mobile\" [(ngModel)]=\"searchMobileNo\"/>\r\n                        </div>\r\n                        <div class=\"col-md-2\" style=\"margin-bottom: 1%;\">\r\n                            <h6>Serial No</h6>\r\n                            <input class=\"form-control\" type=\"number\" placeholder=\"Search Serial No\" [(ngModel)]=\"searchSerialNoInDeviceTab\"/>\r\n                        </div>\r\n                    </div>\r\n                    <div div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n                        <div style=\"display: flex; flex-direction: row; margin-bottom: 1%;\">\r\n                            <div style=\"margin: 2%;\">\r\n                                <button md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"searchDeviceInfo()\">Search</button>\r\n                            </div>\r\n                            <div style=\"margin: 2%;\">\r\n                                <button md-raised-button (click)=\"clearDeviceInfo()\">Clear</button>\r\n                            </div>\r\n                        </div>\r\n                        <div style=\"display: flex; flex-direction: row; margin-bottom: 1%;\">\r\n                            <div style=\"margin: 1%;\">\r\n                                <button *ngIf=\"IsAddEdit\" md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"addDevice()\">Add Device</button>\r\n                            </div>\r\n                            <div style=\"margin: 1%;\">\r\n                                <button md-raised-button mdTooltip=\"Export to CSV\" style=\"background-color: #FFCA28 ; \" class=\"iconsize\" (click)=\"exportDeviceInfo()\">\r\n                                  <em class=\"fa fa-download\"></em>\r\n                                </button>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div\r\n                        class=\"row\"\r\n                        *ngIf=\"demoPageItems?.length == 0\"\r\n                        class=\"alert alert-danger\"\r\n                    >\r\n                        <div class=\"col-12\">{{errorMessageDemoPage}}</div>\r\n                    </div>\r\n                    <div *ngIf=\"demoPageItems?.length > 0\" class=\"table-responsive\">\r\n                        <table class=\"mdl-data-table table-striped col-12\">\r\n                            <tbody>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Name\r\n                                    <button *ngIf=\"deviceCurrentSortColumn==='Name' && deviceCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                    </button>\r\n                                    <button *ngIf=\"deviceCurrentSortColumn==='Name' && deviceCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                    </button>\r\n                                    <sort-dropdown\r\n                                        columnName=\"Name\"\r\n                                        (sortChange)=\"onDeviceSortChange($event)\">\r\n                                    </sort-dropdown>\r\n                                </th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Email Id\r\n                                    <button *ngIf=\"deviceCurrentSortColumn==='EmailId' && deviceCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                    </button>\r\n                                    <button *ngIf=\"deviceCurrentSortColumn==='EmailId' && deviceCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                    </button>\r\n                                    <sort-dropdown\r\n                                        columnName=\"EmailId\"\r\n                                        (sortChange)=\"onDeviceSortChange($event)\">\r\n                                    </sort-dropdown>\r\n                                </th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Mobile No</th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Mac Address\r\n                                    <button *ngIf=\"deviceCurrentSortColumn==='MACAddress' && deviceCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                    </button>\r\n                                    <button *ngIf=\"deviceCurrentSortColumn==='MACAddress' && deviceCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                    </button>\r\n                                    <sort-dropdown\r\n                                        columnName=\"MACAddress\"\r\n                                        (sortChange)=\"onDeviceSortChange($event)\">\r\n                                    </sort-dropdown>\r\n                                </th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Serial No</th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Start Date</th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">End Date</th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">License Type\r\n                                    <button *ngIf=\"deviceCurrentSortColumn==='LicenseType' && deviceCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                    </button>\r\n                                    <button *ngIf=\"deviceCurrentSortColumn==='LicenseType' && deviceCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                    </button>\r\n                                    <sort-dropdown\r\n                                        columnName=\"LicenseType\"\r\n                                        (sortChange)=\"onDeviceSortChange($event)\">\r\n                                    </sort-dropdown>\r\n                                </th> \r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Feedback Date</th> \r\n                                <th *ngIf=\"IsAddEdit\" class=\"mdl-data-table__cell--non-numeric\">Action</th> \r\n                                <tr *ngFor=\"let info of demoPageItems | Lz30DeviceInfoFilterPipe:filterName : filterEmailId : filterMobileNo : filterSerialNoInDeviceTab\">\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.Name}}</span>                             \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.EmailId}}</span>                                \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.Mobile}}</span>                                 \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.MACAddress}}</span>\r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.DeviceSerialNo}}</span>                                   \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.StartDate | date:'dd MMM yyyy'}}</span>                                    \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.EndDate | date:'dd MMM yyyy'}}</span>                                  \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.LicenseType}}</span>                                   \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.FeedbackDate | date:'dd MMM yyyy'}}</span>                               \r\n                                    </td>\r\n                                    <td *ngIf=\"IsAddEdit\" class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                                        <button md-icon-button (click)=\"onEdit(info)\" mdTooltip=\"Edit Device Info\">\r\n                                            <em class=\"fa fa-edit\"></em>\r\n                                        </button>\r\n                                        <button md-icon-button *ngIf=\"info.LZ30UserDetailId!=0\" (click)=\"viewDeviceHistory(info)\" mdTooltip=\"View Device History\">\r\n                                            <em class=\"fa fa-history\"></em>\r\n                                        </button>\r\n                                        <button md-icon-button *ngIf=\"info.LicenseType=='Trial'\" (click)=\"extendLZ30TrialPeriod(info)\" mdTooltip=\"Extend Trial Period\">\r\n                                            <em class=\"fa fa-clock-o\"></em>\r\n                                        </button>\r\n                                    </td>\r\n                                </tr>\r\n                            </tbody>\r\n                        </table>\r\n                        <ul *ngIf=\"demoPager.pages && demoPager.pages.length\" class=\"pagination\"\r\n                        style=\"float: right !important;\">\r\n                            <li [ngClass]=\"{disabled:demoPager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                                <a (click)=\"setPageForDemo(1)\">First</a>\r\n                            </li>\r\n                            <li [ngClass]=\"{disabled:demoPager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                                <a (click)=\"setPageForDemo(demoPager.currentPage - 1)\">Previous</a>\r\n                            </li>\r\n                            <li *ngFor=\"let page of demoPager.pages\" [ngClass]=\"{active:demoPager.currentPage === page}\"\r\n                                style=\"cursor:pointer;\">\r\n                                <a (click)=\"setPageForDemo(page)\">{{page}}</a>\r\n                            </li>\r\n                            <li [ngClass]=\"{disabled:demoPager.currentPage === demoPager.totalPages}\"\r\n                                style=\"cursor:pointer;\">\r\n                                <a (click)=\"setPageForDemo(demoPager.currentPage + 1)\">Next</a>\r\n                            </li>\r\n                            <li [ngClass]=\"{disabled:demoPager.currentPage === demoPager.totalPages}\"\r\n                                style=\"cursor:pointer;\">\r\n                                <a (click)=\"setPageForDemo(demoPager.totalPages)\">Last</a>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </md-tab>\r\n        <md-tab label=\"Purchase Device License\">\r\n            <div class=\"md-tab-content container-fluid\" style=\"border:1px solid #ddd;\">\r\n                <div class=\"row\"> \r\n                    <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n                        <h6>Bill To</h6>\r\n                        <searchable-dropdown\r\n                          [options]=\"BillToList\"\r\n                          placeholder=\"Bill To\"\r\n                          [(selected)]=\"searchBillToName\">\r\n                        </searchable-dropdown>\r\n                    </div>\r\n                    <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n                      <h6>Ship To</h6>\r\n                      <searchable-dropdown\r\n                        [options]=\"ShipToList\"\r\n                        placeholder=\"Ship To\"\r\n                        [(selected)]=\"searchShipToName\">\r\n                      </searchable-dropdown>\r\n                    </div>\r\n                    <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n                      <h6>Serial No</h6>\r\n                      <input class=\"form-control\" type=\"text\" placeholder=\"Select Serial No\" [(ngModel)]=\"searchSerialNoInPurchaseTab\"/>\r\n                    </div>\r\n                </div>\r\n                <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n                    <div style=\"display: flex; flex-direction: row; margin-bottom: 1%;\">\r\n                      <div style=\"margin: 2%;\">\r\n                        <button md-raised-button style=\"background-color: #FFCA28\" (click)=\"searchPurchaseInfo()\">Search</button>\r\n                      </div>\r\n                      <div style=\"margin: 2%;\">\r\n                        <button md-raised-button (click)=\"clearPurchaseInfo()\">Clear</button>\r\n                      </div>\r\n                    </div>\r\n                    <div style=\"display: flex; flex-direction: row; margin-bottom: 1%;\">\r\n                        <div style=\"margin: 1%;\">\r\n                            <button *ngIf=\"IsAddEdit\" md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"addNewDeviceLicenseRequest()\">\r\n                                Add New Device License Request\r\n                            </button>\r\n                        </div>\r\n                      <div style=\"margin: 1%;\">\r\n                        <button md-raised-button mdTooltip=\"Export to CSV\" style=\"background-color: #FFCA28 ; \" class=\"iconsize\" (click)=\"exportDevicePurchaseInfo()\">\r\n                          <em class=\"fa fa-download\"></em>\r\n                        </button>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\" *ngIf=\"purchasePageItems?.length == 0\" class=\"alert alert-danger\">\r\n                    <div class=\"col-12\">{{errorMessagePurchasePage}}</div>\r\n                </div>\r\n                <div *ngIf=\"purchasePageItems?.length > 0\" class=\"table-responsive\">\r\n                    <table class=\"mdl-data-table table-striped col-12\">\r\n                        <tbody>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\"></th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Bill To\r\n                                <button *ngIf=\"purchaseCurrentSortColumn==='BillToName' && purchaseCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                    <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                </button>\r\n                                <button *ngIf=\"purchaseCurrentSortColumn==='BillToName' && purchaseCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                    <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                </button>\r\n                                <sort-dropdown\r\n                                  columnName=\"BillToName\"\r\n                                  (sortChange)=\"onPurchaseSortChange($event)\">\r\n                                </sort-dropdown>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Ship To\r\n                                <button *ngIf=\"purchaseCurrentSortColumn==='ShipToName' && purchaseCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                    <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                </button>\r\n                                <button *ngIf=\"purchaseCurrentSortColumn==='ShipToName' && purchaseCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                    <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                </button>\r\n                                <sort-dropdown\r\n                                  columnName=\"ShipToName\"\r\n                                  (sortChange)=\"onPurchaseSortChange($event)\">\r\n                                </sort-dropdown>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Total Device Purchased</th>\r\n                            <th *ngIf=\"IsAddEdit\" class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                            <ng-container *ngFor=\"let row of purchasePageItems | lz30PurchaseLicenseFilterPipe:filterBillTo : filterShipTo : filterSerialNoInPurchaseTab ; let i=index\">\r\n                                <tr>\r\n                                    <td *ngIf=\"expandedRow!==i\" class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <button md-icon-button mdTooltip=\"View Device Detail\" (click)=\"expandRow(i,row)\">\r\n                                            <em class=\"fa fa-angle-right\"></em>\r\n                                        </button>\r\n                                    </td>\r\n                                    <td *ngIf=\"expandedRow===i\" class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <button md-icon-button mdTooltip=\"View Device Detail\" (click)=\"expandRow(i,row)\">\r\n                                            <em class=\"fa fa-angle-down\"></em>\r\n                                        </button>\r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <div>\r\n                                            <div>\r\n                                                <span style=\"font-weight: bold;\">{{row.BillToName}}</span>\r\n                                            </div>\r\n                                            <div>\r\n                                                <span>{{row.BillToAddress1}}</span>\r\n                                            </div>\r\n                                            <div>\r\n                                                <span>{{row.BillToAddress2}}</span>\r\n                                            </div>\r\n                                            <div>\r\n                                                <span>{{row.BillToCity}}</span>\r\n                                                <span>{{row.BillToState}}</span>\r\n                                            </div>\r\n                                          </div>\r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <div>\r\n                                            <div>\r\n                                                <span style=\"font-weight: bold;\">{{row.ShipToName}}</span>\r\n                                            </div>\r\n                                            <div>\r\n                                                <span>{{row.ShipToAddress1}}</span>\r\n                                            </div>\r\n                                            <div>\r\n                                                <span>{{row.ShipToAddress2}}</span>\r\n                                            </div>\r\n                                            <div>\r\n                                                <span>{{row.ShipToCity}}</span>\r\n                                                <span>{{row.ShipToState}}</span>\r\n                                            </div>\r\n                                          </div>\r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <button style=\"background: none; border: none;\" (click)=\"viewLz30PurchaseLicenseHistory(row)\" >\r\n                                            <span style=\"color: rgba(14, 114, 160);\">\r\n                                                {{row.TotalNoOfDevicePurchased}}\r\n                                            </span>\r\n                                        </button>\r\n                                    </td>\r\n                                    <td *ngIf=\"IsAddEdit\" class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>\r\n                                            <button md-icon-button mdTooltip=\"Add more License\" (click)=\"addMoreLicenseRequest(row)\">\r\n                                                <em class=\"fa fa-plus-square-o\"></em>\r\n                                            </button>\r\n                                        </span>\r\n                                    </td>\r\n                                </tr>\r\n                                <tr *ngIf=\"expandedRow === i\">\r\n                                    <td colspan=\"5\">\r\n                                        <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center;\">\r\n                                            <md-spinner></md-spinner>\r\n                                        </div>\r\n                                        <div *ngIf=\"!isLoading\" class=\"table-responsive\">\r\n                                            <table class=\"mdl-data-table table-striped col-12\">\r\n                                                <tbody>\r\n                                                    <th class=\"mdl-data-table__cell--non-numeric\">MAC Address</th>\r\n                                                    <th class=\"mdl-data-table__cell--non-numeric\">Device Serial No</th>\r\n                                                    <th class=\"mdl-data-table__cell--non-numeric\">Start Date</th>\r\n                                                    <th class=\"mdl-data-table__cell--non-numeric\">End Date</th>\r\n                                                    <tr *ngFor=\"let subRow of UserDeviceDetail\">\r\n                                                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                                            {{subRow.MACAddress}}\r\n                                                        </td>\r\n                                                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                                            {{subRow.DeviceSerialNo}}\r\n                                                        </td>\r\n                                                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                                            {{subRow.StartDate | date:'dd MMM yyyy'}}\r\n                                                        </td>\r\n                                                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                                            {{subRow.EndDate | date:'dd MMM yyyy'}}\r\n                                                        </td>\r\n                                                    </tr>\r\n                                                </tbody>\r\n                                            </table>\r\n                                        </div>\r\n                                    </td>\r\n                                </tr>\r\n                            </ng-container>\r\n                        </tbody>\r\n                    </table>\r\n                    <ul *ngIf=\"purchasePager.pages && purchasePager.pages.length\" class=\"pagination\"\r\n                    style=\"float: right !important;\">\r\n                        <li [ngClass]=\"{disabled:purchasePager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                            <a (click)=\"setPageForPurchase(1)\">First</a>\r\n                        </li>\r\n                        <li [ngClass]=\"{disabled:purchasePager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                            <a (click)=\"setPageForPurchase(purchasePager.currentPage - 1)\">Previous</a>\r\n                        </li>\r\n                        <li *ngFor=\"let page of purchasePager.pages\" [ngClass]=\"{active:purchasePager.currentPage === page}\"\r\n                            style=\"cursor:pointer;\">\r\n                            <a (click)=\"setPageForPurchase(page)\">{{page}}</a>\r\n                        </li>\r\n                        <li [ngClass]=\"{disabled:purchasePager.currentPage === purchasePager.totalPages}\"\r\n                            style=\"cursor:pointer;\">\r\n                            <a (click)=\"setPageForPurchase(purchasePager.currentPage + 1)\">Next</a>\r\n                        </li>\r\n                        <li [ngClass]=\"{disabled:purchasePager.currentPage === purchasePager.totalPages}\"\r\n                            style=\"cursor:pointer;\">\r\n                            <a (click)=\"setPageForPurchase(purchasePager.totalPages)\">Last</a>\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n            </div>\r\n        </md-tab>\r\n        <md-tab label=\"FAQ\">\r\n            <faq></faq>\r\n        </md-tab>\r\n    </md-tab-group>\r\n</div>"

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div style=\"display: flex; flex-direction: row; justify-content: space-between; align-items: center;\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        <button style=\"background: none; border: none;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div  *ngIf=\"errorMessage!=''\" class=\"col-12\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center;\">\r\n        <md-spinner></md-spinner>\r\n    </div>\r\n    <div  *ngIf=\"LZ30DeviceHistory?.length==0\" class=\"col-12\">\r\n        <div class=\"alert alert-danger\">No records found.</div>\r\n    </div>\r\n    <div  *ngIf=\"LZ30DeviceHistory?.length>0\" class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n                <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Name</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Email Id</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Created Date</th>\r\n                    <tr *ngFor=\"let row of LZ30DeviceHistory\"> \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.Name}}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.EmailId}}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.CreatedDate | date: 'dd MMM yyyy' }}\r\n                        </td>  \r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div style=\"display: flex; flex-direction: row; justify-content: space-between; align-items: center;\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        <button style=\"background: none; border: none;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div  *ngIf=\"errorMessage!=''\" class=\"col-12\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center;\">\r\n        <md-spinner></md-spinner>\r\n    </div>\r\n    <div  *ngIf=\"LZ30PurchaseLicenseHistory?.length>0\" class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n                <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Bill To</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Ship To</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">No Of Device Purchased</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">No Of Months</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Purchase Date</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Sales Order No</th>\r\n                    <tr *ngFor=\"let row of LZ30PurchaseLicenseHistory\"> \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <div>\r\n                                <div>\r\n                                    <span style=\"font-weight: bold;\">{{row.BillToName}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.BillToAddress1}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.BillToAddress2}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.BillToCity}}</span>\r\n                                    <span>{{row.BillToState}}</span>\r\n                                </div>\r\n                              </div>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <div>\r\n                                <div>\r\n                                    <span style=\"font-weight: bold;\">{{row.ShipToName}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.ShipToAddress1}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.ShipToAddress2}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.ShipToCity}}</span>\r\n                                    <span>{{row.ShipToState}}</span>\r\n                                </div>\r\n                              </div>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.NoOfDevicePurchased}}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.NoOfMonths}}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.PurchaseDate | date: 'dd MMM yyyy' }}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.SalesOrderNo}}\r\n                        </td>    \r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <section>\r\n        <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n            <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n            <div>\r\n                <button style=\"background: none; border: none; padding: 0px; margin: 0px;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">&nbsp; </div>\r\n        <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n            <div class=\"alert alert-danger\">\r\n                {{errorMessage}}\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">\r\n            <form [formGroup]=\"activateScal360LicenseForm\">\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">SCAL Type</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <span>{{SelectedCustomerLicenseDetail.SCALType}}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">License Type</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <span>{{SelectedCustomerLicenseDetail.LicenseType}}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\" *ngIf=\"error!=''\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">{{error}}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <span>Billing Address</span>\r\n                        <hr color=\"#FFCA28\"/>\r\n                        <div>\r\n                            <span style=\"font-weight: bold;\">{{this.billingShippingDetail.BillToName}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToAddress1}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToAddress2}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToCity}}</span>\r\n                            <span>{{billingShippingDetail.BillToState}}</span>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <span>Shipping Address</span>\r\n                        <hr color=\"#FFCA28\"/>\r\n                        <div>\r\n                            <span style=\"font-weight: bold;\">{{billingShippingDetail.ShipToName}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToAddress1}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToAddress2}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToCity}}</span>\r\n                            <span>{{billingShippingDetail.ShipToState}}</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"table-responsive form-group\">\r\n                    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center;\">\r\n                        <md-spinner></md-spinner>\r\n                    </div>\r\n                    <table *ngIf=\"LicenseActivationDetails?.length>0\" class=\"mdl-data-table table-striped col-12\">\r\n                        <tbody>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\"></th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">License Key</th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">No Of License Activated</th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Expiry Date</th>\r\n                            <tr *ngFor=\"let license of LicenseActivationDetails;let i=index\" [ngClass]=\"{'selected-row':selectedRow===i}\">\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <button (click)=\"selectRow(license,i)\" style=\"background: none; border: none;\"><em class=\"fa fa-check\"></em></button>\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    {{license.LicenseKey}}\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    {{license.NoOfLicenseActivated}}\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    {{license.SupportExpireDate | date:'dd-MMM-yyyy'}}\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Unique H/W Id</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"UniqueHardwareId\" type=\"text\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; activateScal360LicenseForm.controls.UniqueHardwareId.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"activateScal360LicenseForm.controls.UniqueHardwareId.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Unique Hardware Id is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">OS Detail</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <select class=\"form-control\" formControlName=\"OSDetails\">\r\n                            <option *ngFor=\"let detail of OSDetailList;\" [value]=\"detail\">\r\n                                {{detail}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; activateScal360LicenseForm.controls.OSDetail.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"activateScal360LicenseForm.controls.OSDetail.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">OS Detail is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Requester Name</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"RequesterName\" type=\"text\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; activateScal360LicenseForm.controls.RequesterName.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"activateScal360LicenseForm.controls.RequesterName.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Requester Name is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Requester Email</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"RequesterEmail\" type=\"text\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; activateScal360LicenseForm.controls.RequesterEmail.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"activateScal360LicenseForm.controls.RequesterEmail.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Requester email is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Requester Phone No</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"RequesterPhone\" type=\"text\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; activateScal360LicenseForm.controls.RequesterPhone.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"activateScal360LicenseForm.controls.RequesterPhone.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Requester Phone is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-12\"> <!--1. Form valid or not validationForm.valid used 2. Form has any changes for that validationForm.pristine used 3.some situation save button disabled and Enabled that's why we use SaveButtonDisbaled) -->\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ;\"\r\n                            [disabled]=\"SaveButtonDisabled || (!activateScal360LicenseForm.valid || activateScal360LicenseForm.pristine)\"\r\n                            (click)=\"onSave()\">Save</button>                        \r\n                        <span class=\"space\"></span>\r\n                        <button md-raised-button [disabled]=\"CancelButtonDisabled\"\r\n                            (click)=\"onCancel()\">Cancel</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </section>\r\n</article>\r\n\r\n\r\n"

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <section>\r\n        <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n            <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n            <div>\r\n                <button style=\"background: none; border: none; padding: 0px; margin: 0px;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">&nbsp; </div>\r\n        <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n            <div class=\"alert alert-danger\">\r\n                {{errorMessage}}\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">\r\n            <form [formGroup]=\"scal360LicenseForm\">\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">SCAL Type</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <md-radio-group [disabled]=\"isRadioButtonDisabled\" formControlName=\"ScalType\">\r\n                            <md-radio-button *ngFor=\"let type of SCALTypeList\" [value]=\"type.value\" style=\"margin-right: 5px;\">\r\n                                {{type.name}}\r\n                            </md-radio-button>\r\n                        </md-radio-group>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">License Type</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <md-radio-group [disabled]=\"isRadioButtonDisabled\" formControlName=\"LicenseType\">\r\n                            <md-radio-button [value]='\"NEW\"' style=\"margin-right: 5px;\">\r\n                                NEW\r\n                            </md-radio-button>\r\n                            <md-radio-button [value]='\"UPGRADE\"' style=\"margin-right: 5px;\">\r\n                                UPGRADE\r\n                            </md-radio-button>\r\n                        </md-radio-group>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\" *ngIf=\"scal360LicenseForm.value.ScalType==1\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">No of installation(stations)<span style=\"color: red;\">*</span></label>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"NoOfLicensePurchased\" type=\"number\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; scal360LicenseForm.controls.NoOfLicensePurchased.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"scal360LicenseForm.controls.NoOfLicensePurchased.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> No of installation field is required.</span>\r\n                    </div>                 \r\n                </div>  \r\n                <div class=\"form-group row\" *ngIf=\"scal360LicenseForm.value.ScalType==2\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">No of Admin Level License<span style=\"color: red;\">*</span></label>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"NoOfLicensePurchased\" type=\"number\"/>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row form-group\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"scal360LicenseForm.controls['NoOfLicensePurchased'].hasError('max')\" \r\n                        class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Maximum allowed value is 100.</span>\r\n                    </div>\r\n                    <div *ngIf=\"SCALOperation==1 &amp;&amp; scal360LicenseForm.controls['NoOfLicensePurchased'].hasError('min')\" \r\n                        class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Min allowed value is 1.</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\" *ngIf=\"scal360LicenseForm.value.ScalType==2\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">No of User Level License<span style=\"color: red;\">*</span></label>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"NoOfUserLicensePurchased\" type=\"number\"/>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row form-group\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"scal360LicenseForm.controls['NoOfUserLicensePurchased'].hasError('max')\" \r\n                        class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Maximum allowed value is 100.</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Purchase Date</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"PurchaseDate\" type=\"date\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; scal360LicenseForm.controls.PurchaseDate.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"scal360LicenseForm.controls.PurchaseDate.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Purchase Date field is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Support Service Agreement Validity(in Months)<span style=\"color: red;\">*</span></label>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"SupportValidityYear\" type=\"number\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; scal360LicenseForm.controls.SupportValidityYear.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"scal360LicenseForm.controls.SupportValidityYear.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">Support Service Agreement Validity is required.</span>\r\n                    </div>                 \r\n                </div> \r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Sales Order No</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"SalesOrderNo\" (blur)=\"blurSalesOrderEvent()\" type=\"text\"/>\r\n                        </div>\r\n                    <div class=\"col-md-4\">\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ; height: 30px; text-align: center;\" (click)=\"checkSalesOrderNo()\">Fetch Customer</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\" *ngIf=\"error!=''\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">{{error}}</span>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"isBillingShippingDetailFetched && !isLoading\" class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <span>Billing Address</span>\r\n                        <hr color=\"#FFCA28\"/>\r\n                        <div>\r\n                            <span style=\"font-weight: bold;\">{{this.billingShippingDetail.BillToName}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToAddress1}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToAddress2}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToCity}}</span>\r\n                            <span>{{billingShippingDetail.BillToState}}</span>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <span>Shipping Address</span>\r\n                        <hr color=\"#FFCA28\"/>\r\n                        <div>\r\n                            <span style=\"font-weight: bold;\">{{billingShippingDetail.ShipToName}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToAddress1}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToAddress2}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToCity}}</span>\r\n                            <span>{{billingShippingDetail.ShipToState}}</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; scal360LicenseForm.controls.SalesOrderNo.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"scal360LicenseForm.controls.SalesOrderNo.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> SalesOrderNo is required.</span>\r\n                    </div>                 \r\n                </div> \r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-12\"> <!--1. Form valid or not validationForm.valid used 2. Form has any changes for that validationForm.pristine used 3.some situation save button disabled and Enabled that's why we use SaveButtonDisbaled) -->\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ;\"\r\n                            [disabled]=\"SaveButtonDisabled || (!scal360LicenseForm.valid || scal360LicenseForm.pristine)\"\r\n                            (click)=\"onSave()\">Save</button>                        \r\n                        <span class=\"space\"></span>\r\n                        <button md-raised-button [disabled]=\"CancelButtonDisabled\"\r\n                            (click)=\"onCancel()\">Cancel</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </section>\r\n</article>\r\n\r\n\r\n"

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <section>\r\n        <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n            <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n            <div>\r\n                <button style=\"background: none; border: none; padding: 0px; margin: 0px;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">&nbsp; </div>\r\n        <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n            <div class=\"alert alert-danger\">\r\n                {{errorMessage}}\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">\r\n            <div class=\"form-group row\">\r\n                <div class=\"col-md-4\">\r\n                    <label class=\"control-label\">SCAL Type</label><span style=\"color: red;\">*</span>\r\n                </div>\r\n                <div class=\"col-md-8\">\r\n                    <span>{{SelectedCustomerLicenseDetail.SCALType}}</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <div class=\"col-md-4\">\r\n                    <label class=\"control-label\">License Type</label><span style=\"color: red;\">*</span>\r\n                </div>\r\n                <div class=\"col-md-8\">\r\n                    <span>{{SelectedCustomerLicenseDetail.LicenseType}}</span>\r\n                </div>\r\n            </div>\r\n            <div  class=\"form-group row\">\r\n                <div class=\"col-md-6\">\r\n                    <span>Billing Address</span>\r\n                    <hr color=\"#FFCA28\"/>\r\n                    <div>\r\n                        <span style=\"font-weight: bold;\">{{this.billingShippingDetail.BillToName}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.BillToAddress1}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.BillToAddress2}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.BillToCity}}</span>\r\n                        <span>{{billingShippingDetail.BillToState}}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <span>Shipping Address</span>\r\n                    <hr color=\"#FFCA28\"/>\r\n                    <div>\r\n                        <span style=\"font-weight: bold;\">{{billingShippingDetail.ShipToName}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.ShipToAddress1}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.ShipToAddress2}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.ShipToCity}}</span>\r\n                        <span>{{billingShippingDetail.ShipToState}}</span>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"table-responsive form-group\">\r\n                <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center;\">\r\n                    <md-spinner></md-spinner>\r\n                </div>\r\n                <table *ngIf=\"LicenseRenewalDetails?.length>0\" class=\"mdl-data-table table-striped col-12\">\r\n                    <tbody>\r\n                        <th class=\"mdl-data-table__cell--non-numeric\"></th>\r\n                        <th class=\"mdl-data-table__cell--non-numeric\">License Key</th>\r\n                        <th class=\"mdl-data-table__cell--non-numeric\">Expiry Date</th>\r\n                        <th *ngIf=\"this.SelectedCustomerLicenseDetail.SCALType==scalTypeEnum[2]\" class=\"mdl-data-table__cell--non-numeric\">No Of User</th>\r\n                        <th *ngIf=\"this.SelectedCustomerLicenseDetail.SCALType==scalTypeEnum[2]\" class=\"mdl-data-table__cell--non-numeric\">Renewal User</th>\r\n                        <tr *ngFor=\"let license of LicenseRenewalDetails;let i=index\" [ngClass]=\"{'selected-row':this.selectedRow[i]===i}\">\r\n                            <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                <button (click)=\"selectRow(license,i)\" style=\"background: none; border: none;\"><em class=\"fa fa-check\"></em></button>\r\n                            </td>\r\n                            <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                {{license.LicenseKey}}\r\n                            </td>\r\n                            <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                <span *ngIf=\"license.TagName=='Expired'\" style=\"color: red\">\r\n                                    {{license.SupportExpireDate | date:'dd-MMM-yyyy'}}\r\n                                </span>\r\n                                <span *ngIf=\"license.TagName=='NoExpired'\">\r\n                                    {{license.SupportExpireDate | date:'dd-MMM-yyyy'}}\r\n                                </span>\r\n                            </td>\r\n                            <td *ngIf=\"this.SelectedCustomerLicenseDetail.SCALType==scalTypeEnum[2]\" class=\"mdl-data-table__cell--non-numeric\">\r\n                                {{license.NoOfUser}}\r\n                            </td>\r\n                            <td *ngIf=\"this.SelectedCustomerLicenseDetail.SCALType==scalTypeEnum[2]\" class=\"mdl-data-table__cell--non-numeric\">\r\n                                <input type=\"number\" [max]=\"license.NoOfUser\"  [(ngModel)]=\"license.RenewalUser\"/>\r\n                            </td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </div>\r\n            <form [formGroup]=\"renewScal360LicenseForm\">\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Renewal Type</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <md-radio-group formControlName=\"RenewalType\">\r\n                            <md-radio-button *ngFor=\"let type of SCALRenewalTypeList\" [value]=\"type.value\" style=\"margin-right: 5px;\">\r\n                                {{type.name}}\r\n                            </md-radio-button>\r\n                        </md-radio-group>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Purchase Date</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"PurchaseDate\" type=\"date\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; renewScal360LicenseForm.controls.PurchaseDate.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"renewScal360LicenseForm.controls.PurchaseDate.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Purchase Date field is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Support Service Agreement Validity(in Months)<span style=\"color: red;\">*</span></label>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"SupportValidityYear\" type=\"number\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; renewScal360LicenseForm.controls.SupportValidityYear.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"renewScal360LicenseForm.controls.SupportValidityYear.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">Support Service Agreement Validity is required.</span>\r\n                    </div>                 \r\n                </div> \r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Sales Order No</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"SalesOrderNo\" (blur)=\"blurSalesOrderEvent()\" type=\"text\"/>\r\n                        </div>\r\n                    <div class=\"col-md-4\">\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ; height: 30px; text-align: center;\" (click)=\"checkSalesOrderNo()\">Fetch Customer</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\" *ngIf=\"error!=''\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <span style=\"color:red;font-weight: bold;\">{{error}}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-12\"> <!--1. Form valid or not validationForm.valid used 2. Form has any changes for that validationForm.pristine used 3.some situation save button disabled and Enabled that's why we use SaveButtonDisbaled) -->\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ;\"\r\n                            [disabled]=\"SaveButtonDisabled || (!renewScal360LicenseForm.valid || renewScal360LicenseForm.pristine)\"\r\n                            (click)=\"onSave()\">Save</button>                        \r\n                        <span class=\"space\"></span>\r\n                        <button md-raised-button [disabled]=\"CancelButtonDisabled\"\r\n                            (click)=\"onCancel()\">Cancel</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </section>\r\n</article>\r\n\r\n\r\n"

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports = "<section>\r\n    <div class=\"container-fluid\">\r\n        <h3 class=\"title\">SCAL 360</h3>\r\n    </div>\r\n    <div class=\"container-fluid\">\r\n      <hr />\r\n      <div class=\"row\"> \r\n        <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n            <h6>SCAL Type</h6>\r\n            <select class=\"form-control\" [(ngModel)]=\"searchSCALType\">\r\n              <option disabled value=\"\">Select SCAL Type</option>\r\n                <option *ngFor=\"let type of SCALTypeList\" [ngValue]=\"type.value\">\r\n                    {{type.name}}\r\n                </option>\r\n            </select>\r\n        </div>\r\n        <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n          <h6>Bill To</h6>\r\n          <searchable-dropdown\r\n            [options]=\"BillToList\"\r\n            placeholder=\"Bill To\"\r\n            [(selected)]=\"searchBillToName\">\r\n          </searchable-dropdown>\r\n        </div>\r\n        <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n          <h6>Ship To</h6>\r\n          <searchable-dropdown\r\n            [options]=\"ShipToList\"\r\n            placeholder=\"Ship To\"\r\n            [(selected)]=\"searchShipToName\">\r\n          </searchable-dropdown>\r\n        </div>\r\n        <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n          <h6>License Key</h6>\r\n          <input class=\"form-control\" type=\"text\" placeholder=\"Select License Key\" [(ngModel)]=\"searchLicenseKey\"/>\r\n        </div>\r\n      </div>\r\n      <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n        <div style=\"display: flex; flex-direction: row;\">\r\n          <div style=\"margin: 1%;\">\r\n            <button md-raised-button style=\"background-color: #FFCA28\" (click)=\"search()\">Search</button>\r\n          </div>\r\n          <div style=\"margin: 1%;\">\r\n            <button md-raised-button (click)=\"clearSearch()\">Clear</button>\r\n          </div>\r\n        </div>\r\n        <div style=\"display: flex; flex-direction: row;\">\r\n          <div style=\"margin: 1%;\">\r\n            <button *ngIf=\"IsAddEdit\" md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"openGenerateNewLicenseRequestDialog()\">\r\n              Generate New License Request\r\n            </button>\r\n          </div>\r\n          <div style=\"margin: 1%;\">\r\n            <button md-raised-button style=\"background-color: #FFCA28 ;\" class=\"iconsize\" mdTooltip=\"Export to CSV\" (click)=\"exportToCSV()\">\r\n              <em class=\"fa fa-download\"></em>\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">&nbsp;</div>\r\n      <div class=\"row\" *ngIf=\"errorMessage!==''\" class=\"alert alert-danger\">\r\n        <div class=\"col-12\">{{errorMessage}}</div>\r\n      </div>\r\n      <div class=\"row\">&nbsp;</div>\r\n      <div class=\"row\" *ngIf=\"pagedItems?.length > 0\">\r\n        <div class=\"col-12\">\r\n          <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n              <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\"></th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Bill To\r\n                      <button *ngIf=\"currentSortColumn==='BillToName' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                      </button>\r\n                      <button *ngIf=\"currentSortColumn==='BillToName' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                      </button>\r\n                      <sort-dropdown\r\n                          columnName=\"BillToName\"\r\n                          (sortChange)=\"onSortChange($event)\">\r\n                      </sort-dropdown>\r\n                    </th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Ship To\r\n                      <button *ngIf=\"currentSortColumn==='ShipToName' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                      </button>\r\n                      <button *ngIf=\"currentSortColumn==='ShipToName' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                      </button>\r\n                      <sort-dropdown\r\n                          columnName=\"ShipToName\"\r\n                          (sortChange)=\"onSortChange($event)\">\r\n                      </sort-dropdown>\r\n                    </th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">SCAL Type\r\n                      <button *ngIf=\"currentSortColumn==='SCALType' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                      </button>\r\n                      <button *ngIf=\"currentSortColumn==='SCALType' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                      </button>\r\n                      <sort-dropdown\r\n                          columnName=\"SCALType\"\r\n                          (sortChange)=\"onSortChange($event)\">\r\n                      </sort-dropdown>\r\n                    </th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">License Type\r\n                      <button *ngIf=\"currentSortColumn==='LicenseType' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                      </button>\r\n                      <button *ngIf=\"currentSortColumn==='LicenseType' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                         <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                      </button>\r\n                      <sort-dropdown\r\n                          columnName=\"LicenseType\"\r\n                          (sortChange)=\"onSortChange($event)\">\r\n                      </sort-dropdown>\r\n                    </th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Purchased</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Activated</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                    <ng-container *ngFor=\"let row of pagedItems; let i=index\">\r\n                        <tr> \r\n                            <td *ngIf=\"expandedRow!==i\" class=\"mdl-data-table__cell--non-numeric\">\r\n                                <button md-icon-button mdTooltip=\"View Device Detail\" (click)=\"expandRow(i,row)\">\r\n                                    <em class=\"fa fa-angle-right\"></em>\r\n                                </button>\r\n                            </td>\r\n                            <td *ngIf=\"expandedRow===i\" class=\"mdl-data-table__cell--non-numeric\">\r\n                                <button md-icon-button mdTooltip=\"View Device Detail\" (click)=\"expandRow(i,row)\">\r\n                                    <em class=\"fa fa-angle-down\"></em>\r\n                                </button>\r\n                            </td>\r\n                            <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                <div>\r\n                                    <div>\r\n                                        <span style=\"font-weight: bold;\">{{row.BillToName}}</span>\r\n                                    </div>\r\n                                    <div>\r\n                                        <span>{{row.BillToAddress1}}</span>\r\n                                    </div>\r\n                                    <div>\r\n                                        <span>{{row.BillToAddress2}}</span>\r\n                                    </div>\r\n                                    <div>\r\n                                        <span>{{row.BillToCity}}</span>\r\n                                        <span>{{row.BillToState}}</span>\r\n                                    </div>\r\n                                  </div>\r\n                            </td>\r\n                            <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                <div>\r\n                                    <div>\r\n                                        <span style=\"font-weight: bold;\">{{row.ShipToName}}</span>\r\n                                    </div>\r\n                                    <div>\r\n                                        <span>{{row.ShipToAddress1}}</span>\r\n                                    </div>\r\n                                    <div>\r\n                                        <span>{{row.ShipToAddress2}}</span>\r\n                                    </div>\r\n                                    <div>\r\n                                        <span>{{row.ShipToCity}}</span>\r\n                                        <span>{{row.ShipToState}}</span>\r\n                                    </div>\r\n                                  </div>\r\n                            </td>\r\n                            <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                {{row.SCALType}}\r\n                            </td>\r\n                            <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                {{row.LicenseType}}\r\n                            </td>\r\n                            <td *ngIf=\"row.SCALType==SCALTypeEnum[2]\" class=\"mdl-data-table__cell--non-numeric\">\r\n                                <div style=\"display: flex; flex-direction: row;\">\r\n                                    <span style=\"font-weight: bold; margin-right: 2px;\">Admin Lic: </span>\r\n                                    <button style=\"background: none; border: none;\" (click)=\"viewScal360PurchaseHistory(row)\">\r\n                                      <span style=\"color: rgba(14, 114, 160);\">{{row.TotalNoOfLicenses}}</span>\r\n                                    </button>\r\n                                </div>\r\n                                <div style=\"display: flex; flex-direction: row;\">\r\n                                    <span style=\"font-weight: bold; margin-right: 2px;\">User Lic:</span>\r\n                                    <span>{{row.TotalNoOfUserLicenses}}</span>\r\n                                </div>\r\n                            </td>\r\n                            <td *ngIf=\"row.SCALType==SCALTypeEnum[1]\" class=\"mdl-data-table__cell--non-numeric\">\r\n                              <button style=\"background: none; border: none;\" (click)=\"viewScal360PurchaseHistory(row)\">\r\n                                <span style=\"color: rgba(14, 114, 160);\">{{row.TotalNoOfLicenses}}</span>\r\n                              </button>\r\n                                \r\n                            </td>\r\n                            <td class=\"mdl-data-table__cell--non-numeric\">\r\n                              {{row.TotalNoOfLicenseActivated}}\r\n                            </td>\r\n                            <td class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                                <button *ngIf=\"IsAddEdit && row.TotalNoOfLicenseActivated==0\" md-icon-button mdTooltip=\"Edit License\" (click)=\"editLicenseRequestDialog(row)\"><em class=\"fa fa-edit\"></em></button>\r\n                                <button md-icon-button *ngIf=\"IsAddEdit\" mdTooltip=\"Activate License\" (click)=\"activateScalLicense(row)\"><em class=\"fa fa-check-square-o\"></em></button>\r\n                                <button md-icon-button *ngIf=\"IsAddEdit\"  mdTooltip=\"Add more License\" (click)=\"addMoreLicenseRequestDialog(row)\"><em class=\"fa fa-plus-square-o\"></em></button>\r\n                                <button md-icon-button *ngIf=\"IsAddEdit\" mdTooltip=\"Renew License\" (click)=\"renewScalLicense(row)\"><em class=\"fa fa-refresh\"></em></button>\r\n                                <button md-icon-button *ngIf=\"IsDelete && row.TotalNoOfLicenseActivated==0\" mdTooltip=\"Delete License\" (click)=\"deleteCustomerLicense(row)\"><em class=\"fa fa-trash\"></em></button>\r\n                                <button md-icon-button mdTooltip=\"View license information\" (click)=\"viewScal360LicenseInformation(row)\"><em class=\"fa fa-key\"></em></button>\r\n                            </td>    \r\n                        </tr>\r\n                        <tr *ngIf=\"expandedRow === i\">\r\n                            <td colspan=\"8\">\r\n                                <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center;\">\r\n                                    <md-spinner></md-spinner>\r\n                                </div>\r\n                                <div *ngIf=\"!isLoading\" class=\"table-responsive\">\r\n                                    <table class=\"mdl-data-table table-striped col-12\">\r\n                                        <tbody>\r\n                                            <th class=\"mdl-data-table__cell--non-numeric\">License Key</th>\r\n                                            <th class=\"mdl-data-table__cell--non-numeric\">Expiry Date</th>\r\n                                            <th class=\"mdl-data-table__cell--non-numeric\">Activated</th>\r\n                                            <th *ngIf='row.SCALType==SCALTypeEnum[2]' class=\"mdl-data-table__cell--non-numeric\">No Of Users</th>\r\n                                            <th class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                                            <tr *ngFor=\"let subRow of customerLicenseDetails\">\r\n                                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                                    {{subRow.LicenseKey}}\r\n                                                </td>\r\n                                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                                  <button *ngIf=\"subRow.TagName=='NoExpired'\" style=\"background: none; border: none;\" (click)=\"viewScalRenewalHistory(subRow)\" >\r\n                                                    <span  style=\"color: rgba(14, 114, 160);\">{{subRow.SupportExpireDate | date:'dd-MMM-yyyy'}}</span>\r\n                                                  </button>\r\n                                                  <span *ngIf=\"subRow.TagName=='Expired'\" style=\"color: red;\">{{subRow.SupportExpireDate | date:'dd-MMM-yyyy'}}</span>\r\n                                                </td>\r\n                                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                                  <button style=\"background: none; border: none;\" (click)=\"viewScalActivationHistory(subRow)\">\r\n                                                    <span style=\"color: rgba(14, 114, 160);\">{{subRow.NoOfLicenseActivated}}</span>\r\n                                                  </button>\r\n                                                </td>\r\n                                                <td class=\"mdl-data-table__cell--non-numeric\" *ngIf='row.SCALType==SCALTypeEnum[2]'>\r\n                                                  {{subRow.NoOfUser}}\r\n                                                </td>\r\n                                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                                  <button md-icon-button *ngIf=\"subRow.NoOfLicenseActivated==0 && IsDelete\" (click)=\"deleteParticularLicenseKey(subRow,row,customerLicenseDetails)\" mdTooltip=\"Delete License Key\"><em class=\"fa fa-trash-o\"></em></button>\r\n                                                  <button md-icon-button  (click)=\"viewScalDownloadReleaseHistory(subRow)\" mdTooltip=\"View Download Release History\"><em class=\"fa fa-history\"></em></button>\r\n                                                </td>\r\n                                            </tr>\r\n                                        </tbody>\r\n                                    </table>\r\n                                </div>\r\n                            </td>\r\n                        </tr>\r\n                    </ng-container>\r\n              </tbody>\r\n            </table>\r\n            <ul *ngIf=\"pager.pages && pager.pages.length\" class=\"pagination\"\r\n              style=\"float: right !important;\">\r\n              <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                  <a (click)=\"setPage(1)\">First</a>\r\n              </li>\r\n              <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                  <a (click)=\"setPage(pager.currentPage - 1)\">Previous</a>\r\n              </li>\r\n              <li *ngFor=\"let page of pager.pages\" [ngClass]=\"{active:pager.currentPage === page}\"\r\n                  style=\"cursor:pointer;\">\r\n                  <a (click)=\"setPage(page)\">{{page}}</a>\r\n              </li>\r\n              <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                  style=\"cursor:pointer;\">\r\n                  <a (click)=\"setPage(pager.currentPage + 1)\">Next</a>\r\n              </li>\r\n              <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                  style=\"cursor:pointer;\">\r\n                  <a (click)=\"setPage(pager.totalPages)\">Last</a>\r\n              </li>\r\n          </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>"

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div style=\"display: flex; flex-direction: row; justify-content: space-between; align-items: center;\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        <div>\r\n            <button style=\"background: none; border: none;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div  *ngIf=\"errorMessage!=''\" class=\"col-12\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center; align-items: center;\">\r\n        <md-spinner></md-spinner>\r\n    </div>\r\n    <div *ngIf=\"Scal360ActivationHistory?.length>0\" class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n                <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Name</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Email Id</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Phone No</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Hardware Id</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">OS Details</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Activation Key</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Activation Date</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                    <tr *ngFor=\"let row of Scal360ActivationHistory\"> \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.RequesterName}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.RequesterEmail}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.RequesterPhone}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.HardwareId}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.OSDetails}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.ActivationKey}}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.ActivationDate | date:'dd-MMM-yyyy'}}\r\n                        </td>  \r\n                        <td class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                            <button md-icon-button mdTooltip=\"Delete Key\" (click)=\"deleteActivation(row)\"><em class=\"fa fa-trash\"></em></button>\r\n                        </td>  \r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div style=\"display: flex; flex-direction: row; justify-content: space-between; align-items: center;\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        <div>\r\n            <button style=\"background: none; border: none;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div  *ngIf=\"errorMessage!=''\" class=\"col-12\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center; align-items: center;\">\r\n        <md-spinner></md-spinner>\r\n    </div>\r\n    <div *ngIf=\"Scal360DownloadReleaseHistory?.length>0\" class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n                <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Email Id</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Version No</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">IP Address</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Contact No</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Total Download</th>\r\n                    <tr *ngFor=\"let row of Scal360DownloadReleaseHistory\"> \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.EmailId}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                           <span>{{row.SoftwareVersionNo}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.IPAddress}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.PhoneNo}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.TotalDownload}}</span>\r\n                        </td>   \r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"Scal360DownloadReleaseHistory?.length==0\">\r\n        <div class=\"alert alert-danger\">\r\n            <span>Customer download information is not available</span>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <section>\r\n        <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n            <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n            <div>\r\n                <button style=\"background: none; border: none; padding: 0px; margin: 0px;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">&nbsp; </div>\r\n        <div class=\"col-12\">\r\n            <div class=\"form-group row\">\r\n                <div class=\"col-md-4\">\r\n                    <label class=\"control-label\">SCAL Type</label>\r\n                </div>\r\n                <div class=\"col-md-8\">\r\n                    <span>{{SelectedCustomerLicenseDetail.SCALType}}</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <div class=\"col-md-4\">\r\n                    <label class=\"control-label\">License Type</label>\r\n                </div>\r\n                <div class=\"col-md-8\">\r\n                    <span>{{SelectedCustomerLicenseDetail.LicenseType}}</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                 <div class=\"col-md-4\">\r\n                    <label class=\"control-label\">Total Purchased</label>\r\n                </div>\r\n                <div class=\"col-md-8\" *ngIf=\"SelectedCustomerLicenseDetail.SCALType==SCALTypeEnum[2]\">\r\n                    <div style=\"display: flex; flex-direction: row;\">\r\n                        <span style=\"font-weight: bold; margin-right: 2px;\">Admin Lic: </span>\r\n                        <span>{{SelectedCustomerLicenseDetail.TotalNoOfLicenses}}</span>\r\n                        <span>&nbsp;</span>\r\n                        <span style=\"font-weight: bold; margin-right: 2px;\">User Lic:</span>\r\n                        <span>{{SelectedCustomerLicenseDetail.TotalNoOfUserLicenses}}</span>\r\n                    </div>\r\n                    <div style=\"display: flex; flex-direction: row;\">\r\n                        \r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-8\" *ngIf=\"SelectedCustomerLicenseDetail.SCALType==SCALTypeEnum[1]\">\r\n                    <span>{{SelectedCustomerLicenseDetail.TotalNoOfLicenses}}</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <div class=\"col-md-4\">\r\n                    <label class=\"control-label\">Total Activated</label>\r\n                </div>\r\n                <div class=\"col-md-8\">\r\n                    <span>{{SelectedCustomerLicenseDetail.TotalNoOfLicenseActivated}}</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <div class=\"col-md-6\">\r\n                    <hr color=\"#FFCA28\"/>\r\n                    <span style=\"text-align: center;\">Billing Address</span>\r\n                    <hr color=\"#FFCA28\"/>\r\n                    <div>\r\n                        <span style=\"font-weight: bold;\">{{this.billingShippingDetail.BillToName}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.BillToAddress1}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.BillToAddress2}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.BillToCity}}</span>\r\n                        <span>{{billingShippingDetail.BillToState}}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <hr color=\"#FFCA28\"/>\r\n                    <span>Shipping Address</span>\r\n                    <hr color=\"#FFCA28\"/>\r\n                    <div>\r\n                        <span style=\"font-weight: bold;\">{{billingShippingDetail.ShipToName}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.ShipToAddress1}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.ShipToAddress2}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.ShipToCity}}</span>\r\n                        <span>{{billingShippingDetail.ShipToState}}</span>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"table-responsive form-group\">\r\n                <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center;\">\r\n                    <md-spinner></md-spinner>\r\n                </div>\r\n                <table *ngIf=\"LicenseDetails?.length>0\" class=\"mdl-data-table table-striped col-12\"> \r\n                    <tbody>\r\n                        <th class=\"mdl-data-table__cell--non-numeric\">License Key</th>\r\n                        <th class=\"mdl-data-table__cell--non-numeric\">No Of License Activated</th>\r\n                        <th class=\"mdl-data-table__cell--non-numeric\">Expiry Date</th>\r\n                        <th *ngIf=\"SelectedCustomerLicenseDetail.SCALType==SCALTypeEnum[2]\" class=\"mdl-data-table__cell--non-numeric\">No Of User</th>\r\n                        <tr *ngFor=\"let license of LicenseDetails;let i=index\">\r\n                            <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                {{license.LicenseKey}}\r\n                            </td>\r\n                            <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                {{license.NoOfLicenseActivated}}\r\n                            </td>\r\n                            <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                {{license.SupportExpireDate | date:'dd-MMM-yyyy'}}\r\n                            </td>\r\n                            <td *ngIf=\"SelectedCustomerLicenseDetail.SCALType==SCALTypeEnum[2]\" class=\"mdl-data-table__cell--non-numeric\">\r\n                                {{license.NoOfUser}}\r\n                            </td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </div>\r\n        </div>\r\n    </section>\r\n</article>\r\n\r\n\r\n"

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div style=\"display: flex; flex-direction: row; justify-content: space-between; align-items: center;\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        <div>\r\n            <button style=\"background: none; border: none;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div  *ngIf=\"errorMessage!=''\" class=\"col-12\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center; align-items: center;\">\r\n        <md-spinner></md-spinner>\r\n    </div>\r\n    <div *ngIf=\"Scal360PurchaseHistory?.length>0\" class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n                <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Bill To</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Ship To</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Purchased License</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Support Validity Years</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Purchase Date</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Sales Order No</th>\r\n                    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center;\">\r\n                        <md-spinner></md-spinner>\r\n                    </div>\r\n                    <tr *ngFor=\"let row of Scal360PurchaseHistory\"> \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <div>\r\n                                <div>\r\n                                    <span style=\"font-weight: bold;\">{{row.BillToName}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.BillToAddress1}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.BillToAddress2}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.BillToCity}}</span>\r\n                                    <span>{{row.BillToState}}</span>\r\n                                </div>\r\n                              </div>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <div>\r\n                                <div>\r\n                                    <span style=\"font-weight: bold;\">{{row.ShipToName}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.ShipToAddress1}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.ShipToAddress2}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.ShipToCity}}</span>\r\n                                    <span>{{row.ShipToState}}</span>\r\n                                </div>\r\n                              </div>\r\n                        </td>\r\n                        <td *ngIf=\"row.SCALType==SCALTypeEnum[2]\" class=\"mdl-data-table__cell--non-numeric\">\r\n                            <div style=\"display: flex; flex-direction: row;\">\r\n                                <span style=\"font-weight: bold; margin-right: 2px;\">Admin Lic: </span>\r\n                                <span>{{row.NoOfLicensePurchased}}</span>\r\n                            </div>\r\n                            <div style=\"display: flex; flex-direction: row;\">\r\n                                <span style=\"font-weight: bold; margin-right: 2px;\">User Lic:</span>\r\n                                <span>{{row.NoOfUserLicensePurchased}}</span>\r\n                            </div>\r\n                        </td>\r\n                        <td *ngIf=\"row.SCALType==SCALTypeEnum[1]\" class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.NoOfLicensePurchased}}</span>\r\n                            \r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.SupportValidityYears}}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.PurchaseInvoiceDate | date: 'dd MMM yyyy' }}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.SalesOrderNo}}\r\n                        </td>    \r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div style=\"display: flex; flex-direction: row; justify-content: space-between; align-items: center;\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        <div>\r\n            <button style=\"background: none; border: none;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div  *ngIf=\"errorMessage!=''\" class=\"col-12\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center; align-items: center;\">\r\n        <md-spinner></md-spinner>\r\n    </div>\r\n    <div *ngIf=\"Scal360LicenseRenewalHistory?.length>0\" class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n                <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Bill To</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Ship To</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Purchase Date</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">No Of Months</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">No Of User Renewed</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Renewal Date</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Sales Order No</th>\r\n                    <tr *ngFor=\"let row of Scal360LicenseRenewalHistory\"> \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <div>\r\n                                <div>\r\n                                    <span style=\"font-weight: bold;\">{{row.BillToName}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.BillToAddress1}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.BillToAddress2}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.BillToCity}}</span>\r\n                                    <span>{{row.BillToState}}</span>\r\n                                </div>\r\n                              </div>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <div>\r\n                                <div>\r\n                                    <span style=\"font-weight: bold;\">{{row.ShipToName}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.ShipToAddress1}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.ShipToAddress2}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.ShipToCity}}</span>\r\n                                    <span>{{row.ShipToState}}</span>\r\n                                </div>\r\n                              </div>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.PurchaseInvoiceDate | date: 'dd MMM yyyy' }}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.SupportValidityMonths}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.NoOfUserLicenseRenewed}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.RenewalDate | date:'dd-MMM-yyyy'}}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.SalesOrderNo}}\r\n                        </td>    \r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <section>\r\n        <div class=\"col-12\">\r\n            <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        </div>\r\n        <div class=\"col-12\">&nbsp; </div>\r\n        <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n            <div class=\"alert alert-danger\">\r\n                {{errorMessage}}\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">\r\n            <form [formGroup]=\"service360LicenseForm\">\r\n                <div class=\"form-group row\">\r\n                    <label class=\"col-md-4 control-label\">No of installation</label>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"NoOfInstallation\" type=\"number\" max=\"100\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; service360LicenseForm.controls.NoOfInstallation.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"service360LicenseForm.controls.NoOfInstallation.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> No of installation field is required.</span>\r\n                    </div>                 \r\n                </div> \r\n                <div class=\"row form-group\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"service360LicenseForm.controls['NoOfInstallation'].hasError('max')\" \r\n                        class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Maximum allowed value is 100.</span>\r\n                    </div>\r\n                </div> \r\n                <div class=\"form-group row\">\r\n                    <label class=\"col-md-4 control-label\">Sales Order No</label>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"SalesOrderNo\" (blur)=\"blurSalesOrderEvent()\" type=\"text\"/>\r\n                        </div>\r\n                    <div class=\"col-md-4\">\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ; height: 30px; text-align: center;\" (click)=\"checkSalesOrderNo()\">Fetch Customer</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\" *ngIf=\"error!=''\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">{{error}}</span>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"isBillingShippingDetailFetched\" class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <span>Billing Address</span>\r\n                        <hr color=\"#FFCA28\"/>\r\n                        <div>\r\n                            <span style=\"font-weight: bold;\">{{this.billingShippingDetail.BillToName}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToAddress1}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToAddress2}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToCity}}</span>\r\n                            <span>{{billingShippingDetail.BillToState}}</span>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <span>Shipping Address</span>\r\n                        <hr color=\"#FFCA28\"/>\r\n                        <div>\r\n                            <span style=\"font-weight: bold;\">{{billingShippingDetail.ShipToName}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToAddress1}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToAddress2}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToCity}}</span>\r\n                            <span>{{billingShippingDetail.ShipToState}}</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; service360LicenseForm.controls.SalesOrderNo.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"service360LicenseForm.controls.SalesOrderNo.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> SalesOrderNo is required.</span>\r\n                    </div>                 \r\n                </div> \r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-12\"> <!--1. Form valid or not validationForm.valid used 2. Form has any changes for that validationForm.pristine used 3.some situation save button disabled and Enabled that's why we use SaveButtonDisbaled) -->\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ;\"\r\n                            [disabled]=\"SaveButtonDisabled || (!service360LicenseForm.valid || service360LicenseForm.pristine)\"\r\n                            (click)=\"onSave()\">Save</button>                        \r\n                        <span class=\"space\"></span>\r\n                        <button md-raised-button [disabled]=\"CancelButtonDisabled\"\r\n                            (click)=\"onCancel()\">Cancel</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </section>\r\n</article>\r\n\r\n\r\n"

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        <div>\r\n            <button style=\"background: none; border: none; padding: 0px; margin: 0px;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"error!=''\">\r\n        <span class=\"alert alert-danger\">{{error}}</span>\r\n    </div>\r\n    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center;\">\r\n        <md-spinner></md-spinner>\r\n    </div>\r\n    <div  *ngIf=\"ActivationDetail?.length>0\" class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n                <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Device Type</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Hardware Id</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Installation Date</th>\r\n                    <tr *ngFor=\"let row of ActivationDetail\"> \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.DeviceTypes}}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.HardwareId}}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.CreatedDate | date: 'dd MMM yyyy'}}\r\n                        </td>    \r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports = "<section>\r\n    <div class=\"container-fluid\">\r\n        <h3 class=\"title\">Service-360</h3>\r\n    </div>\r\n    <div class=\"container-fluid\">\r\n      <hr />\r\n      <div class=\"row\"> \r\n        <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n          <h6>Bill To</h6>\r\n          <searchable-dropdown\r\n            [options]=\"BillToList\"\r\n            placeholder=\"Bill To\"\r\n            [(selected)]=\"searchBillToName\">\r\n          </searchable-dropdown>\r\n        </div>\r\n        <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n          <h6>Ship To</h6>\r\n          <searchable-dropdown\r\n            [options]=\"ShipToList\"\r\n            placeholder=\"Ship To\"\r\n            [(selected)]=\"searchShipToName\">\r\n          </searchable-dropdown>\r\n        </div>\r\n        <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n          <h6>License Key</h6>\r\n          <input class=\"form-control\" type=\"text\" placeholder=\"Select License Key\" [(ngModel)]=\"searchLicenseKey\"/>\r\n        </div>\r\n      </div>\r\n      <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n        <div style=\"display: flex; flex-direction: row;\">\r\n          <div style=\"margin: 1%;\">\r\n            <button md-raised-button style=\"background-color: #FFCA28\" (click)=\"search()\">Search</button>\r\n          </div>\r\n          <div style=\"margin: 1%;\">\r\n            <button md-raised-button (click)=\"clearSearch()\">Clear</button>\r\n          </div>\r\n        </div>\r\n        <div style=\"display: flex; flex-direction: row;\">\r\n          <div style=\"margin: 1%;\">\r\n            <button *ngIf=\"IsAddEdit\" md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"openGenerateNewLicenseRequestDialog()\">\r\n                Generate New License Request\r\n            </button>\r\n          </div>\r\n          <div style=\"margin: 1%;\">\r\n            <button md-raised-button style=\"background-color: #FFCA28 ;\" class=\"iconsize\" mdTooltip=\"Export to CSV\" (click)=\"exportToCSV()\">\r\n              <em class=\"fa fa-download\"></em>\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">&nbsp;</div>\r\n      <div class=\"row\" *ngIf=\"errorMessage!==''\" class=\"alert alert-danger\">\r\n        <div class=\"col-12\">{{errorMessage}}</div>\r\n      </div>\r\n      <div class=\"row\">&nbsp;</div>\r\n      <div class=\"row\" *ngIf=\"pagedItems?.length > 0\">\r\n        <div class=\"col-12\">\r\n          <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n              <tbody>\r\n                <th class=\"mdl-data-table__cell--non-numeric\">Bill To\r\n                  <button *ngIf=\"currentSortColumn==='BillToName' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                      <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                  </button>\r\n                  <button *ngIf=\"currentSortColumn==='BillToName' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                      <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                  </button>\r\n                  <sort-dropdown\r\n                    columnName=\"BillToName\"\r\n                    (sortChange)=\"onSortChange($event)\">\r\n                  </sort-dropdown>\r\n                </th>\r\n                <th class=\"mdl-data-table__cell--non-numeric\"\r\n                  style=\"align-items: center;  justify-content: center;\" >Ship To\r\n                  <button *ngIf=\"currentSortColumn==='ShipToName' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                      <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                  </button>\r\n                  <button *ngIf=\"currentSortColumn==='ShipToName' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                      <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                  </button>\r\n                  <sort-dropdown\r\n                    columnName=\"ShipToName\"\r\n                    (sortChange)=\"onSortChange($event)\">\r\n                  </sort-dropdown>\r\n                </th>\r\n                <th class=\"mdl-data-table__cell--non-numeric\">\r\n                  License Key\r\n                  <button *ngIf=\"currentSortColumn==='LicenseKey' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                      <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                  </button>\r\n                  <button *ngIf=\"currentSortColumn==='LicenseKey' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                      <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                  </button>\r\n                  <sort-dropdown\r\n                    columnName=\"LicenseKey\"\r\n                    (sortChange)=\"onSortChange($event)\">\r\n                  </sort-dropdown>\r\n                </th>\r\n                <th class=\"mdl-data-table__cell--non-numeric\">\r\n                  Sales Order\r\n                  <button *ngIf=\"currentSortColumn==='SalesOrderNo' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                      <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                  </button>\r\n                  <button *ngIf=\"currentSortColumn==='SalesOrderNo' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                      <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                  </button>\r\n                  <sort-dropdown\r\n                    columnName=\"SalesOrderNo\"\r\n                    (sortChange)=\"onSortChange($event)\">\r\n                  </sort-dropdown>\r\n                </th>\r\n                <th class=\"mdl-data-table__cell--non-numeric\">Expiry Date</th>\r\n                <th class=\"mdl-data-table__cell--non-numeric\">No of installation</th>\r\n                <th class=\"mdl-data-table__cell--non-numeric\">Total Activation</th>\r\n                <th *ngIf=\"IsAddEdit\" class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                <tr *ngFor=\"let row of pagedItems | Service360FilterPipe: filterBillToName : filterShipToName : filterLicenseKey\">\r\n                  <td class=\"mdl-data-table__cell--non-numeric\">\r\n                    <div>\r\n                      <div>\r\n                          <span style=\"font-weight: bold;\">{{row.BillToName}}</span>\r\n                      </div>\r\n                      <div>\r\n                          <span>{{row.BillToAddress1}}</span>\r\n                      </div>\r\n                      <div>\r\n                          <span>{{row.BillToAddress2}}</span>\r\n                      </div>\r\n                      <div>\r\n                          <span>{{row.BillToCity}}</span>\r\n                          <span>{{row.BillToState}}</span>\r\n                      </div>\r\n                    </div>\r\n                  </td>\r\n                  <td class=\"mdl-data-table__cell--non-numeric\">\r\n                    <div>\r\n                      <div>\r\n                          <span style=\"font-weight: bold;\">{{row.ShipToName}}</span>\r\n                      </div>\r\n                      <div>\r\n                          <span>{{row.ShipToAddress1}}</span>\r\n                      </div>\r\n                      <div>\r\n                          <span>{{row.ShipToAddress2}}</span>\r\n                      </div>\r\n                      <div>\r\n                          <span>{{row.ShipToCity}}</span>\r\n                          <span>{{row.ShipToState}}</span>\r\n                      </div>\r\n                    </div>\r\n                  </td>\r\n                  <td class=\"mdl-data-table__cell--non-numeric\">\r\n                    <span>{{\r\n                      row.LicenseKey\r\n                      }}</span>\r\n                  </td>\r\n                  <td class=\"mdl-data-table__cell--non-numeric\">\r\n                    <span>{{\r\n                      row.SalesOrderNo\r\n                      }}</span>\r\n                  </td>\r\n                  <td class=\"mdl-data-table__cell--non-numeric\">\r\n                    <span>{{\r\n                      row.ExpiryDate | date :'dd MMM yyyy'\r\n                      }}</span>\r\n                  </td>\r\n                  <td class=\"mdl-data-table__cell--non-numeric\">\r\n                    <span>{{\r\n                      row.NoOfInstallation\r\n                      }}</span>\r\n                  </td>\r\n                  <td class=\"mdl-data-table__cell--non-numeric\">\r\n                    <button style=\"background: none; border: none;\" (click)=\"viewActivationHistory(row)\">\r\n                      <span style=\"color: rgba(14, 114, 160);\">{{\r\n                        row.NoOfActivations\r\n                        }}</span>\r\n                    </button>\r\n                  </td>\r\n                  <td *ngIf=\"IsAddEdit\" class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                      <span>\r\n                          <button md-icon-button mdTooltip=\"Edit License\" (click)=\"onEdit(row)\">\r\n                              <em class=\"fa fa-edit\"></em>\r\n                          </button>\r\n                      </span>\r\n                      <span>\r\n                          <button *ngIf=\"row.IsRevoke!=0\" md-icon-button mdTooltip=\"Deactivate License\" (click)=\"deactivateLicense(row)\">\r\n                              <em class=\"fa fa-ban\"></em>\r\n                          </button>\r\n                      </span>\r\n                      <span>\r\n                        <button *ngIf=\"row.IsRevoke==0\" md-icon-button mdTooltip=\"Activate License\" (click)=\"activateLicense(row)\">\r\n                          <em class=\"fa fa-check-circle\"></em>\r\n                        </button>\r\n                      </span>\r\n                    \r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n            <ul *ngIf=\"pager.pages && pager.pages.length\" class=\"pagination\"\r\n                style=\"float: right !important;\">\r\n                <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                    <a (click)=\"setPage(1)\">First</a>\r\n                </li>\r\n                <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                    <a (click)=\"setPage(pager.currentPage - 1)\">Previous</a>\r\n                </li>\r\n                <li *ngFor=\"let page of pager.pages\" [ngClass]=\"{active:pager.currentPage === page}\"\r\n                    style=\"cursor:pointer;\">\r\n                    <a (click)=\"setPage(page)\">{{page}}</a>\r\n                </li>\r\n                <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                    style=\"cursor:pointer;\">\r\n                    <a (click)=\"setPage(pager.currentPage + 1)\">Next</a>\r\n                </li>\r\n                <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                    style=\"cursor:pointer;\">\r\n                    <a (click)=\"setPage(pager.totalPages)\">Last</a>\r\n                </li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>"

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div style=\"display: flex; flex-direction: row; justify-content: space-between; align-items: center;\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        <div style=\"display: flex; flex-direction: row; justify-content:center;\">\r\n            <div style=\"margin:5px;width:250px; height:100%\"> \r\n                <searchable-dropdown\r\n                [options]=\"BillToList\"\r\n                placeholder=\"Customer Name\"\r\n                [(selected)]=\"searchCustomerName\">\r\n              </searchable-dropdown>\r\n            </div>\r\n            <div style=\"margin:5px;\">\r\n                <button\r\n                    md-raised-button\r\n                    style=\"background-color:#FFCA28;\"\r\n                    (click)=\"search()\">\r\n                    Search\r\n                </button>\r\n            </div>\r\n            <div style=\"margin:5px;\">\r\n                <button\r\n                    md-raised-button\r\n                    style=\"background-color:white; margin-right:100px\"\r\n                    (click)=\"clear()\">\r\n                    Clear\r\n                </button>\r\n            </div>\r\n            <button style=\"background: none; border: none;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div  *ngIf=\"errorMessage!=''\" class=\"col-12\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center; align-items: center;\">\r\n        <md-spinner></md-spinner>\r\n    </div>\r\n    <div *ngIf=\"pagedItems?.length > 0\" class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n                <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Customer No</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Sales Order No</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Customer Name\r\n                        <button *ngIf=\"currentSortColumn==='BillToName' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                            <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                        </button>\r\n                        <button *ngIf=\"currentSortColumn==='BillToName' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                            <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                        </button>\r\n                        <sort-dropdown\r\n                            columnName=\"BillToName\"\r\n                            (sortChange)=\"onSortChange($event)\">\r\n                        </sort-dropdown>\r\n                    </th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Address Line 1</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Address Line 2</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Customer Email</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                    <tr *ngFor=\"let row of pagedItems;\"> \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.CustomerNo}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.Number}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <span>{{row.BillToName}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\" style=\"text-wrap: wrap;\">\r\n                            <span>{{row.BillToAddress1}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\" style=\"text-wrap: wrap;\">\r\n                            <span>{{row.BillToAddress2}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\" style=\"text-wrap: wrap;\">\r\n                            <span>{{row.CustomerEmailAddress}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                            <button md-icon-button mdTooltip=\"Assign Key\" (click)=\"assignCustomer(row)\"><em class=\"fa fa-check\"></em></button>\r\n                        </td>  \r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n            <ul *ngIf=\"pager.pages && pager.pages.length\" class=\"pagination\"\r\n              style=\"float: right !important;\">\r\n              <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                  <a (click)=\"setPage(1)\">First</a>\r\n              </li>\r\n              <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                  <a (click)=\"setPage(pager.currentPage - 1)\">Previous</a>\r\n              </li>\r\n              <li *ngFor=\"let page of pager.pages\" [ngClass]=\"{active:pager.currentPage === page}\"\r\n                  style=\"cursor:pointer;\">\r\n                  <a (click)=\"setPage(page)\">{{page}}</a>\r\n              </li>\r\n              <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                  style=\"cursor:pointer;\">\r\n                  <a (click)=\"setPage(pager.currentPage + 1)\">Next</a>\r\n              </li>\r\n              <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                  style=\"cursor:pointer;\">\r\n                  <a (click)=\"setPage(pager.totalPages)\">Last</a>\r\n              </li>\r\n          </ul>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports = "<section>\r\n    <div class=\"container-fluid\">\r\n        <h3 class=\"title\">Smart-Cal 360 N</h3>\r\n    </div>\r\n    <div class=\"container-fluid\">\r\n      <hr />\r\n      <form [formGroup]=\"smartCal360NLicenseForm\">\r\n        <div class=\"row\"> \r\n          <div class=\"col-md-2\" style=\"margin-bottom: 1%;\">\r\n            <h6>Serial Number From<span style=\"color: red;\">*</span></h6>\r\n            <input  class=\"form-control\" type=\"number\" formControlName=\"SerialNoFrom\" placeholder=\"Serial Number From\"/>\r\n            <div *ngIf=\"submitted &amp;&amp; smartCal360NLicenseForm.controls.SerialNoFrom.errors\">\r\n                    <div *ngIf=\"smartCal360NLicenseForm.controls.SerialNoFrom.errors.required\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Please input starting Serial Number</span>\r\n                    </div>                 \r\n                </div>\r\n          </div>\r\n          <div class=\"col-md-2\" style=\"margin-bottom: 1%;\">\r\n            <h6>Serial Number To<span style=\"color: red;\">*</span></h6>\r\n            <input  class=\"form-control\" type=\"number\" formControlName=\"SerialNoTo\" placeholder=\"Serial Number To\"/>\r\n            <div *ngIf=\"submitted &amp;&amp; smartCal360NLicenseForm.controls.SerialNoTo.errors\">\r\n                    <div *ngIf=\"smartCal360NLicenseForm.controls.SerialNoTo.errors.required\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Please input ending Serial Number.</span>\r\n                    </div>                 \r\n                </div>\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n          </div>\r\n            <div class=\"col-md-2\" style=\"padding-right: 5px;\">\r\n              <h6>&nbsp;</h6>\r\n              <input\r\n                class=\"form-control\"\r\n                type=\"number\"\r\n                min=\"1\"\r\n                formControlName=\"SearchSerialNumber\"\r\n                placeholder=\"Search Serial Number\" \r\n                style=\"height: 37px;\"/>\r\n                <div *ngIf=\"this.smartCal360NLicenseForm.controls.SearchSerialNumber.errors?.min\"><span style=\"color:red;font-weight: bold;\">{{serialNoValidationMessage}}</span></div>\r\n            </div>\r\n\r\n            <div class=\"col-md-1\" style=\"padding-left: 0px; padding-right:5px\">\r\n              <h6>&nbsp;</h6>\r\n              <button\r\n                md-raised-button\r\n                style=\"background-color:#FFCA28; width:100%;\"\r\n                (click)=\"search()\">\r\n                Search\r\n              </button>\r\n            </div>\r\n            <div class=\"col-md-1\" style=\"padding-left: 0px; padding-right:5px\">\r\n              <h6>&nbsp;</h6>\r\n              <button\r\n                md-raised-button\r\n                style=\"background-color:white; width:100%;\"\r\n                (click)=\"clearSearch()\">\r\n                Clear\r\n              </button>\r\n            </div>\r\n        </div>\r\n        <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n          <div style=\"display: flex; flex-direction: row;\">\r\n            <div style=\"margin: 1%;\">\r\n              <button *ngIf=\"IsAddEdit\" md-raised-button style=\"background-color: #FFCA28\" (click)=\"generateSmartCal360NLicenseKey()\">Generate License Key</button>\r\n            </div>\r\n            <div style=\"margin: 1%;\">\r\n              <button md-raised-button (click)=\"clear()\">Clear</button>\r\n            </div>\r\n          </div>\r\n          <div style=\"display: flex; flex-direction: row;\">\r\n            <div style=\"margin: 1%;\">\r\n              <button *ngIf=\"IsAddEdit\" md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"openAssignCustomerDialog()\">\r\n                  Assign Customer\r\n              </button>\r\n            </div>\r\n            <div style=\"margin: 1%;\">\r\n              <button md-raised-button style=\"background-color: #FFCA28 ;\" class=\"iconsize\" mdTooltip=\"Export to CSV\" (click)=\"exportToCSV()\">\r\n                <em class=\"fa fa-download\"></em>\r\n              </button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </form>\r\n      <div class=\"row\">&nbsp;</div>\r\n      <div class=\"row\" *ngIf=\"errorMessage!==''\" class=\"alert alert-danger\">\r\n        <div class=\"col-12\">{{errorMessage}}</div>\r\n      </div>\r\n      <div class=\"row\">&nbsp;</div>\r\n      <div class=\"row\" *ngIf=\"pagedItems?.length > 0\">\r\n        <div class=\"col-12\">\r\n          <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n              <tbody>\r\n                <th class=\"mdl-data-table__cell--non-numeric\"></th>\r\n                <th class=\"mdl-data-table__cell--non-numeric\">Product Serial Number\r\n                  <button *ngIf=\"currentSortColumn==='ProductSerialNo' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                      <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                  </button>\r\n                  <button *ngIf=\"currentSortColumn==='ProductSerialNo' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                      <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                  </button>\r\n                  <sort-dropdown\r\n                      columnName=\"ProductSerialNo\"\r\n                      (sortChange)=\"onSortChange($event)\">\r\n                  </sort-dropdown>\r\n                </th>\r\n                <th class=\"mdl-data-table__cell--non-numeric\">Product Activation Key</th>\r\n                <th class=\"mdl-data-table__cell--non-numeric\">Customer Name\r\n                  <button *ngIf=\"currentSortColumn==='CustomerName' && currentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                      <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                  </button>\r\n                  <button *ngIf=\"currentSortColumn==='CustomerName' && currentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                      <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                  </button>\r\n                  <sort-dropdown\r\n                      columnName=\"CustomerName\"\r\n                      (sortChange)=\"onSortChange($event)\">\r\n                  </sort-dropdown>\r\n                </th>\r\n                <th style=\"text-wrap: wrap;\" class=\"mdl-data-table__cell--non-numeric\">License Key Creation Date</th>\r\n                <tr *ngFor=\"let row of pagedItems;let i=index;\" [ngClass]=\"{'selected-row':selectedRow[i]===i}\">\r\n                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                        <button style=\"background: none; border: none;\" (click)=\"selectRow(i,row)\"><em class=\"fa fa-check\"></em></button>\r\n                    </td>\r\n                  <td class=\"mdl-data-table__cell--non-numeric\">\r\n                    <span>\r\n                      {{row.ProductSerialNo}}\r\n                    </span>\r\n                  </td>\r\n                  <td class=\"mdl-data-table__cell--non-numeric\">\r\n                    <span>{{row.ProductActivationKey}}</span>\r\n                  </td>\r\n                  <td class=\"mdl-data-table__cell--non-numeric\">\r\n                    <span>{{\r\n                      row.CustomerName\r\n                      }}</span>\r\n                  </td>\r\n                  <td class=\"mdl-data-table__cell--non-numeric\">\r\n                    <span>{{\r\n                      row.CreatedDate | date:'dd  MMM yyyy'\r\n                      }}</span>\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n            <ul *ngIf=\"pager.pages && pager.pages.length\" class=\"pagination\"\r\n            style=\"float: right !important;\">\r\n            <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                <a (click)=\"setPage(1)\">First</a>\r\n            </li>\r\n            <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                <a (click)=\"setPage(pager.currentPage - 1)\">Previous</a>\r\n            </li>\r\n            <li *ngFor=\"let page of pager.pages\" [ngClass]=\"{active:pager.currentPage === page}\"\r\n                style=\"cursor:pointer;\">\r\n                <a (click)=\"setPage(page)\">{{page}}</a>\r\n            </li>\r\n            <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                style=\"cursor:pointer;\">\r\n                <a (click)=\"setPage(pager.currentPage + 1)\">Next</a>\r\n            </li>\r\n            <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                style=\"cursor:pointer;\">\r\n                <a (click)=\"setPage(pager.totalPages)\">Last</a>\r\n            </li>\r\n        </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>"

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <section>\r\n        <div class=\"col-12\">\r\n            <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        </div>\r\n        <div class=\"col-12\">&nbsp; </div>\r\n        <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n            <div class=\"alert alert-danger\">\r\n                {{errorMessage}}\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">\r\n            <form [formGroup]=\"smartLink360LicenseForm\">\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Purchase Date</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"PurchaseInvoiceDate\" type=\"date\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; smartLink360LicenseForm.controls.PurchaseInvoiceDate.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"smartLink360LicenseForm.controls.PurchaseInvoiceDate.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Purchase Date field is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Support Service Agreement Validity(in Months)</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"SupportValidityYear\" type=\"number\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; smartLink360LicenseForm.controls.SupportValidityYear.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"smartLink360LicenseForm.controls.SupportValidityYear.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">Support Service Agreement Validity is required.</span>\r\n                    </div>                 \r\n                </div> \r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Sales Order No</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"SalesOrderNo\" (blur)=\"blurSalesOrderEvent()\" type=\"text\"/>\r\n                        </div>\r\n                    <div class=\"col-md-4\">\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ; height: 30px; text-align: center;\" (click)=\"checkSalesOrderNo()\">Fetch Customer</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\" *ngIf=\"error!=''\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">{{error}}</span>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; smartLink360LicenseForm.controls.SalesOrderNo.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"smartLink360LicenseForm.controls.SalesOrderNo.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> SalesOrderNo is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div *ngIf=\"isBillingShippingDetailFetched\" class=\"form-group row\">\r\n                    <div class=\"col-md-6\">\r\n                        <span>Billing Address</span>\r\n                        <hr color=\"#FFCA28\"/>\r\n                        <div>\r\n                            <span style=\"font-weight: bold;\">{{this.billingShippingDetail.BillToName}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToAddress1}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToAddress2}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.BillToCity}}</span>\r\n                            <span>{{billingShippingDetail.BillToState}}</span>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                        <span>Shipping Address</span>\r\n                        <hr color=\"#FFCA28\"/>\r\n                        <div>\r\n                            <span style=\"font-weight: bold;\">{{billingShippingDetail.ShipToName}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToAddress1}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToAddress2}}</span>\r\n                        </div>\r\n                        <div>\r\n                            <span>{{billingShippingDetail.ShipToCity}}</span>\r\n                            <span>{{billingShippingDetail.ShipToState}}</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-12\"> <!--1. Form valid or not validationForm.valid used 2. Form has any changes for that validationForm.pristine used 3.some situation save button disabled and Enabled that's why we use SaveButtonDisbaled) -->\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ;\"\r\n                            [disabled]=\"!smartLink360LicenseForm.valid || smartLink360LicenseForm.pristine\"\r\n                            (click)=\"onSave()\">Save</button>                        \r\n                        <span class=\"space\"></span>\r\n                        <button md-raised-button [disabled]=\"CancelButtonDisabled\"\r\n                            (click)=\"onCancel()\">Cancel</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </section>\r\n</article>\r\n\r\n\r\n"

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <section>\r\n        <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n            <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n            <div>\r\n                <button style=\"background: none; border: none; padding: 0px; margin: 0px;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">&nbsp; </div>\r\n        <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n            <div class=\"alert alert-danger\">\r\n                {{errorMessage}}\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">\r\n            <div  class=\"form-group row\">\r\n                <div class=\"col-md-6\">\r\n                    <span>Billing Address</span>\r\n                    <hr color=\"#FFCA28\"/>\r\n                    <div>\r\n                        <span style=\"font-weight: bold;\">{{this.billingShippingDetail.BillToName}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.BillToAddress1}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.BillToAddress2}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.BillToCity}}</span>\r\n                        <span>{{billingShippingDetail.BillToState}}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <span>Shipping Address</span>\r\n                    <hr color=\"#FFCA28\"/>\r\n                    <div>\r\n                        <span style=\"font-weight: bold;\">{{billingShippingDetail.ShipToName}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.ShipToAddress1}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.ShipToAddress2}}</span>\r\n                    </div>\r\n                    <div>\r\n                        <span>{{billingShippingDetail.ShipToCity}}</span>\r\n                        <span>{{billingShippingDetail.ShipToState}}</span>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <form [formGroup]=\"renewSmartlink360LicenseForm\">\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Renewal Type</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <md-radio-group formControlName=\"RenewalType\">\r\n                            <md-radio-button *ngFor=\"let type of SCALRenewalTypeList\" [value]=\"type.value\" style=\"margin-right: 5px;\">\r\n                                {{type.name}}\r\n                            </md-radio-button>\r\n                        </md-radio-group>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Purchase Date</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"PurchaseDate\" type=\"date\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; renewSmartlink360LicenseForm.controls.PurchaseDate.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"renewSmartlink360LicenseForm.controls.PurchaseDate.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Purchase Date field is required.</span>\r\n                    </div>                 \r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Support Service Agreement Validity(in Months)<span style=\"color: red;\">*</span></label>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"SupportValidityYear\" type=\"number\"/>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; renewSmartlink360LicenseForm.controls.SupportValidityYear.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"renewSmartlink360LicenseForm.controls.SupportValidityYear.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">Support Service Agreement Validity is required.</span>\r\n                    </div>                 \r\n                </div> \r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                        <label class=\"control-label\">Sales Order No</label><span style=\"color: red;\">*</span>\r\n                    </div>\r\n                    <div class=\"col-md-4\">\r\n                        <input class=\"form-control\" \r\n                            formControlName=\"SalesOrderNo\" (blur)=\"blurSalesOrderEvent()\" type=\"text\"/>\r\n                        </div>\r\n                    <div class=\"col-md-4\">\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ; height: 30px; text-align: center;\" (click)=\"checkSalesOrderNo()\">Fetch Customer</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\" *ngIf=\"error!=''\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\">{{error}}</span>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-12\"> <!--1. Form valid or not validationForm.valid used 2. Form has any changes for that validationForm.pristine used 3.some situation save button disabled and Enabled that's why we use SaveButtonDisbaled) -->\r\n                        <button md-raised-button style=\"background-color:  #FFCA28 ;\"\r\n                            [disabled]=\"SaveButtonDisabled || (!renewSmartlink360LicenseForm.valid || renewSmartlink360LicenseForm.pristine)\"\r\n                            (click)=\"onSave()\">Save</button>                        \r\n                        <span class=\"space\"></span>\r\n                        <button md-raised-button [disabled]=\"CancelButtonDisabled\"\r\n                            (click)=\"onCancel()\">Cancel</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </section>\r\n</article>\r\n\r\n\r\n"

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        <div>\r\n            <button style=\"background: none; border: none; padding: 0px; margin: 0px;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"error!=''\">\r\n        <span class=\"alert alert-danger\">{{error}}</span>\r\n    </div>\r\n    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center;\">\r\n        <md-spinner></md-spinner>\r\n    </div>\r\n    <div  *ngIf=\"ActivationDetail?.length>0\" class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n                <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Name</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">EmailId</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Mobile</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Hardware Id</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Installation Date</th>\r\n                    <tr *ngFor=\"let row of ActivationDetail\"> \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.Name}}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.EmailId}}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.MobileNo}}\r\n                        </td>  \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.HardwareId}}\r\n                        </td>    \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.InstallationDate | date:'dd MMM yyyy'}}\r\n                        </td>      \r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n        <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n        <div>\r\n            <button style=\"background: none; border: none; padding: 0px; margin: 0px;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-12\" *ngIf=\"error!=''\">\r\n        <span class=\"alert alert-danger\">{{error}}</span>\r\n    </div>\r\n    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center;\">\r\n        <md-spinner></md-spinner>\r\n    </div>\r\n    <div  *ngIf=\"feedbackDetails?.length>0\" class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n            <ng-container *ngFor=\"let row of feedbackDetails; let i=index;\">\r\n                <div (click)=\"selectRow(i)\" style=\"margin: 3px 0px 3px 0px\">\r\n                   <span class=\"form-control\">{{row.FeedbackDate}}</span> \r\n                </div>\r\n                <div *ngIf=\"selectedRow === i\">\r\n                    <table class=\"mdl-data-table table-striped col-12\">\r\n                        <tbody>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Question</th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Answer</th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Description</th>\r\n                            <tr *ngFor=\"let subRow of row.QuestionAnswer\">\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    {{subRow.Question}}\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    {{subRow.Answer}}\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    {{subRow.Description}}\r\n                                </td>     \r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n    <div class=\"col-12\">\r\n        <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n            <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{dialogTitle}}</h3>\r\n            <div>\r\n                <button style=\"background: none; border: none; padding: 0px; margin: 0px;\" (click)=\"onCancel()\"><em class=\"fa fa-close\"></em></button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp; </div>\r\n    <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n        <div class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"isLoading\" style=\"display: flex; justify-content: center; align-items: center;\">\r\n        <md-spinner></md-spinner>\r\n    </div>\r\n    <div *ngIf=\"renewalHistoryDetail?.length>0\" class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n            <table class=\"mdl-data-table table-striped col-12\">\r\n                <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Bill To</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Ship To</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Purchase Date</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">No Of Months</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Renewal Date</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Sales Order No</th>\r\n                    <tr *ngFor=\"let row of renewalHistoryDetail\"> \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <div>\r\n                                <div>\r\n                                    <span style=\"font-weight: bold;\">{{row.BillToName}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.BillToAddress1}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.BillToAddress2}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.BillToCity}}</span>\r\n                                    <span>{{row.BillToState}}</span>\r\n                                </div>\r\n                              </div>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            <div>\r\n                                <div>\r\n                                    <span style=\"font-weight: bold;\">{{row.ShipToName}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.ShipToAddress1}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.ShipToAddress2}}</span>\r\n                                </div>\r\n                                <div>\r\n                                    <span>{{row.ShipToCity}}</span>\r\n                                    <span>{{row.ShipToState}}</span>\r\n                                </div>\r\n                              </div>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.PurchaseDate | date:'dd MMM yyyy'}}\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.NoOfMonths}}\r\n                        </td>  \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.CreatedDate | date:'dd MMM yyyy'}}\r\n                        </td>    \r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                            {{row.SalesOrderNo}}\r\n                        </td>      \r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid\">\r\n    <div>\r\n        <h3 class=\"title\">Smart-Link 360</h3>\r\n    </div>\r\n    <md-tab-group>\r\n        <md-tab label=\"Demo License Info\">\r\n            <div class=\"md-tab-content\" style=\"border:1px solid #ddd;\">\r\n                <div class=\"container-fluid\">\r\n                    <div class=\"row\"> \r\n                        <div class=\"col-md-2\" style=\"margin-bottom: 1%;\">\r\n                          <h6>Name</h6>\r\n                          <input class=\"form-control\" type=\"text\" placeholder=\"Search Name\" [(ngModel)]=\"searchName\"/>\r\n                        </div>\r\n                        <div class=\"col-md-2\" style=\"margin-bottom: 1%;\">\r\n                          <h6>Email Id</h6>\r\n                          <input class=\"form-control\" type=\"text\" placeholder=\"Search Email Id\" [(ngModel)]=\"searchEmailId\"/>\r\n                        </div>\r\n                        <div class=\"col-md-2\" style=\"margin-bottom: 1%;\">\r\n                          <h6>Mobile</h6>\r\n                          <input class=\"form-control\" type=\"text\" placeholder=\"Search Mobile\" [(ngModel)]=\"searchMobileNo\"/>\r\n                        </div>\r\n                        <div class=\"col-md-2\" style=\"margin-bottom: 1%;\">\r\n                            <h6>License Key</h6>\r\n                            <input class=\"form-control\" type=\"text\" placeholder=\"Search License Key\" [(ngModel)]=\"searchDemoLicenseKey\"/>\r\n                        </div>\r\n                    </div>\r\n                    <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n                        <div style=\"display: flex; flex-direction: row; margin-bottom: 1%;\">\r\n                            <div style=\"margin: 1%;\">\r\n                                <button md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"searchDemoLicenseInfo()\">Search</button>\r\n                            </div>\r\n                            <div style=\"margin: 1%;\">\r\n                                <button md-raised-button (click)=\"clearDemoLicenseInfo()\">Clear</button>\r\n                            </div>\r\n                        </div>\r\n                        <div style=\"display: flex; flex-direction: row; margin-bottom: 1%;\">\r\n                            <button md-raised-button style=\"background-color: #FFCA28 ;\" class=\"iconsize\" mdTooltip=\"Export to CSV\" (click)=\"exportDemoLicenseInfoToCSV()\">\r\n                                <em class=\"fa fa-download\"></em>\r\n                            </button>\r\n                        </div>\r\n                    </div>\r\n                    <div\r\n                        class=\"row\"\r\n                        *ngIf=\"error!=''\"\r\n                        class=\"alert alert-danger\"\r\n                    >\r\n                        <div class=\"col-12\">{{error}}</div>\r\n                    </div>\r\n                    <div\r\n                        class=\"row\"\r\n                        *ngIf=\"errorMessageDemoPage!=''\"\r\n                        class=\"alert alert-danger\"\r\n                    >\r\n                        <div class=\"col-12\">{{errorMessageDemoPage}}</div>\r\n                    </div>\r\n                    <div *ngIf=\"demoPageItems?.length > 0\" class=\"table-responsive\">\r\n                        <table class=\"mdl-data-table table-striped col-12\">\r\n                            <tbody>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Name\r\n                                    <button *ngIf=\"demoCurrentSortColumn==='Name' && demoCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                    </button>\r\n                                    <button *ngIf=\"demoCurrentSortColumn==='Name' && demoCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                    </button>\r\n                                    <sort-dropdown\r\n                                        columnName=\"Name\"\r\n                                        (sortChange)=\"onDemoSortChange($event)\">\r\n                                    </sort-dropdown>\r\n                                </th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Email Id\r\n                                    <button *ngIf=\"demoCurrentSortColumn==='EmailId' && demoCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                    </button>\r\n                                    <button *ngIf=\"demoCurrentSortColumn==='EmailId' && demoCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                    </button>\r\n                                    <sort-dropdown\r\n                                        columnName=\"EmailId\"\r\n                                        (sortChange)=\"onDemoSortChange($event)\">\r\n                                    </sort-dropdown>\r\n                                </th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Mobile No</th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Organisation\r\n                                    <button *ngIf=\"demoCurrentSortColumn==='Organization' && demoCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                    </button>\r\n                                    <button *ngIf=\"demoCurrentSortColumn==='Organization' && demoCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                    </button>\r\n                                    <sort-dropdown\r\n                                        columnName=\"Organization\"\r\n                                        (sortChange)=\"onDemoSortChange($event)\">\r\n                                    </sort-dropdown>\r\n                                </th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Expiry Date</th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">License Type\r\n                                    <button *ngIf=\"demoCurrentSortColumn==='LicenseType' && demoCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                    </button>\r\n                                    <button *ngIf=\"demoCurrentSortColumn==='LicenseType' && demoCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                    </button>\r\n                                    <sort-dropdown\r\n                                        columnName=\"LicenseType\"\r\n                                        (sortChange)=\"onDemoSortChange($event)\">\r\n                                    </sort-dropdown>\r\n                                </th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Hardware Id</th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">License Key\r\n                                    <button *ngIf=\"demoCurrentSortColumn==='LicenseKey' && demoCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                    </button>\r\n                                    <button *ngIf=\"demoCurrentSortColumn==='LicenseKey' && demoCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                        <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                    </button>\r\n                                    <sort-dropdown\r\n                                        columnName=\"LicenseKey\"\r\n                                        (sortChange)=\"onDemoSortChange($event)\">\r\n                                    </sort-dropdown>\r\n                                </th> \r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Status</th> \r\n                                <th class=\"mdl-data-table__cell--non-numeric\">Action</th> \r\n                                <tr *ngFor=\"let info of demoPageItems | smartlinkDemoLicenseFilter: filterName : filterEmailId : filterMobileNo : filterDemoLicenseKey\">\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.Name}}</span>                             \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.EmailId}}</span>                                \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.MobileNo}}</span>                                 \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.Organization}}</span>\r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.ExpiryDate  |  date:'dd MMM yyyy'}} </span>                                   \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.LicenseType}}</span>                                    \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.HardwareId}}</span>                                  \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{info.LicenseKey}}</span>                                   \r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <div *ngIf=\"info.Status=='Active'\" style=\"background-color: #FFCA28; color: black; border-radius: 3px; padding:2px; text-align: center; \">\r\n                                            <span>{{info.Status}}</span>      \r\n                                        </div>\r\n                                        <div *ngIf=\"info.Status=='InActive'\" style=\"background-color: red; color: white; border-radius: 3px; padding: 2px; text-align: center;\">\r\n                                            {{info.Status}}                           \r\n                                        </div>\r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                                        <button md-icon-button mdTooltip=\"View feedback\" (click)=\"viewFeedback(info)\">\r\n                                            <em class=\"fa fa-info\">\r\n                                            </em>\r\n                                        </button>\r\n                                    </td>\r\n                                </tr>\r\n                            </tbody>\r\n                        </table>\r\n                        <ul *ngIf=\"demoPager.pages && demoPager.pages.length\" class=\"pagination\"\r\n                        style=\"float: right !important;\">\r\n                            <li [ngClass]=\"{disabled:demoPager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                                <a (click)=\"setPageForDemo(1)\">First</a>\r\n                            </li>\r\n                            <li [ngClass]=\"{disabled:demoPager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                                <a (click)=\"setPageForDemo(demoPager.currentPage - 1)\">Previous</a>\r\n                            </li>\r\n                            <li *ngFor=\"let page of demoPager.pages\" [ngClass]=\"{active:demoPager.currentPage === page}\"\r\n                                style=\"cursor:pointer;\">\r\n                                <a (click)=\"setPageForDemo(page)\">{{page}}</a>\r\n                            </li>\r\n                            <li [ngClass]=\"{disabled:demoPager.currentPage === demoPager.totalPages}\"\r\n                                style=\"cursor:pointer;\">\r\n                                <a (click)=\"setPageForDemo(demoPager.currentPage + 1)\">Next</a>\r\n                            </li>\r\n                            <li [ngClass]=\"{disabled:demoPager.currentPage === demoPager.totalPages}\"\r\n                                style=\"cursor:pointer;\">\r\n                                <a (click)=\"setPageForDemo(demoPager.totalPages)\">Last</a>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                    \r\n                </div>\r\n            </div>\r\n        </md-tab>\r\n        <md-tab label=\"Purchase License Info\">\r\n            <div class=\"md-tab-content container-fluid\" style=\"border:1px solid #ddd;\">\r\n                <div class=\"row\"> \r\n                    <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n                      <h6>Bill To</h6>\r\n                      <searchable-dropdown\r\n                          [options]=\"BillToList\"\r\n                          placeholder=\"Bill To\"\r\n                          [(selected)]=\"searchBillTo\">\r\n                        </searchable-dropdown>\r\n                    </div>\r\n                    <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n                      <h6>Ship To</h6>\r\n                      <searchable-dropdown\r\n                          [options]=\"ShipToList\"\r\n                          placeholder=\"Ship To\"\r\n                          [(selected)]=\"searchShipTo\">\r\n                        </searchable-dropdown>\r\n                    </div>\r\n                    <div class=\"col-md-3\" style=\"margin-bottom: 1%;\">\r\n                      <h6>License Key</h6>\r\n                      <input class=\"form-control\" type=\"text\" placeholder=\"Select License Key\" [(ngModel)]=\"searchPurchaseLicenseKey\"/>\r\n                    </div>\r\n                </div>\r\n                <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n                    <div style=\"display: flex; flex-direction: row; margin-bottom: 1%;\">\r\n                      <div style=\"margin: 2%;\">\r\n                        <button md-raised-button style=\"background-color: #FFCA28\" (click)=\"searchPurchaseLicenseInfo()\">Search</button>\r\n                      </div>\r\n                      <div style=\"margin: 2%;\">\r\n                        <button md-raised-button (click)=\"clearPurchaseLicenseInfo()\">Clear</button>\r\n                      </div>\r\n                    </div>\r\n                    <div style=\"display: flex; flex-direction: row; margin-bottom: 1%;\">\r\n                        <div *ngIf=\"IsAddEdit\" style=\"margin: 1%;\">\r\n                            <button md-raised-button style=\"background-color: #FFCA28 ;\" (click)=\"generateNewLicenseRequest()\">\r\n                                Generate New License Request\r\n                            </button>\r\n                        </div>\r\n                      <div style=\"margin: 1%;\">\r\n                        <button md-raised-button style=\"background-color: #FFCA28 ;\" class=\"iconsize\" mdTooltip=\"Export to CSV\" (click)=\"exportPurchaseLicenseData()\">\r\n                            <em class=\"fa fa-download\"></em>\r\n                        </button>\r\n                      </div>\r\n                    </div>\r\n                </div>\r\n                <div\r\n                        class=\"row\"\r\n                        *ngIf=\"errorMessagePurchasePage!=''\"\r\n                        class=\"alert alert-danger\"\r\n                    >\r\n                        <div class=\"col-12\">{{errorMessagePurchasePage}}</div>\r\n                    </div>\r\n                <div *ngIf=\"purchasePageItems?.length > 0\" class=\"table-responsive\">\r\n                    <table class=\"mdl-data-table table-striped col-12\">\r\n                        <tbody>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Bill To\r\n                                <button *ngIf=\"purchaseCurrentSortColumn==='BillToName' && purchaseCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                    <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                </button>\r\n                                <button *ngIf=\"purchaseCurrentSortColumn==='BillToName' && purchaseCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                    <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                </button>\r\n                                <sort-dropdown\r\n                                  columnName=\"BillToName\"\r\n                                  (sortChange)=\"onPurchaseSortChange($event)\">\r\n                                </sort-dropdown>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Ship To\r\n                                <button *ngIf=\"purchaseCurrentSortColumn==='ShipToName' && purchaseCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                    <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                </button>\r\n                                <button *ngIf=\"purchaseCurrentSortColumn==='ShipToName' && purchaseCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                    <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                </button>\r\n                                <sort-dropdown\r\n                                  columnName=\"ShipToName\"\r\n                                  (sortChange)=\"onPurchaseSortChange($event)\">\r\n                                </sort-dropdown>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">License Key\r\n                                <button *ngIf=\"purchaseCurrentSortColumn==='LicenseKey' && purchaseCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                    <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                </button>\r\n                                <button *ngIf=\"purchaseCurrentSortColumn==='LicenseKey' && purchaseCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                    <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                </button>\r\n                                 <sort-dropdown\r\n                                  columnName=\"LicenseKey\"\r\n                                  (sortChange)=\"onPurchaseSortChange($event)\">\r\n                                </sort-dropdown>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Sales Order\r\n                                <button *ngIf=\"purchaseCurrentSortColumn==='SalesOrderNo' && purchaseCurrentSortOrder==='asc'\" style=\"background: none; border: none;\" >\r\n                                    <em class=\"fa fa-sort-up\" style=\"vertical-align: middle; padding-top:6px;\"></em>\r\n                                </button>\r\n                                <button *ngIf=\"purchaseCurrentSortColumn==='SalesOrderNo' && purchaseCurrentSortOrder==='desc'\" style=\"background: none; border: none;\" >\r\n                                    <em class=\"fa fa-sort-down\" style=\"vertical-align: middle; padding-bottom:6px\"></em>\r\n                                </button>\r\n                                 <sort-dropdown\r\n                                  columnName=\"SalesOrderNo\"\r\n                                  (sortChange)=\"onPurchaseSortChange($event)\">\r\n                                </sort-dropdown>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Total Activation</th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Purchase Date</th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">No Of months</th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric\">Expiry Date</th>\r\n                            <th *ngIf=\"IsAddEdit\" class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                            <tr *ngFor=\"let row of purchasePageItems | Service360FilterPipe: filterBillTo : filterShipTo : filterPurchaseLicenseKey \">\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <div>\r\n                                        <div>\r\n                                            <span style=\"font-weight: bold;\">{{row.BillToName}}</span>\r\n                                        </div>\r\n                                        <div>\r\n                                            <span>{{row.BillToAddress1}}</span>\r\n                                        </div>\r\n                                        <div>\r\n                                            <span>{{row.BillToAddress2}}</span>\r\n                                        </div>\r\n                                        <div>\r\n                                            <span>{{row.BillToCity}}</span>\r\n                                            <span>{{row.BillToState}}</span>\r\n                                        </div>\r\n                                      </div>\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <div>\r\n                                        <div>\r\n                                            <span style=\"font-weight: bold;\">{{row.ShipToName}}</span>\r\n                                        </div>\r\n                                        <div>\r\n                                            <span>{{row.ShipToAddress1}}</span>\r\n                                        </div>\r\n                                        <div>\r\n                                            <span>{{row.ShipToAddress2}}</span>\r\n                                        </div>\r\n                                        <div>\r\n                                            <span>{{row.ShipToCity}}</span>\r\n                                            <span>{{row.ShipToState}}</span>\r\n                                        </div>\r\n                                      </div>\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    {{row.LicenseKey}}\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    {{row.SalesOrderNo}}\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\" style=\"text-wrap: wrap;\">\r\n                                    <button style=\"background: none; border: none;\" (click)=\"viewActivationDetail(row)\">\r\n                                        <span style=\"color:rgba(14, 114, 160);; font-style: italic;\">\r\n                                            {{row.TotalNoOfActivation}}\r\n                                        </span>\r\n                                    </button>\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    {{row.PurchaseDate | date:'dd MMM yyyy'}}\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    {{row.NoOfMonths}}\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <button *ngIf=\"row.TagName=='NoExpired'\" style=\"background: none; border: none;\" (click)=\"viewRenewalHistory(row)\">\r\n                                        <span style=\"color: rgba(14, 114, 160);; font-style: italic;\">\r\n                                            {{row.ExpiryDate | date:'dd MMM yyyy'}}\r\n                                        </span>\r\n                                    </button>\r\n                                    <span  *ngIf=\"row.TagName=='Expired'\" style=\"color: red; font-style: italic;\">\r\n                                        {{row.ExpiryDate | date:'dd MMM yyyy'}}\r\n                                    </span>\r\n                                </td>\r\n                                <td *ngIf=\"IsAddEdit\" class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                                    <span>\r\n                                        <button md-icon-button mdTooltip=\"Edit License\" (click)=\"onEdit(row)\">\r\n                                            <em class=\"fa fa-edit\"></em>\r\n                                        </button>\r\n                                    </span>\r\n                                    <span>\r\n                                        <button md-icon-button mdTooltip=\"Renew License\" (click)=\"renewLicense(row)\">\r\n                                            <em class=\"fa fa-refresh\"></em>\r\n                                        </button>\r\n                                    </span>\r\n                                    <span>\r\n                                      <button *ngIf=\"row.IsRevoke==0\" md-icon-button mdTooltip=\"Delete License\" (click)=\"activateLicense(row)\">\r\n                                        <em class=\"fa fa-check-circle\"></em>\r\n                                      </button>\r\n                                    </span>\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                    <ul *ngIf=\"purchasePager.pages && purchasePager.pages.length\" class=\"pagination\"\r\n                        style=\"float: right !important;\">\r\n                        <li [ngClass]=\"{disabled:purchasePager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                            <a (click)=\"setPageForPurchase(1)\">First</a>\r\n                        </li>\r\n                        <li [ngClass]=\"{disabled:purchasePager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                            <a (click)=\"setPageForPurchase(purchasePager.currentPage - 1)\">Previous</a>\r\n                        </li>\r\n                        <li *ngFor=\"let page of purchasePager.pages\" [ngClass]=\"{active:purchasePager.currentPage === page}\"\r\n                            style=\"cursor:pointer;\">\r\n                            <a (click)=\"setPageForPurchase(page)\">{{page}}</a>\r\n                        </li>\r\n                        <li [ngClass]=\"{disabled:purchasePager.currentPage === purchasePager.totalPages}\"\r\n                            style=\"cursor:pointer;\">\r\n                            <a (click)=\"setPageForPurchase(purchasePager.currentPage + 1)\">Next</a>\r\n                        </li>\r\n                        <li [ngClass]=\"{disabled:purchasePager.currentPage === purchasePager.totalPages}\"\r\n                            style=\"cursor:pointer;\">\r\n                            <a (click)=\"setPageForPurchase(purchasePager.totalPages)\">Last</a>\r\n                        </li>\r\n                    </ul>\r\n                </div>\r\n            </div>\r\n        </md-tab>\r\n    </md-tab-group>\r\n</div>"

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n  <section>\r\n    <div\r\n      style=\"display: flex; flex-direction: row; justify-content: space-between\"\r\n    >\r\n      <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{ dialogTitle }}</h3>\r\n      <div>\r\n        <button\r\n          style=\"background: none; border: none; padding: 0px; margin: 0px\"\r\n          (click)=\"onCancel()\"\r\n        >\r\n          <em class=\"fa fa-close\"></em>\r\n        </button>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp;</div>\r\n    <div class=\"col-12\" *ngIf=\"errorMessage\">\r\n      <div class=\"alert alert-danger\">{{ errorMessage }}</div>\r\n    </div>\r\n    <form [formGroup]=\"syncITLicenseForm\">\r\n      <div class=\"form-group row\">\r\n        <div class=\"col-md-3\">\r\n          <label class=\"control-label\">Sales Order No</label\r\n          ><span style=\"color: red\">*</span>\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <input\r\n            class=\"form-control\"\r\n            formControlName=\"SalesOrderNo\"\r\n            (blur)=\"blurSalesOrderEvent()\"\r\n            type=\"text\"\r\n          />\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <button\r\n            md-raised-button\r\n            style=\"background-color: #ffca28; height: 30px; text-align: center\"\r\n            (click)=\"checkSalesOrderNo()\"\r\n          >\r\n            Fetch Customer\r\n          </button>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group row\" *ngIf=\"error != ''\">\r\n        <div class=\"col-md-4\"></div>\r\n        <div class=\"col-md-8\">\r\n          <span style=\"color: red; font-weight: bold\">{{ error }}</span>\r\n        </div>\r\n      </div>\r\n      <div\r\n        *ngIf=\"isBillingShippingDetailFetched && !isLoading\"\r\n        class=\"form-group row\"\r\n      >\r\n        <div class=\"col-md-6\">\r\n          <span>Billing Address</span>\r\n          <hr color=\"#FFCA28\" />\r\n          <div>\r\n            <span style=\"font-weight: bold\">{{\r\n              this.billingShippingDetail.BillToName\r\n            }}</span>\r\n          </div>\r\n          <div>\r\n            <span>{{ billingShippingDetail.BillToAddress1 }}</span>\r\n          </div>\r\n          <div>\r\n            <span>{{ billingShippingDetail.BillToAddress2 }}</span>\r\n          </div>\r\n          <div>\r\n            <span>{{ billingShippingDetail.BillToCity }}</span>\r\n            <span>{{ billingShippingDetail.BillToState }}</span>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-6\">\r\n          <span>Shipping Address</span>\r\n          <hr color=\"#FFCA28\" />\r\n          <div>\r\n            <span style=\"font-weight: bold\">{{\r\n              billingShippingDetail.ShipToName\r\n            }}</span>\r\n          </div>\r\n          <div>\r\n            <span>{{ billingShippingDetail.ShipToAddress1 }}</span>\r\n          </div>\r\n          <div>\r\n            <span>{{ billingShippingDetail.ShipToAddress2 }}</span>\r\n          </div>\r\n          <div>\r\n            <span>{{ billingShippingDetail.ShipToCity }}</span>\r\n            <span>{{ billingShippingDetail.ShipToState }}</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group row\">\r\n        <div class=\"col-md-12\">\r\n          <div\r\n            class=\"card mb-3 p-3\"\r\n            style=\"\r\n              border: 1px solid #ffca28;\r\n              border-radius: 5px;\r\n              background-color: #fff;\r\n            \"\r\n          >\r\n            <h5\r\n              class=\"card-title mb-3\"\r\n              style=\"font-weight: bold; color: #333; font-size: 20px\"\r\n            >\r\n              Sync IT Product List\r\n            </h5>\r\n            <div\r\n              class=\"form-group row font-weight-bold mb-2\"\r\n              style=\"border-bottom: 1px solid #ffca28; padding-bottom: 5px\"\r\n            >\r\n              <div class=\"col-md-5 text-right\">Product Name</div>\r\n              <div class=\"col-md-1 text-right\">Existing Instruments</div>\r\n              <div class=\"col-md-4 text-left\">No of Instruments [Trial Limit-{{MAX_TRIAL_INSTRUMENTS}}]</div>\r\n            </div>\r\n            <div formArrayName=\"Products\">\r\n              <div\r\n                class=\"form-group row align-items-center mb-2\"\r\n                *ngFor=\"\r\n                  let productCtrl of productsFormArray.controls;\r\n                  let i = index\r\n                \"\r\n                [formGroupName]=\"i\"\r\n              >\r\n                <!-- Product Name -->\r\n                <label\r\n                  class=\"col-md-5 col-form-label text-right\"\r\n                  style=\"font-weight: 500\"\r\n                >\r\n                  {{ productCtrl.value.ProductName }}\r\n                </label>\r\n\r\n                <label\r\n                  class=\"col-md-1 col-form-label text-right\"\r\n                  style=\"font-weight: 500\"\r\n                >\r\n                  {{ productCtrl.value.NoOfProductLicense }}\r\n                </label>\r\n                <!-- No of Licenses Input -->\r\n                <div class=\"col-md-4\">\r\n                  <input\r\n                    type=\"number\"\r\n                    min=\"0\"\r\n                    max=\"120\"\r\n                    placeholder=\"Number of licenses\"\r\n                    formControlName=\"NoOfLicense\"\r\n                    class=\"form-control form-control-sm\"\r\n                  />\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div\r\n              *ngIf=\"productsFormArray.errors?.noLicenseSelected && submitted\"\r\n              class=\"text-danger mb-2\"\r\n            >\r\n              Please select at least one product/license.\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group row\">\r\n        <div class=\"col-md-12\">\r\n          <button\r\n            md-raised-button\r\n            [disabled]=\"isSaveDisabled || !isBillingShippingDetailFetched\"\r\n            style=\"background-color: #ffca28\"\r\n            (click)=\"onSave()\"\r\n          >\r\n            Save\r\n          </button>\r\n          <span class=\"space\"></span>\r\n          <button\r\n            md-raised-button\r\n            [disabled]=\"CancelButtonDisabled\"\r\n            (click)=\"onCancel()\"\r\n          >\r\n            Cancel\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </section>\r\n</article>\r\n"

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n  <section>\r\n    <div\r\n      style=\"display: flex; flex-direction: row; justify-content: space-between\"\r\n    >\r\n      <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">Extend Trial Period</h3>\r\n      <div>\r\n        <button\r\n          style=\"background: none; border: none; padding: 0px; margin: 0px\"\r\n          (click)=\"onCancel()\"\r\n        >\r\n          <em class=\"fa fa-close\"></em>\r\n        </button>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp;</div>\r\n    <div class=\"col-12\" *ngIf=\"errorMessage\">\r\n      <div class=\"alert alert-danger\">{{ errorMessage }}</div>\r\n    </div>\r\n    <form [formGroup]=\"SyncItExtendTrialPeriodForm\">\r\n      <!-- Show Months only for Extend Trial -->\r\n      <!-- Show input only for Extend Trial -->\r\n      <div class=\"form-group row\">\r\n        <div class=\"col-md-2\">\r\n          <label class=\"control-label\"> Trial Month </label>\r\n          <span style=\"color: red\">*</span>\r\n        </div>\r\n\r\n        <div class=\"col-md-10\">\r\n          <input\r\n            type=\"number\"\r\n            class=\"form-control\"\r\n            formControlName=\"NoOfMonths\"\r\n            style=\"width: 100px\"\r\n            min=\"1\"\r\n            max=\"120\"\r\n          />\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Show Sales Order No only for Renew -->\r\n\r\n      <!-- Error messages -->\r\n\r\n      <div class=\"form-group row\">\r\n        <div class=\"col-md-12\">\r\n          <button\r\n            [disabled]=\"!SyncItExtendTrialPeriodForm.valid\"\r\n            md-raised-button\r\n            style=\"background-color: #ffca28\"\r\n            (click)=\"onSave()\"\r\n          >\r\n            Save\r\n          </button>\r\n\r\n          <span class=\"space\"></span>\r\n          <button md-raised-button (click)=\"onCancel()\">Cancel</button>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </section>\r\n</article>\r\n"

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n  <section>\r\n    <div\r\n      style=\"display: flex; flex-direction: row; justify-content: space-between\"\r\n    >\r\n      <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{ dialogTitle }}</h3>\r\n      <div>\r\n        <button\r\n          style=\"background: none; border: none; padding: 0px; margin: 0px\"\r\n          (click)=\"onCancel()\"\r\n        >\r\n          <em class=\"fa fa-close\"></em>\r\n        </button>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp;</div>\r\n    <div class=\"col-12\" *ngIf=\"errorMessage\">\r\n      <div class=\"alert alert-danger\">\r\n        {{ errorMessage }}\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12\">\r\n      <form [formGroup]=\"syncITLicenseForm\">\r\n        <div class=\"form-group row\">\r\n          <div class=\"col-md-3\">\r\n            <label class=\"control-label\"\r\n              >License Type<span style=\"color: red\">*</span></label\r\n            >\r\n          </div>\r\n\r\n          <div\r\n            class=\"col-md-3\"\r\n            style=\"display: flex; gap: 20px; align-items: center\"\r\n          >\r\n            <!-- Trial -->\r\n            <label style=\"display: flex; align-items: center; gap: 5px\">\r\n              <input\r\n                type=\"radio\"\r\n                formControlName=\"LicenseType\"\r\n                value=\"1\"\r\n                checked\r\n              />\r\n              Trial\r\n            </label>\r\n\r\n            <!-- Purchase -->\r\n            <label style=\"display: flex; align-items: center; gap: 5px\">\r\n              <input type=\"radio\" formControlName=\"LicenseType\" value=\"2\" />\r\n              Purchase\r\n            </label>\r\n          </div>\r\n          <div class=\"col-md-3\">\r\n            <label class=\"control-label\">Support Validity Months</label\r\n            ><span style=\"color: red\">*</span>\r\n          </div>\r\n\r\n          <div class=\"col-md-3\">\r\n            <input\r\n              class=\"form-control\"\r\n              formControlName=\"NoOfMonths\"\r\n              type=\"number\"\r\n            />\r\n          </div>\r\n        </div>\r\n        <div\r\n          *ngIf=\"submitted &amp;&amp; syncITLicenseForm.controls.NoOfMonths.errors\"\r\n          class=\"form-group row\"\r\n        >\r\n          <div class=\"col-md-6\"></div>\r\n          <div\r\n            *ngIf=\"syncITLicenseForm.controls.NoOfMonths.errors.required\"\r\n            class=\"col-md-3\"\r\n          >\r\n            <span style=\"color: red; font-weight: bold\"\r\n              >Support Service Agreement Validity is required.</span\r\n            >\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group row\">\r\n          <div class=\"col-md-3\">\r\n            <label class=\"control-label\">Purchase Date</label\r\n            ><span style=\"color: red\">*</span>\r\n          </div>\r\n          <div class=\"col-md-3\">\r\n            <input\r\n              class=\"form-control\"\r\n              formControlName=\"PurchaseDate\"\r\n              type=\"date\"\r\n            />\r\n          </div>\r\n\r\n          <div class=\"col-md-3\">\r\n            <label class=\"control-label\">Client Admin Email</label\r\n            ><span style=\"color: red\">*</span>\r\n          </div>\r\n          <div class=\"col-md-3\">\r\n            <input\r\n              class=\"form-control\"\r\n              formControlName=\"clientAdminEmail\"\r\n              type=\"email\"\r\n            />\r\n          </div>\r\n        </div>\r\n        <div\r\n          *ngIf=\"submitted &amp;&amp; syncITLicenseForm.controls.clientAdminEmail.errors\"\r\n          class=\"form-group row\"\r\n        ></div>\r\n\r\n        <div class=\"form-group row\">\r\n          <div class=\"col-md-3\">\r\n            <label class=\"control-label\">Sales Order No</label\r\n            ><span style=\"color: red\">*</span>\r\n          </div>\r\n          <div class=\"col-md-3\">\r\n            <input\r\n              class=\"form-control\"\r\n              formControlName=\"SalesOrderNo\"\r\n              (blur)=\"blurSalesOrderEvent()\"\r\n              type=\"text\"\r\n            />\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n            <button\r\n              md-raised-button\r\n              style=\"\r\n                background-color: #ffca28;\r\n                height: 30px;\r\n                text-align: center;\r\n              \"\r\n              (click)=\"checkSalesOrderNo()\"\r\n            >\r\n              Fetch Customer\r\n            </button>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group row\">\r\n          <div class=\"col-md-3\">\r\n            <label class=\"control-label\">Client Name</label\r\n            ><span style=\"color: red\">*</span>\r\n          </div>\r\n          <div class=\"col-md-3\">\r\n            <input\r\n              class=\"form-control\"\r\n              formControlName=\"clientName\"\r\n              type=\"text\"\r\n            />\r\n          </div>\r\n        </div>\r\n        <div\r\n          *ngIf=\"submitted &amp;&amp; syncITLicenseForm.controls.ClientName.errors\"\r\n          class=\"form-group row\"\r\n        >\r\n          <div class=\"col-md-6\"></div>\r\n          <div\r\n            *ngIf=\"syncITLicenseForm.controls.ClientName.errors.required\"\r\n            class=\"col-md-3\"\r\n          >\r\n            <span style=\"color: red; font-weight: bold\"\r\n              >Support Service Agreement Validity is required.</span\r\n            >\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group row\" *ngIf=\"error != ''\">\r\n          <div class=\"col-md-4\"></div>\r\n          <div class=\"col-md-8\">\r\n            <span style=\"color: red; font-weight: bold\">{{ error }}</span>\r\n          </div>\r\n        </div>\r\n        <div\r\n          *ngIf=\"isBillingShippingDetailFetched && !isLoading\"\r\n          class=\"form-group row\"\r\n        >\r\n          <div class=\"col-md-6\">\r\n            <span>Billing Address</span>\r\n            <hr color=\"#FFCA28\" />\r\n            <div>\r\n              <span style=\"font-weight: bold\">{{\r\n                this.billingShippingDetail.BillToName\r\n              }}</span>\r\n            </div>\r\n            <div>\r\n              <span>{{ billingShippingDetail.BillToAddress1 }}</span>\r\n            </div>\r\n            <div>\r\n              <span>{{ billingShippingDetail.BillToAddress2 }}</span>\r\n            </div>\r\n            <div>\r\n              <span>{{ billingShippingDetail.BillToCity }}</span>\r\n              <span>{{ billingShippingDetail.BillToState }}</span>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md-6\">\r\n            <span>Shipping Address</span>\r\n            <hr color=\"#FFCA28\" />\r\n            <div>\r\n              <span style=\"font-weight: bold\">{{\r\n                billingShippingDetail.ShipToName\r\n              }}</span>\r\n            </div>\r\n            <div>\r\n              <span>{{ billingShippingDetail.ShipToAddress1 }}</span>\r\n            </div>\r\n            <div>\r\n              <span>{{ billingShippingDetail.ShipToAddress2 }}</span>\r\n            </div>\r\n            <div>\r\n              <span>{{ billingShippingDetail.ShipToCity }}</span>\r\n              <span>{{ billingShippingDetail.ShipToState }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div\r\n          *ngIf=\"submitted &amp;&amp; scal360LicenseForm.controls.SalesOrderNo.errors\"\r\n          class=\"form-group row\"\r\n        >\r\n          <div class=\"col-md-4\"></div>\r\n          <div\r\n            *ngIf=\"scal360LicenseForm.controls.SalesOrderNo.errors.required\"\r\n            class=\"col-md-8\"\r\n          >\r\n            <span style=\"color: red; font-weight: bold\">\r\n              SalesOrderNo is required.</span\r\n            >\r\n          </div>\r\n        </div>\r\n\r\n        <div\r\n          class=\"card mb-3 p-3\"\r\n          style=\"\r\n            border: 1px solid #ffca28;\r\n            border-radius: 5px;\r\n            background-color: #fff;\r\n          \"\r\n        >\r\n          <h5\r\n            class=\"card-title mb-3\"\r\n            style=\"font-weight: bold; color: #333; font-size: 20px\"\r\n          >\r\n            Sync IT Product List\r\n          </h5>\r\n          <div\r\n            class=\"form-group row font-weight-bold mb-2\"\r\n            style=\"border-bottom: 1px solid #ffca28; padding-bottom: 5px\"\r\n          >\r\n            <div class=\"col-md-5 text-right\">Product Name</div>\r\n\r\n            <div class=\"col-md-4 text-left\">\r\n              No of Instruments [Trial Limit-{{MAX_TRIAL_INSTRUMENTS}}]\r\n            </div>\r\n          </div>\r\n\r\n          <div formArrayName=\"Products\">\r\n            <div\r\n              class=\"form-group row align-items-center mb-2\"\r\n              *ngFor=\"\r\n                let productCtrl of productsFormArray.controls;\r\n                let i = index\r\n              \"\r\n              [formGroupName]=\"i\"\r\n            >\r\n              <!-- Product Name -->\r\n              <label\r\n                class=\"col-md-5 col-form-label text-right\"\r\n                style=\"font-weight: 500\"\r\n              >\r\n                {{ productCtrl.value.ProductName }}\r\n              </label>\r\n\r\n              <!-- No of Licenses Input -->\r\n              <div class=\"col-md-4\">\r\n                <input\r\n                  type=\"number\"\r\n                  min=\"0\"\r\n                  max=\"120\"\r\n                  placeholder=\"Number of licenses\"\r\n                  formControlName=\"NoOfLicense\"\r\n                  class=\"form-control form-control-sm\"\r\n                />\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group row\">\r\n          <div class=\"col-md-12\">\r\n            <button\r\n              md-raised-button\r\n              style=\"background-color: #ffca28\"\r\n              [disabled]=\"isSaveDisabled\"\r\n              (click)=\"onSave()\"\r\n            >\r\n              Save\r\n            </button>\r\n            <span class=\"space\"></span>\r\n            <button\r\n              md-raised-button\r\n              [disabled]=\"CancelButtonDisabled\"\r\n              (click)=\"onCancel()\"\r\n            >\r\n              Cancel\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</article>\r\n"

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n  <section>\r\n    <div\r\n      style=\"display: flex; flex-direction: row; justify-content: space-between\"\r\n    >\r\n      <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">Renew License</h3>\r\n      <div>\r\n        <button\r\n          style=\"background: none; border: none; padding: 0px; margin: 0px\"\r\n          (click)=\"onCancel()\"\r\n        >\r\n          <em class=\"fa fa-close\"></em>\r\n        </button>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-12\">&nbsp;</div>\r\n    <div class=\"col-12\" *ngIf=\"errorMessage\">\r\n      <div class=\"alert alert-danger\">{{ errorMessage }}</div>\r\n    </div>\r\n    <form [formGroup]=\"SyncItExtendRenewForm\">\r\n      <!-- Show input only for Extend Trial -->\r\n      <div class=\"form-group row\">\r\n        <div class=\"col-md-4\">\r\n          <label class=\"control-label\"> No of Months </label>\r\n        </div>\r\n\r\n        <div class=\"col-md-8\">\r\n          <input\r\n            type=\"number\"\r\n            class=\"form-control\"\r\n            style=\"width: 34%\"\r\n            formControlName=\"NoOfMonths\"\r\n            min=\"0\"\r\n            max=\"120\"\r\n          />\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Show Sales Order No only for Renew -->\r\n      <div class=\"form-group row\">\r\n        <div class=\"col-md-4\">\r\n          <label class=\"control-label\">Sales Order No</label\r\n          ><span style=\"color: red\">*</span>\r\n        </div>\r\n        <div class=\"col-md-3\">\r\n          <input\r\n            class=\"form-control\"\r\n            formControlName=\"SalesOrderNo\"\r\n            (blur)=\"blurSalesOrderEvent()\"\r\n            type=\"text\"\r\n          />\r\n        </div>\r\n        <div class=\"col-md-4\">\r\n          <button\r\n            md-raised-button\r\n            style=\"background-color: #ffca28; height: 30px; text-align: center\"\r\n            (click)=\"checkSalesOrderNo()\"\r\n          >\r\n            Fetch Customer\r\n          </button>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group row\" *ngIf=\"error != ''\">\r\n        <div class=\"col-md-4\"></div>\r\n        <div class=\"col-md-8\">\r\n          <span style=\"color: red; font-weight: bold\">{{ error }}</span>\r\n        </div>\r\n      </div>\r\n      <div\r\n        *ngIf=\"isBillingShippingDetailFetched && !isLoading\"\r\n        class=\"form-group row\"\r\n      >\r\n        <div class=\"col-md-6\">\r\n          <span>Billing Address</span>\r\n          <hr color=\"#FFCA28\" />\r\n          <div>\r\n            <span style=\"font-weight: bold\">{{\r\n              this.billingShippingDetail.BillToName\r\n            }}</span>\r\n          </div>\r\n          <div>\r\n            <span>{{ billingShippingDetail.BillToAddress1 }}</span>\r\n          </div>\r\n          <div>\r\n            <span>{{ billingShippingDetail.BillToAddress2 }}</span>\r\n          </div>\r\n          <div>\r\n            <span>{{ billingShippingDetail.BillToCity }}</span>\r\n            <span>{{ billingShippingDetail.BillToState }}</span>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-6\">\r\n          <span>Shipping Address</span>\r\n          <hr color=\"#FFCA28\" />\r\n          <div>\r\n            <span style=\"font-weight: bold\">{{\r\n              billingShippingDetail.ShipToName\r\n            }}</span>\r\n          </div>\r\n          <div>\r\n            <span>{{ billingShippingDetail.ShipToAddress1 }}</span>\r\n          </div>\r\n          <div>\r\n            <span>{{ billingShippingDetail.ShipToAddress2 }}</span>\r\n          </div>\r\n          <div>\r\n            <span>{{ billingShippingDetail.ShipToCity }}</span>\r\n            <span>{{ billingShippingDetail.ShipToState }}</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div\r\n        *ngIf=\"submitted &amp;&amp; SyncItExtendRenewForm.controls.SalesOrderNo.errors\"\r\n        class=\"form-group row\"\r\n      >\r\n        <div class=\"col-md-4\"></div>\r\n        <div\r\n          *ngIf=\"SyncItExtendRenewForm.controls.SalesOrderNo.errors.required\"\r\n          class=\"col-md-8\"\r\n        >\r\n          <span style=\"color: red; font-weight: bold\">\r\n            SalesOrderNo is required.</span\r\n          >\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Error messages -->\r\n\r\n      <div class=\"form-group row\">\r\n        <div class=\"col-md-12\">\r\n          <button\r\n            [disabled]=\"\r\n              !SyncItExtendRenewForm.valid || !isBillingShippingDetailFetched\r\n            \"\r\n            md-raised-button\r\n            style=\"background-color: #ffca28\"\r\n            (click)=\"onSave()\"\r\n          >\r\n            Save\r\n          </button>\r\n          <span class=\"space\"></span>\r\n          <button md-raised-button (click)=\"onCancel()\">Cancel</button>\r\n        </div>\r\n      </div>\r\n    </form>\r\n  </section>\r\n</article>\r\n"

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports = "<div>\r\n  <div\r\n    style=\"\r\n      display: flex;\r\n      flex-direction: row;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n    \"\r\n  >\r\n    <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{ dialogTitle }}</h3>\r\n    <div>\r\n      <button style=\"background: none; border: none\" (click)=\"onCancel()\">\r\n        <em class=\"fa fa-close\"></em>\r\n      </button>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-12\">&nbsp;</div>\r\n  <div *ngIf=\"errorMessage != ''\" class=\"col-12\">\r\n    <div class=\"alert alert-danger\">\r\n      {{ errorMessage }}\r\n    </div>\r\n  </div>\r\n  <div\r\n    *ngIf=\"isLoading\"\r\n    style=\"display: flex; justify-content: center; align-items: center\"\r\n  >\r\n    <md-spinner></md-spinner>\r\n  </div>\r\n  <div *ngIf=\"SyncItLicenseHistory?.length > 0\" class=\"col-12\">\r\n    <div class=\"table-responsive\">\r\n      <table class=\"mdl-data-table table-striped col-12\">\r\n        <tbody>\r\n          <th class=\"mdl-data-table__cell--non-numeric\">Purchase Date</th>\r\n          <th class=\"mdl-data-table__cell--non-numeric\">Sales Order</th>\r\n          <th class=\"mdl-data-table__cell--non-numeric\">License Type</th>\r\n          <th class=\"mdl-data-table__cell--non-numeric\">\r\n            License Creation Date\r\n          </th>\r\n          <th class=\"mdl-data-table__cell--non-numeric\">Product Licenses</th>\r\n          <th class=\"mdl-data-table__cell--non-numeric\">Hash Key</th>\r\n          <tr *ngFor=\"let row of SyncItLicenseHistory\">\r\n            <td class=\"mdl-data-table__cell--non-numeric\">\r\n              {{ row.PurchaseDate | date : \"dd-MMM-yyyy\" }}\r\n            </td>\r\n            <td class=\"mdl-data-table__cell--non-numeric\">\r\n              <span>{{ row.SalesOrderNo }}</span>\r\n            </td>\r\n            <td class=\"mdl-data-table__cell--non-numeric\">\r\n              <span>{{ row.LicenseType }}</span>\r\n            </td>\r\n            <td class=\"mdl-data-table__cell--non-numeric\">\r\n              {{ row.CreatedDate | date : \"dd-MMM-yyyy\" }}\r\n            </td>\r\n            <td class=\"mdl-data-table__cell--non-numeric\">\r\n              <span>{{ row.ProductLicenses }}</span>\r\n            </td>\r\n            <td\r\n              class=\"mdl-data-table__cell--non-numeric\"\r\n              style=\"display: flex; align-items: center; gap: 5px\"\r\n            >\r\n              <!-- Show truncated hash with tooltip -->\r\n              <span title=\"{{ row.Hashkey }}\">\r\n                {{ row.Hashkey | slice : 0 : 15 }}...\r\n              </span>\r\n\r\n              <!-- Copy button -->\r\n              <button\r\n                style=\"\r\n                  background: none;\r\n                  border: none;\r\n                  cursor: pointer;\r\n                  padding: 0;\r\n                \"\r\n                (click)=\"copyToClipboard(row.Hashkey)\"\r\n                title=\"Copy full Hashkey\"\r\n              >\r\n                <em class=\"fa fa-copy\"></em>\r\n              </button>\r\n            </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n  </div>\r\n</div>\r\n"

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports = "<section>\r\n  <div class=\"container-fluid\">\r\n    <h3 class=\"title\">Sync IT</h3>\r\n  </div>\r\n  <div class=\"container-fluid\">\r\n    <hr />\r\n    <div class=\"row\">\r\n      <div class=\"col-md-3\" style=\"margin-bottom: 1%\">\r\n        <h6>Bill To</h6>\r\n        <searchable-dropdown\r\n          [options]=\"BillToList\"\r\n          placeholder=\"Bill To\"\r\n          [(selected)]=\"searchBillToName\"\r\n        >\r\n        </searchable-dropdown>\r\n      </div>\r\n      <div class=\"col-md-3\" style=\"margin-bottom: 1%\">\r\n        <h6>Ship To</h6>\r\n        <searchable-dropdown\r\n          [options]=\"ShipToList\"\r\n          placeholder=\"Ship To\"\r\n          [(selected)]=\"searchShipToName\"\r\n        >\r\n        </searchable-dropdown>\r\n      </div>\r\n      <div class=\"col-md-3\" style=\"margin-bottom: 1%\">\r\n        <h6>Client Admin Email</h6>\r\n        <input\r\n          type=\"text\"\r\n          class=\"form-control\"\r\n          placeholder=\"Client Admin Email\"\r\n          [(ngModel)]=\"searchClientAdminEmail\"\r\n        />\r\n      </div>\r\n    </div>\r\n    <div\r\n      style=\"display: flex; flex-direction: row; justify-content: space-between\"\r\n    >\r\n      <div style=\"display: flex; flex-direction: row\">\r\n        <div style=\"margin: 1%\">\r\n          <button\r\n            md-raised-button\r\n            style=\"background-color: #ffca28\"\r\n            (click)=\"search()\"\r\n          >\r\n            Search\r\n          </button>\r\n        </div>\r\n        <div style=\"margin: 1%\">\r\n          <button md-raised-button (click)=\"clearSearch()\">Clear</button>\r\n        </div>\r\n      </div>\r\n      <div style=\"display: flex; flex-direction: row\">\r\n        <div style=\"margin: 1%\">\r\n          <button\r\n            *ngIf=\"IsAddEdit\"\r\n            md-raised-button\r\n            style=\"background-color: #ffca28\"\r\n            (click)=\"openGenerateNewLicenseRequestDialog()\"\r\n          >\r\n            Generate New License Request\r\n          </button>\r\n        </div>\r\n        <div style=\"margin: 1%\">\r\n          <button\r\n            md-raised-button\r\n            style=\"background-color: #ffca28\"\r\n            class=\"iconsize\"\r\n            mdTooltip=\"Export to CSV\"\r\n            (click)=\"exportToCSV()\"\r\n          >\r\n            <em class=\"fa fa-download\"></em>\r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">&nbsp;</div>\r\n    <div class=\"row\" *ngIf=\"errorMessage !== ''\" class=\"alert alert-danger\">\r\n      <div class=\"col-12\">{{ errorMessage }}</div>\r\n    </div>\r\n    <div class=\"row\">&nbsp;</div>\r\n    <div class=\"row\" *ngIf=\"pagedItems?.length > 0\">\r\n      <div class=\"col-12\">\r\n        <div class=\"table-responsive\">\r\n          <table class=\"mdl-data-table table-striped col-12\">\r\n            <tbody>\r\n              <th class=\"mdl-data-table__cell--non-numeric\">\r\n                Bill To\r\n                <button\r\n                  *ngIf=\"\r\n                    currentSortColumn === 'BillToName' &&\r\n                    currentSortOrder === 'asc'\r\n                  \"\r\n                  style=\"background: none; border: none\"\r\n                >\r\n                  <em\r\n                    class=\"fa fa-sort-up\"\r\n                    style=\"vertical-align: middle; padding-top: 6px\"\r\n                  ></em>\r\n                </button>\r\n                <button\r\n                  *ngIf=\"\r\n                    currentSortColumn === 'BillToName' &&\r\n                    currentSortOrder === 'desc'\r\n                  \"\r\n                  style=\"background: none; border: none\"\r\n                >\r\n                  <em\r\n                    class=\"fa fa-sort-down\"\r\n                    style=\"vertical-align: middle; padding-bottom: 6px\"\r\n                  ></em>\r\n                </button>\r\n                <sort-dropdown\r\n                  columnName=\"BillToName\"\r\n                  (sortChange)=\"onSortChange($event)\"\r\n                >\r\n                </sort-dropdown>\r\n              </th>\r\n              <th\r\n                class=\"mdl-data-table__cell--non-numeric\"\r\n                style=\"align-items: center; justify-content: center\"\r\n              >\r\n                Ship To\r\n                <button\r\n                  *ngIf=\"\r\n                    currentSortColumn === 'ShipToName' &&\r\n                    currentSortOrder === 'asc'\r\n                  \"\r\n                  style=\"background: none; border: none\"\r\n                >\r\n                  <em\r\n                    class=\"fa fa-sort-up\"\r\n                    style=\"vertical-align: middle; padding-top: 6px\"\r\n                  ></em>\r\n                </button>\r\n                <button\r\n                  *ngIf=\"\r\n                    currentSortColumn === 'ShipToName' &&\r\n                    currentSortOrder === 'desc'\r\n                  \"\r\n                  style=\"background: none; border: none\"\r\n                >\r\n                  <em\r\n                    class=\"fa fa-sort-down\"\r\n                    style=\"vertical-align: middle; padding-bottom: 6px\"\r\n                  ></em>\r\n                </button>\r\n                <sort-dropdown\r\n                  columnName=\"ShipToName\"\r\n                  (sortChange)=\"onSortChange($event)\"\r\n                >\r\n                </sort-dropdown>\r\n              </th>\r\n              <th class=\"mdl-data-table__cell--non-numeric\">\r\n                Client Admin Email\r\n                <em *ngIf=\"currentSortColumn==='ClientAdminEmail'\" class=\"fa\"\r\n                    [ngClass]=\"{\r\n                      'fa-sort-up': currentSortOrder==='asc',\r\n                      'fa-sort-down': currentSortOrder==='desc'\r\n                    }\"></em>\r\n                  <sort-dropdown columnName=\"ClientAdminEmail\"\r\n                    (sortChange)=\"onSortChange($event)\">\r\n                  </sort-dropdown>\r\n              </th>\r\n              <th class=\"mdl-data-table__cell--non-numeric\">Expiry Date  <em *ngIf=\"currentSortColumn==='ExpiryDate'\" class=\"fa\"\r\n                    [ngClass]=\"{\r\n                      'fa-sort-up': currentSortOrder==='asc',\r\n                      'fa-sort-down': currentSortOrder==='desc'\r\n                    }\"></em>\r\n                  <sort-dropdown columnName=\"ExpiryDate\"\r\n                    (sortChange)=\"onSortChange($event)\">\r\n                  </sort-dropdown></th>\r\n\r\n              <th class=\"mdl-data-table__cell--non-numeric\">\r\n                Product Wise Instrument Count <em *ngIf=\"currentSortColumn==='ProductWiseInstrumentCount'\" class=\"fa\"\r\n                    [ngClass]=\"{\r\n                      'fa-sort-up': currentSortOrder==='asc',\r\n                      'fa-sort-down': currentSortOrder==='desc'\r\n                    }\"></em>\r\n                  <sort-dropdown columnName=\"ProductWiseInstrumentCount\"\r\n                    (sortChange)=\"onSortChange($event)\">\r\n                  </sort-dropdown>\r\n              </th>\r\n              <th class=\"mdl-data-table__cell--non-numeric\">License Type <em *ngIf=\"currentSortColumn==='LicenseType'\" class=\"fa\"\r\n                    [ngClass]=\"{\r\n                      'fa-sort-up': currentSortOrder==='asc',\r\n                      'fa-sort-down': currentSortOrder==='desc'\r\n                    }\"></em>\r\n                  <sort-dropdown columnName=\"LicenseType\"\r\n                    (sortChange)=\"onSortChange($event)\">\r\n                  </sort-dropdown></th>\r\n              <th class=\"mdl-data-table__cell--non-numeric\">\r\n                Created/Updated Date <em *ngIf=\"currentSortColumn==='UpdatedDate'\" class=\"fa\"\r\n                    [ngClass]=\"{\r\n                      'fa-sort-up': currentSortOrder==='asc',\r\n                      'fa-sort-down': currentSortOrder==='desc'\r\n                    }\"></em>\r\n                  <sort-dropdown columnName=\"UpdatedDate\"\r\n                    (sortChange)=\"onSortChange($event)\">\r\n                  </sort-dropdown>\r\n              </th>\r\n              <th *ngIf=\"IsAddEdit\" class=\"mdl-data-table__cell--non-numeric\">\r\n                Action\r\n              </th>\r\n              <tr\r\n                *ngFor=\"\r\n                  let row of pagedItems\r\n                    | SyncITFilterPipe\r\n                      : filterBillToName\r\n                      : filterShipToName\r\n                      : filterClientAdminEmail\r\n                \"\r\n              >\r\n                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                  <div>\r\n                    <div>\r\n                      <span style=\"font-weight: bold\">{{\r\n                        row.BillToName\r\n                      }}</span>\r\n                    </div>\r\n                    <div>\r\n                      <span>{{ row.BillToAddress1 }}</span>\r\n                    </div>\r\n                    <div>\r\n                      <span>{{ row.BillToAddress2 }}</span>\r\n                    </div>\r\n                    <div>\r\n                      <span>{{ row.BillToCity }}</span>\r\n                      <span>{{ row.BillToState }}</span>\r\n                      <span>{{ row.BillToCountry }}</span>\r\n                    </div>\r\n                  </div>\r\n                </td>\r\n                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                  <div>\r\n                    <div>\r\n                      <span style=\"font-weight: bold\">{{\r\n                        row.ShipToName\r\n                      }}</span>\r\n                    </div>\r\n                    <div>\r\n                      <span>{{ row.ShipToAddress1 }}</span>\r\n                    </div>\r\n                    <div>\r\n                      <span>{{ row.ShipToAddress2 }}</span>\r\n                    </div>\r\n                    <div>\r\n                      <span>{{ row.ShipToCity }}</span>\r\n                      <span>{{ row.ShipToState }}</span>\r\n                      <span>{{ row.ShipToCountryCode }}</span>\r\n                    </div>\r\n                  </div>\r\n                </td>\r\n                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                  <span>{{ row.ClientAdminEmail }}</span>\r\n                </td>\r\n                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                  <span>{{ row.ExpiryDate | date: \"MMM dd, yyyy\" }}</span>\r\n                </td>\r\n\r\n                <td\r\n                  class=\"mdl-data-table__cell--non-numeric\"\r\n                  [innerHTML]=\"row.ProductWiseInstrumentCount\"\r\n                ></td>\r\n                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                  <a\r\n                    href=\"javascript:void(0);\"\r\n                    (click)=\"openSyncItLicenseHistory(row)\"\r\n                  >\r\n                    {{ row.LicenseType }}\r\n                  </a>\r\n                </td>\r\n                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                  <a\r\n                    href=\"javascript:void(0);\"\r\n                    (click)=\"openSyncItLicenseHistory(row)\"\r\n                  >\r\n                    {{ row.UpdatedDate | date: \"MMM dd, yyyy\" }}\r\n                  </a>\r\n                </td>\r\n                <td\r\n                  *ngIf=\"IsAddEdit\"\r\n                  class=\"mdl-data-table__cell--non-numeric iconsize\"\r\n                >\r\n                  <span>\r\n                    <button\r\n                      md-icon-button\r\n                      mdTooltip=\"Add More Instruments In License\"\r\n                      (click)=\"addMoreLicense(row)\"\r\n                      *ngIf=\"\r\n                        row.LicenseType !== 'Trial' ||\r\n                        row.TotalInstrumentCount < MAX_TRIAL_INSTRUMENTS\r\n                      \"\r\n                    >\r\n                      <em class=\"fa fa-plus\"></em>\r\n                    </button>\r\n                  </span>\r\n                  <button\r\n                    *ngIf=\"row.LicenseType == 'Purchase'\"\r\n                    md-icon-button\r\n                    mdTooltip=\"Renew License\"\r\n                    (click)=\"openExtendTrial(row)\"\r\n                  >\r\n                    <em class=\"fa fa-clock-o\"></em>\r\n                  </button>\r\n\r\n                  <button\r\n                    *ngIf=\"row.IsTrialExtend && row.LicenseType == 'Trial'\"\r\n                    (click)=\"approveTrailPeriodExtension(row)\"\r\n                    md-icon-button\r\n                    mdTooltip=\"Approve Trial Extension\"\r\n                  >\r\n                    <em class=\"fa fa-check\"></em>\r\n                  </button>\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n          <ul\r\n            *ngIf=\"pager.pages && pager.pages.length\"\r\n            class=\"pagination\"\r\n            style=\"float: right !important\"\r\n          >\r\n            <li\r\n              [ngClass]=\"{ disabled: pager.currentPage === 1 }\"\r\n              style=\"cursor: pointer\"\r\n            >\r\n              <a (click)=\"setPage(1)\">First</a>\r\n            </li>\r\n            <li\r\n              [ngClass]=\"{ disabled: pager.currentPage === 1 }\"\r\n              style=\"cursor: pointer\"\r\n            >\r\n              <a (click)=\"setPage(pager.currentPage - 1)\">Previous</a>\r\n            </li>\r\n            <li\r\n              *ngFor=\"let page of pager.pages\"\r\n              [ngClass]=\"{ active: pager.currentPage === page }\"\r\n              style=\"cursor: pointer\"\r\n            >\r\n              <a (click)=\"setPage(page)\">{{ page }}</a>\r\n            </li>\r\n            <li\r\n              [ngClass]=\"{ disabled: pager.currentPage === pager.totalPages }\"\r\n              style=\"cursor: pointer\"\r\n            >\r\n              <a (click)=\"setPage(pager.currentPage + 1)\">Next</a>\r\n            </li>\r\n            <li\r\n              [ngClass]=\"{ disabled: pager.currentPage === pager.totalPages }\"\r\n              style=\"cursor: pointer\"\r\n            >\r\n              <a (click)=\"setPage(pager.totalPages)\">Last</a>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n"

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n  <div>\r\n    <section>\r\n      <div class=\"col-12\">\r\n        <h1 md-dialog-title=\"\" class=\"mat-dialog-title\">{{ this.Title }}</h1>\r\n\r\n        <div\r\n          md-dialog-content=\"\"\r\n          style=\"padding-bottom: 10px\"\r\n          class=\"mat-dialog-content\"\r\n        >\r\n          <md-checkbox\r\n            class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n            [(ngModel)]=\"IsSTPPerformed\"\r\n            (change)=\"checkValue(IsSTPPerformed)\"\r\n            *ngIf=\"data.Status == 2\"\r\n          >\r\n            <span class=\"mat-checkbox-label\">\r\n              I have performed STP.\r\n              <!-- Developer Means Only Add/Edit/Delete Rights-->\r\n            </span>\r\n          </md-checkbox>\r\n          <md-checkbox\r\n            class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n            [(ngModel)]=\"IsPushNotificationChecked\"\r\n            (change)=\"checkValueForPushNotification(IsPushNotificationChecked)\"\r\n            *ngIf=\"data.Status == 3 && checkIsValidProductForNotification()\"\r\n          >\r\n            <span class=\"mat-checkbox-label\">\r\n              Do you want to send push notification for this release?\r\n            </span>\r\n          </md-checkbox>\r\n          <textarea\r\n                 style=\"width: 95%; margin-top: 3%;\"\r\n                  class=\"form-control\"\r\n                  name=\"CommentBox\"\r\n                  type=\"text\"\r\n                  [(ngModel)]=\"commentForRelease\"\r\n                  placeholder=\"Add comment if any for the release\"\r\n                ></textarea>\r\n          <p style=\"margin-top: 15px\">{{ this.TitleDescription }}</p>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12\" style=\"margin-top: 10px\">\r\n        <button\r\n          class=\"btn-w-sm mat-raised-button mat-accent\"\r\n          color=\"primary\"\r\n          (click)=\"onSubmit()\"\r\n          md-raised-button=\"\"\r\n          ng-reflect-color=\"primary\"\r\n        >\r\n          <span class=\"mat-button-wrapper\">Yes</span>\r\n        </button>\r\n        <button\r\n          class=\"btn-w-sm mat-raised-button mat-warn\"\r\n          color=\"primary\"\r\n          (click)=\"onCancel()\"\r\n          md-raised-button=\"\"\r\n          ng-reflect-color=\"primary\"\r\n        >\r\n          <span class=\"mat-button-wrapper\">Cancel</span>\r\n        </button>\r\n      </div>\r\n    </section>\r\n  </div>\r\n</article>\r\n"

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports = "    <div class=\"activate-release__content\" >\r\n      <h1 md-dialog-title class=\"activate-release__title\">{{ Title }}</h1>\r\n      <form\r\n        [formGroup]=\"releaseForm\"\r\n        (ngSubmit)=\"submit()\"\r\n        class=\"activate-release__form\"\r\n        novalidate\r\n      >\r\n        <div class=\"activate-release__content\">\r\n          <!-- ── Comment ─────────────────────────────────────────────────────── -->\r\n          <div class=\"activate-release__section\">\r\n            <label class=\"activate-release__field-label\">\r\n              Comment <span class=\"required\" *ngIf=\"releaseForm.get('releaseType').value != ProductReleaseStatus.ProductionRelease\">*</span>\r\n            </label>\r\n              <div tabindex=\"0\"></div>\r\n              <textarea \r\n                placeholder=\"Add comment for the release\"\r\n                class=\"pop-ta\"\r\n                maxlength=\"122\"\r\n                formControlName=\"comment\"\r\n                (keydown.enter)=\"$event.preventDefault()\">\r\n              </textarea>\r\n              <!-- <md-error\r\n                *ngIf=\"releaseForm.get('comment').hasError('required') &&\r\n                       releaseForm.get('comment').touched\">\r\n                Comment is required.\r\n              </md-error> -->\r\n          </div>\r\n    \r\n          <!-- ── Release Type ────────────────────────────────────────────────── -->\r\n          <div class=\"activate-release__section\">\r\n            <label class=\"activate-release__field-label\">\r\n              Choose Release Type <span class=\"required\">*</span>\r\n            </label>\r\n            <md-radio-group\r\n              formControlName=\"releaseType\"\r\n              class=\"activate-release__radio-group\"\r\n            >\r\n              <md-radio-button\r\n                *ngFor=\"let type of releaseTypes\"\r\n                [value]=\"type.value\"\r\n                [disabled]=\"isReleaseTypeDisabled(type.value)\"\r\n                class=\"activate-release__radio-button\"\r\n              >\r\n                {{ type.label }}\r\n              </md-radio-button>\r\n            </md-radio-group>\r\n          </div>\r\n    \r\n          <!-- ── Customer Selector (Pilot / Custom only) ─────────────────────── -->\r\n          <div\r\n            class=\"activate-release__section\"\r\n            *ngIf=\"\r\n              releaseForm.get('releaseType').value ==\r\n                ProductReleaseStatus.PilotRelease ||\r\n              releaseForm.get('releaseType').value ==\r\n                ProductReleaseStatus.CustomRelease\r\n            \"\r\n          >\r\n            <label class=\"activate-release__field-label\">\r\n              Select Customers <span class=\"required\" *ngIf=\"releaseForm.get('releaseType').value != ProductReleaseStatus.ProductionRelease\">*</span>\r\n            </label>\r\n    \r\n            <searchable-multi-select\r\n              class=\"activate-release__full-width\"\r\n              formControlName=\"customers\"\r\n              [items]=\"customers\"\r\n              idField=\"Id\",\r\n              textField=\"Name\"\r\n              placeholder=\"Select one or more customers…\"\r\n            >\r\n            </searchable-multi-select>\r\n          </div>\r\n\r\n          <div *ngIf=\"releaseForm.get('releaseType').value !=null\" class=\"activate-release__checkbox-container\">\r\n            <label class=\"activate-release__field-label\">\r\n              Send release notification email to SyncIT client admins ? \r\n              <span class=\"required\">*</span>\r\n            </label>\r\n\r\n            <md-radio-group\r\n              class=\"activate-release__notification-options\"\r\n              formControlName=\"isNotifySyncItClientAdmin\">\r\n              <md-radio-button [value]=\"true\">Yes</md-radio-button>\r\n              <md-radio-button [value]=\"false\">No</md-radio-button>\r\n            </md-radio-group>\r\n          </div>\r\n\r\n          <!-- ── Confirmation description ────────────────────────────────────── -->\r\n        </div>\r\n      </form>\r\n      \r\n      <div class=\"warning-box\" *ngIf=\"isProdReleaseWarningDisplay()\">\r\n      <!-- <i class=\"fa fa-warning\"></i> -->\r\n        <span>Release v{{this.data.ProductReleaseNo}} will become available for all the customers <b>except</b> those enrolled in pilot or custom release.</span>\r\n      </div>\r\n\r\n      <p class=\"activate-release__description\">{{ TitleDescription }}</p>\r\n      <!-- ── Actions ─────────────────────────────────────────────────────────── -->\r\n      <div class=\"activate-release__actions\">\r\n        <button\r\n          md-raised-button\r\n          class=\"mat-accent\"\r\n          color=\"primary\"\r\n          (click)=\"onSubmit()\"\r\n          [disabled]=\"releaseForm.invalid\"\r\n        >\r\n          Yes\r\n        </button>\r\n      \r\n        <button\r\n          md-raised-button\r\n          class=\"btn-cancel\"\r\n          type=\"button\"\r\n          (click)=\"onCancel()\"\r\n        >\r\n          Cancel\r\n        </button>\r\n      </div>\r\n    </div>\r\n\r\n"

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <section>\r\n        <div class=\"col-12\">\r\n            <h3 md-dialog-title=\"\" class=\"mat-dialog-title\">{{Title}}</h3>\r\n        </div>\r\n        <div class=\"col-12\">&nbsp; </div>\r\n        <div class=\"col-12\" *ngIf=\"errorMessage!=''\">\r\n            <div class=\"alert alert-danger\">\r\n                {{errorMessage}}\r\n            </div>\r\n        </div>\r\n        <div class=\"col-12\">\r\n            <form [formGroup]=\"validationForm\">\r\n                <div class=\"form-group row\">\r\n                    <label class=\"col-md-4 control-label\">Revision</label>\r\n                    <div class=\"col-md-8\">\r\n                        <input class=\"form-control\" (blur)=\"checkRevsionNo()\" (keydown.space)=\"$event.preventDefault()\" \r\n                            formControlName=\"ProductReleaseNo\" type=\"text\" maxlength=\"8\" />\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; validationForm.controls.ProductReleaseNo.errors\"\r\n                    class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"validationForm.controls.ProductReleaseNo.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Product Revision is required.</span>\r\n                    </div>                 \r\n                </div>                \r\n                <div class=\"form-group row\">\r\n                    <label class=\"col-md-4 control-label\">Date</label>\r\n                    <div class=\"col-md-8\">\r\n                        <input class=\"form-control\" type=\"date\" data-date-format=\"DD MMMM YYYY\" \r\n                            formControlName=\"ReleaseDate\">\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\" *ngIf=\"IsProductCodeVisble\">\r\n                    <label class=\"col-md-4 control-label\">DB Version</label>\r\n                    <div class=\"col-md-8\">\r\n                        <input class=\"form-control\" (blur)=\"checkDBVersion()\" maxlength=\"4\" formControlName=\"DBVersion\" (keypress)=\"DBVersionNumericOnly($event)\"\r\n                            [readonly]=\" (this.IsDeveloperRights==true && this.ProductReleaseStatus!=0) ||\r\n                            (this.IsDeveloperRights==false)\" type=\"text\" />\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; validationForm.controls.DBVersion.errors\" class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"validationForm.controls.DBVersion.errors.required\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> DB Version is required.</span>\r\n                    </div>              \r\n                    <div *ngIf=\"validationForm.controls.DBVersion.errors.pattern\" class=\"col-md-8\">\r\n                        <span style=\"color:red;font-weight: bold;\"> Invalid DB Version.</span>\r\n                    </div>       \r\n                </div>             \r\n                <div class=\"form-group row\">\r\n                    <label class=\"col-md-4 control-label\">Product Upload</label>\r\n                    <div class=\"col-md-8\">\r\n                        <div class=\"input-group\">\r\n                            <input type=\"file\" id=\"productfile\" formControlName=\"file\" class=\"form-control\"\r\n                                (click)=\"disableInputClick($event)\" \r\n                                [readonly]=\"(this.IsDeveloperRights==true && this.ProductReleaseStatus!=0) || (this.IsDeveloperRights==false)\"\r\n                                (change)=\"onChange($event)\"  #productfile/>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <span style=\"font-weight: bold;\" *ngIf=\"percentDone!=0 && uploadresponse==''\">Progress : <span\r\n                                style=\"color:green;\">{{percentDone}}%\r\n                            </span></span>\r\n                        <span style=\"font-weight: bold;\" *ngIf=\"uploadSuccess==true && uploadresponse!=''\">Status :\r\n                            <span style=\"color:green;\">{{uploadresponse}}\r\n                            </span></span>\r\n                        <span style=\"font-weight: bold;\" *ngIf=\"uploadSuccess==false && uploadresponse!=''\">Error :\r\n                            <span style=\"color:red;\">{{uploadresponse}}\r\n                            </span></span>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; validationForm.controls.file.errors\" class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"validationForm.controls.file.errors.required\" class=\"col-md-8\"><span\r\n                            style=\"color:red;font-weight: bold;\">\r\n                            Product File is Required.</span></div>\r\n                </div>\r\n                <div class=\"form-group row\" *ngIf=\"IsProductCodeVisble\">\r\n                    <label class=\"col-md-4 control-label\">Package File Upload</label>\r\n                    <div class=\"col-md-8\">\r\n                        <div class=\"input-group\">\r\n                            <input type=\"file\" id=\"packagefiles\" class=\"form-control\" formControlName=\"packagefile\"\r\n                                (click)=\"disableInputClick($event)\"\r\n                                [readonly]=\"(this.IsDeveloperRights==true && this.ProductReleaseStatus!=0) || (this.IsDeveloperRights==false)\"\r\n                                (change)=\"onPackageChange($event)\" #packagefiles/>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div class=\"col-md-8\">\r\n                        <span style=\"font-weight: bold;\"\r\n                            *ngIf=\"packagepercentDone!=0 && packageuploadresponse==''\">Progress : <span\r\n                                style=\"color:green;\">{{packagepercentDone}}%\r\n                            </span></span>\r\n                        <span style=\"font-weight: bold;\"\r\n                            *ngIf=\"packageuploadSuccess==true && packageuploadresponse!=''\">Status : <span\r\n                                style=\"color:green;\">{{packageuploadresponse}}\r\n                            </span></span>\r\n                        <span style=\"font-weight: bold;\"\r\n                            *ngIf=\"packageuploadSuccess==false && packageuploadresponse!=''\">Error : <span\r\n                                style=\"color:red;\">{{packageuploadresponse}}\r\n                            </span></span>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"submitted &amp;&amp; validationForm.controls.packagefile.errors\" class=\"form-group row\">\r\n                    <div class=\"col-md-4\">\r\n                    </div>\r\n                    <div *ngIf=\"validationForm.controls.packagefile.errors.required\" class=\"col-md-8\"><span\r\n                            style=\"color:red;font-weight: bold;\"> Package File is Required.</span></div>\r\n                </div>\r\n                <div class=\"form-group row\" *ngIf=\"this.data.ProductReleaseId!=0\">\r\n                    <label class=\"col-md-4\">Current Files </label>\r\n                    <div class=\"col-md-8\">\r\n                        <div class=\"box box-default\">\r\n                            <div class=\"box-body\" style=\"border: 1px solid #ddd;\">\r\n                                <md-list dense=\"\" role=\"list\" class=\"mat-list\">\r\n                                    <h3 md-subheader=\"\" class=\"mat-subheader\">Current Release File <span><a  *ngIf=\"this.data.ProductReleaseId!=0 && this.ProductReleaseStatus==0 && this.IsDeveloperRights==true\" (click)=\"productfile.click()\" style=\"margin-left: 10px;color:blue;cursor: pointer;\" >[ Replace ]</a></span> </h3>\r\n                                    <md-list-item role=\"listitem\" class=\"mat-list-item-avatar mat-2-line mat-list-item\">\r\n                                        <div class=\"mat-list-item-content\">\r\n                                            <div class=\"mat-list-item-ripple mat-ripple\" md-ripple=\"\"\r\n                                                ng-reflect-trigger=\"[object HTMLElement]\" ng-reflect-disabled=\"true\">\r\n                                            </div>\r\n                                            <md-icon md-list-avatar=\"\" role=\"img\"\r\n                                                class=\"material-icons mat-icon mat-list-avatar\" aria-label=\"folder\">\r\n                                                folder</md-icon>\r\n                                            <div class=\"mat-list-text\">\r\n                                                <h4 class=\"mat-line\" style=\"overflow: hidden;\">{{filename}}</h4>\r\n                                                <p class=\"mat-line\"  md-line=\"\"> {{(filesize/1024)| number:\r\n                                                    '1.2-2'}}\r\n                                                    KB </p>\r\n                                            </div>\r\n                                        </div>\r\n                                    </md-list-item>\r\n                                    <div *ngIf=\"ProductReleaseSupportEditData!=''\">\r\n                                        <md-divider class=\"mat-divider\"></md-divider>\r\n                                        <h3 md-subheader=\"\" class=\"mat-subheader\">Package Files<span><a  *ngIf=\"this.data.ProductReleaseId!=0 && this.ProductReleaseStatus==0 && this.IsDeveloperRights==true\" (click)=\"UpdatePackageFile();\" style=\"margin-left: 10px;color:blue;cursor: pointer;\" >[ Replace ]</a></span> </h3>\r\n                                        <div style=\"height:58px;\">\r\n                                            <md-list-item role=\"listitem\"\r\n                                                class=\"mat-list-item-avatar mat-2-line mat-list-item\"\r\n                                                *ngFor=\"let row of ProductReleaseSupportEditData;let i = index\">\r\n                                                <div class=\"mat-list-item-content\">\r\n                                                    <md-icon md-list-avatar=\"\" role=\"img\"\r\n                                                        class=\"material-icons mat-icon mat-list-avatar1\"\r\n                                                        aria-label=\"note\">\r\n                                                        note\r\n                                                    </md-icon>\r\n                                                    <div class=\"mat-list-text\">\r\n                                                        <h4 style=\"overflow: hidden;\" class=\"mat-line\">{{row.PackageFileName}}</h4>\r\n                                                        <p class=\"demo-2 mat-line\" md-line=\"\">\r\n                                                            {{row.PackageFileSize/1024 |\r\n                                                            number: '1.2-2'}} KB\r\n                                                        </p>\r\n                                                    </div>                                                    \r\n                                                </div>\r\n                                            </md-list-item>\r\n                                        </div>\r\n                                    </div>\r\n                                </md-list>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-12\">\r\n                        <table style=\"width: 100%;\" aria-describedby=\"ChangeLogActionTable\">\r\n                            <th></th>\r\n                            <tr>\r\n                                <td>\r\n                                    <strong>Change Log</strong>\r\n                                </td>\r\n                                <td style=\"text-align:center;\">\r\n                                    <span mdTooltip=\"Add Change Log\" (click)=\"addChangeLog()\">\r\n                                        <em class=\"fa fa-plus fa-2x\"></em></span>\r\n                                </td>\r\n                            </tr>\r\n                            <tr>\r\n                                <td colspan=\"2\">\r\n                                    <span style=\"font-weight: bold;\" *ngIf=\"IsChangeLog==true\"><span\r\n                                            style=\"color:red;\">At least one change log required.\r\n                                        </span></span>\r\n                                </td>\r\n                            </tr>\r\n                        </table>\r\n                        <table class=\"mdl-data-table col-12\" formArrayName=\"ChangeLogs\" aria-describedby=\"ViewChangeLogTable\">\r\n                            <tbody>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                    Sr.No\r\n                                </th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                    Change Log\r\n                                </th>\r\n                                <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                    Action\r\n                                </th>\r\n                                <tr *ngIf=\"ChangeLogs==''\">\r\n                                    <td colspan=\"3\" style=\"text-align: center;\">\r\n                                        No Change Logs found\r\n                                    </td>\r\n                                </tr>\r\n                                <tr [formGroupName]=\"i\" *ngFor=\"let changelog of ChangeLogs.controls; let i=index\">\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span>{{i+ 1}}</span>\r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\"><span>\r\n                                            <textarea name=\"txtChangeLog\" cols=\"40\" rows=\"2\" formControlName=\"ChangeLog\"\r\n                                                pattern=\"^[^\\s]+([a-zA-Z0-9_ \\n\\W]*$)\"\r\n                                                class=\"form-control\"\r\n                                                (blur)=\"CheckChangeLog($event.target.value)\"></textarea></span>\r\n                                        <label *ngIf=\"ChangeLogs.controls[i].get('ChangeLog')?.errors?.required\"\r\n                                            style=\"color: red;\">\r\n                                            Change Log required.\r\n                                        </label>\r\n                                        <label style=\"color:red\"\r\n                                            *ngIf=\"ChangeLogs.controls[i].get('ChangeLog')?.errors?.pattern\">\r\n                                            Please Enter Valid ChangeLog.!\r\n                                        </label>\r\n                                    </td>\r\n                                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                        <span mdTooltip=\"Delete Change Log\" (click)=\"deleteChangeLog(i)\" *ngIf=\"validationForm.controls.ChangeLogs.controls.length >1\">\r\n                                            <em class=\"fa fa-trash fa-2x\"></em></span>\r\n                                    </td>\r\n                                </tr>\r\n                            </tbody>\r\n                        </table>\r\n                    </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                    <div class=\"col-md-12\"> <!--1. Form valid or not validationForm.valid used 2. Form has any changes for that validationForm.pristine used 3.some situation save button disabled and Enabled that's why we use SaveButtonDisbaled) -->\r\n                        <button md-raised-button color=\"accent\"\r\n                            [disabled]=\"SaveButtonDisabled || (!validationForm.valid || validationForm.pristine )\"\r\n                            (click)=\"onSubmit()\">Save</button>                        \r\n                        <span class=\"space\"></span>\r\n                        <button md-raised-button color=\"warn\" [disabled]=\"CancelButtonDisabled\"\r\n                            (click)=\"oneditcancel()\">Cancel</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </section>\r\n</article>\r\n\r\n\r\n"

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports = "<section class=\"page-with-tabs\">\r\n    <div class=\"article\" style=\"padding-left: 5px\">\r\n        <h2 class=\"container-fluid\">Add/ Edit Product</h2>\r\n    </div>\r\n    <section class=\"container-fluid\">\r\n        <article class=\"article\">\r\n            <div class=\"\">\r\n                <section>\r\n                    <hr />\r\n                    <div class=\"col-6 alert alert-danger\" *ngIf=\"errorMessage\">\r\n                        <span style=\"color:red;\">{{errorMessage}} </span>\r\n                    </div>\r\n                    <form [formGroup]=\"validationForm\">\r\n                        <div class=\"form-group row\">\r\n                        </div>\r\n                        <div class=\"form-group row\">\r\n                            <label class=\"col-md-2 control-label\" for=\"inputEmail3\">Product Name</label>\r\n                            <div class=\"col-md-4\">\r\n                                <input class=\"form-control\" formControlName=\"ProductName\" type=\"text\">\r\n                            </div>\r\n                            <div *ngIf=\"submitted &amp;&amp; validationForm.controls.ProductName.errors\"\r\n                                class=\"col-md-6\">\r\n                                <div *ngIf=\"validationForm.controls.ProductName.errors.required\">\r\n                                    <span style=\"color:red;\"> Instrument Type Name is required.</span>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"form-group row\">\r\n                            <label class=\"col-md-2 control-label\" for=\"inputPassword3\">Instrument Code</label>\r\n                            <div class=\"col-md-4\">\r\n                                <input class=\"form-control\" id=\"Code\" formControlName=\"Code\" type=\"number\">\r\n                            </div>\r\n                            <div *ngIf=\"submitted &amp;&amp; validationForm.controls.Code.errors\" class=\"col-md-6\">\r\n                                <div *ngIf=\"validationForm.controls.Code.errors.required\">\r\n                                    <span style=\"color:red;\"> Product Code is required.</span>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"form-group row\">\r\n                            <label class=\"col-md-2 control-label\">Product Sub Code</label>\r\n                            <div class=\"col-md-4\">\r\n                                <input class=\"form-control\" id=\"SubType\" formControlName=\"SubType\" type=\"number\">\r\n                            </div>\r\n                            <div *ngIf=\"submitted &amp;&amp; validationForm.controls.SubType.errors\" class=\"col-md-6\">\r\n                                <div *ngIf=\"validationForm.controls.SubType.errors.required\">\r\n                                    <span style=\"color:red;\"> Product Sub Type is required.</span>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"form-group row\">\r\n                            <div class=\"offset-md-2 col-md-10\">\r\n                                <button class=\"btn-w-md no-margin-left mat-raised-button mat-accent\" color=\"primary\"\r\n                                    (click)=\"onSubmit()\" md-raised-button=\"\" ng-reflect-color=\"primary\"><span\r\n                                        class=\"mat-button-wrapper\">Save</span>\r\n\r\n                                </button>\r\n                                <button class=\"btn-w-md no-margin-left mat-raised-button mat-warn\" color=\"primary\"\r\n                                    (click)=\"oneditcancel()\" md-raised-button=\"\" ng-reflect-color=\"primary\"><span\r\n                                        class=\"mat-button-wrapper\">Cancel</span>\r\n                                </button>\r\n                            </div>\r\n                        </div>\r\n                    </form>\r\n                    <div class=\"row\">&nbsp;</div>\r\n                    <div class=\"row\" *ngIf=\"ProductData?.length == 0\" class=\"alert alert-danger\">\r\n                        <div class=\"col-12\">\r\n                            No Product Records Found\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"row\" *ngIf=\"ProductData?.length > 0\">\r\n                        <div class=\"col-12\">\r\n                            <table class=\"mdl-data-table table-striped col-12\" aria-describedby=\"ViewAllProducts\">\r\n                                <tbody>\r\n                                    <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                        Product Name\r\n                                    </th>\r\n                                    <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                        Product Code\r\n                                    </th>\r\n                                    <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                        Product Sub Type\r\n                                    </th>\r\n                                    <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                        Action\r\n                                    </th>\r\n                                    <tr *ngFor=\"let row of ProductData\">\r\n                                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                            <span>{{row.ProductName}}</span>\r\n                                        </td>\r\n                                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                            <span>{{row.Code}}</span>\r\n                                        </td>\r\n                                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                            <span>{{row.SubType}}</span>\r\n                                        </td>\r\n                                        <td class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                                            <span mdTooltip=\"Edit Product\">\r\n                                                <button md-icon-button (click)=\"EditProductDetail(row)\">\r\n                                                    <em class=\"fa fa-edit  text-success\" aria-hidden=\"true\"> </em>\r\n                                                </button>\r\n                                            </span>\r\n                                        </td>\r\n                                    </tr>\r\n                                </tbody>\r\n                            </table>\r\n                        </div>\r\n                    </div>\r\n                </section>\r\n            </div>\r\n        </article>\r\n    </section>\r\n</section>"

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports = "<h2 md-dialog-title>Change Release Type</h2>\r\n\r\n<md-dialog-content class=\"dialog-content\">\r\n\r\n  <!-- Current Release -->\r\n  <div class=\"current-release\" \r\n    [ngClass]=\"{\r\n        'pilot-release': data.Status == ProductReleaseStatus.PilotRelease,\r\n        'custom-release': data.Status == ProductReleaseStatus.CustomRelease\r\n    }\">\r\n    <span class=\"release-badge\">\r\n      {{ currentReleaseBadge }}\r\n    </span>\r\n\r\n    <span class=\"release-text\">\r\n      v{{ data.ProductReleaseNo }}\r\n    </span>\r\n  </div>\r\n\r\n  <div class=\"mt-20\">\r\n    <label class=\"section-title\">\r\n      Change to <span class=\"required\">*</span>\r\n    </label>\r\n\r\n    <md-radio-group [(ngModel)]=\"selectedReleaseType\" (ngModelChange)=\"onReleaseTypeChanged($event)\">\r\n\r\n      <div class=\"radio-option\">\r\n          <md-radio-button [value]=\"ProductReleaseStatus.QARelease\" [disabled]=\"!isQAEnabled\">\r\n            QA  \r\n            <!-- <span class=\"radio-label\">QA</span> -->\r\n        </md-radio-button>\r\n\r\n        <div class=\"option-description\" [class.option-description-disabled]=\"!isQAEnabled\">\r\n          Release returns to QA state. All customer assignments are removed.\r\n        </div>\r\n      </div>\r\n\r\n      <div>\r\n        <md-radio-button [value]=\"ProductReleaseStatus.ProductionRelease\" [disabled]=\"isHigherProdReleaseExists\">\r\n          Prod\r\n          <!-- <span class=\"radio-label\">Prod</span> -->\r\n        </md-radio-button>\r\n\r\n        <div class=\"option-description\" [class.option-description-disabled]=\"isHigherProdReleaseExists\">\r\n          Release becomes Prod. Existing Prod release is changed to QA.\r\n          All customer assignments are removed.\r\n        </div>\r\n      </div>\r\n\r\n    </md-radio-group>\r\n  </div>\r\n\r\n  <div style=\"display: flex; flex-direction: column;\">\r\n    <div *ngIf=\"selectedReleaseType\" class=\"checkbox-container\">\r\n      <label class=\"section-title\" [class.option-description-disabled]=\"isRadioGroupDisabled()\">\r\n        Send release notification email to SyncIT client admins ? <span *ngIf=\"!isRadioGroupDisabled()\" class=\"required\">*</span>\r\n      </label>\r\n\r\n      <md-radio-group\r\n        class=\"notification-options\"\r\n        [disabled]=\"isRadioGroupDisabled()\"\r\n        [(ngModel)]=\"isNotifySyncItClientAdmin\">\r\n        <md-radio-button [value]=\"true\">Yes</md-radio-button>\r\n        <md-radio-button [value]=\"false\">No</md-radio-button>\r\n      </md-radio-group>\r\n    </div>\r\n\r\n    <span \r\n      *ngIf=\"selectedReleaseType == ProductReleaseStatus.QARelease && isNotifySyncItClientAdmin\" \r\n      [class.option-description-disabled]=\"!isHigherProdReleaseExists\" \r\n      class=\"checkbox-description\" \r\n      [innerHTML]=\"getCheckboxNote()\">\r\n    </span>\r\n\r\n  </div>\r\n          \r\n  <div class=\"warning-box\" *ngIf=\"selectedReleaseType\">\r\n    <!-- <i class=\"fa fa-warning\"></i> -->\r\n    <span [innerHTML]=\"getWarningMessage()\"></span>\r\n  </div>\r\n\r\n</md-dialog-content>\r\n\r\n<div class=\"action-buttons\">\r\n\r\n  <button\r\n    class=\"mat-accent\"\r\n    md-raised-button\r\n    color=\"primary\"\r\n    [disabled]=\"isConfirmButtonDisabled()\"\r\n    (click)=\"onConfirm()\">\r\n    Confirm\r\n  </button>\r\n\r\n  <button\r\n    class=\"btn-cancel\"\r\n    md-raised-button\r\n    type=\"button\"\r\n    (click)=\"onCancel()\">\r\n    Cancel\r\n  </button>\r\n\r\n</div>"

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <div>\r\n        <section>\r\n            <div class=\"col-12\">\r\n                <h1 md-dialog-title=\"\" class=\"mat-dialog-title\">Warning</h1>\r\n\r\n                <div md-dialog-content=\"\" style=\"padding-bottom: 20px;\" class=\"mat-dialog-content\">\r\n                    {{this.TitleDescription}}\r\n                </div>\r\n            </div>\r\n            <div class=\"col-12\">\r\n                <button class=\"btn-w-sm mat-raised-button mat-warn\" color=\"primary\" (click)=\"onCancel()\"\r\n                    md-raised-button=\"\" ng-reflect-color=\"primary\">\r\n                    <span class=\"mat-button-wrapper\">Cancel</span>\r\n                </button>\r\n            </div>\r\n\r\n\r\n        </section>\r\n    </div>\r\n</article>"

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports = "<section class=\"page-with-tabs\" *ngIf=\"!IsValid\">\r\n  <div class=\"article\">\r\n    <div class=\"container-fluid\">\r\n      <div class=\"row\">\r\n        <div class=\"col-7\">\r\n          <h4>{{ Title }}</h4>\r\n        </div>\r\n        <div class=\"col-5\" style=\"text-align: right\">\r\n          \r\n            <div style=\"margin-top: 24px;\">\r\n              <md-checkbox\r\n                class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                [(ngModel)]=\"IsShowDeleted\"\r\n                (change)=\"showRejected(IsShowDeleted)\"\r\n                style=\"position: relative; top: 3px; right: 7px;\"\r\n              >\r\n                <span class=\"mat-checkbox-label\"> Show Rejected Releases </span>\r\n              </md-checkbox>\r\n              <button\r\n                md-raised-button\r\n                type=\"submit\"\r\n                *ngIf=\"this.IsAdd\"\r\n                color=\"primary\"\r\n                (click)=\"openProductReleaseAddDialog()\"\r\n              >\r\n                Add New\r\n              </button>\r\n              <button\r\n                md-raised-button\r\n                type=\"submit\"\r\n                color=\"primary\"\r\n                *ngIf=\"pagedItems?.length > 0\"\r\n                (click)=\"OpenViewAllChangeLog()\"\r\n                mdTooltip=\"View All Releases Change Logs\"\r\n              >\r\n                Change Logs\r\n              </button>\r\n            </div>\r\n          \r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <section class=\"container-fluid\">\r\n    <article class=\"article\">\r\n      <div class=\"\">\r\n        <section>\r\n          <hr />\r\n          <div\r\n            class=\"row\"\r\n            *ngIf=\"pagedItems?.length == 0\"\r\n            class=\"alert alert-danger\"\r\n          >\r\n            <div class=\"col-12\">No Records Found</div>\r\n          </div>\r\n          <div class=\"row\">&nbsp;</div>\r\n          <div class=\"row\" *ngIf=\"pagedItems?.length > 0\">\r\n            <div class=\"table-responsive\">\r\n              <table\r\n                class=\"mdl-data-table table-striped col-12\"\r\n                aria-describedby=\"TabRelaseInformation\"\r\n              >\r\n                <tbody>\r\n                  <th class=\"mdl-data-table__cell--non-numeric\">Rev</th>\r\n                  <th class=\"mdl-data-table__cell--non-numeric\">\r\n                    Release Date\r\n                  </th>\r\n                  <th class=\"mdl-data-table__cell--non-numeric\">\r\n                    Release Updated By\r\n                  </th>\r\n                  <th\r\n                    class=\"mdl-data-table__cell--non-numeric\"\r\n                    *ngIf=\"this.IsProductCodeVisble == true\"\r\n                  >\r\n                    DB Version\r\n                  </th>\r\n                  <th class=\"mdl-data-table__cell--non-numeric\">\r\n                    Release Status\r\n                  </th>\r\n                  <th class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                  <tr\r\n                    *ngFor=\"let row of pagedItems; let i = index\"\r\n                    [ngClass]=\"{\r\n                      STPStart: row.Status === ProductReleaseStatus.STPStart\r\n                    }\"\r\n                  >\r\n                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                      <span>{{ row.ProductReleaseNo }}</span>\r\n                    </td>\r\n                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                      <span>{{ row.UpdatedDate | date : \"dd MMM yyyy\" }}</span>\r\n                    </td>\r\n                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                      <span>{{ row.Name }}</span>\r\n                    </td>\r\n                    <td\r\n                      class=\"mdl-data-table__cell--non-numeric\"\r\n                      *ngIf=\"this.IsProductCodeVisble == true\"\r\n                    >\r\n                      <span>{{ row.DBVersion }}</span>\r\n                    </td>\r\n                    <td class=\"mdl-data-table__cell--non-numeric\">\r\n                      <span\r\n                        class=\"badge badge-success\"\r\n                        *ngIf=\"\r\n                          row.Status == ProductReleaseStatus.ProductionRelease && row.IsDeleted == false\r\n                        \"\r\n                        >Prod Release</span\r\n                      >\r\n                      <!-- Condition Change -->\r\n                      <span\r\n                        class=\"badge badge-primary\"\r\n                        *ngIf=\"row.Status == ProductReleaseStatus.QARelease && row.IsDeleted == false\"\r\n                      >\r\n                        QA Release\r\n                      </span>\r\n                      <span\r\n                        class=\"badge badge-info\"\r\n                        *ngIf=\"row.Status == ProductReleaseStatus.STPStart && row.IsDeleted == false\"\r\n                        >STP In Progress</span\r\n                      >\r\n                      <span\r\n                        class=\"badge badge-warning\"\r\n                        *ngIf=\"row.Status == ProductReleaseStatus.DevRelease && row.IsDeleted == false\"\r\n                        >Dev Release</span\r\n                      >\r\n                      <span\r\n                        class=\"badge badge-pilot\"\r\n                        *ngIf=\"row.Status == ProductReleaseStatus.PilotRelease && row.IsDeleted == false\"\r\n                        >Pilot Release</span\r\n                      >\r\n                      <span\r\n                        class=\"badge badge-custom\"\r\n                        *ngIf=\"row.Status == ProductReleaseStatus.CustomRelease && row.IsDeleted == false\"\r\n                        >Custom Release</span>\r\n                        \r\n                      <span\r\n                      class=\"badge badge-error\"\r\n                      *ngIf=\"row.IsDeleted == true\"\r\n                      >Release Rejected</span\r\n                    >\r\n                    </td>\r\n                    <td class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                      <span\r\n                        *ngIf=\"\r\n                          (this.IsAdd ||\r\n                          this.IsApprove ||\r\n                          this.IsProductionRights) && row.IsDeleted == false\r\n                        \"\r\n                      >\r\n                        <button\r\n                          md-icon-button\r\n                          mdTooltip=\"Edit Release\"\r\n                          (click)=\"openProductReleaseEditDialog(row)\"\r\n                        >\r\n                          <em class=\"fa fa-edit text-warning\"></em>\r\n                        </button>\r\n                      </span>\r\n\r\n                      <span\r\n                        (click)=\"openDialogWithAResult(row)\"\r\n                      >\r\n                        <button md-icon-button mdTooltip=\"View Change Log\">\r\n                          <em class=\"fa fa-info text-info\" aria-hidden=\"true\">\r\n                          </em>\r\n                        </button>\r\n                      </span>\r\n\r\n                      <span>\r\n                        <button md-icon-button mdTooltip=\"View History\" (click)=\"ViewHistory(row)\">\r\n                          <em\r\n                            class=\"fa fa-history\"\r\n                            style=\"color: olive\"\r\n                            aria-hidden=\"true\"\r\n                          >\r\n                          </em>\r\n                        </button>\r\n                      </span>\r\n\r\n                      <span>\r\n                        <button\r\n                          md-icon-button\r\n                          mdTooltip=\"Activate Release\"\r\n                          (click)=\"ActiveRelease(row)\"\r\n                          *ngIf=\"\r\n                            row.Status == ProductReleaseStatus.QARelease &&\r\n                            this.IsProductionRights == true && row.IsDeleted == false\r\n                          \"\r\n                        >\r\n                          <em\r\n                            class=\"fa fa-toggle-off\"\r\n                            style=\"color: grey\"\r\n                            aria-hidden=\"true\"\r\n                          >\r\n                          </em>\r\n                        </button>\r\n                      </span>\r\n\r\n                      <span\r\n                        *ngIf=\"\r\n                          row.Status == ProductReleaseStatus.ProductionRelease && row.IsDeleted == false\r\n                        \"\r\n                      >\r\n                        <button md-icon-button>\r\n                          <em\r\n                            class=\"fa fa-toggle-on text-success\"\r\n                            aria-hidden=\"true\"\r\n                          >\r\n                          </em>\r\n                        </button>\r\n                      </span>\r\n\r\n                      <span\r\n                        *ngIf=\"\r\n                          (row.Status == ProductReleaseStatus.PilotRelease || row.Status == ProductReleaseStatus.CustomRelease) &&\r\n                          row.IsDeleted == false\r\n                        \">\r\n                          <button \r\n                          (click)=\"this.IsProductionRights == true && row.IsDeleted == false && ChangeReleaseType(row)\"\r\n                          md-icon-button mdTooltip=\"Change Release Status\">\r\n                            <em\r\n                              class=\"fa fa-toggle-on\"\r\n                              [ngClass]=\"{\r\n                                'text-pilot': row.Status == ProductReleaseStatus.PilotRelease,\r\n                                'text-custom': row.Status == ProductReleaseStatus.CustomRelease\r\n                              }\"\r\n                              aria-hidden=\"true\"\r\n                            >\r\n                            </em>\r\n                          </button>\r\n                      </span>\r\n\r\n                      <span>\r\n                        <button\r\n                          md-icon-button\r\n                          mdTooltip=\"Approve Release\"\r\n                          (click)=\"ApproveRelease(row)\"\r\n                          *ngIf=\"\r\n                            this.IsApprove == true &&\r\n                            row.Status == ProductReleaseStatus.STPStart && row.IsDeleted == false\r\n                          \"\r\n                        >\r\n                          <em\r\n                            class=\"fa fa-thumbs-up\"\r\n                            style=\"color: #7e57c2\"\r\n                            aria-hidden=\"true\"\r\n                          >\r\n                          </em>\r\n                        </button>\r\n                      </span>\r\n\r\n                      <span>\r\n                        <button\r\n                          md-icon-button\r\n                          mdTooltip=\"Reject Release\"\r\n                          (click)=\"RejectRelease(row)\"\r\n                          *ngIf=\"\r\n                            this.IsApprove == true &&\r\n                            row.Status == ProductReleaseStatus.STPStart && row.IsDeleted == false\r\n                          \"\r\n                        >\r\n                          <em\r\n                            class=\"fa fa-trash\"\r\n                            style=\"color: red\"\r\n                            aria-hidden=\"true\"\r\n                          >\r\n                          </em>\r\n                        </button>\r\n                      </span>\r\n\r\n                      <span>\r\n                        <button\r\n                          md-icon-button\r\n                          mdTooltip=\"STP Start\"\r\n                          (click)=\"STPStart(row)\"\r\n                          *ngIf=\"\r\n                            this.IsApprove == true &&\r\n                            row.Status == ProductReleaseStatus.DevRelease && row.IsDeleted == false\r\n                          \"\r\n                        >\r\n                          <em\r\n                            class=\"fa fa-hourglass-start\"\r\n                            style=\"color: lightseagreen\"\r\n                            aria-hidden=\"true\"\r\n                          >\r\n                          </em>\r\n                        </button>\r\n                      </span>\r\n\r\n                      <!-- Download Button display to all Rights.[Dev & STP Start Release only download by QA Rights]-->\r\n                      <span>\r\n                        <button\r\n                          md-icon-button\r\n                          mdTooltip=\"Download File\"\r\n                          *ngIf=\"\r\n                            ((this.IsApprove == true &&\r\n                              (row.Status == ProductReleaseStatus.DevRelease ||\r\n                                row.Status == ProductReleaseStatus.STPStart)) ||\r\n                              \r\n                              row.Status == ProductReleaseStatus.QARelease ||\r\n                              row.Status == ProductReleaseStatus.ProductionRelease ||\r\n                              row.Status == ProductReleaseStatus.PilotRelease ||\r\n                              row.Status == ProductReleaseStatus.CustomRelease) \r\n                                \r\n                              && row.IsDeleted == false\r\n                          \"\r\n                          (click)=\"DownloadFile(row)\"\r\n                        >\r\n                          <em\r\n                            class=\"fa fa-download\"\r\n                            style=\"color: maroon\"\r\n                            aria-hidden=\"true\"\r\n                          >\r\n                          </em>\r\n                        </button>\r\n                      </span>\r\n\r\n                      <!-- Customer ToolTip Icon -->\r\n                      <span>\r\n                        <button\r\n                          md-icon-button\r\n                          [mdTooltip]=\"row.CustomerTooltip\"\r\n                          *ngIf=\"\r\n                            (row.Status == ProductReleaseStatus.PilotRelease || row.Status == ProductReleaseStatus.CustomRelease) && row.IsDeleted == false\r\n                          \"\r\n                        >\r\n                          <em\r\n                            class=\"fa fa-eye\"\r\n                            aria-hidden=\"true\"\r\n                          >\r\n                          </em>\r\n                        </button>\r\n                      </span>\r\n\r\n                    </td>\r\n                  </tr>\r\n                </tbody>\r\n              </table>\r\n              <!-- <ul *ngIf=\"pager.pages && pager.pages.length\" class=\"pagination\"\r\n                                    style=\"float: right !important;\">\r\n                                    <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                                        <a (click)=\"setPage(1)\">First</a>\r\n                                    </li>\r\n                                    <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                                        <a (click)=\"setPage(pager.currentPage - 1)\">Previous</a>\r\n                                    </li>\r\n                                    <li *ngFor=\"let page of pager.pages\" [ngClass]=\"{active:pager.currentPage === page}\"\r\n                                        style=\"cursor:pointer;\">\r\n                                        <a (click)=\"setPage(page)\">{{page}}</a>\r\n                                    </li>\r\n                                    <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                                        style=\"cursor:pointer;\">\r\n                                        <a (click)=\"setPage(pager.currentPage + 1)\">Next</a>\r\n                                    </li>\r\n                                    <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                                        style=\"cursor:pointer;\">\r\n                                        <a (click)=\"setPage(pager.totalPages)\">Last</a>\r\n                                    </li>\r\n                                </ul> -->\r\n            </div>\r\n          </div>\r\n        </section>\r\n      </div>\r\n    </article>\r\n  </section>\r\n</section>\r\n\r\n<section class=\"page-with-tabs\" *ngIf=\"IsValid\">\r\n  <div class=\"article\">\r\n    <div class=\"container-fluid\">\r\n      <div class=\"row\">\r\n        <div class=\"col-8\">\r\n          <h4>{{ Title }}</h4>\r\n        </div>\r\n        <div class=\"col-4\" style=\"text-align: right\">\r\n          <h4></h4>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <section class=\"container-fluid\">\r\n    <article class=\"article\">\r\n      <div class=\"\">\r\n        <section>\r\n          <hr />\r\n          <div class=\"row\" class=\"alert alert-danger\">\r\n            <div class=\"col-12\">Not Implemented</div>\r\n          </div>\r\n        </section>\r\n      </div>\r\n    </article>\r\n  </section>\r\n</section>\r\n"

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports = "<section class=\"page-with-tabs\">\r\n  <div class=\"article\">\r\n    <div class=\"container-fluid\">\r\n      <div class=\"row\">\r\n        <div class=\"col-7\">\r\n          <label class=\"title\">{{ Title }}</label>\r\n        </div>\r\n        <div class=\"col-5\" style=\"text-align: right\">\r\n          <button \r\n          *ngIf=\"isValidProductForPushNotification\"\r\n            md-raised-button\r\n            type=\"button\"\r\n            color=\"primary\"\r\n            mdTooltip=\"View push notification history\"\r\n            (click)=\"getNotificationHistory()\"\r\n            class=\"pushNotificationHistoryButton\"\r\n          > Notification History \r\n          </button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <section class=\"container-fluid\">\r\n    <article class=\"article\">\r\n      <div class=\"\">\r\n        <section>\r\n          <hr />\r\n          <div style=\"display: flex; flex-direction: row-reverse;\">\r\n            <div>\r\n              <md-checkbox\r\n                class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                [(ngModel)]=\"IsShowDeleted\"\r\n                (change)=\"showRejected(IsShowDeleted)\"\r\n                style=\"position: relative; top: 8px; right: 15px\"\r\n              >\r\n                <span class=\"mat-checkbox-label\"> Show Rejected Releases </span>\r\n              </md-checkbox>\r\n              <button\r\n                md-raised-button\r\n                type=\"submit\"\r\n                *ngIf=\"this.IsAdd\"\r\n                color=\"primary\"\r\n                (click)=\"openProductReleaseAddDialog()\"\r\n              >\r\n                Add New\r\n              </button>\r\n              <button\r\n                md-raised-button\r\n                type=\"submit\"\r\n                color=\"primary\"\r\n                *ngIf=\"pagedItems?.length > 0\"\r\n                (click)=\"OpenViewAllChangeLog()\"\r\n                mdTooltip=\"View All Releases Change Logs\"\r\n              >\r\n                Change Logs\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\">&nbsp;</div>\r\n          <div\r\n            class=\"row\"\r\n            *ngIf=\"releaseData && pagedItems?.length == 0\"\r\n            class=\"alert alert-danger\"\r\n          >\r\n            <div class=\"col-12\">No Records Found</div>\r\n          </div>\r\n          <div class=\"row\">&nbsp;</div>\r\n          <div class=\"row\" *ngIf=\"pagedItems?.length > 0\">\r\n            <div class=\"col-12\">\r\n              <div class=\"table-responsive\">\r\n                <table\r\n                  class=\"mdl-data-table table-striped col-12\"\r\n                  aria-describedby=\"ViewProductReleaseList\"\r\n                >\r\n                  <tbody>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Rev</th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">\r\n                      Release Date\r\n                    </th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">\r\n                      Release Updated By\r\n                    </th>\r\n                    <th\r\n                      class=\"mdl-data-table__cell--non-numeric\"\r\n                      *ngIf=\"this.IsProductCodeVisble == true\"\r\n                    >\r\n                      DB Version\r\n                    </th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">\r\n                      Release Status\r\n                    </th>\r\n                    <th class=\"mdl-data-table__cell--non-numeric\">Action</th>\r\n                    <tr\r\n                      *ngFor=\"let row of pagedItems; let i = index\"\r\n                      [ngClass]=\"{\r\n                        STPStart: row.Status === ProductReleaseStatus.STPStart\r\n                      }\"\r\n                    >\r\n                      <td class=\"mdl-data-table__cell--non-numeric\">\r\n                        <span>{{ row.ProductReleaseNo }}</span>\r\n                      </td>\r\n                      <td class=\"mdl-data-table__cell--non-numeric\">\r\n                        <span>{{\r\n                          row.UpdatedDate | date : \"dd MMM yyyy\"\r\n                        }}</span>\r\n                      </td>\r\n                      <td class=\"mdl-data-table__cell--non-numeric\">\r\n                        <span>{{ row.Name }}</span>\r\n                      </td>\r\n                      <td\r\n                        class=\"mdl-data-table__cell--non-numeric\"\r\n                        *ngIf=\"this.IsProductCodeVisble == true\"\r\n                      >\r\n                        <span>{{ row.DBVersion }}</span>\r\n                      </td>\r\n                      <td class=\"mdl-data-table__cell--non-numeric\">\r\n                        <span\r\n                          class=\"badge badge-success\"\r\n                          *ngIf=\"\r\n                            row.Status == ProductReleaseStatus.ProductionRelease && row.IsDeleted == false\r\n                          \"\r\n                          >Prod Release</span\r\n                        >\r\n                        <span\r\n                          class=\"badge badge-primary\"\r\n                          *ngIf=\"row.Status == ProductReleaseStatus.QARelease && row.IsDeleted == false\"\r\n                        >\r\n                          QA Release\r\n                        </span>\r\n                        <span\r\n                          class=\"badge badge-info\"\r\n                          *ngIf=\"row.Status == ProductReleaseStatus.STPStart && row.IsDeleted == false\"\r\n                          >STP In Progress</span\r\n                        >\r\n                        <span\r\n                          class=\"badge badge-warning\"\r\n                          *ngIf=\"row.Status == ProductReleaseStatus.DevRelease && row.IsDeleted == false\"\r\n                          >Dev Release</span\r\n                        >\r\n\r\n                        <span\r\n                          class=\"badge badge-pilot\"\r\n                          *ngIf=\"row.Status == ProductReleaseStatus.PilotRelease && row.IsDeleted == false\">\r\n                          Pilot Release\r\n                        </span>\r\n\r\n                        <span\r\n                          class=\"badge badge-custom\"\r\n                          *ngIf=\"row.Status == ProductReleaseStatus.CustomRelease && row.IsDeleted == false\">\r\n                          Custom Release\r\n                        </span>\r\n\r\n\r\n                        <span\r\n                        class=\"badge badge-error\"\r\n                        *ngIf=\"row.IsDeleted == true\"\r\n                        >Release Rejected</span\r\n                      >\r\n                      </td>\r\n                      <td class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                        <span\r\n                          *ngIf=\"\r\n                            (this.IsAdd ||\r\n                            this.IsApprove ||\r\n                            this.IsProductionRights) &&\r\n                            row.IsDeleted == false\r\n                          \"\r\n                        >\r\n                          <button\r\n                            mdTooltip=\"Edit Release\"\r\n                            md-icon-button\r\n                            (click)=\"openProductReleaseEditDialog(row)\"\r\n                          >\r\n                            <em class=\"fa fa-edit text-warning\"></em>\r\n                          </button>\r\n                        </span>\r\n\r\n                        <span\r\n                          (click)=\"openDialogWithAResult(row)\"\r\n                        >\r\n                          <button md-icon-button\r\n                            mdTooltip=\"View Change Log\"\r\n                          >\r\n                            <em class=\"fa fa-info text-info\" aria-hidden=\"true\">\r\n                            </em>\r\n                          </button>\r\n                        </span>\r\n\r\n                        <span>\r\n                          <button md-icon-button mdTooltip=\"View History\" (click)=\"ViewHistory(row)\">\r\n                            <em\r\n                              class=\"fa fa-history\"\r\n                              style=\"color: olive\"\r\n                              aria-hidden=\"true\"\r\n                            ></em>\r\n                          </button>\r\n                        </span>\r\n\r\n                        <span>\r\n                          <button\r\n                            md-icon-button\r\n                            mdTooltip=\"Activate Release\"\r\n                            (click)=\"ActiveRelease(row)\"\r\n                            *ngIf=\"\r\n                              row.Status == ProductReleaseStatus.QARelease &&\r\n                              this.IsProductionRights == true  &&\r\n                              row.IsDeleted == false\r\n                            \"\r\n                          >\r\n                            <em\r\n                              class=\"fa fa-toggle-off\"\r\n                              style=\"color: grey\"\r\n                              aria-hidden=\"true\"\r\n                            ></em>\r\n                          </button>\r\n                        </span>\r\n\r\n                        <span\r\n                          *ngIf=\"\r\n                            row.Status == ProductReleaseStatus.ProductionRelease  &&\r\n                            row.IsDeleted == false\r\n                          \"\r\n                        >\r\n                          <button md-icon-button>\r\n                            <em\r\n                              class=\"fa fa-toggle-on text-success\"\r\n                              aria-hidden=\"true\"\r\n                            >\r\n                            </em>\r\n                          </button>\r\n                        </span>\r\n\r\n                        <span\r\n                          *ngIf=\"\r\n                            (row.Status == ProductReleaseStatus.PilotRelease || row.Status == ProductReleaseStatus.CustomRelease) &&\r\n                            row.IsDeleted == false\r\n                        \">\r\n                          <button \r\n                          (click)=\"this.IsProductionRights == true && row.IsDeleted == false && ChangeReleaseType(row)\"\r\n                          md-icon-button mdTooltip=\"Change Release Status\">\r\n                            <em\r\n                              class=\"fa fa-toggle-on\"\r\n                              [ngClass]=\"{\r\n                                'text-pilot': row.Status == ProductReleaseStatus.PilotRelease,\r\n                                'text-custom': row.Status == ProductReleaseStatus.CustomRelease\r\n                              }\"\r\n                              aria-hidden=\"true\"\r\n                            >\r\n                            </em>\r\n                          </button>\r\n                      </span>\r\n\r\n                        <span>\r\n                          <button\r\n                            md-icon-button\r\n                            mdTooltip=\"Approve Release\"\r\n                            (click)=\"ApproveRelease(row)\"\r\n                            *ngIf=\"\r\n                              this.IsApprove == true &&\r\n                              row.Status == ProductReleaseStatus.STPStart  &&\r\n                              row.IsDeleted == false\r\n                            \"\r\n                          >\r\n                            <em\r\n                              class=\"fa fa-thumbs-up\"\r\n                              style=\"color: #7e57c2\"\r\n                              aria-hidden=\"true\"\r\n                            ></em>\r\n                          </button>\r\n                        </span>\r\n\r\n                        <span>\r\n                          <button\r\n                            mdTooltip=\"Reject Release\"\r\n                            md-icon-button\r\n                            (click)=\"RejectRelease(row)\"\r\n                            *ngIf=\"\r\n                              this.IsApprove == true &&\r\n                              row.Status == ProductReleaseStatus.STPStart  &&\r\n                              row.IsDeleted == false\r\n                            \"\r\n                          >\r\n                            <em\r\n                              class=\"fa fa-trash\"\r\n                              style=\"color: red\"\r\n                              aria-hidden=\"true\"\r\n                            ></em>\r\n                          </button>\r\n                        </span>\r\n\r\n                        <span>\r\n                          <button\r\n                            md-icon-button\r\n                            mdTooltip=\"STP Start\"\r\n                            (click)=\"STPStart(row)\"\r\n                            *ngIf=\"\r\n                              this.IsApprove == true &&\r\n                              row.Status == ProductReleaseStatus.DevRelease  &&\r\n                              row.IsDeleted == false\r\n                            \"\r\n                          >\r\n                            <em\r\n                              class=\"fa fa-hourglass-start\"\r\n                              style=\"color: lightseagreen\"\r\n                              aria-hidden=\"true\"\r\n                            >\r\n                            </em>\r\n                          </button>\r\n                        </span>\r\n\r\n                        <!-- Download Button display to all Rights.[Dev & STP Start Release only download by QA Rights]-->\r\n                        <span>\r\n                          <button\r\n                            md-icon-button\r\n                            mdTooltip=\"Download File\"\r\n                            *ngIf=\"\r\n                              ((this.IsApprove == true &&\r\n                                (row.Status ==\r\n                                  ProductReleaseStatus.DevRelease ||\r\n                                  row.Status ==\r\n                                    ProductReleaseStatus.STPStart)) ||\r\n                                row.Status == ProductReleaseStatus.QARelease ||\r\n                                row.Status == ProductReleaseStatus.ProductionRelease || \r\n                                row.Status == ProductReleaseStatus.PilotRelease ||\r\n                                row.Status == ProductReleaseStatus.CustomRelease) &&\r\n                                row.IsDeleted == false\r\n                            \"\r\n                            (click)=\"DownloadFile(row)\"\r\n                          >\r\n                            <em\r\n                              class=\"fa fa-download\"\r\n                              style=\"color: maroon\"\r\n                              aria-hidden=\"true\"\r\n                            ></em>\r\n                          </button>\r\n                        </span>\r\n\r\n                        <!-- Customer ToolTip Icon -->\r\n                        <span>\r\n                          <button\r\n                            md-icon-button\r\n                            [mdTooltip]=\"row.CustomerTooltip\"\r\n                            *ngIf=\"\r\n                              (row.Status == ProductReleaseStatus.PilotRelease || row.Status == ProductReleaseStatus.CustomRelease) && row.IsDeleted == false\r\n                            \"\r\n                          >\r\n                            <em\r\n                              class=\"fa fa-eye\"\r\n                              aria-hidden=\"true\"\r\n                            >\r\n                            </em>\r\n                          </button>\r\n                        </span>\r\n                      \r\n                      </td>\r\n                    </tr>\r\n                  </tbody>\r\n                </table>\r\n                <!-- <ul *ngIf=\"pager.pages && pager.pages.length\" class=\"pagination\">\r\n                                    <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                                        <a (click)=\"setPage(1)\">First</a>\r\n                                    </li>\r\n                                    <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                                        <a (click)=\"setPage(pager.currentPage - 1)\">Previous</a>\r\n                                    </li>\r\n                                    <li *ngFor=\"let page of pager.pages\" [ngClass]=\"{active:pager.currentPage === page}\"\r\n                                        style=\"cursor:pointer;\">\r\n                                        <a (click)=\"setPage(page)\">{{page}}</a>\r\n                                    </li>\r\n                                    <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                                        style=\"cursor:pointer;\">\r\n                                        <a (click)=\"setPage(pager.currentPage + 1)\">Next</a>\r\n                                    </li>\r\n                                    <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                                        style=\"cursor:pointer;\">\r\n                                        <a (click)=\"setPage(pager.totalPages)\">Last</a>\r\n                                    </li>\r\n                                </ul> -->\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </section>\r\n      </div>\r\n    </article>\r\n  </section>\r\n</section>\r\n"

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports = "<section class=\"page-with-tabs\">\r\n    <div class=\"article\">\r\n        <div class=\"container-fluid\">\r\n            <div class=\"row\">\r\n                <div class=\"col-7\">\r\n                    <h3>{{Title}}</h3>\r\n                </div> \r\n                <div class=\"col-5\" style=\"text-align: right; margin-top: 24px;\">\r\n                    <button *ngIf=\"this.isValidProductForPushNotification\"\r\n                    id=\"notificationhistory\"\r\n                      md-raised-button\r\n                      type=\"button\"\r\n                      color=\"primary\"\r\n                      mdTooltip=\"View push notification history\"\r\n                      (click)=\"getNotificationHistory()\"\r\n                    > Notification History\r\n                    </button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <section class=\"container-fluid\">\r\n        <article class=\"article\">            \r\n            <div class=\"\">\r\n                <section>\r\n                     <div class=\"\">                                                      \r\n                        <md-tab-group [selectedIndex]=\"SelectedTabIndex\">\r\n                            <md-tab *ngFor=\"let tab of Tab\" [label]=\"tab.ProductName\"> \r\n                                <div class=\"md-tab-content\" style=\"border:1px solid #ddd; \"><my-page-layout-with-product-release-tab-list [SubProductName]=\"tab.ProductName\" [SubType]=\"tab.SubType\" [Id]=\"tab.ProductId\" [TabOrder]=\"tab.TabOrder\" [ParentProductId]=\"ParentProductId\" [Code]=\"tab.Code\" [ProductName]=\"Title\" [Variant]=\"variant\"></my-page-layout-with-product-release-tab-list></div>                                                                                                   \r\n                            </md-tab>                                                                                   \r\n                        </md-tab-group>   \r\n                    </div>\r\n                </section>\r\n            </div>\r\n        </article>\r\n    </section>\r\n</section>\r\n\r\n\r\n"

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports = "<section class=\"page-with-tabs\">\r\n    <div class=\"article\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row\">\r\n          <div class=\"col-10\">\r\n            <h3 class=\"title\">Notification History for {{productName}}</h3>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <section class=\"container-fluid\">\r\n      <article class=\"article\">\r\n        <div class=\"\">\r\n          <section>\r\n            <hr />\r\n            <div style=\"display: flex; flex-direction: row;\">\r\n            </div>\r\n            <div class=\"row\">&nbsp;</div>\r\n            <div class=\"row\" *ngIf=\"errorMessage!==''\" class=\"alert alert-danger\">\r\n              <div class=\"col-12\">{{errorMessage}}</div>\r\n            </div>\r\n            <div class=\"row\">&nbsp;</div>\r\n            <div class=\"row\" *ngIf=\"pushNotificationHistoryList?.length > 0\">\r\n              <div class=\"col-12\">\r\n                <div class=\"table-responsive\">\r\n                  <table class=\"mdl-data-table table-striped col-12\" aria-describedby=\"ViewProductReleaseList\">\r\n                    <tbody>\r\n                      <th class=\"mdl-data-table__cell--non-numeric\">Sr.No</th>\r\n                      <th class=\"mdl-data-table__cell--non-numeric\"\r\n                        style=\"align-items: center;  justify-content: center;\" *ngIf=\"IsProductSubTypeVisible\">ProductSubType</th>\r\n                      <th class=\"mdl-data-table__cell--non-numeric\">\r\n                        Title\r\n                      </th>\r\n                      <th style=\"text-wrap: wrap;\" class=\"mdl-data-table__cell--non-numeric\">\r\n                        Body\r\n                      </th>\r\n                      <th class=\"mdl-data-table__cell--non-numeric\">\r\n                        Revision Number\r\n                      </th>\r\n                      <th class=\"mdl-data-table__cell--non-numeric\">\r\n                        TimeStamp\r\n                      </th>\r\n                      <tr *ngFor=\"let row of pushNotificationHistoryList; let i = index\">\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                          <span>{{i+1}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\" *ngIf=\"IsProductSubTypeVisible\" >\r\n                          <span>{{row.ProductSubType}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                          <span>{{\r\n                            row.Title\r\n                            }}</span>\r\n                        </td>\r\n                        <td style=\"text-wrap: wrap; white-space: pre-line;\" class=\"mdl-data-table__cell--non-numeric\">\r\n                          <span>{{row.Body}}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                          <span>{{ row.ProductReleaseNo }}</span>\r\n                        </td>\r\n                        <td class=\"mdl-data-table__cell--non-numeric\">\r\n                          <span>{{\r\n                            UTCToLocalTimeZone(row.CreatedDate)\r\n                            | date : \"dd/MM/yyyy hh:mm:ss a\"\r\n                            }}</span>\r\n                        </td>\r\n                      </tr>\r\n                    </tbody>\r\n                  </table>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </section>\r\n        </div>\r\n      </article>\r\n    </section>\r\n  </section>"

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <div>\r\n        <section>\r\n            <div class=\"col-12\">\r\n                <button type=\"button\" class=\"close\" (click)=\"onCancel()\">&times;</button>\r\n                <h1 md-dialog-title=\"\" class=\"mat-dialog-title\">{{Title}}</h1>\r\n                <div class=\"row\" *ngIf=\"ChangeLogData?.length == 0\" class=\"alert alert-danger\">\r\n                    No Records Found\r\n                </div>\r\n            </div>\r\n            <div class=\"col-12\" *ngIf=\"ChangeLogData?.length > 0\">\r\n                <div class=\"table-responsive\">\r\n                    <table class=\"mdl-data-table table-striped col-12\" aria-describedby=\"ViewChangeLogTable\">\r\n                        <tbody>\r\n                            <th class=\"mdl-data-table__cell--non-numeric_title\" >\r\n                                <strong>Sr. No</strong>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric_title\" >\r\n                                <strong>Change Log</strong>\r\n                            </th>\r\n                            <tr *ngFor=\"let row of ChangeLogData;let i = index\">\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <span>{{ i + 1}}</span>\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <span style=\"text-wrap: wrap;\" class=\"wraptext\">{{row.ChangeLog}}</span>\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>                \r\n            </div>\r\n        </section>\r\n    </div>\r\n</article>"

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n  <div>\r\n    <section>\r\n      <div class=\"col-12\">\r\n        <button type=\"button\" class=\"close\" (click)=\"onCancel()\">\r\n          &times;\r\n        </button>\r\n        <h1 md-dialog-title=\"\" class=\"mat-dialog-title\">{{ Title }}</h1>\r\n        <div\r\n          class=\"row\"\r\n          *ngIf=\"historyData?.length == 0\"\r\n          class=\"alert alert-danger\"\r\n        >\r\n          <div class=\"col-12\">No Records Found</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-12\" *ngIf=\"historyData?.length > 0\">\r\n        <div class=\"table-responsive\">\r\n          <table\r\n            class=\"mdl-data-table table-striped col-12\"\r\n            aria-describedby=\"ProductReleaseRevisionHistory\"\r\n          >\r\n            <tbody>\r\n              <th class=\"mdl-data-table__cell--non-numeric_title\">User</th>\r\n              <th class=\"mdl-data-table__cell--non-numeric_title\">Role</th>\r\n              <th class=\"mdl-data-table__cell--non-numeric_title\">Status</th>\r\n              <th class=\"mdl-data-table__cell--non-numeric_title\">\r\n                Updated On\r\n              </th>\r\n              <th style=\"text-wrap: wrap;\" class=\"mdl-data-table__cell--non-numeric_title\">\r\n                Comments\r\n              </th>\r\n              <tr *ngFor=\"let row of historyData; let i = index\">\r\n                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                  <span>\r\n                    <strong>{{ row.CreatedBy }}</strong></span\r\n                  >\r\n                </td>\r\n                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                  {{ row.Role }}\r\n                </td>\r\n                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                  {{ row.Notes }}\r\n                </td>\r\n                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                  <span>\r\n                    {{\r\n                      UTCToLocalTimeZone(row.CreatedDate)\r\n                        | date : \"dd/MM/yyyy hh:mm:ss a\"\r\n                    }}\r\n                  </span>\r\n                </td>\r\n                <td style=\"text-wrap: wrap;\" class=\"mdl-data-table__cell--non-numeric\">\r\n                  {{row.CommentDesc}}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n      </div>\r\n    </section>\r\n  </div>\r\n</article>\r\n"

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <div>\r\n        <section>\r\n            <div class=\"col-12\">\r\n                <button type=\"button\" class=\"close\" (click)=\"onCancel()\">&times;</button>\r\n                <h1 md-dialog-title=\"\" class=\"mat-dialog-title\">{{Title}}</h1>\r\n                <div class=\"row\" *ngIf=\"changeLogData?.length == 0\" class=\"alert alert-danger\">\r\n                    No Records Found\r\n                </div>\r\n            </div>\r\n            <div class=\"col-12\" *ngIf=\"changeLogData?.length > 0\">\r\n                <div class=\"table-responsive\">\r\n                    <ul *ngFor=\"let row of changeLogData;let i = index\">\r\n                        <li><strong>{{row.ProductReleaseNo}}</strong></li>\r\n                        <ul *ngFor=\"let changelog of row.ChangeLog;let j = index\">\r\n                            <li>\r\n                                <span style=\"white-space: pre;\">{{changelog}}</span>\r\n                            </li>\r\n                        </ul>\r\n                        <br />\r\n                    </ul>\r\n                </div>\r\n            </div>\r\n        </section>\r\n    </div>\r\n</article>"

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports = "<!--\r\n  Two visual regions rendered in normal flow:\r\n  1. .sms-host  — the trigger + absolute dropdown panel\r\n  2. .sms-confirmed — the Selected Items list (always in-flow, below the host)\r\n-->\r\n\r\n<!-- ── Region 1: Trigger + Panel ────────────────────────────────────────────── -->\r\n<div\r\n  class=\"sms-host\"\r\n  [class.sms-host--open]=\"isOpen\"\r\n  [class.sms-host--disabled]=\"disabled\">\r\n\r\n  <!-- Trigger: bordered box with placeholder and chevron -->\r\n  <div\r\n    class=\"sms-trigger\"\r\n    role=\"combobox\"\r\n    [attr.aria-expanded]=\"isOpen\"\r\n    aria-haspopup=\"listbox\"\r\n    [attr.aria-disabled]=\"disabled\"\r\n    tabindex=\"{{ disabled ? -1 : 0 }}\"\r\n    (click)=\"togglePanel()\"\r\n    (keydown.enter)=\"togglePanel()\"\r\n    (keydown.space)=\"togglePanel()\">\r\n\r\n    <span class=\"sms-trigger__value sms-trigger__value--placeholder\">\r\n      {{ placeholder }}\r\n    </span>\r\n\r\n    <span class=\"sms-trigger__arrow\" aria-hidden=\"true\">\r\n      <svg width=\"10\" height=\"6\" viewBox=\"0 0 10 6\">\r\n        <path d=\"M0 0l5 6 5-6z\" fill=\"currentColor\"/>\r\n      </svg>\r\n    </span>\r\n  </div>\r\n\r\n  <!-- ── Dropdown panel ───────────────────────────────────────────────────── -->\r\n  <div\r\n    *ngIf=\"isOpen\"\r\n    class=\"sms-panel\"\r\n    role=\"listbox\"\r\n    aria-multiselectable=\"true\">\r\n\r\n    <!-- Search row — magnifier icon + text input + optional clear -->\r\n    <div class=\"sms-panel__search\">\r\n      <span class=\"sms-panel__search-icon\" aria-hidden=\"true\">\r\n        <!-- Simple SVG magnifier; no icon font dependency -->\r\n        <svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\">\r\n          <circle cx=\"11\" cy=\"11\" r=\"8\"/>\r\n          <line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\"/>\r\n        </svg>\r\n      </span>\r\n\r\n      <input\r\n        #searchInput\r\n        class=\"sms-panel__search-input\"\r\n        type=\"text\"\r\n        placeholder=\"Search…\"\r\n        [value]=\"searchQuery\"\r\n        (input)=\"onSearchChange(searchInput.value)\"\r\n        (keydown.escape)=\"closePanel()\"\r\n        autocomplete=\"off\"\r\n        aria-label=\"Search options\"/>\r\n\r\n      <button\r\n        *ngIf=\"searchQuery\"\r\n        class=\"sms-panel__search-clear\"\r\n        type=\"button\"\r\n        tabindex=\"-1\"\r\n        aria-label=\"Clear search\"\r\n        (click)=\"onSearchChange('')\">\r\n        &#x2715;\r\n      </button>\r\n    </div>\r\n\r\n    <!-- Scrollable options list — shows only available (non-confirmed) items -->\r\n    <ul class=\"sms-panel__list\" role=\"presentation\">\r\n\r\n      <li\r\n        *ngIf=\"filteredItems.length === 0\"\r\n        class=\"sms-panel__empty\"\r\n        role=\"option\"\r\n        aria-selected=\"false\">\r\n        No results found\r\n      </li>\r\n\r\n      <!--\r\n        Label is on the LEFT; checkbox is on the RIGHT — matching the reference.\r\n        trackById keeps unchanged rows stable during search keystrokes.\r\n      -->\r\n      <li\r\n        *ngFor=\"let item of filteredItems; trackBy: trackById\"\r\n        class=\"sms-panel__option\"\r\n        [class.sms-panel__option--selected]=\"isSelected(item)\"\r\n        role=\"option\"\r\n        [attr.aria-selected]=\"isSelected(item)\"\r\n        (click)=\"toggleItem(item)\"\r\n        (keydown.enter)=\"toggleItem(item)\"\r\n        (keydown.space)=\"toggleItem(item)\"\r\n        tabindex=\"0\">\r\n\r\n        <span class=\"sms-panel__option-label\">{{ item[textField] }}</span>\r\n\r\n        <span\r\n          class=\"sms-checkbox\"\r\n          [class.sms-checkbox--checked]=\"isSelected(item)\"\r\n          aria-hidden=\"true\">\r\n          <span class=\"sms-checkbox__box\">\r\n            <span class=\"sms-checkbox__checkmark\"></span>\r\n          </span>\r\n        </span>\r\n\r\n      </li>\r\n\r\n    </ul>\r\n\r\n    <!-- Footer: pending count (left) + Confirm button (right) -->\r\n    <div class=\"sms-panel__footer\">\r\n      \r\n      <button\r\n        type=\"button\"\r\n        class=\"sms-panel__confirm\"\r\n        [disabled]=\"pendingCount === 0\"\r\n        (click)=\"confirmSelection()\">\r\n        Select Customers\r\n      </button>\r\n      \r\n      <!--\r\n        type=\"button\" is critical — prevents Enter on this button from\r\n        submitting the parent <form>.\r\n        -->\r\n      \r\n      <span class=\"sms-panel__count\">\r\n        <ng-container *ngIf=\"pendingCount > 0\">\r\n          {{ pendingCount }} selected\r\n        </ng-container>\r\n      </span>\r\n    </div>\r\n\r\n  </div><!-- /.sms-panel -->\r\n\r\n</div><!-- /.sms-host -->\r\n\r\n<!-- ── Region 2: Selected Items list ─────────────────────────────────────── -->\r\n<!--\r\n  Rendered in normal document flow directly below the trigger.\r\n  Only shown when at least one item has been confirmed.\r\n-->\r\n<div class=\"sms-confirmed\" *ngIf=\"confirmedItems.length > 0\">\r\n\r\n  <div class=\"sms-confirmed__heading\">\r\n    Selected Customers ({{ confirmedItems.length }})\r\n  </div>\r\n\r\n  <ul class=\"sms-confirmed__list\">\r\n\r\n    <li\r\n      *ngFor=\"let item of confirmedItems; trackBy: trackById\"\r\n      class=\"sms-confirmed__row\">\r\n\r\n      <span class=\"sms-confirmed__name\">{{ item[textField] }}</span>\r\n\r\n      <!--\r\n        Remove button — circle-minus icon in primary colour.\r\n        type=\"button\" prevents accidental form submission.\r\n      -->\r\n      <button\r\n        type=\"button\"\r\n        title=\"Remove customer\"\r\n        class=\"sms-confirmed__remove\"\r\n        [attr.aria-label]=\"'Remove ' + item[textField]\"\r\n        (click)=\"removeConfirmed(item[idField])\">\r\n        <!-- Circle-minus SVG; no icon font dependency -->\r\n        <svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\"\r\n             stroke=\"currentColor\" stroke-width=\"2\">\r\n          <circle cx=\"12\" cy=\"12\" r=\"10\"/>\r\n          <line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"/>\r\n        </svg>\r\n      </button>\r\n\r\n    </li>\r\n\r\n  </ul>\r\n\r\n</div><!-- /.sms-confirmed -->\r\n"

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports = "<section>\r\n  <div style=\"display: flex; align-items: center; justify-content: center; margin-top: 60px ;\">\r\n    <h2>Add/ Edit User</h2>\r\n  </div>\r\n  <section>\r\n    <article class=\"article\">\r\n      <div class=\"\">\r\n        <section>\r\n          <div class=\"\">\r\n            <header>\r\n              <h4></h4>\r\n            </header>\r\n            <div class=\"col-12\">\r\n              <form [formGroup]=\"validationForm\" (ngSubmit)=\"onSubmit()\">\r\n                <div class=\"form-group row\">\r\n                  <label class=\"col-md-2 control-label\" for=\"inputEmail3\"\r\n                    >Name\r\n                  </label>\r\n                  <div class=\"col-md-4\">\r\n                    <input\r\n                      class=\"form-control\"\r\n                      maxlength=\"50\"\r\n                      formControlName=\"Name\"\r\n                      type=\"text\"\r\n                    />\r\n                  </div>\r\n                  <div\r\n                    *ngIf=\"submitted &amp;&amp; validationForm.controls.Name.errors\"\r\n                    class=\"col-md-6\"\r\n                  >\r\n                    <div *ngIf=\"validationForm.controls.Name.errors.required\">\r\n                      <span style=\"color: red\"> Name is required.</span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group row\" >\r\n                  <div class=\"col-md-2\"></div>\r\n                  <div class=\"col-md-4\" *ngIf=\"validationForm.get('Name').hasError('pattern')\">\r\n                    <span style=\"color: red\">Enter valid name</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                  <label class=\"col-md-2 control-label\" for=\"inputEmail3\"\r\n                    >Email Id\r\n                  </label>\r\n                  <div class=\"col-md-4\">\r\n                    <input\r\n                      class=\"form-control\"\r\n                      maxlength=\"64\"\r\n                      formControlName=\"EmailId\"\r\n                      type=\"text\"\r\n                    />\r\n                  </div>\r\n                  <div\r\n                    *ngIf=\"submitted && validationForm.controls.EmailId.errors\"\r\n                    class=\"col-md-6\"\r\n                  >\r\n                    <div\r\n                      *ngIf=\"validationForm.controls.EmailId.errors.required\"\r\n                    >\r\n                      <span style=\"color: red\"> EmailId is required.</span>\r\n                    </div>\r\n                    <div *ngIf=\"validationForm.controls.EmailId.errors.pattern\">\r\n                      <span style=\"color: red\"\r\n                        >Email must be a valid email address</span\r\n                      >\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                  <label class=\"col-md-2 control-label\"\r\n                    >Rights\r\n                  </label>\r\n                  <div class=\"col-md-4\" style=\"display: flex; flex-direction: column;\">\r\n                    <md-checkbox\r\n                      class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                      formControlName=\"OTARights\"\r\n                      (change)=\"OTARightsChange($event)\">\r\n                      <span>OTA</span>\r\n                    </md-checkbox>\r\n                    <div *ngIf=\"validationForm.value.OTARights\">\r\n                      <div style=\"display: flex; flex-direction: row; margin-left: 7%;\">\r\n                        <div style=\"font-weight: bold;\"><span >Role:&nbsp;&nbsp;&nbsp;</span></div>\r\n                        <div>\r\n                          <md-radio-group\r\n                            [(ngModel)]=\"selected\"\r\n                            formControlName=\"Role\"\r\n                          >\r\n                            <md-radio-button\r\n                              style=\"margin-right: 10px\"\r\n                              *ngFor=\"let a of items\"\r\n                              [value]=\"a.value\"\r\n                              (change)=\"radioChange($event)\"\r\n                            >\r\n                              {{ a.label }}\r\n                            </md-radio-button>\r\n                          </md-radio-group>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <md-checkbox\r\n                      class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                      formControlName=\"LicensingRights\"\r\n                      (change)=\"LicenseRightsChange($event)\">\r\n                      Licensing\r\n                    </md-checkbox>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group row\">\r\n                  <label class=\"col-md-2 control-label\" for=\"inputEmail3\">\r\n                  </label>\r\n                  <div class=\"col-md-4\">\r\n                    <md-checkbox\r\n                      class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                      formControlName=\"IsAdmin\"\r\n                      (change)=\"checkCheckBoxvalue($event)\"\r\n                    >\r\n                      <span class=\"mat-checkbox-label\"> Is Admin </span>\r\n                    </md-checkbox>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">&nbsp;</div>\r\n              </form>\r\n              <div class=\"row\" *ngIf=\"validationForm.value.OTARights\">\r\n                <div class=\"col-xl-12\">\r\n                  <div class=\"box\">\r\n                    <div class=\"box-header box-dark\">\r\n                      <!-- <md-checkbox\r\n                        class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                        [ngModel]=\"chkAllProduct\"\r\n                        (change)=\"CheckAllProductOptions()\"\r\n                        form\r\n                      >\r\n                        <span class=\"mat-checkbox-label\"> Product Rights </span>\r\n                      </md-checkbox> -->\r\n                      <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n                        <h6 style=\"margin: 5px;\"><b>Product Rights</b></h6>\r\n                        <button md-icon-button class=\"iconsize\" style=\"background:none\" (click)=\"ExpandProductRightsColumn()\"><em class=\"fa fa-angle-down\"></em></button>\r\n                      </div>\r\n                    </div>\r\n                    <div *ngIf=\"isProductRightsColumnExpanded\" class=\"box-body bg-color-white\">\r\n                      <div\r\n                        class=\"row\"\r\n                        *ngFor=\"let product of productData; let i = index\"\r\n                      >\r\n                        <div class=\"col-md-4\">\r\n                          <!-- <md-checkbox\r\n                            class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                            [(ngModel)]=\"product.checked\"\r\n                            (change)=\"changeproductvalue(i)\"\r\n                            form\r\n                          >\r\n                            <span class=\"mat-checkbox-label\">\r\n                              {{ product.ProductName }}\r\n                            </span>\r\n                          </md-checkbox> -->\r\n                          <label class=\"control-label top-space\">\r\n                            {{ product.ProductName }}\r\n                          </label>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          <md-checkbox\r\n                            class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                            [(ngModel)]=\"product.Addchecked\" (change)=\"checkDevValue(1, product.Addchecked, product)\"\r\n                          >\r\n                            <span class=\"mat-checkbox-label\" [ngStyle]=\"product.isDirtyAddchecked?{'color': 'red'} : {'color': 'black'}\">\r\n                              Developer\r\n                              <!-- Developer Means Only Add/Edit/Delete Rights-->\r\n                            </span>\r\n                          </md-checkbox>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          <md-checkbox\r\n                            class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                            [(ngModel)]=\"product.Approvechecked\" (change)=\"checkDevValue(2, product.Approvechecked, product)\"\r\n                          >\r\n                            <span class=\"mat-checkbox-label\"  [ngStyle]=\"product.isDirtyActiveInactiveChecked?{'color': 'red'} : {'color': 'black'}\">\r\n                              QA\r\n                              <!--  QA Means Approve/Reject Means Only Approve/Reject Rights-->\r\n                            </span>\r\n                          </md-checkbox>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          <md-checkbox\r\n                            class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                            [(ngModel)]=\"product.ActiveInactiveChecked\" (change)=\"checkDevValue(3, product.ActiveInactiveChecked, product)\"\r\n                          >\r\n                            <span class=\"mat-checkbox-label\"  [ngStyle]=\"product.isDirtyApprovechecked?{'color': 'red'} : {'color': 'black'}\">\r\n                              Production\r\n                              <!-- Production Rights Means Only Active/Inactive-->\r\n                            </span>\r\n                          </md-checkbox>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\" *ngIf=\"validationForm.value.LicensingRights\">\r\n                <div class=\"col-xl-12\">\r\n                  <div class=\"box\">\r\n                    <div class=\"box-header box-dark\">\r\n                      <!-- <md-checkbox\r\n                        class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                        [ngModel]=\"chkAllProduct\"\r\n                        (change)=\"CheckAllProductOptions()\"\r\n                        form\r\n                      >\r\n                        <span class=\"mat-checkbox-label\"> Product Rights </span>\r\n                      </md-checkbox> -->\r\n                      <div style=\"display: flex; flex-direction: row; justify-content: space-between;\">\r\n                        <h6 style=\"margin: 5px;\"><b>Licensing Rights</b></h6>\r\n                        <button md-icon-button class=\"iconsize\" style=\"background:none\" (click)=\"ExpandLicenseRightsColumn()\"><em class=\"fa fa-angle-down\"></em></button>\r\n                      </div>\r\n                    </div>\r\n                    <div *ngIf=\"isLicenseRightsColumnExpanded\" class=\"box-body bg-color-white\">\r\n                      <div\r\n                        class=\"row\"\r\n                        *ngFor=\"let product of licenseProducts; let i = index\"\r\n                      >\r\n                        <div class=\"col-md-4\">\r\n                          <!-- <md-checkbox\r\n                            class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                            [(ngModel)]=\"product.checked\"\r\n                            (change)=\"changeproductvalue(i)\"\r\n                            form\r\n                          >\r\n                            <span class=\"mat-checkbox-label\">\r\n                              {{ product.ProductName }}\r\n                            </span>\r\n                          </md-checkbox> -->\r\n                          <label class=\"control-label top-space\">\r\n                            {{ product.ProductName }}\r\n                          </label>\r\n                        </div>\r\n                        <div class=\"col-md-2\">\r\n                          <md-checkbox\r\n                            class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n                            [(ngModel)]=\"product.IsAddEdit\"\r\n                          >\r\n                            <span class=\"mat-checkbox-label\">\r\n                              Add/Edit License\r\n                              <!-- Developer Means Only Add/Edit/Delete Rights-->\r\n                            </span>\r\n                          </md-checkbox>\r\n                        </div>\r\n                       <div class=\"col-md-2\" *ngIf=\"product.ProductName !== 'Sync IT'\">\r\n  <md-checkbox\r\n    class=\"mat-checkbox mat-accent mat-checkbox-anim-unchecked-checked mat-checkbox-checked\"\r\n    [(ngModel)]=\"product.IsDelete\"\r\n  >\r\n    <span class=\"mat-checkbox-label\">\r\n      Delete License\r\n    </span>\r\n  </md-checkbox>\r\n</div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                  <button\r\n                    class=\"btn-w-md no-margin-left mat-raised-button mat-accent\"\r\n                    \r\n                    [disabled]=\"!validationForm.valid\"\r\n                    color=\"primary\"\r\n                    (click)=\"onSubmit()\"\r\n                    md-raised-button=\"\"\r\n                    ng-reflect-color=\"primary\"\r\n                  >\r\n                    <span class=\"mat-button-wrapper\">Save</span>\r\n                  </button>\r\n                  <button\r\n                    class=\"btn-w-md no-margin-left mat-raised-button mat-warn\"\r\n                    color=\"primary\"\r\n                    (click)=\"oneditcancel()\"\r\n                    md-raised-button=\"\"\r\n                    ng-reflect-color=\"primary\"\r\n                  >\r\n                    <span class=\"mat-button-wrapper\">Cancel</span>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </section>\r\n      </div>\r\n    </article>\r\n  </section>\r\n</section>\r\n\r\n<style>\r\n  :host ::ng-deep .mat-radio-container {\r\n    height: 17px !important;\r\n  }\r\n</style>\r\n"

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports = "<section id=\"page-container\" class=\"app-page-container\">\r\n    <my-app-header></my-app-header>\r\n    <div>\r\n        <div class=\"container-fluid\">\r\n            <router-outlet></router-outlet>\r\n        </div>\r\n    </div>\r\n    <my-app-footer></my-app-footer>\r\n</section>"

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports = "<article class=\"article\">\r\n    <div>\r\n        <section>\r\n            <div class=\"col-12\">\r\n                <button type=\"button\" class=\"close\" (click)=\"onCancel()\">&times;</button>\r\n                <h1 md-dialog-title=\"\" class=\"mat-dialog-title\">{{Title}}</h1>\r\n                <div class=\"row\" *ngIf=\"userrightssummary?.length == 0\" class=\"alert alert-danger\">\r\n                    No Records Found\r\n                </div>\r\n            </div>\r\n            <div class=\"col-12\" *ngIf=\"userrightssummary?.length > 0\">\r\n                <div class=\"table-responsive\">\r\n                    <table class=\"mdl-data-table table-striped col-12\" aria-describedby=\"UserRightsLogTable\">\r\n                        <tbody>\r\n                            <th class=\"mdl-data-table__cell--non-numeric_title\" >\r\n                                <strong>Sr. No</strong>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric_title\" >\r\n                                <strong>Authorization Update On</strong>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric_title\" >\r\n                                <strong>Authorizer</strong>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric_title\" >\r\n                                <strong>Authorizer Role</strong>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric_title\" >\r\n                                <strong>Product</strong>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric_title\" >\r\n                                <strong>Rights</strong>\r\n                            </th>\r\n                            <th class=\"mdl-data-table__cell--non-numeric_title\" >\r\n                                <strong>Permission</strong>\r\n                            </th>\r\n                            <tr *ngFor=\"let row of userrightssummary;let i = index\">\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <span>{{ i + 1}}</span>\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <span class=\"wraptext\">{{UTCToLocalTimeZone(row.AuthorizationUpdateOn) | date:'dd/MM/yyyy hh:mm:ss a'}}</span>\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <span class=\"wraptext\">{{row.Authorizer}}</span>\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <span class=\"wraptext\">{{row.AuthorizerRole}}</span>\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <span class=\"wraptext\" *ngIf=\"row.IsOTARight \">{{row.OTAProduct}}</span>\r\n                                    <span class=\"wraptext\" *ngIf=\"!row.IsOTARight\">{{row.LicenseProduct}}</span>\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <span class=\"wraptext\">{{row.Rights}}</span>\r\n                                </td>\r\n                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                    <span class=\"wraptext\">{{row.Permission}}</span>\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>                \r\n            </div>\r\n        </section>\r\n    </div>\r\n</article>"

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports = "<section>\r\n    <div style=\"display: flex; align-items: center; justify-content: center; margin-top: 60px ;\">\r\n        <h2>User Management</h2>\r\n    </div>\r\n    <section>\r\n        <article class=\"article\">\r\n            <div class=\"\">\r\n                <section>\r\n                    <div class=\"\">\r\n                        <header>                            \r\n                        </header>\r\n                        <div class=\"\">\r\n                            <hr />\r\n                            <div class=\"row\">\r\n                                <div class=\"col-11\">                                   \r\n                                </div>\r\n                                <div class=\"col-1\">\r\n                                    <button md-raised-button type=\"submit\" color=\"primary\"\r\n                                        [routerLink]=\"['/user-management/add-user',0]\" class=\"float-right\">Add New</button>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"row\">&nbsp;</div>\r\n                            <div class=\"row\" *ngIf=\"userData?.length == 0\" class=\"alert alert-danger\">\r\n                                <div class=\"col-12\">\r\n                                    No User Records Found\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"row\" *ngIf=\"userData?.length > 0\">\r\n                                <div class=\"col-12\">\r\n                                    <table class=\"mdl-data-table table-striped col-12\" aria-describedby=\"UserRightsTable\">\r\n                                        <tbody>\r\n                                            <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                                Name\r\n                                            </th>\r\n                                            <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                                Email Id\r\n                                            </th>\r\n                                            <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                                Role\r\n                                            </th>\r\n                                            <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                                Created Date\r\n                                            </th>\r\n                                            <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                                Is Admin\r\n                                            </th>\r\n                                            <th class=\"mdl-data-table__cell--non-numeric\">\r\n                                                Action\r\n                                            </th>\r\n                                            <tr *ngFor=\"let row of pagedItems\">\r\n                                                <td class=\"mdl-data-table__cell--non-numeric\"><span>{{row.Name}}</span>\r\n                                                </td>\r\n                                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                                    <span>{{row.EmailId}}</span>\r\n                                                </td>\r\n                                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                                    <span>{{row.Role}}</span>\r\n                                                </td>\r\n                                                <td class=\"mdl-data-table__cell--non-numeric\"><span>{{row.CreatedDate |\r\n                                                        date :'dd MMM yyyy'}}</span></td>\r\n                                                <td class=\"mdl-data-table__cell--non-numeric\">\r\n                                                    <span>{{row.IsAdmin}}</span>\r\n                                                </td>\r\n                                                <td class=\"mdl-data-table__cell--non-numeric iconsize\">\r\n                                                    <span>\r\n                                                        <button md-icon-button\r\n                                                            mdTooltip=\"Edit to Approve/Reject\"\r\n                                                            [routerLink]=\"['/user-management/add-user',row.UserId]\">                                                            \r\n                                                            <em class=\"fa fa-edit  text-success\" aria-hidden=\"true\"></em>\r\n                                                        </button>\r\n                                                    </span>\r\n\r\n                                                    <span (click)=\"openDialogWithAResult(row)\">\r\n                                                        <button md-icon-button mdTooltip=\"View User Rights Summary\">\r\n                                                            <em class=\"fa fa-info text-info\" aria-hidden=\"true\"> </em>\r\n                                                        </button>\r\n                                                    </span>\r\n                                                </td>\r\n                                            </tr>\r\n                                        </tbody>\r\n                                    </table>\r\n                                    <!-- <ul *ngIf=\"pager.pages && pager.pages.length\" class=\"pagination\"\r\n                                        style=\"float: right !important;\">\r\n                                        <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                                            <a (click)=\"setPage(1)\">First</a>\r\n                                        </li>\r\n                                        <li [ngClass]=\"{disabled:pager.currentPage === 1}\" style=\"cursor:pointer;\">\r\n                                            <a (click)=\"setPage(pager.currentPage - 1)\">Previous</a>\r\n                                        </li>\r\n                                        <li *ngFor=\"let page of pager.pages\"\r\n                                            [ngClass]=\"{active:pager.currentPage === page}\" style=\"cursor:pointer;\">\r\n                                            <a (click)=\"setPage(page)\">{{page}}</a>\r\n                                        </li>\r\n                                        <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                                            style=\"cursor:pointer;\">\r\n                                            <a (click)=\"setPage(pager.currentPage + 1)\">Next</a>\r\n                                        </li>\r\n                                        <li [ngClass]=\"{disabled:pager.currentPage === pager.totalPages}\"\r\n                                            style=\"cursor:pointer;\">\r\n                                            <a (click)=\"setPage(pager.totalPages)\">Last</a>\r\n                                        </li>\r\n                                    </ul> -->\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </section>\r\n            </div>\r\n        </article>\r\n    </section>\r\n</section>"

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

module.exports = "<div class=\"text-center\">\r\n    <h6 class=\"m-0 pb-1\" style=\"white-space: pre-wrap; line-height: 1.4;\">{{ title }}</h6>\r\n    <div md-dialog-content>\r\n        <md-spinner [style.margin]=\"'auto'\"></md-spinner>\r\n        <div style=\"position:relative; top: -60px; left: 0px;font-weight:bold;\">{{percentage}}</div>\r\n    </div>\r\n</div>\r\n"

/***/ })
],[768]);


// WEBPACK FOOTER //
// js/main.0c30f0cc34ef0fdd0038.js